/* This file is auto-generated. Do not modify it directly! */            

import type { SpecialOpsCode as SpecialOperationCode } from '@allocine/fullstack-utils';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: string; output: string; }
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: { input: string; output: string; }
  /** Integers that will have a value of 0 or more. */
  NonNegativeInt: { input: number; output: number; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: string; output: string; }
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: { input: string; output: string; }
  /** A 3D Tag */
  Tag3D: { input: string; output: string; }
  /** A rich text for body fields (as JSON). */
  RichText: { input: string | object[]; output: string | object[]; }
  /** A partial date. */
  PartialDate: { input: string; output: string; }
  /** A time without timezone. */
  TimeWithoutTz: { input: string; output: string; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
  /** A datetime without timezone. */
  DateTimeWithoutTz: { input: string; output: string; }
  /** Integers that will have a value greater than 0. */
  PositiveInt: { input: number; output: number; }
  /** Floats that will have a value of 0 or more. */
  NonNegativeFloat: { input: number; output: number; }
  /** A local time string (i.e., with no associated timezone) in 24-hr `HH:mm[:ss[.SSS]]` format, e.g. `14:25` or `14:25:06` or `14:25:06.123`. */
  LocalTime: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /**
   *
   *     A string representing a duration conforming to the ISO8601 standard,
   *     such as: P1W1DT13H23M34S
   *     P is the duration designator (for period) placed at the start of the duration representation.
   *     Y is the year designator that follows the value for the number of years.
   *     M is the month designator that follows the value for the number of months.
   *     W is the week designator that follows the value for the number of weeks.
   *     D is the day designator that follows the value for the number of days.
   *     T is the time designator that precedes the time components of the representation.
   *     H is the hour designator that follows the value for the number of hours.
   *     M is the minute designator that follows the value for the number of minutes.
   *     S is the second designator that follows the value for the number of seconds.
   *
   *     Note the time designator, T, that precedes the time value.
   *
   *     Matches moment.js, Luxon and DateFns implementations
   *     ,/. is valid for decimal places and +/- is a valid prefix
   *
   */
  Duration: { input: string; output: string; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: string; output: string; }
  /** A datetime in ISO 8601 format (2020-01-01T06:15:00.123Z) */
  DateTimeISO8601: { input: string; output: string; }
  /** A field whose value is a JSON Web Token (JWT): https://jwt.io/introduction. */
  JWT: { input: string; output: string; }
  /** The `Byte` scalar type represents byte value as a Buffer */
  Byte: { input: string; output: string; }
  /** A string that cannot be passed as an empty value */
  NonEmptyString: { input: string; output: string; }
};

export enum BrandEnum {
  AC = 'AC',
  CO = 'CO',
  SC = 'SC',
  MX = 'MX',
  AD = 'AD',
  BP = 'BP',
  FS = 'FS'
}

/** Type of event that occurred on an entity */
export enum EventLogType {
  MatchedEntity = 'MATCHED_ENTITY',
  UnmatchedEntity = 'UNMATCHED_ENTITY',
  MatchedTheater = 'MATCHED_THEATER',
  UnmatchedTheater = 'UNMATCHED_THEATER',
  IgnoredEntity = 'IGNORED_ENTITY',
  IgnoredTheater = 'IGNORED_THEATER',
  DeletedEntity = 'DELETED_ENTITY',
  DeletedTheater = 'DELETED_THEATER',
  AiMatchedEntity = 'AI_MATCHED_ENTITY',
  ImportWizardReport = 'IMPORT_WIZARD_REPORT'
}

export enum ReleaseGenericFlag {
  Direct = 'DIRECT'
}

export enum ReleaseOnlineFlag {
  Exclusive = 'EXCLUSIVE',
  Original = 'ORIGINAL'
}

export enum ReleaseTheaterFlag {
  LimitationPlatform = 'LIMITATION_PLATFORM',
  LimitationTheater = 'LIMITATION_THEATER',
  Preview = 'PREVIEW',
  Rerun = 'RERUN'
}

export enum ImageEntityType {
  Movie = 'MOVIE',
  Person = 'PERSON',
  Series = 'SERIES',
  SeriesSeason = 'SERIES_SEASON',
  SeriesEpisode = 'SERIES_EPISODE'
}

export type Directory = Entry & {
  path: Scalars['String']['output'];
  name: Scalars['String']['output'];
  contents: Array<Entry>;
};


export type DirectoryContentsArgs = {
  includeDirectories?: InputMaybe<Scalars['Boolean']['input']>;
  extension?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Entry = {
  path: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type File = Entry & {
  path: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export { SpecialOperationCode };

/** The available slots value for ticket anchor special operation */
export enum TicketAnchorSlot {
  Homepage = 'HOMEPAGE',
  MovieCard = 'MOVIE_CARD',
  MovieCardTheaterPage = 'MOVIE_CARD_THEATER_PAGE',
  News = 'NEWS',
  PersonPage = 'PERSON_PAGE',
  Showtimes = 'SHOWTIMES',
  TheaterPage = 'THEATER_PAGE'
}

export type Query = {
  application: Maybe<Application>;
  applications: ApplicationPager;
  author: Maybe<Author>;
  authors: AuthorPager;
  brand: Maybe<Brand>;
  brandByRef: Maybe<Brand>;
  brands: Array<Brand>;
  brandSearchLink: Maybe<BrandSearchLink>;
  brandSearchLinkByRef: Maybe<BrandSearchLink>;
  brandSearchLinks: Maybe<BrandSearchLinkPager>;
  carousel: Maybe<Carousel>;
  carouselByRef: Maybe<Carousel>;
  carousels: CarouselPager;
  certificate: Maybe<Certificate>;
  certificates: CertificatePager;
  checkURL: Maybe<CheckUrl>;
  clock: Maybe<Clock>;
  clockByRef: Maybe<Clock>;
  clocks: ClockPager;
  club: Maybe<Club>;
  clubs: Array<Club>;
  companies: CompanyPager;
  /** The activities and subactivities mapping of the company. */
  companiesActivitySubactivityMapping: Array<CompanyActivitySubactivity>;
  company: Maybe<Company>;
  companyByRef: Maybe<Company>;
  companyProducts: Array<CompanyProduct>;
  companyStaff: Maybe<CompanyStaff>;
  companyStaffByRef: Maybe<CompanyStaff>;
  companyStaffList: CompanyStaffPager;
  copyrights: Array<Copyright>;
  countries: CountryPager;
  country: Maybe<Country>;
  countryByAlpha2: Maybe<Country>;
  countryByRef: Maybe<Country>;
  credit: Maybe<PersonCredits>;
  customer: Maybe<Customer>;
  customerByRef: Maybe<Customer>;
  customerQueries: CustomerQueryPager;
  customerQuery: Maybe<CustomerQuery>;
  customerQueryByRef: Maybe<CustomerQuery>;
  customers: CustomerPager;
  dataApi: Scalars['JSONObject']['output'];
  deleteImportShowtimesStats: DeleteImportShowtimesStats;
  duplicate: Maybe<Duplicate>;
  duplicates: DuplicatePager;
  editorialReview: Maybe<EditorialReview>;
  editorialReviews: EditorialReviewPager;
  entitiesByRef: Maybe<Array<Maybe<Ref>>>;
  entity: Maybe<Entity>;
  entityByRef: Maybe<Ref>;
  /** Retrieves event logs from BigQuery */
  eventLogs: EventLogPager;
  externalIdProviders: Array<Scalars['String']['output']>;
  fare: Maybe<Fare>;
  /** Generate article title, description and keywords using the given AI skill (article + ArticleContent only). */
  getAIArticleContent: AiArticleContentResult;
  /** List AI skills (prompts) for the given entity type and code, ordered by rank. */
  getAISkills: Array<AiSkill>;
  festival: Maybe<Festival>;
  festivalAwardByRef: Maybe<FestivalAward>;
  festivalAwards: FestivalAwardPager;
  festivalByRef: Maybe<Festival>;
  festivalEdition: Maybe<FestivalEdition>;
  festivalEditionCompetitions: Maybe<Array<FestivalEditionCompetition>>;
  festivalEditionCompetitionsSearch: Maybe<Array<FestivalEditionCompetitionSearchResult>>;
  festivalEditions: FestivalEditionPager;
  festivalJuries: Maybe<Array<FestivalJury>>;
  festivals: FestivalPager;
  festivalSelections: Maybe<Array<FestivalSelection>>;
  fileMetadata: Maybe<FileMetadata>;
  fileSystem: Maybe<Directory>;
  ignoredProducts: Maybe<IgnoredProductPager>;
  ignoredShowtimeSources: IgnoredShowtimeSourcePager;
  image: Maybe<Image>;
  imageCategories: ImageCategoryPager;
  images: ImagePager;
  imagesByEntity: ImageReferencePager;
  importConfiguration: Maybe<ImportConfiguration>;
  importConfigurations: ImportConfigurationPager;
  importCrawler: Maybe<ImportCrawler>;
  importCrawlers: ImportCrawlerPager;
  importMatchers: Array<Scalars['String']['output']>;
  importRun: Maybe<ImportRun>;
  importRuns: ImportRunPager;
  /** The import wizard runs launched in a period, aggregated for the imports dashboard. */
  importWizardDashboard: ImportWizardDashboard;
  /** A cast and credits import report read by its id, of any entity; null when the id is unknown or malformed. Reserved to the imports dashboard. */
  importWizardReport: Maybe<PersonCreditsImportReport>;
  /** Every cast and credits import report, of any entity, removed ones included. Reserved to the imports dashboard. */
  importWizardReports: PersonCreditsImportReportPager;
  incompleteShowtimeSources: IncompleteShowtimeSourcePager;
  job: Maybe<JobType>;
  /** Gets all active (running) jobs */
  activeJobs: Array<JobType>;
  /** Retrieves a list of jump links history */
  jumpLinks: Maybe<JumpLinkPager>;
  jumpPlatformDomains: Array<JumpPlatformDomain>;
  jumpPlatformEncodedUrl: Maybe<JumpLink>;
  linkedEntities: EntityLinkPager;
  localCredit: Maybe<EntityHasPersonLocalized>;
  locale: Maybe<Locale>;
  localeByRef: Maybe<Locale>;
  locales: Array<Locale>;
  localesList: LocalePager;
  localizations: LocalizationPager;
  /** Retrieves a list of markets. */
  markets: Array<Scalars['String']['output']>;
  /** Entites related to the given matched product */
  matchedProductEntities: Maybe<MatchedProduct>;
  /** List of products that are matched with an entity */
  matchedProducts: MatchedProductPager;
  matchedShowtimeEntities: MatchedShowtimeEntityPager;
  matchedShowtimeTheaters: MatchedShowtimeTheaterPager;
  metabase: Scalars['URL']['output'];
  movie: Maybe<Movie>;
  movies: MoviePager;
  news: Maybe<News>;
  newsByRef: Maybe<News>;
  newsList: NewsPager;
  newsPage: Maybe<NewsPage>;
  person: Maybe<Person>;
  /** The list of a person activities, from all entities */
  personActivities: Array<PersonActivity>;
  personByRef: Maybe<Person>;
  /** The sources a cast and credits import can read on this server: the ones whose key is configured. */
  personCreditsImportSources: Array<PersonCreditsImportSource>;
  /** The crew jobs of every completed cast and credits import that no rule maps to an activity, most frequent first: the list the database managers review. */
  personCreditsImportUnmappedJobs: Array<PersonCreditsImportUnmappedJob>;
  /** The sources person images can be read from on this server. */
  personImageSources: Array<PersonImageSource>;
  persons: PersonPager;
  preset: Maybe<Preset>;
  presets: PresetPager;
  pressReview: Maybe<PressReview>;
  pressReviews: PressReviewPager;
  /** Retrieve all distinct source channels for a product source and country */
  productSourceChannels: Array<ProductSourceChannel>;
  /** Retrieves all product sources for a given country. */
  productSources: Array<ProductSourceStats>;
  /** List of product type options (value = tag, label = display name). When companyActivity is provided, options are filtered by the provider activities. When only companyId is provided, company is loaded and its tags used as companyActivity. */
  productTypeOptions: Array<ProductTypeOption>;
  /** Product data for the Products Management edit form. */
  product: Maybe<ProductDetail>;
  /** Paginated list of products for Products Management, pivot on company_has_product. */
  productList: ProductsPager;
  redirectionRule: Maybe<RedirectionRule>;
  /** Plans the rules a create or update with these values would point straight at the end of their redirection chain. Writes nothing; pass the returned `reviewToken` as `chainReviewToken` to apply this exact plan. */
  redirectionRuleChainRewrites: Maybe<RedirectionRuleChainPlan>;
  redirectionRules: Maybe<RedirectionRulePager>;
  release: Maybe<EntityRelease>;
  releaseByRef: Maybe<EntityRelease>;
  releases: EntityReleasePager;
  /** True if a release of the given type exists for the entity in the given country and optional company. */
  hasReleaseForEntity: Scalars['Boolean']['output'];
  scope: Maybe<Scope>;
  scopeByRef: Maybe<Scope>;
  scopes: ScopePager;
  screen: Maybe<Screen>;
  screens: ScreenPager;
  searchEntities: SearchEntityPager;
  series: Maybe<Series>;
  seriesByRef: Maybe<Series>;
  seriesEpisode: Maybe<SeriesEpisode>;
  seriesEpisodeByRef: Maybe<SeriesEpisode>;
  seriesList: SeriesPager;
  seriesSeason: Maybe<SeriesSeason>;
  seriesSeasonByRef: Maybe<SeriesSeason>;
  showtime: Maybe<Showtime>;
  showtimeEntitySuggestions: Array<ShowtimeEntitySuggestion>;
  showtimes: ShowtimePager;
  slide: Maybe<Slide>;
  slides: SlidePager;
  slideshowSlide: Maybe<SlideshowSlide>;
  socialImagesList: ImageReferencePager;
  socialUser: Maybe<SocialUser>;
  socialUsers: SocialUserPager;
  specialOperation: Maybe<SpecialOperation>;
  specialOperationByRef: Maybe<SpecialOperation>;
  specialOperations: SpecialOperationPager;
  tag: Maybe<Tag>;
  tagByRef: Maybe<Tag>;
  tags: TagPager;
  team: Maybe<Team>;
  /** @deprecated Use entityByRef instead */
  teamByRef: Maybe<Team>;
  teams: TeamPager;
  temporalBoxoffice: Maybe<TemporalBoxoffice>;
  temporalBoxoffices: TemporalBoxofficePager;
  theater: Maybe<Theater>;
  theaterByCode: Maybe<Theater>;
  theaterEvent: Maybe<TheaterEvent>;
  theaterFeed: Maybe<TheaterFeed>;
  theaterFeeds: TheaterFeedPager;
  theaters: TheaterPager;
  theatersEvents: TheaterEventPager;
  theaterShowtimes: TheaterShowtimePager;
  timezones: Array<Scalars['String']['output']>;
  token: Maybe<Token>;
  tokenByRef: Maybe<Token>;
  tokens: TokenPager;
  trivia: Maybe<Trivia>;
  triviaByRef: Maybe<Trivia>;
  trivias: TriviaPager;
  unknownProducts: UnknownProductPager;
  unmatchedMovies: UnmatchedMoviePager;
  unmatchedTheaters: UnmatchedTheaterPager;
  user: Maybe<User>;
  userRating: Maybe<UserRating>;
  userRatings: UserRatingPager;
  users: UserPager;
  videoLegacy: Maybe<VideoLegacy>;
  videoLegacyList: VideoLegacyPager;
  videosB2BByEntity: EntityHasVideoPager;
  videosLegacyByEntity: EntityHasVideoPager;
  viewer: User;
  widgets: WidgetPager;
  wysiwyg: Wysiwyg;
};


export type QueryApplicationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryApplicationsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAuthorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAuthorsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBrandArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBrandByRefArgs = {
  ref: Scalars['String']['input'];
};


export type QueryBrandSearchLinkArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBrandSearchLinkByRefArgs = {
  ref: Scalars['String']['input'];
};


export type QueryBrandSearchLinksArgs = {
  urls?: InputMaybe<Array<Scalars['String']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  brandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCarouselArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCarouselByRefArgs = {
  ref: Scalars['ID']['input'];
};


export type QueryCarouselsArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  target?: InputMaybe<Scalars['Tag3D']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCertificateArgs = {
  id: Scalars['String']['input'];
};


export type QueryCertificatesArgs = {
  countryId?: InputMaybe<Scalars['ID']['input']>;
  limitedLocalizationId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<CertificateScope>;
  orderBy?: InputMaybe<CertificateOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCheckUrlArgs = {
  url: Scalars['String']['input'];
};


export type QueryClockArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClockByRefArgs = {
  ref: Scalars['ID']['input'];
};


export type QueryClocksArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  theaterId?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<ClockOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryClubArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClubsArgs = {
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryCompaniesArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  countryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  activities?: InputMaybe<Array<CompanyActivity>>;
  additionalTags?: InputMaybe<Array<CompanyAdditionalTag>>;
  orderBy?: InputMaybe<CompanyOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyByRefArgs = {
  ref: Scalars['ID']['input'];
};


export type QueryCompanyProductsArgs = {
  entityId: Scalars['ID']['input'];
  countryId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCompanyStaffArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyStaffByRefArgs = {
  ref: Scalars['ID']['input'];
};


export type QueryCompanyStaffListArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<CompanyStaffOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCopyrightsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCountriesArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<CountryOrder>;
  linkedToBrand?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCountryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCountryByAlpha2Args = {
  alpha2: Scalars['String']['input'];
};


export type QueryCountryByRefArgs = {
  ref: Scalars['ID']['input'];
};


export type QueryCreditArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomerByRefArgs = {
  ref: Scalars['ID']['input'];
};


export type QueryCustomerQueriesArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  excludeScope?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCustomerQueryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomerQueryByRefArgs = {
  ref: Scalars['ID']['input'];
};


export type QueryCustomersArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDataApiArgs = {
  query: Scalars['String']['input'];
  variables?: InputMaybe<Scalars['JSONObject']['input']>;
};


export type QueryDeleteImportShowtimesStatsArgs = {
  theaterId: Scalars['ID']['input'];
  entityId?: InputMaybe<Scalars['ID']['input']>;
  range?: InputMaybe<DateRangeInput>;
};


export type QueryDuplicateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDuplicatesArgs = {
  status?: InputMaybe<Array<DuplicateStatus>>;
  entityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityType?: InputMaybe<DuplicateEntityType>;
  orderBy?: InputMaybe<DuplicateOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEditorialReviewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEditorialReviewsArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  entityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEntitiesByRefArgs = {
  type: EntityType;
  refs: Array<Scalars['ID']['input']>;
};


export type QueryEntityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEntityByRefArgs = {
  type: EntityType;
  ref: Scalars['ID']['input'];
};


export type QueryEventLogsArgs = {
  eventTypes?: InputMaybe<Array<EventLogType>>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<EventLogOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryExternalIdProvidersArgs = {
  type: ExternalIdProviderType;
};


export type QueryFareArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAiArticleContentArgs = {
  aiSkillId: Scalars['ID']['input'];
  articleId?: InputMaybe<Scalars['ID']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  universe?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGetAiSkillsArgs = {
  entityType: AiSkillEntityType;
  code: AiSkillCode;
};


export type QueryFestivalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFestivalAwardByRefArgs = {
  ref: Scalars['ID']['input'];
};


export type QueryFestivalAwardsArgs = {
  festivalId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<FestivalAwardOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFestivalByRefArgs = {
  ref: Scalars['ID']['input'];
};


export type QueryFestivalEditionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFestivalEditionCompetitionsArgs = {
  editionId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFestivalEditionCompetitionsSearchArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  festivalId: Scalars['ID']['input'];
  festivalEditionId?: InputMaybe<Scalars['ID']['input']>;
  onlyAvailableOnEdition?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFestivalEditionsArgs = {
  festivalId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<FestivalEditionOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFestivalJuriesArgs = {
  festivalId: Scalars['ID']['input'];
  editionId: Scalars['ID']['input'];
  competitionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFestivalsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  countryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderBy?: InputMaybe<FestivalOrder>;
  themes?: InputMaybe<Array<FestivalTheme>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFestivalSelectionsArgs = {
  festivalId: Scalars['ID']['input'];
  editionId: Scalars['ID']['input'];
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<FestivalSelectionOrder>;
};


export type QueryFileMetadataArgs = {
  uploadToken: Scalars['String']['input'];
};


export type QueryFileSystemArgs = {
  bucket: Scalars['String']['input'];
};


export type QueryIgnoredProductsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIgnoredShowtimeSourcesArgs = {
  sourceType?: InputMaybe<ShowtimeSourceType>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryImageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryImageCategoriesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  imageTypes?: InputMaybe<Array<InputMaybe<ImageType>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<ImageCategoryOrder>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryImagesArgs = {
  type?: InputMaybe<ImageType>;
  orderBy?: InputMaybe<ImageOrder>;
  createdByUserId?: InputMaybe<Scalars['ID']['input']>;
  updatedByUserId?: InputMaybe<Scalars['ID']['input']>;
  imageId?: InputMaybe<Scalars['String']['input']>;
  imageCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  imageCategoryBrandIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  hasTTL?: InputMaybe<Scalars['Boolean']['input']>;
  onlyUncategorizedAvatarsAndBanners?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryImagesByEntityArgs = {
  type?: InputMaybe<ImageType>;
  entityId: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<EntityHasImageOrder>>>;
  mainPoster?: InputMaybe<Scalars['Boolean']['input']>;
  mainBrandPosters?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  mainLocalizedPosters?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryImportConfigurationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryImportConfigurationsArgs = {
  crawler?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  linksOnly?: InputMaybe<Scalars['Boolean']['input']>;
  inheritsScreenAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  moviesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<ImportConfigurationOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryImportCrawlerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryImportCrawlersArgs = {
  orderBy?: InputMaybe<ImportCrawlerOrder>;
  name?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<CrawlerType>>;
  countries?: InputMaybe<Array<Scalars['ID']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryImportMatchersArgs = {
  sourceType: ShowtimeSourceType;
};


export type QueryImportRunArgs = {
  id: Scalars['ID']['input'];
};


export type QueryImportRunsArgs = {
  crawler?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ImportRunStatus>;
  lastStep?: InputMaybe<ImportRunStepType>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryImportWizardDashboardArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  timeZone: Scalars['String']['input'];
  source?: InputMaybe<PersonCreditsImportSource>;
};


export type QueryImportWizardReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryImportWizardReportsArgs = {
  filter?: InputMaybe<ImportWizardReportFilter>;
  order?: InputMaybe<ImportWizardReportOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryIncompleteShowtimeSourcesArgs = {
  sourceType: ShowtimeSourceType;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<IncompleteMavenStatus>;
  showId?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobArgs = {
  jobId: Scalars['String']['input'];
  jobTaskType: JobTaskType;
};


export type QueryActiveJobsArgs = {
  jobTaskType?: InputMaybe<JobTaskType>;
};


export type QueryJumpLinksArgs = {
  orderBy?: InputMaybe<JumpLinkOrder>;
  search?: InputMaybe<Scalars['String']['input']>;
  targetDomainUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceUrls?: InputMaybe<Array<Scalars['String']['input']>>;
  partners?: InputMaybe<Array<Scalars['String']['input']>>;
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJumpPlatformEncodedUrlArgs = {
  targetDomainUrl: Scalars['String']['input'];
  sourceUrl: Scalars['URL']['input'];
  partner?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryLinkedEntitiesArgs = {
  entityId: Scalars['ID']['input'];
  linkType?: InputMaybe<EntityLinkType>;
  orderBy?: InputMaybe<EntityLinkOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLocalCreditArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLocaleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLocaleByRefArgs = {
  ref: Scalars['String']['input'];
};


export type QueryLocalesListArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  limitedLocalizationId?: InputMaybe<Scalars['ID']['input']>;
  syncFromIdBrand?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLocalizationsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  localizationKind?: InputMaybe<Array<LocalizationKind>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMarketsArgs = {
  countryId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMatchedProductEntitiesArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryMatchedProductsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  sourceName: Scalars['String']['input'];
  countryId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMatchedShowtimeEntitiesArgs = {
  sourceName?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMatchedShowtimeTheatersArgs = {
  sourceName?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  theaterId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMetabaseArgs = {
  dashboard: Scalars['Int']['input'];
  params?: InputMaybe<Scalars['JSONObject']['input']>;
};


export type QueryMovieArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMoviesArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  productionYear?: InputMaybe<Scalars['Int']['input']>;
  directorId?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<MovieOrder>;
  type?: InputMaybe<MovieType>;
  searchIn?: InputMaybe<EntitySearchTypes>;
  searchSensitivity?: InputMaybe<EntitySearchOptions>;
  algorithm?: InputMaybe<MovieSearchAlgorithm>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNewsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNewsByRefArgs = {
  ref: Scalars['ID']['input'];
};


export type QueryNewsListArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NewsType>;
  universes?: InputMaybe<Array<InputMaybe<NewsUniverse>>>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  authorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  relatedEntityId?: InputMaybe<Scalars['ID']['input']>;
  tagId?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<NewsOrder>;
  range?: InputMaybe<DateRangeInput>;
  publicationStatus?: InputMaybe<EntityPublicationStatus>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNewsPageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPersonArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPersonActivitiesArgs = {
  entityType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPersonByRefArgs = {
  ref: Scalars['ID']['input'];
};


export type QueryPersonsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<PersonOrder>;
  activities?: InputMaybe<Array<InputMaybe<PersonActivity>>>;
  algorithm?: InputMaybe<PersonSearchAlgorithm>;
  searchIn?: InputMaybe<EntitySearchTypes>;
  searchSensitivity?: InputMaybe<EntitySearchOptions>;
  relatedEntities?: InputMaybe<Array<Scalars['ID']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPresetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPresetsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  universes?: InputMaybe<Array<Universe>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPressReviewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPressReviewsArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  entityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductSourceChannelsArgs = {
  sourceId: Scalars['ID']['input'];
  countryId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProductSourcesArgs = {
  countryId: Scalars['ID']['input'];
};


export type QueryProductTypeOptionsArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  companyActivity?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryProductArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryProductListArgs = {
  countryId: Scalars['ID']['input'];
  companyId?: InputMaybe<Scalars['ID']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<ProductEntityType>;
  entitySearch?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<ProductListOrigin>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRedirectionRuleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRedirectionRuleChainRewritesArgs = {
  brandId: Scalars['ID']['input'];
  kind: RedirectionRuleKind;
  mode: WritableRedirectionMode;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  sourcePattern?: InputMaybe<Scalars['String']['input']>;
  targetPattern?: InputMaybe<Scalars['String']['input']>;
  sourceEntity?: InputMaybe<Scalars['String']['input']>;
  targetEntity?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  endAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRedirectionRulesArgs = {
  q?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  brandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  kinds?: InputMaybe<Array<RedirectionRuleKind>>;
  modes?: InputMaybe<Array<RedirectionMode>>;
  status?: InputMaybe<RedirectionRuleStatus>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  destinationUrl?: InputMaybe<Scalars['String']['input']>;
  containsRegexp?: InputMaybe<Scalars['Boolean']['input']>;
  startAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  endAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  orderBy?: InputMaybe<RedirectionRulesOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReleaseArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReleaseByRefArgs = {
  ref: Scalars['ID']['input'];
  entityType: ReleasableEntityType;
};


export type QueryReleasesArgs = {
  entityId: Scalars['ID']['input'];
  type?: InputMaybe<ReleaseType>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHasReleaseForEntityArgs = {
  entityId: Scalars['ID']['input'];
  countryId: Scalars['ID']['input'];
  limitedCompanyId?: InputMaybe<Scalars['ID']['input']>;
  type: ReleaseType;
};


export type QueryScopeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryScopeByRefArgs = {
  ref: Scalars['ID']['input'];
};


export type QueryScopesArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryScreenArgs = {
  id: Scalars['ID']['input'];
};


export type QueryScreensArgs = {
  theaterId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchEntitiesArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<SearchEntityOrder>;
  entityType?: InputMaybe<Array<SearchableEntityType>>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  options?: InputMaybe<SearchOptionsInput>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySeriesArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySeriesByRefArgs = {
  ref: Scalars['ID']['input'];
};


export type QuerySeriesEpisodeArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySeriesEpisodeByRefArgs = {
  ref: Scalars['ID']['input'];
};


export type QuerySeriesListArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
  genres?: InputMaybe<Array<Genre>>;
  orderBy?: InputMaybe<SeriesOrder>;
  algorithm?: InputMaybe<SeriesSearchAlgorithm>;
  searchIn?: InputMaybe<EntitySearchTypes>;
  searchSensitivity?: InputMaybe<EntitySearchOptions>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySeriesSeasonArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySeriesSeasonByRefArgs = {
  ref: Scalars['ID']['input'];
};


export type QueryShowtimeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryShowtimeEntitySuggestionsArgs = {
  entityMatcher: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
};


export type QueryShowtimesArgs = {
  movieId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySlideArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySlidesArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  createdByUserId?: InputMaybe<Scalars['ID']['input']>;
  updatedByUserId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<SlideOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySlideshowSlideArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySocialImagesListArgs = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  onlyUncategorizedAvatarsAndBanners?: InputMaybe<Scalars['Boolean']['input']>;
  imageCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  type?: InputMaybe<ImageType>;
  hasTTL?: InputMaybe<Scalars['Boolean']['input']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  validityFrom?: InputMaybe<Scalars['Date']['input']>;
  validityTo?: InputMaybe<Scalars['Date']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySocialUserArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySocialUsersArgs = {
  search: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySpecialOperationArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySpecialOperationByRefArgs = {
  ref: Scalars['ID']['input'];
};


export type QuerySpecialOperationsArgs = {
  brandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  codes?: InputMaybe<Array<SpecialOperationCode>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTagArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTagByRefArgs = {
  ref: Scalars['ID']['input'];
};


export type QueryTagsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<TagOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTeamArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTeamByRefArgs = {
  ref: Scalars['ID']['input'];
};


export type QueryTeamsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  countryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  brandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  localeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTemporalBoxofficeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTemporalBoxofficesArgs = {
  countryId: Scalars['ID']['input'];
  range?: InputMaybe<DateRangeInput>;
  rangeOperator?: InputMaybe<RangeOperator>;
  movieId?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<TemporalBoxofficeOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTheaterArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTheaterByCodeArgs = {
  code: Scalars['ID']['input'];
};


export type QueryTheaterEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTheaterFeedArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTheaterFeedsArgs = {
  theaterId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTheatersArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  countryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  localizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  theaterOpeningStatuses?: InputMaybe<Array<TheaterOpeningStatus>>;
  showtimeSources?: InputMaybe<Array<TheaterShowtimeSource>>;
  orderBy?: InputMaybe<TheaterOrder>;
  showtimesGatheringMethod?: InputMaybe<Array<TheaterShowtimesGatheringMethod>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTheatersEventsArgs = {
  kind?: InputMaybe<TheaterEventKind>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  states?: InputMaybe<Array<EntityState>>;
  search?: InputMaybe<Scalars['String']['input']>;
  originCountryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  afterReleaseDate?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  beforeReleaseDate?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  releaseStatus?: InputMaybe<Array<TheaterEventReleaseStatus>>;
  orderBy?: InputMaybe<TheaterEventOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTheaterShowtimesArgs = {
  movieId: Scalars['ID']['input'];
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTokenArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTokenByRefArgs = {
  ref: Scalars['ID']['input'];
};


export type QueryTokensArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  applicationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderBy?: InputMaybe<TokenOrder>;
  includeUserTokens?: Scalars['Boolean']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTriviaArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTriviaByRefArgs = {
  ref: Scalars['ID']['input'];
};


export type QueryTriviasArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUnknownProductsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  countryId: Scalars['ID']['input'];
  entityType?: InputMaybe<Scalars['String']['input']>;
  sourceChannelNames?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUnmatchedMoviesArgs = {
  sourceName?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUnmatchedTheatersArgs = {
  sourceName?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserRatingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserRatingsArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  entityTypes?: InputMaybe<Array<SocialRatingsEntityType>>;
  entityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  onlyReviews?: InputMaybe<Scalars['Boolean']['input']>;
  ratings?: InputMaybe<Array<Scalars['Int']['input']>>;
  statuses?: InputMaybe<Array<UserReviewStatus>>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['DateTimeISO']['input']>;
  to?: InputMaybe<Scalars['DateTimeISO']['input']>;
  orderBy?: InputMaybe<SocialRatingsOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUsersArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVideoLegacyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVideoLegacyListArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VideoType>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  universes?: InputMaybe<Array<InputMaybe<VideoUniverse>>>;
  orderBy?: InputMaybe<VideoOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVideosB2BByEntityArgs = {
  type?: InputMaybe<VideoType>;
  entityId: Scalars['ID']['input'];
  orderBy?: InputMaybe<VideoOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVideosLegacyByEntityArgs = {
  type?: InputMaybe<VideoType>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  entityId: Scalars['ID']['input'];
  orderBy?: InputMaybe<VideoOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWidgetsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Application = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  origin: Scalars['String']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  name: Scalars['String']['output'];
};

export type Metadata = {
  /** The origin of the entity, LEGACY, CORE... */
  origin: Maybe<Scalars['String']['output']>;
  /** The creation date. */
  createdAt: Scalars['DateTime']['output'];
  /** The user which created this entity. */
  createdBy: Maybe<User>;
  /** The last modification date. */
  updatedAt: Scalars['DateTime']['output'];
  /** The last user which modified this entity. */
  updatedBy: Maybe<User>;
  /** Is scheduled for deletion */
  scheduledForDeletion: Scalars['Boolean']['output'];
  /** The state of the record (if this is an entity, it incidates if the entity is live, planned for deletion, etc.) */
  state: EntityState;
};

export type User = Entity & Node & Ref & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** Other IDs from external source to represent the screen. */
  externalIDs: Array<ExternalId>;
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The name of the user. */
  name: Scalars['String']['output'];
  /** The email of the user. */
  email: Scalars['EmailAddress']['output'];
  /** True if user has admin rights. */
  admin: Scalars['Boolean']['output'];
  /** True is user is an application. */
  application: Scalars['Boolean']['output'];
  /** The token if the user is an application. */
  token: Maybe<Scalars['String']['output']>;
  /** The user's rights. */
  rights: Array<UserRole>;
  /** The permissions of the user */
  permissions: Array<Permission>;
  presets: Array<Preset>;
  allowedBrands: Array<Brand>;
  allowedCountries: Array<Country>;
  allowedLocales: Array<Locale>;
  allowedNewsScopes: Array<NewsScope>;
  defaultBrand: Maybe<Brand>;
  defaultCountry: Maybe<Country>;
  defaultLocale: Maybe<Locale>;
  author: Maybe<Author>;
};


export type UserExternalIDsArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
};

export type Entity = {
  id: Scalars['ID']['output'];
  externalIDs: Array<ExternalId>;
  metadata: Metadata;
};

export type ExternalId = {
  /** The ID provider. */
  type: Scalars['String']['output'];
  /** The provider's IDs. */
  alts: Array<Scalars['ID']['output']>;
};

export type Node = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
};

export type Ref = {
  ref: Scalars['ID']['output'];
};

export type UserRole = {
  /** An user's team. */
  team: Team;
  /** The preset for the team and the user. */
  preset: Preset;
};

export type Team = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The name of the team. */
  name: Scalars['String']['output'];
  /** Team's countries. */
  countries: Array<Country>;
  /** Team's locales. */
  locales: Array<Locale>;
  /** Team's brands. */
  brands: Array<Brand>;
};

export type Country = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The name of the country. */
  name: Scalars['String']['output'];
  /** The ISO 3166-1 alpha-2 code of the country */
  alpha2: Scalars['String']['output'];
  /** The ISO 3166-1 alpha-3 code of the country */
  alpha3: Scalars['String']['output'];
  /** The language used by this country */
  language: Maybe<Language>;
  /** The locale of this country */
  locale: Maybe<Locale>;
  /** The day of the week at which the play week starts */
  showtimeReleaseDay: Maybe<ShowtimeReleaseDay>;
  /** The main clock format used by this country */
  preferredClockFormat: Maybe<PreferredClockFormat>;
  hasLocalCertificates: Maybe<Scalars['Boolean']['output']>;
  /** The currency of the country. */
  currency: Scalars['String']['output'];
};

export enum Language {
  English = 'ENGLISH',
  French = 'FRENCH',
  German = 'GERMAN',
  Spanish = 'SPANISH',
  Turkish = 'TURKISH',
  Portuguese = 'PORTUGUESE',
  AboriginalLanguage = 'ABORIGINAL_LANGUAGE',
  AfricanDialect = 'AFRICAN_DIALECT',
  Afrikaans = 'AFRIKAANS',
  Albanian = 'ALBANIAN',
  Algerian = 'ALGERIAN',
  Amharic = 'AMHARIC',
  Arab = 'ARAB',
  Aramaic = 'ARAMAIC',
  Armenian = 'ARMENIAN',
  Assamese = 'ASSAMESE',
  Azeri = 'AZERI',
  Bambara = 'BAMBARA',
  Belarusian = 'BELARUSIAN',
  Bengali = 'BENGALI',
  Bosnian = 'BOSNIAN',
  Bhojpuri = 'BHOJPURI',
  Briton = 'BRITON',
  Bulgarian = 'BULGARIAN',
  Burmese = 'BURMESE',
  Cantonese = 'CANTONESE',
  Catalan = 'CATALAN',
  Chechen = 'CHECHEN',
  Chhattisgarhi = 'CHHATTISGARHI',
  Chinese = 'CHINESE',
  Creole = 'CREOLE',
  Croat = 'CROAT',
  Czech = 'CZECH',
  Danish = 'DANISH',
  Dutch = 'DUTCH',
  Dyula = 'DYULA',
  Estonian = 'ESTONIAN',
  Euskera = 'EUSKERA',
  Farsi = 'FARSI',
  Filipino = 'FILIPINO',
  Finnish = 'FINNISH',
  Flemish = 'FLEMISH',
  Friulian = 'FRIULIAN',
  Gaelic = 'GAELIC',
  Gallego = 'GALLEGO',
  Georgian = 'GEORGIAN',
  Greek = 'GREEK',
  Guarani = 'GUARANI',
  Gujarati = 'GUJARATI',
  Hebrew = 'HEBREW',
  Hindi = 'HINDI',
  Hokkien = 'HOKKIEN',
  Hungarian = 'HUNGARIAN',
  Icelandic = 'ICELANDIC',
  Indonesian = 'INDONESIAN',
  Inuktitut = 'INUKTITUT',
  Italian = 'ITALIAN',
  Japanese = 'JAPANESE',
  Kannada = 'KANNADA',
  Kalaalisut = 'KALAALISUT',
  Kazakh = 'KAZAKH',
  Khasi = 'KHASI',
  Khmer = 'KHMER',
  Kirgizian = 'KIRGIZIAN',
  Klingon = 'KLINGON',
  Korean = 'KOREAN',
  Kurdish = 'KURDISH',
  Latin = 'LATIN',
  Latvian = 'LATVIAN',
  Lingala = 'LINGALA',
  Lituanian = 'LITUANIAN',
  Luxembourgish = 'LUXEMBOURGISH',
  Macedonian = 'MACEDONIAN',
  Malagasy = 'MALAGASY',
  Malay = 'MALAY',
  Malayalam = 'MALAYALAM',
  Maltese = 'MALTESE',
  Mandarin = 'MANDARIN',
  Mandchourian = 'MANDCHOURIAN',
  Maori = 'MAORI',
  Marathi = 'MARATHI',
  Maya = 'MAYA',
  Mongolese = 'MONGOLESE',
  Nagpuri = 'NAGPURI',
  Nahuatl = 'NAHUATL',
  Nepali = 'NEPALI',
  Norwegian = 'NORWEGIAN',
  Odia = 'ODIA',
  Other = 'OTHER',
  Pashto = 'PASHTO',
  Persian = 'PERSIAN',
  Polish = 'POLISH',
  Punjabi = 'PUNJABI',
  Romanian = 'ROMANIAN',
  Romany = 'ROMANY',
  Russian = 'RUSSIAN',
  Serb = 'SERB',
  SerboCroat = 'SERBO_CROAT',
  SignLanguage = 'SIGN_LANGUAGE',
  Silent = 'SILENT',
  Sindhi = 'SINDHI',
  Sinhala = 'SINHALA',
  Slovak = 'SLOVAK',
  Slovenian = 'SLOVENIAN',
  Somali = 'SOMALI',
  Sotho = 'SOTHO',
  Swahili = 'SWAHILI',
  Swedish = 'SWEDISH',
  SwissGerman = 'SWISS_GERMAN',
  Tadzhik = 'TADZHIK',
  Tagalog = 'TAGALOG',
  Tamil = 'TAMIL',
  Telugu = 'TELUGU',
  Thai = 'THAI',
  Tibetan = 'TIBETAN',
  Tulu = 'TULU',
  Ukrainian = 'UKRAINIAN',
  UndeterminedLanguage = 'UNDETERMINED_LANGUAGE',
  Urdu = 'URDU',
  Valenciano = 'VALENCIANO',
  Vietnamese = 'VIETNAMESE',
  Welsh = 'WELSH',
  Wolof = 'WOLOF',
  Yiddish = 'YIDDISH',
  Yoruba = 'YORUBA',
  Zulu = 'ZULU'
}

export type Locale = Node & Ref & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The name of the locale. */
  name: Scalars['String']['output'];
  language: Maybe<Language>;
  /** The brand to sync from when related data changes */
  syncFromBrand: Maybe<Brand>;
  /** The locale's brands. */
  brands: Array<Brand>;
  /** The country of the locale. */
  country: Country;
  /** The localization of the locale. */
  limitedLocalization: Maybe<Localization>;
};

export type Brand = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The name of the brand. */
  name: Scalars['String']['output'];
  /** The URL of the brand. */
  url: Scalars['String']['output'];
  /** URLs the deployment is configured with for this brand's services. */
  envRelatedDomainUrl: BrandEnvRelatedDomainUrl;
  /** Host the SEO redirection rules of the brand are served on, e.g. `www.allocine.fr`, read from WWW_URL_PER_BRAND_<BRAND>. */
  redirectionDomain: Maybe<Scalars['String']['output']>;
  timezone: Maybe<Scalars['String']['output']>;
  /** The country of the brand. */
  country: Country;
  language: Maybe<Language>;
  /** The locale of the brand. */
  locale: Locale;
  wysiwygFeatures: Array<WysiwygFeature>;
  /** The image configuration (for b2b_available scope) */
  imageConfiguration: Maybe<ImageBrandConfiguration>;
};

/** URLs of a brand's services, read from the WWW_URL_PER_BRAND_*, SSO_URL_* and GRAPH_API_URL_* mappings. */
export type BrandEnvRelatedDomainUrl = {
  /** Website of the brand, e.g. `https://www.allocine.fr` (`WWW_URL_PER_BRAND_<BRAND>`). */
  www: Scalars['String']['output'];
  /** SSO of the brand, e.g. `https://sso.stg.allocine.fr` (`SSO_URL_<BRAND>`). */
  sso: Scalars['String']['output'];
  /** Graph API of the brand, e.g. `https://graph.stg.allocine.fr/v1/cms/` (`GRAPH_API_URL_<BRAND>`). */
  graph: Scalars['String']['output'];
};

export enum WysiwygFeature {
  BoxofficeData = 'BOXOFFICE_DATA',
  Blockquote = 'BLOCKQUOTE',
  Club300 = 'CLUB300',
  EntityItem = 'ENTITY_ITEM',
  Formatting = 'FORMATTING',
  Heading = 'HEADING',
  Image = 'IMAGE',
  Link = 'LINK',
  List = 'LIST',
  Quizz = 'QUIZZ',
  SeeMore = 'SEE_MORE',
  SocialNetwork = 'SOCIAL_NETWORK',
  Sound = 'SOUND',
  Spoiler = 'SPOILER',
  Video = 'VIDEO',
  WebsiteLink = 'WEBSITE_LINK'
}

export type ImageBrandConfiguration = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  imageTypes: Maybe<Array<ImageType>>;
  defaultValue: Scalars['Boolean']['output'];
};

export enum ImageType {
  Poster = 'POSTER',
  PhotoAndStillFrame = 'PHOTO_AND_STILL_FRAME',
  PromotionalPicture = 'PROMOTIONAL_PICTURE',
  Quad = 'QUAD',
  Banner = 'BANNER',
  Slider = 'SLIDER',
  SocialUserAvatar = 'SOCIAL_USER_AVATAR',
  SocialUserBanner = 'SOCIAL_USER_BANNER'
}

export type Localization = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The type of the localization. */
  type: LocalizationKind;
  /** The name of the localization. */
  name: Scalars['String']['output'];
  /** The code of the localization. */
  code: Maybe<Scalars['String']['output']>;
  /** The localization's country. */
  country: Maybe<Country>;
  /** The localization's parent. */
  parent: Maybe<Localization>;
};

export enum LocalizationKind {
  Area = 'AREA',
  Borough = 'BOROUGH',
  Country = 'COUNTRY',
  County = 'COUNTY',
  LocalArea = 'LOCAL_AREA',
  Region = 'REGION'
}

export enum ShowtimeReleaseDay {
  Monday = 'MONDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
  Thursday = 'THURSDAY',
  Friday = 'FRIDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY'
}

export enum PreferredClockFormat {
  Format_12H = 'FORMAT_12H',
  Format_24H = 'FORMAT_24H'
}

export type Preset = Node & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The name of the preset. */
  name: Scalars['String']['output'];
  permissions: Array<Permission>;
  universes: Array<Universe>;
  users: Array<User>;
};

export enum Permission {
  StaticBrand = 'STATIC_BRAND',
  StaticCountry = 'STATIC_COUNTRY',
  StaticLocale = 'STATIC_LOCALE',
  StaticLocalization = 'STATIC_LOCALIZATION',
  Company = 'COMPANY',
  Movie = 'MOVIE',
  Person = 'PERSON',
  Series = 'SERIES',
  Theater = 'THEATER',
  TheaterEvent = 'THEATER_EVENT',
  Festival = 'FESTIVAL',
  EntityDeletion = 'ENTITY_DELETION',
  EntityBrandData = 'ENTITY_BRAND_DATA',
  EntityLocaleData = 'ENTITY_LOCALE_DATA',
  EntitySeoData = 'ENTITY_SEO_DATA',
  EntityReleases = 'ENTITY_RELEASES',
  EntityChangeEvent = 'ENTITY_CHANGE_EVENT',
  BrandAuthor = 'BRAND_AUTHOR',
  BrandCarousel = 'BRAND_CAROUSEL',
  BrandEditorialReview = 'BRAND_EDITORIAL_REVIEW',
  BrandSpecialOperation = 'BRAND_SPECIAL_OPERATION',
  BrandNews = 'BRAND_NEWS',
  BrandPressReview = 'BRAND_PRESS_REVIEW',
  BrandTag = 'BRAND_TAG',
  BrandTrivia = 'BRAND_TRIVIA',
  BrandSearchLink = 'BRAND_SEARCH_LINK',
  BrandRedirectionRule = 'BRAND_REDIRECTION_RULE',
  MediaImage = 'MEDIA_IMAGE',
  MediaVideo = 'MEDIA_VIDEO',
  Boxoffice = 'BOXOFFICE',
  Duplicate = 'DUPLICATE',
  ProductMatching = 'PRODUCT_MATCHING',
  Product = 'PRODUCT',
  SocialUser = 'SOCIAL_USER',
  SocialUserReview = 'SOCIAL_USER_REVIEW',
  SocialUserImagesCategories = 'SOCIAL_USER_IMAGES_CATEGORIES',
  KhronosImportCrawler = 'KHRONOS_IMPORT_CRAWLER',
  KhronosImportConfiguration = 'KHRONOS_IMPORT_CONFIGURATION',
  KhronosImportRun = 'KHRONOS_IMPORT_RUN',
  KhronosShowtime = 'KHRONOS_SHOWTIME',
  KhronosTriggerAll = 'KHRONOS_TRIGGER_ALL',
  ShowtimeClock = 'SHOWTIME_CLOCK',
  ShowtimeMatching = 'SHOWTIME_MATCHING',
  ShowtimeMatchingIgnoreAllMatchers = 'SHOWTIME_MATCHING_IGNORE_ALL_MATCHERS',
  GraphApiApplication = 'GRAPH_API_APPLICATION',
  GraphApiToken = 'GRAPH_API_TOKEN',
  GraphApiProxy = 'GRAPH_API_PROXY',
  JumpPlatformGenerateLink = 'JUMP_PLATFORM_GENERATE_LINK',
  SecurityPreset = 'SECURITY_PRESET',
  SecurityUser = 'SECURITY_USER',
  PersonLinkTags = 'PERSON_LINK_TAGS',
  ImportWizardAccess = 'IMPORT_WIZARD_ACCESS',
  ImportWizardDashboard = 'IMPORT_WIZARD_DASHBOARD',
  ImportWizardCastingTmdb = 'IMPORT_WIZARD_CASTING_TMDB',
  ImportWizardCastingOmdb = 'IMPORT_WIZARD_CASTING_OMDB',
  ImportWizardCastingWikipedia = 'IMPORT_WIZARD_CASTING_WIKIPEDIA',
  ImportWizardCastingImage = 'IMPORT_WIZARD_CASTING_IMAGE',
  ImportWizardCastingText = 'IMPORT_WIZARD_CASTING_TEXT',
  ImportWizardCastingPdf = 'IMPORT_WIZARD_CASTING_PDF',
  ImportWizardCreditsTmdb = 'IMPORT_WIZARD_CREDITS_TMDB',
  ImportWizardCreditsOmdb = 'IMPORT_WIZARD_CREDITS_OMDB',
  ImportWizardCreditsWikipedia = 'IMPORT_WIZARD_CREDITS_WIKIPEDIA',
  ImportWizardCreditsImage = 'IMPORT_WIZARD_CREDITS_IMAGE',
  ImportWizardCreditsText = 'IMPORT_WIZARD_CREDITS_TEXT',
  ImportWizardCreditsPdf = 'IMPORT_WIZARD_CREDITS_PDF',
  ImportWizardPersonTmdb = 'IMPORT_WIZARD_PERSON_TMDB',
  ImportWizardPersonWikimediaCommons = 'IMPORT_WIZARD_PERSON_WIKIMEDIA_COMMONS',
  ImportWizardPersonWikidata = 'IMPORT_WIZARD_PERSON_WIKIDATA',
  ImportWizardPersonBestimage = 'IMPORT_WIZARD_PERSON_BESTIMAGE',
  MovieBrandedContent = 'MOVIE_BRANDED_CONTENT',
  MovieClub = 'MOVIE_CLUB',
  MovieConnection = 'MOVIE_CONNECTION',
  MovieLinkTags = 'MOVIE_LINK_TAGS',
  MovieShowtimesEmbargos = 'MOVIE_SHOWTIMES_EMBARGOS',
  MovieBrandedDataCopyToLocaleData = 'MOVIE_BRANDED_DATA_COPY_TO_LOCALE_DATA',
  MovieBrandedDataRuling = 'MOVIE_BRANDED_DATA_RULING',
  SeriesLinkTags = 'SERIES_LINK_TAGS',
  SeriesSeasonDelete = 'SERIES_SEASON_DELETE',
  SeriesEpisodeDelete = 'SERIES_EPISODE_DELETE',
  SeriesBrandedDataRuling = 'SERIES_BRANDED_DATA_RULING',
  SeriesClub = 'SERIES_CLUB',
  NewsLinkTags = 'NEWS_LINK_TAGS',
  Widget = 'WIDGET',
  ConfigurationRatings = 'CONFIGURATION_RATINGS',
  CanUseAiGeneration = 'CAN_USE_AI_GENERATION'
}

export enum Universe {
  Alts = 'ALTS',
  Author = 'AUTHOR',
  Boxoffice = 'BOXOFFICE',
  Carousel = 'CAROUSEL',
  Company = 'COMPANY',
  Country = 'COUNTRY',
  Duplicate = 'DUPLICATE',
  EditorialReview = 'EDITORIAL_REVIEW',
  Graph = 'GRAPH',
  Khronos = 'KHRONOS',
  MatchingToolShowtimes = 'MATCHING_TOOL_SHOWTIMES',
  MatchingTool = 'MATCHING_TOOL',
  Movie = 'MOVIE',
  News = 'NEWS',
  NewsTemporary = 'NEWS_TEMPORARY',
  Person = 'PERSON',
  PressReview = 'PRESS_REVIEW',
  Release = 'RELEASE',
  Security = 'SECURITY',
  Seo = 'SEO',
  Series = 'SERIES',
  Showtimes = 'SHOWTIMES',
  Social = 'SOCIAL',
  Soundtrack = 'SOUNDTRACK',
  SpecialOperation = 'SPECIAL_OPERATION',
  Tag = 'TAG',
  Theater = 'THEATER',
  Trivia = 'TRIVIA',
  User = 'USER',
  Video = 'VIDEO'
}

export enum NewsScope {
  Www = 'WWW',
  GenericIvoryCoast = 'GENERIC_IVORY_COAST',
  GenericTvActu = 'GENERIC_TV_ACTU',
  GenericShopping = 'GENERIC_SHOPPING'
}

export type Author = Ref & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  name: Scalars['String']['output'];
  /** The associated brand. */
  brand: Brand;
  seoData: Maybe<AuthorSeoDataType>;
  position: Maybe<Scalars['String']['output']>;
  /** The CMS user associated with this author */
  user: Maybe<User>;
  /** The social user associated with this author */
  socialUser: Maybe<SocialUser>;
  startDate: Maybe<Scalars['Date']['output']>;
  stopDate: Maybe<Scalars['Date']['output']>;
  avatar: Maybe<Image>;
  shortBio: Scalars['String']['output'];
  longBio: Maybe<Scalars['RichText']['output']>;
  /** The author's social links. */
  links: SocialLinks;
  /** The author's signatures */
  signatures: Array<AuthorSignature>;
};

export type AuthorSeoDataType = {
  isAutonomouslyActivable: Scalars['Boolean']['output'];
  browsable: Scalars['Boolean']['output'];
  description: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  alternateTitle: Maybe<Scalars['String']['output']>;
  brand: Brand;
  canActivate: Scalars['Boolean']['output'];
  userRequests: Maybe<Array<EntitySeoDataUserRequests>>;
};

export type EntitySeoDataUserRequests = {
  user: Maybe<User>;
  reason: Maybe<Scalars['String']['output']>;
};

export type SocialUser = Node & Entity & Ref & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** Other IDs from external source to represent the screen. */
  externalIDs: Array<ExternalId>;
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  /** The avatar of the user. */
  avatar: Maybe<Scalars['String']['output']>;
  /** The email of the user. If null, it means the user has been anonymized */
  email: Maybe<Scalars['EmailAddress']['output']>;
  /** The legacy ID of the user. */
  legacyID: Scalars['String']['output'];
  /** The username. */
  nickname: Maybe<Scalars['String']['output']>;
  /** The actito id of the user. */
  actito: Maybe<Scalars['String']['output']>;
  /** The username. */
  isClub300: Scalars['Boolean']['output'];
  /** User's email activation status. */
  isEmailValid: Scalars['Boolean']['output'];
  /** User's validation EULA status. */
  isEULAAccepted: Scalars['Boolean']['output'];
  socialProviders: Array<Scalars['String']['output']>;
  /** User's network data normalized. */
  stats: SocialStatsProviderType;
};


export type SocialUserExternalIDsArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
};

export type SocialStatsProviderType = {
  database: SocialStats;
  /** User's network data from GraphAPI. */
  graphAPI: SocialStats;
};

export type SocialStats = {
  ratingCount: Scalars['Int']['output'];
  reviewCount: Scalars['Int']['output'];
  actionCount: Scalars['Int']['output'];
  theaterCount: Scalars['Int']['output'];
  collectionCount: Scalars['Int']['output'];
  followedCollectionCount: Scalars['Int']['output'];
  followerCount: Scalars['Int']['output'];
  followeeCount: Scalars['Int']['output'];
};

export type Image = Node & Entity & Ref & Brandable & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** Other IDs from external source to represent the screen. */
  externalIDs: Array<ExternalId>;
  /** The image's title. */
  title: Maybe<Scalars['String']['output']>;
  activeOnBrands: Array<Brand>;
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The image's path. */
  path: Scalars['String']['output'];
  /** The URL of the image. */
  url: Scalars['URL']['output'];
  tags: Array<Scalars['Tag3D']['output']>;
  /** The type of the image. */
  type: Maybe<ImageType>;
  /** The final name of the combination of the related copyrights */
  copyrightName: Maybe<Scalars['String']['output']>;
  /** The final name of the combination of the related b2b copyrights */
  b2bCopyrightName: Maybe<Scalars['String']['output']>;
  /** The copyrights of the image */
  copyrights: Maybe<Array<Copyright>>;
  /** The MIME of the image. */
  mime: Maybe<Scalars['String']['output']>;
  /** The size of the image. */
  size: Maybe<Scalars['Int']['output']>;
  /** The width of the image. */
  width: Maybe<Scalars['Int']['output']>;
  /** The height of the image. */
  height: Maybe<Scalars['Int']['output']>;
  /** The validity start date of the image in social images categories. */
  startDate: Maybe<Scalars['Date']['output']>;
  /** The validity end date of the image in social images categories. */
  endDate: Maybe<Scalars['Date']['output']>;
  /** All brand's fields for the image. */
  brandData: Maybe<ImageBrandData>;
  /** All localized fields for the image. */
  localizedData: Maybe<ImageLocaleData>;
  /** Verify if the image has localized data for the localeId. */
  hasLocalizedData: Scalars['Boolean']['output'];
  /** The B2B availability of the image. */
  b2bAvailable: Scalars['Boolean']['output'];
  /** The B2B copyrights of the image */
  b2bCopyrights: Maybe<Array<Copyright>>;
  /** Entities linked to this image */
  relatedEntities: Array<ImageLinkableEntity>;
  /** Whether the image is the main poster of the arg entity, compatible with all entities using an id_poster */
  isMainPosterOfEntity: Scalars['Boolean']['output'];
  /** Whether the image is the main poster of the brand given */
  isMainBrandedPoster: Scalars['Boolean']['output'];
  /** Whether the image is the main poster of the locale given */
  isMainLocalizedPoster: Scalars['Boolean']['output'];
};


export type ImageExternalIDsArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
};


export type ImageBrandDataArgs = {
  brandId: Scalars['ID']['input'];
};


export type ImageLocalizedDataArgs = {
  localeId: Scalars['ID']['input'];
};


export type ImageHasLocalizedDataArgs = {
  localeId?: InputMaybe<Scalars['ID']['input']>;
};


export type ImageIsMainPosterOfEntityArgs = {
  entityId: Scalars['ID']['input'];
};


export type ImageIsMainBrandedPosterArgs = {
  entityId: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
};


export type ImageIsMainLocalizedPosterArgs = {
  entityId: Scalars['ID']['input'];
  localeId: Scalars['ID']['input'];
};

export type Brandable = {
  activeOnBrands: Array<Brand>;
};

/** A copyright. */
export type Copyright = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ImageBrandData = {
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The image's title. */
  title: Maybe<Scalars['String']['output']>;
  /** The image's description. */
  description: Maybe<Scalars['String']['output']>;
  /** The final name of the combination of the related copyrights */
  copyrightName: Maybe<Scalars['String']['output']>;
  /** The copyright of the video */
  copyrights: Maybe<Array<Copyright>>;
  /** Showtimes starting before this value won't be displayed. Default value is today at midnight. */
  from: Maybe<Scalars['Date']['output']>;
  /** Showtimes starting after this value won't be displayed. Default value is tomorrow at midnight. */
  to: Maybe<Scalars['Date']['output']>;
  brand: Brand;
};

export type ImageLocaleData = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  title: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  locale: Maybe<Scalars['String']['output']>;
  tags: Maybe<Array<Scalars['Tag3D']['output']>>;
};

export type ImageLinkableEntity = Movie | Person | SeriesEpisode | SeriesSeason | Series | FestivalEdition;

/** A movie. */
export type Movie = Node & Entity & Ref & Brandable & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** Other IDs from external source to represent the screen. */
  externalIDs: Array<ExternalId>;
  /** The metadata of this entity. */
  metadata: Metadata;
  images: ImageReferencePager;
  /** The trivias associated with the entity. */
  trivias: EntityTriviaPager;
  /** @deprecated use seoAttributes field now */
  seoData: Maybe<EntitySeoData>;
  tags: EntityTagPager;
  /** The popularity of the movie. */
  popularity: Maybe<Scalars['NonNegativeInt']['output']>;
  activeOnBrands: Array<Brand>;
  entityLinks: Array<EntityLink>;
  /** The title of the movie. */
  title: Scalars['String']['output'];
  /** The poster of the movie. */
  poster: Maybe<Image>;
  /** The production year of the movie. */
  productionYear: Maybe<Scalars['Int']['output']>;
  /** A cast and credits import report of this entity: the latest one, running or not, or the one whose id is given; null when none was ever launched or the id is not one of this entity's reports. */
  personCreditsImport: Maybe<PersonCreditsImportReport>;
  /** The cast and credits import reports of this entity, newest first. */
  personCreditsImports: Array<PersonCreditsImportReport>;
  /** The credits of the movie. */
  credits: PersonCreditsPager;
  /** Clubs informations for the entity */
  clubs: Maybe<Array<BrandEntityClub>>;
  /** The companies of the movie. */
  companies: EntityCompanyPager;
  /** The movie releases. */
  releases: EntityReleasePager;
  /** The closest movie release, time-related */
  closestRelease: Maybe<EntityRelease>;
  /** The movie's countries. */
  countries: Array<Country>;
  /** The type of the movie. */
  type: MovieType;
  /** The languages of the movie. */
  languages: Array<Language>;
  /** The genres of the movie. */
  genres: Array<Genre>;
  projections: Array<MovieProjection>;
  additionalTags: Array<MovieAdditional>;
  foxproSync: MovieFoxProSync;
  /** The budget with the currency of the movie. */
  budget: Maybe<Scalars['String']['output']>;
  /** The budget of the movie. */
  budgetValue: Maybe<Scalars['NonNegativeFloat']['output']>;
  /** The currency related to the budget of the movie */
  budgetCurrency: Maybe<Currency>;
  /**
   * The old budget value of the movie.
   * @deprecated Use budget instead, we will remove this field in the future.
   */
  budgetOld: Maybe<Scalars['String']['output']>;
  /** The runtime of the movie. */
  runtime: Maybe<Runtime>;
  /** The color of the movie. */
  color: Maybe<Scalars['Tag3D']['output']>;
  /** The projection format of the movie */
  projection: Maybe<Scalars['Tag3D']['output']>;
  /** The production format of the movie. */
  production: Maybe<Scalars['Tag3D']['output']>;
  /** The sound format of the movie */
  sound: Maybe<Scalars['Tag3D']['output']>;
  /** All localized fields for the movie. */
  localeData: Maybe<MovieLocaleData>;
  localesData: Maybe<Array<MovieLocaleData>>;
  /** All brand's fields for the movie. */
  brandData: Maybe<MovieBrandData>;
  /** All brand's fields for the movie. */
  brandsData: Maybe<Array<MovieBrandData>>;
  seoAttributes: Array<EntitySeoData>;
  /** The total US box office for a movie. */
  totalBoxofficeUs: Maybe<Scalars['Int']['output']>;
  /** The international total box office (non US) for a movie. */
  totalBoxofficeInternational: Maybe<Scalars['Int']['output']>;
  showtimesEmbargos: Array<ShowtimesEmbargo>;
  versions: Array<MovieVersion>;
  /** The movie's keywords. */
  keywords: Array<Scalars['String']['output']>;
};


/** A movie. */
export type MovieExternalIDsArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
};


/** A movie. */
export type MovieImagesArgs = {
  hasTTL?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** A movie. */
export type MovieTriviasArgs = {
  brandId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** A movie. */
export type MovieSeoDataArgs = {
  brandId: Scalars['ID']['input'];
};


/** A movie. */
export type MovieTagsArgs = {
  brandId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** A movie. */
export type MovieEntityLinksArgs = {
  linkType?: InputMaybe<Array<EntityLinkType>>;
};


/** A movie. */
export type MoviePersonCreditsImportArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** A movie. */
export type MoviePersonCreditsImportsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** A movie. */
export type MovieCreditsArgs = {
  activities?: InputMaybe<Array<PersonActivity>>;
  excludeActivities?: InputMaybe<Array<PersonActivity>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** A movie. */
export type MovieClubsArgs = {
  brandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  clubIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** A movie. */
export type MovieCompaniesArgs = {
  activities?: InputMaybe<Array<CompanyActivity>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** A movie. */
export type MovieReleasesArgs = {
  type?: InputMaybe<ReleaseType>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<ReleaseOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** A movie. */
export type MovieClosestReleaseArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  releaseType?: InputMaybe<ReleaseType>;
  referenceDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  filterOnVisaNumber?: InputMaybe<Scalars['Boolean']['input']>;
  filterOnlyPastReleases?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A movie. */
export type MovieLocaleDataArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['ID']['input']>;
};


/** A movie. */
export type MovieLocalesDataArgs = {
  locales?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** A movie. */
export type MovieBrandDataArgs = {
  brandId: Scalars['ID']['input'];
};


/** A movie. */
export type MovieBrandsDataArgs = {
  brandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** A movie. */
export type MovieSeoAttributesArgs = {
  brandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** A pager to a list of ImageReference objects. */
export type ImageReferencePager = {
  /** The list of objects. */
  nodes: Array<ImageReference>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
  maxRank: Scalars['NonNegativeInt']['output'];
};

export type ImageReference = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  image: Image;
  category: Maybe<ImageCategory>;
  rank: Scalars['NonNegativeInt']['output'];
};

export type ImageCategory = Ref & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  /** The type of the image. */
  imageType: Maybe<ImageType>;
  name: Maybe<Scalars['String']['output']>;
  sponsored: Scalars['Boolean']['output'];
  rank: Scalars['NonNegativeInt']['output'];
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  images: ImageReferencePager;
  /** Aggregated TTL / validity stats for social user avatar and banner images in this category. */
  imagesValidityRange: ImagesValidityRange;
};


export type ImageCategoryImagesArgs = {
  hasTTL?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Aggregated validity stats for social avatar/banner images in the category (batched DataLoader). COMING_SOON: TTL start within 3 months after server now; PLANNED: TTL start later than that. */
export type ImagesValidityRange = {
  /** MIN(start_date) over images with full TTL (both dates set). */
  min: Maybe<Scalars['Date']['output']>;
  /** MAX(end_date) over images with full TTL. */
  max: Maybe<Scalars['Date']['output']>;
  /** Count of social avatar/banner images with both start_date and end_date set. */
  totalHasTtl: Scalars['Int']['output'];
  /** Count of social avatar/banner images in the category without a full TTL pair. */
  totalWithoutTtl: Scalars['Int']['output'];
  /** True if at least one full-TTL image has start in the future and within 3 calendar months from now. */
  hasComingSoon: Scalars['Boolean']['output'];
  /** True if at least one full-TTL image has start_date more than 3 calendar months after now. */
  hasPlanned: Scalars['Boolean']['output'];
};

/** A pager to a list of EntityTrivia objects. */
export type EntityTriviaPager = {
  /** The list of objects. */
  nodes: Array<EntityTrivia>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type EntityTrivia = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  rank: Scalars['NonNegativeInt']['output'];
  trivia: Trivia;
};

export type Trivia = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  type: Maybe<TriviaType>;
  /** The title of the trivia. */
  title: Scalars['String']['output'];
  body: Maybe<Scalars['RichText']['output']>;
  /** Entities linked to this trivia */
  relatedEntities: Array<TriviaLinkableEntity>;
};


export type TriviaRelatedEntitiesArgs = {
  includedTypes?: InputMaybe<Array<TriviaLinkableEntityType>>;
  excludedTypes?: InputMaybe<Array<TriviaLinkableEntityType>>;
};

/** Possible certificate scopes. */
export enum TriviaType {
  GoodReasons = 'GOOD_REASONS',
  Replicas = 'REPLICAS',
  FilmingSecrets = 'FILMING_SECRETS',
  Taglines = 'TAGLINES'
}

export type TriviaLinkableEntity = Movie | Series | SeriesSeason | SeriesEpisode | Person;

export type Series = Node & Entity & Ref & Brandable & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** Other IDs from external source to represent the screen. */
  externalIDs: Array<ExternalId>;
  /** The metadata of this entity. */
  metadata: Metadata;
  /** @deprecated use seoAttributes field now */
  seoData: Maybe<EntitySeoData>;
  images: ImageReferencePager;
  /** The trivias associated with the entity. */
  trivias: EntityTriviaPager;
  activeOnBrands: Array<Brand>;
  entityLinks: Array<EntityLink>;
  tags: EntityTagPager;
  /** The popularity of the series. */
  popularity: Maybe<Scalars['NonNegativeInt']['output']>;
  /** The title of the series. */
  title: Scalars['String']['output'];
  originalPremiere: Maybe<Scalars['PartialDate']['output']>;
  originalFinale: Maybe<Scalars['PartialDate']['output']>;
  premiereChannel: Maybe<Company>;
  /** The poster image of the series. */
  poster: Maybe<Image>;
  /** The series episodes base runtime in minutes. */
  baseRuntime: Maybe<Scalars['PositiveInt']['output']>;
  /** The genres of the series. */
  genres: Array<Genre>;
  /** Clubs informations for the entity */
  clubs: Maybe<Array<BrandEntityClub>>;
  /** The series's countries. */
  countries: Array<Country>;
  /** The companies of the series. */
  companies: EntityCompanyPager;
  type: Maybe<SeriesType>;
  status: Maybe<SeriesStatus>;
  /** The series releases. */
  releases: EntityReleasePager;
  /** The closest series release, time-related */
  closestRelease: Maybe<EntityRelease>;
  /** A cast and credits import report of this entity: the latest one, running or not, or the one whose id is given; null when none was ever launched or the id is not one of this entity's reports. */
  personCreditsImport: Maybe<PersonCreditsImportReport>;
  /** The cast and credits import reports of this entity, newest first. */
  personCreditsImports: Array<PersonCreditsImportReport>;
  /** The credits of the series. */
  credits: PersonCreditsPager;
  /** The series's seasons */
  seasons: SeriesSeasonPager;
  /** The series's episodes */
  episodes: SeriesEpisodePager;
  /** All localized fields for the series. */
  localeData: Maybe<SeriesLocaleData>;
  localesData: Maybe<Array<SeriesLocaleData>>;
  /** All brand's fields for the series. */
  brandData: Maybe<SeriesBrandData>;
  /** All brand's fields for the series. */
  brandsData: Maybe<Array<SeriesBrandData>>;
  seoAttributes: Array<EntitySeoData>;
  /** The series's keywords. */
  keywords: Array<Scalars['String']['output']>;
};


export type SeriesExternalIDsArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
};


export type SeriesSeoDataArgs = {
  brandId: Scalars['ID']['input'];
};


export type SeriesImagesArgs = {
  hasTTL?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type SeriesTriviasArgs = {
  brandId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type SeriesEntityLinksArgs = {
  linkType?: InputMaybe<Array<EntityLinkType>>;
};


export type SeriesTagsArgs = {
  brandId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type SeriesClubsArgs = {
  brandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  clubIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type SeriesCompaniesArgs = {
  activities?: InputMaybe<Array<CompanyActivity>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type SeriesReleasesArgs = {
  type?: InputMaybe<ReleaseType>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type SeriesClosestReleaseArgs = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  releaseType?: InputMaybe<ReleaseType>;
  referenceDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  filterOnVisaNumber?: InputMaybe<Scalars['Boolean']['input']>;
  filterOnlyPastReleases?: InputMaybe<Scalars['Boolean']['input']>;
};


export type SeriesPersonCreditsImportArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type SeriesPersonCreditsImportsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type SeriesCreditsArgs = {
  activities?: InputMaybe<Array<PersonActivity>>;
  excludeActivities?: InputMaybe<Array<PersonActivity>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type SeriesSeasonsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  seasonNumbers?: InputMaybe<Array<Scalars['NonNegativeInt']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type SeriesEpisodesArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SeriesEpisodeFilter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type SeriesLocaleDataArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['ID']['input']>;
};


export type SeriesLocalesDataArgs = {
  locales?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type SeriesBrandDataArgs = {
  brandId: Scalars['ID']['input'];
};


export type SeriesBrandsDataArgs = {
  brandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type SeriesSeoAttributesArgs = {
  brandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type EntitySeoData = {
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  isAutonomouslyActivable: Scalars['Boolean']['output'];
  browsable: Scalars['Boolean']['output'];
  description: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  alternateTitle: Maybe<Scalars['String']['output']>;
  brand: Brand;
  canActivate: Scalars['Boolean']['output'];
  userRequests: Maybe<Array<EntitySeoDataUserRequests>>;
};

export type EntityLink = {
  source: Entity;
  target: Entity;
  linkType: EntityLinkType;
  rank: Scalars['Int']['output'];
};

export enum EntityLinkType {
  IsARemakeOf = 'IS_A_REMAKE_OF',
  WasInspiredBy = 'WAS_INSPIRED_BY',
  IsASpinOffFrom = 'IS_A_SPIN_OFF_FROM',
  Similar = 'SIMILAR',
  PubPartner = 'PUB_PARTNER',
  CopyPartner = 'COPY_PARTNER'
}

/** A pager to a list of EntityTag objects. */
export type EntityTagPager = {
  /** The list of objects. */
  nodes: Array<EntityTag>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type EntityTag = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  rank: Scalars['NonNegativeInt']['output'];
  tag: Tag;
  entity: TagEntity;
};

export type Tag = Node & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  /** The name of the Tag. */
  name: Scalars['String']['output'];
  /** The data of the Tag. */
  data: TagData;
  /** The type of the Tag. */
  type: TagType;
  /** The scope of the Tag. */
  scope: Maybe<TagScope>;
  /** The entities linked to the tag */
  entities: EntityTagPager;
};


export type TagEntitiesArgs = {
  entityType?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type TagData = {
  seo: Maybe<TagSeoData>;
};

export type TagSeoData = {
  browsable: Maybe<Scalars['Boolean']['output']>;
  friendly: Maybe<Scalars['Boolean']['output']>;
  topRanking: Maybe<Scalars['Boolean']['output']>;
  scope: Maybe<TagSeoScopeData>;
};

export type TagSeoScopeData = {
  userRating: Maybe<TagSeoScope>;
  pressRating: Maybe<TagSeoScope>;
  popularity: Maybe<TagSeoScope>;
  ranking: Maybe<TagSeoScope>;
};

export type TagSeoScope = {
  movie: Maybe<TagSeoScopeEntityData>;
  series: Maybe<TagSeoScopeEntityData>;
};

export type TagSeoScopeEntityData = {
  title: Maybe<Scalars['String']['output']>;
  subTitle: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
};

export enum TagType {
  Ambiance = 'AMBIANCE',
  Characteristic = 'CHARACTERISTIC',
  Documentation = 'DOCUMENTATION',
  Envies = 'ENVIES',
  Environnement = 'ENVIRONNEMENT',
  Format = 'FORMAT',
  FictiveCharacter = 'FICTIVE_CHARACTER',
  Garbage = 'GARBAGE',
  HistoricalCharacter = 'HISTORICAL_CHARACTER',
  Keyword = 'KEYWORD',
  Location = 'LOCATION',
  MediaKeyword = 'MEDIA_KEYWORD',
  OeuvreDOrigine = 'OEUVRE_D_ORIGINE',
  Paysage = 'PAYSAGE',
  PublicVise = 'PUBLIC_VISE',
  Saga = 'SAGA',
  SubGenre = 'SUB_GENRE',
  Theme = 'THEME',
  ThemeDeSociete = 'THEME_DE_SOCIETE',
  Time = 'TIME',
  Versions = 'VERSIONS'
}

/** The available scopes for a tag. */
export enum TagScope {
  Age = 'AGE',
  Provider = 'PROVIDER',
  Theme = 'THEME',
  Tracking = 'TRACKING'
}

/** An entity associated to a tag */
export type TagEntity = Company | Movie | News | Person | SeriesEpisode | SeriesSeason | Series | Slide | Theater;

export type Company = Node & Establishment & Entity & Ref & Brandable & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** Other IDs from external source to represent the screen. */
  externalIDs: Array<ExternalId>;
  images: ImageReferencePager;
  activeOnBrands: Array<Brand>;
  /** @deprecated use seoAttributes field now */
  seoData: Maybe<EntitySeoData>;
  /** The name of the establishment. */
  name: Scalars['String']['output'];
  /** The parent establishment. */
  parent: Maybe<Company>;
  /** The establishment's logo. */
  logo: Maybe<Image>;
  /** The date when the establishment was created. */
  foundedAt: Maybe<Scalars['Date']['output']>;
  /** The establishment's links. */
  links: SocialLinks;
  /** The url to download the android application of the establishment. */
  androidUrl: Maybe<Scalars['URL']['output']>;
  /** The url to download the ios application of the establishment. */
  iosUrl: Maybe<Scalars['URL']['output']>;
  /** Whether the establishment is closed or not. */
  closed: Scalars['Boolean']['output'];
  /** The establishment's email. */
  email: Maybe<Scalars['EmailAddress']['output']>;
  /** The establishment's phone number. */
  phone: Maybe<Scalars['String']['output']>;
  /** The establishment's website URL. */
  websiteUrl: Maybe<Scalars['URL']['output']>;
  /** Some info relative to the location of the establishment. */
  location: Maybe<Address>;
  /** The establishment's coordinates. */
  coordinates: Maybe<Coordinates>;
  /** The establishment's localization. */
  localization: Maybe<Localization>;
  /** The establishment's additional notes. */
  note: Maybe<Scalars['String']['output']>;
  /** The establishment's description. */
  description: Maybe<Scalars['String']['output']>;
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The activities of the company. */
  activities: Array<CompanyActivity>;
  /** The activities tree structure */
  activitiesTree: Array<CompanyActivitySubactivity>;
  /** Whether users can select the company as a favorite SVOD provider. Only meaningful for companies carrying the ACTIVITY_PROVIDER_SVOD activity. */
  providerAsFavorite: Scalars['Boolean']['output'];
  companyStaffs: CompanyStaffPager;
  /** The child companies. */
  children: Array<Company>;
  data: CompanyData;
  /** All localized fields for the company. */
  localeData: Maybe<CompanyLocaleData>;
  /** All brand's fields for the company. */
  brandData: Maybe<CompanyBrandData>;
  brandsData: Maybe<Array<CompanyBrandData>>;
  seoAttributes: Array<EntitySeoData>;
  /** The country of the company. */
  country: Maybe<Country>;
};


export type CompanyExternalIDsArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyImagesArgs = {
  hasTTL?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanySeoDataArgs = {
  brandId: Scalars['ID']['input'];
};


export type CompanyCompanyStaffsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<CompanyStaffOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyLocaleDataArgs = {
  localeId: Scalars['ID']['input'];
};


export type CompanyBrandDataArgs = {
  brandId: Scalars['ID']['input'];
};


export type CompanyBrandsDataArgs = {
  brandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type CompanySeoAttributesArgs = {
  brandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Establishment = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** Other IDs from external source to represent the screen. */
  externalIDs: Array<ExternalId>;
  images: ImageReferencePager;
  activeOnBrands: Array<Brand>;
  /** @deprecated use seoAttributes field now */
  seoData: Maybe<EntitySeoData>;
  /** The name of the establishment. */
  name: Scalars['String']['output'];
  /** The parent establishment. */
  parent: Maybe<Company>;
  /** The establishment's logo. */
  logo: Maybe<Image>;
  /** The date when the establishment was created. */
  foundedAt: Maybe<Scalars['Date']['output']>;
  /** The establishment's links. */
  links: SocialLinks;
  /** The url to download the android application of the establishment. */
  androidUrl: Maybe<Scalars['URL']['output']>;
  /** The url to download the ios application of the establishment. */
  iosUrl: Maybe<Scalars['URL']['output']>;
  /** Whether the establishment is closed or not. */
  closed: Scalars['Boolean']['output'];
  /** The establishment's email. */
  email: Maybe<Scalars['EmailAddress']['output']>;
  /** The establishment's phone number. */
  phone: Maybe<Scalars['String']['output']>;
  /** The establishment's website URL. */
  websiteUrl: Maybe<Scalars['URL']['output']>;
  /** Some info relative to the location of the establishment. */
  location: Maybe<Address>;
  /** The establishment's coordinates. */
  coordinates: Maybe<Coordinates>;
  /** The establishment's localization. */
  localization: Maybe<Localization>;
  /** The establishment's additional notes. */
  note: Maybe<Scalars['String']['output']>;
  /** The establishment's description. */
  description: Maybe<Scalars['String']['output']>;
};


export type EstablishmentExternalIDsArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
};


export type EstablishmentImagesArgs = {
  hasTTL?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type EstablishmentSeoDataArgs = {
  brandId: Scalars['ID']['input'];
};

export type SocialLinks = {
  facebook: Maybe<Scalars['URL']['output']>;
  bluesky: Maybe<Scalars['URL']['output']>;
  instagram: Maybe<Scalars['URL']['output']>;
  letterboxd: Maybe<Scalars['URL']['output']>;
  linkedin: Maybe<Scalars['URL']['output']>;
  pinterest: Maybe<Scalars['URL']['output']>;
  snapchat: Maybe<Scalars['URL']['output']>;
  threads: Maybe<Scalars['URL']['output']>;
  tiktok: Maybe<Scalars['URL']['output']>;
  tumblr: Maybe<Scalars['URL']['output']>;
  twitter: Maybe<Scalars['URL']['output']>;
  vk: Maybe<Scalars['URL']['output']>;
  wechat: Maybe<Scalars['URL']['output']>;
  whatsapp: Maybe<Scalars['URL']['output']>;
  youtube: Maybe<Scalars['URL']['output']>;
};

export type Address = {
  /** The main address. */
  address: Maybe<Scalars['String']['output']>;
  /** The address complement. */
  address2: Maybe<Scalars['String']['output']>;
  /** The address zip. */
  zip: Maybe<Scalars['String']['output']>;
  /** The address city. */
  city: Maybe<Scalars['String']['output']>;
  /** The address country. */
  country: Maybe<Scalars['String']['output']>;
  /** The address state. */
  state: Maybe<Scalars['String']['output']>;
  /** The address county. */
  county: Maybe<Scalars['String']['output']>;
};

export type Coordinates = {
  /** The coordinates' latitude. */
  latitude: Scalars['Float']['output'];
  /** The coordinates' longitude. */
  longitude: Scalars['Float']['output'];
  /** The distance between those coordinates and those passed in 'from' parameter. */
  distance: Scalars['Float']['output'];
};


export type CoordinatesDistanceArgs = {
  from: CoordinatesInput;
  unit: DistanceUnit;
};

export type CoordinatesInput = {
  /** The coordinates' latitude. */
  latitude: Scalars['Float']['input'];
  /** The coordinates' longitude. */
  longitude: Scalars['Float']['input'];
};

export enum DistanceUnit {
  Km = 'KM',
  Mi = 'MI'
}

export enum CompanyActivity {
  ActivityProduction = 'ACTIVITY_PRODUCTION',
  ActivityDistribution = 'ACTIVITY_DISTRIBUTION',
  ActivityInternationalDistributionExports = 'ACTIVITY_INTERNATIONAL_DISTRIBUTION_EXPORTS',
  ActivityAnimationStudio = 'ACTIVITY_ANIMATION_STUDIO',
  ActivityCoProduction = 'ACTIVITY_CO_PRODUCTION',
  ActivityAgents = 'ACTIVITY_AGENTS',
  SubactivityFilmDistribution = 'SUBACTIVITY_FILM_DISTRIBUTION',
  SubactivityAlternateProgramDistribution = 'SUBACTIVITY_ALTERNATE_PROGRAM_DISTRIBUTION',
  ActivityBooking = 'ACTIVITY_BOOKING',
  SubactivityNationalBookers = 'SUBACTIVITY_NATIONAL_BOOKERS',
  ActivityExecutiveProducer = 'ACTIVITY_EXECUTIVE_PRODUCER',
  ActivityFilmExhibitor = 'ACTIVITY_FILM_EXHIBITOR',
  ActivityMusicalSupervisor = 'ACTIVITY_MUSICAL_SUPERVISOR',
  ActivityNetworkServiceProvider = 'ACTIVITY_NETWORK_SERVICE_PROVIDER',
  ActivityPostProduction = 'ACTIVITY_POST_PRODUCTION',
  ActivityPrAgency = 'ACTIVITY_PR_AGENCY',
  ActivityPress = 'ACTIVITY_PRESS',
  ActivityProviderAvod = 'ACTIVITY_PROVIDER_AVOD',
  ActivityProviderDvd = 'ACTIVITY_PROVIDER_DVD',
  ActivityProviderReplay = 'ACTIVITY_PROVIDER_REPLAY',
  ActivityProviderSvod = 'ACTIVITY_PROVIDER_SVOD',
  ActivityProviderVod = 'ACTIVITY_PROVIDER_VOD',
  ActivitySoundEditor = 'ACTIVITY_SOUND_EDITOR',
  ActivitySpecialEffects = 'ACTIVITY_SPECIAL_EFFECTS',
  ActivityStorage = 'ACTIVITY_STORAGE',
  ActivityMerchant = 'ACTIVITY_MERCHANT',
  SubactivityCopyStorageAndPublicity = 'SUBACTIVITY_COPY_STORAGE_AND_PUBLICITY',
  SubactivityCarriers = 'SUBACTIVITY_CARRIERS',
  ActivityLayout = 'ACTIVITY_LAYOUT',
  SubactivityArchitectsDesignOfficesSchedulingSteeringCoordination = 'SUBACTIVITY_ARCHITECTS_DESIGN_OFFICES_SCHEDULING_STEERING_COORDINATION',
  SubactivityConstruction = 'SUBACTIVITY_CONSTRUCTION',
  SubactivityWallCoveringsCarpeting = 'SUBACTIVITY_WALL_COVERINGS_CARPETING',
  ActivityEquipment = 'ACTIVITY_EQUIPMENT',
  SubactivityTheaterPointOfSale = 'SUBACTIVITY_THEATER_POINT_OF_SALE',
  SubactivityDisplayingSignsInfoSystems = 'SUBACTIVITY_DISPLAYING_SIGNS_INFO_SYSTEMS',
  SubactivitySeatsDecorationMarkup = 'SUBACTIVITY_SEATS_DECORATION_MARKUP',
  SubactivityCounterLayout = 'SUBACTIVITY_COUNTER_LAYOUT',
  SubactivityServicesAndMaintenance = 'SUBACTIVITY_SERVICES_AND_MAINTENANCE',
  ActivityBooth = 'ACTIVITY_BOOTH',
  SubactivityProjectors = 'SUBACTIVITY_PROJECTORS',
  SubactivityServersAndElectronicDeliverySystems = 'SUBACTIVITY_SERVERS_AND_ELECTRONIC_DELIVERY_SYSTEMS',
  SubactivityDigitalCinemaPromoters = 'SUBACTIVITY_DIGITAL_CINEMA_PROMOTERS',
  SubactivitySoundSystem = 'SUBACTIVITY_SOUND_SYSTEM',
  SubactivityScreens_3DGlasses = 'SUBACTIVITY_SCREENS_3D_GLASSES',
  SubactivityRentingEventServices = 'SUBACTIVITY_RENTING_EVENT_SERVICES',
  ActivityCounter = 'ACTIVITY_COUNTER',
  SubactivityDrinksSweetsChocolateIceCreamPopcornSnacks = 'SUBACTIVITY_DRINKS_SWEETS_CHOCOLATE_ICE_CREAM_POPCORN_SNACKS',
  SubactivityWholesalers = 'SUBACTIVITY_WHOLESALERS',
  ActivityAdvertisingCommunication = 'ACTIVITY_ADVERTISING_COMMUNICATION',
  SubactivityAdvertisingNetworks = 'SUBACTIVITY_ADVERTISING_NETWORKS',
  SubactivityCommunicationAndMarketing = 'SUBACTIVITY_COMMUNICATION_AND_MARKETING',
  ActivityServices = 'ACTIVITY_SERVICES',
  SubactivityStudiesSurveysNumbers = 'SUBACTIVITY_STUDIES_SURVEYS_NUMBERS',
  SubactivityInsuranceFunding = 'SUBACTIVITY_INSURANCE_FUNDING',
  SubactivityTraining = 'SUBACTIVITY_TRAINING',
  ActivityInstitutions = 'ACTIVITY_INSTITUTIONS',
  SubactivityCnc = 'SUBACTIVITY_CNC',
  SubactivityCinemaMediator = 'SUBACTIVITY_CINEMA_MEDIATOR',
  SubactivityPublicOrganizations = 'SUBACTIVITY_PUBLIC_ORGANIZATIONS',
  SubactivityAssociationsFederations = 'SUBACTIVITY_ASSOCIATIONS_FEDERATIONS',
  SubactivityUnions = 'SUBACTIVITY_UNIONS',
  ActivityTheaterAffiliate = 'ACTIVITY_THEATER_AFFILIATE',
  ActivityTheater = 'ACTIVITY_THEATER',
  ActivityTheaterChain = 'ACTIVITY_THEATER_CHAIN',
  ActivityTheaterOnlineTicketing = 'ACTIVITY_THEATER_ONLINE_TICKETING',
  ActivityTheaterPointOfSale = 'ACTIVITY_THEATER_POINT_OF_SALE',
  ActivityTheaterTradeGroup = 'ACTIVITY_THEATER_TRADE_GROUP',
  ActivityTvChannel = 'ACTIVITY_TV_CHANNEL',
  ActivityVideoProvider = 'ACTIVITY_VIDEO_PROVIDER',
  ActivityVisualEffects = 'ACTIVITY_VISUAL_EFFECTS',
  SubactivitySurveillanceSecurityProtection = 'SUBACTIVITY_SURVEILLANCE_SECURITY_PROTECTION'
}

export type CompanyActivitySubactivity = {
  activity: CompanyActivities;
  subactivities: Array<CompanySubactivities>;
};

export enum CompanyActivities {
  ActivityProduction = 'ACTIVITY_PRODUCTION',
  ActivityDistribution = 'ACTIVITY_DISTRIBUTION',
  ActivityInternationalDistributionExports = 'ACTIVITY_INTERNATIONAL_DISTRIBUTION_EXPORTS',
  ActivityAnimationStudio = 'ACTIVITY_ANIMATION_STUDIO',
  ActivityCoProduction = 'ACTIVITY_CO_PRODUCTION',
  ActivityAgents = 'ACTIVITY_AGENTS',
  ActivityBooking = 'ACTIVITY_BOOKING',
  ActivityExecutiveProducer = 'ACTIVITY_EXECUTIVE_PRODUCER',
  ActivityFilmExhibitor = 'ACTIVITY_FILM_EXHIBITOR',
  ActivityMusicalSupervisor = 'ACTIVITY_MUSICAL_SUPERVISOR',
  ActivityNetworkServiceProvider = 'ACTIVITY_NETWORK_SERVICE_PROVIDER',
  ActivityPostProduction = 'ACTIVITY_POST_PRODUCTION',
  ActivityPrAgency = 'ACTIVITY_PR_AGENCY',
  ActivityPress = 'ACTIVITY_PRESS',
  ActivityProviderAvod = 'ACTIVITY_PROVIDER_AVOD',
  ActivityProviderDvd = 'ACTIVITY_PROVIDER_DVD',
  ActivityProviderReplay = 'ACTIVITY_PROVIDER_REPLAY',
  ActivityProviderSvod = 'ACTIVITY_PROVIDER_SVOD',
  ActivityProviderVod = 'ACTIVITY_PROVIDER_VOD',
  ActivitySoundEditor = 'ACTIVITY_SOUND_EDITOR',
  ActivitySpecialEffects = 'ACTIVITY_SPECIAL_EFFECTS',
  ActivityStorage = 'ACTIVITY_STORAGE',
  ActivityMerchant = 'ACTIVITY_MERCHANT',
  ActivityLayout = 'ACTIVITY_LAYOUT',
  ActivityEquipment = 'ACTIVITY_EQUIPMENT',
  ActivityBooth = 'ACTIVITY_BOOTH',
  ActivityCounter = 'ACTIVITY_COUNTER',
  ActivityAdvertisingCommunication = 'ACTIVITY_ADVERTISING_COMMUNICATION',
  ActivityServices = 'ACTIVITY_SERVICES',
  ActivityInstitutions = 'ACTIVITY_INSTITUTIONS',
  ActivityTheaterAffiliate = 'ACTIVITY_THEATER_AFFILIATE',
  ActivityTheater = 'ACTIVITY_THEATER',
  ActivityTheaterChain = 'ACTIVITY_THEATER_CHAIN',
  ActivityTheaterOnlineTicketing = 'ACTIVITY_THEATER_ONLINE_TICKETING',
  ActivityTheaterPointOfSale = 'ACTIVITY_THEATER_POINT_OF_SALE',
  ActivityTheaterTradeGroup = 'ACTIVITY_THEATER_TRADE_GROUP',
  ActivityTvChannel = 'ACTIVITY_TV_CHANNEL',
  ActivityVideoProvider = 'ACTIVITY_VIDEO_PROVIDER',
  ActivityVisualEffects = 'ACTIVITY_VISUAL_EFFECTS'
}

export enum CompanySubactivities {
  SubactivityFilmDistribution = 'SUBACTIVITY_FILM_DISTRIBUTION',
  SubactivityAlternateProgramDistribution = 'SUBACTIVITY_ALTERNATE_PROGRAM_DISTRIBUTION',
  SubactivityNationalBookers = 'SUBACTIVITY_NATIONAL_BOOKERS',
  SubactivityCopyStorageAndPublicity = 'SUBACTIVITY_COPY_STORAGE_AND_PUBLICITY',
  SubactivityCarriers = 'SUBACTIVITY_CARRIERS',
  SubactivityArchitectsDesignOfficesSchedulingSteeringCoordination = 'SUBACTIVITY_ARCHITECTS_DESIGN_OFFICES_SCHEDULING_STEERING_COORDINATION',
  SubactivityConstruction = 'SUBACTIVITY_CONSTRUCTION',
  SubactivityWallCoveringsCarpeting = 'SUBACTIVITY_WALL_COVERINGS_CARPETING',
  SubactivityTheaterPointOfSale = 'SUBACTIVITY_THEATER_POINT_OF_SALE',
  SubactivityDisplayingSignsInfoSystems = 'SUBACTIVITY_DISPLAYING_SIGNS_INFO_SYSTEMS',
  SubactivitySeatsDecorationMarkup = 'SUBACTIVITY_SEATS_DECORATION_MARKUP',
  SubactivityCounterLayout = 'SUBACTIVITY_COUNTER_LAYOUT',
  SubactivityServicesAndMaintenance = 'SUBACTIVITY_SERVICES_AND_MAINTENANCE',
  SubactivityProjectors = 'SUBACTIVITY_PROJECTORS',
  SubactivityServersAndElectronicDeliverySystems = 'SUBACTIVITY_SERVERS_AND_ELECTRONIC_DELIVERY_SYSTEMS',
  SubactivityDigitalCinemaPromoters = 'SUBACTIVITY_DIGITAL_CINEMA_PROMOTERS',
  SubactivitySoundSystem = 'SUBACTIVITY_SOUND_SYSTEM',
  SubactivityScreens_3DGlasses = 'SUBACTIVITY_SCREENS_3D_GLASSES',
  SubactivityRentingEventServices = 'SUBACTIVITY_RENTING_EVENT_SERVICES',
  SubactivityDrinksSweetsChocolateIceCreamPopcornSnacks = 'SUBACTIVITY_DRINKS_SWEETS_CHOCOLATE_ICE_CREAM_POPCORN_SNACKS',
  SubactivityWholesalers = 'SUBACTIVITY_WHOLESALERS',
  SubactivityAdvertisingNetworks = 'SUBACTIVITY_ADVERTISING_NETWORKS',
  SubactivityCommunicationAndMarketing = 'SUBACTIVITY_COMMUNICATION_AND_MARKETING',
  SubactivityStudiesSurveysNumbers = 'SUBACTIVITY_STUDIES_SURVEYS_NUMBERS',
  SubactivityInsuranceFunding = 'SUBACTIVITY_INSURANCE_FUNDING',
  SubactivityTraining = 'SUBACTIVITY_TRAINING',
  SubactivityCnc = 'SUBACTIVITY_CNC',
  SubactivityCinemaMediator = 'SUBACTIVITY_CINEMA_MEDIATOR',
  SubactivityPublicOrganizations = 'SUBACTIVITY_PUBLIC_ORGANIZATIONS',
  SubactivityAssociationsFederations = 'SUBACTIVITY_ASSOCIATIONS_FEDERATIONS',
  SubactivityUnions = 'SUBACTIVITY_UNIONS',
  SubactivitySurveillanceSecurityProtection = 'SUBACTIVITY_SURVEILLANCE_SECURITY_PROTECTION'
}

/** A pager to a list of CompanyStaff objects. */
export type CompanyStaffPager = {
  /** The list of objects. */
  nodes: Array<CompanyStaff>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

/** The staff related to a company */
export type CompanyStaff = Node & Entity & Ref & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** @deprecated use seoAttributes field now */
  seoData: Maybe<EntitySeoData>;
  /** Other IDs from external source to represent the screen. */
  externalIDs: Array<ExternalId>;
  /** The metadata of this entity. */
  metadata: Metadata;
  rank: Scalars['NonNegativeInt']['output'];
  /** The company where the staff belongs to */
  company: Maybe<Company>;
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** The company ID where the staff belongs to */
  companyId: Maybe<Scalars['ID']['output']>;
  /** The department of the staff */
  department: Maybe<CompanyStaffDepartment>;
  /** The full name of the staff */
  name: Maybe<Scalars['String']['output']>;
  /** The fist name of the staff */
  firstName: Maybe<Scalars['String']['output']>;
  /** The last name of the staff */
  lastName: Maybe<Scalars['String']['output']>;
  /** The title of the staff */
  title: Maybe<Scalars['String']['output']>;
  /** The email of the staff */
  email: Maybe<Scalars['String']['output']>;
  /** The work phone of the staff */
  workPhone: Maybe<Scalars['String']['output']>;
  /** The mobile phone of the staff */
  mobilePhone: Maybe<Scalars['String']['output']>;
  /** The company that have link storage and/or publicity as sub-activity */
  linkedCompanies: Maybe<Array<Company>>;
};


/** The staff related to a company */
export type CompanyStaffSeoDataArgs = {
  brandId: Scalars['ID']['input'];
};


/** The staff related to a company */
export type CompanyStaffExternalIDsArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
};


/** The staff related to a company */
export type CompanyStaffLinkedCompaniesArgs = {
  linkType?: InputMaybe<EntityLinkType>;
};

export enum CompanyStaffDepartment {
  Executive = 'EXECUTIVE',
  Sales = 'SALES',
  Tech = 'TECH',
  ClientAccounting = 'CLIENT_ACCOUNTING',
  Press = 'PRESS',
  Communication = 'COMMUNICATION',
  Finance = 'FINANCE',
  Operations = 'OPERATIONS',
  ExhibitorMarketing = 'EXHIBITOR_MARKETING',
  MarketingPublicity = 'MARKETING_PUBLICITY',
  CommercialManagement = 'COMMERCIAL_MANAGEMENT',
  Programming = 'PROGRAMMING',
  Acquisitions = 'ACQUISITIONS',
  ExhibitorBilling = 'EXHIBITOR_BILLING',
  Administration = 'ADMINISTRATION'
}

export type CompanyStaffOrder = {
  /** The field to order by. */
  field: CompanyStaffOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum CompanyStaffOrderField {
  Id = 'ID',
  Rank = 'RANK',
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
  Department = 'DEPARTMENT',
  Name = 'NAME',
  Title = 'TITLE',
  Active = 'ACTIVE'
}

/** Possible directions in which to order a list of items. */
export enum OrderDirection {
  /** Specifies an ascending order. */
  Asc = 'ASC',
  /** Specifies a descending order. */
  Desc = 'DESC'
}

export type CompanyData = {
  approvals: Maybe<CompanyDataApproval>;
  sourceName: Maybe<Scalars['String']['output']>;
  allowMatchingTypeOverrides: Scalars['Boolean']['output'];
};

export type CompanyDataApproval = {
  cnc: Maybe<CompanyDataApprovalGeneric>;
};

export type CompanyDataApprovalGeneric = {
  number: Maybe<Scalars['String']['output']>;
};

export type CompanyLocaleData = {
  /** The company's summary. */
  description: Maybe<Scalars['String']['output']>;
  /** The company's name. */
  name: Maybe<Scalars['String']['output']>;
  /** The locale. */
  locale: Scalars['ID']['output'];
};

export type CompanyBrandData = {
  /** The company's summary. */
  description: Maybe<Scalars['String']['output']>;
  /** The company's name. */
  name: Maybe<Scalars['String']['output']>;
  brand: Brand;
};

export type News = Node & Entity & Ref & PublishableEntityInterface & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** Other IDs from external source to represent the screen. */
  externalIDs: Array<ExternalId>;
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  tags: EntityTagPager;
  isUpdatedWhenPublished: Scalars['Boolean']['output'];
  publications: Array<EntityPublication>;
  publicationStatus: EntityPublicationStatus;
  publicationDate: Maybe<Scalars['DateTime']['output']>;
  /** The title of the news. */
  title: Scalars['String']['output'];
  /** The social title of the news. */
  socialTitle: Maybe<Scalars['String']['output']>;
  /** The type of the news. */
  type: NewsType;
  /** The category of the news. */
  category: Maybe<NewsCategory>;
  /** The universe of the news. */
  universe: Maybe<NewsUniverse>;
  /** The credits of the news. */
  credits: Maybe<Scalars['String']['output']>;
  /** The headline of the news. */
  headline: Maybe<Scalars['String']['output']>;
  /** The poster of the news. */
  poster: Maybe<Image>;
  /** The authors of the news */
  authors: Array<NewsAuthor>;
  seoAttributes: NewsSeoAttributes;
  seoHidden: Scalars['Boolean']['output'];
  onlyOnSocialSite: Scalars['Boolean']['output'];
  slideshowSlides: Array<SlideshowSlide>;
  pages: Array<NewsPage>;
  /** Entities linked to this news */
  relatedEntities: Array<NewsLinkableEntity>;
  /** Keywords related to this news */
  keywords: Array<Scalars['String']['output']>;
  tracking: Scalars['Boolean']['output'];
};


export type NewsExternalIDsArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
};


export type NewsTagsArgs = {
  brandId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type NewsRelatedEntitiesArgs = {
  includedTypes?: InputMaybe<Array<NewsLinkableEntityType>>;
  excludedTypes?: InputMaybe<Array<NewsLinkableEntityType>>;
};

export type PublishableEntityInterface = {
  isUpdatedWhenPublished: Scalars['Boolean']['output'];
  publications: Array<EntityPublication>;
  publicationStatus: EntityPublicationStatus;
  publicationDate: Maybe<Scalars['DateTime']['output']>;
};

export type EntityPublication = {
  startsAt: Scalars['DateTime']['output'];
  endsAt: Maybe<Scalars['DateTime']['output']>;
  status: EntityPublicationStatus;
};

export enum EntityPublicationStatus {
  Draft = 'DRAFT',
  Planned = 'PLANNED',
  Published = 'PUBLISHED',
  Archived = 'ARCHIVED'
}

export enum NewsType {
  Actualite = 'ACTUALITE',
  Diaporama = 'DIAPORAMA',
  Dossier = 'DOSSIER',
  Jukebox = 'JUKEBOX',
  OldFolder = 'OLD_FOLDER',
  Playlist = 'PLAYLIST',
  Podcast = 'PODCAST'
}

export enum NewsCategory {
  AmigosDeSensacine = 'AMIGOS_DE_SENSACINE',
  AsSeenOnTheWeb = 'AS_SEEN_ON_THE_WEB',
  AsSeenOnTheWebFeature = 'AS_SEEN_ON_THE_WEB_FEATURE',
  Berlinale = 'BERLINALE',
  Business = 'BUSINESS',
  BusinessFeature = 'BUSINESS_FEATURE',
  Celebrities = 'CELEBRITIES',
  CelebritiesFeature = 'CELEBRITIES_FEATURE',
  CelebritiesFeatureMovie = 'CELEBRITIES_FEATURE_MOVIE',
  CelebritiesProject = 'CELEBRITIES_PROJECT',
  ComicCon = 'COMIC_CON',
  ConcursosYPreestrenos = 'CONCURSOS_Y_PREESTRENOS',
  Culture = 'CULTURE',
  DossierGalleriePhotoDie = 'DOSSIER_GALLERIE_PHOTO_DIE',
  DossierGalleriePhotoListenListenListen = 'DOSSIER_GALLERIE_PHOTO_LISTEN_LISTEN_LISTEN',
  DossierGalleriePhotoPortraitDeStarSeries = 'DOSSIER_GALLERIE_PHOTO_PORTRAIT_DE_STAR_SERIES',
  DossierGalleriePhotoTvTipps = 'DOSSIER_GALLERIE_PHOTO_TV_TIPPS',
  DossiersCourtsMetrages = 'DOSSIERS_COURTS_METRAGES',
  DvdBooks = 'DVD_BOOKS',
  EmissionsMags = 'EMISSIONS_MAGS',
  Features = 'FEATURES',
  FestivalsAwards = 'FESTIVALS_AWARDS',
  FestivalsAwardsFeature = 'FESTIVALS_AWARDS_FEATURE',
  FilmsAsSeenOnTheWeb = 'FILMS_AS_SEEN_ON_THE_WEB',
  FilmsInProduction = 'FILMS_IN_PRODUCTION',
  FilmsPeople = 'FILMS_PEOPLE',
  FilmsTrailerVideos = 'FILMS_TRAILER_VIDEOS',
  Indie = 'INDIE',
  Insolite = 'INSOLITE',
  Interviews = 'INTERVIEWS',
  InterviewsFeature = 'INTERVIEWS_FEATURE',
  InterviewsSeries = 'INTERVIEWS_SERIES',
  Itunes = 'ITUNES',
  ListeGenerique = 'LISTE_GENERIQUE',
  MovieDidYouKnow = 'MOVIE_DID_YOU_KNOW',
  MovieEvent = 'MOVIE_EVENT',
  MovieLaunch = 'MOVIE_LAUNCH',
  MovieLaunchFeature = 'MOVIE_LAUNCH_FEATURE',
  MovieNews = 'MOVIE_NEWS',
  MovieQuiz = 'MOVIE_QUIZ',
  MoviesOnTv = 'MOVIES_ON_TV',
  OnTv = 'ON_TV',
  NationalEventTheater = 'NATIONAL_EVENT_THEATER',
  Netflix = 'NETFLIX',
  NewsPhotos = 'NEWS_PHOTOS',
  NewsSoundtrack = 'NEWS_SOUNDTRACK',
  NowFilming = 'NOW_FILMING',
  NowFilmingFeature = 'NOW_FILMING_FEATURE',
  OurVideoPicks = 'OUR_VIDEO_PICKS',
  PersonalStuffMovie = 'PERSONAL_STUFF_MOVIE',
  PersonalStuffSeries = 'PERSONAL_STUFF_SERIES',
  Report = 'REPORT',
  Retrospective = 'RETROSPECTIVE',
  Series = 'SERIES',
  SeriesAsSeenOnTheWeb = 'SERIES_AS_SEEN_ON_THE_WEB',
  SeriesInProduction = 'SERIES_IN_PRODUCTION',
  SeriesDidYouKnow = 'SERIES_DID_YOU_KNOW',
  SeriesQuiz = 'SERIES_QUIZ',
  SeriesStreaming = 'SERIES_STREAMING',
  ShortFilms = 'SHORT_FILMS',
  ShortFilmsVideo = 'SHORT_FILMS_VIDEO',
  Streaming = 'STREAMING',
  Telerealite = 'TELEREALITE',
  TopsFlopsSeries = 'TOPS_FLOPS_SERIES',
  Tv = 'TV',
  TvSeries = 'TV_SERIES',
  TvSeriesBusiness = 'TV_SERIES_BUSINESS',
  TvSeriesChannels = 'TV_SERIES_CHANNELS',
  TvSeriesFeatures = 'TV_SERIES_FEATURES',
  TvSeriesFeaturesBestof = 'TV_SERIES_FEATURES_BESTOF',
  TvSeriesFeaturesFocusOn = 'TV_SERIES_FEATURES_FOCUS_ON',
  TvSeriesFeaturesTalkBack = 'TV_SERIES_FEATURES_TALK_BACK',
  TvSeriesFeaturesWhatsOn = 'TV_SERIES_FEATURES_WHATS_ON',
  TvSeriesFeaturesWhereAreTheyNow = 'TV_SERIES_FEATURES_WHERE_ARE_THEY_NOW',
  TvSeriesFestivals = 'TV_SERIES_FESTIVALS',
  TvSeriesInterviews = 'TV_SERIES_INTERVIEWS',
  TvSeriesPeople = 'TV_SERIES_PEOPLE',
  TvSeriesPressRoundup = 'TV_SERIES_PRESS_ROUNDUP',
  TvSeriesQuiz = 'TV_SERIES_QUIZ',
  TvSeriesRatings = 'TV_SERIES_RATINGS',
  TvSeriesSpoilers = 'TV_SERIES_SPOILERS',
  TvSeriesTopFeatures = 'TV_SERIES_TOP_FEATURES',
  VideoBuzz = 'VIDEO_BUZZ',
  VideoGamesFeature = 'VIDEO_GAMES_FEATURE',
  VideoGamesNews = 'VIDEO_GAMES_NEWS',
  ShoppingGoodDeals = 'SHOPPING_GOOD_DEALS',
  ShoppingBuyingGuides = 'SHOPPING_BUYING_GUIDES',
  ShoppingTests = 'SHOPPING_TESTS'
}

export enum NewsUniverse {
  Movie = 'MOVIE',
  Person = 'PERSON',
  Series = 'SERIES',
  ShortFilm = 'SHORT_FILM',
  ShortFilmMovie = 'SHORT_FILM_MOVIE',
  Soundtrack = 'SOUNDTRACK',
  Video = 'VIDEO',
  VideoGame = 'VIDEO_GAME',
  GenericIvoryCoast = 'GENERIC_IVORY_COAST',
  GenericTvActu = 'GENERIC_TV_ACTU',
  GenericShopping = 'GENERIC_SHOPPING'
}

/** The link between a news and an author */
export type NewsAuthor = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  rank: Scalars['NonNegativeInt']['output'];
  author: Author;
  signature: Maybe<AuthorSignature>;
};

export type AuthorSignature = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  signature: Scalars['String']['output'];
  author: Author;
};

export type NewsSeoAttributes = {
  title: Maybe<Scalars['String']['output']>;
  subtitle: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
};

/** Represents a slide from a news slideshow */
export type SlideshowSlide = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The associated brand. */
  brand: Brand;
  number: Scalars['Int']['output'];
  news: News;
  image: Image;
  title: Scalars['String']['output'];
  body: Maybe<Scalars['RichText']['output']>;
};

export type NewsPage = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The associated brand. */
  brand: Brand;
  number: Scalars['Int']['output'];
  news: News;
  video: Maybe<VideoLegacy>;
  title: Maybe<Scalars['String']['output']>;
  body: Maybe<Scalars['RichText']['output']>;
};

export type VideoLegacy = Node & Entity & Ref & Video & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** Other IDs from external source to represent the screen. */
  externalIDs: Array<ExternalId>;
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The title of the video. */
  title: Maybe<Scalars['String']['output']>;
  /** The generated title of the video */
  generatedTitle: Maybe<Scalars['String']['output']>;
  /** The type of the video. */
  type: VideoType;
  /** The universe of the video */
  universe: Maybe<VideoUniverse>;
  /** The start date of the video */
  startsAt: Maybe<Scalars['DateTime']['output']>;
  /** The end date of the video */
  endsAt: Maybe<Scalars['DateTime']['output']>;
  /** The language of the video. */
  language: Maybe<Language>;
  /** The subtitle of the video. */
  subtitle: Maybe<Language>;
  /** The restrictions of the video */
  restrictions: Array<RestrictionType>;
  /** The description of the video. */
  description: Maybe<Scalars['String']['output']>;
  /** The snapshot of the video. */
  snapshot: Maybe<Image>;
  /** The final name of the combination of the related copyrights */
  copyrightName: Maybe<Scalars['String']['output']>;
  /** The copyright of the video */
  copyrights: Maybe<Array<Copyright>>;
  /** The embed code of the video */
  embedCode: Maybe<Scalars['String']['output']>;
  /** The duration of the video. */
  duration: Maybe<Runtime>;
  /** Entities linked to this video */
  relatedEntities: Array<VideoLinkableEntity>;
  /** Entities linked to this video */
  rankRelatedEntities: Array<RankRelatedEntity>;
  /** Files linked to the video */
  videoFiles: Maybe<Array<Maybe<VideoFile>>>;
  /** Main file linked to the video that can be used for previews */
  previewVideoFile: Maybe<VideoFile>;
  alt: Maybe<VideoAltType>;
  /** The suggested title according to the video and all its related entities */
  suggestedTitle: Maybe<Scalars['String']['output']>;
  validity: Maybe<VideoValidityType>;
  /** The associated brand. */
  brand: Brand;
  /** Dailymotion url of the video */
  dailymotionUrl: Maybe<Scalars['String']['output']>;
  /** YouTube url of the video */
  youtubeUrl: Maybe<Scalars['String']['output']>;
  /** YouTube channel preselected for this video, from its Video.Type tag */
  defaultYoutubeChannelId: Maybe<Scalars['String']['output']>;
  /** Dailymotion channel (user id) the video is published under; null when the brand has no Dailymotion config */
  dailymotionChannelId: Maybe<Scalars['String']['output']>;
  /** YouTube channels of the video brand; empty when YouTube is not configured for the brand */
  youtubeChannels: Array<YoutubeChannel>;
  certificate: Maybe<Certificate>;
};


export type VideoLegacyExternalIDsArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
};


export type VideoLegacyRankRelatedEntitiesArgs = {
  entityId?: InputMaybe<Scalars['ID']['input']>;
};

export type Video = {
  id: Scalars['ID']['output'];
  ref: Scalars['ID']['output'];
  active: Maybe<Scalars['Boolean']['output']>;
  metadata: Metadata;
  snapshot: Maybe<Image>;
  type: VideoType;
  duration: Maybe<Runtime>;
  title: Maybe<Scalars['String']['output']>;
  generatedTitle: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  copyrightName: Maybe<Scalars['String']['output']>;
  copyrights: Maybe<Array<Copyright>>;
  embedCode: Maybe<Scalars['String']['output']>;
  startsAt: Maybe<Scalars['DateTime']['output']>;
  endsAt: Maybe<Scalars['DateTime']['output']>;
  language: Maybe<Language>;
  subtitle: Maybe<Language>;
  restrictions: Array<Maybe<RestrictionType>>;
  relatedEntities: Array<VideoLinkableEntity>;
  rankRelatedEntities: Array<RankRelatedEntity>;
  videoFiles: Maybe<Array<Maybe<VideoFile>>>;
  alt: Maybe<VideoAltType>;
  suggestedTitle: Maybe<Scalars['String']['output']>;
  validity: Maybe<VideoValidityType>;
  certificate: Maybe<Certificate>;
};


export type VideoRankRelatedEntitiesArgs = {
  entityId?: InputMaybe<Scalars['ID']['input']>;
};

export enum VideoType {
  Trailer = 'TRAILER',
  Teaser = 'TEASER',
  Clip = 'CLIP',
  Commercial = 'COMMERCIAL',
  CritiqueInternauteVideo = 'CRITIQUE_INTERNAUTE_VIDEO',
  EmergenceCarouselVideo = 'EMERGENCE_CAROUSEL_VIDEO',
  Emission = 'EMISSION',
  Featurette = 'FEATURETTE',
  FullLenght = 'FULL_LENGHT',
  Interview = 'INTERVIEW',
  MoviegoerReactions = 'MOVIEGOER_REACTIONS',
  ParodyMashup = 'PARODY_MASHUP',
  PremieresMinutesExclusif = 'PREMIERES_MINUTES_EXCLUSIF',
  SagaAllocine = 'SAGA_ALLOCINE',
  SoundtrackSample = 'SOUNDTRACK_SAMPLE',
  SpecialReport = 'SPECIAL_REPORT',
  TrailerStream = 'TRAILER_STREAM',
  VideoClip = 'VIDEO_CLIP',
  VideoCredits = 'VIDEO_CREDITS',
  VideoGameTrealer = 'VIDEO_GAME_TREALER'
}

export type Runtime = {
  hours: Scalars['Int']['output'];
  minutes: Scalars['Int']['output'];
  seconds: Scalars['Int']['output'];
};

export enum RestrictionType {
  NoPreRoll = 'NO_PRE_ROLL',
  NoPostRoll = 'NO_POST_ROLL'
}

export type VideoLinkableEntity = Movie | Series | SeriesSeason | SeriesEpisode | Person | Festival | FestivalEdition;

export type SeriesSeason = Node & Entity & Ref & Brandable & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** Other IDs from external source to represent the screen. */
  externalIDs: Array<ExternalId>;
  /** @deprecated use seoAttributes field now */
  seoData: Maybe<EntitySeoData>;
  activeOnBrands: Array<Brand>;
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The series of the season. */
  series: Series;
  /** The number of the season. */
  number: Scalars['Int']['output'];
  originalPremiere: Maybe<Scalars['PartialDate']['output']>;
  originalFinale: Maybe<Scalars['PartialDate']['output']>;
  /** The poster image of the season. */
  poster: Maybe<Image>;
  status: Maybe<SeriesStatus>;
  /** The season's episodes. */
  episodes: SeriesEpisodePager;
  /** The series season releases. */
  releases: EntityReleasePager;
  /** The companies of the season. */
  companies: EntityCompanyPager;
  /** A cast and credits import report of this entity: the latest one, running or not, or the one whose id is given; null when none was ever launched or the id is not one of this entity's reports. */
  personCreditsImport: Maybe<PersonCreditsImportReport>;
  /** The cast and credits import reports of this entity, newest first. */
  personCreditsImports: Array<PersonCreditsImportReport>;
  /** The credits of the season. */
  credits: PersonCreditsPager;
  /** All brand's fields for the season. */
  brandData: Maybe<SeriesSeasonBrandData>;
};


export type SeriesSeasonExternalIDsArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
};


export type SeriesSeasonSeoDataArgs = {
  brandId: Scalars['ID']['input'];
};


export type SeriesSeasonEpisodesArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  episodeNumbers?: InputMaybe<Array<Scalars['NonNegativeInt']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type SeriesSeasonReleasesArgs = {
  type?: InputMaybe<ReleaseType>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type SeriesSeasonCompaniesArgs = {
  activities?: InputMaybe<Array<CompanyActivity>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type SeriesSeasonPersonCreditsImportArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type SeriesSeasonPersonCreditsImportsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type SeriesSeasonCreditsArgs = {
  activities?: InputMaybe<Array<PersonActivity>>;
  excludeActivities?: InputMaybe<Array<PersonActivity>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type SeriesSeasonBrandDataArgs = {
  brandId: Scalars['ID']['input'];
};

export enum SeriesStatus {
  Cancelled = 'CANCELLED',
  Ended = 'ENDED',
  InProgress = 'IN_PROGRESS',
  Pilot = 'PILOT',
  ToCome = 'TO_COME'
}

/** A pager to a list of SeriesEpisode objects. */
export type SeriesEpisodePager = {
  /** The list of objects. */
  nodes: Array<SeriesEpisode>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type SeriesEpisode = Node & Entity & Ref & Brandable & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** Other IDs from external source to represent the screen. */
  externalIDs: Array<ExternalId>;
  activeOnBrands: Array<Brand>;
  /** The metadata of this entity. */
  metadata: Metadata;
  /** @deprecated use seoAttributes field now */
  seoData: Maybe<EntitySeoData>;
  /** The original premiere date of the episode. */
  originalPremiere: Maybe<Scalars['PartialDate']['output']>;
  /** The series of the episode. */
  series: Series;
  /** The season of the episode. */
  season: Maybe<SeriesSeason>;
  /** The title of the episode. */
  title: Maybe<Scalars['String']['output']>;
  /** The number of the episode in the season. */
  number: Scalars['Int']['output'];
  /** The series episode releases. */
  releases: EntityReleasePager;
  /** The companies of the episode. */
  companies: EntityCompanyPager;
  /** A cast and credits import report of this entity: the latest one, running or not, or the one whose id is given; null when none was ever launched or the id is not one of this entity's reports. */
  personCreditsImport: Maybe<PersonCreditsImportReport>;
  /** The cast and credits import reports of this entity, newest first. */
  personCreditsImports: Array<PersonCreditsImportReport>;
  /** The credits of the episode. */
  credits: PersonCreditsPager;
  /** All brand's fields for the episode. */
  brandData: Maybe<SeriesEpisodeBrandData>;
};


export type SeriesEpisodeExternalIDsArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
};


export type SeriesEpisodeSeoDataArgs = {
  brandId: Scalars['ID']['input'];
};


export type SeriesEpisodeReleasesArgs = {
  type?: InputMaybe<ReleaseType>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type SeriesEpisodeCompaniesArgs = {
  activities?: InputMaybe<Array<CompanyActivity>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type SeriesEpisodePersonCreditsImportArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type SeriesEpisodePersonCreditsImportsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type SeriesEpisodeCreditsArgs = {
  activities?: InputMaybe<Array<PersonActivity>>;
  excludeActivities?: InputMaybe<Array<PersonActivity>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type SeriesEpisodeBrandDataArgs = {
  brandId: Scalars['ID']['input'];
};

/** A pager to a list of EntityRelease objects. */
export type EntityReleasePager = {
  /** The list of objects. */
  nodes: Array<EntityRelease>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type EntityRelease = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  type: Maybe<ReleaseType>;
  /** The entity associated to this release */
  entity: ReleasableEntity;
  flags: Array<ReleaseFlag>;
  notReleasedYet: Scalars['Boolean']['output'];
  country: Country;
  releasedAt: Maybe<Scalars['PartialDate']['output']>;
  releasedAtTime: Maybe<Scalars['TimeWithoutTz']['output']>;
  unreleasedAt: Maybe<Scalars['Date']['output']>;
  limitedCompany: Maybe<Company>;
  limitedLocalization: Maybe<Localization>;
  certificate: Maybe<Certificate>;
  visaNumber: Maybe<Scalars['String']['output']>;
  distributors: Array<Company>;
  techInfo: Maybe<Scalars['String']['output']>;
  openingEstimate: Maybe<Scalars['Int']['output']>;
  advisory: Maybe<Scalars['String']['output']>;
  localCertificates: Array<EntityLocalRelease>;
};

/** The available release types. */
export enum ReleaseType {
  Online = 'ONLINE',
  OnlineAvod = 'ONLINE_AVOD',
  OnlineECinema = 'ONLINE_E_CINEMA',
  OnlineReplay = 'ONLINE_REPLAY',
  OnlineSvod = 'ONLINE_SVOD',
  OnlineVod = 'ONLINE_VOD',
  OnlineVodest = 'ONLINE_VODEST',
  Physical = 'PHYSICAL',
  PhysicalBluray = 'PHYSICAL_BLURAY',
  PhysicalDvd = 'PHYSICAL_DVD',
  Television = 'TELEVISION',
  Theater = 'THEATER'
}

/** An entity that can have releases */
export type ReleasableEntity = Movie | Series | SeriesSeason | SeriesEpisode;

export enum ReleaseFlag {
  Direct = 'DIRECT',
  LimitationPlatform = 'LIMITATION_PLATFORM',
  LimitationTheater = 'LIMITATION_THEATER',
  Preview = 'PREVIEW',
  Rerun = 'RERUN',
  Exclusive = 'EXCLUSIVE',
  Original = 'ORIGINAL'
}

export type Certificate = Node & Ref & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  rank: Scalars['NonNegativeInt']['output'];
  /** The label of the certificate. */
  label: Maybe<Scalars['String']['output']>;
  /** The code of the certificate. */
  code: Maybe<Scalars['String']['output']>;
  /** The scope of the certificate. */
  scope: Maybe<Scalars['String']['output']>;
  /** The country of the certificate. */
  country: Country;
  limitedLocalization: Maybe<Localization>;
};

export type EntityLocalRelease = {
  /** The localization of the localized certificate */
  localization: Localization;
  certificate: Certificate;
  /** The advise of the localized certificate */
  advisory: Maybe<Scalars['String']['output']>;
};

/** A pager to a list of EntityCompany objects. */
export type EntityCompanyPager = {
  /** The list of objects. */
  nodes: Array<EntityCompany>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type EntityCompany = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The company. */
  company: Company;
  /** The activity of the company. */
  activity: CompanyActivity;
  /** The rank of the company */
  rank: Scalars['NonNegativeInt']['output'];
};

/** One run of the cast and credits import of an entity: its status, how the title was resolved, the levels tried and, once completed, its people reconciled with the entity's credits. */
export type PersonCreditsImportReport = {
  id: Scalars['ID']['output'];
  status: ImportWizardReportStatus;
  failureReason: Maybe<Scalars['String']['output']>;
  launchedAt: Scalars['DateTime']['output'];
  finishedAt: Maybe<Scalars['DateTime']['output']>;
  /** The source that ran. */
  source: PersonCreditsImportSource;
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The entity this report imports the credits of; null when that entity was deleted since. */
  entity: Maybe<Entity>;
  /** The type of the entity this report imports the credits of, known even once it is deleted. */
  entityType: ImportWizardEntityType;
  /** Whether the editor removed this report from its entity's history; it stays for the statistics. */
  isRemovedFromHistory: Scalars['Boolean']['output'];
  /** Whether this report is still RUNNING past its 5-minute timeout, counted from its start, or from its launch if it never started: its timeout job did not run, or it never started. */
  isStale: Scalars['Boolean']['output'];
  /** How many credits the source returned, whatever their reconciliation status. */
  creditsCount: Scalars['Int']['output'];
  /** The lines of this report the history shows: the ones asked for at launch (every line the entity has for a report older than that), less the ones removed. */
  sections: Array<PersonCreditsImportDataType>;
  resolution: Maybe<PersonCreditsImportResolution>;
  /** The source's outcome for the credits once completed. */
  outcome: Maybe<ImportWizardOutcome>;
  /** The level that answered. */
  answeredBy: Maybe<ImportWizardLevel>;
  counts: PersonCreditsImportCounts;
  stats: PersonCreditsImportStats;
  /** The roles localization of this run; null when the launch carried no locale. */
  localization: Maybe<PersonCreditsImportLocalization>;
  entries: Array<PersonCreditsImportEntry>;
};

export enum ImportWizardReportStatus {
  /** The pipeline is running; the report is published when it ends. */
  Running = 'RUNNING',
  Completed = 'COMPLETED',
  /** A step of the pipeline failed for good; see failureReason. */
  Failed = 'FAILED'
}

/** The external source a cast and credits import reads. */
export enum PersonCreditsImportSource {
  Tmdb = 'TMDB',
  Omdb = 'OMDB',
  Image = 'IMAGE',
  Text = 'TEXT',
  Pdf = 'PDF',
  Wikipedia = 'WIKIPEDIA'
}

/** The entity types an import of cast and credits runs on. */
export enum ImportWizardEntityType {
  Movie = 'MOVIE',
  Series = 'SERIES',
  SeriesSeason = 'SERIES_SEASON',
  SeriesEpisode = 'SERIES_EPISODE'
}

/** The two lines a cast and credits import answers: the casting and the credits. */
export enum PersonCreditsImportDataType {
  /** The casting: the actors and their characters. */
  Cast = 'CAST',
  /** The credits: every other job. */
  Crew = 'CREW'
}

/** How the source resolved the entity to one of its titles: given, exact, likely, ambiguous or none. */
export type PersonCreditsImportResolution = {
  confidence: Scalars['String']['output'];
  /** The source's id of the resolved title. */
  sourceId: Maybe<Scalars['String']['output']>;
  /** given, or the route used: tmdb-find, tmdb-search, ... */
  source: Scalars['String']['output'];
  detail: Scalars['String']['output'];
  candidates: Array<PersonCreditsImportTitleCandidate>;
};

/** A title the source proposed when the entity could not be resolved with certainty. */
export type PersonCreditsImportTitleCandidate = {
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  year: Maybe<Scalars['Int']['output']>;
  kind: Maybe<Scalars['String']['output']>;
};

/** The credits outcome of a completed run: answered, or why the source answered nothing. */
export enum ImportWizardOutcome {
  Answered = 'ANSWERED',
  Empty = 'EMPTY',
  Blocked = 'BLOCKED',
  Error = 'ERROR',
  Unresolved = 'UNRESOLVED'
}

/** A level of the acquisition ladder: L1 the source's API, L2 its page, L3 a language model, L4 a browser. */
export enum ImportWizardLevel {
  L1Api = 'L1_API',
  L2Page = 'L2_PAGE',
  L3Llm = 'L3_LLM',
  L4Browser = 'L4_BROWSER'
}

export type PersonCreditsImportCounts = {
  linked: Scalars['Int']['output'];
  matched: Scalars['Int']['output'];
  ambiguous: Scalars['Int']['output'];
  unknown: Scalars['Int']['output'];
  extraneous: Scalars['Int']['output'];
};

/** What the pipeline measured on this run: levels tried, requests, bytes, durations and LLM cost. */
export type PersonCreditsImportStats = {
  durationMs: Scalars['Int']['output'];
  requests: Scalars['Int']['output'];
  bytesReceived: Scalars['Int']['output'];
  resolutionDurationMs: Scalars['Int']['output'];
  resolutionRequests: Scalars['Int']['output'];
  levels: Array<PersonCreditsImportLevel>;
  llm: Maybe<PersonCreditsImportLlmCall>;
};

/** One level of the acquisition ladder the pipeline ran, with its outcome and cost. */
export type PersonCreditsImportLevel = {
  /** 1 API, 2 page, 3 LLM, 4 browser */
  level: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** answered, empty, blocked, skipped or error */
  outcome: Scalars['String']['output'];
  durationMs: Scalars['Int']['output'];
  requests: Scalars['Int']['output'];
  bytesReceived: Scalars['Int']['output'];
  creditsCount: Scalars['Int']['output'];
  detail: Scalars['String']['output'];
  /** Level 3: what the LLM route would read, or read. */
  llmInputTokens: Maybe<Scalars['Int']['output']>;
  llm: Maybe<PersonCreditsImportLlmCall>;
};

export type PersonCreditsImportLlmCall = {
  provider: Scalars['String']['output'];
  model: Scalars['String']['output'];
  inputTokens: Scalars['Int']['output'];
  outputTokens: Scalars['Int']['output'];
  durationMs: Scalars['Int']['output'];
  costUsd: Maybe<Scalars['Float']['output']>;
  error: Maybe<Scalars['String']['output']>;
};

/** The characters of the casting proposed in the editor's locale by a language model. */
export type PersonCreditsImportLocalization = {
  /** The locale ref, e.g. fr_FR. */
  locale: Scalars['String']['output'];
  /** The locale's global id, what addCreditsToEntity takes back. */
  localeId: Scalars['ID']['output'];
  /** answered, empty, skipped or error; null while the run has not reached the step */
  outcome: Maybe<Scalars['String']['output']>;
  detail: Maybe<Scalars['String']['output']>;
  /** The duration of the step, every chunk included, in milliseconds. */
  durationMs: Maybe<Scalars['Int']['output']>;
  /** The actor characters sent to the language model. */
  rolesAsked: Maybe<Scalars['Int']['output']>;
  /** The characters the language model answered, null ones excluded. */
  rolesLocalized: Maybe<Scalars['Int']['output']>;
  llm: Maybe<PersonCreditsImportLlmCall>;
};

/** One person, either returned by the import or linked to the entity, with its reconciliation status. */
export type PersonCreditsImportEntry = {
  status: PersonCreditsImportStatus;
  /** The name as the source returned it. */
  name: Maybe<Scalars['String']['output']>;
  /** The source's category: actor, director, writer, producer, ... */
  category: Maybe<Scalars['String']['output']>;
  /** The gender the source gave, UNKNOWN when it had none; null for a credit the import did not return. */
  gender: Maybe<Gender>;
  /** The character or the job as the source returned it, a voice marker taken off (see isVoice). */
  role: Maybe<Scalars['String']['output']>;
  /** The source marked the character as a voice role, TMDB's `(voice)`: linked as the row's original voice. */
  isVoice: Scalars['Boolean']['output'];
  /** How the linked person sits on its credit (LINKED and EXTRANEOUS). */
  linkKind: Maybe<PersonCreditsImportLinkKind>;
  /** The locale of a local voice (linkKind LOCAL_VOICE). */
  linkLocale: Maybe<Scalars['String']['output']>;
  /** The DBZ person this entry is linked as: the credit's actor, original voice or local voice (LINKED and EXTRANEOUS). */
  linkedPerson: Maybe<Person>;
  /** The character in the report's locale, proposed by the language model; null when the step did not run or could not localize it */
  localizedRole: Maybe<Scalars['String']['output']>;
  /** The person's id at the source, when the source has one. */
  externalPersonId: Maybe<Scalars['String']['output']>;
  order: Maybe<Scalars['Int']['output']>;
  /** The persons carrying the same name (one when MATCHED, several when AMBIGUOUS). */
  candidates: Array<Person>;
  /** The entity's credit for this person (LINKED and EXTRANEOUS). */
  credit: Maybe<PersonCredits>;
  /** The activity a link of this entry gets by default, from the source's job, then its category, for the entity type; null when none applies. */
  suggestedActivity: Maybe<PersonActivity>;
};

export enum PersonCreditsImportStatus {
  /** Returned by the import, not linked, exactly one person carries the name: offer to link it. */
  Matched = 'MATCHED',
  /** Returned by the import, not linked, several persons carry the name: a human picks. */
  Ambiguous = 'AMBIGUOUS',
  /** Returned by the import, not linked, no person carries the name: offer to create then link. */
  Unknown = 'UNKNOWN',
  /** Returned by the import and already linked to the entity. */
  Linked = 'LINKED',
  /** Linked to the entity but not returned by the import: probably extraneous, a human decides. */
  Extraneous = 'EXTRANEOUS'
}

export enum Gender {
  Male = 'MALE',
  Female = 'FEMALE',
  Unknown = 'UNKNOWN'
}

/** How a linked person sits on its casting row. */
export enum PersonCreditsImportLinkKind {
  /** The row's actor, or a crew credit's person. */
  Actor = 'ACTOR',
  /** The row's original voice. */
  Voice = 'VOICE',
  /** One of the row's local voices, see linkLocale. */
  LocalVoice = 'LOCAL_VOICE'
}

export type Person = Node & Entity & Ref & Brandable & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** Other IDs from external source to represent the screen. */
  externalIDs: Array<ExternalId>;
  /** A search of images of this person, by id; null when it is not one of this person's. */
  imageImport: Maybe<PersonImageImportReport>;
  /** The searches of images of this person, newest first. */
  imageImports: Array<PersonImageImportReport>;
  /** The metadata of this entity. */
  metadata: Metadata;
  images: ImageReferencePager;
  activeOnBrands: Array<Brand>;
  /** @deprecated use seoAttributes field now */
  seoData: Maybe<EntitySeoData>;
  /** The person's firstname. */
  firstName: Maybe<Scalars['String']['output']>;
  /** The person's lastname */
  lastName: Maybe<Scalars['String']['output']>;
  /** The person's formal name. */
  formalName: Maybe<Scalars['String']['output']>;
  /** The person's gender. */
  gender: Maybe<Gender>;
  tags: EntityTagPager;
  /** The person's poster. */
  poster: Maybe<Image>;
  /** The person's birthDate. */
  birthDate: Maybe<Scalars['PartialDate']['output']>;
  /** The person's deathDate. */
  deathDate: Maybe<Scalars['PartialDate']['output']>;
  /** The person's keywords. */
  keywords: Array<Scalars['String']['output']>;
  /** The person's countries. */
  countries: Array<Country>;
  /** The person's filmography */
  filmography: FilmographyPager;
  /** The person's nicknames */
  nicknames: Array<PersonNickname>;
  /** All brand's fields for the person. */
  brandData: Maybe<PersonBrandData>;
  /** All brand's fields for the person. */
  brandsData: Maybe<Array<PersonBrandData>>;
  seoAttributes: Array<EntitySeoData>;
  /** The list of a person activities, from all entities */
  activities: Array<PersonActivity>;
};


export type PersonExternalIDsArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
};


export type PersonImageImportArgs = {
  id: Scalars['ID']['input'];
};


export type PersonImageImportsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonImagesArgs = {
  hasTTL?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonSeoDataArgs = {
  brandId: Scalars['ID']['input'];
};


export type PersonTagsArgs = {
  brandId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonFilmographyArgs = {
  entityTypes?: InputMaybe<Array<InputMaybe<FilmographyEntity>>>;
  activities?: InputMaybe<Array<PersonActivity>>;
  orderBy?: InputMaybe<FilmographyOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type PersonBrandDataArgs = {
  brandId: Scalars['ID']['input'];
};


export type PersonBrandsDataArgs = {
  brandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type PersonSeoAttributesArgs = {
  brandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** One search of an external source for the images of a person, kept with the candidates it proposed and what the editor added from them. */
export type PersonImageImportReport = {
  id: Scalars['ID']['output'];
  status: ImportWizardReportStatus;
  failureReason: Maybe<Scalars['String']['output']>;
  launchedAt: Scalars['DateTime']['output'];
  finishedAt: Maybe<Scalars['DateTime']['output']>;
  /** The source that was searched. */
  source: PersonImageSource;
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The person's id in the source, when one was found. */
  sourceId: Maybe<Scalars['String']['output']>;
  confidence: PersonImageConfidence;
  detail: Scalars['String']['output'];
  /** The most images the search was asked for. */
  limit: Scalars['Int']['output'];
  candidatesCount: Scalars['Int']['output'];
  /** The candidates added to the gallery since the search. */
  importedCount: Scalars['Int']['output'];
  candidates: Array<PersonImageCandidate>;
  /** What became of the candidates the editor tried to add, the last attempt of each. */
  outcomes: Array<PersonImageImportResult>;
};

/** The external source person images are read from. */
export enum PersonImageSource {
  Tmdb = 'TMDB',
  WikimediaCommons = 'WIKIMEDIA_COMMONS',
  Wikidata = 'WIKIDATA',
  Bestimage = 'BESTIMAGE'
}

/** How sure the source is about the person it found for the images. */
export enum PersonImageConfidence {
  /** The person's id in the source was recorded in DBZ. */
  Given = 'GIVEN',
  /** A single person matched the name and the birth year. */
  Exact = 'EXACT',
  /** A single person matched the name; nothing confirms it is the same. */
  Likely = 'LIKELY',
  /** Several persons matched; no image is proposed. */
  Ambiguous = 'AMBIGUOUS',
  /** No person found. */
  None = 'NONE'
}

/** An image an external source proposes for a person, not yet imported. */
export type PersonImageCandidate = {
  /** Stable within the source. */
  id: Scalars['String']['output'];
  source: PersonImageSource;
  /** Where the image is downloaded from on import. */
  url: Scalars['String']['output'];
  /** Where the preview is read from; a source that keeps its previews in the connector storage gets a signed url. */
  thumbnailUrl: Scalars['String']['output'];
  /** The resolutions the source delivers the image in; empty when it has a single one. */
  qualities: Array<PersonImageQuality>;
  width: Maybe<Scalars['Int']['output']>;
  height: Maybe<Scalars['Int']['output']>;
  /** The CMS image type guessed from the source; photo and still frame when nothing tells otherwise. */
  type: ImageType;
  /** The source's own category of the image, mapped to the CMS type by the connector. */
  category: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  /** The page of the source describing the image. */
  pageUrl: Maybe<Scalars['String']['output']>;
  credit: Maybe<Scalars['String']['output']>;
  license: Maybe<Scalars['String']['output']>;
};

/** The resolution a source is asked to deliver an image in, when it offers several. */
export enum PersonImageQuality {
  Medium = 'MEDIUM',
  High = 'HIGH'
}

export type PersonImageImportResult = {
  url: Scalars['String']['output'];
  status: PersonImageImportStatus;
  message: Maybe<Scalars['String']['output']>;
};

export enum PersonImageImportStatus {
  /** A new image was created and linked to the person. */
  Imported = 'IMPORTED',
  /** The image was already in the library; it is now linked to the person. */
  AlreadyExisted = 'ALREADY_EXISTED',
  /** The image could not be imported; see message. */
  Failed = 'FAILED',
  /** The image is being downloaded by a job; its outcome is recorded when it ends. */
  Pending = 'PENDING'
}

/** A pager to a list of Filmography objects. */
export type FilmographyPager = {
  /** The list of objects. */
  nodes: Array<Filmography>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type Filmography = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The entity related to the person (movie or series). */
  entity: FilmographyNode;
  /** The person's activity. Voice dubbing are nulls for the moment (no tag3d activity) */
  activity: Maybe<Scalars['String']['output']>;
  /** The person's role (either localized or original) */
  role: Maybe<Scalars['String']['output']>;
  productionDate: Maybe<Scalars['PartialDate']['output']>;
};

export type FilmographyNode = Movie | Series | SeriesSeason | SeriesEpisode;

export enum FilmographyEntity {
  Movie = 'MOVIE',
  Series = 'SERIES',
  SeriesSeason = 'SERIES_SEASON',
  SeriesEpisode = 'SERIES_EPISODE'
}

/** Possible person activities. */
export enum PersonActivity {
  DirectionDirector = 'DIRECTION_DIRECTOR',
  StorylineScreenwriter = 'STORYLINE_SCREENWRITER',
  StorylineCreator = 'STORYLINE_CREATOR',
  ProductionProducer = 'PRODUCTION_PRODUCER',
  ProductionExecutiveProducer = 'PRODUCTION_EXECUTIVE_PRODUCER',
  ProductionExecutiveCoProducer = 'PRODUCTION_EXECUTIVE_CO_PRODUCER',
  ProductionArtisticProducer = 'PRODUCTION_ARTISTIC_PRODUCER',
  DirectionShowrunner = 'DIRECTION_SHOWRUNNER',
  StorylineBasedOn = 'STORYLINE_BASED_ON',
  MusicMusicComposer = 'MUSIC_MUSIC_COMPOSER',
  CrewDirectorOfPhotography = 'CREW_DIRECTOR_OF_PHOTOGRAPHY',
  ActorActor = 'ACTOR_ACTOR',
  Crew_1StAssistantDirector = 'CREW_1ST_ASSISTANT_DIRECTOR',
  Crew_1StCameraAssistant = 'CREW_1ST_CAMERA_ASSISTANT',
  Crew_2DSpecialEffects = 'CREW_2D_SPECIAL_EFFECTS',
  Crew_2NdAssistantDirector = 'CREW_2ND_ASSISTANT_DIRECTOR',
  Crew_2NdCameraAssistant = 'CREW_2ND_CAMERA_ASSISTANT',
  Crew_2NdUnitDirector = 'CREW_2ND_UNIT_DIRECTOR',
  Crew_3DSupervisor = 'CREW_3D_SUPERVISOR',
  Crew_3RdAssistantDirector = 'CREW_3RD_ASSISTANT_DIRECTOR',
  CrewActingCoaching = 'CREW_ACTING_COACHING',
  CrewAirRecording = 'CREW_AIR_RECORDING',
  CrewAnimalHandler = 'CREW_ANIMAL_HANDLER',
  CrewAnimatic = 'CREW_ANIMATIC',
  CrewAnimationAndVisualEffectsSupervisor = 'CREW_ANIMATION_AND_VISUAL_EFFECTS_SUPERVISOR',
  CrewAnimator = 'CREW_ANIMATOR',
  CrewArtDirector = 'CREW_ART_DIRECTOR',
  CrewArtSupervisor = 'CREW_ART_SUPERVISOR',
  CrewArtisticConsultant = 'CREW_ARTISTIC_CONSULTANT',
  CrewAssistantCostumeDesigner = 'CREW_ASSISTANT_COSTUME_DESIGNER',
  CrewAssistantDirector = 'CREW_ASSISTANT_DIRECTOR',
  CrewAssistantEditor = 'CREW_ASSISTANT_EDITOR',
  CrewFightCoordinator = 'CREW_FIGHT_COORDINATOR',
  CrewAssistantFightChoreographer = 'CREW_ASSISTANT_FIGHT_CHOREOGRAPHER',
  CrewAssistantProductionCoOrdinator = 'CREW_ASSISTANT_PRODUCTION_CO_ORDINATOR',
  CrewAssistantSetDecorator = 'CREW_ASSISTANT_SET_DECORATOR',
  CrewAssistantSetDresser = 'CREW_ASSISTANT_SET_DRESSER',
  CrewAssistantStuntCoordinator = 'CREW_ASSISTANT_STUNT_COORDINATOR',
  CrewAssistantTechnicalAdvisor = 'CREW_ASSISTANT_TECHNICAL_ADVISOR',
  CrewAssistantToArtDirector = 'CREW_ASSISTANT_TO_ART_DIRECTOR',
  CrewAssistantUnitManager = 'CREW_ASSISTANT_UNIT_MANAGER',
  CrewAssociateEditor = 'CREW_ASSOCIATE_EDITOR',
  CrewBCamera = 'CREW_B_CAMERA',
  CrewBoomOperator = 'CREW_BOOM_OPERATOR',
  CrewCameraAssistant = 'CREW_CAMERA_ASSISTANT',
  CrewCameraOperator = 'CREW_CAMERA_OPERATOR',
  CrewCastingDirector = 'CREW_CASTING_DIRECTOR',
  CrewCastingDirectorChildren = 'CREW_CASTING_DIRECTOR_CHILDREN',
  CrewCastingProducer = 'CREW_CASTING_PRODUCER',
  CrewCgSupervisor = 'CREW_CG_SUPERVISOR',
  CrewCharacterAnimationSupervisor = 'CREW_CHARACTER_ANIMATION_SUPERVISOR',
  CrewCharacterEffects = 'CREW_CHARACTER_EFFECTS',
  CrewCharacterGraphicCreation = 'CREW_CHARACTER_GRAPHIC_CREATION',
  CrewCharacterPaintingSupervisor = 'CREW_CHARACTER_PAINTING_SUPERVISOR',
  CrewCharacterSpecialEffects = 'CREW_CHARACTER_SPECIAL_EFFECTS',
  CrewCharacterTechnicalDirector = 'CREW_CHARACTER_TECHNICAL_DIRECTOR',
  CrewChildrenSCoach = 'CREW_CHILDREN_S_COACH',
  CrewChoreographer = 'CREW_CHOREOGRAPHER',
  CrewColorist = 'CREW_COLORIST',
  CrewCompositingSupervisor = 'CREW_COMPOSITING_SUPERVISOR',
  CrewConceptArtist = 'CREW_CONCEPT_ARTIST',
  CrewConsultant = 'CREW_CONSULTANT',
  CrewCostumeDesigner = 'CREW_COSTUME_DESIGNER',
  CrewCostumeSupervisor = 'CREW_COSTUME_SUPERVISOR',
  CrewCrowd = 'CREW_CROWD',
  CrewDancer = 'CREW_DANCER',
  CrewDialogueEditor = 'CREW_DIALOGUE_EDITOR',
  CrewDialogueEditorSupervisor = 'CREW_DIALOGUE_EDITOR_SUPERVISOR',
  CrewDirectorOfPhotographyAssistant = 'CREW_DIRECTOR_OF_PHOTOGRAPHY_ASSISTANT',
  CrewDubbingAssistant = 'CREW_DUBBING_ASSISTANT',
  CrewEditor = 'CREW_EDITOR',
  CrewEditorInChief = 'CREW_EDITOR_IN_CHIEF',
  CrewElectricians = 'CREW_ELECTRICIANS',
  CrewExecutiveDirector = 'CREW_EXECUTIVE_DIRECTOR',
  CrewExtrasCasting = 'CREW_EXTRAS_CASTING',
  CrewFightChoreographer = 'CREW_FIGHT_CHOREOGRAPHER',
  CrewFilmPosterBy = 'CREW_FILM_POSTER_BY',
  CrewFoleyArtist = 'CREW_FOLEY_ARTIST',
  CrewFoleyEditor = 'CREW_FOLEY_EDITOR',
  CrewFoleyRecordist = 'CREW_FOLEY_RECORDIST',
  CrewGaffer = 'CREW_GAFFER',
  CrewGraphicDesigner = 'CREW_GRAPHIC_DESIGNER',
  CrewHair = 'CREW_HAIR',
  CrewHairdresserSupervisor = 'CREW_HAIRDRESSER_SUPERVISOR',
  CrewHeadCostumer = 'CREW_HEAD_COSTUMER',
  CrewIllustrator = 'CREW_ILLUSTRATOR',
  CrewIntertitles = 'CREW_INTERTITLES',
  CrewIntimacyCoordinator = 'CREW_INTIMACY_COORDINATOR',
  CrewKeyGrip = 'CREW_KEY_GRIP',
  CrewLayout = 'CREW_LAYOUT',
  CrewLayoutSupervisor = 'CREW_LAYOUT_SUPERVISOR',
  CrewLeadMan = 'CREW_LEAD_MAN',
  CrewLegalAdvisor = 'CREW_LEGAL_ADVISOR',
  CrewLighting = 'CREW_LIGHTING',
  CrewLightingDirector = 'CREW_LIGHTING_DIRECTOR',
  CrewLocationAssistantAssistant = 'CREW_LOCATION_ASSISTANT_ASSISTANT',
  CrewLocationManager = 'CREW_LOCATION_MANAGER',
  CrewLocationScout = 'CREW_LOCATION_SCOUT',
  CrewMakeUp = 'CREW_MAKE_UP',
  CrewMakeUpAssistant = 'CREW_MAKE_UP_ASSISTANT',
  CrewMakeUpSupervisor = 'CREW_MAKE_UP_SUPERVISOR',
  CrewMakeUpVisualEffects = 'CREW_MAKE_UP_VISUAL_EFFECTS',
  CrewMakingOfBy = 'CREW_MAKING_OF_BY',
  CrewMattePainter = 'CREW_MATTE_PAINTER',
  CrewModelMaker = 'CREW_MODEL_MAKER',
  CrewModelling = 'CREW_MODELLING',
  CrewPainter = 'CREW_PAINTER',
  CrewPhotographer = 'CREW_PHOTOGRAPHER',
  CrewPictureRestoration = 'CREW_PICTURE_RESTORATION',
  CrewPostProductionCoordinator = 'CREW_POST_PRODUCTION_COORDINATOR',
  CrewPostProductionProducer = 'CREW_POST_PRODUCTION_PRODUCER',
  CrewPostProductionSupervisor = 'CREW_POST_PRODUCTION_SUPERVISOR',
  CrewProduction = 'CREW_PRODUCTION',
  CrewProductionAdministrator = 'CREW_PRODUCTION_ADMINISTRATOR',
  CrewProductionAssistant = 'CREW_PRODUCTION_ASSISTANT',
  CrewProductionCoOrdinator = 'CREW_PRODUCTION_CO_ORDINATOR',
  CrewProductionCoordinator = 'CREW_PRODUCTION_COORDINATOR',
  CrewProductionCoordinatorDirector = 'CREW_PRODUCTION_COORDINATOR_DIRECTOR',
  CrewProductionDesigner = 'CREW_PRODUCTION_DESIGNER',
  CrewProductionDirector = 'CREW_PRODUCTION_DIRECTOR',
  CrewProductionManager = 'CREW_PRODUCTION_MANAGER',
  CrewProductionSecretary = 'CREW_PRODUCTION_SECRETARY',
  CrewProductionSupervisor = 'CREW_PRODUCTION_SUPERVISOR',
  CrewPropMaster = 'CREW_PROP_MASTER',
  CrewPropWrangler = 'CREW_PROP_WRANGLER',
  CrewPuppeteer = 'CREW_PUPPETEER',
  CrewResearch = 'CREW_RESEARCH',
  CrewScanningLaser3D = 'CREW_SCANNING_LASER3D',
  CrewScript = 'CREW_SCRIPT',
  CrewSecondUnitCinematographer = 'CREW_SECOND_UNIT_CINEMATOGRAPHER',
  CrewSecondUnitStuntCoordinator = 'CREW_SECOND_UNIT_STUNT_COORDINATOR',
  CrewSetDecorator = 'CREW_SET_DECORATOR',
  CrewSetInColor = 'CREW_SET_IN_COLOR',
  CrewSoundAssistant = 'CREW_SOUND_ASSISTANT',
  CrewSoundCreation = 'CREW_SOUND_CREATION',
  CrewSoundDesign = 'CREW_SOUND_DESIGN',
  CrewSoundDesigner = 'CREW_SOUND_DESIGNER',
  CrewSoundEditor = 'CREW_SOUND_EDITOR',
  CrewSoundEffectsEditor = 'CREW_SOUND_EFFECTS_EDITOR',
  CrewSoundEffectsEngineer = 'CREW_SOUND_EFFECTS_ENGINEER',
  CrewSoundEngineer = 'CREW_SOUND_ENGINEER',
  CrewSoundMixing = 'CREW_SOUND_MIXING',
  CrewSoundRestoration = 'CREW_SOUND_RESTORATION',
  CrewSpecialEffects = 'CREW_SPECIAL_EFFECTS',
  CrewSportsCoach = 'CREW_SPORTS_COACH',
  CrewStagehand = 'CREW_STAGEHAND',
  CrewStereographicAnimation = 'CREW_STEREOGRAPHIC_ANIMATION',
  CrewStereoscopicSupervisor = 'CREW_STEREOSCOPIC_SUPERVISOR',
  CrewStillsPhotographer = 'CREW_STILLS_PHOTOGRAPHER',
  CrewStory = 'CREW_STORY',
  CrewStoryboardArtist = 'CREW_STORYBOARD_ARTIST',
  CrewStuntCoordinator = 'CREW_STUNT_COORDINATOR',
  CrewStunts = 'CREW_STUNTS',
  CrewStuntsRigger = 'CREW_STUNTS_RIGGER',
  CrewStylist = 'CREW_STYLIST',
  CrewSubmarinePhotography = 'CREW_SUBMARINE_PHOTOGRAPHY',
  CrewSubtitles = 'CREW_SUBTITLES',
  CrewSupportAdditionalLocationAssistant = 'CREW_SUPPORT_ADDITIONAL_LOCATION_ASSISTANT',
  CrewTamer = 'CREW_TAMER',
  CrewTechnicalAdvisor = 'CREW_TECHNICAL_ADVISOR',
  CrewTechnicalDirector = 'CREW_TECHNICAL_DIRECTOR',
  CrewTechnicalSupervisor = 'CREW_TECHNICAL_SUPERVISOR',
  CrewTexturing = 'CREW_TEXTURING',
  CrewTitleSequenceDesigner = 'CREW_TITLE_SEQUENCE_DESIGNER',
  CrewUnitManager = 'CREW_UNIT_MANAGER',
  CrewVisualDevelopment = 'CREW_VISUAL_DEVELOPMENT',
  CrewVisualEffectsCinematographer = 'CREW_VISUAL_EFFECTS_CINEMATOGRAPHER',
  CrewVisualEffectsCoordinator = 'CREW_VISUAL_EFFECTS_COORDINATOR',
  CrewVisualEffectsDirector = 'CREW_VISUAL_EFFECTS_DIRECTOR',
  CrewVisualEffectsEditor = 'CREW_VISUAL_EFFECTS_EDITOR',
  CrewVisualEffectsSupervisor = 'CREW_VISUAL_EFFECTS_SUPERVISOR',
  CrewVoiceCoaching = 'CREW_VOICE_COACHING',
  CrewWardrobe = 'CREW_WARDROBE',
  CrewWeaponsMaster = 'CREW_WEAPONS_MASTER',
  CrewWildlifePhotography = 'CREW_WILDLIFE_PHOTOGRAPHY',
  DirectionCoDirector = 'DIRECTION_CO_DIRECTOR',
  DirectionCreatorShowrunner = 'DIRECTION_CREATOR_SHOWRUNNER',
  DirectionActionDirector = 'DIRECTION_ACTION_DIRECTOR',
  DistributionPressAgent = 'DISTRIBUTION_PRESS_AGENT',
  DistributionPublicRelations = 'DISTRIBUTION_PUBLIC_RELATIONS',
  DistributionSalesAgent = 'DISTRIBUTION_SALES_AGENT',
  MusicAdditionalMusic = 'MUSIC_ADDITIONAL_MUSIC',
  MusicAdditionalMusicComposer = 'MUSIC_ADDITIONAL_MUSIC_COMPOSER',
  MusicMusicComposerThemeSong = 'MUSIC_MUSIC_COMPOSER_THEME_SONG',
  MusicMusicCoordinator = 'MUSIC_MUSIC_COORDINATOR',
  MusicMusicEditor = 'MUSIC_MUSIC_EDITOR',
  MusicMusicMixing = 'MUSIC_MUSIC_MIXING',
  MusicMusicProducer = 'MUSIC_MUSIC_PRODUCER',
  MusicMusicalConsultant = 'MUSIC_MUSICAL_CONSULTANT',
  MusicMusicalSupervisor = 'MUSIC_MUSICAL_SUPERVISOR',
  MusicMusician = 'MUSIC_MUSICIAN',
  MusicOriginalCompositionBy = 'MUSIC_ORIGINAL_COMPOSITION_BY',
  MusicSinger = 'MUSIC_SINGER',
  MusicSingerSongsFromTheFilmFrenchVersion = 'MUSIC_SINGER_SONGS_FROM_THE_FILM_FRENCH_VERSION',
  MusicThemeSongPerformer = 'MUSIC_THEME_SONG_PERFORMER',
  MusicTitleSoundtrack = 'MUSIC_TITLE_SOUNDTRACK',
  MusicYelmo = 'MUSIC_YELMO',
  OthersAdjunctExecutiveDirector = 'OTHERS_ADJUNCT_EXECUTIVE_DIRECTOR',
  OthersBusinessman = 'OTHERS_BUSINESSMAN',
  OthersDirectorOfCommunications = 'OTHERS_DIRECTOR_OF_COMMUNICATIONS',
  OthersExplorer = 'OTHERS_EXPLORER',
  OthersJournalist = 'OTHERS_JOURNALIST',
  OthersLawyer = 'OTHERS_LAWYER',
  OthersPoet = 'OTHERS_POET',
  OthersPolitician = 'OTHERS_POLITICIAN',
  OthersPresenter = 'OTHERS_PRESENTER',
  OthersPsychiatrist = 'OTHERS_PSYCHIATRIST',
  OthersScientist = 'OTHERS_SCIENTIST',
  OthersSportsman = 'OTHERS_SPORTSMAN',
  OthersTvProducer = 'OTHERS_TV_PRODUCER',
  OthersUnknown = 'OTHERS_UNKNOWN',
  ProductionAssociateProducer = 'PRODUCTION_ASSOCIATE_PRODUCER',
  ProductionCoProducer = 'PRODUCTION_CO_PRODUCER',
  ProductionGeneralRepresentative = 'PRODUCTION_GENERAL_REPRESENTATIVE',
  ProductionLineProducer = 'PRODUCTION_LINE_PRODUCER',
  StorylineAdaptedBy = 'STORYLINE_ADAPTED_BY',
  StorylineAuthor = 'STORYLINE_AUTHOR',
  StorylineCoScreenwriter = 'STORYLINE_CO_SCREENWRITER',
  StorylineCollaborationToTheScenario = 'STORYLINE_COLLABORATION_TO_THE_SCENARIO',
  StorylineDialogueCoach = 'STORYLINE_DIALOGUE_COACH',
  StorylineDialogueWriter = 'STORYLINE_DIALOGUE_WRITER',
  StorylineGagman = 'STORYLINE_GAGMAN',
  StorylineOriginalCharactersBy = 'STORYLINE_ORIGINAL_CHARACTERS_BY',
  StorylineOriginalIdea = 'STORYLINE_ORIGINAL_IDEA',
  StorylineOriginalScriptBy = 'STORYLINE_ORIGINAL_SCRIPT_BY',
  StorylineStoryEditor = 'STORYLINE_STORY_EDITOR',
  StorylineWritingDirector = 'STORYLINE_WRITING_DIRECTOR',
  CompaniesDigitalEffects = 'COMPANIES_DIGITAL_EFFECTS',
  CompaniesDistribution = 'COMPANIES_DISTRIBUTION',
  CompaniesForeignDistributor = 'COMPANIES_FOREIGN_DISTRIBUTOR',
  CompaniesFrenchDistributor = 'COMPANIES_FRENCH_DISTRIBUTOR',
  CompaniesInternationalDistributionExports = 'COMPANIES_INTERNATIONAL_DISTRIBUTION_EXPORTS'
}

export type FilmographyOrder = {
  /** The field to order by. */
  field: FilmographyOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum FilmographyOrderField {
  ProductionDate = 'PRODUCTION_DATE'
}

export type PersonNickname = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  nickname: Scalars['String']['output'];
  gender: Gender;
};

export type PersonBrandData = {
  /** The person's biography. */
  biography: Maybe<Scalars['RichText']['output']>;
  /** The person's short biography. */
  biographyShort: Maybe<Scalars['String']['output']>;
  /** The poster of the person. */
  poster: Maybe<Image>;
  birthPlace: Maybe<Scalars['String']['output']>;
  deathPlace: Maybe<Scalars['String']['output']>;
  deathCause: Maybe<Scalars['String']['output']>;
  brand: Brand;
};

export type PersonCredits = Element & {
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** The person. */
  person: Maybe<Person>;
  /** The department to which the person belongs. */
  department: PersonDepartment;
  /** The activity of the person. */
  activity: PersonActivity;
  /** The rank of the person within the department */
  rank: Scalars['NonNegativeInt']['output'];
  /** The person's role. */
  role: Maybe<Scalars['String']['output']>;
  /** Original voice for this role. */
  voice: Maybe<Person>;
  /** Localized data for this role. */
  localeData: EntityHasPersonLocalizedPager;
};


export type PersonCreditsLocaleDataArgs = {
  locale?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type Element = {
  /** Indicates if the element is active or not */
  active: Scalars['Boolean']['output'];
};

/** Possible person departments. */
export enum PersonDepartment {
  Actor = 'ACTOR',
  Companies = 'COMPANIES',
  Crew = 'CREW',
  Direction = 'DIRECTION',
  Distribution = 'DISTRIBUTION',
  Music = 'MUSIC',
  Others = 'OTHERS',
  Production = 'PRODUCTION',
  Storyline = 'STORYLINE',
  Unknown = 'UNKNOWN'
}

/** A pager to a list of EntityHasPersonLocalized objects. */
export type EntityHasPersonLocalizedPager = {
  /** The list of objects. */
  nodes: Array<EntityHasPersonLocalized>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type EntityHasPersonLocalized = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** Local voice for this role. */
  voice: Maybe<Person>;
  /** A localized role. */
  role: Maybe<Scalars['String']['output']>;
  /** The locale associated. */
  locale: Locale;
};

/** A pager to a list of PersonCredits objects. */
export type PersonCreditsPager = {
  /** The list of objects. */
  nodes: Array<PersonCredits>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type SeriesEpisodeBrandData = {
  /** The episode's title. */
  title: Maybe<Scalars['String']['output']>;
  /** The episode's synopsis. */
  synopsis: Maybe<Scalars['RichText']['output']>;
  ruling: EntityBrandDataRuling;
};

export type EntityBrandDataRuling = {
  hasRating: Scalars['Boolean']['output'];
  atRisk: Scalars['Boolean']['output'];
  hasWarningMessage: Scalars['Boolean']['output'];
  hasMandatoryReview: Scalars['Boolean']['output'];
};

export type SeriesSeasonBrandData = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The season's synopsis. */
  synopsis: Maybe<Scalars['RichText']['output']>;
  /** The poster of the season. */
  poster: Maybe<Image>;
  ruling: EntityBrandDataRuling;
};

/** A festival. */
export type Festival = Node & Entity & Ref & Brandable & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** Other IDs from external source to represent the screen. */
  externalIDs: Array<ExternalId>;
  /** The metadata of this entity. */
  metadata: Metadata;
  latestFestivalEdition: Maybe<FestivalEdition>;
  images: ImageReferencePager;
  /** The trivias associated with the entity. */
  trivias: EntityTriviaPager;
  /** @deprecated use seoAttributes field now */
  seoData: Maybe<EntitySeoData>;
  tags: EntityTagPager;
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  activeOnBrands: Array<Brand>;
  entityLinks: Array<EntityLink>;
  /** The name of the festival. */
  name: Scalars['String']['output'];
  /** The type of the festival. */
  type: Maybe<FestivalType>;
  /** The theme of the festival. */
  theme: Maybe<FestivalTheme>;
  /** The country of the festival. */
  country: Country;
  /** The localization city of the festival. */
  localization: Maybe<Localization>;
  /** The localized data related to the festival. */
  localizedData: Maybe<FestivalLocalized>;
  /** The poster image of the festival */
  poster: Maybe<Image>;
  /** The keywords of the festival. */
  keywords: Maybe<Array<Scalars['String']['output']>>;
};


/** A festival. */
export type FestivalExternalIDsArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
};


/** A festival. */
export type FestivalImagesArgs = {
  hasTTL?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** A festival. */
export type FestivalTriviasArgs = {
  brandId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** A festival. */
export type FestivalSeoDataArgs = {
  brandId: Scalars['ID']['input'];
};


/** A festival. */
export type FestivalTagsArgs = {
  brandId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** A festival. */
export type FestivalEntityLinksArgs = {
  linkType?: InputMaybe<Array<EntityLinkType>>;
};


/** A festival. */
export type FestivalLocalizedDataArgs = {
  locale: Scalars['ID']['input'];
};

/** A festival edition */
export type FestivalEdition = Node & Entity & Ref & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** @deprecated use seoAttributes field now */
  seoData: Maybe<EntitySeoData>;
  /** Other IDs from external source to represent the screen. */
  externalIDs: Array<ExternalId>;
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The name of the festival */
  name: Maybe<Scalars['String']['output']>;
  /** The edition number of the festival */
  editionNumber: Maybe<Scalars['Int']['output']>;
  /** The year of the festival edition */
  year: Scalars['Int']['output'];
  /** The start date of the festival edition */
  startsAt: Maybe<Scalars['PartialDate']['output']>;
  /** The end date of the festival edition */
  endsAt: Maybe<Scalars['PartialDate']['output']>;
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** The poster image of the festival edition. */
  poster: Maybe<Image>;
  /** The related festival. */
  festival: Festival;
  /** The localized data related to the festival. */
  localizedData: Maybe<FestivalEditionLocalized>;
};


/** A festival edition */
export type FestivalEditionSeoDataArgs = {
  brandId: Scalars['ID']['input'];
};


/** A festival edition */
export type FestivalEditionExternalIDsArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
};


/** A festival edition */
export type FestivalEditionLocalizedDataArgs = {
  locale: Scalars['ID']['input'];
};

export type FestivalEditionLocalized = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The localized festival edition name. */
  name: Maybe<Scalars['String']['output']>;
};

export enum FestivalType {
  CyclesNuit = 'CYCLES_NUIT',
  Exposition = 'EXPOSITION',
  FestivalInternational = 'FESTIVAL_INTERNATIONAL',
  FestivalItinerant = 'FESTIVAL_ITINERANT',
  FestivalNational = 'FESTIVAL_NATIONAL',
  Prix = 'PRIX',
  Rencontres = 'RENCONTRES',
  Retrospective = 'RETROSPECTIVE'
}

export enum FestivalTheme {
  FestivalCinemaTelevision = 'FESTIVAL_CINEMA_TELEVISION',
  FestivalCourtMetrage = 'FESTIVAL_COURT_METRAGE',
  FestivalLongEtCourtMetrage = 'FESTIVAL_LONG_ET_COURT_METRAGE',
  FestivalLongMetrage = 'FESTIVAL_LONG_METRAGE',
  FestivalTelevision = 'FESTIVAL_TELEVISION',
  Webtv = 'WEBTV'
}

export type FestivalLocalized = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The localized festival name */
  name: Maybe<Scalars['String']['output']>;
  /** The localized festival description */
  synopsis: Maybe<Scalars['RichText']['output']>;
};

export type RankRelatedEntity = {
  rank: Scalars['NonNegativeInt']['output'];
  entity: VideoLinkableEntity;
};

export type VideoFile = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  quality: VideoQuality;
  formats: Array<VideoFormats>;
  path: Maybe<Scalars['String']['output']>;
  cdnUrl: Maybe<Scalars['String']['output']>;
  width: Maybe<Scalars['Int']['output']>;
  height: Maybe<Scalars['Int']['output']>;
  size: Maybe<Scalars['Int']['output']>;
  data: Maybe<Scalars['JSONObject']['output']>;
};

export enum VideoQuality {
  Thumb = 'THUMB',
  Sprite = 'SPRITE',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Standard = 'STANDARD',
  High = 'HIGH',
  FullHigh = 'FULL_HIGH',
  QuadHigh = 'QUAD_HIGH',
  UltraHigh = 'ULTRA_HIGH'
}

export enum VideoFormats {
  Mpeg = 'MPEG',
  AviXVid = 'AVI_X_VID',
  FlvH_264 = 'FLV_H_264',
  FlvLetter = 'FLV_LETTER',
  M4V = 'M4V',
  Mp4Archive = 'MP4_ARCHIVE',
  Mp4Hip = 'MP4_HIP',
  Mp4HipRaw = 'MP4_HIP_RAW',
  Mp4Lc = 'MP4_LC',
  Mp4LcRaw = 'MP4_LC_RAW'
}

export type VideoAltType = {
  dailymotion: Maybe<Array<Scalars['String']['output']>>;
  youtube: Maybe<Array<VideoYoutubeType>>;
  videoEncoder: Maybe<Array<VideoEncoderType>>;
};

export type VideoYoutubeType = {
  id: Scalars['String']['output'];
  channelId: Scalars['String']['output'];
  channelLabel: Maybe<Scalars['String']['output']>;
};

export type VideoEncoderType = {
  /** Video encoder API job id, null until the video encoding job submitted the source file */
  id: Maybe<Scalars['String']['output']>;
  platform: VideoPlatformEnum;
  channelId: Maybe<Scalars['String']['output']>;
  /** An existing YouTube video set by its id: it has no encoder job */
  isLinked: Scalars['Boolean']['output'];
  /** Encoded files registered for this entry so far (Dailymotion), updated while the encoder writes them; null before the first one */
  fileCount: Maybe<Scalars['Int']['output']>;
  /** The uploaded source file is stored, so this platform can be encoded again from it; never while its cancel failed or runs on the video encoder (its job may still run) */
  canRetry: Scalars['Boolean']['output'];
  status: VideoEncoderStatusEnum;
  statusText: Maybe<Scalars['String']['output']>;
  /** Why the video encoder could not cancel this CANCEL entry's job (it may still run): cancelling again retries it */
  cancelError: Maybe<Scalars['String']['output']>;
  /** The video encoder is cancelling this CANCEL entry's job right now: its outcome is not known yet */
  isCancelPending: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum VideoPlatformEnum {
  Dailymotion = 'DAILYMOTION',
  Youtube = 'YOUTUBE'
}

export enum VideoEncoderStatusEnum {
  Pending = 'PENDING',
  Cancel = 'CANCEL',
  InProgress = 'IN_PROGRESS',
  Error = 'ERROR',
  Done = 'DONE'
}

export type VideoValidityType = {
  validity_from: Maybe<Scalars['DateTime']['output']>;
  validity_to: Maybe<Scalars['DateTime']['output']>;
};

export enum VideoUniverse {
  Global = 'GLOBAL',
  GenericTvActu = 'GENERIC_TV_ACTU'
}

export type YoutubeChannel = {
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type NewsLinkableEntity = Festival | FestivalEdition | Movie | News | Person | SeriesEpisode | SeriesSeason | Series;

export enum NewsLinkableEntityType {
  Movie = 'MOVIE',
  News = 'NEWS',
  Person = 'PERSON',
  Series = 'SERIES',
  SeriesSeason = 'SERIES_SEASON',
  SeriesEpisode = 'SERIES_EPISODE',
  Festival = 'FESTIVAL',
  FestivalEdition = 'FESTIVAL_EDITION'
}

export type Slide = Node & Entity & Ref & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** Other IDs from external source to represent the screen. */
  externalIDs: Array<ExternalId>;
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** The title of the slide. */
  title: Scalars['String']['output'];
  /** The description of the slide. */
  description: Scalars['String']['output'];
  /** The poster of the slide. */
  poster: Maybe<Image>;
  parents: Array<CarouselHasSlide>;
  link: Link;
};


export type SlideExternalIDsArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
};

export type CarouselHasSlide = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  carousel: Carousel;
  slide: Slide;
  rank: Scalars['NonNegativeInt']['output'];
};

export type Carousel = Node & Ref & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The associated brand. */
  brand: Brand;
  /** The metadata of this entity. */
  metadata: Metadata;
  startsAt: Scalars['DateTimeWithoutTz']['output'];
  target: Scalars['Tag3D']['output'];
  slides: Array<CarouselHasSlide>;
};

export type Link = {
  url: Scalars['URL']['output'];
  blank: Scalars['Boolean']['output'];
};

export type Theater = Node & Establishment & Entity & Ref & Brandable & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** Other IDs from external source to represent the screen. */
  externalIDs: Array<ExternalId>;
  images: ImageReferencePager;
  activeOnBrands: Array<Brand>;
  /** @deprecated use seoAttributes field now */
  seoData: Maybe<EntitySeoData>;
  /** The name of the establishment. */
  name: Scalars['String']['output'];
  /** The parent establishment. */
  parent: Maybe<Company>;
  /** The establishment's logo. */
  logo: Maybe<Image>;
  /** The date when the establishment was created. */
  foundedAt: Maybe<Scalars['Date']['output']>;
  /** The establishment's links. */
  links: SocialLinks;
  /** The url to download the android application of the establishment. */
  androidUrl: Maybe<Scalars['URL']['output']>;
  /** The url to download the ios application of the establishment. */
  iosUrl: Maybe<Scalars['URL']['output']>;
  /** Whether the establishment is closed or not. */
  closed: Scalars['Boolean']['output'];
  /** The establishment's email. */
  email: Maybe<Scalars['EmailAddress']['output']>;
  /** The establishment's phone number. */
  phone: Maybe<Scalars['String']['output']>;
  /** The establishment's website URL. */
  websiteUrl: Maybe<Scalars['URL']['output']>;
  /** Some info relative to the location of the establishment. */
  location: Maybe<Address>;
  /** The establishment's coordinates. */
  coordinates: Maybe<Coordinates>;
  /** The establishment's localization. */
  localization: Maybe<Localization>;
  /** The establishment's additional notes. */
  note: Maybe<Scalars['String']['output']>;
  /** The establishment's description. */
  description: Maybe<Scalars['String']['output']>;
  /** The metadata of this entity. */
  metadata: Metadata;
  code: Scalars['ID']['output'];
  timezone: Maybe<Scalars['String']['output']>;
  /** The number of seat in the theater. */
  seats: Maybe<Scalars['Int']['output']>;
  /** The theater's screen. */
  screens: ScreenPager;
  /** The theater's fares. */
  fares: FarePager;
  /** All localized fields for the theater. */
  localeData: Maybe<TheaterLocaleData>;
  /** The country of the theater. */
  country: Country;
  /** The theater's market. */
  market: Maybe<Scalars['String']['output']>;
  /** Represents which companies this theater is affiliated to. */
  affiliatedTo: Array<Company>;
  /** Represents which trade group this theater belongs to. */
  tradeGroup: Array<Company>;
  /** Represents which company provides this theater point of sale. */
  pointOfSale: Array<Company>;
  /** The theater's types of programmation. */
  scheduledTypology: Array<TheaterTypology>;
  temporaryClosure: Maybe<TheaterTemporaryClosure>;
  nextOpening: Maybe<TheaterNextOpening>;
  showtimeSource: Maybe<TheaterShowtimeSource>;
  /** The theater's display name in B2B applications */
  displayName: Maybe<Scalars['String']['output']>;
  /** The theater's showtimes url. */
  showtimesUrl: Maybe<Scalars['URL']['output']>;
  /** The theater's alternate showtimes url. */
  showtimesAlternateUrl: Maybe<Scalars['URL']['output']>;
  /** The theater's movie line. */
  movieLine: Maybe<Scalars['String']['output']>;
  flags: TheaterFlags;
  ticketing: TheaterTicketing;
  openingStatus: TheaterOpeningStatus;
  showtimesGatheringMethod: Maybe<TheaterShowtimesGatheringMethod>;
  showtimesGatheringMethodCode: Maybe<Scalars['String']['output']>;
  showtimesGatheringMethodPriority: Maybe<Scalars['String']['output']>;
  /** Whether the theater has automatically imported showtimes or is configured to do so */
  wouldImportShowtimes: Scalars['Boolean']['output'];
};


export type TheaterExternalIDsArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
};


export type TheaterImagesArgs = {
  hasTTL?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type TheaterSeoDataArgs = {
  brandId: Scalars['ID']['input'];
};


export type TheaterScreensArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type TheaterFaresArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type TheaterLocaleDataArgs = {
  locale: Scalars['ID']['input'];
};

/** A pager to a list of Screen objects. */
export type ScreenPager = {
  /** The list of objects. */
  nodes: Array<Screen>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type Screen = Node & Entity & Ref & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** Other IDs from external source to represent the screen. */
  externalIDs: Array<ExternalId>;
  /** The name of the screen. */
  name: Scalars['String']['output'];
  number: Maybe<Scalars['Int']['output']>;
  size: Maybe<ScreenSize>;
  description: Maybe<Scalars['String']['output']>;
  seats: Maybe<Scalars['Int']['output']>;
  theater: Theater;
  images: ImageReferencePager;
  flags: ScreenFlags;
};


export type ScreenExternalIDsArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
};


export type ScreenImagesArgs = {
  hasTTL?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ScreenSize = {
  width: Maybe<Scalars['Float']['output']>;
  unit: Maybe<ScreenSizeUnit>;
};

export enum ScreenSizeUnit {
  Meter = 'METER',
  Foot = 'FOOT'
}

export type ScreenFlags = {
  accessibility: Array<Scalars['Tag3D']['output']>;
  comfort: Array<Scalars['Tag3D']['output']>;
  experience: Array<Scalars['Tag3D']['output']>;
  food: Array<Scalars['Tag3D']['output']>;
  picture: Array<Scalars['Tag3D']['output']>;
  projection: Array<Scalars['Tag3D']['output']>;
  restriction: Array<Scalars['Tag3D']['output']>;
  service: Array<Scalars['Tag3D']['output']>;
  sound: Array<Scalars['Tag3D']['output']>;
};

/** A pager to a list of Fare objects. */
export type FarePager = {
  /** The list of objects. */
  nodes: Array<Fare>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type Fare = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** Name of Fare */
  name: Scalars['String']['output'];
  comment: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  currency: Currency;
  screens: Array<Screen>;
  theater: Theater;
  rank: Scalars['NonNegativeInt']['output'];
};

/** An ISO-4217 currency code. */
export enum Currency {
  /** US Dollar */
  Usd = 'USD',
  /** Euro */
  Eur = 'EUR',
  /** UAE Dirham */
  Aed = 'AED',
  /** Afghani */
  Afn = 'AFN',
  /** Lek */
  All = 'ALL',
  /** Armenian Dram */
  Amd = 'AMD',
  /** Netherlands Antillean Guilder */
  Ang = 'ANG',
  /** Kwanza */
  Aoa = 'AOA',
  /** Argentine Peso */
  Ars = 'ARS',
  /** Australian Dollar */
  Aud = 'AUD',
  /** Aruban Florin */
  Awg = 'AWG',
  /** Azerbaijan Manat */
  Azn = 'AZN',
  /** Convertible Mark */
  Bam = 'BAM',
  /** Barbados Dollar */
  Bbd = 'BBD',
  /** Taka */
  Bdt = 'BDT',
  /** Bulgarian Lev */
  Bgn = 'BGN',
  /** Bahraini Dinar */
  Bhd = 'BHD',
  /** Burundi Franc */
  Bif = 'BIF',
  /** Bermudian Dollar */
  Bmd = 'BMD',
  /** Brunei Dollar */
  Bnd = 'BND',
  /** Boliviano */
  Bob = 'BOB',
  /** Mvdol */
  Bov = 'BOV',
  /** Brazilian Real */
  Brl = 'BRL',
  /** Bahamian Dollar */
  Bsd = 'BSD',
  /** Ngultrum */
  Btn = 'BTN',
  /** Pula */
  Bwp = 'BWP',
  /** Belarusian Ruble */
  Byn = 'BYN',
  /** Belize Dollar */
  Bzd = 'BZD',
  /** Canadian Dollar */
  Cad = 'CAD',
  /** Congolese Franc */
  Cdf = 'CDF',
  /** WIR Euro */
  Che = 'CHE',
  /** Swiss Franc */
  Chf = 'CHF',
  /** WIR Franc */
  Chw = 'CHW',
  /** Unidad de Fomento */
  Clf = 'CLF',
  /** Chilean Peso */
  Clp = 'CLP',
  /** Yuan Renminbi */
  Cny = 'CNY',
  /** Colombian Peso */
  Cop = 'COP',
  /** Unidad de Valor Real */
  Cou = 'COU',
  /** Costa Rican Colon */
  Crc = 'CRC',
  /** Peso Convertible */
  Cuc = 'CUC',
  /** Cuban Peso */
  Cup = 'CUP',
  /** Cabo Verde Escudo */
  Cve = 'CVE',
  /** Czech Koruna */
  Czk = 'CZK',
  /** Djibouti Franc */
  Djf = 'DJF',
  /** Danish Krone */
  Dkk = 'DKK',
  /** Dominican Peso */
  Dop = 'DOP',
  /** Algerian Dinar */
  Dzd = 'DZD',
  /** Egyptian Pound */
  Egp = 'EGP',
  /** Nakfa */
  Ern = 'ERN',
  /** Ethiopian Birr */
  Etb = 'ETB',
  /** Fiji Dollar */
  Fjd = 'FJD',
  /** Falkland Islands Pound */
  Fkp = 'FKP',
  /** Pound Sterling */
  Gbp = 'GBP',
  /** Lari */
  Gel = 'GEL',
  /** Ghana Cedi */
  Ghs = 'GHS',
  /** Gibraltar Pound */
  Gip = 'GIP',
  /** Dalasi */
  Gmd = 'GMD',
  /** Guinean Franc */
  Gnf = 'GNF',
  /** Quetzal */
  Gtq = 'GTQ',
  /** Guyana Dollar */
  Gyd = 'GYD',
  /** Hong Kong Dollar */
  Hkd = 'HKD',
  /** Lempira */
  Hnl = 'HNL',
  /** Kuna */
  Hrk = 'HRK',
  /** Gourde */
  Htg = 'HTG',
  /** Forint */
  Huf = 'HUF',
  /** Rupiah */
  Idr = 'IDR',
  /** New Israeli Sheqel */
  Ils = 'ILS',
  /** Indian Rupee */
  Inr = 'INR',
  /** Iraqi Dinar */
  Iqd = 'IQD',
  /** Iranian Rial */
  Irr = 'IRR',
  /** Iceland Krona */
  Isk = 'ISK',
  /** Jamaican Dollar */
  Jmd = 'JMD',
  /** Jordanian Dinar */
  Jod = 'JOD',
  /** Yen */
  Jpy = 'JPY',
  /** Kenyan Shilling */
  Kes = 'KES',
  /** Som */
  Kgs = 'KGS',
  /** Riel */
  Khr = 'KHR',
  /** Comorian Franc */
  Kmf = 'KMF',
  /** North Korean Won */
  Kpw = 'KPW',
  /** Won */
  Krw = 'KRW',
  /** Kuwaiti Dinar */
  Kwd = 'KWD',
  /** Cayman Islands Dollar */
  Kyd = 'KYD',
  /** Tenge */
  Kzt = 'KZT',
  /** Lao Kip */
  Lak = 'LAK',
  /** Lebanese Pound */
  Lbp = 'LBP',
  /** Sri Lanka Rupee */
  Lkr = 'LKR',
  /** Liberian Dollar */
  Lrd = 'LRD',
  /** Loti */
  Lsl = 'LSL',
  /** Libyan Dinar */
  Lyd = 'LYD',
  /** Moroccan Dirham */
  Mad = 'MAD',
  /** Moldovan Leu */
  Mdl = 'MDL',
  /** Malagasy Ariary */
  Mga = 'MGA',
  /** Denar */
  Mkd = 'MKD',
  /** Kyat */
  Mmk = 'MMK',
  /** Tugrik */
  Mnt = 'MNT',
  /** Pataca */
  Mop = 'MOP',
  /** Ouguiya */
  Mru = 'MRU',
  /** Mauritius Rupee */
  Mur = 'MUR',
  /** Rufiyaa */
  Mvr = 'MVR',
  /** Malawi Kwacha */
  Mwk = 'MWK',
  /** Mexican Peso */
  Mxn = 'MXN',
  /** Mexican Unidad de Inversion (UDI) */
  Mxv = 'MXV',
  /** Malaysian Ringgit */
  Myr = 'MYR',
  /** Mozambique Metical */
  Mzn = 'MZN',
  /** Namibia Dollar */
  Nad = 'NAD',
  /** Naira */
  Ngn = 'NGN',
  /** Cordoba Oro */
  Nio = 'NIO',
  /** Norwegian Krone */
  Nok = 'NOK',
  /** Nepalese Rupee */
  Npr = 'NPR',
  /** New Zealand Dollar */
  Nzd = 'NZD',
  /** Rial Omani */
  Omr = 'OMR',
  /** Balboa */
  Pab = 'PAB',
  /** Sol */
  Pen = 'PEN',
  /** Kina */
  Pgk = 'PGK',
  /** Philippine Piso */
  Php = 'PHP',
  /** Pakistan Rupee */
  Pkr = 'PKR',
  /** Zloty */
  Pln = 'PLN',
  /** Guarani */
  Pyg = 'PYG',
  /** Qatari Rial */
  Qar = 'QAR',
  /** Romanian Leu */
  Ron = 'RON',
  /** Serbian Dinar */
  Rsd = 'RSD',
  /** Russian Ruble */
  Rub = 'RUB',
  /** Rwanda Franc */
  Rwf = 'RWF',
  /** Saudi Riyal */
  Sar = 'SAR',
  /** Solomon Islands Dollar */
  Sbd = 'SBD',
  /** Seychelles Rupee */
  Scr = 'SCR',
  /** Sudanese Pound */
  Sdg = 'SDG',
  /** Swedish Krona */
  Sek = 'SEK',
  /** Singapore Dollar */
  Sgd = 'SGD',
  /** Saint Helena Pound */
  Shp = 'SHP',
  /** Leone */
  Sll = 'SLL',
  /** Somali Shilling */
  Sos = 'SOS',
  /** Surinam Dollar */
  Srd = 'SRD',
  /** South Sudanese Pound */
  Ssp = 'SSP',
  /** Dobra */
  Stn = 'STN',
  /** El Salvador Colon */
  Svc = 'SVC',
  /** Syrian Pound */
  Syp = 'SYP',
  /** Lilangeni */
  Szl = 'SZL',
  /** Baht */
  Thb = 'THB',
  /** Somoni */
  Tjs = 'TJS',
  /** Turkmenistan New Manat */
  Tmt = 'TMT',
  /** Tunisian Dinar */
  Tnd = 'TND',
  /** Pa'anga */
  Top = 'TOP',
  /** Turkish Lira */
  Try = 'TRY',
  /** Trinidad and Tobago Dollar */
  Ttd = 'TTD',
  /** New Taiwan Dollar */
  Twd = 'TWD',
  /** Tanzanian Shilling */
  Tzs = 'TZS',
  /** Hryvnia */
  Uah = 'UAH',
  /** Uganda Shilling */
  Ugx = 'UGX',
  /** US Dollar (Next day) */
  Usn = 'USN',
  /** Uruguay Peso en Unidades Indexadas (URUIURUI) */
  Uyi = 'UYI',
  /** Peso Uruguayo */
  Uyu = 'UYU',
  /** Uzbekistan Sum */
  Uzs = 'UZS',
  /** Bolívar */
  Vef = 'VEF',
  /** Dong */
  Vnd = 'VND',
  /** Vatu */
  Vuv = 'VUV',
  /** Tala */
  Wst = 'WST',
  /** CFA Franc BEAC */
  Xaf = 'XAF',
  /** Silver */
  Xag = 'XAG',
  /** Gold */
  Xau = 'XAU',
  /** Bond Markets Unit European Composite Unit (EURCO) */
  Xba = 'XBA',
  /** Bond Markets Unit European Monetary Unit (E.M.U.-6) */
  Xbb = 'XBB',
  /** Bond Markets Unit European Unit of Account 9 (E.U.A.-9) */
  Xbc = 'XBC',
  /** Bond Markets Unit European Unit of Account 17 (E.U.A.-17) */
  Xbd = 'XBD',
  /** East Caribbean Dollar */
  Xcd = 'XCD',
  /** SDR (Special Drawing Right) */
  Xdr = 'XDR',
  /** CFA Franc BCEAO */
  Xof = 'XOF',
  /** Palladium */
  Xpd = 'XPD',
  /** CFP Franc */
  Xpf = 'XPF',
  /** Platinum */
  Xpt = 'XPT',
  /** Sucre */
  Xsu = 'XSU',
  /** Codes specifically reserved for testing purposes */
  Xts = 'XTS',
  /** ADB Unit of Account */
  Xua = 'XUA',
  /** The codes assigned for transactions where no currency is involved */
  Xxx = 'XXX',
  /** Yemeni Rial */
  Yer = 'YER',
  /** Rand */
  Zar = 'ZAR',
  /** Zambian Kwacha */
  Zmw = 'ZMW',
  /** Zimbabwe Dollar */
  Zwl = 'ZWL'
}

export type TheaterLocaleData = {
  /** The theater's title. */
  title: Maybe<Scalars['String']['output']>;
  /** The theater's summary. */
  description: Maybe<Scalars['String']['output']>;
  /** The locale. */
  locale: Scalars['ID']['output'];
  /** The theater's address */
  address: Maybe<Scalars['String']['output']>;
  /** The theater's city */
  city: Maybe<Scalars['String']['output']>;
  /** The theater's state */
  state: Maybe<Scalars['String']['output']>;
};

export enum TheaterTypology {
  FirstRun = 'FIRST_RUN',
  SubRun = 'SUB_RUN',
  Occasional = 'OCCASIONAL',
  TravelingTheater = 'TRAVELING_THEATER',
  DriveIn = 'DRIVE_IN',
  Outdoor = 'OUTDOOR'
}

export type TheaterTemporaryClosure = {
  /** The start date of closure. */
  startsAt: Maybe<Scalars['PartialDate']['output']>;
  /** The end date of closure. */
  endsAt: Maybe<Scalars['PartialDate']['output']>;
  /** The reason of closure. */
  message: Scalars['String']['output'];
};

export type TheaterNextOpening = {
  /** The starts date of opening. */
  startsAt: Maybe<Scalars['PartialDate']['output']>;
  /** More informations about the opening. */
  message: Scalars['String']['output'];
};

export enum TheaterShowtimeSource {
  Khronos = 'KHRONOS',
  Legacy = 'LEGACY',
  WwmImport = 'WWM_IMPORT'
}

export type TheaterFlags = {
  /** The theater's supported payment methods */
  payment: Array<TheaterPaymentMethod>;
  /** The theater's extra services */
  service: Array<TheaterExtraService>;
};

export enum TheaterPaymentMethod {
  ChequeCinemaUniversel = 'CHEQUE_CINEMA_UNIVERSEL',
  CineCarteCip = 'CINE_CARTE_CIP',
  Cinecheque = 'CINECHEQUE',
  Cinepass = 'CINEPASS',
  UgcIllimite = 'UGC_ILLIMITE',
  Grac = 'GRAC'
}

export enum TheaterExtraService {
  AirConditioning = 'AIR_CONDITIONING',
  Autism = 'AUTISM',
  CandyStore = 'CANDY_STORE',
  DisabledAccess = 'DISABLED_ACCESS',
  Restaurant = 'RESTAURANT'
}

export type TheaterTicketing = {
  useAtom: Scalars['Boolean']['output'];
  useMovieTickets: Scalars['Boolean']['output'];
};

export enum TheaterOpeningStatus {
  Opened = 'OPENED',
  DefinitivelyClosed = 'DEFINITIVELY_CLOSED',
  TemporarilyClosed = 'TEMPORARILY_CLOSED',
  NextOpening = 'NEXT_OPENING'
}

export enum TheaterShowtimesGatheringMethod {
  Import = 'IMPORT',
  Manual = 'MANUAL',
  Set = 'SET'
}

export enum Genre {
  Action = 'ACTION',
  Adventure = 'ADVENTURE',
  Animation = 'ANIMATION',
  Ballet = 'BALLET',
  Biopic = 'BIOPIC',
  Bollywood = 'BOLLYWOOD',
  Cartoon = 'CARTOON',
  Classic = 'CLASSIC',
  Comedy = 'COMEDY',
  Comedydrama = 'COMEDYDRAMA',
  Concert = 'CONCERT',
  Detective = 'DETECTIVE',
  Documentary = 'DOCUMENTARY',
  Drama = 'DRAMA',
  Erotic = 'EROTIC',
  Experimental = 'EXPERIMENTAL',
  Family = 'FAMILY',
  Fantasy = 'FANTASY',
  Historical = 'HISTORICAL',
  HistoricalEpic = 'HISTORICAL_EPIC',
  Horror = 'HORROR',
  Judicial = 'JUDICIAL',
  KoreanDrama = 'KOREAN_DRAMA',
  MartialArts = 'MARTIAL_ARTS',
  Medical = 'MEDICAL',
  MovieNight = 'MOVIE_NIGHT',
  Music = 'MUSIC',
  Musical = 'MUSICAL',
  Opera = 'OPERA',
  Romance = 'ROMANCE',
  ScienceFiction = 'SCIENCE_FICTION',
  Show = 'SHOW',
  Soap = 'SOAP',
  SportEvent = 'SPORT_EVENT',
  Spy = 'SPY',
  Theater = 'THEATER',
  Thriller = 'THRILLER',
  Unknown = 'UNKNOWN',
  WarMovie = 'WAR_MOVIE',
  WebSeries = 'WEB_SERIES',
  Western = 'WESTERN'
}

export type BrandEntityClub = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  brand: Brand;
  club: Club;
  seen: Maybe<Scalars['Boolean']['output']>;
  approved: Maybe<Scalars['Boolean']['output']>;
  rating: Maybe<BrandEntityClubRating>;
};

export type Club = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Unique code for the club */
  code: Scalars['String']['output'];
  brand: Brand;
};

export type BrandEntityClubRating = {
  excellent: Maybe<Scalars['Float']['output']>;
  good: Maybe<Scalars['Float']['output']>;
  average: Maybe<Scalars['Float']['output']>;
  bad: Maybe<Scalars['Float']['output']>;
};

export enum SeriesType {
  Series = 'SERIES',
  Mini = 'MINI',
  Web = 'WEB',
  Manga = 'MANGA',
  Show = 'SHOW',
  Report = 'REPORT',
  Unknown = 'UNKNOWN'
}

/** A pager to a list of SeriesSeason objects. */
export type SeriesSeasonPager = {
  /** The list of objects. */
  nodes: Array<SeriesSeason>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export enum SeriesEpisodeFilter {
  All = 'ALL',
  Orphans = 'ORPHANS'
}

export type SeriesLocaleData = {
  /** The series's title. */
  title: Maybe<Scalars['String']['output']>;
  /** The series's synopsis. */
  synopsis: Maybe<Scalars['String']['output']>;
  /** The series's synopsis. */
  synopsisShort: Maybe<Scalars['String']['output']>;
  /** A website url for the series. */
  url: Maybe<Scalars['URL']['output']>;
  /** The locale. */
  locale: Scalars['ID']['output'];
  /** The series's poster */
  poster: Maybe<Image>;
};

export type SeriesBrandData = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The series's title. */
  title: Maybe<Scalars['String']['output']>;
  /** The series's synopsis. */
  synopsis: Maybe<Scalars['RichText']['output']>;
  /** The series's short synopsis. */
  synopsisShort: Maybe<Scalars['String']['output']>;
  /** The poster of the series. */
  poster: Maybe<Image>;
  /** The series's keywords. */
  keywords: Array<Scalars['String']['output']>;
  brand: Brand;
  ruling: EntityBrandDataRuling;
};

export enum TriviaLinkableEntityType {
  Movie = 'MOVIE',
  Series = 'SERIES',
  SeriesSeason = 'SERIES_SEASON',
  SeriesEpisode = 'SERIES_EPISODE',
  Person = 'PERSON'
}

export type ReleaseOrder = {
  /** The field to order by. */
  field: ReleaseOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum ReleaseOrderField {
  Id = 'ID',
  ReleasedAt = 'RELEASED_AT'
}

export enum MovieType {
  Feature = 'FEATURE',
  MediumLengthFilm = 'MEDIUM_LENGTH_FILM',
  ShortFilm = 'SHORT_FILM',
  TvMovie = 'TV_MOVIE',
  SpecialEvent = 'SPECIAL_EVENT',
  BrandContent = 'BRAND_CONTENT',
  Commercial = 'COMMERCIAL',
  Episode = 'EPISODE',
  Serial = 'SERIAL',
  SketchMovie = 'SKETCH_MOVIE'
}

export enum MovieProjection {
  HasPostGenericScene = 'HAS_POST_GENERIC_SCENE'
}

export enum MovieAdditional {
  IoRestrictionNotGoogle = 'IO_RESTRICTION_NOT_GOOGLE',
  MatchingConfigurationNoAutoMatching = 'MATCHING_CONFIGURATION_NO_AUTO_MATCHING'
}

/** The foxpro sync informations for the movie */
export type MovieFoxProSync = {
  create3D: Scalars['Boolean']['output'];
  createImax: Scalars['Boolean']['output'];
};

export type MovieLocaleData = {
  /** The movie's title. */
  title: Maybe<Scalars['String']['output']>;
  /** The movie's synopsis. */
  synopsis: Maybe<Scalars['String']['output']>;
  /** The movie's synopsis. */
  synopsisShort: Maybe<Scalars['String']['output']>;
  /** A website url for the movie. */
  url: Maybe<Scalars['URL']['output']>;
  /** Movie notes. */
  notes: Maybe<Scalars['String']['output']>;
  /** The locale. */
  locale: Scalars['ID']['output'];
  /** The movie's poster */
  poster: Maybe<Image>;
  /** The movie's first image to match the type parameter */
  image: Maybe<Image>;
};


export type MovieLocaleDataImageArgs = {
  type?: InputMaybe<ImageType>;
};

export type MovieBrandData = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The movie's title. */
  title: Maybe<Scalars['String']['output']>;
  /** The movie's synopsis. */
  synopsis: Maybe<Scalars['RichText']['output']>;
  /** The movie's short synopsis. */
  synopsisShort: Maybe<Scalars['RichText']['output']>;
  /** The poster of the movie. */
  poster: Maybe<Image>;
  /** The movie's keywords. */
  keywords: Array<Scalars['String']['output']>;
  brand: Brand;
  brandedContent: Maybe<MovieBrandedContent>;
  ruling: EntityBrandDataRuling;
};

export type MovieBrandedContent = {
  tabs: Maybe<Array<MovieTabs>>;
};

export type MovieTabs = {
  index: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  contentJson: Scalars['RichText']['output'];
};

export type ShowtimesEmbargo = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  country: Country;
  bookableAt: Maybe<Scalars['DateTime']['output']>;
  publicAt: Maybe<Scalars['DateTime']['output']>;
};

export type MovieVersion = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  version: MovieVersionType;
  runtime: Maybe<Runtime>;
  label: Maybe<Scalars['String']['output']>;
};

export enum MovieVersionType {
  ExtendedCut = 'EXTENDED_CUT',
  DirectorsCut = 'DIRECTORS_CUT'
}

export enum EntityState {
  ScheduledForDeletion = 'SCHEDULED_FOR_DELETION',
  Live = 'LIVE'
}

/** A pager to a list of Application objects. */
export type ApplicationPager = {
  /** The list of objects. */
  nodes: Array<Application>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

/** A pager to a list of Author objects. */
export type AuthorPager = {
  /** The list of objects. */
  nodes: Array<Author>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type BrandSearchLink = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  title: Maybe<Scalars['String']['output']>;
  /** Pointing actual URL of this link */
  url: Maybe<Scalars['String']['output']>;
  description: Maybe<Scalars['String']['output']>;
  /** Keywords used to retrieve this link */
  keywords: Maybe<Array<Scalars['String']['output']>>;
  brand: Brand;
  poster: Maybe<Image>;
};

/** A pager to a list of BrandSearchLink objects. */
export type BrandSearchLinkPager = {
  /** The list of objects. */
  nodes: Array<BrandSearchLink>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

/** A pager to a list of Carousel objects. */
export type CarouselPager = {
  /** The list of objects. */
  nodes: Array<Carousel>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

/** A pager to a list of Certificate objects. */
export type CertificatePager = {
  /** The list of objects. */
  nodes: Array<Certificate>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

/** Possible certificate scopes. */
export enum CertificateScope {
  Movie = 'MOVIE',
  Series = 'SERIES'
}

export type CertificateOrder = {
  /** The field to order by. */
  field: CertificateOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum CertificateOrderField {
  /** Order certificates by ID. */
  Id = 'ID',
  /** Order certificates by rank. */
  Rank = 'RANK'
}

export type CheckUrl = {
  error: Maybe<Scalars['String']['output']>;
  responseTime: Scalars['Int']['output'];
  statusCode: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Clock = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  range: DateRange;
  theater: Theater;
  screen: Maybe<Screen>;
  entity: ClockEntity;
  showtimes: Array<Scalars['LocalTime']['output']>;
  technos: Array<ClockTechno>;
  sound: Maybe<ClockSound>;
  subtitlesLanguage: Maybe<Language>;
  language: Maybe<Language>;
  seatingStyle: Maybe<ClockSeatingStyle>;
  amenity: Maybe<ClockAmenity>;
  comment: Maybe<Scalars['String']['output']>;
};

export type DateRange = {
  startsAt: Scalars['Date']['output'];
  endsAt: Scalars['Date']['output'];
};

export type ClockEntity = Movie;

export enum ClockTechno {
  '2D' = '_2D',
  '3D' = '_3D',
  '4D' = '_4D',
  Imax = 'IMAX',
  Imax3D = 'IMAX3D',
  '4K' = '_4K',
  Hfr = 'HFR',
  '70Mm' = '_70MM',
  '35Mm' = '_35MM',
  Imax_70Mm = 'IMAX_70MM',
  VistaVision_35Mm = 'VISTA_VISION_35MM',
  InfinityVision = 'INFINITY_VISION'
}

export enum ClockSound {
  Atmos = 'ATMOS',
  Thx = 'THX',
  '5_1' = '_5_1',
  '7_1' = '_7_1',
  Dolby_7_1 = 'DOLBY_7_1'
}

export enum ClockSeatingStyle {
  Reserved = 'RESERVED'
}

export enum ClockAmenity {
  AirConditioning = 'AIR_CONDITIONING',
  DineIn = 'DINE_IN',
  AlcoholDrinks = 'ALCOHOL_DRINKS',
  FoodAndBeverage = 'FOOD_AND_BEVERAGE'
}

/** A pager to a list of Clock objects. */
export type ClockPager = {
  /** The list of objects. */
  nodes: Array<Clock>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type ClockOrder = {
  /** The field to order by. */
  field: ClockOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum ClockOrderField {
  /** Order by start date */
  StartsAt = 'STARTS_AT'
}

/** A pager to a list of Company objects. */
export type CompanyPager = {
  /** The list of objects. */
  nodes: Array<Company>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export enum CompanyAdditionalTag {
  SocialProviderAsFavorite = 'SOCIAL_PROVIDER_AS_FAVORITE'
}

export type CompanyOrder = {
  /** The field to order by. */
  field: CompanyOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum CompanyOrderField {
  Id = 'ID',
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  Score = 'SCORE'
}

/** Represent the relation between a product and a company */
export type CompanyProduct = {
  product: Product;
  company: Company;
  url: Scalars['URL']['output'];
};

export type Product = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  country: Country;
  name: Scalars['String']['output'];
  type: ProductType;
};

export enum ProductType {
  Avod = 'AVOD',
  Bluray = 'BLURAY',
  Dvd = 'DVD',
  Replay = 'REPLAY',
  Svod = 'SVOD',
  Vod = 'VOD',
  Vodest = 'VODEST'
}

/** A pager to a list of Country objects. */
export type CountryPager = {
  /** The list of objects. */
  nodes: Array<Country>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type CountryOrder = {
  /** The field to order by. */
  field: CountryOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum CountryOrderField {
  /** Order countries by ID. */
  Id = 'ID',
  /** Order countries by name. */
  Name = 'NAME'
}

export type Customer = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  name: Scalars['String']['output'];
  comment: Maybe<Scalars['String']['output']>;
  graphBackendEndpoint: Maybe<Scalars['URL']['output']>;
};

/** A pager to a list of CustomerQuery objects. */
export type CustomerQueryPager = {
  /** The list of objects. */
  nodes: Array<CustomerQuery>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type CustomerQuery = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  name: Scalars['String']['output'];
  template: Scalars['String']['output'];
};

/** A pager to a list of Customer objects. */
export type CustomerPager = {
  /** The list of objects. */
  nodes: Array<Customer>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type DeleteImportShowtimesStats = {
  totalCount: Scalars['Int']['output'];
};

export type DateRangeInput = {
  startsAt: Scalars['Date']['input'];
  endsAt: Scalars['Date']['input'];
};

export type Duplicate = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  firstEntity: DuplicateEntity;
  secondEntity: DuplicateEntity;
  status: DuplicateStatus;
  priority: DuplicatePriority;
  winner: Maybe<DuplicateEntity>;
  comment: Maybe<Scalars['String']['output']>;
};

export type DuplicateEntity = DeletedEntity | Company | Movie | Series | Person;

export type DeletedEntity = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  source: DeletedEntitySource;
};

export type DeletedEntitySource = {
  typename: Scalars['String']['output'];
  ref: Scalars['ID']['output'];
};

export enum DuplicateStatus {
  New = 'NEW',
  Investigating = 'INVESTIGATING',
  ToTransfer = 'TO_TRANSFER',
  ToRedirect = 'TO_REDIRECT',
  ToClose = 'TO_CLOSE',
  AwaitingProduction = 'AWAITING_PRODUCTION',
  Closed = 'CLOSED'
}

export enum DuplicatePriority {
  Regular = 'REGULAR',
  Urgent = 'URGENT'
}

/** A pager to a list of Duplicate objects. */
export type DuplicatePager = {
  /** The list of objects. */
  nodes: Array<Duplicate>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export enum DuplicateEntityType {
  Company = 'COMPANY',
  Movie = 'MOVIE',
  Series = 'SERIES',
  Person = 'PERSON'
}

export type DuplicateOrder = {
  /** The field to order by. */
  field: DuplicateOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum DuplicateOrderField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type EditorialReview = PublishableEntityInterface & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** The associated brand. */
  brand: Brand;
  rating: Scalars['Int']['output'];
  isUpdatedWhenPublished: Scalars['Boolean']['output'];
  publications: Array<EntityPublication>;
  publicationStatus: EntityPublicationStatus;
  publicationDate: Maybe<Scalars['DateTime']['output']>;
  /** The editorial review authors */
  authors: Array<EditorialReviewAuthor>;
  body: Maybe<Scalars['RichText']['output']>;
  bodyShort: Maybe<Scalars['String']['output']>;
  /** The editorial review title */
  title: Maybe<Scalars['String']['output']>;
  /** The editorial review picture */
  picture: Maybe<Image>;
  /** The editorial review entity linked */
  entity: EditorialReviewEntity;
};

/** The link between an editorial review and an author */
export type EditorialReviewAuthor = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  rank: Scalars['NonNegativeInt']['output'];
  author: Author;
  signature: Maybe<AuthorSignature>;
};

export type EditorialReviewEntity = Movie | Series | SeriesSeason;

/** A pager to a list of EditorialReview objects. */
export type EditorialReviewPager = {
  /** The list of objects. */
  nodes: Array<EditorialReview>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export enum EntityType {
  Author = 'AUTHOR',
  Company = 'COMPANY',
  Carousel = 'CAROUSEL',
  Country = 'COUNTRY',
  Fare = 'FARE',
  Screen = 'SCREEN',
  Festival = 'FESTIVAL',
  FestivalEdition = 'FESTIVAL_EDITION',
  FestivalCompetition = 'FESTIVAL_COMPETITION',
  FestivalSelection = 'FESTIVAL_SELECTION',
  CompanyStaff = 'COMPANY_STAFF',
  Image = 'IMAGE',
  ImageCategory = 'IMAGE_CATEGORY',
  Movie = 'MOVIE',
  News = 'NEWS',
  Person = 'PERSON',
  PressReview = 'PRESS_REVIEW',
  Series = 'SERIES',
  SeriesSeason = 'SERIES_SEASON',
  SeriesEpisode = 'SERIES_EPISODE',
  Slide = 'SLIDE',
  SocialUser = 'SOCIAL_USER',
  Theater = 'THEATER',
  TheaterScreen = 'THEATER_SCREEN',
  TheaterEvent = 'THEATER_EVENT',
  User = 'USER',
  VideoB2B = 'VIDEO_B2B',
  VideoLegacy = 'VIDEO_LEGACY',
  FestivalAward = 'FESTIVAL_AWARD',
  Trivia = 'TRIVIA',
  EditorialReview = 'EDITORIAL_REVIEW',
  Widget = 'WIDGET',
  Locale = 'LOCALE',
  Certificate = 'CERTIFICATE'
}

/** A pager to a list of EventLog objects. */
export type EventLogPager = {
  /** The list of objects. */
  nodes: Array<EventLog>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type EventLog = {
  uuid: Scalars['String']['output'];
  /** Event type (matched, unmatched, ignored, deleted) */
  eventType: EventLogType;
  occuredAt: Scalars['DateTime']['output'];
  /** JSON data of the event */
  payload: Scalars['JSON']['output'];
  /** Textual description of the event */
  label: Scalars['String']['output'];
  user: Maybe<User>;
};

export type EventLogOrder = {
  /** The field to order by. */
  field: EventLogOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum EventLogOrderField {
  OccuredAt = 'OCCURED_AT',
  UserName = 'USER_NAME'
}

export enum ExternalIdProviderType {
  Company = 'COMPANY',
  Movie = 'MOVIE',
  Screen = 'SCREEN',
  SeriesEpisode = 'SERIES_EPISODE',
  SeriesSeason = 'SERIES_SEASON',
  Series = 'SERIES',
  Theater = 'THEATER'
}

/** Generated title, description and keywords from Gemini. */
export type AiArticleContentResult = {
  title: Scalars['String']['output'];
  description: Scalars['String']['output'];
  keywords: Array<Scalars['String']['output']>;
  /** Token usage metadata from the AI generation, if available. */
  aiMetadata: Maybe<AiMetadata>;
};

/** Token usage metadata from an AI generation (input and total tokens). */
export type AiMetadata = {
  /** Number of tokens in the prompt (input). */
  promptTokenCount: Maybe<Scalars['Int']['output']>;
  /** Total number of tokens (input + output). */
  totalTokenCount: Maybe<Scalars['Int']['output']>;
};

/** An AI skill (prompt + model) for content generation. */
export type AiSkill = {
  id: Scalars['ID']['output'];
  entityType: AiSkillEntityType;
  code: AiSkillCode;
  version: Scalars['Int']['output'];
  /** Whether this version is the default for users. */
  isDefault: Scalars['Boolean']['output'];
  /** Gemini model name (e.g. gemini-2.5-flash). */
  model: GeminiModel;
  /** Markdown content of the prompt. */
  content: Maybe<Scalars['String']['output']>;
  /** Suggested label for UI (e.g. version + model). */
  displayLabel: Maybe<Scalars['String']['output']>;
};

/** Entity type for the AI skill (article or trivia). */
export enum AiSkillEntityType {
  Article = 'article',
  Trivia = 'trivia'
}

/** Prompt code (e.g. ArticleContent, BrandedTrivia). */
export enum AiSkillCode {
  ArticleContent = 'ArticleContent',
  BrandedTrivia = 'BrandedTrivia'
}

/** Available Gemini model name for AI skills. */
export enum GeminiModel {
  Gemini_3_1ProPreview = 'GEMINI_3_1_PRO_PREVIEW',
  Gemini_2_5Flash = 'GEMINI_2_5_FLASH',
  Gemini_2_5Pro = 'GEMINI_2_5_PRO'
}

/** A festival award */
export type FestivalAward = Node & Entity & Ref & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** @deprecated use seoAttributes field now */
  seoData: Maybe<EntitySeoData>;
  /** Other IDs from external source to represent the screen. */
  externalIDs: Array<ExternalId>;
  /** The metadata of this entity. */
  metadata: Metadata;
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** The name of the award */
  name: Scalars['String']['output'];
  festival: Festival;
  /** The localized data related to festival award */
  localizedData: Maybe<FestivalAwardLocalized>;
  /** The list of nominees */
  nominees: Maybe<FestivalSelectionNomineesType>;
  rank: Scalars['NonNegativeInt']['output'];
  /** The festival selections associated */
  festivalSelections: Maybe<Array<Maybe<FestivalSelection>>>;
};


/** A festival award */
export type FestivalAwardSeoDataArgs = {
  brandId: Scalars['ID']['input'];
};


/** A festival award */
export type FestivalAwardExternalIDsArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
};


/** A festival award */
export type FestivalAwardLocalizedDataArgs = {
  locale: Scalars['ID']['input'];
};


/** A festival award */
export type FestivalAwardFestivalSelectionsArgs = {
  orderBy?: InputMaybe<FestivalSelectionEntityOrder>;
};

export type FestivalAwardLocalized = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The localized festival award name. */
  name: Maybe<Scalars['String']['output']>;
};

export type FestivalSelectionNomineesType = {
  /** The nominated movie or series */
  entity: Maybe<MovieOrSeries>;
  /** The list of person nominated for the movie */
  persons: Maybe<Array<Person>>;
};

export type MovieOrSeries = Movie | Series;

/** A festival selection */
export type FestivalSelection = Node & Entity & Ref & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** @deprecated use seoAttributes field now */
  seoData: Maybe<EntitySeoData>;
  /** Other IDs from external source to represent the screen. */
  externalIDs: Array<ExternalId>;
  /** The metadata of this entity. */
  metadata: Metadata;
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** The id of the festival */
  festivalId: Maybe<Scalars['ID']['output']>;
  /** The id of the festival competition */
  festivalCompetitionId: Maybe<Scalars['ID']['output']>;
  /** The festival competition */
  festivalCompetition: Maybe<FestivalCompetition>;
  /** The id of the festival edition */
  festivalEditionId: Maybe<Scalars['ID']['output']>;
  /** The festival edition */
  festivalEdition: FestivalEdition;
  /** The list of nominees */
  nominees: Maybe<FestivalSelectionNomineesType>;
  /** The awards associated */
  awards: Maybe<Array<FestivalAward>>;
};


/** A festival selection */
export type FestivalSelectionSeoDataArgs = {
  brandId: Scalars['ID']['input'];
};


/** A festival selection */
export type FestivalSelectionExternalIDsArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
};

/** A festival competition in a festival */
export type FestivalCompetition = Node & Entity & Ref & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** @deprecated use seoAttributes field now */
  seoData: Maybe<EntitySeoData>;
  /** Other IDs from external source to represent the screen. */
  externalIDs: Array<ExternalId>;
  /** The metadata of this entity. */
  metadata: Metadata;
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** The name of the competition (or section) */
  name: Maybe<Scalars['String']['output']>;
  /** The display of the competition (or section) */
  display: Maybe<FestivalCompetitionDisplay>;
  festival: Festival;
  /** The localized data related to festival competition (or section) */
  localizedData: Maybe<FestivalCompetitionLocalized>;
};


/** A festival competition in a festival */
export type FestivalCompetitionSeoDataArgs = {
  brandId: Scalars['ID']['input'];
};


/** A festival competition in a festival */
export type FestivalCompetitionExternalIDsArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
};


/** A festival competition in a festival */
export type FestivalCompetitionLocalizedDataArgs = {
  locale: Scalars['ID']['input'];
};

export enum FestivalCompetitionDisplay {
  FilmSerie = 'FILM_SERIE',
  FilmSeriePersonne = 'FILM_SERIE_PERSONNE',
  FilmPersonne = 'FILM_PERSONNE',
  PersonneFilmSerie = 'PERSONNE_FILM_SERIE'
}

export type FestivalCompetitionLocalized = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The localized festival description. */
  name: Maybe<Scalars['String']['output']>;
};

export type FestivalSelectionEntityOrder = {
  /** The field to order by. */
  field: FestivalSelectionEntityOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum FestivalSelectionEntityOrderField {
  EditionYear = 'EDITION_YEAR'
}

/** A pager to a list of FestivalAward objects. */
export type FestivalAwardPager = {
  /** The list of objects. */
  nodes: Array<FestivalAward>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type FestivalAwardOrder = {
  /** The field to order by. */
  field: FestivalAwardOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum FestivalAwardOrderField {
  Id = 'ID',
  Active = 'ACTIVE',
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
  Name = 'NAME'
}

/** A "virtual" festival competition linked to a festival edition */
export type FestivalEditionCompetition = Node & Entity & Ref & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** @deprecated use seoAttributes field now */
  seoData: Maybe<EntitySeoData>;
  /** Other IDs from external source to represent the screen. */
  externalIDs: Array<ExternalId>;
  /** The metadata of this entity. */
  metadata: Metadata;
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** The rank order of the competition (AKA section) */
  rank: Scalars['NonNegativeInt']['output'];
  festivalCompetition: Maybe<FestivalCompetition>;
  festival: Festival;
};


/** A "virtual" festival competition linked to a festival edition */
export type FestivalEditionCompetitionSeoDataArgs = {
  brandId: Scalars['ID']['input'];
};


/** A "virtual" festival competition linked to a festival edition */
export type FestivalEditionCompetitionExternalIDsArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
};

export type FestivalEditionCompetitionSearchResult = {
  /** The name of the festival competition */
  name: Scalars['String']['output'];
  /** The edition related to festival competition (or section) */
  edition: FestivalEdition;
  /** The festival competition */
  festivalCompetition: FestivalCompetition;
  /** The localized data of the festival competition */
  localizedData: Maybe<FestivalCompetitionLocalized>;
};


export type FestivalEditionCompetitionSearchResultLocalizedDataArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

/** A pager to a list of FestivalEdition objects. */
export type FestivalEditionPager = {
  /** The list of objects. */
  nodes: Array<FestivalEdition>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type FestivalEditionOrder = {
  /** The field to order by. */
  field: FestivalEditionOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum FestivalEditionOrderField {
  Id = 'ID',
  Year = 'YEAR',
  StartsAt = 'STARTS_AT',
  EndsAt = 'ENDS_AT',
  Name = 'NAME',
  Active = 'ACTIVE'
}

/** A festival jury */
export type FestivalJury = Node & Entity & Ref & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** @deprecated use seoAttributes field now */
  seoData: Maybe<EntitySeoData>;
  /** Other IDs from external source to represent the screen. */
  externalIDs: Array<ExternalId>;
  /** The metadata of this entity. */
  metadata: Metadata;
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** The id of the festival */
  festivalId: Scalars['ID']['output'];
  /** The id of the festival edition */
  festivalEditionId: Scalars['ID']['output'];
  /** The id of the festival competition */
  festivalCompetitionId: Maybe<Scalars['ID']['output']>;
  /** The jury identity */
  person: Person;
  /** The role of the member of the jury */
  role: FestivalJuryRole;
  /** The rank of the member of the jury */
  rank: Scalars['Int']['output'];
};


/** A festival jury */
export type FestivalJurySeoDataArgs = {
  brandId: Scalars['ID']['input'];
};


/** A festival jury */
export type FestivalJuryExternalIDsArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
};

export enum FestivalJuryRole {
  MaitreDeCeremonie = 'MAITRE_DE_CEREMONIE',
  MaitresseDeCeremonie = 'MAITRESSE_DE_CEREMONIE',
  Marraine = 'MARRAINE',
  MembreDuJury = 'MEMBRE_DU_JURY',
  Parrain = 'PARRAIN',
  PresidentDeLaCeremonie = 'PRESIDENT_DE_LA_CEREMONIE',
  PresidentDuFestival = 'PRESIDENT_DU_FESTIVAL',
  PresidentDuJury = 'PRESIDENT_DU_JURY'
}

/** A pager to a list of Festival objects. */
export type FestivalPager = {
  /** The list of objects. */
  nodes: Array<Festival>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type FestivalOrder = {
  /** The field to order by. */
  field: FestivalOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum FestivalOrderField {
  Id = 'ID',
  CreatedAt = 'CREATED_AT',
  Name = 'NAME'
}

export type FestivalSelectionOrder = {
  /** The field to order by. */
  field: FestivalSelectionOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum FestivalSelectionOrderField {
  Id = 'ID',
  Entity = 'ENTITY',
  Type = 'TYPE'
}

export type FileMetadata = {
  hash: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  path: Scalars['String']['output'];
  fileStorageType: FileUploadStorageType;
  ressourceURI: Scalars['URL']['output'];
  /** Public HTTP URL to read the file (publicBaseUrl + path, or signed URL when publicBaseUrl is not set) */
  resourceUrl: Maybe<Scalars['URL']['output']>;
  timeCreated: Maybe<Scalars['DateTime']['output']>;
  updated: Maybe<Scalars['DateTime']['output']>;
  imageSize: Maybe<ImageFileSize>;
};

/** Type of file to upload (image, video, etc.) */
export enum FileUploadStorageType {
  Image = 'IMAGE',
  ConnectorImages = 'CONNECTOR_IMAGES',
  Video = 'VIDEO',
  WwwAsset = 'WWW_ASSET',
  SpecialOperationMobileDdayFont = 'SPECIAL_OPERATION_MOBILE_DDAY_FONT'
}

export type ImageFileSize = {
  width: Scalars['Int']['output'];
  height: Scalars['Int']['output'];
};

/** A pager to a list of IgnoredProduct objects. */
export type IgnoredProductPager = {
  /** The list of objects. */
  nodes: Array<IgnoredProduct>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type IgnoredProduct = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The title of the product. */
  title: Maybe<Scalars['String']['output']>;
  /** The type of the product. */
  type: Scalars['String']['output'];
  /** The product id in the source reference system */
  sourceId: Scalars['String']['output'];
  /** The source of this product */
  source: ProductSource;
};

export type ProductSource = {
  /** The source id */
  id: Scalars['ID']['output'];
};

/** A pager to a list of IgnoredShowtimeSource objects. */
export type IgnoredShowtimeSourcePager = {
  /** The list of objects. */
  nodes: Array<IgnoredShowtimeSource>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type IgnoredShowtimeSource = {
  sourceType: ShowtimeSourceType;
  sourceName: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  title: Maybe<Scalars['String']['output']>;
};

export enum ShowtimeSourceType {
  Entity = 'ENTITY',
  Theater = 'THEATER'
}

/** A pager to a list of ImageCategory objects. */
export type ImageCategoryPager = {
  /** The list of objects. */
  nodes: Array<ImageCategory>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type ImageCategoryOrder = {
  /** The field to order by. */
  field: ImageCategoryOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum ImageCategoryOrderField {
  Id = 'ID',
  Rank = 'RANK',
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  DateRange = 'DATE_RANGE'
}

/** A pager to a list of Image objects. */
export type ImagePager = {
  /** The list of objects. */
  nodes: Array<Image>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type ImageOrder = {
  /** The field to order by. */
  field: ImageOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum ImageOrderField {
  /** Order images by updated date. */
  UpdatedAt = 'UPDATED_AT',
  /** Order images by created date. */
  CreatedAt = 'CREATED_AT'
}

export type EntityHasImageOrder = {
  /** The field to order by. */
  field: EntityHasImageOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum EntityHasImageOrderField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
  Rank = 'RANK',
  ImageCreatedAt = 'IMAGE_CREATED_AT',
  ImageUpdatedAt = 'IMAGE_UPDATED_AT'
}

export type ImportConfiguration = Node & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  crawler: ImportCrawler;
  sourceId: Maybe<Scalars['String']['output']>;
  fetchedDays: Scalars['Int']['output'];
  gathertimesTimeout: Maybe<Scalars['NonNegativeInt']['output']>;
  uri: Scalars['URL']['output'];
  enabled: Scalars['Boolean']['output'];
  lastRun: Maybe<ImportRun>;
  nextRun: Scalars['DateTime']['output'];
  interval: Scalars['Int']['output'];
  theaterMatcher: Maybe<Scalars['String']['output']>;
  entityMatcher: Maybe<Scalars['String']['output']>;
  averageDuration: Maybe<Scalars['Duration']['output']>;
  runs: ImportRunPager;
  entity: Maybe<ImportConfigurationEntity>;
  inheritsScreenAttributes: Scalars['Boolean']['output'];
  parameters: Maybe<Scalars['String']['output']>;
  linksOnly: Scalars['Boolean']['output'];
  moviesOnly: Scalars['Boolean']['output'];
};


export type ImportConfigurationRunsArgs = {
  lastStep?: InputMaybe<ImportRunStepType>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ImportCrawler = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  name: Scalars['String']['output'];
  type: Maybe<CrawlerType>;
  countries: Maybe<Array<Country>>;
  tags: Maybe<Array<Scalars['Tag3D']['output']>>;
  notes: Maybe<Scalars['String']['output']>;
  parameters: Maybe<Scalars['String']['output']>;
  defaultConfiguration: Maybe<CrawlerDefaultConfiguration>;
  configurations: Maybe<ImportConfigurationPager>;
};


export type ImportCrawlerConfigurationsArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export enum CrawlerType {
  Webscrape = 'WEBSCRAPE',
  CustomApi = 'CUSTOM_API',
  Pos = 'POS',
  Other = 'OTHER'
}

export type CrawlerDefaultConfiguration = {
  uri: Maybe<Scalars['String']['output']>;
  theaterMatcher: Maybe<Scalars['String']['output']>;
  entityMatcher: Maybe<Scalars['String']['output']>;
  parameters: Maybe<Scalars['String']['output']>;
};

/** A pager to a list of ImportConfiguration objects. */
export type ImportConfigurationPager = {
  /** The list of objects. */
  nodes: Array<ImportConfiguration>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type ImportRun = Node & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  configuration: ImportConfiguration;
  status: ImportRunStatus;
  startTime: Maybe<Scalars['DateTime']['output']>;
  endTime: Maybe<Scalars['DateTime']['output']>;
  stats: Maybe<ImportRunStats>;
  steps: Array<ImportRunStep>;
  /** The export file produced by GatherTimes */
  crawlExportFile: Maybe<Scalars['URL']['output']>;
  /** The movie file produced by GatherTimes */
  crawlMovieExportFile: Maybe<Scalars['URL']['output']>;
};

export enum ImportRunStatus {
  Started = 'STARTED',
  Failed = 'FAILED',
  Complete = 'COMPLETE',
  Cancelled = 'CANCELLED',
  NoShowtimes = 'NO_SHOWTIMES'
}

export type ImportRunStats = {
  totalShowtimes: Scalars['Int']['output'];
  insertedShowtimes: Scalars['Int']['output'];
  matchedShowtimes: Scalars['Int']['output'];
  removedShowtimes: Scalars['Int']['output'];
  unmatchedShowtimes: Scalars['Int']['output'];
  ignoredShowtimes: Scalars['Int']['output'];
  importedMovies: Scalars['Int']['output'];
  importedTheaters: Scalars['Int']['output'];
};

export type ImportRunStep = {
  name: Scalars['String']['output'];
  status: ImportRunStatus;
  error: Maybe<Scalars['String']['output']>;
  extra: Maybe<Scalars['JSON']['output']>;
};

/** A pager to a list of ImportRun objects. */
export type ImportRunPager = {
  /** The list of objects. */
  nodes: Array<ImportRun>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export enum ImportRunStepType {
  Gathertimes = 'gathertimes',
  PrepareFileSystem = 'prepareFileSystem',
  DiffCheck = 'diffCheck',
  Import = 'import',
  DbzImport = 'DBZImport',
  Publish = 'publish'
}

export type ImportConfigurationEntity = Company | Theater;

export type ImportConfigurationOrder = {
  /** The field to order by. */
  field: ImportConfigurationOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum ImportConfigurationOrderField {
  NextRun = 'NEXT_RUN',
  Crawler = 'CRAWLER',
  SourceId = 'SOURCE_ID'
}

/** A pager to a list of ImportCrawler objects. */
export type ImportCrawlerPager = {
  /** The list of objects. */
  nodes: Array<ImportCrawler>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type ImportCrawlerOrder = {
  /** The field to order by. */
  field: ImportCrawlerOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum ImportCrawlerOrderField {
  Name = 'NAME',
  CreatedAt = 'CREATED_AT'
}

/** The import wizard runs of a period, aggregated per widget; only the requested fields are computed. */
export type ImportWizardDashboard = {
  totals: ImportWizardDashboardTotals;
  /** The totals of the period of the same length just before. */
  previousTotals: ImportWizardDashboardTotals;
  running: ImportWizardDashboardRunning;
  perDay: Array<ImportWizardDashboardDay>;
  byLevel: Array<ImportWizardDashboardLevel>;
  byModel: Array<ImportWizardDashboardModel>;
  nothingReturned: Array<ImportWizardDashboardNothingReturned>;
  bySource: Array<ImportWizardDashboardSource>;
  byUser: Array<ImportWizardDashboardUser>;
};

/** The key figures of the runs launched in a period. */
export type ImportWizardDashboardTotals = {
  /** The runs launched. */
  launched: Scalars['Int']['output'];
  /** The runs that completed, whatever they answered. */
  completed: Scalars['Int']['output'];
  /** The runs that failed. */
  failed: Scalars['Int']['output'];
  /** The completed runs that returned credits. */
  answered: Scalars['Int']['output'];
  /** The answered runs whose answer came from the LLM or the browser level. */
  answeredAtLlmOrBrowser: Scalars['Int']['output'];
  /** The runs that called an LLM. */
  llmRuns: Scalars['Int']['output'];
  /** The runs whose roles localization answered. */
  localizedRuns: Scalars['Int']['output'];
  /** The runs whose roles localization failed. */
  localizationErrors: Scalars['Int']['output'];
  /** The LLM cost, in US dollars. */
  llmCostUsd: Scalars['Float']['output'];
  /** The LLM input tokens. */
  llmInputTokens: Scalars['Float']['output'];
  /** The LLM output tokens. */
  llmOutputTokens: Scalars['Float']['output'];
  /** The median duration of the completed runs; null without any. */
  durationMedianMs: Maybe<Scalars['Float']['output']>;
  /** The 95th percentile duration of the completed runs; null without any. */
  durationP95Ms: Maybe<Scalars['Float']['output']>;
  /** The cost of the roles localization calls, in US dollars; included in llmCostUsd. */
  localizationCostUsd: Scalars['Float']['output'];
  /** The input tokens of the roles localization calls. */
  localizationInputTokens: Scalars['Float']['output'];
  /** The output tokens of the roles localization calls. */
  localizationOutputTokens: Scalars['Float']['output'];
  /** The median duration of the roles localization step over the runs where it answered; null without any. */
  localizationDurationMedianMs: Maybe<Scalars['Float']['output']>;
};

/** The runs running now, whatever the period. */
export type ImportWizardDashboardRunning = {
  /** The runs within their 5-minute timeout, counted from their start, or from their launch if they never started. */
  active: Scalars['Int']['output'];
  /** The runs still RUNNING past their 5-minute timeout, counted from their start, or from their launch if they never started: their timeout job did not run, or they never started. */
  stale: Scalars['Int']['output'];
};

/** The runs launched on one day of the requested time zone; days without runs are left out. */
export type ImportWizardDashboardDay = {
  /** The day, as YYYY-MM-DD. */
  day: Scalars['String']['output'];
  /** The runs that completed. */
  completed: Scalars['Int']['output'];
  /** The runs that failed. */
  failed: Scalars['Int']['output'];
  /** The LLM cost, in US dollars. */
  llmCostUsd: Scalars['Float']['output'];
};

/** The answered runs of one answering level, most frequent first. */
export type ImportWizardDashboardLevel = {
  /** The level's name, such as `L1 api`. */
  level: Scalars['String']['output'];
  /** The number of runs. */
  runs: Scalars['Int']['output'];
  /** The median duration of these runs. */
  durationMedianMs: Scalars['Float']['output'];
};

/** The runs that called one LLM model, most frequent first. */
export type ImportWizardDashboardModel = {
  provider: Scalars['String']['output'];
  model: Scalars['String']['output'];
  /** The number of runs. */
  runs: Scalars['Int']['output'];
  /** The LLM cost, in US dollars. */
  llmCostUsd: Scalars['Float']['output'];
};

/** The runs that returned no credits for one reason, most frequent first. */
export type ImportWizardDashboardNothingReturned = {
  /** The outcome of a completed run (empty, blocked, error, unresolved) or the failure kind of a failed one, `unclassified` when it recorded none. */
  kind: Scalars['String']['output'];
  /** The number of runs. */
  runs: Scalars['Int']['output'];
};

/** The runs of one source, most frequent first. */
export type ImportWizardDashboardSource = {
  source: PersonCreditsImportSource;
  /** The number of runs. */
  runs: Scalars['Int']['output'];
};

/** The runs one user launched; the ten most active users, most active first. */
export type ImportWizardDashboardUser = {
  user: User;
  /** The number of runs. */
  runs: Scalars['Int']['output'];
};

/** A pager to a list of PersonCreditsImportReport objects. */
export type PersonCreditsImportReportPager = {
  /** The list of objects. */
  nodes: Array<PersonCreditsImportReport>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type ImportWizardReportFilter = {
  /** Launched at or after this instant. */
  from?: InputMaybe<Scalars['DateTime']['input']>;
  /** Launched strictly before this instant. */
  to?: InputMaybe<Scalars['DateTime']['input']>;
  source?: InputMaybe<PersonCreditsImportSource>;
  status?: InputMaybe<ImportWizardReportStatus>;
  outcome?: InputMaybe<ImportWizardOutcome>;
  /** The level that answered. */
  answeredBy?: InputMaybe<ImportWizardLevel>;
  entityType?: InputMaybe<ImportWizardEntityType>;
  /** The global id of the user who launched the run. */
  launchedById?: InputMaybe<Scalars['ID']['input']>;
};

export type ImportWizardReportOrder = {
  /** The field to order by. */
  field: ImportWizardReportOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum ImportWizardReportOrderField {
  LaunchedAt = 'LAUNCHED_AT',
  DurationMs = 'DURATION_MS',
  /** The LLM cost of the acquisition and of the roles localization together; runs without any last. */
  LlmCostUsd = 'LLM_COST_USD'
}

/** A pager to a list of IncompleteShowtimeSource objects. */
export type IncompleteShowtimeSourcePager = {
  /** The list of objects. */
  nodes: Array<IncompleteShowtimeSource>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type IncompleteShowtimeSource = {
  sourceName: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  showId: Maybe<Scalars['ID']['output']>;
  count: Scalars['Int']['output'];
  titles: Array<Scalars['String']['output']>;
  entityInfos: Maybe<IncompleteShowtimeEntityInfos>;
  entityInfosRaw: Maybe<Scalars['JSONObject']['output']>;
};

export type IncompleteShowtimeEntityInfos = {
  url: Maybe<Scalars['String']['output']>;
  images: Maybe<Array<Maybe<IncompleteShowtimeEntityInfosImage>>>;
  rating: Maybe<Scalars['String']['output']>;
  summary: Maybe<Scalars['String']['output']>;
  trailer: Maybe<Scalars['String']['output']>;
};

export type IncompleteShowtimeEntityInfosImage = {
  url: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  display: Maybe<Scalars['String']['output']>;
};

/** Filter status for incomplete showtime sources (entity list). */
export enum IncompleteMavenStatus {
  Todo = 'TODO',
  InProgressMavens = 'IN_PROGRESS_MAVENS'
}

/** Represents a BullMQ Job in the queue with its status and optional active job information */
export type JobType = {
  jobId: Scalars['String']['output'];
  state: JobState;
  jobTaskType: Maybe<JobTaskType>;
  progress: Maybe<Scalars['JSON']['output']>;
  data: Scalars['JSON']['output'];
  /** Job result (if completed) */
  result: Maybe<Scalars['JSON']['output']>;
  /** Failure reason (if failed) */
  failedReason: Maybe<Scalars['String']['output']>;
  /** Timestamp when the job started processing (as ISO string, only available when job is active) */
  processedOn: Maybe<Scalars['String']['output']>;
  /** Timestamp when the job was created (as ISO string, only available when job is active) */
  timestamp: Maybe<Scalars['String']['output']>;
};

/** State of a job in the queue */
export enum JobState {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Active = 'ACTIVE',
  Delayed = 'DELAYED',
  Prioritized = 'PRIORITIZED',
  Waiting = 'WAITING',
  WaitingChildren = 'WAITING_CHILDREN'
}

export enum JobTaskType {
  /** Scheduled AI batch matching of unknown products to entities */
  AiProductMatchingOrchestrator = 'aiProductMatchingOrchestrator',
  /** One batch of the AI product matching */
  AiProductMatchingBatch = 'aiProductMatchingBatch',
  /** Application of the redirection rules to the proxy */
  RedirectionRuleProxyBatch = 'redirectionRuleProxyBatch',
  /** ImportWizardAI: title resolution and the acquisition ladder of one cast and credits import */
  ImportWizardAcquire = 'importWizardAcquire',
  /** ImportWizardAI: reconciliation with DBZ, completion and publication of the report */
  ImportWizardFinalize = 'importWizardFinalize',
  /** Bestimage: search of a person's photos with a headless browser, previews kept for the editor */
  ImportWizardBestimageSearch = 'importWizardBestimageSearch',
  /** Bestimage: download of the photos an editor picked, added to the person's gallery */
  ImportWizardBestimageDownload = 'importWizardBestimageDownload',
  /** Push of News metadata and content to Polaris, the Webedia content hub */
  Polaris = 'polaris'
}

/** A pager to a list of JumpLink objects. */
export type JumpLinkPager = {
  /** The list of objects. */
  nodes: Array<JumpLink>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type JumpLink = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  sourceUrl: Scalars['String']['output'];
  targetDomainUrl: Scalars['String']['output'];
  generatedUrl: Scalars['String']['output'];
  company: Maybe<Company>;
  partner: Maybe<Scalars['String']['output']>;
  data: Maybe<Scalars['JSON']['output']>;
};

export type JumpLinkOrder = {
  /** The field to order by. */
  field: JumpLinkOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum JumpLinkOrderField {
  Id = 'ID',
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
  SourceUrl = 'SOURCE_URL',
  TargetDomainUrl = 'TARGET_DOMAIN_URL',
  Partner = 'PARTNER'
}

export type JumpPlatformDomain = {
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** A pager to a list of EntityLink objects. */
export type EntityLinkPager = {
  /** The list of objects. */
  nodes: Array<EntityLink>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type EntityLinkOrder = {
  /** The field to order by. */
  field: EntityLinkOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum EntityLinkOrderField {
  LinkType = 'LINK_TYPE',
  Rank = 'RANK'
}

/** A pager to a list of Locale objects. */
export type LocalePager = {
  /** The list of objects. */
  nodes: Array<Locale>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

/** A pager to a list of Localization objects. */
export type LocalizationPager = {
  /** The list of objects. */
  nodes: Array<Localization>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type MatchedProduct = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: ProductType;
  /** The URL of the product */
  url: Maybe<Scalars['URL']['output']>;
  linkedEntities: Array<MatchedProductEntity>;
};

export type MatchedProductEntity = Movie | SeriesEpisode | SeriesSeason | Series;

/** A pager to a list of MatchedProduct objects. */
export type MatchedProductPager = {
  /** The list of objects. */
  nodes: Array<MatchedProduct>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

/** A pager to a list of MatchedShowtimeEntity objects. */
export type MatchedShowtimeEntityPager = {
  /** The list of objects. */
  nodes: Array<MatchedShowtimeEntity>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type MatchedShowtimeEntity = {
  sourceName: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  entity: Entity;
};

/** A pager to a list of MatchedShowtimeTheater objects. */
export type MatchedShowtimeTheaterPager = {
  /** The list of objects. */
  nodes: Array<MatchedShowtimeTheater>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type MatchedShowtimeTheater = {
  sourceName: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  theater: Theater;
};

/** A pager to a list of Movie objects. */
export type MoviePager = {
  /** The list of objects. */
  nodes: Array<Movie>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type MovieOrder = {
  /** The field to order by. */
  field: MovieOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum MovieOrderField {
  Id = 'ID',
  Popularity = 'POPULARITY',
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
  Name = 'NAME',
  Score = 'SCORE',
  ProductionYear = 'PRODUCTION_YEAR'
}

export enum EntitySearchTypes {
  Keyword = 'KEYWORD',
  MultiTitle = 'MULTI_TITLE'
}

export enum EntitySearchOptions {
  Exact = 'EXACT',
  Wildcard = 'WILDCARD',
  Fuzzy = 'FUZZY'
}

export enum MovieSearchAlgorithm {
  Default = 'DEFAULT',
  ReleasesFirst = 'RELEASES_FIRST',
  ReleasesShowtimesFirst = 'RELEASES_SHOWTIMES_FIRST'
}

/** A pager to a list of News objects. */
export type NewsPager = {
  /** The list of objects. */
  nodes: Array<News>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type NewsOrder = {
  /** The field to order by. */
  field: NewsOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum NewsOrderField {
  /** Order news by ID. */
  Id = 'ID',
  /** Order news by publication date */
  PublicationDate = 'PUBLICATION_DATE',
  /** Order news by title. */
  Title = 'TITLE',
  /** Order news by updated_at. */
  UpdatedAt = 'UPDATED_AT',
  /** Order news by ES score. */
  Score = 'SCORE'
}

/** A crew job returned by the completed imports that no rule maps to an activity, per source and category: what to add, map or whitelist. */
export type PersonCreditsImportUnmappedJob = {
  source: PersonCreditsImportSource;
  /** The source's category or department, lower-cased. */
  category: Scalars['String']['output'];
  /** The job as the source first wrote it; empty when it gave none. */
  job: Scalars['String']['output'];
  /** The credits carrying this job, across every completed import. */
  occurrences: Scalars['Int']['output'];
  /** The entities whose imports carry this job. */
  entities: Scalars['Int']['output'];
  /** What the category alone gives the job, when the entity type allows it; null when the job gets no activity at all. */
  fallbackActivity: Maybe<PersonActivity>;
  /** The launch of the latest import carrying this job. */
  lastSeenAt: Scalars['DateTime']['output'];
};

/** A pager to a list of Person objects. */
export type PersonPager = {
  /** The list of objects. */
  nodes: Array<Person>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type PersonOrder = {
  /** The field to order by. */
  field: PersonOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum PersonOrderField {
  Id = 'ID',
  UpdatedAt = 'UPDATED_AT',
  BirthDate = 'BIRTH_DATE',
  DeathDate = 'DEATH_DATE',
  Name = 'NAME',
  Score = 'SCORE'
}

export enum PersonSearchAlgorithm {
  Default = 'DEFAULT',
  ClosestMatch = 'CLOSEST_MATCH'
}

/** A pager to a list of Preset objects. */
export type PresetPager = {
  /** The list of objects. */
  nodes: Array<Preset>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type PressReview = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** The associated brand. */
  brand: Brand;
  rating: Scalars['Int']['output'];
  author: Maybe<Scalars['String']['output']>;
  body: Maybe<Scalars['RichText']['output']>;
  snippet: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['URL']['output']>;
  company: Company;
  entity: PressReviewEntity;
};

export type PressReviewEntity = Movie | Series | SeriesSeason;

/** A pager to a list of PressReview objects. */
export type PressReviewPager = {
  /** The list of objects. */
  nodes: Array<PressReview>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type ProductSourceChannel = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  channel: Scalars['String']['output'];
  country: Country;
  stats: Maybe<ProductSourceChannelStats>;
};

export type ProductSourceChannelStats = {
  unmatchedTotal: Scalars['NonNegativeInt']['output'];
};

export type ProductSourceStats = {
  id: Scalars['ID']['output'];
  sourceName: Scalars['String']['output'];
  company: Maybe<Company>;
  /** The number of unmatched products related to this one */
  unmatchedTotal: Scalars['Int']['output'];
};

export type ProductTypeOption = {
  value: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type ProductDetail = {
  productId: Scalars['ID']['output'];
  countryId: Scalars['ID']['output'];
  country: Country;
  companyId: Scalars['ID']['output'];
  productType: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['String']['output']>;
  currency: Maybe<Scalars['String']['output']>;
  linkedEntities: Array<MatchedProductEntity>;
};

/** A pager to a list of Products objects. */
export type ProductsPager = {
  /** The list of objects. */
  nodes: Array<Products>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type Products = {
  productId: Scalars['ID']['output'];
  product: Product;
  /** The metadata of this entity. */
  metadata: Metadata;
  productType: Maybe<Scalars['String']['output']>;
  productName: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
  price: Maybe<Scalars['String']['output']>;
  currency: Maybe<Scalars['String']['output']>;
  /** Company (provider) for this product. */
  provider: Maybe<Company>;
  /** GraphQL global ID of the linked entity, for use in unlinkEntityFromProduct. */
  relatedEntityId: Scalars['ID']['output'];
};

export enum ProductEntityType {
  Unknown = 'UNKNOWN',
  Movie = 'MOVIE',
  Series = 'SERIES',
  Season = 'SEASON',
  Episode = 'EPISODE',
  SeriesSeason = 'SERIES_SEASON',
  SeriesEpisode = 'SERIES_EPISODE'
}

/** Filter by product origin (values match DBZ enum). Omit to show all origins. */
export enum ProductListOrigin {
  Legacy = 'LEGACY',
  Boxoffice = 'BOXOFFICE',
  Core = 'CORE',
  CoreImport = 'CORE_IMPORT',
  GraphAdmin = 'GRAPH_ADMIN',
  GraphApi = 'GRAPH_API',
  Test = 'TEST',
  WwmImport = 'WWM_IMPORT',
  Khronos = 'KHRONOS'
}

export type RedirectionRule = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  brand: Brand;
  /** Whether the rule redirects by entity global id or by URL pattern. */
  kind: RedirectionRuleKind;
  /** The HTTP redirection status code (301, 302, ...). */
  mode: RedirectionMode;
  /** Source URL or regexp matched by this rule (PATTERN kind). */
  sourcePattern: Maybe<Scalars['String']['output']>;
  /** Destination URL this rule redirects to (PATTERN kind). */
  targetPattern: Maybe<Scalars['String']['output']>;
  /** Source entity global id path matched by this rule (ENTITY kind). */
  sourceEntity: Maybe<Scalars['String']['output']>;
  /** Destination entity global id path this rule redirects to (ENTITY kind). */
  targetEntity: Maybe<Scalars['String']['output']>;
  /** Read from the Cloudflare bulk redirect list of the brand, cached for a minute. Always UNKNOWN for an ENTITY rule: resolving its URLs needs the www routing API, which is too costly for a list. */
  cloudflareState: RedirectionRuleCloudflareState;
  /** Start of the validity window (ISO UTC). */
  startAt: Maybe<Scalars['DateTimeISO']['output']>;
  /** End of the validity window (ISO UTC). */
  endAt: Maybe<Scalars['DateTimeISO']['output']>;
};

/** Whether the rule matches on entity global ids (ENTITY) or on URL patterns (PATTERN). */
export enum RedirectionRuleKind {
  Entity = 'ENTITY',
  Pattern = 'PATTERN'
}

/** The HTTP status code used for the redirection. */
export enum RedirectionMode {
  MovedPermanently = 'MOVED_PERMANENTLY',
  Found = 'FOUND',
  Gone = 'GONE'
}

/** Whether the rule is really served by Cloudflare right now: APPLIED and NOT_APPLICABLE are the settled states, MISSING and STALE mean the bulk redirect list has not caught up (or drifted), UNKNOWN that it could not be told. */
export enum RedirectionRuleCloudflareState {
  Applied = 'APPLIED',
  Missing = 'MISSING',
  NotApplicable = 'NOT_APPLICABLE',
  Stale = 'STALE',
  Unknown = 'UNKNOWN'
}

export type RedirectionRuleChainPlan = {
  /** The destination the rule will be saved with. */
  target: Scalars['String']['output'];
  /** Why the rule's own flattened destination may need another look, empty when it is not flattened. */
  warnings: Array<RedirectionChainWarning>;
  /** The other rules the save points straight at the end of their chain. */
  rewrites: Array<RedirectionRuleChainRewrite>;
  /** Pass it as `chainReviewToken` to apply exactly this plan. */
  reviewToken: Scalars['String']['output'];
};

/** Why a flattened rule may need another look: TEMPORARY_HOP, a skipped hop is a 302; INACTIVE_HOP, it is inactive; SCHEDULED_HOP, it has a start or end date. */
export enum RedirectionChainWarning {
  TemporaryHop = 'TEMPORARY_HOP',
  InactiveHop = 'INACTIVE_HOP',
  ScheduledHop = 'SCHEDULED_HOP'
}

/** A rule a save points straight at the end of its redirection chain. */
export type RedirectionRuleChainRewrite = {
  /** The stored rule, null for a rule the save creates. */
  rule: Maybe<RedirectionRule>;
  /** Position of the CSV row this rule comes from, null outside an import. */
  rowIndex: Maybe<Scalars['Int']['output']>;
  source: Scalars['String']['output'];
  previousTarget: Scalars['String']['output'];
  newTarget: Scalars['String']['output'];
  /** Sources crossed between the source and the new destination, in order. */
  path: Array<Scalars['String']['output']>;
  warnings: Array<RedirectionChainWarning>;
};

/** The HTTP status codes a redirection rule can be created or updated with: 301 (permanent) and 302 (temporary). */
export enum WritableRedirectionMode {
  MovedPermanently = 'MOVED_PERMANENTLY',
  Found = 'FOUND'
}

/** A pager to a list of RedirectionRule objects. */
export type RedirectionRulePager = {
  /** The list of objects. */
  nodes: Array<RedirectionRule>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

/** Filter status: ACTIVE/INACTIVE match the active flag; PLANNED matches rules that carry a start and/or end date. */
export enum RedirectionRuleStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Planned = 'PLANNED'
}

export type RedirectionRulesOrder = {
  /** The field to order by. */
  field: RedirectionRulesOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum RedirectionRulesOrderField {
  StartAt = 'START_AT',
  EndAt = 'END_AT'
}

export enum ReleasableEntityType {
  Movie = 'MOVIE',
  Series = 'SERIES',
  SeriesSeason = 'SERIES_SEASON',
  SeriesEpisode = 'SERIES_EPISODE'
}

export type Scope = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  name: Scalars['String']['output'];
  customer: Customer;
  /** A CustomerQuery linked to this scope */
  scopeCustomerQuery: ScopeCustomerQuery;
  /** A list of CustomerQuery linked to this scope */
  scopeCustomerQueries: ScopeCustomerQueryPager;
};


export type ScopeScopeCustomerQueryArgs = {
  scopeCustomerQueryId: Scalars['ID']['input'];
};


export type ScopeScopeCustomerQueriesArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents a CustomerQuery linked to a Scope */
export type ScopeCustomerQuery = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  alias: Scalars['String']['output'];
  config: QueryConfig;
  customerQuery: CustomerQuery;
  scope: Scope;
};

export type QueryConfig = {
  variables: Scalars['JSONObject']['output'];
  userVariables: Array<Maybe<Scalars['String']['output']>>;
};

/** A pager to a list of ScopeCustomerQuery objects. */
export type ScopeCustomerQueryPager = {
  /** The list of objects. */
  nodes: Array<ScopeCustomerQuery>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

/** A pager to a list of Scope objects. */
export type ScopePager = {
  /** The list of objects. */
  nodes: Array<Scope>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

/** A pager to a list of SearchEntity objects. */
export type SearchEntityPager = {
  /** The list of objects. */
  nodes: Array<SearchEntity>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type SearchEntity = Movie | Series | Slide | Company | CompanyStaff | Festival | News | Person | SeriesEpisode | SeriesSeason | Theater | VideoLegacy;

export type SearchEntityOrder = {
  /** The field to order by. */
  field: SearchEntityOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum SearchEntityOrderField {
  Id = 'ID',
  CreatedAt = 'CREATED_AT',
  Score = 'SCORE'
}

export enum SearchableEntityType {
  Company = 'COMPANY',
  CompanyStaff = 'COMPANY_STAFF',
  Festival = 'FESTIVAL',
  Movie = 'MOVIE',
  News = 'NEWS',
  Person = 'PERSON',
  Series = 'SERIES',
  SeriesSeason = 'SERIES_SEASON',
  SeriesEpisode = 'SERIES_EPISODE',
  Slide = 'SLIDE',
  Theater = 'THEATER',
  VideoLegacy = 'VIDEO_LEGACY'
}

export type SearchOptionsInput = {
  MOVIE?: InputMaybe<MovieArgsInput>;
  SERIES?: InputMaybe<SeriesArgsInput>;
  SLIDE?: InputMaybe<SlideArgsInput>;
  COMPANY?: InputMaybe<CompanyArgsInput>;
  COMPANY_STAFF?: InputMaybe<CompanyStaffArgsInput>;
  FESTIVAL?: InputMaybe<FestivalArgsInput>;
  NEWS?: InputMaybe<NewsArgsInput>;
  PERSON?: InputMaybe<PersonArgsInput>;
  SERIES_EPISODE?: InputMaybe<SeriesEpisodeArgsInput>;
  SERIES_SEASON?: InputMaybe<SeriesSeasonArgsInput>;
  THEATER?: InputMaybe<TheaterArgsInput>;
  VIDEO_LEGACY?: InputMaybe<VideoLegacyArgsInput>;
};

export type MovieArgsInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  productionYear?: InputMaybe<Scalars['Int']['input']>;
  directorId?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<MovieOrder>;
  type?: InputMaybe<MovieType>;
  searchIn?: InputMaybe<EntitySearchTypes>;
  searchSensitivity?: InputMaybe<EntitySearchOptions>;
  algorithm?: InputMaybe<MovieSearchAlgorithm>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type SeriesArgsInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
  genres?: InputMaybe<Array<Genre>>;
  orderBy?: InputMaybe<SeriesOrder>;
  algorithm?: InputMaybe<SeriesSearchAlgorithm>;
  searchIn?: InputMaybe<EntitySearchTypes>;
  searchSensitivity?: InputMaybe<EntitySearchOptions>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type SeriesOrder = {
  /** The field to order by. */
  field: SeriesOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum SeriesOrderField {
  Id = 'ID',
  Popularity = 'POPULARITY',
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
  Name = 'NAME',
  Score = 'SCORE',
  ReleaseDate = 'RELEASE_DATE'
}

export enum SeriesSearchAlgorithm {
  FuzzySearch = 'FUZZY_SEARCH'
}

export type SlideArgsInput = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  createdByUserId?: InputMaybe<Scalars['ID']['input']>;
  updatedByUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Search by ID, title or description */
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<SlideOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type SlideOrder = {
  /** The field to order by. */
  field: SlideOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum SlideOrderField {
  Id = 'ID',
  UpdatedAt = 'UPDATED_AT'
}

export type CompanyArgsInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  countryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  activities?: InputMaybe<Array<CompanyActivity>>;
  additionalTags?: InputMaybe<Array<CompanyAdditionalTag>>;
  orderBy?: InputMaybe<CompanyOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyStaffArgsInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<CompanyStaffOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
};

export type FestivalArgsInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  countryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderBy?: InputMaybe<FestivalOrder>;
  themes?: InputMaybe<Array<FestivalTheme>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type NewsArgsInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<NewsType>;
  universes?: InputMaybe<Array<InputMaybe<NewsUniverse>>>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  authorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  relatedEntityId?: InputMaybe<Scalars['ID']['input']>;
  tagId?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<NewsOrder>;
  range?: InputMaybe<DateRangeInput>;
  publicationStatus?: InputMaybe<EntityPublicationStatus>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonArgsInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<PersonOrder>;
  activities?: InputMaybe<Array<InputMaybe<PersonActivity>>>;
  algorithm?: InputMaybe<PersonSearchAlgorithm>;
  searchIn?: InputMaybe<EntitySearchTypes>;
  searchSensitivity?: InputMaybe<EntitySearchOptions>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type SeriesEpisodeArgsInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<SeriesEpisodeOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type SeriesEpisodeOrder = {
  /** The field to order by. */
  field: SeriesEpisodeOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum SeriesEpisodeOrderField {
  Id = 'ID',
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  Score = 'SCORE'
}

export type SeriesSeasonArgsInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<SeriesSeasonOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type SeriesSeasonOrder = {
  /** The field to order by. */
  field: SeriesSeasonOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum SeriesSeasonOrderField {
  Id = 'ID',
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  Score = 'SCORE'
}

export type TheaterArgsInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  countryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  localizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  theaterOpeningStatuses?: InputMaybe<Array<TheaterOpeningStatus>>;
  showtimeSources?: InputMaybe<Array<TheaterShowtimeSource>>;
  orderBy?: InputMaybe<TheaterOrder>;
  showtimesGatheringMethod?: InputMaybe<Array<TheaterShowtimesGatheringMethod>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type TheaterOrder = {
  /** The field to order by. */
  field: TheaterOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum TheaterOrderField {
  Id = 'ID',
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  Score = 'SCORE'
}

export type VideoLegacyArgsInput = {
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<VideoType>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  universes?: InputMaybe<Array<InputMaybe<VideoUniverse>>>;
  orderBy?: InputMaybe<VideoOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type VideoOrder = {
  /** The field to order by. */
  field: VideoOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum VideoOrderField {
  /** Order video by ID. */
  Id = 'ID',
  /** Order video by title. */
  Title = 'TITLE',
  /** Order video by updated_at. */
  UpdatedAt = 'UPDATED_AT',
  /** Order video by rank. */
  Rank = 'RANK',
  /** Order video by ES score. */
  Score = 'SCORE'
}

/** A pager to a list of Series objects. */
export type SeriesPager = {
  /** The list of objects. */
  nodes: Array<Series>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type Showtime = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The start date of the showtime (the hour is about the theater). */
  startsAt: Scalars['DateTime']['output'];
  projection: Maybe<Array<Maybe<Scalars['Tag3D']['output']>>>;
  /** Ticketing URLs */
  ticketing: Maybe<Array<Maybe<Scalars['URL']['output']>>>;
};


export type ShowtimeTicketingArgs = {
  platform?: InputMaybe<Platform>;
  provider?: InputMaybe<Scalars['String']['input']>;
};

export enum Platform {
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE'
}

export type ShowtimeEntitySuggestion = {
  entity: Entity;
  score: Scalars['Float']['output'];
};

/** A pager to a list of Showtime objects. */
export type ShowtimePager = {
  /** The list of objects. */
  nodes: Array<Showtime>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

/** A pager to a list of Slide objects. */
export type SlidePager = {
  /** The list of objects. */
  nodes: Array<Slide>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

/** A pager to a list of SocialUser objects. */
export type SocialUserPager = {
  /** The list of objects. */
  nodes: Array<SocialUser>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type SpecialOperation = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  entity: Maybe<SpecialOperationEntity>;
  targets: Array<SpecialOperationTarget>;
  code: SpecialOperationCode;
  startsAt: Scalars['DateTimeWithoutTz']['output'];
  endsAt: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  /** Dot paths of the data fields required for activation that are missing or invalid. An update that leaves any of them missing deactivates the operation, and activating it is refused while any is missing. */
  missingRequiredFields: Array<Scalars['String']['output']>;
  data: SpecialOperationData;
  displayShowtimes: Maybe<Scalars['Boolean']['output']>;
  link: Maybe<Scalars['String']['output']>;
  slots: Array<TicketAnchorSlot>;
  medias: Maybe<SpecialOperationMedia>;
  name: Maybe<Scalars['String']['output']>;
};


export type SpecialOperationTargetsArgs = {
  target?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
};

/** An entity that can be linked to a special operation */
export type SpecialOperationEntity = Company | Movie | News | Series | SeriesSeason | Slide;

export type SpecialOperationTarget = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  entity: Maybe<Entity>;
  rank: Scalars['NonNegativeInt']['output'];
  target: Maybe<Scalars['Tag3D']['output']>;
  startsAt: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  endsAt: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  data: Scalars['JSONObject']['output'];
};

export type SpecialOperationData = BannerHpData | CanalHomeData | ClassiqueHomeData | Club300Data | DisneyHomeData | DolbyHomeData | EmergenceMovieData | EmergenceSeriesData | EmergenceSvodData | EmergenceTheaterData | FestivalSectionData | FilmesOnlineData | ImaxHomeData | IndelebileHomeData | M6HomeData | MaxHomeData | MobileDdayData | NovelasHomeData | RollerHomeData | SponsoredAutocompleteData | Tf1HomeData | TicketAnchorData | VodHomeData;

export type BannerHpData = {
  link_desktop: Maybe<Scalars['URL']['output']>;
  link_mobile: Maybe<Scalars['URL']['output']>;
  medias: Maybe<BannerHpDataMedias>;
};

export type BannerHpDataMedias = {
  desktop: Maybe<Scalars['URL']['output']>;
  mobile: Maybe<Scalars['URL']['output']>;
};

export type CanalHomeData = {
  heading1: Maybe<Scalars['String']['output']>;
  heading2: Maybe<Scalars['String']['output']>;
  heading3: Maybe<Scalars['String']['output']>;
};

export type ClassiqueHomeData = {
  heading1: Maybe<Scalars['String']['output']>;
  heading2: Maybe<Scalars['String']['output']>;
  heading3: Maybe<Scalars['String']['output']>;
  link1_label: Maybe<Scalars['String']['output']>;
  link1_url: Maybe<Scalars['URL']['output']>;
  link2_label: Maybe<Scalars['String']['output']>;
  link2_url: Maybe<Scalars['URL']['output']>;
};

export type Club300Data = {
  _placeholder: Maybe<Scalars['Boolean']['output']>;
};

export type DisneyHomeData = {
  medias: Maybe<DisneyHomeDataMedias>;
};

export type DisneyHomeDataMedias = {
  native_grand_angle: Maybe<DisneyHomeDataMediasNativeGrandAngle>;
};

export type DisneyHomeDataMediasNativeGrandAngle = {
  image_url: Maybe<Scalars['URL']['output']>;
  url: Maybe<Scalars['URL']['output']>;
};

export type DolbyHomeData = {
  _placeholder: Maybe<Scalars['Boolean']['output']>;
};

export type EmergenceMovieData = {
  distribution: Maybe<EmergenceDistribution>;
  provider: Maybe<SvodProvider>;
  release_date: Maybe<Scalars['DateTimeISO8601']['output']>;
};

/** Where an EMERGENCE_MOVIE film is released */
export enum EmergenceDistribution {
  Streaming = 'STREAMING',
  Theater = 'THEATER'
}

export enum SvodProvider {
  AmazonPrime = 'AMAZON_PRIME',
  Appletv = 'APPLETV',
  Canalplay = 'CANALPLAY',
  Disney = 'DISNEY',
  Filmotv = 'FILMOTV',
  Globoplay = 'GLOBOPLAY',
  LionsgatePlus = 'LIONSGATE_PLUS',
  Madelen = 'MADELEN',
  Max = 'MAX',
  Movistar = 'MOVISTAR',
  Mubi = 'MUBI',
  Mycanal = 'MYCANAL',
  Netflix = 'NETFLIX',
  Ocs = 'OCS',
  ParamountplusPvc = 'PARAMOUNTPLUS_PVC',
  Salto = 'SALTO',
  SfrPlay = 'SFR_PLAY',
  Sky = 'SKY',
  Skyshowtime = 'SKYSHOWTIME',
  StarPlus = 'STAR_PLUS',
  Starzplay = 'STARZPLAY',
  Telecine = 'TELECINE',
  Tf1Plus = 'TF1PLUS'
}

export type EmergenceSeriesData = {
  provider: Maybe<SvodProvider>;
  release_date: Maybe<Scalars['DateTimeISO8601']['output']>;
};

export type EmergenceSvodData = {
  provider: Maybe<SvodProvider>;
  release_date: Maybe<Scalars['DateTimeISO8601']['output']>;
};

export type EmergenceTheaterData = {
  release_date: Maybe<Scalars['DateTimeISO8601']['output']>;
};

export type FestivalSectionData = {
  festivalEditionId: Maybe<Scalars['Int']['output']>;
  festivalId: Maybe<Scalars['Int']['output']>;
  playlist: Maybe<Array<Maybe<FestivalSectionDataPlaylistEntry>>>;
};

export type FestivalSectionDataPlaylistEntry = {
  key: Scalars['String']['output'];
  value: Maybe<FestivalSectionDataPlaylistValue>;
};

export type FestivalSectionDataPlaylistValue = {
  movies: Maybe<Array<Scalars['Int']['output']>>;
  series: Maybe<Array<Scalars['Int']['output']>>;
};

export type FilmesOnlineData = {
  heading1: Maybe<Scalars['String']['output']>;
  heading2: Maybe<Scalars['String']['output']>;
  heading3: Maybe<Scalars['String']['output']>;
  heading4: Maybe<Scalars['String']['output']>;
  heading5: Maybe<Scalars['String']['output']>;
  heading6: Maybe<Scalars['String']['output']>;
  heading7: Maybe<Scalars['String']['output']>;
  heading8: Maybe<Scalars['String']['output']>;
  heading9: Maybe<Scalars['String']['output']>;
  heading10: Maybe<Scalars['String']['output']>;
};

export type ImaxHomeData = {
  _placeholder: Maybe<Scalars['Boolean']['output']>;
};

export type IndelebileHomeData = {
  heading1: Maybe<Scalars['String']['output']>;
  heading2: Maybe<Scalars['String']['output']>;
  heading3: Maybe<Scalars['String']['output']>;
};

export type M6HomeData = {
  heading1: Maybe<Scalars['String']['output']>;
  heading2: Maybe<Scalars['String']['output']>;
  heading3: Maybe<Scalars['String']['output']>;
};

export type MaxHomeData = {
  heading1: Maybe<Scalars['String']['output']>;
  heading2: Maybe<Scalars['String']['output']>;
  heading3: Maybe<Scalars['String']['output']>;
};

export type MobileDdayData = {
  dday_campaign: Maybe<Scalars['String']['output']>;
  dday_movie_id: Maybe<Scalars['Int']['output']>;
  dday_movie_list_id: Maybe<Array<Scalars['Int']['output']>>;
  dday_movie_list_title: Maybe<Scalars['String']['output']>;
  dday_force_uppercase_headers: Maybe<Scalars['Boolean']['output']>;
  dday_nav_background_color_light: Maybe<Scalars['String']['output']>;
  dday_nav_background_color_dark: Maybe<Scalars['String']['output']>;
  dday_nav_font_color_light: Maybe<Scalars['String']['output']>;
  dday_nav_font_color_dark: Maybe<Scalars['String']['output']>;
  dday_main_color_light: Maybe<Scalars['String']['output']>;
  dday_main_color_dark: Maybe<Scalars['String']['output']>;
  dday_title_spacing_between_letters: Maybe<Scalars['Float']['output']>;
  dday_title_see_more_title_displayed: Maybe<Scalars['Boolean']['output']>;
  dday_background_color: Maybe<Scalars['String']['output']>;
  dday_force_theme_light: Maybe<Scalars['Boolean']['output']>;
  dday_force_theme_dark: Maybe<Scalars['Boolean']['output']>;
  dday_status_bar_icons_light: Maybe<Scalars['Boolean']['output']>;
  dday_status_bar_icons_dark: Maybe<Scalars['Boolean']['output']>;
  dday_segmented_color_light: Maybe<Scalars['String']['output']>;
  dday_segmented_color_dark: Maybe<Scalars['String']['output']>;
  dday_segmented_selected_font_color_light: Maybe<Scalars['String']['output']>;
  dday_segmented_selected_font_color_dark: Maybe<Scalars['String']['output']>;
  dday_date: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  dday_last_date: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  dday_assets_version: Maybe<Scalars['Int']['output']>;
  dday_assets_hash: Maybe<Scalars['String']['output']>;
  dday_font_url: Maybe<Scalars['URL']['output']>;
  dday_font_size: Maybe<Scalars['Int']['output']>;
  dday_movie_background_url: Maybe<Scalars['URL']['output']>;
  dday_movie_background_id: Maybe<Scalars['ID']['output']>;
  dday_movie_logo_url: Maybe<Scalars['URL']['output']>;
  dday_movie_logo_id: Maybe<Scalars['ID']['output']>;
  dday_splash_background_url: Maybe<Scalars['URL']['output']>;
  dday_splash_background_id: Maybe<Scalars['ID']['output']>;
  dday_splash_logo_url: Maybe<Scalars['URL']['output']>;
  dday_splash_logo_id: Maybe<Scalars['ID']['output']>;
  dday_splashscreen_status_bar_color_style: Maybe<Scalars['String']['output']>;
  dday_splashscreen_activity_color: Maybe<Scalars['String']['output']>;
};

export type NovelasHomeData = {
  _placeholder: Maybe<Scalars['Boolean']['output']>;
};

export type RollerHomeData = {
  title: Maybe<Scalars['String']['output']>;
};

export type SponsoredAutocompleteData = {
  release_date: Maybe<Scalars['DateTimeISO8601']['output']>;
};

export type Tf1HomeData = {
  heading1: Maybe<Scalars['String']['output']>;
  heading2: Maybe<Scalars['String']['output']>;
  heading3: Maybe<Scalars['String']['output']>;
};

export type TicketAnchorData = {
  cta_text_after_release: Maybe<Scalars['String']['output']>;
  cta_text_before_release: Maybe<Scalars['String']['output']>;
  display_showtimes: Maybe<Scalars['Boolean']['output']>;
  link: Maybe<Scalars['URL']['output']>;
  medias: Maybe<SpecialOpsMedias>;
  release_date: Maybe<Scalars['DateTimeISO8601']['output']>;
  slots: Maybe<Array<TicketAnchorSlot>>;
  text_after_release: Maybe<Scalars['String']['output']>;
  text_before_release: Maybe<Scalars['String']['output']>;
  text_color: Maybe<Scalars['String']['output']>;
};

export type SpecialOpsMedias = {
  desktop: Maybe<Scalars['URL']['output']>;
  desktopHp: Maybe<Scalars['URL']['output']>;
  mobile: Maybe<Scalars['URL']['output']>;
};

export type VodHomeData = {
  heading1: Maybe<Scalars['String']['output']>;
  heading2: Maybe<Scalars['String']['output']>;
};

export type SpecialOperationMedia = SpecialOpsMedias;

/** A pager to a list of SpecialOperation objects. */
export type SpecialOperationPager = {
  /** The list of objects. */
  nodes: Array<SpecialOperation>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

/** A pager to a list of Tag objects. */
export type TagPager = {
  /** The list of objects. */
  nodes: Array<Tag>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type TagOrder = {
  /** The field to order by. */
  field: TagOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum TagOrderField {
  /** Order tag by ID. */
  Id = 'ID',
  /** Order tag by update date. */
  UpdatedAt = 'UPDATED_AT'
}

/** A pager to a list of Team objects. */
export type TeamPager = {
  /** The list of objects. */
  nodes: Array<Team>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type TemporalBoxoffice = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  country: Country;
  movie: Movie;
  type: BoxofficePeriod;
  value: Maybe<Scalars['NonNegativeInt']['output']>;
  cumulative: Maybe<Scalars['NonNegativeInt']['output']>;
  unit: BoxofficeUnit;
  range: DateRange;
  copyCount: Maybe<Scalars['Int']['output']>;
  estimate: Maybe<Scalars['PositiveInt']['output']>;
};

export enum BoxofficePeriod {
  Day = 'DAY',
  Week = 'WEEK',
  Weekend = 'WEEKEND'
}

export enum BoxofficeUnit {
  Count = 'COUNT',
  Eur = 'EUR',
  Usd = 'USD'
}

/** A pager to a list of TemporalBoxoffice objects. */
export type TemporalBoxofficePager = {
  /** The list of objects. */
  nodes: Array<TemporalBoxoffice>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export enum RangeOperator {
  /** Search into the current range. */
  Include = 'INCLUDE',
  /** Search all range lower than current range. */
  Lower = 'LOWER'
}

export type TemporalBoxofficeOrder = {
  /** The field to order by. */
  field: TemporalBoxofficeOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum TemporalBoxofficeOrderField {
  Date = 'DATE',
  Total = 'TOTAL'
}

export type TheaterEvent = Node & Entity & Ref & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  kind: Maybe<TheaterEventKind>;
  type: Maybe<Scalars['String']['output']>;
  /** Other IDs from external source to represent the screen. */
  externalIDs: Array<ExternalId>;
  /** The metadata of this entity. */
  metadata: Metadata;
  title: Scalars['String']['output'];
  synopsis: Maybe<Scalars['String']['output']>;
  trailer: Maybe<Scalars['String']['output']>;
  startsAt: Maybe<Scalars['DateTime']['output']>;
  releaseDate: Maybe<Scalars['DateTime']['output']>;
  releaseStatus: TheaterEventReleaseStatus;
  genres: Array<Genre>;
  runtime: Maybe<Runtime>;
  directors: Maybe<Array<Scalars['String']['output']>>;
  casting: Maybe<Array<Scalars['String']['output']>>;
  originCountry: Maybe<Country>;
  poster: Maybe<Image>;
  certificate: Maybe<Certificate>;
  ownerEntity: TheaterEventOwnerEntity;
  targetEntityLinks: Maybe<TheaterEventHasEntityPager>;
};


export type TheaterEventExternalIDsArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
};

export enum TheaterEventKind {
  CustomMovie = 'CUSTOM_MOVIE',
  GenericEvent = 'GENERIC_EVENT'
}

export enum TheaterEventReleaseStatus {
  Upcoming = 'UPCOMING',
  Released = 'RELEASED',
  Unscheduled = 'UNSCHEDULED'
}

export type TheaterEventOwnerEntity = Theater | Company;

/** A pager to a list of TheaterEventHasEntity objects. */
export type TheaterEventHasEntityPager = {
  /** The list of objects. */
  nodes: Array<TheaterEventHasEntity>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type TheaterEventHasEntity = Node & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  event: TheaterEvent;
  entity: TheaterEventTargetEntity;
};

export type TheaterEventTargetEntity = Movie;

export type TheaterFeed = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  title: Scalars['String']['output'];
  body: Scalars['String']['output'];
  startsAt: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  startsDisplayAt: Scalars['DateTimeWithoutTz']['output'];
  endsAt: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  endsDisplayAt: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  type: TheaterFeedType;
  theater: Theater;
  image: Maybe<Image>;
};

export enum TheaterFeedType {
  Cycle = 'CYCLE',
  Preview = 'PREVIEW',
  PreviewWithMovieTeam = 'PREVIEW_WITH_MOVIE_TEAM',
  SpecialOffer = 'SPECIAL_OFFER',
  Various = 'VARIOUS'
}

/** A pager to a list of TheaterFeed objects. */
export type TheaterFeedPager = {
  /** The list of objects. */
  nodes: Array<TheaterFeed>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

/** A pager to a list of Theater objects. */
export type TheaterPager = {
  /** The list of objects. */
  nodes: Array<Theater>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

/** A pager to a list of TheaterEvent objects. */
export type TheaterEventPager = {
  /** The list of objects. */
  nodes: Array<TheaterEvent>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type TheaterEventOrder = {
  /** The field to order by. */
  field: TheaterEventOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum TheaterEventOrderField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
  ReleaseDate = 'RELEASE_DATE'
}

/** A pager to a list of TheaterShowtime objects. */
export type TheaterShowtimePager = {
  /** The list of objects. */
  nodes: Array<TheaterShowtime>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type TheaterShowtime = {
  theater: Theater;
  showtimes: Array<Showtime>;
};

export type Token = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  uuid: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  lastCheckedAt: Scalars['DateTime']['output'];
  application: Maybe<Application>;
  user: Maybe<SocialUser>;
  scope: Maybe<Scope>;
  token: Scalars['JWT']['output'];
  comment: Maybe<Scalars['String']['output']>;
};

/** A pager to a list of Token objects. */
export type TokenPager = {
  /** The list of objects. */
  nodes: Array<Token>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type TokenOrder = {
  /** The field to order by. */
  field: TokenOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum TokenOrderField {
  Id = 'ID',
  CreatedAt = 'CREATED_AT',
  ExpiresAt = 'EXPIRES_AT',
  LastCheckedAt = 'LAST_CHECKED_AT'
}

/** A pager to a list of Trivia objects. */
export type TriviaPager = {
  /** The list of objects. */
  nodes: Array<Trivia>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

/** A pager to a list of UnknownProduct objects. */
export type UnknownProductPager = {
  /** The list of objects. */
  nodes: Array<UnknownProduct>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type UnknownProduct = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The title of the product. */
  title: Scalars['String']['output'];
  /** The type of the product. */
  type: Scalars['String']['output'];
  /** The type of entity the product is linked to. UNKNOWN when entity type is abstract (not yet linked to movie, series, season, or episode). */
  entityType: ProductEntityType;
  /** The product id in the source reference system */
  sourceId: Scalars['String']['output'];
  /** The source of this product */
  source: ProductSource;
  /** Channel associated to particular sources such as amazon prime (embed of other channels) */
  sourceChannelName: Maybe<Scalars['String']['output']>;
  /** The url of the product */
  url: Maybe<Scalars['URL']['output']>;
  /** The url of the product's image */
  imageUrl: Maybe<Scalars['URL']['output']>;
  sourceData: Scalars['String']['output'];
  matchingData: MatchingData;
};

export type MatchingData = {
  title: Maybe<Scalars['String']['output']>;
  actors: Array<Scalars['String']['output']>;
  directors: Array<Scalars['String']['output']>;
  seasonNumber: Maybe<Scalars['Int']['output']>;
  episodeNumber: Maybe<Scalars['Int']['output']>;
  episodeTitle: Maybe<Scalars['String']['output']>;
  releasedAt: Maybe<Scalars['PartialDate']['output']>;
  releasedAtTime: Maybe<Scalars['TimeWithoutTz']['output']>;
  unreleasedAt: Maybe<Scalars['Date']['output']>;
  info: Maybe<Scalars['JSON']['output']>;
  productionYear: Maybe<Scalars['Int']['output']>;
  runtime: Maybe<Scalars['Int']['output']>;
};

/** A pager to a list of UnmatchedMovie objects. */
export type UnmatchedMoviePager = {
  /** The list of objects. */
  nodes: Array<UnmatchedMovie>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type UnmatchedMovie = {
  sourceName: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  title: Maybe<Scalars['String']['output']>;
  data: Scalars['JSONObject']['output'];
};

/** A pager to a list of UnmatchedTheater objects. */
export type UnmatchedTheaterPager = {
  /** The list of objects. */
  nodes: Array<UnmatchedTheater>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type UnmatchedTheater = {
  sourceName: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  data: Scalars['JSONObject']['output'];
};

export type UserRating = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** The associated brand. */
  brand: Brand;
  rating: Scalars['Int']['output'];
  entity: UserRatingEntity;
  review: Maybe<UserReview>;
  user: SocialUser;
};

export type UserRatingEntity = Movie | Series | SeriesSeason | SeriesEpisode;

export type UserReview = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** The associated brand. */
  brand: Brand;
  status: UserReviewStatus;
  body: Scalars['String']['output'];
  stats: UserReviewStats;
};

export enum UserReviewStatus {
  Accepted = 'ACCEPTED',
  BeingChecked = 'BEING_CHECKED',
  Blocked = 'BLOCKED',
  Denied = 'DENIED',
  MustBeChecked = 'MUST_BE_CHECKED',
  Pending = 'PENDING',
  Published = 'PUBLISHED',
  Reported = 'REPORTED'
}

export type UserReviewStats = {
  rating: Maybe<Scalars['Int']['output']>;
  wilsonScore: Maybe<Scalars['Float']['output']>;
  helpfulCount: Maybe<Scalars['Int']['output']>;
  unhelpfulCount: Maybe<Scalars['Int']['output']>;
};

/** A pager to a list of UserRating objects. */
export type UserRatingPager = {
  /** The list of objects. */
  nodes: Array<UserRating>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export enum SocialRatingsEntityType {
  Movie = 'MOVIE',
  Series = 'SERIES',
  SeriesSeason = 'SERIES_SEASON',
  SeriesEpisode = 'SERIES_EPISODE'
}

export type SocialRatingsOrder = {
  /** The field to order by. */
  field: SocialRatingsOrderField;
  /** The ordering direction. */
  direction: OrderDirection;
};

export enum SocialRatingsOrderField {
  Id = 'ID',
  Rating = 'RATING',
  MetadataCreatedAt = 'METADATA_CREATED_AT',
  MetadataUpdatedAt = 'METADATA_UPDATED_AT'
}

/** A pager to a list of User objects. */
export type UserPager = {
  /** The list of objects. */
  nodes: Array<User>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

/** A pager to a list of VideoLegacy objects. */
export type VideoLegacyPager = {
  /** The list of objects. */
  nodes: Array<VideoLegacy>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

/** A pager to a list of EntityHasVideo objects. */
export type EntityHasVideoPager = {
  /** The list of objects. */
  nodes: Array<EntityHasVideo>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type EntityHasVideo = {
  video: Video;
  rank: Scalars['NonNegativeInt']['output'];
};

/** A pager to a list of Widget objects. */
export type WidgetPager = {
  /** The list of objects. */
  nodes: Array<Widget>;
  /** The total number of objects in this list. */
  totalCount: Scalars['NonNegativeInt']['output'];
};

export type Widget = Node & Ref & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The name of the widget. */
  name: Scalars['String']['output'];
  /** The type of the widget. */
  type: WidgetType;
  /** The url of the widget. */
  url: Maybe<Scalars['String']['output']>;
};

export enum WidgetType {
  Metabase = 'METABASE',
  Custom = 'CUSTOM'
}

export type Wysiwyg = {
  wellKnownRoutes: Array<WellKnownWebsiteRoute>;
  wellKnownRoute: Maybe<WellKnownWebsiteRoute>;
};


export type WysiwygWellKnownRoutesArgs = {
  brandId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
};


export type WysiwygWellKnownRouteArgs = {
  brandId: Scalars['ID']['input'];
  route: Scalars['String']['input'];
  params: Array<InputMaybe<WebsiteRouteParamInput>>;
};

export type WellKnownWebsiteRoute = {
  name: Scalars['String']['output'];
  params: Array<WebsiteRouteParam>;
  title: Scalars['String']['output'];
  type: WellKnownWebsiteRouteType;
  mainParam: Scalars['String']['output'];
  entity: WellKnownWebsiteRouteEntity;
};

export type WebsiteRouteParam = {
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum WellKnownWebsiteRouteType {
  Company = 'COMPANY',
  Movie = 'MOVIE',
  News = 'NEWS',
  Person = 'PERSON',
  Season = 'SEASON',
  Series = 'SERIES',
  GenericUniverse = 'GENERIC_UNIVERSE'
}

export type WellKnownWebsiteRouteEntity = Company | Movie | News | Person | SeriesSeason | Series;

export type WebsiteRouteParamInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Mutation = {
  addActorToEntity: Maybe<PersonCredits>;
  addCompanyToEntity: Maybe<EntityCompany>;
  addCreditToEntity: Maybe<PersonCredits>;
  addCreditsToEntity: Array<PersonCredits>;
  addDuplicate: Maybe<Duplicate>;
  addEntityToTag: Maybe<EntityTag>;
  addEntityToTheaterEvent: Maybe<TheaterEventHasEntity>;
  addFare: Maybe<Fare>;
  addImageToCategory: Maybe<ImageHasCategory>;
  addImageToCompany: Maybe<ImageReference>;
  addImageToScreen: Maybe<ImageReference>;
  addImageToTheater: Maybe<ImageReference>;
  addLocalizedActorToEntity: Maybe<EntityHasPersonLocalized>;
  addPersonNickname: Maybe<PersonNickname>;
  addReleaseToEntity: Maybe<EntityRelease>;
  addSlide: Maybe<CarouselHasSlide>;
  addTargetToSpecialOperation: Maybe<SpecialOperation>;
  addTemporalBoxoffice: Maybe<TemporalBoxoffice>;
  addTheaterEvent: Maybe<TheaterEvent>;
  addToken: Maybe<Token>;
  addTriviaToEntity: Maybe<EntityTrivia>;
  applyCastingToEntity: Maybe<Array<PersonCredits>>;
  applyCreditToEntity: Maybe<Array<PersonCredits>>;
  batchCreateSeriesEpisodes: Maybe<Array<SeriesEpisode>>;
  batchCreateSeriesSeasons: Maybe<Array<SeriesSeason>>;
  batchImportConfigurationOperation: Maybe<ImportConfiguration>;
  /** Cancels a running import: it is kept as failed, cancelled by you, its jobs are dropped, and a new one can be launched. */
  cancelImport: Scalars['ID']['output'];
  copyFestivalEdition: Maybe<FestivalEdition>;
  copyMovieBrandedDataToLocalizedData: Maybe<MovieLocaleData>;
  createActitoProfile: Maybe<SocialUser>;
  createApplication: Maybe<Application>;
  createAuthor: Maybe<Author>;
  createAuthorSignature: Maybe<AuthorSignature>;
  createBrandSearchLink: Maybe<BrandSearchLink>;
  createRedirectionRule: Maybe<RedirectionRule>;
  createCarousel: Maybe<Carousel>;
  createCertificate: Maybe<Certificate>;
  createClocks: Maybe<Array<Maybe<Clock>>>;
  createCompany: Maybe<Company>;
  createCompanyStaff: Maybe<CompanyStaff>;
  createCopyright: Maybe<Copyright>;
  createCustomer: Maybe<Customer>;
  createCustomerQuery: Maybe<CustomerQuery>;
  createEditorialReview: Maybe<EditorialReview>;
  createEntityPublication: Maybe<PublishableEntity>;
  createFestival: Maybe<Festival>;
  createFestivalAward: Maybe<FestivalAward>;
  createFestivalCompetition: FestivalCompetition;
  createFestivalEdition: Maybe<FestivalEdition>;
  createFestivalEditionCompetition: Maybe<FestivalEditionCompetition>;
  /** Mutation to create a new festival jury and assign a person to a specific role within a festival competition. */
  createFestivalJury: Maybe<FestivalJury>;
  createFestivalSelection: Maybe<FestivalSelection>;
  /** Return required payload to actually upload a file on a storage type (generally a bucket). An origin HTTP header is required to securse the upload */
  createFileUploadToken: Maybe<FileUploadTokenPayload>;
  createImage: Maybe<CreateImagePayload>;
  createImageCategory: Maybe<ImageCategory>;
  createImportConfiguration: Maybe<ImportConfiguration>;
  createImportConfigurationsFromCSV: Maybe<Scalars['Int']['output']>;
  createImportCrawler: Maybe<ImportCrawler>;
  createLocalCertificate: Maybe<EntityLocalRelease>;
  createLocale: Maybe<Locale>;
  createMovie: Maybe<Movie>;
  createMovieVersion: Maybe<MovieVersion>;
  createNews: Maybe<News>;
  createNewsPage: Maybe<NewsPage>;
  createPerson: Maybe<Person>;
  createPreset: Maybe<Preset>;
  createPressReview: Maybe<PressReview>;
  createProduct: CreateProductPayload;
  createScope: Maybe<Scope>;
  createScreen: Maybe<Screen>;
  createScreens: Maybe<Array<Screen>>;
  createSeries: Maybe<Series>;
  createSeriesEpisode: Maybe<SeriesEpisode>;
  createSeriesSeason: Maybe<SeriesSeason>;
  createShowtimesEmbargo: Maybe<ShowtimesEmbargo>;
  createSlide: Maybe<Slide>;
  createSlideshowSlide: Maybe<SlideshowSlide>;
  createSpecialOperation: Maybe<SpecialOperation>;
  upsertBannerHP: Maybe<BannerHpSpecialOperation>;
  upsertCanalHome: Maybe<CanalHomeSpecialOperation>;
  upsertClassiqueHome: Maybe<ClassiqueHomeSpecialOperation>;
  upsertClub300: Maybe<Club300SpecialOperation>;
  upsertDisneyHome: Maybe<DisneyHomeSpecialOperation>;
  upsertDolbyHome: Maybe<DolbyHomeSpecialOperation>;
  upsertEmergenceMovie: Maybe<EmergenceMovieSpecialOperation>;
  upsertEmergenceSeries: Maybe<EmergenceSeriesSpecialOperation>;
  upsertEmergenceSVOD: Maybe<EmergenceSvodSpecialOperation>;
  upsertEmergenceTheater: Maybe<EmergenceTheaterSpecialOperation>;
  upsertFestivalSection: Maybe<FestivalSectionSpecialOperation>;
  upsertFilmesOnline: Maybe<FilmesOnlineSpecialOperation>;
  upsertIMAXHome: Maybe<ImaxHomeSpecialOperation>;
  upsertIndelebileHome: Maybe<IndelebileHomeSpecialOperation>;
  upsertM6Home: Maybe<M6HomeSpecialOperation>;
  upsertMaxHome: Maybe<MaxHomeSpecialOperation>;
  upsertNovelasHome: Maybe<NovelasHomeSpecialOperation>;
  upsertRollerHome: Maybe<RollerHomeSpecialOperation>;
  upsertSponsoredAutocomplete: Maybe<SponsoredAutocompleteSpecialOperation>;
  upsertTF1Home: Maybe<Tf1HomeSpecialOperation>;
  upsertTicketAnchor: Maybe<TicketAnchorSpecialOperation>;
  upsertVODHome: Maybe<VodHomeSpecialOperation>;
  upsertMobileDday: Maybe<MobileDdaySpecialOperation>;
  createTag: Maybe<Tag>;
  createTeam: Maybe<Team>;
  createTheater: Maybe<Theater>;
  createTheaterFeed: Maybe<TheaterFeed>;
  createTrivia: Maybe<Trivia>;
  createUser: Maybe<User>;
  createVideo: Maybe<Video>;
  createWidget: Maybe<Widget>;
  deleteBrandEntityClub: Maybe<BrandEntityClub>;
  deleteBrandSearchLink: Maybe<BrandSearchLink>;
  /** Deletes redirection rules in bulk and returns how many were removed. All or nothing: an unknown id, or a brand the user is not entitled to, rejects the whole call. However many rules are deleted, the Cloudflare run and the validity window rescheduling happen once per affected brand. */
  deleteRedirectionRules: Scalars['Int']['output'];
  deleteCarousel: Maybe<Carousel>;
  deleteCertificate: Maybe<Certificate>;
  deleteClock: Maybe<Clock>;
  deleteCompanyStaff: Maybe<CompanyStaff>;
  deleteCredit: Maybe<PersonCredits>;
  /** Removes one line, casting or credits, of a cast and credits import report from the history of its entity and returns the report's id: the report goes once every line it shows is removed. A running report cannot be removed, and the credits already linked are untouched. */
  deletePersonCreditsImportReport: Scalars['ID']['output'];
  /** Removes a search of images from the history of a person and returns its id; the images already added to the gallery stay. */
  deletePersonImagesImport: Scalars['ID']['output'];
  deleteCustomer: Maybe<Customer>;
  deleteCustomerQuery: Maybe<CustomerQuery>;
  deleteEditorialReview: Maybe<EditorialReview>;
  deleteEntityPublication: Maybe<PublishableEntity>;
  deleteEntity: Maybe<DeleteEntityPayload>;
  deleteEntityCompany: Maybe<EntityCompany>;
  deleteEntityFromTag: Maybe<EntityTag>;
  deleteEntityFromTheaterEvent: Maybe<TheaterEventHasEntity>;
  deleteEntityLink: Maybe<EntityLink>;
  deleteFare: Maybe<Fare>;
  deleteFestival: Maybe<Festival>;
  deleteFestivalAward: Maybe<FestivalAward>;
  deleteFestivalEdition: Maybe<FestivalEdition>;
  deleteFestivalEditionCompetition: Maybe<FestivalEditionCompetition>;
  /** Mutation to delete a festival jury by setting the active flag to false and adding an entry to the 'entity_to_delete' table. */
  deleteFestivalJury: Maybe<FestivalJury>;
  deleteFestivalSelection: Maybe<FestivalSelection>;
  deleteIgnoredProduct: Maybe<IgnoredProduct>;
  deleteIgnoredShowtimeSource: Maybe<IgnoredShowtimeSource>;
  deleteImageCategory: Maybe<Scalars['Boolean']['output']>;
  deleteImageFromCompany: ImageReference;
  deleteImageFromScreen: ImageReference;
  deleteImageFromTheater: Maybe<ImageReference>;
  deleteImportConfiguration: Maybe<ImportConfiguration>;
  deleteImportCrawler: Maybe<ImportCrawler>;
  deleteImportShowtimes: Maybe<DeleteImportShowtimesStats>;
  deleteLocalCertificate: Maybe<EntityLocalRelease>;
  deleteLocalCredit: EntityHasPersonLocalized;
  deleteLocale: Maybe<Locale>;
  deleteMatchedShowtimeEntity: Maybe<Scalars['Int']['output']>;
  deleteMatchedShowtimeTheater: Maybe<Scalars['Int']['output']>;
  deleteMovieVersion: Maybe<MovieVersion>;
  deleteNews: Maybe<News>;
  deleteNewsPage: Maybe<NewsPage>;
  deleteOrAnonymizeSocialUser: Maybe<SocialUser>;
  deletePersonNickname: Maybe<PersonNickname>;
  deletePreset: Maybe<Preset>;
  deletePressReview: Maybe<PressReview>;
  deleteReleaseFromEntity: Maybe<EntityRelease>;
  deleteScope: Maybe<Scope>;
  deleteScreen: Maybe<Screen>;
  deleteShowtimesEmbargo: Maybe<ShowtimesEmbargo>;
  deleteSlideshowSlide: Maybe<SlideshowSlide>;
  deleteSpecialOperation: Maybe<SpecialOperation>;
  deleteTeam: Maybe<Team>;
  deleteTemporalBoxoffice: Maybe<TemporalBoxoffice>;
  deleteTheaterEvent: Maybe<TheaterEvent>;
  deleteTheaterFeed: Maybe<TheaterFeed>;
  deleteToken: Maybe<Token>;
  deleteTrivia: Maybe<Trivia>;
  deleteTriviaFromEntity: Maybe<EntityTrivia>;
  deleteVideo: Maybe<Video>;
  /** Deletes an encoded file of a video, from the database and from the storage. Administrators only */
  deleteVideoFile: Maybe<UploadVideoPayload>;
  deleteWidget: Maybe<Widget>;
  duplicateCarousel: Maybe<Carousel>;
  generateUserToken: Maybe<Scalars['String']['output']>;
  ignoreIncompleteShowtimeSource: Scalars['Int']['output'];
  ignoreProduct: Maybe<IgnoredProduct>;
  markIncompleteEntityInProgressByMavens: Scalars['Int']['output'];
  linkAuthorToEditorialReview: Maybe<EditorialReviewAuthor>;
  linkAuthorToNews: Maybe<NewsAuthor>;
  linkCustomerQueryToScope: Maybe<ScopeCustomerQuery>;
  linkEntities: Maybe<EntityLink>;
  linkEntityToEntity: Maybe<EntityLink>;
  linkEntityToImage: Maybe<ImageLinkableEntity>;
  linkEntityToNews: Maybe<NewsLinkableEntity>;
  linkEntityToVideo: Maybe<VideoLinkableEntity>;
  linkProducts: Maybe<LinkProductsPayload>;
  /** Downloads the chosen candidates of an external source, stores them as images and links them to the person's gallery. Returns one result per image; a failing image does not stop the others. The images of a source driven by a browser are downloaded by a job and come back PENDING; the report gets their outcome when the job ends. */
  importPersonImages: Array<PersonImageImportResult>;
  /** Asks an external source for images of a person and keeps its answer as a report (the candidates, typed for the CMS); nothing is added to the gallery until importPersonImages. */
  launchPersonImagesImport: PersonImageImportReport;
  /** Launches the cast and credits import of a movie, a series, a season or an episode from an external source, and returns the running report; subscribe to personCreditsImportReport for its completion. */
  launchPersonCreditsImport: PersonCreditsImportReport;
  matchShowtimeEntity: Maybe<Scalars['Int']['output']>;
  matchShowtimeTheater: Maybe<Scalars['Int']['output']>;
  moveAuthorInEditorialReviews: Maybe<EditorialReviewAuthor>;
  moveAuthorInNews: Maybe<NewsAuthor>;
  moveCompany: Maybe<EntityCompany>;
  moveCompanyStaff: Maybe<CompanyStaff>;
  moveCredit: Maybe<PersonCredits>;
  moveEntityImage: Maybe<ImageLinkableEntity>;
  moveEntityLink: Maybe<EntityLink>;
  moveEntityVideo: Maybe<VideoLinkableEntity>;
  moveFare: Maybe<Fare>;
  /** Mutation to move a festival jury to a new rank. */
  moveFestivalJury: Maybe<FestivalJury>;
  moveNewsSlide: Maybe<SlideshowSlide>;
  moveSlide: Maybe<CarouselHasSlide>;
  publishEntityChangeEvents: Maybe<Array<Maybe<EntityChangeEvent>>>;
  removeImageFromCategory: Maybe<ImageHasCategory>;
  removeSlide: Maybe<CarouselHasSlide>;
  removeTargetFromSpecialOperation: Maybe<SpecialOperation>;
  retroengineerUrl: Maybe<WebsiteRoute>;
  /** Encodes again, or for the first time, a branded video on one platform, from the source file of its last upload */
  retryVideoPlatformEncoding: Maybe<VideoLegacy>;
  /** Sets an existing YouTube video on a video, as a finished YouTube encoding would: stored under the default YouTube channel of the video, except the id it already has (or the one a pending replacement was deleting), which keeps its channel. Nothing is sent to YouTube; the next save does it. */
  setYoutubeVideoId: Maybe<VideoLegacy>;
  toggleEntityBrandActivation: Maybe<Entity>;
  toggleNewsActivation: Maybe<News>;
  toggleTagActivation: Maybe<Tag>;
  unlinkAuthorFromEditorialReview: Maybe<EditorialReviewAuthor>;
  unlinkAuthorFromNews: Maybe<NewsAuthor>;
  unlinkCustomerQueryFromScope: Maybe<ScopeCustomerQuery>;
  unlinkEntities: Maybe<EntityLink>;
  unlinkEntityFromImage: Maybe<ImageLinkableEntity>;
  unlinkEntityFromNews: Maybe<NewsLinkableEntity>;
  unlinkEntityFromProduct: Maybe<MatchedProduct>;
  unlinkEntityFromVideo: Maybe<VideoLinkableEntity>;
  updateApplication: Maybe<Application>;
  updateAuthor: Maybe<Author>;
  updateAuthorSeoData: Maybe<Author>;
  updateAuthorSignature: Maybe<AuthorSignature>;
  updateBrand: Maybe<Brand>;
  updateBrandEntityClub: Maybe<BrandEntityClub>;
  updateBrandSearchLink: Maybe<BrandSearchLink>;
  updateRedirectionRule: Maybe<RedirectionRule>;
  /** Creates or merges pattern redirection rules in bulk. Rules are matched on (brandRef, sourceUrl): unknown ones are created, known ones are merged over. Returns a report; a single error rolls the whole write back. */
  upsertRedirectionRules: RedirectionRuleUpsertReport;
  updateCarousel: Maybe<Carousel>;
  updateCertificate: Maybe<Certificate>;
  updateClock: Maybe<Clock>;
  updateCompany: Maybe<Company>;
  updateCompanyBrandData: Maybe<CompanyBrandData>;
  updateCompanyLocaleData: Maybe<CompanyLocaleData>;
  updateCompanyStaff: Maybe<CompanyStaff>;
  updateCountry: Maybe<Country>;
  updateCredit: Maybe<PersonCredits>;
  updateCustomer: Maybe<Customer>;
  updateCustomerQuery: Maybe<CustomerQuery>;
  updateDuplicate: Maybe<Duplicate>;
  updateEditorialReview: Maybe<EditorialReview>;
  updateEntityPublication: Maybe<PublishableEntity>;
  updateEntityAlts: Maybe<Entity>;
  updateEntityGeneratedVideoTitles: Maybe<EntityGeneratedVideoTitles>;
  updateEntityLink: Maybe<EntityLink>;
  updateEntityLocalization: Maybe<Establishment>;
  updateEntityMainBrandPoster: Maybe<Entity>;
  updateEntityMainLocalizedPoster: Maybe<Entity>;
  updateEntityMainPoster: Maybe<Entity>;
  updateEntitySeoData: Maybe<Entity>;
  updateFare: Maybe<Fare>;
  updateFestival: Maybe<Festival>;
  updateFestivalAward: Maybe<FestivalAward>;
  updateFestivalCompetition: Maybe<FestivalCompetition>;
  updateFestivalEdition: Maybe<FestivalEdition>;
  updateFestivalEditionCompetition: Maybe<FestivalEditionCompetition>;
  updateFestivalSelection: Maybe<FestivalSelection>;
  updateImage: Maybe<Image>;
  updateImageB2bData: Maybe<Image>;
  updateImageBrandData: Maybe<ImageBrandData>;
  updateImageCategory: Maybe<ImageCategory>;
  updateImageInCategory: Maybe<ImageHasCategory>;
  updateImageLocaleData: Maybe<ImageLocaleData>;
  updateImportConfiguration: Maybe<ImportConfiguration>;
  updateImportCrawler: Maybe<ImportCrawler>;
  updateLocalCertificate: Maybe<EntityLocalRelease>;
  updateLocalCredit: EntityHasPersonLocalized;
  updateLocale: Maybe<Locale>;
  updateMovie: Maybe<Movie>;
  updateMovieBoxoffice: Maybe<Movie>;
  updateMovieBrandData: Maybe<MovieBrandData>;
  updateMovieBrandedContent: Maybe<MovieBrandedContent>;
  updateMovieLocaleData: Maybe<MovieLocaleData>;
  updateMovieVersion: Maybe<MovieVersion>;
  updateNews: Maybe<News>;
  updateNewsNavigationData: Maybe<News>;
  updateNewsPage: Maybe<NewsPage>;
  updateNewsPageNumber: Maybe<NewsPage>;
  updateNewsSeoAttributes: Maybe<News>;
  updatePerson: Maybe<Person>;
  updatePersonBrandData: Maybe<PersonBrandData>;
  updatePreset: Maybe<Preset>;
  updatePressReview: Maybe<PressReview>;
  updateProductDetails: Maybe<MatchedProduct>;
  updateProductProvider: Maybe<MatchedProduct>;
  updateRelease: Maybe<EntityRelease>;
  updateScope: Maybe<Scope>;
  updateScreen: Maybe<Screen>;
  updateSeries: Maybe<Series>;
  updateSeriesBrandData: Maybe<SeriesBrandData>;
  updateSeriesEpisode: Maybe<SeriesEpisode>;
  updateSeriesEpisodeBrandData: Maybe<SeriesEpisodeBrandData>;
  updateSeriesSeason: Maybe<SeriesSeason>;
  updateSeriesSeasonBrandData: Maybe<SeriesSeasonBrandData>;
  updateShowtimesEmbargo: Maybe<ShowtimesEmbargo>;
  updateSlide: Maybe<Slide>;
  updateSlideshowSlide: Maybe<SlideshowSlide>;
  updateSocialUser: Maybe<SocialUser>;
  updateSpecialOperation: Maybe<SpecialOperation>;
  updateSpecialOperationTarget: Maybe<SpecialOperationTarget>;
  updateTag: Maybe<Tag>;
  updateTagRank: Maybe<EntityTag>;
  updateTeam: Maybe<Team>;
  updateTemporalBoxoffice: Maybe<TemporalBoxoffice>;
  updateTheater: Maybe<Theater>;
  updateTheaterEvent: Maybe<TheaterEvent>;
  updateTheaterFeed: Maybe<TheaterFeed>;
  updateTheaterLocaleData: Maybe<Theater>;
  updateTheaterTicketing: Maybe<Theater>;
  updateToken: Maybe<Token>;
  updateTrivia: Maybe<Trivia>;
  updateTriviaRank: Maybe<EntityTrivia>;
  updateUser: Maybe<User>;
  updateUserPreferences: Maybe<User>;
  updateUserReview: Maybe<UserReview>;
  updateVideo: Maybe<Video>;
  updateWidget: Maybe<Widget>;
  uploadVideo: Maybe<UploadVideoPayload>;
};


export type MutationAddActorToEntityArgs = {
  input: AddActorToEntityInput;
};


export type MutationAddCompanyToEntityArgs = {
  input: AddCompanyToEntityInput;
};


export type MutationAddCreditToEntityArgs = {
  input: AddCreditToEntityInput;
};


export type MutationAddCreditsToEntityArgs = {
  input: AddCreditsToEntityInput;
};


export type MutationAddDuplicateArgs = {
  input: AddDuplicateInput;
};


export type MutationAddEntityToTagArgs = {
  input: AddEntityToTagInput;
};


export type MutationAddEntityToTheaterEventArgs = {
  input: AddEntityToTheaterEventInput;
};


export type MutationAddFareArgs = {
  input: AddFareInput;
};


export type MutationAddImageToCategoryArgs = {
  input: AddImageToCategoryInput;
};


export type MutationAddImageToCompanyArgs = {
  input: AddImageToCompanyInput;
};


export type MutationAddImageToScreenArgs = {
  input: AddImageToScreenInput;
};


export type MutationAddImageToTheaterArgs = {
  input: AddImageToTheaterInput;
};


export type MutationAddLocalizedActorToEntityArgs = {
  input: AddLocalizedActorToEntityInput;
};


export type MutationAddPersonNicknameArgs = {
  input: AddPersonNicknameInput;
};


export type MutationAddReleaseToEntityArgs = {
  input: AddReleaseToEntityInput;
};


export type MutationAddSlideArgs = {
  input: AddSlideInput;
};


export type MutationAddTargetToSpecialOperationArgs = {
  input: AddTargetToSpecialOperationInput;
};


export type MutationAddTemporalBoxofficeArgs = {
  input: AddTemporalBoxofficeInput;
};


export type MutationAddTheaterEventArgs = {
  input: AddTheaterEventInput;
};


export type MutationAddTokenArgs = {
  input: AddTokenInput;
};


export type MutationAddTriviaToEntityArgs = {
  input: AddTriviaToEntityInput;
};


export type MutationApplyCastingToEntityArgs = {
  input: ApplyCastingToEntityInput;
};


export type MutationApplyCreditToEntityArgs = {
  input: ApplyCreditToEntityInput;
};


export type MutationBatchCreateSeriesEpisodesArgs = {
  input: BatchCreateSeriesEpisodesInput;
};


export type MutationBatchCreateSeriesSeasonsArgs = {
  input: BatchCreateSeriesSeasonsInput;
};


export type MutationBatchImportConfigurationOperationArgs = {
  input: BatchImportConfigurationOperationInput;
};


export type MutationCancelImportArgs = {
  reportId: Scalars['ID']['input'];
};


export type MutationCopyFestivalEditionArgs = {
  input: CopyFestivalEditionInput;
};


export type MutationCopyMovieBrandedDataToLocalizedDataArgs = {
  input: CopyMovieBrandedDataToLocalizedDataInput;
};


export type MutationCreateActitoProfileArgs = {
  input: CreateActitoProfileInput;
};


export type MutationCreateApplicationArgs = {
  input: CreateApplicationInput;
};


export type MutationCreateAuthorArgs = {
  input: CreateAuthorInput;
};


export type MutationCreateAuthorSignatureArgs = {
  input: CreateAuthorSignatureInput;
};


export type MutationCreateBrandSearchLinkArgs = {
  input: CreateBrandSearchLinkInput;
};


export type MutationCreateRedirectionRuleArgs = {
  input: CreateRedirectionRuleInput;
};


export type MutationCreateCarouselArgs = {
  input: CreateCarouselInput;
};


export type MutationCreateCertificateArgs = {
  input: CreateCertificateInput;
};


export type MutationCreateClocksArgs = {
  input: CreateClocksInput;
};


export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};


export type MutationCreateCompanyStaffArgs = {
  input: CreateCompanyStaffInput;
};


export type MutationCreateCopyrightArgs = {
  input: CreateCopyrightInput;
};


export type MutationCreateCustomerArgs = {
  input: CreateCustomerInput;
};


export type MutationCreateCustomerQueryArgs = {
  input: CreateCustomerQueryInput;
};


export type MutationCreateEditorialReviewArgs = {
  input: CreateEditorialReviewInput;
};


export type MutationCreateEntityPublicationArgs = {
  input: CreateEntityPublicationInput;
};


export type MutationCreateFestivalArgs = {
  input: CreateFestivalInput;
};


export type MutationCreateFestivalAwardArgs = {
  input: CreateFestivalAwardInput;
};


export type MutationCreateFestivalCompetitionArgs = {
  input: CreateFestivalCompetitionInput;
};


export type MutationCreateFestivalEditionArgs = {
  input: CreateFestivalEditionInput;
};


export type MutationCreateFestivalEditionCompetitionArgs = {
  input: CreateFestivalEditionCompetitionInput;
};


export type MutationCreateFestivalJuryArgs = {
  input: CreateFestivalJuryInput;
};


export type MutationCreateFestivalSelectionArgs = {
  input: CreateFestivalSelectionInput;
};


export type MutationCreateFileUploadTokenArgs = {
  input: CreateFileUploadTokenInput;
};


export type MutationCreateImageArgs = {
  input: CreateImageInput;
};


export type MutationCreateImageCategoryArgs = {
  input: CreateImageCategoryInput;
};


export type MutationCreateImportConfigurationArgs = {
  input: CreateImportConfigurationInput;
};


export type MutationCreateImportConfigurationsFromCsvArgs = {
  input: CreateImportConfigurationsFromCsvInput;
};


export type MutationCreateImportCrawlerArgs = {
  input: CreateImportCrawlerInput;
};


export type MutationCreateLocalCertificateArgs = {
  input: CreateLocalCertificateInput;
};


export type MutationCreateLocaleArgs = {
  input: CreateLocaleInput;
};


export type MutationCreateMovieArgs = {
  input: CreateMovieInput;
};


export type MutationCreateMovieVersionArgs = {
  input: CreateMovieVersionInput;
};


export type MutationCreateNewsArgs = {
  input: CreateNewsInput;
};


export type MutationCreateNewsPageArgs = {
  input: CreateNewsPageInput;
};


export type MutationCreatePersonArgs = {
  input: CreatePersonInput;
};


export type MutationCreatePresetArgs = {
  input: CreatePresetInput;
};


export type MutationCreatePressReviewArgs = {
  input: CreatePressReviewInput;
};


export type MutationCreateProductArgs = {
  input: CreateProductInput;
};


export type MutationCreateScopeArgs = {
  input: CreateScopeInput;
};


export type MutationCreateScreenArgs = {
  input: CreateScreenInput;
};


export type MutationCreateScreensArgs = {
  input: CreateScreensInput;
};


export type MutationCreateSeriesArgs = {
  input: CreateSeriesInput;
};


export type MutationCreateSeriesEpisodeArgs = {
  input: CreateSeriesEpisodeInput;
};


export type MutationCreateSeriesSeasonArgs = {
  input: CreateSeriesSeasonInput;
};


export type MutationCreateShowtimesEmbargoArgs = {
  input: CreateShowtimesEmbargoInput;
};


export type MutationCreateSlideArgs = {
  input: CreateSlideInput;
};


export type MutationCreateSlideshowSlideArgs = {
  input: CreateSlideshowSlideInput;
};


export type MutationCreateSpecialOperationArgs = {
  input: CreateSpecialOperationInput;
};


export type MutationUpsertBannerHpArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId: Scalars['ID']['input'];
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: BannerHpDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertCanalHomeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId: Scalars['ID']['input'];
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: CanalHomeDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertClassiqueHomeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId: Scalars['ID']['input'];
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: ClassiqueHomeDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertClub300Args = {
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId: Scalars['ID']['input'];
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: Club300DataInput;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertDisneyHomeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId: Scalars['ID']['input'];
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: DisneyHomeDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertDolbyHomeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId: Scalars['ID']['input'];
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: DolbyHomeDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertEmergenceMovieArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId: Scalars['ID']['input'];
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: EmergenceMovieDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertEmergenceSeriesArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId: Scalars['ID']['input'];
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: EmergenceSeriesDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertEmergenceSvodArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId: Scalars['ID']['input'];
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: EmergenceSvodDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertEmergenceTheaterArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId: Scalars['ID']['input'];
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: EmergenceTheaterDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertFestivalSectionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId: Scalars['ID']['input'];
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: FestivalSectionDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertFilmesOnlineArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId: Scalars['ID']['input'];
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: FilmesOnlineDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertImaxHomeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId: Scalars['ID']['input'];
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: ImaxHomeDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertIndelebileHomeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId: Scalars['ID']['input'];
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: IndelebileHomeDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertM6HomeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId: Scalars['ID']['input'];
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: M6HomeDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertMaxHomeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId: Scalars['ID']['input'];
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: MaxHomeDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertNovelasHomeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId: Scalars['ID']['input'];
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: NovelasHomeDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertRollerHomeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId: Scalars['ID']['input'];
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: RollerHomeDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertSponsoredAutocompleteArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId: Scalars['ID']['input'];
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: SponsoredAutocompleteDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertTf1HomeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId: Scalars['ID']['input'];
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: Tf1HomeDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertTicketAnchorArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId: Scalars['ID']['input'];
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: TicketAnchorDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertVodHomeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId: Scalars['ID']['input'];
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: VodHomeDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertMobileDdayArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId: Scalars['ID']['input'];
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: MobileDdayDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};


export type MutationCreateTheaterArgs = {
  input: CreateTheaterInput;
};


export type MutationCreateTheaterFeedArgs = {
  input: CreateTheaterFeedInput;
};


export type MutationCreateTriviaArgs = {
  input: CreateTriviaInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateVideoArgs = {
  input: CreateVideoInput;
};


export type MutationCreateWidgetArgs = {
  input: CreateWidgetInput;
};


export type MutationDeleteBrandEntityClubArgs = {
  input: DeleteBrandEntityClubInput;
};


export type MutationDeleteBrandSearchLinkArgs = {
  input: DeleteBrandSearchLinkInput;
};


export type MutationDeleteRedirectionRulesArgs = {
  input: DeleteRedirectionRulesInput;
};


export type MutationDeleteCarouselArgs = {
  input: DeleteCarouselInput;
};


export type MutationDeleteCertificateArgs = {
  input: DeleteCertificateInput;
};


export type MutationDeleteClockArgs = {
  input: DeleteClockInput;
};


export type MutationDeleteCompanyStaffArgs = {
  input: DeleteCompanyStaffInput;
};


export type MutationDeleteCreditArgs = {
  input: DeleteCreditInput;
};


export type MutationDeletePersonCreditsImportReportArgs = {
  input: DeletePersonCreditsImportReportInput;
};


export type MutationDeletePersonImagesImportArgs = {
  input: DeletePersonImagesImportInput;
};


export type MutationDeleteCustomerArgs = {
  input: DeleteCustomerInput;
};


export type MutationDeleteCustomerQueryArgs = {
  input: DeleteCustomerQueryInput;
};


export type MutationDeleteEditorialReviewArgs = {
  input: DeleteEditorialReviewInput;
};


export type MutationDeleteEntityPublicationArgs = {
  input: DeleteEntityPublicationInput;
};


export type MutationDeleteEntityArgs = {
  input: DeleteEntityInput;
};


export type MutationDeleteEntityCompanyArgs = {
  input: DeleteEntityCompanyInput;
};


export type MutationDeleteEntityFromTagArgs = {
  input: DeleteEntityFromTagInput;
};


export type MutationDeleteEntityFromTheaterEventArgs = {
  input: DeleteEntityFromTheaterEventInput;
};


export type MutationDeleteEntityLinkArgs = {
  input: DeleteEntityLinkInput;
};


export type MutationDeleteFareArgs = {
  input: DeleteFareInput;
};


export type MutationDeleteFestivalArgs = {
  input: DeleteFestivalInput;
};


export type MutationDeleteFestivalAwardArgs = {
  input: DeleteFestivalAwardInput;
};


export type MutationDeleteFestivalEditionArgs = {
  input: DeleteFestivalEditionInput;
};


export type MutationDeleteFestivalEditionCompetitionArgs = {
  input: DeleteFestivalEditionCompetitionInput;
};


export type MutationDeleteFestivalJuryArgs = {
  input: DeleteFestivalJuryInput;
};


export type MutationDeleteFestivalSelectionArgs = {
  input: DeleteFestivalSelectionInput;
};


export type MutationDeleteIgnoredProductArgs = {
  input: DeleteIgnoredProductInput;
};


export type MutationDeleteIgnoredShowtimeSourceArgs = {
  input: DeleteIgnoredShowtimeSourceInput;
};


export type MutationDeleteImageCategoryArgs = {
  input: DeleteImageCategoryInput;
};


export type MutationDeleteImageFromCompanyArgs = {
  input: DeleteImageFromCompanyInput;
};


export type MutationDeleteImageFromScreenArgs = {
  input: DeleteImageFromScreenInput;
};


export type MutationDeleteImageFromTheaterArgs = {
  input: DeleteImageFromTheaterInput;
};


export type MutationDeleteImportConfigurationArgs = {
  input: DeleteImportConfigurationInput;
};


export type MutationDeleteImportCrawlerArgs = {
  input: DeleteImportCrawlerInput;
};


export type MutationDeleteImportShowtimesArgs = {
  input: DeleteImportShowtimesInput;
};


export type MutationDeleteLocalCertificateArgs = {
  input: DeleteLocalCertificateInput;
};


export type MutationDeleteLocalCreditArgs = {
  input: DeleteLocalCreditInput;
};


export type MutationDeleteLocaleArgs = {
  input: DeleteLocaleInput;
};


export type MutationDeleteMatchedShowtimeEntityArgs = {
  input: DeleteMatchedShowtimeEntityInput;
};


export type MutationDeleteMatchedShowtimeTheaterArgs = {
  input: DeleteMatchedShowtimeTheaterInput;
};


export type MutationDeleteMovieVersionArgs = {
  input: DeleteMovieVersionInput;
};


export type MutationDeleteNewsArgs = {
  input: DeleteNewsInput;
};


export type MutationDeleteNewsPageArgs = {
  input: DeleteNewsPageInput;
};


export type MutationDeleteOrAnonymizeSocialUserArgs = {
  input: DeleteOrAnonymizeSocialUserInput;
};


export type MutationDeletePersonNicknameArgs = {
  input: DeletePersonNicknameInput;
};


export type MutationDeletePresetArgs = {
  input: DeletePresetInput;
};


export type MutationDeletePressReviewArgs = {
  input: DeletePressReviewInput;
};


export type MutationDeleteReleaseFromEntityArgs = {
  input: DeleteReleaseFromEntityInput;
};


export type MutationDeleteScopeArgs = {
  input: DeleteScopeInput;
};


export type MutationDeleteScreenArgs = {
  input: DeleteScreenInput;
};


export type MutationDeleteShowtimesEmbargoArgs = {
  input: DeleteShowtimesEmbargoInput;
};


export type MutationDeleteSlideshowSlideArgs = {
  input: DeleteSlideshowSlideInput;
};


export type MutationDeleteSpecialOperationArgs = {
  input: DeleteSpecialOperationInput;
};


export type MutationDeleteTeamArgs = {
  input: DeleteTeamInput;
};


export type MutationDeleteTemporalBoxofficeArgs = {
  input: DeleteTemporalBoxofficeInput;
};


export type MutationDeleteTheaterEventArgs = {
  input: DeleteTheaterEventInput;
};


export type MutationDeleteTheaterFeedArgs = {
  input: DeleteTheaterFeedInput;
};


export type MutationDeleteTokenArgs = {
  input: DeleteTokenInput;
};


export type MutationDeleteTriviaArgs = {
  input: DeleteTriviaInput;
};


export type MutationDeleteTriviaFromEntityArgs = {
  input: DeleteTriviaFromEntityInput;
};


export type MutationDeleteVideoArgs = {
  input: DeleteVideoInput;
};


export type MutationDeleteVideoFileArgs = {
  input: DeleteVideoFileInput;
};


export type MutationDeleteWidgetArgs = {
  input: DeleteWidgetInput;
};


export type MutationDuplicateCarouselArgs = {
  input: DuplicateCarouselInput;
};


export type MutationGenerateUserTokenArgs = {
  input: GenerateUserTokenInput;
};


export type MutationIgnoreIncompleteShowtimeSourceArgs = {
  input: IgnoreIncompleteShowtimeSourceInput;
};


export type MutationIgnoreProductArgs = {
  input: IgnoreProductInput;
};


export type MutationMarkIncompleteEntityInProgressByMavensArgs = {
  input: MarkIncompleteEntityInProgressByMavensInput;
};


export type MutationLinkAuthorToEditorialReviewArgs = {
  input: LinkAuthorToEditorialReviewInput;
};


export type MutationLinkAuthorToNewsArgs = {
  input: LinkAuthorToNewsInput;
};


export type MutationLinkCustomerQueryToScopeArgs = {
  input: LinkCustomerQueryToScopeInput;
};


export type MutationLinkEntitiesArgs = {
  input: LinkEntitiesInput;
};


export type MutationLinkEntityToEntityArgs = {
  input: LinkEntityToEntityInput;
};


export type MutationLinkEntityToImageArgs = {
  input: LinkEntityToImageInput;
};


export type MutationLinkEntityToNewsArgs = {
  input: LinkEntityToNewsInput;
};


export type MutationLinkEntityToVideoArgs = {
  input: LinkEntityToVideoInput;
};


export type MutationLinkProductsArgs = {
  input: LinkProductsInput;
};


export type MutationImportPersonImagesArgs = {
  input: ImportPersonImagesInput;
};


export type MutationLaunchPersonImagesImportArgs = {
  input: LaunchPersonImagesImportInput;
};


export type MutationLaunchPersonCreditsImportArgs = {
  input: LaunchPersonCreditsImportInput;
};


export type MutationMatchShowtimeEntityArgs = {
  input: MatchShowtimeEntityInput;
};


export type MutationMatchShowtimeTheaterArgs = {
  input: MatchShowtimeTheaterInput;
};


export type MutationMoveAuthorInEditorialReviewsArgs = {
  input: MoveAuthorInEditorialReviewsInput;
};


export type MutationMoveAuthorInNewsArgs = {
  input: MoveAuthorInNewsInput;
};


export type MutationMoveCompanyArgs = {
  input: MoveCompanyInput;
};


export type MutationMoveCompanyStaffArgs = {
  input: MoveCompanyStaffInput;
};


export type MutationMoveCreditArgs = {
  input: MoveCreditInput;
};


export type MutationMoveEntityImageArgs = {
  input: MoveEntityImageInput;
};


export type MutationMoveEntityLinkArgs = {
  input: MoveEntityLinkInput;
};


export type MutationMoveEntityVideoArgs = {
  input: MoveEntityVideoInput;
};


export type MutationMoveFareArgs = {
  input: MoveFareInput;
};


export type MutationMoveFestivalJuryArgs = {
  input: MoveFestivalJuryInput;
};


export type MutationMoveNewsSlideArgs = {
  input: MoveNewsSlideInput;
};


export type MutationMoveSlideArgs = {
  input: MoveSlideInput;
};


export type MutationPublishEntityChangeEventsArgs = {
  batchEvents?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<Array<PublishEntityChangeEventsInput>>;
};


export type MutationRemoveImageFromCategoryArgs = {
  input: RemoveImageFromCategoryInput;
};


export type MutationRemoveSlideArgs = {
  input: RemoveSlideInput;
};


export type MutationRemoveTargetFromSpecialOperationArgs = {
  input: RemoveTargetFromSpecialOperationInput;
};


export type MutationRetroengineerUrlArgs = {
  input: RetroengineerUrlInput;
};


export type MutationRetryVideoPlatformEncodingArgs = {
  input: RetryVideoPlatformEncodingInput;
};


export type MutationSetYoutubeVideoIdArgs = {
  input: SetYoutubeVideoIdInput;
};


export type MutationToggleEntityBrandActivationArgs = {
  input: ToggleEntityBrandActivationInput;
};


export type MutationToggleNewsActivationArgs = {
  input: ToggleNewsActivationInput;
};


export type MutationToggleTagActivationArgs = {
  input: ToggleTagActivationInput;
};


export type MutationUnlinkAuthorFromEditorialReviewArgs = {
  input: UnlinkAuthorFromEditorialReviewInput;
};


export type MutationUnlinkAuthorFromNewsArgs = {
  input: UnlinkAuthorFromNewsInput;
};


export type MutationUnlinkCustomerQueryFromScopeArgs = {
  input: UnlinkCustomerQueryFromScopeInput;
};


export type MutationUnlinkEntitiesArgs = {
  input: UnlinkEntitiesInput;
};


export type MutationUnlinkEntityFromImageArgs = {
  input: UnlinkEntityFromImageInput;
};


export type MutationUnlinkEntityFromNewsArgs = {
  input: UnlinkEntityFromNewsInput;
};


export type MutationUnlinkEntityFromProductArgs = {
  input: UnlinkEntityFromProductInput;
};


export type MutationUnlinkEntityFromVideoArgs = {
  input: UnlinkEntityFromVideoInput;
};


export type MutationUpdateApplicationArgs = {
  input: UpdateApplicationInput;
};


export type MutationUpdateAuthorArgs = {
  input: UpdateAuthorInput;
};


export type MutationUpdateAuthorSeoDataArgs = {
  input: UpdateAuthorSeoDataInput;
};


export type MutationUpdateAuthorSignatureArgs = {
  input: UpdateAuthorSignatureInput;
};


export type MutationUpdateBrandArgs = {
  input: UpdateBrandInput;
};


export type MutationUpdateBrandEntityClubArgs = {
  input: UpdateBrandEntityClubInput;
};


export type MutationUpdateBrandSearchLinkArgs = {
  input: UpdateBrandSearchLinkInput;
};


export type MutationUpdateRedirectionRuleArgs = {
  input: UpdateRedirectionRuleInput;
};


export type MutationUpsertRedirectionRulesArgs = {
  input: UpsertRedirectionRulesInput;
};


export type MutationUpdateCarouselArgs = {
  input: UpdateCarouselInput;
};


export type MutationUpdateCertificateArgs = {
  input: UpdateCertificateInput;
};


export type MutationUpdateClockArgs = {
  input: UpdateClockInput;
};


export type MutationUpdateCompanyArgs = {
  input: UpdateCompanyInput;
};


export type MutationUpdateCompanyBrandDataArgs = {
  input: UpdateCompanyBrandDataInput;
};


export type MutationUpdateCompanyLocaleDataArgs = {
  input: UpdateCompanyLocaleDataInput;
};


export type MutationUpdateCompanyStaffArgs = {
  input: UpdateCompanyStaffInput;
};


export type MutationUpdateCountryArgs = {
  input: UpdateCountryInput;
};


export type MutationUpdateCreditArgs = {
  input: UpdateCreditInput;
};


export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerInput;
};


export type MutationUpdateCustomerQueryArgs = {
  input: UpdateCustomerQueryInput;
};


export type MutationUpdateDuplicateArgs = {
  input: UpdateDuplicateInput;
};


export type MutationUpdateEditorialReviewArgs = {
  input: UpdateEditorialReviewInput;
};


export type MutationUpdateEntityPublicationArgs = {
  input: UpdateEntityPublicationInput;
};


export type MutationUpdateEntityAltsArgs = {
  input: UpdateEntityAltsInput;
};


export type MutationUpdateEntityGeneratedVideoTitlesArgs = {
  input: UpdateEntityGeneratedVideoTitlesInput;
};


export type MutationUpdateEntityLinkArgs = {
  input: UpdateEntityLinkInput;
};


export type MutationUpdateEntityLocalizationArgs = {
  input: UpdateEntityLocalizationInput;
};


export type MutationUpdateEntityMainBrandPosterArgs = {
  input: UpdateEntityMainBrandPosterInput;
};


export type MutationUpdateEntityMainLocalizedPosterArgs = {
  input: UpdateEntityMainLocalizedPosterInput;
};


export type MutationUpdateEntityMainPosterArgs = {
  input: UpdateEntityMainPosterInput;
};


export type MutationUpdateEntitySeoDataArgs = {
  input: UpdateEntitySeoDataInput;
};


export type MutationUpdateFareArgs = {
  input: UpdateFareInput;
};


export type MutationUpdateFestivalArgs = {
  input: UpdateFestivalInput;
};


export type MutationUpdateFestivalAwardArgs = {
  input: UpdateFestivalAwardInput;
};


export type MutationUpdateFestivalCompetitionArgs = {
  input: UpdateFestivalCompetitionInput;
};


export type MutationUpdateFestivalEditionArgs = {
  input: UpdateFestivalEditionInput;
};


export type MutationUpdateFestivalEditionCompetitionArgs = {
  input: UpdateFestivalEditionCompetitionInput;
};


export type MutationUpdateFestivalSelectionArgs = {
  input: UpdateFestivalSelectionInput;
};


export type MutationUpdateImageArgs = {
  input: UpdateImageInput;
};


export type MutationUpdateImageB2bDataArgs = {
  input: UpdateImageB2bDataInput;
};


export type MutationUpdateImageBrandDataArgs = {
  input: UpdateImageBrandDataInput;
};


export type MutationUpdateImageCategoryArgs = {
  input: UpdateImageCategoryInput;
};


export type MutationUpdateImageInCategoryArgs = {
  input: UpdateImageInCategoryInput;
};


export type MutationUpdateImageLocaleDataArgs = {
  input: UpdateImageLocaleDataInput;
};


export type MutationUpdateImportConfigurationArgs = {
  input: UpdateImportConfigurationInput;
};


export type MutationUpdateImportCrawlerArgs = {
  input: UpdateImportCrawlerInput;
};


export type MutationUpdateLocalCertificateArgs = {
  input: UpdateLocalCertificateInput;
};


export type MutationUpdateLocalCreditArgs = {
  input: UpdateLocalCreditInput;
};


export type MutationUpdateLocaleArgs = {
  input: UpdateLocaleInput;
};


export type MutationUpdateMovieArgs = {
  input: UpdateMovieInput;
};


export type MutationUpdateMovieBoxofficeArgs = {
  input: UpdateMovieBoxofficeInput;
};


export type MutationUpdateMovieBrandDataArgs = {
  input: UpdateMovieBrandDataInput;
};


export type MutationUpdateMovieBrandedContentArgs = {
  input: UpdateMovieBrandedContentInput;
};


export type MutationUpdateMovieLocaleDataArgs = {
  input: UpdateMovieLocaleDataInput;
};


export type MutationUpdateMovieVersionArgs = {
  input: UpdateMovieVersionInput;
};


export type MutationUpdateNewsArgs = {
  input: UpdateNewsInput;
};


export type MutationUpdateNewsNavigationDataArgs = {
  input: UpdateNewsNavigationDataInput;
};


export type MutationUpdateNewsPageArgs = {
  input: UpdateNewsPageInput;
};


export type MutationUpdateNewsPageNumberArgs = {
  input: UpdateNewsPageNumberInput;
};


export type MutationUpdateNewsSeoAttributesArgs = {
  input: UpdateNewsSeoAttributesInput;
};


export type MutationUpdatePersonArgs = {
  input: UpdatePersonInput;
};


export type MutationUpdatePersonBrandDataArgs = {
  input: UpdatePersonBrandDataInput;
};


export type MutationUpdatePresetArgs = {
  input: UpdatePresetInput;
};


export type MutationUpdatePressReviewArgs = {
  input: UpdatePressReviewInput;
};


export type MutationUpdateProductDetailsArgs = {
  input: UpdateProductDetailsInput;
};


export type MutationUpdateProductProviderArgs = {
  input: UpdateProductProviderInput;
};


export type MutationUpdateReleaseArgs = {
  input: UpdateReleaseInput;
};


export type MutationUpdateScopeArgs = {
  input: UpdateScopeInput;
};


export type MutationUpdateScreenArgs = {
  input: UpdateScreenInput;
};


export type MutationUpdateSeriesArgs = {
  input: UpdateSeriesInput;
};


export type MutationUpdateSeriesBrandDataArgs = {
  input: UpdateSeriesBrandDataInput;
};


export type MutationUpdateSeriesEpisodeArgs = {
  input: UpdateSeriesEpisodeInput;
};


export type MutationUpdateSeriesEpisodeBrandDataArgs = {
  input: UpdateSeriesEpisodeBrandDataInput;
};


export type MutationUpdateSeriesSeasonArgs = {
  input: UpdateSeriesSeasonInput;
};


export type MutationUpdateSeriesSeasonBrandDataArgs = {
  input: UpdateSeriesSeasonBrandDataInput;
};


export type MutationUpdateShowtimesEmbargoArgs = {
  input: UpdateShowtimesEmbargoInput;
};


export type MutationUpdateSlideArgs = {
  input: UpdateSlideInput;
};


export type MutationUpdateSlideshowSlideArgs = {
  input: UpdateSlideshowSlideInput;
};


export type MutationUpdateSocialUserArgs = {
  input: UpdateSocialUserInput;
};


export type MutationUpdateSpecialOperationArgs = {
  input: UpdateSpecialOperationInput;
};


export type MutationUpdateSpecialOperationTargetArgs = {
  input: UpdateSpecialOperationTargetInput;
};


export type MutationUpdateTagArgs = {
  input: UpdateTagInput;
};


export type MutationUpdateTagRankArgs = {
  input: UpdateTagRankInput;
};


export type MutationUpdateTeamArgs = {
  input: UpdateTeamInput;
};


export type MutationUpdateTemporalBoxofficeArgs = {
  input: UpdateTemporalBoxofficeInput;
};


export type MutationUpdateTheaterArgs = {
  input: UpdateTheaterInput;
};


export type MutationUpdateTheaterEventArgs = {
  input: UpdateTheaterEventInput;
};


export type MutationUpdateTheaterFeedArgs = {
  input: UpdateTheaterFeedInput;
};


export type MutationUpdateTheaterLocaleDataArgs = {
  input: UpdateTheaterLocaleDataInput;
};


export type MutationUpdateTheaterTicketingArgs = {
  input: UpdateTheaterTicketingInput;
};


export type MutationUpdateTokenArgs = {
  input: UpdateTokenInput;
};


export type MutationUpdateTriviaArgs = {
  input: UpdateTriviaInput;
};


export type MutationUpdateTriviaRankArgs = {
  input: UpdateTriviaRankInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserPreferencesArgs = {
  input: UpdateUserPreferencesInput;
};


export type MutationUpdateUserReviewArgs = {
  input: UpdateUserReviewInput;
};


export type MutationUpdateVideoArgs = {
  input: UpdateVideoInput;
};


export type MutationUpdateWidgetArgs = {
  input: UpdateWidgetInput;
};


export type MutationUploadVideoArgs = {
  input: UploadVideoInput;
};

export type AddActorToEntityInput = {
  entityId: Scalars['ID']['input'];
  /** The rank of the person in the credits */
  rank?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  /** The person. */
  personId?: InputMaybe<Scalars['ID']['input']>;
  /** The original role for the casting */
  role?: InputMaybe<Scalars['String']['input']>;
  /** Original voice for the role. */
  voiceId?: InputMaybe<Scalars['ID']['input']>;
};

export type AddCompanyToEntityInput = {
  entityId: Scalars['ID']['input'];
  /** The person. */
  companyId: Scalars['ID']['input'];
  /** The person's activity. */
  activity: CompanyActivity;
};

export type AddCreditToEntityInput = {
  entityId: Scalars['ID']['input'];
  /** The person. */
  personId: Scalars['ID']['input'];
  /** The person's activity. */
  activity: PersonActivity;
};

export type AddCreditsToEntityInput = {
  entityId: Scalars['ID']['input'];
  credits: Array<AddCreditsToEntityCreditInput>;
  /** The persons to create first, in the same transaction; the credits name them by key. */
  newPersons?: InputMaybe<Array<AddCreditsToEntityNewPersonInput>>;
  /** The locale of the credits' localizedRole; required with one, refused without any. */
  localeId?: InputMaybe<Scalars['ID']['input']>;
};

export type AddCreditsToEntityCreditInput = {
  /** An existing person; or name one of the list's new persons by its key. */
  personId?: InputMaybe<Scalars['ID']['input']>;
  /** The key of one of `newPersons`, created by this call. */
  newPersonKey?: InputMaybe<Scalars['String']['input']>;
  activity: PersonActivity;
  /** The character for an actor, the job otherwise; stored as the credit's role. */
  role?: InputMaybe<Scalars['String']['input']>;
  /** 1-based rank within the activity; appended at the end when omitted. */
  rank?: InputMaybe<Scalars['Int']['input']>;
  /** The person is the original voice of the character: set on the actor credit of that character when it has no voice yet, otherwise a voice-only credit is created; the rank is ignored. */
  isVoice?: InputMaybe<Scalars['Boolean']['input']>;
  /** The character in that locale, written as the credit's localized row; actors only, ignored on a voice that joins an existing credit. */
  localizedRole?: InputMaybe<Scalars['String']['input']>;
};

/** A person to create with the credits that name its key; several credits may share one person. */
export type AddCreditsToEntityNewPersonInput = {
  key: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  gender: Gender;
};

export type AddDuplicateInput = {
  firstEntityId: Scalars['ID']['input'];
  secondEntityId: Scalars['ID']['input'];
  status: DuplicateStatus;
  priority: DuplicatePriority;
  comment?: InputMaybe<Scalars['String']['input']>;
};

export type AddEntityToTagInput = {
  entityId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};

export type AddEntityToTheaterEventInput = {
  eventId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
};

export type AddFareInput = {
  theaterId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  currency: Currency;
  screenIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ImageHasCategory = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  imageId: Scalars['ID']['output'];
  categoryId: Scalars['ID']['output'];
  rank: Scalars['NonNegativeInt']['output'];
};

export type AddImageToCategoryInput = {
  imageId: Scalars['ID']['input'];
  categoryId: Scalars['ID']['input'];
  rank?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type AddImageToCompanyInput = {
  imageId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
};

export type AddImageToScreenInput = {
  imageId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
};

export type AddImageToTheaterInput = {
  imageId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
};

export type AddLocalizedActorToEntityInput = {
  /** The locale associated to the credit */
  localeId: Scalars['ID']['input'];
  /** The original credit. */
  creditId: Scalars['ID']['input'];
  /** The local role for the casting */
  role?: InputMaybe<Scalars['String']['input']>;
  /** Local voice for the role. */
  voiceId?: InputMaybe<Scalars['ID']['input']>;
};

export type AddPersonNicknameInput = {
  /** The person's id */
  personId: Scalars['ID']['input'];
  /** The person's nickname. */
  nickname: Scalars['String']['input'];
  /** The person's nickname gender. */
  gender: Gender;
};

export type AddReleaseToEntityInput = {
  entityId: Scalars['ID']['input'];
  countryId: Scalars['ID']['input'];
  classificationId?: InputMaybe<Scalars['ID']['input']>;
  visaNumber?: InputMaybe<Scalars['String']['input']>;
  type: ReleaseType;
  flags?: InputMaybe<Array<ReleaseFlag>>;
  /** If release will come soon, but we don't know date. */
  notReleasedYet?: InputMaybe<Scalars['Boolean']['input']>;
  releasedAt?: InputMaybe<Scalars['PartialDate']['input']>;
  releasedAtTime?: InputMaybe<Scalars['TimeWithoutTz']['input']>;
  unreleasedAt?: InputMaybe<Scalars['Date']['input']>;
  /** The company ID if the release is limited to it. */
  limitedCompanyId?: InputMaybe<Scalars['ID']['input']>;
  /** The state/region related to the selected country, if the release is limited to it. */
  limitedLocalizationId?: InputMaybe<Scalars['ID']['input']>;
  distributorsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  openingEstimate?: InputMaybe<Scalars['Int']['input']>;
  advisory?: InputMaybe<Scalars['String']['input']>;
};

export type AddSlideInput = {
  carouselId: Scalars['ID']['input'];
  slideId: Scalars['ID']['input'];
};

export type AddTargetToSpecialOperationInput = {
  specialOperationId: Scalars['ID']['input'];
  entityId?: InputMaybe<Scalars['ID']['input']>;
  rank: Scalars['NonNegativeInt']['input'];
  target?: InputMaybe<Scalars['String']['input']>;
  startsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  data?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type AddTemporalBoxofficeInput = {
  countryId: Scalars['ID']['input'];
  range: DateRangeInput;
  movieId: Scalars['ID']['input'];
  earning?: InputMaybe<Scalars['PositiveInt']['input']>;
  cumulative?: InputMaybe<Scalars['PositiveInt']['input']>;
  copyCount?: InputMaybe<Scalars['PositiveInt']['input']>;
  estimate?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type AddTheaterEventInput = {
  kind?: InputMaybe<TheaterEventKind>;
  type?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  synopsis?: InputMaybe<Scalars['String']['input']>;
  /** embedded trailer */
  trailer?: InputMaybe<Scalars['String']['input']>;
  originCountryId?: InputMaybe<Scalars['ID']['input']>;
  posterId?: InputMaybe<Scalars['ID']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseDate?: InputMaybe<Scalars['DateTime']['input']>;
  genres?: InputMaybe<Array<Genre>>;
  runtime?: InputMaybe<RuntimeInput>;
  certificateId?: InputMaybe<Scalars['ID']['input']>;
  /** The related owner, a Theater or a Company */
  ownerEntityId: Scalars['ID']['input'];
  directors?: InputMaybe<Array<Scalars['String']['input']>>;
  casting?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RuntimeInput = {
  hours: Scalars['Int']['input'];
  minutes: Scalars['Int']['input'];
  seconds?: InputMaybe<Scalars['Int']['input']>;
};

export type AddTokenInput = {
  applicationId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  expiresAt: Scalars['DateTime']['input'];
  scopeId?: InputMaybe<Scalars['ID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
};

export type AddTriviaToEntityInput = {
  triviaId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
};

export type ApplyCastingToEntityInput = {
  /** The entity to applied the casting. */
  receiverEntityId: Scalars['ID']['input'];
  /** The casting to be copied. */
  copiedEntityId: Scalars['ID']['input'];
};

export type ApplyCreditToEntityInput = {
  /** The entity to applied the credit. */
  receiverEntityId: Scalars['ID']['input'];
  /** The credit to be copied. */
  copiedEntityId: Scalars['ID']['input'];
  /** The credit type to applied the credit copy */
  receiverCreditType: AllowedCreditTypeToCopyEnum;
};

export enum AllowedCreditTypeToCopyEnum {
  Person = 'PERSON',
  Company = 'COMPANY'
}

export type BatchCreateSeriesEpisodesInput = {
  seasonId: Scalars['ID']['input'];
  episodesQuantity: Scalars['PositiveInt']['input'];
  startingEpisodeNumber?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type BatchCreateSeriesSeasonsInput = {
  seriesId: Scalars['ID']['input'];
  seasonsQuantity: Scalars['PositiveInt']['input'];
  episodesQuantity?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type BatchImportConfigurationOperationInput = {
  ids: Array<Scalars['ID']['input']>;
  action: ImportConfigurationBatchOperation;
  interval?: InputMaybe<Scalars['Int']['input']>;
};

export enum ImportConfigurationBatchOperation {
  Enable = 'ENABLE',
  Disable = 'DISABLE',
  Trigger = 'TRIGGER'
}

export type CopyFestivalEditionInput = {
  sourceEditionId: Scalars['ID']['input'];
  targetEditionId: Scalars['ID']['input'];
};

export type CopyMovieBrandedDataToLocalizedDataInput = {
  id: Scalars['ID']['input'];
  localeId: Scalars['ID']['input'];
};

export type CreateActitoProfileInput = {
  socialUserId: Scalars['ID']['input'];
};

export type CreateApplicationInput = {
  name: Scalars['String']['input'];
  active: Scalars['Boolean']['input'];
};

export type CreateAuthorInput = {
  brandId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  shortBio: Scalars['String']['input'];
  position?: InputMaybe<Scalars['String']['input']>;
  secureUserId?: InputMaybe<Scalars['ID']['input']>;
  socialUserLegacyId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  stopDate?: InputMaybe<Scalars['Date']['input']>;
  avatarId?: InputMaybe<Scalars['ID']['input']>;
  longBio?: InputMaybe<Scalars['RichText']['input']>;
};

export type CreateAuthorSignatureInput = {
  authorId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  signature: Scalars['String']['input'];
};

export type CreateBrandSearchLinkInput = {
  brandId: Scalars['ID']['input'];
  posterId?: InputMaybe<Scalars['ID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateRedirectionRuleInput = {
  brandId: Scalars['ID']['input'];
  kind: RedirectionRuleKind;
  mode: WritableRedirectionMode;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  sourcePattern?: InputMaybe<Scalars['String']['input']>;
  targetPattern?: InputMaybe<Scalars['String']['input']>;
  sourceEntity?: InputMaybe<Scalars['String']['input']>;
  targetEntity?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  endAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** The reviewToken of redirectionRuleChainRewrites for these values: chains are then flattened as reviewed instead of refused. */
  chainReviewToken?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCarouselInput = {
  brandId: Scalars['ID']['input'];
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  target: Scalars['Tag3D']['input'];
};

export type CreateCertificateInput = {
  countryId: Scalars['ID']['input'];
  localizationId?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CreateClocksInput = {
  theaterId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
  screenId?: InputMaybe<Scalars['ID']['input']>;
  dateRanges: Array<DateRangeWithoutTzInput>;
  showtimes: Array<Scalars['LocalTime']['input']>;
  technos?: InputMaybe<Array<ClockTechno>>;
  sound?: InputMaybe<ClockSound>;
  subtitles?: InputMaybe<Language>;
  language?: InputMaybe<Language>;
  seatingStyle?: InputMaybe<ClockSeatingStyle>;
  amenity?: InputMaybe<ClockAmenity>;
  comment?: InputMaybe<Scalars['String']['input']>;
};

export type DateRangeWithoutTzInput = {
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt: Scalars['DateTimeWithoutTz']['input'];
};

export type CreateCompanyInput = {
  name: Scalars['String']['input'];
  activities?: InputMaybe<Array<CompanyActivitySubactivityArgsType>>;
  countryId: Scalars['ID']['input'];
  providerAsFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  logoId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyActivitySubactivityArgsType = {
  activity: CompanyActivities;
  subactivities?: InputMaybe<Array<InputMaybe<CompanySubactivities>>>;
};

export type CreateCompanyStaffInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  companyId: Scalars['ID']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  department?: InputMaybe<CompanyStaffDepartment>;
  title?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  workPhone?: InputMaybe<Scalars['String']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  copyCompanies?: InputMaybe<Array<Scalars['ID']['input']>>;
  pubCompanies?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateCopyrightInput = {
  name: Scalars['String']['input'];
};

export type CreateCustomerInput = {
  name: Scalars['String']['input'];
  active: Scalars['Boolean']['input'];
  graphBackendEndpoint?: InputMaybe<Scalars['URL']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCustomerQueryInput = {
  name: Scalars['String']['input'];
  template: Scalars['String']['input'];
};

export type CreateEditorialReviewInput = {
  entityId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  brandId: Scalars['ID']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  rating: Scalars['Int']['input'];
  bodyShort?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['RichText']['input']>;
};

export type PublishableEntity = News | EditorialReview;

export type CreateEntityPublicationInput = {
  entityId: Scalars['ID']['input'];
  startsAt: Scalars['DateTime']['input'];
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateFestivalInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  type?: InputMaybe<FestivalType>;
  theme?: InputMaybe<FestivalTheme>;
  countryId: Scalars['ID']['input'];
  posterId?: InputMaybe<Scalars['ID']['input']>;
  localizationId?: InputMaybe<Scalars['ID']['input']>;
  synopsis?: InputMaybe<Scalars['RichText']['input']>;
  locale: Scalars['ID']['input'];
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateFestivalAwardInput = {
  festivalId: Scalars['ID']['input'];
  locale: Scalars['ID']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreateFestivalCompetitionInput = {
  festivalId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  active: Scalars['Boolean']['input'];
  display?: InputMaybe<FestivalCompetitionDisplay>;
  locale: Scalars['ID']['input'];
};

export type CreateFestivalEditionInput = {
  id_festival: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  year: Scalars['Int']['input'];
  editionNumber?: InputMaybe<Scalars['Int']['input']>;
  startsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  active: Scalars['Boolean']['input'];
  locale: Scalars['ID']['input'];
  posterId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateFestivalEditionCompetitionInput = {
  festivalId: Scalars['ID']['input'];
  editionId: Scalars['ID']['input'];
  competitionId: Scalars['ID']['input'];
  active: Scalars['Boolean']['input'];
};

export type CreateFestivalJuryInput = {
  festivalId: Scalars['ID']['input'];
  editionId: Scalars['ID']['input'];
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  personId: Scalars['ID']['input'];
  role: FestivalJuryRole;
};

export type CreateFestivalSelectionInput = {
  festivalId: Scalars['ID']['input'];
  festivalEditionId: Scalars['ID']['input'];
  festivalCompetitionId?: InputMaybe<Scalars['ID']['input']>;
  nominees?: InputMaybe<Array<Scalars['ID']['input']>>;
  festivalAwardIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type FileUploadTokenPayload = {
  uploadUrl: Scalars['URL']['output'];
  uploadToken: Scalars['String']['output'];
  /** Additional parameters that should be set in headers/query while uploading file to uploadUrl */
  additionalStorageParams: Maybe<Scalars['JSON']['output']>;
  relativePath: Scalars['String']['output'];
};

export type CreateFileUploadTokenInput = {
  originalFileName?: InputMaybe<Scalars['String']['input']>;
  /** Type of file to upload (image, video, etc.). If not provided, will be determined from mimeType */
  fileStorageType: FileUploadStorageType;
  /** ISO 8601 duration string, such as PT15M for 15 minutes, (15min by default) */
  iso8601Duration?: InputMaybe<Scalars['String']['input']>;
  /** MIME type of the file to upload */
  mimeType?: InputMaybe<FileUploadMimeType>;
};

/** Supported MIME types for file uploads */
export enum FileUploadMimeType {
  ImageGif = 'IMAGE_GIF',
  ImageJpeg = 'IMAGE_JPEG',
  ImagePng = 'IMAGE_PNG',
  ImageWebp = 'IMAGE_WEBP',
  ApplicationPdf = 'APPLICATION_PDF',
  VideoMp4 = 'VIDEO_MP4',
  VideoWebm = 'VIDEO_WEBM',
  VideoQuicktime = 'VIDEO_QUICKTIME',
  FontTtf = 'FONT_TTF',
  FontOtf = 'FONT_OTF',
  FontWoff = 'FONT_WOFF',
  FontWoff2 = 'FONT_WOFF2'
}

export type CreateImagePayload = Image | DuplicatedImage;

export type DuplicatedImage = {
  image: Image;
};

export type CreateImageInput = {
  /** The MD5 checksum of the image. */
  hash: Scalars['String']['input'];
  /** The path where the image is stored. */
  path: Scalars['String']['input'];
  /** The file size in bytes. */
  size: Scalars['Int']['input'];
  /** The width of the image. */
  width: Scalars['Int']['input'];
  /** The height of the image. */
  height: Scalars['Int']['input'];
  /** The MIME type of the image. */
  mimeType: Scalars['String']['input'];
  /** The copyrights of the image */
  copyrightIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Image type of the image. */
  type?: InputMaybe<ImageTypeEnum>;
  /** Whether the image is available for B2B. */
  b2bAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the image is active. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** The image's title. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The start date of the image. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** The end date of the image. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
};

export enum ImageTypeEnum {
  Poster = 'POSTER',
  PhotoAndStillFrame = 'PHOTO_AND_STILL_FRAME',
  PromotionalPicture = 'PROMOTIONAL_PICTURE',
  Quad = 'QUAD',
  Banner = 'BANNER',
  Slider = 'SLIDER',
  SocialUserAvatar = 'SOCIAL_USER_AVATAR',
  SocialUserBanner = 'SOCIAL_USER_BANNER'
}

export type CreateImageCategoryInput = {
  brandId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  type?: InputMaybe<ImageType>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  rank?: InputMaybe<Scalars['PositiveInt']['input']>;
  sponsored?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateImportConfigurationInput = {
  crawler: Scalars['String']['input'];
  sourceId?: InputMaybe<Scalars['String']['input']>;
  fetchedDays?: InputMaybe<Scalars['Int']['input']>;
  gathertimesTimeout?: InputMaybe<Scalars['PositiveInt']['input']>;
  uri: Scalars['URL']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['Int']['input']>;
  nextRun?: InputMaybe<Scalars['DateTime']['input']>;
  theaterMatcher?: InputMaybe<Scalars['String']['input']>;
  entityMatcher?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  inheritsScreenAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  parameters?: InputMaybe<Scalars['String']['input']>;
  linksOnly?: InputMaybe<Scalars['Boolean']['input']>;
  moviesOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateImportConfigurationsFromCsvInput = {
  content: Scalars['Byte']['input'];
};

export type CreateImportCrawlerInput = {
  /** The crawler name. */
  name: Scalars['String']['input'];
  /** The crawler type. */
  type: CrawlerType;
  /** The crawler country IDs. */
  countryIds: Array<Scalars['ID']['input']>;
  /** The crawler notes. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The crawler tags. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The crawler parameters. */
  parameters?: InputMaybe<Scalars['String']['input']>;
  /** The crawler default configuration. */
  defaultConfiguration?: InputMaybe<CrawlerDefaultConfigurationInput>;
};

export type CrawlerDefaultConfigurationInput = {
  uri?: InputMaybe<Scalars['String']['input']>;
  theaterMatcher?: InputMaybe<Scalars['String']['input']>;
  entityMatcher?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLocalCertificateInput = {
  localizationId: Scalars['ID']['input'];
  releaseId: Scalars['ID']['input'];
  certificateId: Scalars['ID']['input'];
  advisory?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLocaleInput = {
  /** The locale id. */
  id: Scalars['ID']['input'];
  /** The locale country id. */
  countryId: Scalars['ID']['input'];
  /** The locale localization id. */
  localizationId?: InputMaybe<Scalars['ID']['input']>;
  /** The locale sync from id brand. */
  syncFromIdBrand?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateMovieInput = {
  title: Scalars['String']['input'];
  productionYear: Scalars['Int']['input'];
  type: MovieType;
  posterId?: InputMaybe<Scalars['ID']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  additionalTags?: InputMaybe<Array<MovieAdditional>>;
  foxproSync?: InputMaybe<MovieFoxProSyncInput>;
};

export type MovieFoxProSyncInput = {
  create3D: Scalars['Boolean']['input'];
  createImax: Scalars['Boolean']['input'];
};

export type CreateMovieVersionInput = {
  movieId: Scalars['ID']['input'];
  runtime?: InputMaybe<RuntimeInput>;
  version: MovieVersionType;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CreateNewsInput = {
  brandId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  socialTitle?: InputMaybe<Scalars['String']['input']>;
  universe: NewsUniverse;
  category: NewsCategory;
  type: NewsType;
  headline: Scalars['String']['input'];
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateNewsPageInput = {
  newsId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreatePersonInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  formalName?: InputMaybe<Scalars['String']['input']>;
  gender: Gender;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The person's countries. */
  countryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  posterId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreatePresetInput = {
  name: Scalars['String']['input'];
  permissions?: InputMaybe<Array<Permission>>;
  universes?: InputMaybe<Array<Universe>>;
};

export type CreatePressReviewInput = {
  brandId: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  author: Scalars['String']['input'];
  rating: Scalars['Int']['input'];
  body: Scalars['RichText']['input'];
  url?: InputMaybe<Scalars['URL']['input']>;
};

export type CreateProductPayload = {
  product: MatchedProduct;
  releaseCreated: Scalars['Boolean']['output'];
};

export type CreateProductInput = {
  countryId: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
  productType: Scalars['String']['input'];
  relatedEntityId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Currency>;
};

export type CreateScopeInput = {
  name: Scalars['String']['input'];
  customerId: Scalars['ID']['input'];
};

export type CreateScreenInput = {
  name: Scalars['String']['input'];
  theaterId: Scalars['ID']['input'];
  seats?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['Int']['input'];
  size?: InputMaybe<ScreenSizeInput>;
  flags?: InputMaybe<ScreenFlagsInput>;
};

export type ScreenSizeInput = {
  width: Scalars['Float']['input'];
  unit: ScreenSizeUnit;
};

export type ScreenFlagsInput = {
  accessibility?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
  comfort?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
  experience?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
  food?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
  picture?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
  projection?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
  restriction?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
  service?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
  sound?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
};

export type CreateScreensInput = {
  theaterId: Scalars['ID']['input'];
  count: Scalars['Int']['input'];
};

export type CreateSeriesInput = {
  title: Scalars['String']['input'];
  type?: InputMaybe<SeriesType>;
  status?: InputMaybe<SeriesStatus>;
  posterId?: InputMaybe<Scalars['ID']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateSeriesEpisodeInput = {
  seriesId: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSeriesSeasonInput = {
  seriesId: Scalars['ID']['input'];
  status?: InputMaybe<SeriesStatus>;
  posterId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateShowtimesEmbargoInput = {
  countryId: Scalars['ID']['input'];
  movieId: Scalars['ID']['input'];
  bookableAt?: InputMaybe<Scalars['DateTime']['input']>;
  publicAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateSlideInput = {
  brandId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  description: Scalars['String']['input'];
  active: Scalars['Boolean']['input'];
  posterId: Scalars['ID']['input'];
  link: LinkInput;
};

export type LinkInput = {
  url: Scalars['URL']['input'];
  blank: Scalars['Boolean']['input'];
};

export type CreateSlideshowSlideInput = {
  newsId: Scalars['ID']['input'];
  imageId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  copyrightIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  body?: InputMaybe<Scalars['RichText']['input']>;
};

export type CreateSpecialOperationInput = {
  brandId: Scalars['ID']['input'];
  code: SpecialOperationCode;
  data?: InputMaybe<Scalars['JSONObject']['input']>;
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startsAt: Scalars['DateTimeWithoutTz']['input'];
};

export type BannerHpSpecialOperation = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  entity: Maybe<SpecialOperationEntity>;
  targets: Array<SpecialOperationTarget>;
  code: SpecialOperationCode;
  startsAt: Scalars['DateTimeWithoutTz']['output'];
  endsAt: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  /** Dot paths of the data fields required for activation that are missing or invalid. An update that leaves any of them missing deactivates the operation, and activating it is refused while any is missing. */
  missingRequiredFields: Array<Scalars['String']['output']>;
  data: BannerHpData;
  medias: Maybe<SpecialOperationMedia>;
  name: Maybe<Scalars['String']['output']>;
};


export type BannerHpSpecialOperationTargetsArgs = {
  target?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
};

export type BannerHpDataInput = {
  link_desktop?: InputMaybe<Scalars['URL']['input']>;
  link_mobile?: InputMaybe<Scalars['URL']['input']>;
  medias?: InputMaybe<BannerHpDataMediasInput>;
};

export type BannerHpDataMediasInput = {
  desktop?: InputMaybe<Scalars['URL']['input']>;
  mobile?: InputMaybe<Scalars['URL']['input']>;
};

export type CanalHomeSpecialOperation = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  entity: Maybe<SpecialOperationEntity>;
  targets: Array<SpecialOperationTarget>;
  code: SpecialOperationCode;
  startsAt: Scalars['DateTimeWithoutTz']['output'];
  endsAt: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  /** Dot paths of the data fields required for activation that are missing or invalid. An update that leaves any of them missing deactivates the operation, and activating it is refused while any is missing. */
  missingRequiredFields: Array<Scalars['String']['output']>;
  data: CanalHomeData;
  medias: Maybe<SpecialOperationMedia>;
  name: Maybe<Scalars['String']['output']>;
};


export type CanalHomeSpecialOperationTargetsArgs = {
  target?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
};

export type CanalHomeDataInput = {
  heading1?: InputMaybe<Scalars['String']['input']>;
  heading2?: InputMaybe<Scalars['String']['input']>;
  heading3?: InputMaybe<Scalars['String']['input']>;
};

export type ClassiqueHomeSpecialOperation = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  entity: Maybe<SpecialOperationEntity>;
  targets: Array<SpecialOperationTarget>;
  code: SpecialOperationCode;
  startsAt: Scalars['DateTimeWithoutTz']['output'];
  endsAt: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  /** Dot paths of the data fields required for activation that are missing or invalid. An update that leaves any of them missing deactivates the operation, and activating it is refused while any is missing. */
  missingRequiredFields: Array<Scalars['String']['output']>;
  data: ClassiqueHomeData;
  medias: Maybe<SpecialOperationMedia>;
  name: Maybe<Scalars['String']['output']>;
};


export type ClassiqueHomeSpecialOperationTargetsArgs = {
  target?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
};

export type ClassiqueHomeDataInput = {
  heading1?: InputMaybe<Scalars['String']['input']>;
  heading2?: InputMaybe<Scalars['String']['input']>;
  heading3?: InputMaybe<Scalars['String']['input']>;
  link1_label?: InputMaybe<Scalars['String']['input']>;
  link1_url?: InputMaybe<Scalars['URL']['input']>;
  link2_label?: InputMaybe<Scalars['String']['input']>;
  link2_url?: InputMaybe<Scalars['URL']['input']>;
};

export type Club300SpecialOperation = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  entity: Maybe<SpecialOperationEntity>;
  targets: Array<SpecialOperationTarget>;
  code: SpecialOperationCode;
  startsAt: Scalars['DateTimeWithoutTz']['output'];
  endsAt: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  /** Dot paths of the data fields required for activation that are missing or invalid. An update that leaves any of them missing deactivates the operation, and activating it is refused while any is missing. */
  missingRequiredFields: Array<Scalars['String']['output']>;
  data: Club300Data;
  medias: Maybe<SpecialOperationMedia>;
  name: Maybe<Scalars['String']['output']>;
};


export type Club300SpecialOperationTargetsArgs = {
  target?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
};

export type Club300DataInput = {
  _placeholder?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DisneyHomeSpecialOperation = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  entity: Maybe<SpecialOperationEntity>;
  targets: Array<SpecialOperationTarget>;
  code: SpecialOperationCode;
  startsAt: Scalars['DateTimeWithoutTz']['output'];
  endsAt: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  /** Dot paths of the data fields required for activation that are missing or invalid. An update that leaves any of them missing deactivates the operation, and activating it is refused while any is missing. */
  missingRequiredFields: Array<Scalars['String']['output']>;
  data: DisneyHomeData;
  medias: Maybe<SpecialOperationMedia>;
  name: Maybe<Scalars['String']['output']>;
};


export type DisneyHomeSpecialOperationTargetsArgs = {
  target?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
};

export type DisneyHomeDataInput = {
  medias?: InputMaybe<DisneyHomeDataMediasInput>;
};

export type DisneyHomeDataMediasInput = {
  native_grand_angle?: InputMaybe<DisneyHomeDataMediasNativeGrandAngleInput>;
};

export type DisneyHomeDataMediasNativeGrandAngleInput = {
  image_url?: InputMaybe<Scalars['URL']['input']>;
  url?: InputMaybe<Scalars['URL']['input']>;
};

export type DolbyHomeSpecialOperation = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  entity: Maybe<SpecialOperationEntity>;
  targets: Array<SpecialOperationTarget>;
  code: SpecialOperationCode;
  startsAt: Scalars['DateTimeWithoutTz']['output'];
  endsAt: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  /** Dot paths of the data fields required for activation that are missing or invalid. An update that leaves any of them missing deactivates the operation, and activating it is refused while any is missing. */
  missingRequiredFields: Array<Scalars['String']['output']>;
  data: DolbyHomeData;
  medias: Maybe<SpecialOperationMedia>;
  name: Maybe<Scalars['String']['output']>;
};


export type DolbyHomeSpecialOperationTargetsArgs = {
  target?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
};

export type DolbyHomeDataInput = {
  _placeholder?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmergenceMovieSpecialOperation = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  entity: Maybe<SpecialOperationEntity>;
  targets: Array<SpecialOperationTarget>;
  code: SpecialOperationCode;
  startsAt: Scalars['DateTimeWithoutTz']['output'];
  endsAt: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  /** Dot paths of the data fields required for activation that are missing or invalid. An update that leaves any of them missing deactivates the operation, and activating it is refused while any is missing. */
  missingRequiredFields: Array<Scalars['String']['output']>;
  data: EmergenceMovieData;
  medias: Maybe<SpecialOperationMedia>;
  name: Maybe<Scalars['String']['output']>;
};


export type EmergenceMovieSpecialOperationTargetsArgs = {
  target?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
};

export type EmergenceMovieDataInput = {
  distribution?: InputMaybe<EmergenceDistribution>;
  provider?: InputMaybe<SvodProvider>;
  release_date?: InputMaybe<Scalars['DateTimeISO8601']['input']>;
};

export type EmergenceSeriesSpecialOperation = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  entity: Maybe<SpecialOperationEntity>;
  targets: Array<SpecialOperationTarget>;
  code: SpecialOperationCode;
  startsAt: Scalars['DateTimeWithoutTz']['output'];
  endsAt: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  /** Dot paths of the data fields required for activation that are missing or invalid. An update that leaves any of them missing deactivates the operation, and activating it is refused while any is missing. */
  missingRequiredFields: Array<Scalars['String']['output']>;
  data: EmergenceSeriesData;
  medias: Maybe<SpecialOperationMedia>;
  name: Maybe<Scalars['String']['output']>;
};


export type EmergenceSeriesSpecialOperationTargetsArgs = {
  target?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
};

export type EmergenceSeriesDataInput = {
  provider?: InputMaybe<SvodProvider>;
  release_date?: InputMaybe<Scalars['DateTimeISO8601']['input']>;
};

export type EmergenceSvodSpecialOperation = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  entity: Maybe<SpecialOperationEntity>;
  targets: Array<SpecialOperationTarget>;
  code: SpecialOperationCode;
  startsAt: Scalars['DateTimeWithoutTz']['output'];
  endsAt: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  /** Dot paths of the data fields required for activation that are missing or invalid. An update that leaves any of them missing deactivates the operation, and activating it is refused while any is missing. */
  missingRequiredFields: Array<Scalars['String']['output']>;
  data: EmergenceSvodData;
  medias: Maybe<SpecialOperationMedia>;
  name: Maybe<Scalars['String']['output']>;
};


export type EmergenceSvodSpecialOperationTargetsArgs = {
  target?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
};

export type EmergenceSvodDataInput = {
  provider?: InputMaybe<SvodProvider>;
  release_date?: InputMaybe<Scalars['DateTimeISO8601']['input']>;
};

export type EmergenceTheaterSpecialOperation = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  entity: Maybe<SpecialOperationEntity>;
  targets: Array<SpecialOperationTarget>;
  code: SpecialOperationCode;
  startsAt: Scalars['DateTimeWithoutTz']['output'];
  endsAt: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  /** Dot paths of the data fields required for activation that are missing or invalid. An update that leaves any of them missing deactivates the operation, and activating it is refused while any is missing. */
  missingRequiredFields: Array<Scalars['String']['output']>;
  data: EmergenceTheaterData;
  medias: Maybe<SpecialOperationMedia>;
  name: Maybe<Scalars['String']['output']>;
};


export type EmergenceTheaterSpecialOperationTargetsArgs = {
  target?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
};

export type EmergenceTheaterDataInput = {
  release_date?: InputMaybe<Scalars['DateTimeISO8601']['input']>;
};

export type FestivalSectionSpecialOperation = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  entity: Maybe<SpecialOperationEntity>;
  targets: Array<SpecialOperationTarget>;
  code: SpecialOperationCode;
  startsAt: Scalars['DateTimeWithoutTz']['output'];
  endsAt: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  /** Dot paths of the data fields required for activation that are missing or invalid. An update that leaves any of them missing deactivates the operation, and activating it is refused while any is missing. */
  missingRequiredFields: Array<Scalars['String']['output']>;
  data: FestivalSectionData;
  medias: Maybe<SpecialOperationMedia>;
  name: Maybe<Scalars['String']['output']>;
};


export type FestivalSectionSpecialOperationTargetsArgs = {
  target?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
};

export type FestivalSectionDataInput = {
  festivalEditionId?: InputMaybe<Scalars['Int']['input']>;
  festivalId?: InputMaybe<Scalars['Int']['input']>;
  playlist?: InputMaybe<Array<InputMaybe<FestivalSectionDataPlaylistEntryInput>>>;
};

export type FestivalSectionDataPlaylistEntryInput = {
  key: Scalars['String']['input'];
  value?: InputMaybe<FestivalSectionDataPlaylistValueInput>;
};

export type FestivalSectionDataPlaylistValueInput = {
  movies?: InputMaybe<Array<Scalars['Int']['input']>>;
  series?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FilmesOnlineSpecialOperation = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  entity: Maybe<SpecialOperationEntity>;
  targets: Array<SpecialOperationTarget>;
  code: SpecialOperationCode;
  startsAt: Scalars['DateTimeWithoutTz']['output'];
  endsAt: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  /** Dot paths of the data fields required for activation that are missing or invalid. An update that leaves any of them missing deactivates the operation, and activating it is refused while any is missing. */
  missingRequiredFields: Array<Scalars['String']['output']>;
  data: FilmesOnlineData;
  medias: Maybe<SpecialOperationMedia>;
  name: Maybe<Scalars['String']['output']>;
};


export type FilmesOnlineSpecialOperationTargetsArgs = {
  target?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
};

export type FilmesOnlineDataInput = {
  heading1?: InputMaybe<Scalars['String']['input']>;
  heading2?: InputMaybe<Scalars['String']['input']>;
  heading3?: InputMaybe<Scalars['String']['input']>;
  heading4?: InputMaybe<Scalars['String']['input']>;
  heading5?: InputMaybe<Scalars['String']['input']>;
  heading6?: InputMaybe<Scalars['String']['input']>;
  heading7?: InputMaybe<Scalars['String']['input']>;
  heading8?: InputMaybe<Scalars['String']['input']>;
  heading9?: InputMaybe<Scalars['String']['input']>;
  heading10?: InputMaybe<Scalars['String']['input']>;
};

export type ImaxHomeSpecialOperation = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  entity: Maybe<SpecialOperationEntity>;
  targets: Array<SpecialOperationTarget>;
  code: SpecialOperationCode;
  startsAt: Scalars['DateTimeWithoutTz']['output'];
  endsAt: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  /** Dot paths of the data fields required for activation that are missing or invalid. An update that leaves any of them missing deactivates the operation, and activating it is refused while any is missing. */
  missingRequiredFields: Array<Scalars['String']['output']>;
  data: ImaxHomeData;
  medias: Maybe<SpecialOperationMedia>;
  name: Maybe<Scalars['String']['output']>;
};


export type ImaxHomeSpecialOperationTargetsArgs = {
  target?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
};

export type ImaxHomeDataInput = {
  _placeholder?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IndelebileHomeSpecialOperation = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  entity: Maybe<SpecialOperationEntity>;
  targets: Array<SpecialOperationTarget>;
  code: SpecialOperationCode;
  startsAt: Scalars['DateTimeWithoutTz']['output'];
  endsAt: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  /** Dot paths of the data fields required for activation that are missing or invalid. An update that leaves any of them missing deactivates the operation, and activating it is refused while any is missing. */
  missingRequiredFields: Array<Scalars['String']['output']>;
  data: IndelebileHomeData;
  medias: Maybe<SpecialOperationMedia>;
  name: Maybe<Scalars['String']['output']>;
};


export type IndelebileHomeSpecialOperationTargetsArgs = {
  target?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
};

export type IndelebileHomeDataInput = {
  heading1?: InputMaybe<Scalars['String']['input']>;
  heading2?: InputMaybe<Scalars['String']['input']>;
  heading3?: InputMaybe<Scalars['String']['input']>;
};

export type M6HomeSpecialOperation = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  entity: Maybe<SpecialOperationEntity>;
  targets: Array<SpecialOperationTarget>;
  code: SpecialOperationCode;
  startsAt: Scalars['DateTimeWithoutTz']['output'];
  endsAt: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  /** Dot paths of the data fields required for activation that are missing or invalid. An update that leaves any of them missing deactivates the operation, and activating it is refused while any is missing. */
  missingRequiredFields: Array<Scalars['String']['output']>;
  data: M6HomeData;
  medias: Maybe<SpecialOperationMedia>;
  name: Maybe<Scalars['String']['output']>;
};


export type M6HomeSpecialOperationTargetsArgs = {
  target?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
};

export type M6HomeDataInput = {
  heading1?: InputMaybe<Scalars['String']['input']>;
  heading2?: InputMaybe<Scalars['String']['input']>;
  heading3?: InputMaybe<Scalars['String']['input']>;
};

export type MaxHomeSpecialOperation = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  entity: Maybe<SpecialOperationEntity>;
  targets: Array<SpecialOperationTarget>;
  code: SpecialOperationCode;
  startsAt: Scalars['DateTimeWithoutTz']['output'];
  endsAt: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  /** Dot paths of the data fields required for activation that are missing or invalid. An update that leaves any of them missing deactivates the operation, and activating it is refused while any is missing. */
  missingRequiredFields: Array<Scalars['String']['output']>;
  data: MaxHomeData;
  medias: Maybe<SpecialOperationMedia>;
  name: Maybe<Scalars['String']['output']>;
};


export type MaxHomeSpecialOperationTargetsArgs = {
  target?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
};

export type MaxHomeDataInput = {
  heading1?: InputMaybe<Scalars['String']['input']>;
  heading2?: InputMaybe<Scalars['String']['input']>;
  heading3?: InputMaybe<Scalars['String']['input']>;
};

export type NovelasHomeSpecialOperation = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  entity: Maybe<SpecialOperationEntity>;
  targets: Array<SpecialOperationTarget>;
  code: SpecialOperationCode;
  startsAt: Scalars['DateTimeWithoutTz']['output'];
  endsAt: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  /** Dot paths of the data fields required for activation that are missing or invalid. An update that leaves any of them missing deactivates the operation, and activating it is refused while any is missing. */
  missingRequiredFields: Array<Scalars['String']['output']>;
  data: NovelasHomeData;
  medias: Maybe<SpecialOperationMedia>;
  name: Maybe<Scalars['String']['output']>;
};


export type NovelasHomeSpecialOperationTargetsArgs = {
  target?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
};

export type NovelasHomeDataInput = {
  _placeholder?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RollerHomeSpecialOperation = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  entity: Maybe<SpecialOperationEntity>;
  targets: Array<SpecialOperationTarget>;
  code: SpecialOperationCode;
  startsAt: Scalars['DateTimeWithoutTz']['output'];
  endsAt: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  /** Dot paths of the data fields required for activation that are missing or invalid. An update that leaves any of them missing deactivates the operation, and activating it is refused while any is missing. */
  missingRequiredFields: Array<Scalars['String']['output']>;
  data: RollerHomeData;
  medias: Maybe<SpecialOperationMedia>;
  name: Maybe<Scalars['String']['output']>;
};


export type RollerHomeSpecialOperationTargetsArgs = {
  target?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
};

export type RollerHomeDataInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SponsoredAutocompleteSpecialOperation = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  entity: Maybe<SpecialOperationEntity>;
  targets: Array<SpecialOperationTarget>;
  code: SpecialOperationCode;
  startsAt: Scalars['DateTimeWithoutTz']['output'];
  endsAt: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  /** Dot paths of the data fields required for activation that are missing or invalid. An update that leaves any of them missing deactivates the operation, and activating it is refused while any is missing. */
  missingRequiredFields: Array<Scalars['String']['output']>;
  data: SponsoredAutocompleteData;
  medias: Maybe<SpecialOperationMedia>;
  name: Maybe<Scalars['String']['output']>;
};


export type SponsoredAutocompleteSpecialOperationTargetsArgs = {
  target?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
};

export type SponsoredAutocompleteDataInput = {
  release_date?: InputMaybe<Scalars['DateTimeISO8601']['input']>;
};

export type Tf1HomeSpecialOperation = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  entity: Maybe<SpecialOperationEntity>;
  targets: Array<SpecialOperationTarget>;
  code: SpecialOperationCode;
  startsAt: Scalars['DateTimeWithoutTz']['output'];
  endsAt: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  /** Dot paths of the data fields required for activation that are missing or invalid. An update that leaves any of them missing deactivates the operation, and activating it is refused while any is missing. */
  missingRequiredFields: Array<Scalars['String']['output']>;
  data: Tf1HomeData;
  medias: Maybe<SpecialOperationMedia>;
  name: Maybe<Scalars['String']['output']>;
};


export type Tf1HomeSpecialOperationTargetsArgs = {
  target?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
};

export type Tf1HomeDataInput = {
  heading1?: InputMaybe<Scalars['String']['input']>;
  heading2?: InputMaybe<Scalars['String']['input']>;
  heading3?: InputMaybe<Scalars['String']['input']>;
};

export type TicketAnchorSpecialOperation = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  entity: Maybe<SpecialOperationEntity>;
  targets: Array<SpecialOperationTarget>;
  code: SpecialOperationCode;
  startsAt: Scalars['DateTimeWithoutTz']['output'];
  endsAt: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  /** Dot paths of the data fields required for activation that are missing or invalid. An update that leaves any of them missing deactivates the operation, and activating it is refused while any is missing. */
  missingRequiredFields: Array<Scalars['String']['output']>;
  data: TicketAnchorData;
  medias: Maybe<SpecialOperationMedia>;
  name: Maybe<Scalars['String']['output']>;
};


export type TicketAnchorSpecialOperationTargetsArgs = {
  target?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
};

export type TicketAnchorDataInput = {
  cta_text_after_release?: InputMaybe<Scalars['String']['input']>;
  cta_text_before_release?: InputMaybe<Scalars['String']['input']>;
  display_showtimes?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<Scalars['URL']['input']>;
  medias?: InputMaybe<SpecialOpsMediasInput>;
  release_date?: InputMaybe<Scalars['DateTimeISO8601']['input']>;
  slots?: InputMaybe<Array<TicketAnchorSlot>>;
  text_after_release?: InputMaybe<Scalars['String']['input']>;
  text_before_release?: InputMaybe<Scalars['String']['input']>;
  text_color?: InputMaybe<Scalars['String']['input']>;
};

export type SpecialOpsMediasInput = {
  desktop?: InputMaybe<Scalars['URL']['input']>;
  desktopHp?: InputMaybe<Scalars['URL']['input']>;
  mobile?: InputMaybe<Scalars['URL']['input']>;
};

export type VodHomeSpecialOperation = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  entity: Maybe<SpecialOperationEntity>;
  targets: Array<SpecialOperationTarget>;
  code: SpecialOperationCode;
  startsAt: Scalars['DateTimeWithoutTz']['output'];
  endsAt: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  /** Dot paths of the data fields required for activation that are missing or invalid. An update that leaves any of them missing deactivates the operation, and activating it is refused while any is missing. */
  missingRequiredFields: Array<Scalars['String']['output']>;
  data: VodHomeData;
  medias: Maybe<SpecialOperationMedia>;
  name: Maybe<Scalars['String']['output']>;
};


export type VodHomeSpecialOperationTargetsArgs = {
  target?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
};

export type VodHomeDataInput = {
  heading1?: InputMaybe<Scalars['String']['input']>;
  heading2?: InputMaybe<Scalars['String']['input']>;
};

export type MobileDdaySpecialOperation = {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The associated brand. */
  brand: Brand;
  entity: Maybe<SpecialOperationEntity>;
  targets: Array<SpecialOperationTarget>;
  code: SpecialOperationCode;
  startsAt: Scalars['DateTimeWithoutTz']['output'];
  endsAt: Maybe<Scalars['DateTimeWithoutTz']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  /** Dot paths of the data fields required for activation that are missing or invalid. An update that leaves any of them missing deactivates the operation, and activating it is refused while any is missing. */
  missingRequiredFields: Array<Scalars['String']['output']>;
  data: MobileDdayData;
  medias: Maybe<SpecialOperationMedia>;
  name: Maybe<Scalars['String']['output']>;
};


export type MobileDdaySpecialOperationTargetsArgs = {
  target?: InputMaybe<Array<Scalars['Tag3D']['input']>>;
};

export type MobileDdayDataInput = {
  dday_campaign?: InputMaybe<Scalars['String']['input']>;
  dday_movie_id?: InputMaybe<Scalars['Int']['input']>;
  dday_movie_list_id?: InputMaybe<Array<Scalars['Int']['input']>>;
  dday_movie_list_title?: InputMaybe<Scalars['String']['input']>;
  dday_force_uppercase_headers?: InputMaybe<Scalars['Boolean']['input']>;
  dday_nav_background_color_light?: InputMaybe<Scalars['String']['input']>;
  dday_nav_background_color_dark?: InputMaybe<Scalars['String']['input']>;
  dday_nav_font_color_light?: InputMaybe<Scalars['String']['input']>;
  dday_nav_font_color_dark?: InputMaybe<Scalars['String']['input']>;
  dday_main_color_light?: InputMaybe<Scalars['String']['input']>;
  dday_main_color_dark?: InputMaybe<Scalars['String']['input']>;
  dday_title_spacing_between_letters?: InputMaybe<Scalars['Float']['input']>;
  dday_title_see_more_title_displayed?: InputMaybe<Scalars['Boolean']['input']>;
  dday_background_color?: InputMaybe<Scalars['String']['input']>;
  dday_force_theme_light?: InputMaybe<Scalars['Boolean']['input']>;
  dday_force_theme_dark?: InputMaybe<Scalars['Boolean']['input']>;
  dday_status_bar_icons_light?: InputMaybe<Scalars['Boolean']['input']>;
  dday_status_bar_icons_dark?: InputMaybe<Scalars['Boolean']['input']>;
  dday_segmented_color_light?: InputMaybe<Scalars['String']['input']>;
  dday_segmented_color_dark?: InputMaybe<Scalars['String']['input']>;
  dday_segmented_selected_font_color_light?: InputMaybe<Scalars['String']['input']>;
  dday_segmented_selected_font_color_dark?: InputMaybe<Scalars['String']['input']>;
  dday_date?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  dday_last_date?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  dday_assets_version?: InputMaybe<Scalars['Int']['input']>;
  dday_assets_hash?: InputMaybe<Scalars['String']['input']>;
  dday_font_url?: InputMaybe<Scalars['URL']['input']>;
  dday_font_size?: InputMaybe<Scalars['Int']['input']>;
  dday_movie_background_url?: InputMaybe<Scalars['URL']['input']>;
  dday_movie_background_id?: InputMaybe<Scalars['ID']['input']>;
  dday_movie_logo_url?: InputMaybe<Scalars['URL']['input']>;
  dday_movie_logo_id?: InputMaybe<Scalars['ID']['input']>;
  dday_splash_background_url?: InputMaybe<Scalars['URL']['input']>;
  dday_splash_background_id?: InputMaybe<Scalars['ID']['input']>;
  dday_splash_logo_url?: InputMaybe<Scalars['URL']['input']>;
  dday_splash_logo_id?: InputMaybe<Scalars['ID']['input']>;
  dday_splashscreen_status_bar_color_style?: InputMaybe<Scalars['String']['input']>;
  dday_splashscreen_activity_color?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTagInput = {
  /** The tag's name. */
  name: Scalars['String']['input'];
  /** The tag's brand. */
  brandId: Scalars['ID']['input'];
  /** The tag's type. */
  type: TagType;
};

export type CreateTeamInput = {
  name: Scalars['String']['input'];
  countryIds: Array<Scalars['ID']['input']>;
  brandIds: Array<Scalars['ID']['input']>;
  localeIds: Array<Scalars['ID']['input']>;
};

export type CreateTheaterInput = {
  name: Scalars['String']['input'];
  countryId: Scalars['ID']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  logoId?: InputMaybe<Scalars['ID']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTheaterFeedInput = {
  title: Scalars['NonEmptyString']['input'];
  body: Scalars['NonEmptyString']['input'];
  type: TheaterFeedType;
  theaterId: Scalars['ID']['input'];
  startsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  startsDisplayAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  endsDisplayAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateTriviaInput = {
  brandId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<TriviaType>;
  body: Scalars['RichText']['input'];
};

export type CreateUserInput = {
  name: Scalars['String']['input'];
  email: Scalars['EmailAddress']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  application?: InputMaybe<Scalars['Boolean']['input']>;
  permissions?: InputMaybe<Array<Permission>>;
  presetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  allowedBrandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  allowedCountryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  allowedLocaleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  allowedNewsScopes?: InputMaybe<Array<NewsScope>>;
};

export type CreateVideoInput = {
  /** The poster of the video */
  posterId?: InputMaybe<Scalars['ID']['input']>;
  /** The active status of the video. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The type of the video */
  videoType?: InputMaybe<VideoType>;
  /** The title of the video */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The description of the video */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The restriction type of the video */
  restrictionType?: InputMaybe<Array<RestrictionType>>;
  /** The video linked entity id */
  entityId?: InputMaybe<Scalars['ID']['input']>;
  /** The brand of the video */
  brandId?: InputMaybe<Scalars['ID']['input']>;
  /** The universe of the video */
  universe?: InputMaybe<VideoUniverse>;
};

export type CreateWidgetInput = {
  /** The widget type. */
  type: WidgetType;
  /** The widget name. */
  name: Scalars['String']['input'];
  /** The url type. */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteBrandEntityClubInput = {
  brandId: Scalars['ID']['input'];
  clubId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
};

export type DeleteBrandSearchLinkInput = {
  id: Scalars['ID']['input'];
};

export type DeleteRedirectionRulesInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type DeleteCarouselInput = {
  carouselId: Scalars['ID']['input'];
};

export type DeleteCertificateInput = {
  /** The certificate id. */
  id: Scalars['ID']['input'];
};

export type DeleteClockInput = {
  clockId: Scalars['ID']['input'];
};

export type DeleteCompanyStaffInput = {
  companyStaffId: Scalars['ID']['input'];
};

export type DeleteCreditInput = {
  creditId: Scalars['ID']['input'];
};

export type DeletePersonCreditsImportReportInput = {
  reportId: Scalars['ID']['input'];
  /** The line to remove. */
  section: PersonCreditsImportDataType;
};

export type DeletePersonImagesImportInput = {
  personId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
};

export type DeleteCustomerInput = {
  customerId: Scalars['ID']['input'];
};

export type DeleteCustomerQueryInput = {
  customerQueryId: Scalars['ID']['input'];
};

export type DeleteEditorialReviewInput = {
  editorialReviewId: Scalars['ID']['input'];
};

export type DeleteEntityPublicationInput = {
  entityId: Scalars['ID']['input'];
  index: Scalars['NonNegativeInt']['input'];
};

export type DeleteEntityPayload = Movie | Person | Series | SeriesSeason | SeriesEpisode;

export type DeleteEntityInput = {
  /** The entity id. */
  entityId: Scalars['ID']['input'];
};

export type DeleteEntityCompanyInput = {
  entityCompanyId: Scalars['ID']['input'];
};

export type DeleteEntityFromTagInput = {
  entityId: Scalars['ID']['input'];
  tagId: Scalars['ID']['input'];
};

export type DeleteEntityFromTheaterEventInput = {
  eventId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
};

export type DeleteEntityLinkInput = {
  sourceId: Scalars['ID']['input'];
  targetId: Scalars['ID']['input'];
  linkType: EntityLinkType;
};

export type DeleteFareInput = {
  fareId: Scalars['ID']['input'];
};

export type DeleteFestivalInput = {
  festivalId: Scalars['ID']['input'];
};

export type DeleteFestivalAwardInput = {
  id: Scalars['ID']['input'];
};

export type DeleteFestivalEditionInput = {
  festivalEditionId: Scalars['ID']['input'];
};

export type DeleteFestivalEditionCompetitionInput = {
  festivalEditionId: Scalars['ID']['input'];
  festivalCompetitionId: Scalars['ID']['input'];
};

export type DeleteFestivalJuryInput = {
  juryId: Scalars['ID']['input'];
};

export type DeleteFestivalSelectionInput = {
  festivalSelectionId: Scalars['ID']['input'];
};

export type DeleteIgnoredProductInput = {
  productId: Scalars['ID']['input'];
};

export type DeleteIgnoredShowtimeSourceInput = {
  sourceType: ShowtimeSourceType;
  sourceName: Scalars['String']['input'];
  sourceId: Scalars['String']['input'];
};

export type DeleteImageCategoryInput = {
  id: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
};

export type DeleteImageFromCompanyInput = {
  imageId: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
};

export type DeleteImageFromScreenInput = {
  imageId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
};

export type DeleteImageFromTheaterInput = {
  imageId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
};

export type DeleteImportConfigurationInput = {
  id: Scalars['ID']['input'];
};

export type DeleteImportCrawlerInput = {
  /** The ID of the crawler to delete. */
  crawlerId: Scalars['ID']['input'];
};

export type DeleteImportShowtimesInput = {
  theaterId: Scalars['ID']['input'];
  entityId?: InputMaybe<Scalars['ID']['input']>;
  range?: InputMaybe<DateRangeInput>;
};

export type DeleteLocalCertificateInput = {
  releaseId: Scalars['ID']['input'];
  certificateId: Scalars['ID']['input'];
  localizationId: Scalars['ID']['input'];
};

export type DeleteLocalCreditInput = {
  creditId: Scalars['ID']['input'];
  localeId: Scalars['ID']['input'];
};

export type DeleteLocaleInput = {
  /** The locale id. */
  id: Scalars['ID']['input'];
};

export type DeleteMatchedShowtimeEntityInput = {
  sourceName: Scalars['String']['input'];
  sourceId: Scalars['String']['input'];
  entityId: Scalars['ID']['input'];
};

export type DeleteMatchedShowtimeTheaterInput = {
  sourceName: Scalars['String']['input'];
  sourceId: Scalars['String']['input'];
};

export type DeleteMovieVersionInput = {
  versionId: Scalars['ID']['input'];
};

export type DeleteNewsInput = {
  newsId: Scalars['ID']['input'];
};

export type DeleteNewsPageInput = {
  newsPageId: Scalars['ID']['input'];
};

export type DeleteOrAnonymizeSocialUserInput = {
  socialUserId: Scalars['ID']['input'];
};

export type DeletePersonNicknameInput = {
  /** The nickname id */
  nicknameId: Scalars['ID']['input'];
};

export type DeletePresetInput = {
  presetId: Scalars['ID']['input'];
};

export type DeletePressReviewInput = {
  pressReviewId: Scalars['ID']['input'];
};

export type DeleteReleaseFromEntityInput = {
  entityHasReleaseId: Scalars['ID']['input'];
};

export type DeleteScopeInput = {
  scopeId: Scalars['ID']['input'];
};

export type DeleteScreenInput = {
  screenId: Scalars['ID']['input'];
};

export type DeleteShowtimesEmbargoInput = {
  embargoId: Scalars['ID']['input'];
};

export type DeleteSlideshowSlideInput = {
  slideId: Scalars['ID']['input'];
};

export type DeleteSpecialOperationInput = {
  specialOperationId: Scalars['ID']['input'];
};

export type DeleteTeamInput = {
  teamId: Scalars['ID']['input'];
};

export type DeleteTemporalBoxofficeInput = {
  id: Scalars['ID']['input'];
};

export type DeleteTheaterEventInput = {
  id: Scalars['ID']['input'];
};

export type DeleteTheaterFeedInput = {
  theaterFeedId: Scalars['ID']['input'];
};

export type DeleteTokenInput = {
  tokenId: Scalars['ID']['input'];
};

export type DeleteTriviaInput = {
  id: Scalars['ID']['input'];
};

export type DeleteTriviaFromEntityInput = {
  triviaId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
};

export type DeleteVideoInput = {
  videoId: Scalars['ID']['input'];
};

export type UploadVideoPayload = VideoLegacy | VideoB2B;

export type VideoB2B = Node & Entity & Ref & Video & {
  /** The ID of this object. */
  id: Scalars['ID']['output'];
  /** The original ID of this object. */
  rawId: Scalars['NonNegativeInt']['output'];
  /** The reference of this object. */
  ref: Scalars['ID']['output'];
  /** Indicates whether the object is active or not */
  active: Scalars['Boolean']['output'];
  /** Other IDs from external source to represent the screen. */
  externalIDs: Array<ExternalId>;
  /** The metadata of this entity. */
  metadata: Metadata;
  /** The title of the video. */
  title: Maybe<Scalars['String']['output']>;
  /** The generated title of the video */
  generatedTitle: Maybe<Scalars['String']['output']>;
  /** The type of the video. */
  type: VideoType;
  /** The universe of the video */
  universe: Maybe<VideoUniverse>;
  /** The start date of the video */
  startsAt: Maybe<Scalars['DateTime']['output']>;
  /** The end date of the video */
  endsAt: Maybe<Scalars['DateTime']['output']>;
  /** The language of the video. */
  language: Maybe<Language>;
  /** The subtitle of the video. */
  subtitle: Maybe<Language>;
  /** The restrictions of the video */
  restrictions: Array<RestrictionType>;
  /** The description of the video. */
  description: Maybe<Scalars['String']['output']>;
  /** The snapshot of the video. */
  snapshot: Maybe<Image>;
  /** The final name of the combination of the related copyrights */
  copyrightName: Maybe<Scalars['String']['output']>;
  /** The copyright of the video */
  copyrights: Maybe<Array<Copyright>>;
  /** The embed code of the video */
  embedCode: Maybe<Scalars['String']['output']>;
  /** The duration of the video. */
  duration: Maybe<Runtime>;
  /** Entities linked to this video */
  relatedEntities: Array<VideoLinkableEntity>;
  /** Entities linked to this video */
  rankRelatedEntities: Array<RankRelatedEntity>;
  /** Files linked to the video */
  videoFiles: Maybe<Array<Maybe<VideoFile>>>;
  /** Main file linked to the video that can be used for previews */
  previewVideoFile: Maybe<VideoFile>;
  alt: Maybe<VideoAltType>;
  /** The suggested title according to the video and all its related entities */
  suggestedTitle: Maybe<Scalars['String']['output']>;
  validity: Maybe<VideoValidityType>;
  certificate: Maybe<Certificate>;
};


export type VideoB2BExternalIDsArgs = {
  source?: InputMaybe<Scalars['String']['input']>;
};


export type VideoB2BRankRelatedEntitiesArgs = {
  entityId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteVideoFileInput = {
  videoRef: Scalars['ID']['input'];
  /** Global id of the file, as exposed by `videoFiles` */
  fileId: Scalars['ID']['input'];
};

export type DeleteWidgetInput = {
  /** The widget id. */
  widgetId: Scalars['ID']['input'];
};

export type DuplicateCarouselInput = {
  carouselId: Scalars['ID']['input'];
  startsAt: Scalars['DateTimeWithoutTz']['input'];
};

export type GenerateUserTokenInput = {
  userId: Scalars['ID']['input'];
  expiresAt: Scalars['DateTime']['input'];
};

export type IgnoreIncompleteShowtimeSourceInput = {
  sourceType: ShowtimeSourceType;
  sourceName: Scalars['String']['input'];
  sourceId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type IgnoreProductInput = {
  productId: Scalars['ID']['input'];
};

export type MarkIncompleteEntityInProgressByMavensInput = {
  sourceName: Scalars['String']['input'];
  sourceId: Scalars['String']['input'];
  /** Full path (pathname + search) for the show link; the backend will prepend FRONTEND_ROOT_URL as origin. */
  pathname: Scalars['String']['input'];
};

export type LinkAuthorToEditorialReviewInput = {
  editorialReviewId: Scalars['ID']['input'];
  authorId: Scalars['ID']['input'];
  signatureId?: InputMaybe<Scalars['ID']['input']>;
};

export type LinkAuthorToNewsInput = {
  newsId: Scalars['ID']['input'];
  authorId: Scalars['ID']['input'];
  signatureId?: InputMaybe<Scalars['ID']['input']>;
};

export type LinkCustomerQueryToScopeInput = {
  scopeId: Scalars['ID']['input'];
  customerQueryId: Scalars['ID']['input'];
  alias: Scalars['String']['input'];
  config: QueryConfigInput;
};

export type QueryConfigInput = {
  variables: Scalars['JSONObject']['input'];
  userVariables: Array<Scalars['String']['input']>;
};

export type LinkEntitiesInput = {
  sourceId: Scalars['ID']['input'];
  targetId: Scalars['ID']['input'];
  linkType: EntityLinkType;
};

export type LinkEntityToEntityInput = {
  sourceId: Scalars['ID']['input'];
  targetId: Scalars['ID']['input'];
  linkType: EntityLinkType;
};

export type LinkEntityToImageInput = {
  /** The linked entity. */
  entityId: Scalars['ID']['input'];
  /** The image ID. */
  imageId: Scalars['ID']['input'];
};

export type LinkEntityToNewsInput = {
  newsId: Scalars['ID']['input'];
  relatedEntityId: Scalars['ID']['input'];
};

export type LinkEntityToVideoInput = {
  /** The linked entity. */
  entityId: Scalars['ID']['input'];
  /** The video ID. */
  videoId: Scalars['ID']['input'];
};

export type LinkProductsPayload = {
  unknownProducts: Array<UnknownProduct>;
  entities: Array<Maybe<Entity>>;
};

export type LinkProductsInput = {
  /** The unknown product IDs to link */
  productIds: Array<Scalars['ID']['input']>;
  /** The IDs of the matched entities */
  entitiesIds: Array<Scalars['ID']['input']>;
};

export type ImportPersonImagesInput = {
  personId: Scalars['ID']['input'];
  images: Array<PersonImageImportInput>;
  /** The search (launchPersonImagesImport) the images were picked from; it keeps what became of them. */
  reportId?: InputMaybe<Scalars['ID']['input']>;
};

export type PersonImageImportInput = {
  /** The url of a candidate. */
  url: Scalars['String']['input'];
  /** The CMS image type the image is created with. */
  type: ImageType;
  title?: InputMaybe<Scalars['String']['input']>;
  /** The resolution to download when the source offers several; the best one it has when unavailable. */
  quality?: InputMaybe<PersonImageQuality>;
};

export type LaunchPersonImagesImportInput = {
  personId: Scalars['ID']['input'];
  source: PersonImageSource;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type LaunchPersonCreditsImportInput = {
  entityId: Scalars['ID']['input'];
  /** The source to read; TMDB when omitted. personCreditsImportSources lists the configured ones. */
  source?: InputMaybe<PersonCreditsImportSource>;
  /** The files to read: screenshots of a credits listing for the IMAGE source, PDFs for the PDF source; required by those two, refused by the others. */
  documents?: InputMaybe<Array<PersonCreditsImportDocumentInput>>;
  /** The lines, casting and credits, the editor wants from this run; both when omitted. The run answers both, the history shows the asked ones. */
  sections?: InputMaybe<Array<PersonCreditsImportDataType>>;
  /** The pasted text to read (a mail, a press release); required by the TEXT source, refused by the others. */
  text?: InputMaybe<Scalars['String']['input']>;
  /** The locale the actor characters are proposed in (the editor's brand locale); omitted, or ignored when the run does not ask for the cast. */
  localeId?: InputMaybe<Scalars['ID']['input']>;
};

/** A file the editor uploaded through createFileUploadToken (CONNECTOR_IMAGES storage): a screenshot read by the IMAGE source, a PDF read by the PDF source. */
export type PersonCreditsImportDocumentInput = {
  /** The uploadToken createFileUploadToken returned: the file's path and MIME type are read from it. */
  uploadToken: Scalars['String']['input'];
};

export type MatchShowtimeEntityInput = {
  sourceName: Scalars['String']['input'];
  sourceId: Scalars['String']['input'];
  entityId: Scalars['ID']['input'];
};

export type MatchShowtimeTheaterInput = {
  sourceName: Scalars['String']['input'];
  sourceId: Scalars['String']['input'];
  theaterId: Scalars['ID']['input'];
};

export type MoveAuthorInEditorialReviewsInput = {
  editorialReviewAuthorId: Scalars['ID']['input'];
  rank: Scalars['NonNegativeInt']['input'];
};

export type MoveAuthorInNewsInput = {
  id: Scalars['ID']['input'];
  rank: Scalars['NonNegativeInt']['input'];
};

export type MoveCompanyInput = {
  entityCompanyId: Scalars['ID']['input'];
  rank: Scalars['NonNegativeInt']['input'];
};

export type MoveCompanyStaffInput = {
  companyId: Scalars['ID']['input'];
  staffId: Scalars['ID']['input'];
  rank: Scalars['NonNegativeInt']['input'];
};

export type MoveCreditInput = {
  creditId: Scalars['ID']['input'];
  rank: Scalars['NonNegativeInt']['input'];
};

export type MoveEntityImageInput = {
  entityId: Scalars['ID']['input'];
  imageId: Scalars['ID']['input'];
  number: Scalars['NonNegativeInt']['input'];
};

export type MoveEntityLinkInput = {
  sourceId: Scalars['ID']['input'];
  targetId: Scalars['ID']['input'];
  linkType: EntityLinkType;
  rank: Scalars['NonNegativeInt']['input'];
};

export type MoveEntityVideoInput = {
  entityId: Scalars['ID']['input'];
  videoId: Scalars['ID']['input'];
  rank: Scalars['NonNegativeInt']['input'];
};

export type MoveFareInput = {
  fareId: Scalars['ID']['input'];
  rank: Scalars['NonNegativeInt']['input'];
};

export type MoveFestivalJuryInput = {
  juryId: Scalars['ID']['input'];
  rank: Scalars['PositiveInt']['input'];
};

export type MoveNewsSlideInput = {
  newsSlideId: Scalars['ID']['input'];
  number: Scalars['PositiveInt']['input'];
};

export type MoveSlideInput = {
  carouselId: Scalars['ID']['input'];
  slideId: Scalars['ID']['input'];
  rank: Scalars['NonNegativeInt']['input'];
};

export type EntityChangeEvent = {
  entityGid: Scalars['ID']['output'];
  type: Maybe<EntityChangeEventType>;
  scope: Maybe<EntityChangeEventScope>;
  properties: Maybe<Scalars['JSONObject']['output']>;
};

/** Possible event types associated to entities change events */
export enum EntityChangeEventType {
  Create = 'CREATE',
  Update = 'UPDATE',
  Delete = 'DELETE'
}

/** Possible scopes associated to entities change events */
export enum EntityChangeEventScope {
  Entity = 'ENTITY',
  RelatedData = 'RELATED_DATA'
}

export type PublishEntityChangeEventsInput = {
  entityId: Scalars['ID']['input'];
  type?: InputMaybe<EntityChangeEventType>;
  scope?: InputMaybe<EntityChangeEventScope>;
  /** Additional properties to add to this event */
  properties?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type RemoveImageFromCategoryInput = {
  imageId: Scalars['ID']['input'];
  categoryId: Scalars['ID']['input'];
};

export type RemoveSlideInput = {
  carouselId: Scalars['ID']['input'];
  slideId: Scalars['ID']['input'];
};

export type RemoveTargetFromSpecialOperationInput = {
  targetId: Scalars['ID']['input'];
};

export type WebsiteRoute = {
  name: Scalars['String']['output'];
  params: Array<WebsiteRouteParam>;
};

export type RetroengineerUrlInput = {
  url: Scalars['URL']['input'];
  brandId: Scalars['ID']['input'];
};

export type RetryVideoPlatformEncodingInput = {
  videoRef: Scalars['ID']['input'];
  platform: VideoPlatformEnum;
  /** YouTube channel of the video brand, required to push a video to YouTube for the first time */
  youtubeChannelId?: InputMaybe<Scalars['String']['input']>;
};

export type SetYoutubeVideoIdInput = {
  videoRef: Scalars['ID']['input'];
  /** A YouTube video id, or the URL of a YouTube video */
  youtubeVideo: Scalars['String']['input'];
};

export type ToggleEntityBrandActivationInput = {
  brandId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type ToggleNewsActivationInput = {
  newsId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type ToggleTagActivationInput = {
  tagId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UnlinkAuthorFromEditorialReviewInput = {
  editorialReviewId: Scalars['ID']['input'];
  authorId: Scalars['ID']['input'];
};

export type UnlinkAuthorFromNewsInput = {
  newsId: Scalars['ID']['input'];
  authorId: Scalars['ID']['input'];
};

export type UnlinkCustomerQueryFromScopeInput = {
  scopeId: Scalars['ID']['input'];
  customerQueryId: Scalars['ID']['input'];
};

export type UnlinkEntitiesInput = {
  sourceId: Scalars['ID']['input'];
  targetId: Scalars['ID']['input'];
  linkType: EntityLinkType;
};

export type UnlinkEntityFromImageInput = {
  /** The linked entity. */
  entityId: Scalars['ID']['input'];
  /** The image ID. */
  imageId: Scalars['ID']['input'];
};

export type UnlinkEntityFromNewsInput = {
  newsId: Scalars['ID']['input'];
  relatedEntityId: Scalars['ID']['input'];
};

export type UnlinkEntityFromProductInput = {
  productId: Scalars['ID']['input'];
  relatedEntityId: Scalars['ID']['input'];
};

export type UnlinkEntityFromVideoInput = {
  /** The linked entity. */
  entityId: Scalars['ID']['input'];
  /** The video ID. */
  videoId: Scalars['ID']['input'];
};

export type UpdateApplicationInput = {
  id: Scalars['ID']['input'];
  active: Scalars['Boolean']['input'];
};

export type UpdateAuthorInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  shortBio?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  secureUserId?: InputMaybe<Scalars['ID']['input']>;
  socialUserLegacyId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  stopDate?: InputMaybe<Scalars['Date']['input']>;
  avatarId?: InputMaybe<Scalars['ID']['input']>;
  longBio?: InputMaybe<Scalars['RichText']['input']>;
  links?: InputMaybe<SocialLinksInput>;
};

export type SocialLinksInput = {
  facebook?: InputMaybe<Scalars['URL']['input']>;
  bluesky?: InputMaybe<Scalars['URL']['input']>;
  instagram?: InputMaybe<Scalars['URL']['input']>;
  letterboxd?: InputMaybe<Scalars['URL']['input']>;
  linkedin?: InputMaybe<Scalars['URL']['input']>;
  pinterest?: InputMaybe<Scalars['URL']['input']>;
  snapchat?: InputMaybe<Scalars['URL']['input']>;
  threads?: InputMaybe<Scalars['URL']['input']>;
  tiktok?: InputMaybe<Scalars['URL']['input']>;
  tumblr?: InputMaybe<Scalars['URL']['input']>;
  twitter?: InputMaybe<Scalars['URL']['input']>;
  vk?: InputMaybe<Scalars['URL']['input']>;
  wechat?: InputMaybe<Scalars['URL']['input']>;
  whatsapp?: InputMaybe<Scalars['URL']['input']>;
  youtube?: InputMaybe<Scalars['URL']['input']>;
};

export type UpdateAuthorSeoDataInput = {
  id: Scalars['ID']['input'];
  browsable?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAuthorSignatureInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBrandInput = {
  brandId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** The country's name. */
  wysiwygFeatures?: InputMaybe<Array<WysiwygFeature>>;
};

export type UpdateBrandEntityClubInput = {
  brandId: Scalars['ID']['input'];
  clubId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
  seen?: InputMaybe<Scalars['Boolean']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  rating: EntityCLubRatingsInput;
};

export type EntityCLubRatingsInput = {
  excellent?: InputMaybe<Scalars['Float']['input']>;
  good?: InputMaybe<Scalars['Float']['input']>;
  average?: InputMaybe<Scalars['Float']['input']>;
  bad?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateBrandSearchLinkInput = {
  id: Scalars['ID']['input'];
  brandId?: InputMaybe<Scalars['ID']['input']>;
  posterId?: InputMaybe<Scalars['ID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateRedirectionRuleInput = {
  brandId?: InputMaybe<Scalars['ID']['input']>;
  kind?: InputMaybe<RedirectionRuleKind>;
  mode?: InputMaybe<WritableRedirectionMode>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  sourcePattern?: InputMaybe<Scalars['String']['input']>;
  targetPattern?: InputMaybe<Scalars['String']['input']>;
  sourceEntity?: InputMaybe<Scalars['String']['input']>;
  targetEntity?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  endAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  /** The reviewToken of redirectionRuleChainRewrites for these values: chains are then flattened as reviewed instead of refused. */
  chainReviewToken?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Outcome of a bulk upsert. A non empty `errors` list means nothing was written: the write is all or nothing. */
export type RedirectionRuleUpsertReport = {
  /** Number of rules received in the input list. */
  totalRows: Scalars['Int']['output'];
  createdCount: Scalars['Int']['output'];
  updatedCount: Scalars['Int']['output'];
  /** Rules matching an existing one that already held the given values. */
  unchangedCount: Scalars['Int']['output'];
  errors: Array<RedirectionRuleUpsertError>;
  /** Stored rules (not rows of the payload) pointed straight at the end of their chain. */
  rewrittenCount: Scalars['Int']['output'];
  /** Every planned rewrite, rows of the payload included; empty unless the call was a dry run or carried a chainReviewToken. */
  chainRewrites: Array<RedirectionRuleChainRewrite>;
  /** Pass it back with the same rows to apply exactly this plan. Null when nothing was planned. */
  chainReviewToken: Maybe<Scalars['String']['output']>;
};

/** A single validation or referential error preventing the write. */
export type RedirectionRuleUpsertError = {
  /** Position of the offending rule in the input list, null for payload wide errors. */
  index: Maybe<Scalars['Int']['output']>;
  /** Input field the error comes from, null when not tied to a field. */
  field: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type UpsertRedirectionRulesInput = {
  rules: Array<RedirectionRuleUpsertInput>;
  /** Runs the whole write, then rolls it back: the report tells what would happen, chains included. */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The chainReviewToken of a dry run of the same rows: chains are then flattened as reviewed instead of refused. */
  chainReviewToken?: InputMaybe<Scalars['String']['input']>;
};

/** One pattern rule to write, matched on (brandRef, sourceUrl). An omitted optional field keeps the value the matched rule already holds; an explicit null clears it. */
export type RedirectionRuleUpsertInput = {
  /** Raw brand identifier, as written by the CSV export. */
  brandRef: Scalars['String']['input'];
  /** Path the redirection starts from; the domain comes from the brand. */
  sourceUrl: Scalars['String']['input'];
  mode: WritableRedirectionMode;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  targetUrl?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  endAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type UpdateCarouselInput = {
  carouselId: Scalars['ID']['input'];
  startsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  target?: InputMaybe<Scalars['Tag3D']['input']>;
};

export type UpdateCertificateInput = {
  /** The certificate id. */
  id: Scalars['ID']['input'];
  localizationId?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateClockInput = {
  clockId: Scalars['ID']['input'];
  theaterId?: InputMaybe<Scalars['ID']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  dateRange?: InputMaybe<DateRangeWithoutTzInput>;
  showtimes?: InputMaybe<Array<Scalars['LocalTime']['input']>>;
  screenId?: InputMaybe<Scalars['ID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  technos?: InputMaybe<Array<ClockTechno>>;
  sound?: InputMaybe<ClockSound>;
  subtitles?: InputMaybe<Language>;
  language?: InputMaybe<Language>;
  seatingStyle?: InputMaybe<ClockSeatingStyle>;
  amenity?: InputMaybe<ClockAmenity>;
};

export type UpdateCompanyInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activities?: InputMaybe<Array<InputMaybe<CompanyActivitySubactivityArgsType>>>;
  providerAsFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  foundedAt?: InputMaybe<Scalars['Date']['input']>;
  links?: InputMaybe<SocialLinksInput>;
  logoId?: InputMaybe<Scalars['ID']['input']>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['URL']['input']>;
  androidUrl?: InputMaybe<Scalars['URL']['input']>;
  iosUrl?: InputMaybe<Scalars['URL']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  cncNumber?: InputMaybe<Scalars['String']['input']>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  allowMatchingTypeOverrides?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCompanyBrandDataInput = {
  companyId: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanyLocaleDataInput = {
  id: Scalars['ID']['input'];
  localeId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanyStaffInput = {
  id: Scalars['ID']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<CompanyStaffDepartment>;
  title?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  workPhone?: InputMaybe<Scalars['String']['input']>;
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  copyCompanies?: InputMaybe<Array<Scalars['ID']['input']>>;
  pubCompanies?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateCountryInput = {
  /** The country's id. */
  id: Scalars['ID']['input'];
  /** The country's name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The country's alpha 2 code. */
  alpha2?: InputMaybe<Scalars['String']['input']>;
  /** The country's alpha 3 code */
  alpha3?: InputMaybe<Scalars['String']['input']>;
  /** The country's preferred clock format */
  preferredClockFormat?: InputMaybe<PreferredClockFormat>;
};

export type UpdateCreditInput = {
  /** The credit ID. */
  creditId: Scalars['ID']['input'];
  /** The person. */
  personId?: InputMaybe<Scalars['ID']['input']>;
  /** The original role for the casting */
  role?: InputMaybe<Scalars['String']['input']>;
  /** Original voice for the role. */
  voiceId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCustomerInput = {
  /** The customer's id. */
  id: Scalars['ID']['input'];
  /** The customer's name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** If true, the customer must be active. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** The customer's graph backend endpoint. */
  graphBackendEndpoint?: InputMaybe<Scalars['URL']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerQueryInput = {
  /** The customer query's id. */
  id: Scalars['ID']['input'];
  /** The customer query's name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The customer query template. */
  template?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDuplicateInput = {
  duplicateId: Scalars['ID']['input'];
  status: DuplicateStatus;
  priority: DuplicatePriority;
  winner?: InputMaybe<Scalars['ID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEditorialReviewInput = {
  editorialReviewId: Scalars['ID']['input'];
  entityId?: InputMaybe<Scalars['ID']['input']>;
  pictureId?: InputMaybe<Scalars['ID']['input']>;
  pictureCopyrightIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  body?: InputMaybe<Scalars['RichText']['input']>;
  bodyShort?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateEntityPublicationInput = {
  entityId: Scalars['ID']['input'];
  index: Scalars['NonNegativeInt']['input'];
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  endsAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateEntityAltsInput = {
  entityId: Scalars['ID']['input'];
  externalIds: Array<ExternalIdInput>;
};

export type ExternalIdInput = {
  /** The ID provider. */
  type: Scalars['String']['input'];
  /** The provider's IDs. */
  alts: Array<Scalars['ID']['input']>;
};

export type EntityGeneratedVideoTitles = {
  count: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type UpdateEntityGeneratedVideoTitlesInput = {
  entityId: Scalars['ID']['input'];
  brandId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<VideoType>;
};

export type UpdateEntityLinkInput = {
  sourceId: Scalars['ID']['input'];
  targetId: Scalars['ID']['input'];
  linkType: EntityLinkType;
};

export type UpdateEntityLocalizationInput = {
  entityId: Scalars['ID']['input'];
  coordinates: CoordinatesInput;
  location: LocationInput;
};

export type LocationInput = {
  address: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEntityMainBrandPosterInput = {
  /** The ID of the entity to update */
  entityId: Scalars['ID']['input'];
  /** Brand ID on which set the main poster */
  brandId: Scalars['ID']['input'];
  /** Image ID to use as the main poster */
  imageId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateEntityMainLocalizedPosterInput = {
  /** The ID of the entity to update */
  entityId: Scalars['ID']['input'];
  /** Locale ID on which set the main poster */
  localeId: Scalars['ID']['input'];
  /** Image ID to use as the main poster */
  imageId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateEntityMainPosterInput = {
  /** The ID of the entity to update */
  entityId: Scalars['ID']['input'];
  /** Image ID to use as the main poster */
  imageId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateEntitySeoDataInput = {
  /** The ID of the entity. */
  entityId: Scalars['ID']['input'];
  /** The brand ID. */
  brandId: Scalars['ID']['input'];
  /** The active status of the entity. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** The browsable status of the entity. */
  browsable?: InputMaybe<Scalars['Boolean']['input']>;
  /** The SEO title of the entity. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The SEO alternate title of the entity. */
  alternateTitle?: InputMaybe<Scalars['String']['input']>;
  /** The SEO description of the entity. */
  description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFareInput = {
  fareId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Currency>;
  screenIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateFestivalInput = {
  id: Scalars['ID']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FestivalType>;
  theme?: InputMaybe<FestivalTheme>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  posterId?: InputMaybe<Scalars['ID']['input']>;
  localizationId?: InputMaybe<Scalars['ID']['input']>;
  synopsis?: InputMaybe<Scalars['RichText']['input']>;
  locale: Scalars['ID']['input'];
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateFestivalAwardInput = {
  id: Scalars['ID']['input'];
  locale: Scalars['ID']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFestivalCompetitionInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  display?: InputMaybe<FestivalCompetitionDisplay>;
  locale: Scalars['ID']['input'];
};

export type UpdateFestivalEditionInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  editionNumber?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
  startsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  locale: Scalars['ID']['input'];
  posterId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateFestivalEditionCompetitionInput = {
  editionId: Scalars['ID']['input'];
  competitionId: Scalars['ID']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  rank?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type UpdateFestivalSelectionInput = {
  festivalId: Scalars['ID']['input'];
  festivalEditionId: Scalars['ID']['input'];
  festivalCompetitionId?: InputMaybe<Scalars['ID']['input']>;
  nominees?: InputMaybe<Array<Scalars['ID']['input']>>;
  festivalAwardIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  festivalSelectionId: Scalars['ID']['input'];
};

export type UpdateImageInput = {
  id: Scalars['ID']['input'];
  type?: InputMaybe<ImageType>;
  copyrightIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  b2bAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  width?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  height?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateImageB2bDataInput = {
  id: Scalars['ID']['input'];
  available?: InputMaybe<Scalars['Boolean']['input']>;
  copyrightIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateImageBrandDataInput = {
  imageId: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  copyrightIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateImageCategoryInput = {
  id: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ImageType>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  rank?: InputMaybe<Scalars['PositiveInt']['input']>;
  sponsored?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateImageInCategoryInput = {
  imageId: Scalars['ID']['input'];
  categoryId: Scalars['ID']['input'];
  rank: Scalars['PositiveInt']['input'];
};

export type UpdateImageLocaleDataInput = {
  imageId: Scalars['ID']['input'];
  localeId: Scalars['ID']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateImportConfigurationInput = {
  id: Scalars['ID']['input'];
  crawler?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  fetchedDays?: InputMaybe<Scalars['Int']['input']>;
  gathertimesTimeout?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  uri?: InputMaybe<Scalars['URL']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['Int']['input']>;
  nextRun?: InputMaybe<Scalars['DateTime']['input']>;
  theaterMatcher?: InputMaybe<Scalars['String']['input']>;
  entityMatcher?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  inheritsScreenAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  parameters?: InputMaybe<Scalars['String']['input']>;
  linksOnly?: InputMaybe<Scalars['Boolean']['input']>;
  moviesOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateImportCrawlerInput = {
  /** The crawler name. */
  name: Scalars['String']['input'];
  /** The crawler type. */
  type: CrawlerType;
  /** The crawler country IDs. */
  countryIds: Array<Scalars['ID']['input']>;
  /** The crawler notes. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The crawler tags. */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The crawler parameters. */
  parameters?: InputMaybe<Scalars['String']['input']>;
  /** The crawler default configuration. */
  defaultConfiguration?: InputMaybe<CrawlerDefaultConfigurationInput>;
  /** The ID of the crawler to update. */
  crawlerId: Scalars['ID']['input'];
};

export type UpdateLocalCertificateInput = {
  releaseId: Scalars['ID']['input'];
  localCertificateToUpdate: Scalars['JSONObject']['input'];
  payload: Scalars['JSONObject']['input'];
};

export type UpdateLocalCreditInput = {
  creditLocalId: Scalars['ID']['input'];
  /** Local role for the locale. */
  role?: InputMaybe<Scalars['String']['input']>;
  /** Local voice for the role. */
  voiceId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateLocaleInput = {
  /** The locale id. */
  id: Scalars['ID']['input'];
  /** The locale country id. */
  countryId: Scalars['ID']['input'];
  /** The locale sync from id Brand. */
  syncFromIdBrand?: InputMaybe<Scalars['ID']['input']>;
  /** The locale localization id. */
  localizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateMovieInput = {
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  productionYear?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<MovieType>;
  posterId?: InputMaybe<Scalars['ID']['input']>;
  runtime?: InputMaybe<RuntimeInput>;
  budget_value?: InputMaybe<Scalars['NonNegativeFloat']['input']>;
  budget_currency?: InputMaybe<Currency>;
  genres?: InputMaybe<Array<Genre>>;
  countries?: InputMaybe<Array<Scalars['ID']['input']>>;
  languages?: InputMaybe<Array<Language>>;
  color?: InputMaybe<Scalars['Tag3D']['input']>;
  production?: InputMaybe<Scalars['Tag3D']['input']>;
  projection?: InputMaybe<Scalars['Tag3D']['input']>;
  sound?: InputMaybe<Scalars['Tag3D']['input']>;
  foxproSync?: InputMaybe<MovieFoxProSyncInput>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  projectionTags?: InputMaybe<Array<MovieProjection>>;
  additionalTags?: InputMaybe<Array<MovieAdditional>>;
};

export type UpdateMovieBoxofficeInput = {
  movieId: Scalars['ID']['input'];
  totalBoxofficeUs?: InputMaybe<Scalars['Int']['input']>;
  totalBoxofficeInternational?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateMovieBrandDataInput = {
  movieId: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  synopsis?: InputMaybe<Scalars['RichText']['input']>;
  synopsisShort?: InputMaybe<Scalars['RichText']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  posterId?: InputMaybe<Scalars['ID']['input']>;
  ruling?: InputMaybe<EntityBrandDataRulingInput>;
};

export type EntityBrandDataRulingInput = {
  hasRating?: InputMaybe<Scalars['Boolean']['input']>;
  atRisk?: InputMaybe<Scalars['Boolean']['input']>;
  hasWarningMessage?: InputMaybe<Scalars['Boolean']['input']>;
  hasMandatoryReview?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMovieBrandedContentInput = {
  movieId: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
  tab?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type UpdateMovieLocaleDataInput = {
  id: Scalars['ID']['input'];
  localeId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  synopsisShort?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['URL']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  posterId?: InputMaybe<Scalars['ID']['input']>;
  imageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  copyToLocaleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateMovieVersionInput = {
  versionId: Scalars['ID']['input'];
  version?: InputMaybe<MovieVersionType>;
  runtime?: InputMaybe<RuntimeInput>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNewsInput = {
  newsId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  socialTitle?: InputMaybe<Scalars['String']['input']>;
  universe?: InputMaybe<NewsUniverse>;
  category?: InputMaybe<NewsCategory>;
  headline?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  posterId?: InputMaybe<Scalars['ID']['input']>;
  posterCopyrightIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  isUpdatedWhenPublished?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateNewsNavigationDataInput = {
  id: Scalars['ID']['input'];
  seoHidden?: InputMaybe<Scalars['Boolean']['input']>;
  onlyOnSocialSite?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateNewsPageInput = {
  newsPageId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['ID']['input']>;
  body?: InputMaybe<Scalars['RichText']['input']>;
};

export type UpdateNewsPageNumberInput = {
  newsPageId: Scalars['ID']['input'];
  number: Scalars['Int']['input'];
};

export type UpdateNewsSeoAttributesInput = {
  id: Scalars['ID']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePersonInput = {
  /** The person's id */
  id: Scalars['ID']['input'];
  /** The person's first name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The person's last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The person's formal name. */
  formalName?: InputMaybe<Scalars['String']['input']>;
  /** The person's gender. */
  gender?: InputMaybe<Gender>;
  /** The person's birth date. */
  birthDate?: InputMaybe<Scalars['PartialDate']['input']>;
  /** The person's death date. */
  deathDate?: InputMaybe<Scalars['PartialDate']['input']>;
  /** The person's keywords. */
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The person's countries. */
  countryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  posterId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePersonBrandDataInput = {
  personId: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
  biography?: InputMaybe<Scalars['RichText']['input']>;
  biographyShort?: InputMaybe<Scalars['String']['input']>;
  birthPlace?: InputMaybe<Scalars['String']['input']>;
  deathPlace?: InputMaybe<Scalars['String']['input']>;
  deathCause?: InputMaybe<Scalars['String']['input']>;
  posterId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePresetInput = {
  /** The preset's id. */
  id: Scalars['ID']['input'];
  /** The preset's name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The permissions granted by this preset. */
  permissions?: InputMaybe<Array<Permission>>;
  /** The universes associated to this preset. */
  universes?: InputMaybe<Array<Universe>>;
};

export type UpdatePressReviewInput = {
  id: Scalars['ID']['input'];
  companyId?: InputMaybe<Scalars['ID']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  author?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  body?: InputMaybe<Scalars['RichText']['input']>;
  url?: InputMaybe<Scalars['URL']['input']>;
};

export type UpdateProductDetailsInput = {
  productId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Currency>;
};

export type UpdateProductProviderInput = {
  productId: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
};

export type UpdateReleaseInput = {
  /** The release ID. */
  id: Scalars['ID']['input'];
  /** If release will come soon, but we don't know date. */
  notReleasedYet: Scalars['Boolean']['input'];
  /** The release's country. */
  countryId: Scalars['ID']['input'];
  /** The release's type. */
  type?: InputMaybe<ReleaseType>;
  /** The release's flags. */
  flags?: InputMaybe<Array<ReleaseFlag>>;
  /** The release's release date. */
  releasedAt?: InputMaybe<Scalars['PartialDate']['input']>;
  /** The release's time on the releasedAt date. Format is HH:MM:SS */
  releasedAtTime?: InputMaybe<Scalars['TimeWithoutTz']['input']>;
  /** The release's release end date. */
  unreleasedAt?: InputMaybe<Scalars['Date']['input']>;
  /** The company ID if the release is limited to it. */
  limitedCompanyId?: InputMaybe<Scalars['ID']['input']>;
  /** The state/region related to the selected country, if the release is limited to it. */
  limitedLocalizationId?: InputMaybe<Scalars['ID']['input']>;
  /** The release's distributor. */
  distributorsIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** The release's classification ID. */
  classificationId?: InputMaybe<Scalars['ID']['input']>;
  /** The release's visa number */
  visaNumber?: InputMaybe<Scalars['String']['input']>;
  /** The opening estimate for a movie. */
  openingEstimate?: InputMaybe<Scalars['Int']['input']>;
  advisory?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateScopeInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateScreenInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  seats?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<ScreenSizeInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  flags?: InputMaybe<ScreenFlagsInput>;
};

export type UpdateSeriesInput = {
  seriesId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SeriesType>;
  status?: InputMaybe<SeriesStatus>;
  posterId?: InputMaybe<Scalars['ID']['input']>;
  baseRuntime?: InputMaybe<Scalars['PositiveInt']['input']>;
  genres?: InputMaybe<Array<Genre>>;
  countries?: InputMaybe<Array<Scalars['ID']['input']>>;
  originalPremiere?: InputMaybe<Scalars['PartialDate']['input']>;
  originalFinale?: InputMaybe<Scalars['PartialDate']['input']>;
  premiereChannelId?: InputMaybe<Scalars['ID']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateSeriesBrandDataInput = {
  seriesId: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  synopsis?: InputMaybe<Scalars['RichText']['input']>;
  synopsisShort?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  posterId?: InputMaybe<Scalars['ID']['input']>;
  ruling?: InputMaybe<EntityBrandDataRulingInput>;
};

export type UpdateSeriesEpisodeInput = {
  episodeId: Scalars['ID']['input'];
  seasonId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type UpdateSeriesEpisodeBrandDataInput = {
  episodeId: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  synopsis?: InputMaybe<Scalars['RichText']['input']>;
  ruling?: InputMaybe<EntityBrandDataRulingInput>;
};

export type UpdateSeriesSeasonInput = {
  seasonId: Scalars['ID']['input'];
  number?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  status?: InputMaybe<SeriesStatus>;
  originalPremiere?: InputMaybe<Scalars['PartialDate']['input']>;
  originalFinale?: InputMaybe<Scalars['PartialDate']['input']>;
  posterId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateSeriesSeasonBrandDataInput = {
  seasonId: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
  synopsis?: InputMaybe<Scalars['RichText']['input']>;
  posterId?: InputMaybe<Scalars['ID']['input']>;
  ruling?: InputMaybe<EntityBrandDataRulingInput>;
};

export type UpdateShowtimesEmbargoInput = {
  embargoId: Scalars['ID']['input'];
  publicAt?: InputMaybe<Scalars['DateTime']['input']>;
  bookableAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateSlideInput = {
  slideId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  posterId?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkInput>;
};

export type UpdateSlideshowSlideInput = {
  slideId: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  copyrightIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  body?: InputMaybe<Scalars['RichText']['input']>;
};

export type UpdateSocialUserInput = {
  /** The id of the social user. */
  id: Scalars['ID']['input'];
  isClub300?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, the email is valid. */
  isEmailValid?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  actito?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSpecialOperationInput = {
  id: Scalars['ID']['input'];
  entityId?: InputMaybe<Scalars['ID']['input']>;
  startsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  additionalInfos?: InputMaybe<Scalars['JSONObject']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slots?: InputMaybe<Array<InputMaybe<TicketAnchorSlot>>>;
  medias?: InputMaybe<Scalars['JSONObject']['input']>;
  data?: InputMaybe<Scalars['JSONObject']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSpecialOperationTargetInput = {
  targetId: Scalars['ID']['input'];
  entityId?: InputMaybe<Scalars['ID']['input']>;
  rank?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  startsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  data?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type UpdateTagInput = {
  /** The tag's id. */
  id: Scalars['ID']['input'];
  /** The tag's name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The tag's type. */
  type?: InputMaybe<TagType>;
  scope?: InputMaybe<TagScope>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  browsable?: InputMaybe<Scalars['Boolean']['input']>;
  topRanking?: InputMaybe<Scalars['Boolean']['input']>;
  friendly?: InputMaybe<Scalars['Boolean']['input']>;
  seoScope?: InputMaybe<TagSeoScopeDataInput>;
  /** The reason of seo setting change. */
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type TagSeoScopeDataInput = {
  userRating?: InputMaybe<TagSeoScopeInput>;
  pressRating?: InputMaybe<TagSeoScopeInput>;
  popularity?: InputMaybe<TagSeoScopeInput>;
  ranking?: InputMaybe<TagSeoScopeInput>;
};

export type TagSeoScopeInput = {
  movie?: InputMaybe<TagSeoScopeEntityDataInput>;
  series?: InputMaybe<TagSeoScopeEntityDataInput>;
};

export type TagSeoScopeEntityDataInput = {
  title?: InputMaybe<Scalars['String']['input']>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTagRankInput = {
  entityTagId: Scalars['ID']['input'];
  rank: Scalars['NonNegativeInt']['input'];
};

export type UpdateTeamInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  countryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  brandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  localeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateTemporalBoxofficeInput = {
  boxofficeId: Scalars['ID']['input'];
  countryId?: InputMaybe<Scalars['ID']['input']>;
  range?: InputMaybe<DateRangeInput>;
  movieId?: InputMaybe<Scalars['ID']['input']>;
  earning?: InputMaybe<Scalars['PositiveInt']['input']>;
  cumulative?: InputMaybe<Scalars['PositiveInt']['input']>;
  copyCount?: InputMaybe<Scalars['PositiveInt']['input']>;
  estimate?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type UpdateTheaterInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  foundedAt?: InputMaybe<Scalars['Date']['input']>;
  links?: InputMaybe<SocialLinksInput>;
  logoId?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
  affiliatedTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  pointOfSale?: InputMaybe<Array<Scalars['ID']['input']>>;
  tradeGroup?: InputMaybe<Array<Scalars['ID']['input']>>;
  scheduledTypology?: InputMaybe<Array<TheaterTypology>>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  temporaryClosure?: InputMaybe<TemporaryClosureInput>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['URL']['input']>;
  showtimesUrl?: InputMaybe<Scalars['URL']['input']>;
  showtimesAlternateUrl?: InputMaybe<Scalars['URL']['input']>;
  androidUrl?: InputMaybe<Scalars['URL']['input']>;
  iosUrl?: InputMaybe<Scalars['URL']['input']>;
  movieLine?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<TheaterFlagsInput>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  nextOpening?: InputMaybe<NextOpeningInput>;
  showtimeSource?: InputMaybe<TheaterShowtimeSource>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  showtimesGatheringMethod?: InputMaybe<TheaterShowtimesGatheringMethod>;
  showtimesGatheringMethodCode?: InputMaybe<Scalars['String']['input']>;
  showtimesGatheringMethodPriority?: InputMaybe<Scalars['String']['input']>;
};

export type TemporaryClosureInput = {
  message: Scalars['String']['input'];
  startsAt: Scalars['PartialDate']['input'];
  endsAt: Scalars['PartialDate']['input'];
};

export type TheaterFlagsInput = {
  payment?: InputMaybe<Array<TheaterPaymentMethod>>;
  service?: InputMaybe<Array<TheaterExtraService>>;
};

export type NextOpeningInput = {
  message: Scalars['String']['input'];
  startsAt?: InputMaybe<Scalars['PartialDate']['input']>;
};

export type UpdateTheaterEventInput = {
  id: Scalars['ID']['input'];
  kind?: InputMaybe<TheaterEventKind>;
  type?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  /** embeded trailer */
  trailer?: InputMaybe<Scalars['String']['input']>;
  originCountryId?: InputMaybe<Scalars['ID']['input']>;
  posterId?: InputMaybe<Scalars['ID']['input']>;
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseDate?: InputMaybe<Scalars['DateTime']['input']>;
  genres?: InputMaybe<Array<Genre>>;
  runtime?: InputMaybe<RuntimeInput>;
  certificateId?: InputMaybe<Scalars['ID']['input']>;
  directors?: InputMaybe<Array<Scalars['String']['input']>>;
  casting?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateTheaterFeedInput = {
  theaterFeedId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['NonEmptyString']['input']>;
  body?: InputMaybe<Scalars['NonEmptyString']['input']>;
  startsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  startsDisplayAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  endsDisplayAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  type?: InputMaybe<TheaterFeedType>;
  theaterId?: InputMaybe<Scalars['ID']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateTheaterLocaleDataInput = {
  theaterId: Scalars['ID']['input'];
  locale: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTheaterTicketingInput = {
  theaterId: Scalars['ID']['input'];
  useAtom?: InputMaybe<Scalars['Boolean']['input']>;
  useMovieTickets?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTokenInput = {
  id: Scalars['ID']['input'];
  active: Scalars['Boolean']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTriviaInput = {
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  body?: InputMaybe<Scalars['RichText']['input']>;
};

export type UpdateTriviaRankInput = {
  triviaId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
  rank: Scalars['NonNegativeInt']['input'];
};

export type UpdateUserInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  rights?: InputMaybe<Array<RightsInput>>;
  application?: InputMaybe<Scalars['Boolean']['input']>;
  permissions?: InputMaybe<Array<Permission>>;
  presetIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  allowedBrandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  allowedCountryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  allowedLocaleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  allowedNewsScopes?: InputMaybe<Array<NewsScope>>;
};

export type RightsInput = {
  /** The team's id. */
  team: Scalars['ID']['input'];
  /** The preset's id. */
  preset: Scalars['ID']['input'];
};

export type UpdateUserPreferencesInput = {
  userId?: InputMaybe<Scalars['ID']['input']>;
  defaultBrandId?: InputMaybe<Scalars['ID']['input']>;
  defaultCountryId?: InputMaybe<Scalars['ID']['input']>;
  defaultLocaleId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateUserReviewInput = {
  id: Scalars['ID']['input'];
  status: UserReviewStatus;
};

export type UpdateVideoInput = {
  /** The poster of the video */
  posterId?: InputMaybe<Scalars['ID']['input']>;
  /** The active status of the video. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The type of the video */
  videoType?: InputMaybe<VideoType>;
  /** The title of the video */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The description of the video */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The restriction type of the video */
  restrictionType?: InputMaybe<Array<RestrictionType>>;
  /** The video ID. */
  videoId: Scalars['ID']['input'];
  /** The language of the video */
  language?: InputMaybe<Language>;
  /** The subtitle of the video */
  subtitle?: InputMaybe<Language>;
  /** The copyright id of the video. */
  copyrightIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The embed code of the video. */
  embedCode?: InputMaybe<Scalars['String']['input']>;
  /** The status of the job encoding */
  videoEncoderStatus?: InputMaybe<VideoEncoderStatusEnum>;
  /** Limits the video encoder status update (a cancel) to the encoding of this platform */
  videoEncoderPlatform?: InputMaybe<VideoPlatformEnum>;
  /** The validity range of the video */
  validity?: InputMaybe<Scalars['JSONObject']['input']>;
  /** The certificate ID of the video */
  certificateId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateWidgetInput = {
  /** The widget id. */
  widgetId: Scalars['ID']['input'];
  /** The widget type. */
  type: WidgetType;
  /** The widget name. */
  name: Scalars['String']['input'];
  /** The url type. */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UploadVideoInput = {
  videoRef: Scalars['ID']['input'];
  /** Token returned by the createFileUploadToken mutation */
  uploadToken: Scalars['String']['input'];
  /** Platforms to publish the uploaded file on, at least one */
  platforms?: InputMaybe<Array<VideoPlatformEnum>>;
  /** YouTube channel of the video brand, required with YOUTUBE */
  youtubeChannelId?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  /** Fires on every step of a cast and credits import of the entity (title resolved, level tried) and when it ends, completed or failed, with the report as persisted. */
  personCreditsImportReport: PersonCreditsImportReport;
  jobCompleted: Maybe<JobCompletedPayload>;
  /** Encoding status of a video: its current one first, then each one pushed by the video encoding job after it pulled the video encoder */
  videoEncodingProgress: VideoEncodingProgressPayload;
};


export type SubscriptionPersonCreditsImportReportArgs = {
  entityId: Scalars['ID']['input'];
};


export type SubscriptionJobCompletedArgs = {
  jobId: Scalars['String']['input'];
};


export type SubscriptionVideoEncodingProgressArgs = {
  videoId: Scalars['ID']['input'];
};

export type JobCompletedPayload = {
  jobId: Scalars['String']['output'];
  /** Job task type (e.g. 'polaris') */
  jobTaskType: Scalars['String']['output'];
  data: Scalars['JSON']['output'];
  success: Scalars['Boolean']['output'];
  message: Maybe<Scalars['String']['output']>;
};

export type VideoEncodingProgressPayload = {
  videoId: Scalars['ID']['output'];
  /**
   * Entry of the platform that changed (the first entry for the current status)
   * @deprecated Use videoEncoders, one entry per platform
   */
  videoEncoder: VideoEncoderType;
  /** Every platform entry of the video, after the change */
  videoEncoders: Array<VideoEncoderType>;
};

export type CheckUrlQueryVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type CheckUrlQuery = { checkURL: { success: boolean, error: string | null, statusCode: number | null, responseTime: number } | null };

export type GetFileMetadataQueryVariables = Exact<{
  uploadToken: Scalars['String']['input'];
}>;


export type GetFileMetadataQuery = { fileMetadata: { hash: string, mimeType: string, size: number, path: string, ressourceURI: string, resourceUrl: string | null, imageSize: { width: number, height: number } | null } | null };

export type HeaderInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type HeaderInfoQuery = { viewer: { id: string, ref: string, name: string, author: { id: string, ref: string } | null } };

export type CreateAuthorSignatureMutationVariables = Exact<{
  input: CreateAuthorSignatureInput;
}>;


export type CreateAuthorSignatureMutation = { createAuthorSignature: { id: string } | null };

export type CreateAuthorMutationVariables = Exact<{
  input: CreateAuthorInput;
}>;


export type CreateAuthorMutation = { createAuthor: { id: string, ref: string, user: { author: { id: string } | null } | null } | null };

export type GetAuthorListQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  brandId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAuthorListQuery = { authors: { totalCount: number, nodes: Array<{ id: string, ref: string, name: string, user: { __typename: 'User', id: string, ref: string, name: string } | null, metadata: { updatedAt: string }, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> }, viewer: { id: string } };

export type GetAuthorSignaturesListQueryVariables = Exact<{
  authorId: Scalars['ID']['input'];
}>;


export type GetAuthorSignaturesListQuery = { author: { id: string, user: { id: string } | null, signatures: Array<{ id: string, name: string, signature: string }> } | null, viewer: { id: string } };

export type UpdateAuthorLinksMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  links: SocialLinksInput;
}>;


export type UpdateAuthorLinksMutation = { updateAuthor: { id: string, links: { facebook: string | null, bluesky: string | null, instagram: string | null, letterboxd: string | null, linkedin: string | null, pinterest: string | null, snapchat: string | null, tiktok: string | null, threads: string | null, tumblr: string | null, twitter: string | null, vk: string | null, wechat: string | null, whatsapp: string | null, youtube: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type GetAuthorQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetAuthorQuery = { entityByRef: { id: string, ref: string, name: string, position: string | null, startDate: string | null, stopDate: string | null, shortBio: string, longBio: string | object[] | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, user: { id: string, name: string, email: string } | null, socialUser: { legacyID: string } | null, avatar: { id: string, url: string, ref: string } | null, seoData: { isAutonomouslyActivable: boolean, browsable: boolean, title: string | null, description: string | null } | null, links: { facebook: string | null, bluesky: string | null, instagram: string | null, letterboxd: string | null, linkedin: string | null, pinterest: string | null, snapchat: string | null, tiktok: string | null, threads: string | null, tumblr: string | null, twitter: string | null, vk: string | null, wechat: string | null, whatsapp: string | null, youtube: string | null } } | {} | null, viewer: { id: string } };

export type UpdateAuthorSeoDataMutationVariables = Exact<{
  input: UpdateAuthorSeoDataInput;
}>;


export type UpdateAuthorSeoDataMutation = { updateAuthorSeoData: { id: string, seoData: { isAutonomouslyActivable: boolean, browsable: boolean, title: string | null, description: string | null } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpdateAuthorMutationVariables = Exact<{
  input: UpdateAuthorInput;
}>;


export type UpdateAuthorMutation = { updateAuthor: { id: string, ref: string, name: string, position: string | null, startDate: string | null, stopDate: string | null, shortBio: string, longBio: string | object[] | null, user: { id: string, name: string, email: string, author: { id: string } | null } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, socialUser: { legacyID: string } | null, avatar: { id: string, url: string, ref: string } | null } | null };

export type UpdateAuthorSignatureMutationVariables = Exact<{
  input: UpdateAuthorSignatureInput;
}>;


export type UpdateAuthorSignatureMutation = { updateAuthorSignature: { id: string, name: string, signature: string } | null };

export type AddBoxofficeMutationVariables = Exact<{
  input: AddTemporalBoxofficeInput;
}>;


export type AddBoxofficeMutation = { addTemporalBoxoffice: { id: string } | null };

export type DeleteBoxofficeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteBoxofficeMutation = { deleteTemporalBoxoffice: { id: string } | null };

export type GetBoxofficeListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  countryId: Scalars['ID']['input'];
  movieId?: InputMaybe<Scalars['ID']['input']>;
  range?: InputMaybe<DateRangeInput>;
  rangeOperator?: InputMaybe<RangeOperator>;
  orderBy?: InputMaybe<TemporalBoxofficeOrder>;
}>;


export type GetBoxofficeListQuery = { temporalBoxoffices: { totalCount: number, nodes: Array<{ id: string, value: number | null, cumulative: number | null, copyCount: number | null, estimate: number | null, movie: { __typename: 'Movie', ref: string, id: string, title: string }, range: { startsAt: string, endsAt: string }, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } }> } };

export type UpdateBoxofficeMutationVariables = Exact<{
  input: UpdateTemporalBoxofficeInput;
}>;


export type UpdateBoxofficeMutation = { updateTemporalBoxoffice: { id: string, value: number | null, cumulative: number | null, copyCount: number | null, estimate: number | null, movie: { __typename: 'Movie', ref: string, id: string, title: string }, range: { startsAt: string, endsAt: string }, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } } | null };

export type BrandSearchLinkRowFragment = { __typename: 'BrandSearchLink', id: string, ref: string, active: boolean, title: string | null, url: string | null, description: string | null, keywords: Array<string> | null, brand: { id: string, ref: string, name: string }, poster: { id: string, url: string, ref: string } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type BrandSearchLinksListQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type BrandSearchLinksListQuery = { brandSearchLinks: { totalCount: number, nodes: Array<{ __typename: 'BrandSearchLink', id: string, ref: string, active: boolean, title: string | null, url: string | null, description: string | null, keywords: Array<string> | null, brand: { id: string, ref: string, name: string }, poster: { id: string, url: string, ref: string } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> } | null };

export type DeleteBrandSearchLinkMutationVariables = Exact<{
  input: DeleteBrandSearchLinkInput;
}>;


export type DeleteBrandSearchLinkMutation = { deleteBrandSearchLink: { id: string, title: string | null, ref: string } | null };

export type CreateBrandSearchLinkMutationVariables = Exact<{
  input: CreateBrandSearchLinkInput;
}>;


export type CreateBrandSearchLinkMutation = { createBrandSearchLink: { __typename: 'BrandSearchLink', id: string, ref: string, active: boolean, title: string | null, url: string | null, description: string | null, keywords: Array<string> | null, brand: { id: string, ref: string, name: string }, poster: { id: string, url: string, ref: string } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpdateBrandSearchLinkMutationVariables = Exact<{
  input: UpdateBrandSearchLinkInput;
}>;


export type UpdateBrandSearchLinkMutation = { updateBrandSearchLink: { __typename: 'BrandSearchLink', id: string, ref: string, active: boolean, title: string | null, url: string | null, description: string | null, keywords: Array<string> | null, brand: { id: string, ref: string, name: string }, poster: { id: string, url: string, ref: string } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type AddSlideMutationVariables = Exact<{
  input: AddSlideInput;
}>;


export type AddSlideMutation = { addSlide: { carousel: { id: string, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, slides: Array<{ id: string, rank: number, node: { id: string, ref: string, title: string } }> } } | null };

export type CreateCarouselMutationVariables = Exact<{
  input: CreateCarouselInput;
}>;


export type CreateCarouselMutation = { createCarousel: { ref: string, id: string } | null };

export type CreateSlideMutationVariables = Exact<{
  input: CreateSlideInput;
}>;


export type CreateSlideMutation = { createSlide: { id: string, ref: string } | null };

export type DeleteCarouselMutationVariables = Exact<{
  input: DeleteCarouselInput;
}>;


export type DeleteCarouselMutation = { deleteCarousel: { id: string } | null };

export type DuplicateCarouselMutationVariables = Exact<{
  input: DuplicateCarouselInput;
}>;


export type DuplicateCarouselMutation = { duplicateCarousel: { id: string, ref: string } | null };

export type GetCarouselListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  target?: InputMaybe<Scalars['Tag3D']['input']>;
}>;


export type GetCarouselListQuery = { carousels: { totalCount: number, nodes: Array<{ id: string, ref: string, startsAt: string, metadata: { createdBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> } };

export type CarouselRowFragment = { id: string, ref: string, startsAt: string, metadata: { createdBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type GetCarouselQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetCarouselQuery = { carouselByRef: { id: string, ref: string, target: string, startsAt: string, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, slides: Array<{ id: string, rank: number, node: { id: string, ref: string, title: string } }>, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type GetSlideListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  createdByUserId?: InputMaybe<Scalars['ID']['input']>;
  updatedByUserId?: InputMaybe<Scalars['ID']['input']>;
  orderBy: SlideOrder;
}>;


export type GetSlideListQuery = { slides: { totalCount: number, nodes: Array<{ id: string, ref: string, title: string, active: boolean, metadata: { updatedAt: string } }> } };

export type SlideRowFragment = { id: string, ref: string, title: string, active: boolean, metadata: { updatedAt: string } };

export type GetSlideQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetSlideQuery = { entityByRef: { id: string, active: boolean, title: string, description: string, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, link: { url: string, blank: boolean }, poster: { id: string, url: string, ref: string } | null, parents: Array<{ id: string, rank: number, node: { id: string, ref: string, target: string, startsAt: string } }>, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | {} | null };

export type MoveSlideMutationVariables = Exact<{
  input: MoveSlideInput;
}>;


export type MoveSlideMutation = { moveSlide: { carousel: { id: string, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, slides: Array<{ id: string, rank: number, node: { id: string, ref: string, title: string } }> } } | null };

export type RemoveSlideMutationVariables = Exact<{
  input: RemoveSlideInput;
}>;


export type RemoveSlideMutation = { removeSlide: { carousel: { id: string, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, slides: Array<{ id: string, rank: number, node: { id: string, ref: string, title: string } }> } } | null };

export type UpdateSlideMutationVariables = Exact<{
  input: UpdateSlideInput;
}>;


export type UpdateSlideMutation = { updateSlide: { id: string, active: boolean, title: string, description: string, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, link: { url: string, blank: boolean }, poster: { id: string, url: string, ref: string } | null } | null };

export type UpdateCarouselMutationVariables = Exact<{
  input: UpdateCarouselInput;
}>;


export type UpdateCarouselMutation = { updateCarousel: { id: string, ref: string, target: string, startsAt: string, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } } | null };

export type CreateCertificateMutationVariables = Exact<{
  input: CreateCertificateInput;
}>;


export type CreateCertificateMutation = { createCertificate: { __typename: 'Certificate', id: string, ref: string, rank: number, active: boolean, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null } | null };

export type DeleteCertificateMutationVariables = Exact<{
  input: DeleteCertificateInput;
}>;


export type DeleteCertificateMutation = { deleteCertificate: { __typename: 'Certificate', id: string, ref: string, rank: number, active: boolean, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null } | null };

export type UpdateCertificateMutationVariables = Exact<{
  input: UpdateCertificateInput;
}>;


export type UpdateCertificateMutation = { updateCertificate: { __typename: 'Certificate', id: string, ref: string, rank: number, active: boolean, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null } | null };

export type GetCertificatesListQueryVariables = Exact<{
  countryId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  limitedLocalizationId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCertificatesListQuery = { certificates: { totalCount: number, nodes: Array<{ __typename: 'Certificate', id: string, ref: string, rank: number, active: boolean, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null }> } };

export type GetCertificateQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetCertificateQuery = { entityByRef: { __typename: 'User' } | { __typename: 'Locale' } | { __typename: 'Author' } | { __typename: 'SocialUser' } | { __typename: 'Image' } | { __typename: 'Movie' } | { __typename: 'ImageCategory' } | { __typename: 'Series' } | { __typename: 'Company' } | { __typename: 'CompanyStaff' } | { __typename: 'News' } | { __typename: 'VideoLegacy' } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' } | { __typename: 'Certificate', id: string, ref: string, rank: number, active: boolean, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null } | { __typename: 'Person' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | { __typename: 'Slide' } | { __typename: 'Carousel' } | { __typename: 'Theater' } | { __typename: 'Screen' } | { __typename: 'FestivalAward' } | { __typename: 'FestivalSelection' } | { __typename: 'FestivalCompetition' } | { __typename: 'FestivalEditionCompetition' } | { __typename: 'FestivalJury' } | { __typename: 'TheaterEvent' } | { __typename: 'Widget' } | { __typename: 'VideoB2B' } | null };

export type CreateClocksMutationVariables = Exact<{
  input: CreateClocksInput;
}>;


export type CreateClocksMutation = { createClocks: Array<{ id: string, ref: string } | null> | null };

export type DeleteClockMutationVariables = Exact<{
  input: DeleteClockInput;
}>;


export type DeleteClockMutation = { deleteClock: { id: string } | null };

export type GetClockTheaterQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetClockTheaterQuery = { theater: { __typename: 'Theater', id: string, ref: string, code: string, name: string, openingStatus: TheaterOpeningStatus, showtimeSource: TheaterShowtimeSource | null, parent: { __typename: 'Company', id: string, ref: string, name: string } | null, location: { city: string | null } | null, country: { __typename: 'Country', showtimeReleaseDay: ShowtimeReleaseDay | null, preferredClockFormat: PreferredClockFormat | null, id: string, ref: string, name: string, alpha2: string } } | null };

export type GetClockListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  theaterId?: InputMaybe<Scalars['ID']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  orderBy: ClockOrder;
}>;


export type GetClockListQuery = { clocks: { totalCount: number, nodes: Array<{ id: string, ref: string, showtimes: Array<string>, technos: Array<ClockTechno>, amenity: ClockAmenity | null, seatingStyle: ClockSeatingStyle | null, sound: ClockSound | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, range: { startsAt: string, endsAt: string }, entity: { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null }, theater: { __typename: 'Theater', id: string, ref: string, code: string, country: { __typename: 'Country', preferredClockFormat: PreferredClockFormat | null, id: string, ref: string, name: string, alpha2: string } } }> } };

export type ClockRowFragment = { id: string, ref: string, showtimes: Array<string>, technos: Array<ClockTechno>, amenity: ClockAmenity | null, seatingStyle: ClockSeatingStyle | null, sound: ClockSound | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, range: { startsAt: string, endsAt: string }, entity: { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null }, theater: { __typename: 'Theater', id: string, ref: string, code: string, country: { __typename: 'Country', preferredClockFormat: PreferredClockFormat | null, id: string, ref: string, name: string, alpha2: string } } };

export type GetClockQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetClockQuery = { clockByRef: { __typename: 'Clock', id: string, ref: string, subtitlesLanguage: Language | null, language: Language | null, seatingStyle: ClockSeatingStyle | null, amenity: ClockAmenity | null, showtimes: Array<string>, technos: Array<ClockTechno>, sound: ClockSound | null, comment: string | null, range: { startsAt: string, endsAt: string }, theater: { __typename: 'Theater', id: string, ref: string, code: string, name: string, country: { __typename: 'Country', showtimeReleaseDay: ShowtimeReleaseDay | null, preferredClockFormat: PreferredClockFormat | null, id: string, ref: string, name: string, alpha2: string } }, screen: { id: string, name: string } | null, entity: { __typename: 'Movie', id: string, title: string, ref: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type TheaterWouldImportShowtimesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TheaterWouldImportShowtimesQuery = { theater: { wouldImportShowtimes: boolean } | null };

export type GetTheaterOptionQueryVariables = Exact<{
  theaterId: Scalars['ID']['input'];
}>;


export type GetTheaterOptionQuery = { theaterByCode: { __typename: 'Theater', id: string, ref: string, code: string, name: string, openingStatus: TheaterOpeningStatus, location: { city: string | null, zip: string | null } | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, parent: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null } | null };

export type UpdateClockMutationVariables = Exact<{
  input: UpdateClockInput;
}>;


export type UpdateClockMutation = { updateClock: { id: string, ref: string, subtitlesLanguage: Language | null, language: Language | null, seatingStyle: ClockSeatingStyle | null, amenity: ClockAmenity | null, showtimes: Array<string>, technos: Array<ClockTechno>, sound: ClockSound | null, comment: string | null, range: { startsAt: string, endsAt: string }, theater: { __typename: 'Theater', id: string, ref: string, code: string, name: string, country: { __typename: 'Country', showtimeReleaseDay: ShowtimeReleaseDay | null, preferredClockFormat: PreferredClockFormat | null, id: string, ref: string, name: string, alpha2: string } }, screen: { id: string, name: string } | null, entity: { __typename: 'Movie', id: string, title: string, ref: string } } | null };

export type CreateCompanyMutationVariables = Exact<{
  input: CreateCompanyInput;
}>;


export type CreateCompanyMutation = { createCompany: { id: string, ref: string } | null };

export type AddImageToCompanyMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
  imageId: Scalars['ID']['input'];
}>;


export type AddImageToCompanyMutation = { addImageToCompany: { rank: number, image: { id: string, url: string, ref: string } } | null };

export type CreateCompanyStaffMutationVariables = Exact<{
  input: CreateCompanyStaffInput;
}>;


export type CreateCompanyStaffMutation = { createCompanyStaff: { id: string, ref: string } | null };

export type DeleteCompanyStaffMutationVariables = Exact<{
  input: DeleteCompanyStaffInput;
}>;


export type DeleteCompanyStaffMutation = { deleteCompanyStaff: { id: string } | null };

export type DeleteImageFromCompanyMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  imageId: Scalars['ID']['input'];
}>;


export type DeleteImageFromCompanyMutation = { deleteImageFromCompany: { rank: number, image: { id: string, url: string } } };

export type GetActivityMappingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActivityMappingQuery = { companiesActivitySubactivityMapping: Array<{ activity: CompanyActivities, subactivities: Array<CompanySubactivities> }> };

export type GetCompanyBrandedDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
}>;


export type GetCompanyBrandedDataQuery = { company: { id: string, brandData: { description: string | null, name: string | null } | null } | null };

export type GetCompanyIdentityQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type GetCompanyIdentityQuery = { company: { __typename: 'Company', id: string, foundedAt: string | null, activities: Array<CompanyActivity>, closed: boolean, providerAsFavorite: boolean, email: string | null, websiteUrl: string | null, androidUrl: string | null, iosUrl: string | null, phone: string | null, note: string | null, description: string | null, ref: string, name: string, activitiesTree: Array<{ activity: CompanyActivities, subactivities: Array<CompanySubactivities> }>, externalIDs: Array<{ type: string, alts: Array<string> }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, coordinates: { latitude: number, longitude: number } | null, location: { address: string | null, address2: string | null, zip: string | null, city: string | null, state: string | null, county: string | null, country: string | null } | null, parent: { __typename: 'Company', id: string, ref: string, name: string, activities: Array<CompanyActivity>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null, logo: { id: string, url: string, ref: string } | null, data: { sourceName: string | null, allowMatchingTypeOverrides: boolean, approvals: { cnc: { number: string | null } | null } | null }, links: { facebook: string | null, bluesky: string | null, instagram: string | null, letterboxd: string | null, linkedin: string | null, pinterest: string | null, snapchat: string | null, tiktok: string | null, threads: string | null, tumblr: string | null, twitter: string | null, vk: string | null, wechat: string | null, whatsapp: string | null, youtube: string | null }, children: Array<{ __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }>, activeOnBrands: Array<{ ref: string }> } | null };

export type GetCompanyStaffIdentityQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetCompanyStaffIdentityQuery = { entityByRef: { __typename: 'User' } | { __typename: 'Locale' } | { __typename: 'Author' } | { __typename: 'SocialUser' } | { __typename: 'Image' } | { __typename: 'Movie' } | { __typename: 'ImageCategory' } | { __typename: 'Series' } | { __typename: 'Company' } | { __typename: 'CompanyStaff', ref: string, id: string, rank: number, active: boolean, companyId: string | null, firstName: string | null, lastName: string | null, name: string | null, department: CompanyStaffDepartment | null, title: string | null, email: string | null, workPhone: string | null, mobilePhone: string | null, company: { ref: string } | null, copyCompanies: Array<{ id: string, name: string }> | null, pubCompanies: Array<{ id: string, name: string }> | null } | { __typename: 'News' } | { __typename: 'VideoLegacy' } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' } | { __typename: 'Certificate' } | { __typename: 'Person' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | { __typename: 'Slide' } | { __typename: 'Carousel' } | { __typename: 'Theater' } | { __typename: 'Screen' } | { __typename: 'FestivalAward' } | { __typename: 'FestivalSelection' } | { __typename: 'FestivalCompetition' } | { __typename: 'FestivalEditionCompetition' } | { __typename: 'FestivalJury' } | { __typename: 'TheaterEvent' } | { __typename: 'Widget' } | { __typename: 'VideoB2B' } | null };

export type GetCompanyImagesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
}>;


export type GetCompanyImagesQuery = { company: { id: string, images: { totalCount: number, nodes: Array<{ rank: number, image: { id: string, url: string, ref: string } }> } } | null };

export type GetCompanyListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  search: Scalars['String']['input'];
  activities: Array<CompanyActivity> | CompanyActivity;
  additionalTags: Array<CompanyAdditionalTag> | CompanyAdditionalTag;
  countryIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  orderBy: CompanyOrder;
}>;


export type GetCompanyListQuery = { companies: { totalCount: number, nodes: Array<{ ref: string, id: string, name: string, activities: Array<CompanyActivity>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, parent: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null, metadata: { createdAt: string } }> } };

export type GetCompanyTheatersQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  companyIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCompanyTheatersQuery = { theaters: { totalCount: number, nodes: Array<{ id: string, code: string, name: string, openingStatus: TheaterOpeningStatus, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, coordinates: { latitude: number, longitude: number } | null, location: { address: string | null, zip: string | null, city: string | null, country: string | null, state: string | null, county: string | null } | null }> } };

export type CompanyTheaterFragment = { id: string, code: string, name: string, openingStatus: TheaterOpeningStatus, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, coordinates: { latitude: number, longitude: number } | null, location: { address: string | null, zip: string | null, city: string | null, country: string | null, state: string | null, county: string | null } | null };

export type GetCompanyStaffListQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
  orderBy?: InputMaybe<CompanyStaffOrder>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
}>;


export type GetCompanyStaffListQuery = { companyStaffList: { totalCount: number, nodes: Array<{ __typename: 'CompanyStaff', ref: string, id: string, rank: number, active: boolean, companyId: string | null, firstName: string | null, lastName: string | null, name: string | null, department: CompanyStaffDepartment | null, title: string | null, email: string | null, workPhone: string | null, mobilePhone: string | null, company: { ref: string } | null, copyCompanies: Array<{ id: string, name: string }> | null, pubCompanies: Array<{ id: string, name: string }> | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> } };

export type GetCompanyQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetCompanyQuery = { entityByRef: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | {} | null };

export type GetCompanyLocalizedDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  locale: Scalars['ID']['input'];
}>;


export type GetCompanyLocalizedDataQuery = { company: { id: string, localeData: { description: string | null, name: string | null } | null } | null };

export type UpdateCompanyAddressMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
  coordinates: CoordinatesInput;
  location: LocationInput;
}>;


export type UpdateCompanyAddressMutation = { updateEntityLocalization: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }>, coordinates: { latitude: number, longitude: number } | null, location: { address: string | null, address2: string | null, zip: string | null, city: string | null, state: string | null, county: string | null, country: string | null } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | {} | null };

export type MoveCompanyStaffMutationVariables = Exact<{
  input: MoveCompanyStaffInput;
}>;


export type MoveCompanyStaffMutation = { moveCompanyStaff: { id: string, rank: number } | null };

export type UpdateCompanyBrandedDataMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCompanyBrandedDataMutation = { updateCompanyBrandData: { name: string | null, description: string | null } | null };

export type UpdateCompanyIdentityMutationVariables = Exact<{
  input: UpdateCompanyInput;
}>;


export type UpdateCompanyIdentityMutation = { updateCompany: { __typename: 'Company', id: string, foundedAt: string | null, activities: Array<CompanyActivity>, closed: boolean, providerAsFavorite: boolean, email: string | null, websiteUrl: string | null, androidUrl: string | null, iosUrl: string | null, phone: string | null, note: string | null, description: string | null, ref: string, name: string, activitiesTree: Array<{ activity: CompanyActivities, subactivities: Array<CompanySubactivities> }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, parent: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null, logo: { id: string, url: string, ref: string } | null, data: { sourceName: string | null, allowMatchingTypeOverrides: boolean, approvals: { cnc: { number: string | null } | null } | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, activeOnBrands: Array<{ ref: string }> } | null };

export type UpdateCompanyLinksMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  links: SocialLinksInput;
}>;


export type UpdateCompanyLinksMutation = { updateCompany: { __typename: 'Company', id: string, ref: string, name: string, links: { facebook: string | null, bluesky: string | null, instagram: string | null, letterboxd: string | null, linkedin: string | null, pinterest: string | null, snapchat: string | null, tiktok: string | null, threads: string | null, tumblr: string | null, twitter: string | null, vk: string | null, wechat: string | null, whatsapp: string | null, youtube: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null };

export type UpdateCompanyInfoMutationVariables = Exact<{
  input: UpdateCompanyInput;
}>;


export type UpdateCompanyInfoMutation = { updateCompany: { __typename: 'Company', id: string, foundedAt: string | null, activities: Array<CompanyActivity>, closed: boolean, providerAsFavorite: boolean, email: string | null, websiteUrl: string | null, androidUrl: string | null, iosUrl: string | null, phone: string | null, note: string | null, description: string | null, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, parent: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null, logo: { id: string, url: string, ref: string } | null, data: { sourceName: string | null, allowMatchingTypeOverrides: boolean, approvals: { cnc: { number: string | null } | null } | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, activeOnBrands: Array<{ ref: string }> } | null };

export type UpdateCompanyLocalizedDataMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  localeId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCompanyLocalizedDataMutation = { updateCompanyLocaleData: { name: string | null, description: string | null } | null };

export type UpdateCompanyStaffMutationVariables = Exact<{
  input: UpdateCompanyStaffInput;
}>;


export type UpdateCompanyStaffMutation = { updateCompanyStaff: { ref: string, id: string, rank: number, active: boolean, companyId: string | null, firstName: string | null, lastName: string | null, name: string | null, department: CompanyStaffDepartment | null, title: string | null, email: string | null, workPhone: string | null, mobilePhone: string | null, company: { ref: string } | null, copyCompanies: Array<{ id: string, name: string }> | null, pubCompanies: Array<{ id: string, name: string }> | null } | null };

export type GetCountryListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  search: Scalars['String']['input'];
  orderBy: CountryOrder;
}>;


export type GetCountryListQuery = { countries: { totalCount: number, nodes: Array<{ id: string, ref: string, name: string, alpha2: string, alpha3: string }> } };

export type GetCountryByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCountryByIdQuery = { country: { __typename: 'Country', alpha3: string, preferredClockFormat: PreferredClockFormat | null, id: string, ref: string, name: string, alpha2: string, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type GetCountryQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetCountryQuery = { countryByRef: { __typename: 'Country', alpha3: string, preferredClockFormat: PreferredClockFormat | null, id: string, ref: string, name: string, alpha2: string, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpdateCountryMutationVariables = Exact<{
  input: UpdateCountryInput;
}>;


export type UpdateCountryMutation = { updateCountry: { __typename: 'Country', alpha3: string, preferredClockFormat: PreferredClockFormat | null, id: string, ref: string, name: string, alpha2: string, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type GetDuplicateListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  status?: InputMaybe<Array<DuplicateStatus> | DuplicateStatus>;
  entityType?: InputMaybe<DuplicateEntityType>;
  orderBy?: InputMaybe<DuplicateOrder>;
  entityIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetDuplicateListQuery = { duplicates: { totalCount: number, nodes: Array<{ id: string, ref: string, status: DuplicateStatus, priority: DuplicatePriority, metadata: { createdAt: string, updatedAt: string }, firstEntity: { __typename: 'DeletedEntity', ref: string, source: { typename: string, ref: string } } | { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | { __typename: 'Movie', ref: string, title: string } | { __typename: 'Series', ref: string, title: string } | { __typename: 'Person', ref: string, lastName: string | null, firstName: string | null }, secondEntity: { __typename: 'DeletedEntity', ref: string, source: { typename: string, ref: string } } | { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | { __typename: 'Movie', ref: string, title: string } | { __typename: 'Series', ref: string, title: string } | { __typename: 'Person', ref: string, lastName: string | null, firstName: string | null }, winner: { __typename: 'DeletedEntity', ref: string, source: { typename: string, ref: string } } | { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | { __typename: 'Movie', ref: string, title: string } | { __typename: 'Series', ref: string, title: string } | { __typename: 'Person', ref: string, lastName: string | null, firstName: string | null } | null }> } };

type DuplicateEntityLight_DeletedEntity_Fragment = { __typename: 'DeletedEntity', ref: string, source: { typename: string, ref: string } };

type DuplicateEntityLight_Company_Fragment = { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> };

type DuplicateEntityLight_Movie_Fragment = { __typename: 'Movie', ref: string, title: string };

type DuplicateEntityLight_Series_Fragment = { __typename: 'Series', ref: string, title: string };

type DuplicateEntityLight_Person_Fragment = { __typename: 'Person', ref: string, lastName: string | null, firstName: string | null };

export type DuplicateEntityLightFragment = DuplicateEntityLight_DeletedEntity_Fragment | DuplicateEntityLight_Company_Fragment | DuplicateEntityLight_Movie_Fragment | DuplicateEntityLight_Series_Fragment | DuplicateEntityLight_Person_Fragment;

export type UpdateDuplicateMutationVariables = Exact<{
  input: UpdateDuplicateInput;
}>;


export type UpdateDuplicateMutation = { updateDuplicate: { id: string, status: DuplicateStatus, priority: DuplicatePriority, comment: string | null, firstEntity: { __typename: 'DeletedEntity', ref: string, id: string, source: { typename: string, ref: string } } | { __typename: 'Company', id: string, ref: string, name: string, logo: { id: string } | null, activeOnBrands: Array<{ ref: string }>, brandsData: Array<{ description: string | null, name: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, seoAttributes: Array<{ isAutonomouslyActivable: boolean, browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', ref: string, id: string, title: string, releases: { totalCount: number }, activeOnBrands: Array<{ ref: string }>, movieBrandsData: Array<{ synopsis: string | object[] | null, synopsisShort: string | object[] | null, title: string | null, poster: { id: string } | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, seoAttributes: Array<{ isAutonomouslyActivable: boolean, browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }>, externalIDs: Array<{ type: string, alts: Array<string> }> } | { __typename: 'Series', ref: string, id: string, title: string, releases: { totalCount: number }, activeOnBrands: Array<{ ref: string }>, seriesBrandsData: Array<{ synopsis: string | object[] | null, synopsisShort: string | null, title: string | null, poster: { id: string } | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, seoAttributes: Array<{ isAutonomouslyActivable: boolean, browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> } | { __typename: 'Person', ref: string, id: string, lastName: string | null, firstName: string | null, activeOnBrands: Array<{ ref: string }>, brandsData: Array<{ biography: string | object[] | null, biographyShort: string | null, poster: { id: string } | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, seoAttributes: Array<{ isAutonomouslyActivable: boolean, browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> }, secondEntity: { __typename: 'DeletedEntity', ref: string, id: string, source: { typename: string, ref: string } } | { __typename: 'Company', id: string, ref: string, name: string, logo: { id: string } | null, activeOnBrands: Array<{ ref: string }>, brandsData: Array<{ description: string | null, name: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, seoAttributes: Array<{ isAutonomouslyActivable: boolean, browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', ref: string, id: string, title: string, releases: { totalCount: number }, activeOnBrands: Array<{ ref: string }>, movieBrandsData: Array<{ synopsis: string | object[] | null, synopsisShort: string | object[] | null, title: string | null, poster: { id: string } | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, seoAttributes: Array<{ isAutonomouslyActivable: boolean, browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }>, externalIDs: Array<{ type: string, alts: Array<string> }> } | { __typename: 'Series', ref: string, id: string, title: string, releases: { totalCount: number }, activeOnBrands: Array<{ ref: string }>, seriesBrandsData: Array<{ synopsis: string | object[] | null, synopsisShort: string | null, title: string | null, poster: { id: string } | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, seoAttributes: Array<{ isAutonomouslyActivable: boolean, browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> } | { __typename: 'Person', ref: string, id: string, lastName: string | null, firstName: string | null, activeOnBrands: Array<{ ref: string }>, brandsData: Array<{ biography: string | object[] | null, biographyShort: string | null, poster: { id: string } | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, seoAttributes: Array<{ isAutonomouslyActivable: boolean, browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> }, winner: { id: string } | { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | { id: string } | { id: string } | { id: string } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type GetDuplicateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDuplicateQuery = { duplicate: { id: string, status: DuplicateStatus, priority: DuplicatePriority, comment: string | null, firstEntity: { __typename: 'DeletedEntity', ref: string, id: string, source: { typename: string, ref: string } } | { __typename: 'Company', id: string, ref: string, name: string, logo: { id: string } | null, activeOnBrands: Array<{ ref: string }>, brandsData: Array<{ description: string | null, name: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, seoAttributes: Array<{ isAutonomouslyActivable: boolean, browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', ref: string, id: string, title: string, releases: { totalCount: number }, activeOnBrands: Array<{ ref: string }>, movieBrandsData: Array<{ synopsis: string | object[] | null, synopsisShort: string | object[] | null, title: string | null, poster: { id: string } | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, seoAttributes: Array<{ isAutonomouslyActivable: boolean, browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }>, externalIDs: Array<{ type: string, alts: Array<string> }> } | { __typename: 'Series', ref: string, id: string, title: string, releases: { totalCount: number }, activeOnBrands: Array<{ ref: string }>, seriesBrandsData: Array<{ synopsis: string | object[] | null, synopsisShort: string | null, title: string | null, poster: { id: string } | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, seoAttributes: Array<{ isAutonomouslyActivable: boolean, browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> } | { __typename: 'Person', ref: string, id: string, lastName: string | null, firstName: string | null, activeOnBrands: Array<{ ref: string }>, brandsData: Array<{ biography: string | object[] | null, biographyShort: string | null, poster: { id: string } | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, seoAttributes: Array<{ isAutonomouslyActivable: boolean, browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> }, secondEntity: { __typename: 'DeletedEntity', ref: string, id: string, source: { typename: string, ref: string } } | { __typename: 'Company', id: string, ref: string, name: string, logo: { id: string } | null, activeOnBrands: Array<{ ref: string }>, brandsData: Array<{ description: string | null, name: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, seoAttributes: Array<{ isAutonomouslyActivable: boolean, browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', ref: string, id: string, title: string, releases: { totalCount: number }, activeOnBrands: Array<{ ref: string }>, movieBrandsData: Array<{ synopsis: string | object[] | null, synopsisShort: string | object[] | null, title: string | null, poster: { id: string } | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, seoAttributes: Array<{ isAutonomouslyActivable: boolean, browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }>, externalIDs: Array<{ type: string, alts: Array<string> }> } | { __typename: 'Series', ref: string, id: string, title: string, releases: { totalCount: number }, activeOnBrands: Array<{ ref: string }>, seriesBrandsData: Array<{ synopsis: string | object[] | null, synopsisShort: string | null, title: string | null, poster: { id: string } | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, seoAttributes: Array<{ isAutonomouslyActivable: boolean, browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> } | { __typename: 'Person', ref: string, id: string, lastName: string | null, firstName: string | null, activeOnBrands: Array<{ ref: string }>, brandsData: Array<{ biography: string | object[] | null, biographyShort: string | null, poster: { id: string } | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, seoAttributes: Array<{ isAutonomouslyActivable: boolean, browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> }, winner: { id: string } | { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | { id: string } | { id: string } | { id: string } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null, brands: Array<{ ref: string }> };

export type AddDuplicateMutationVariables = Exact<{
  input: AddDuplicateInput;
}>;


export type AddDuplicateMutation = { addDuplicate: { ref: string } | null };

export type CreateFestivalAwardMutationVariables = Exact<{
  input: CreateFestivalAwardInput;
}>;


export type CreateFestivalAwardMutation = { createFestivalAward: { id: string, ref: string, name: string } | null };

export type CreateFestivalEditionCompetitionMutationVariables = Exact<{
  input: CreateFestivalEditionCompetitionInput;
}>;


export type CreateFestivalEditionCompetitionMutation = { createFestivalEditionCompetition: { id: string, ref: string } | null };

export type CopyFestivalEditionMutationVariables = Exact<{
  input: CopyFestivalEditionInput;
}>;


export type CopyFestivalEditionMutation = { copyFestivalEdition: { id: string, ref: string } | null };

export type CreateFestivalCompetitionMutationVariables = Exact<{
  input: CreateFestivalCompetitionInput;
}>;


export type CreateFestivalCompetitionMutation = { createFestivalCompetition: { id: string, ref: string } };

export type CreateFestivalSelectionMutationVariables = Exact<{
  input: CreateFestivalSelectionInput;
}>;


export type CreateFestivalSelectionMutation = { createFestivalSelection: { id: string, ref: string } | null };

export type CreateFestivalEditionMutationVariables = Exact<{
  input: CreateFestivalEditionInput;
}>;


export type CreateFestivalEditionMutation = { createFestivalEdition: { id: string, ref: string } | null };

export type CreateFestivalMutationVariables = Exact<{
  input: CreateFestivalInput;
}>;


export type CreateFestivalMutation = { createFestival: { id: string, ref: string } | null };

export type CreateFestivalJuryMutationVariables = Exact<{
  input: CreateFestivalJuryInput;
}>;


export type CreateFestivalJuryMutation = { createFestivalJury: { id: string, ref: string } | null };

export type DeleteFestivalAwardMutationVariables = Exact<{
  input: DeleteFestivalAwardInput;
}>;


export type DeleteFestivalAwardMutation = { deleteFestivalAward: { id: string } | null };

export type DeleteFestivalEditionCompetitionMutationVariables = Exact<{
  input: DeleteFestivalEditionCompetitionInput;
}>;


export type DeleteFestivalEditionCompetitionMutation = { deleteFestivalEditionCompetition: { id: string } | null };

export type DeleteFestivalEditionMutationVariables = Exact<{
  input: DeleteFestivalEditionInput;
}>;


export type DeleteFestivalEditionMutation = { deleteFestivalEdition: { id: string } | null };

export type DeleteFestivalJuryMutationVariables = Exact<{
  input: DeleteFestivalJuryInput;
}>;


export type DeleteFestivalJuryMutation = { deleteFestivalJury: { id: string } | null };

export type DeleteFestivalSelectionMutationVariables = Exact<{
  input: DeleteFestivalSelectionInput;
}>;


export type DeleteFestivalSelectionMutation = { deleteFestivalSelection: { id: string } | null };

export type DeleteFestivalMutationVariables = Exact<{
  input: DeleteFestivalInput;
}>;


export type DeleteFestivalMutation = { deleteFestival: { id: string } | null };

export type GetFestivalAwardsByRefQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
  orderBy?: InputMaybe<FestivalSelectionEntityOrder>;
}>;


export type GetFestivalAwardsByRefQuery = { festivalAwardByRef: { __typename: 'FestivalAward', ref: string, id: string, name: string, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, festival: { __typename: 'Festival', id: string, ref: string, name: string }, festivalSelections: Array<{ __typename: 'FestivalSelection', ref: string, id: string, festivalEdition: { __typename: 'FestivalEdition', id: string, ref: string, year: number, festival: { __typename: 'Festival', id: string, ref: string, name: string } }, nominees: { entity: { __typename: 'Movie', ref: string, title: string } | { __typename: 'Series', ref: string, title: string } | null, persons: Array<{ __typename: 'Person', ref: string, lastName: string | null, firstName: string | null }> | null } | null } | null> | null } | null };

export type GetFestivalAwardsListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  festivalId: Scalars['ID']['input'];
  locale: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<FestivalAwardOrder>;
}>;


export type GetFestivalAwardsListQuery = { festivalAwards: { totalCount: number, nodes: Array<{ __typename: 'FestivalAward', id: string, ref: string, active: boolean, name: string, rank: number, festival: { id: string, ref: string, name: string, localizedData: { name: string | null, synopsis: string | object[] | null } | null }, nominees: { entity: { __typename: 'Movie', id: string, ref: string, title: string, localeData: { title: string | null } | null } | { __typename: 'Series', id: string, ref: string, title: string, localeData: { title: string | null } | null } | null, persons: Array<{ __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null }> | null } | null, localizedData: { name: string | null } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> } };

export type GetFestivalAndEditionByRefsQueryVariables = Exact<{
  festivalRef: Scalars['ID']['input'];
  editionRef: Scalars['ID']['input'];
}>;


export type GetFestivalAndEditionByRefsQuery = { festival: { __typename: 'User' } | { __typename: 'Locale' } | { __typename: 'Author' } | { __typename: 'SocialUser' } | { __typename: 'Image' } | { __typename: 'Movie' } | { __typename: 'ImageCategory' } | { __typename: 'Series' } | { __typename: 'Company' } | { __typename: 'CompanyStaff' } | { __typename: 'News' } | { __typename: 'VideoLegacy' } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' } | { __typename: 'Certificate' } | { __typename: 'Person' } | { __typename: 'Festival', id: string, ref: string } | { __typename: 'FestivalEdition' } | { __typename: 'Slide' } | { __typename: 'Carousel' } | { __typename: 'Theater' } | { __typename: 'Screen' } | { __typename: 'FestivalAward' } | { __typename: 'FestivalSelection' } | { __typename: 'FestivalCompetition' } | { __typename: 'FestivalEditionCompetition' } | { __typename: 'FestivalJury' } | { __typename: 'TheaterEvent' } | { __typename: 'Widget' } | { __typename: 'VideoB2B' } | null, festivalEdition: { __typename: 'User' } | { __typename: 'Locale' } | { __typename: 'Author' } | { __typename: 'SocialUser' } | { __typename: 'Image' } | { __typename: 'Movie' } | { __typename: 'ImageCategory' } | { __typename: 'Series' } | { __typename: 'Company' } | { __typename: 'CompanyStaff' } | { __typename: 'News' } | { __typename: 'VideoLegacy' } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' } | { __typename: 'Certificate' } | { __typename: 'Person' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition', id: string, ref: string } | { __typename: 'Slide' } | { __typename: 'Carousel' } | { __typename: 'Theater' } | { __typename: 'Screen' } | { __typename: 'FestivalAward' } | { __typename: 'FestivalSelection' } | { __typename: 'FestivalCompetition' } | { __typename: 'FestivalEditionCompetition' } | { __typename: 'FestivalJury' } | { __typename: 'TheaterEvent' } | { __typename: 'Widget' } | { __typename: 'VideoB2B' } | null };

export type GetFestivalByRefQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetFestivalByRefQuery = { festivalByRef: { __typename: 'Festival', id: string, ref: string, name: string, poster: { url: string } | null, latestFestivalEdition: { __typename: 'FestivalEdition', poster: { url: string } | null } | null, country: { locale: { id: string } | null } } | null };

export type GetFestivalDefaultContextQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFestivalDefaultContextQuery = { festivalDefaultLocale: { id: string, name: string, ref: string } | null, festivalDefaultBrand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } | null };

export type GetFestivalCompetitionMetadataQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
  locale: Scalars['ID']['input'];
}>;


export type GetFestivalCompetitionMetadataQuery = { entityByRef: { __typename: 'User' } | { __typename: 'Locale' } | { __typename: 'Author' } | { __typename: 'SocialUser' } | { __typename: 'Image' } | { __typename: 'Movie' } | { __typename: 'ImageCategory' } | { __typename: 'Series' } | { __typename: 'Company' } | { __typename: 'CompanyStaff' } | { __typename: 'News' } | { __typename: 'VideoLegacy' } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' } | { __typename: 'Certificate' } | { __typename: 'Person' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | { __typename: 'Slide' } | { __typename: 'Carousel' } | { __typename: 'Theater' } | { __typename: 'Screen' } | { __typename: 'FestivalAward' } | { __typename: 'FestivalSelection' } | { __typename: 'FestivalCompetition', id: string, ref: string, name: string | null, active: boolean, display: FestivalCompetitionDisplay | null, localizedData: { name: string | null } | null, festival: { ref: string, name: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | { __typename: 'FestivalEditionCompetition' } | { __typename: 'FestivalJury' } | { __typename: 'TheaterEvent' } | { __typename: 'Widget' } | { __typename: 'VideoB2B' } | null };

export type GetFestivalEditionByRefQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetFestivalEditionByRefQuery = { entityByRef: { __typename: 'User' } | { __typename: 'Locale' } | { __typename: 'Author' } | { __typename: 'SocialUser' } | { __typename: 'Image' } | { __typename: 'Movie' } | { __typename: 'ImageCategory' } | { __typename: 'Series' } | { __typename: 'Company' } | { __typename: 'CompanyStaff' } | { __typename: 'News' } | { __typename: 'VideoLegacy' } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' } | { __typename: 'Certificate' } | { __typename: 'Person' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition', id: string, ref: string, name: string | null, year: number, editionNumber: number | null, poster: { url: string } | null, festival: { name: string } } | { __typename: 'Slide' } | { __typename: 'Carousel' } | { __typename: 'Theater' } | { __typename: 'Screen' } | { __typename: 'FestivalAward' } | { __typename: 'FestivalSelection' } | { __typename: 'FestivalCompetition' } | { __typename: 'FestivalEditionCompetition' } | { __typename: 'FestivalJury' } | { __typename: 'TheaterEvent' } | { __typename: 'Widget' } | { __typename: 'VideoB2B' } | null };

export type GetFestivalEditionIdentityQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  locale: Scalars['ID']['input'];
}>;


export type GetFestivalEditionIdentityQuery = { festivalEdition: { id: string, ref: string, active: boolean, year: number, editionNumber: number | null, name: string | null, startsAt: string | null, endsAt: string | null, localizedData: { name: string | null } | null, festival: { __typename: 'Festival', id: string, ref: string, name: string }, poster: { id: string, url: string, ref: string } | null } | null };

export type GetFestivalEditionCompetitionIdsQueryVariables = Exact<{
  editionId: Scalars['ID']['input'];
}>;


export type GetFestivalEditionCompetitionIdsQuery = { festivalEditionCompetitions: Array<{ festivalCompetition: { ref: string, name: string | null } | null }> | null };

export type GetFestivalEditionAvailableCompetitionsSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  festivalId: Scalars['ID']['input'];
  festivalEditionId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetFestivalEditionAvailableCompetitionsSearchQuery = { festivalEditionCompetitionsSearch: Array<{ name: string, festivalCompetition: { id: string }, edition: { editionNumber: number | null, year: number }, localizedData: { name: string | null } | null }> | null };

export type GetFestivalEditionCompetitionsQueryVariables = Exact<{
  editionId: Scalars['ID']['input'];
  locale: Scalars['ID']['input'];
}>;


export type GetFestivalEditionCompetitionsQuery = { festivalEditionCompetitions: Array<{ __typename: 'FestivalEditionCompetition', id: string, active: boolean, rank: number, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, festivalCompetition: { id: string, ref: string, name: string | null, active: boolean, display: FestivalCompetitionDisplay | null, localizedData: { name: string | null } | null, festival: { ref: string, name: string } } | null, festival: { ref: string, name: string } }> | null };

export type GetFestivalEditionListQueryVariables = Exact<{
  festivalId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  locale: Scalars['ID']['input'];
  orderBy?: InputMaybe<FestivalEditionOrder>;
}>;


export type GetFestivalEditionListQuery = { festivalEditions: { totalCount: number, nodes: Array<{ __typename: 'FestivalEdition', id: string, ref: string, active: boolean, year: number, editionNumber: number | null, name: string | null, startsAt: string | null, endsAt: string | null, localizedData: { name: string | null } | null, festival: { __typename: 'Festival', id: string, ref: string, name: string }, poster: { id: string, url: string, ref: string } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> } };

export type GetFestivalIdentityQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  locale: Scalars['ID']['input'];
}>;


export type GetFestivalIdentityQuery = { festival: { id: string, active: boolean, ref: string, name: string, type: FestivalType | null, theme: FestivalTheme | null, keywords: Array<string> | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, localization: { id: string, name: string, type: LocalizationKind } | null, localizedData: { name: string | null, synopsis: string | object[] | null } | null, poster: { id: string, url: string, ref: string } | null } | null };

export type GetFestivalJuryListQueryVariables = Exact<{
  festivalId: Scalars['ID']['input'];
  editionId: Scalars['ID']['input'];
  competitionId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetFestivalJuryListQuery = { festivalJuries: Array<{ id: string, ref: string, role: FestivalJuryRole, rank: number, person: { __typename: 'Person', ref: string, firstName: string | null, lastName: string | null } }> | null };

export type GetFestivalEditionMetadataQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
  locale: Scalars['ID']['input'];
}>;


export type GetFestivalEditionMetadataQuery = { entityByRef: { __typename: 'User' } | { __typename: 'Locale' } | { __typename: 'Author' } | { __typename: 'SocialUser' } | { __typename: 'Image' } | { __typename: 'Movie' } | { __typename: 'ImageCategory' } | { __typename: 'Series' } | { __typename: 'Company' } | { __typename: 'CompanyStaff' } | { __typename: 'News' } | { __typename: 'VideoLegacy' } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' } | { __typename: 'Certificate' } | { __typename: 'Person' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition', id: string, ref: string, active: boolean, year: number, editionNumber: number | null, name: string | null, startsAt: string | null, endsAt: string | null, localizedData: { name: string | null } | null, festival: { __typename: 'Festival', id: string, ref: string, name: string }, poster: { id: string, url: string, ref: string } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | { __typename: 'Slide' } | { __typename: 'Carousel' } | { __typename: 'Theater' } | { __typename: 'Screen' } | { __typename: 'FestivalAward' } | { __typename: 'FestivalSelection' } | { __typename: 'FestivalCompetition' } | { __typename: 'FestivalEditionCompetition' } | { __typename: 'FestivalJury' } | { __typename: 'TheaterEvent' } | { __typename: 'Widget' } | { __typename: 'VideoB2B' } | null };

export type GetFestivalListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy: FestivalOrder;
  countryIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  locale: Scalars['ID']['input'];
  themes?: InputMaybe<Array<FestivalTheme> | FestivalTheme>;
}>;


export type GetFestivalListQuery = { festivals: { totalCount: number, nodes: Array<{ __typename: 'Festival', id: string, active: boolean, ref: string, name: string, type: FestivalType | null, theme: FestivalTheme | null, keywords: Array<string> | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, localization: { id: string, name: string, type: LocalizationKind } | null, localizedData: { name: string | null, synopsis: string | object[] | null } | null, poster: { id: string, url: string, ref: string } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> } };

export type GetFestivalSelectionsForCompetitionListQueryVariables = Exact<{
  festivalId: Scalars['ID']['input'];
  editionId: Scalars['ID']['input'];
  competitionId: Scalars['ID']['input'];
  locale: Scalars['ID']['input'];
  orderBy: FestivalSelectionOrder;
}>;


export type GetFestivalSelectionsForCompetitionListQuery = { festivalSelections: Array<{ id: string, ref: string, festivalCompetitionId: string | null, awards: Array<{ __typename: 'FestivalAward', id: string, ref: string, active: boolean, name: string, rank: number, festival: { id: string, ref: string, name: string, localizedData: { name: string | null, synopsis: string | object[] | null } | null }, nominees: { entity: { __typename: 'Movie', id: string, ref: string, title: string, localeData: { title: string | null } | null } | { __typename: 'Series', id: string, ref: string, title: string, localeData: { title: string | null } | null } | null, persons: Array<{ __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null }> | null } | null, localizedData: { name: string | null } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> | null, nominees: { entity: { __typename: 'Movie', id: string, ref: string, title: string, localeData: { title: string | null } | null } | { __typename: 'Series', id: string, ref: string, title: string, localeData: { title: string | null } | null } | null, persons: Array<{ __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null }> | null } | null }> | null, festivalCompetition: { __typename: 'User' } | { __typename: 'SocialUser' } | { __typename: 'Image' } | { __typename: 'Movie' } | { __typename: 'Series' } | { __typename: 'Company' } | { __typename: 'CompanyStaff' } | { __typename: 'News' } | { __typename: 'VideoLegacy' } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' } | { __typename: 'Person' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | { __typename: 'Slide' } | { __typename: 'Theater' } | { __typename: 'Screen' } | { __typename: 'FestivalAward' } | { __typename: 'FestivalSelection' } | { __typename: 'FestivalCompetition', display: FestivalCompetitionDisplay | null } | { __typename: 'FestivalEditionCompetition' } | { __typename: 'FestivalJury' } | { __typename: 'TheaterEvent' } | { __typename: 'VideoB2B' } | null };

export type GetFestivalMetadataQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
  locale: Scalars['ID']['input'];
}>;


export type GetFestivalMetadataQuery = { entityByRef: { __typename: 'User' } | { __typename: 'Locale' } | { __typename: 'Author' } | { __typename: 'SocialUser' } | { __typename: 'Image' } | { __typename: 'Movie' } | { __typename: 'ImageCategory' } | { __typename: 'Series' } | { __typename: 'Company' } | { __typename: 'CompanyStaff' } | { __typename: 'News' } | { __typename: 'VideoLegacy' } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' } | { __typename: 'Certificate' } | { __typename: 'Person' } | { __typename: 'Festival', id: string, active: boolean, ref: string, name: string, type: FestivalType | null, theme: FestivalTheme | null, keywords: Array<string> | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, localization: { id: string, name: string, type: LocalizationKind } | null, localizedData: { name: string | null, synopsis: string | object[] | null } | null, poster: { id: string, url: string, ref: string } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | { __typename: 'FestivalEdition' } | { __typename: 'Slide' } | { __typename: 'Carousel' } | { __typename: 'Theater' } | { __typename: 'Screen' } | { __typename: 'FestivalAward' } | { __typename: 'FestivalSelection' } | { __typename: 'FestivalCompetition' } | { __typename: 'FestivalEditionCompetition' } | { __typename: 'FestivalJury' } | { __typename: 'TheaterEvent' } | { __typename: 'Widget' } | { __typename: 'VideoB2B' } | null };

export type GetFestivalSelectionsListQueryVariables = Exact<{
  festivalId: Scalars['ID']['input'];
  editionId: Scalars['ID']['input'];
  competitionId?: InputMaybe<Scalars['ID']['input']>;
  locale: Scalars['ID']['input'];
  orderBy: FestivalSelectionOrder;
}>;


export type GetFestivalSelectionsListQuery = { festivalSelections: Array<{ id: string, ref: string, festivalCompetitionId: string | null, awards: Array<{ __typename: 'FestivalAward', id: string, ref: string, active: boolean, name: string, rank: number, festival: { id: string, ref: string, name: string, localizedData: { name: string | null, synopsis: string | object[] | null } | null }, nominees: { entity: { __typename: 'Movie', id: string, ref: string, title: string, localeData: { title: string | null } | null } | { __typename: 'Series', id: string, ref: string, title: string, localeData: { title: string | null } | null } | null, persons: Array<{ __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null }> | null } | null, localizedData: { name: string | null } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> | null, nominees: { entity: { __typename: 'Movie', id: string, ref: string, title: string, localeData: { title: string | null } | null } | { __typename: 'Series', id: string, ref: string, title: string, localeData: { title: string | null } | null } | null, persons: Array<{ __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null }> | null } | null }> | null };

export type UpdateFestivalCompetitionMutationVariables = Exact<{
  input: UpdateFestivalCompetitionInput;
  locale: Scalars['ID']['input'];
}>;


export type UpdateFestivalCompetitionMutation = { updateFestivalCompetition: { __typename: 'FestivalCompetition', id: string, ref: string, name: string | null, active: boolean, display: FestivalCompetitionDisplay | null, localizedData: { name: string | null } | null, festival: { ref: string, name: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type MoveFestivalJuryMutationVariables = Exact<{
  input: MoveFestivalJuryInput;
}>;


export type MoveFestivalJuryMutation = { moveFestivalJury: { id: string, rank: number } | null };

export type GetFestivalEditionCompetitionsCategoriesQueryVariables = Exact<{
  editionId: Scalars['ID']['input'];
}>;


export type GetFestivalEditionCompetitionsCategoriesQuery = { festivalEditionCompetitions: Array<{ __typename: 'FestivalEditionCompetition', festivalCompetition: { display: FestivalCompetitionDisplay | null } | null }> | null };

export type UpdateFestivalAwardMutationVariables = Exact<{
  locale: Scalars['ID']['input'];
  input: UpdateFestivalAwardInput;
}>;


export type UpdateFestivalAwardMutation = { updateFestivalAward: { __typename: 'FestivalAward', id: string, ref: string, active: boolean, name: string, rank: number, festival: { id: string, ref: string, name: string, localizedData: { name: string | null, synopsis: string | object[] | null } | null }, nominees: { entity: { __typename: 'Movie', id: string, ref: string, title: string, localeData: { title: string | null } | null } | { __typename: 'Series', id: string, ref: string, title: string, localeData: { title: string | null } | null } | null, persons: Array<{ __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null }> | null } | null, localizedData: { name: string | null } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpdateFestivalEditionCompetitionMutationVariables = Exact<{
  input: UpdateFestivalEditionCompetitionInput;
  locale: Scalars['ID']['input'];
}>;


export type UpdateFestivalEditionCompetitionMutation = { updateFestivalEditionCompetition: { __typename: 'FestivalEditionCompetition', id: string, active: boolean, rank: number, festivalCompetition: { id: string, ref: string, name: string | null, active: boolean, display: FestivalCompetitionDisplay | null, localizedData: { name: string | null } | null, festival: { ref: string, name: string } } | null, festival: { ref: string, name: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpdateFestivalEditionMutationVariables = Exact<{
  input: UpdateFestivalEditionInput;
  locale: Scalars['ID']['input'];
}>;


export type UpdateFestivalEditionMutation = { updateFestivalEdition: { id: string, ref: string, active: boolean, year: number, editionNumber: number | null, name: string | null, startsAt: string | null, endsAt: string | null, localizedData: { name: string | null } | null, festival: { __typename: 'Festival', id: string, ref: string, name: string }, poster: { id: string, url: string, ref: string } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpdateFestivalSelectionMutationVariables = Exact<{
  locale: Scalars['ID']['input'];
  input: UpdateFestivalSelectionInput;
}>;


export type UpdateFestivalSelectionMutation = { updateFestivalSelection: { id: string, ref: string, festivalCompetitionId: string | null, awards: Array<{ __typename: 'FestivalAward', id: string, ref: string, active: boolean, name: string, rank: number, festival: { id: string, ref: string, name: string, localizedData: { name: string | null, synopsis: string | object[] | null } | null }, nominees: { entity: { __typename: 'Movie', id: string, ref: string, title: string, localeData: { title: string | null } | null } | { __typename: 'Series', id: string, ref: string, title: string, localeData: { title: string | null } | null } | null, persons: Array<{ __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null }> | null } | null, localizedData: { name: string | null } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> | null, nominees: { entity: { __typename: 'Movie', id: string, ref: string, title: string, localeData: { title: string | null } | null } | { __typename: 'Series', id: string, ref: string, title: string, localeData: { title: string | null } | null } | null, persons: Array<{ __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null }> | null } | null } | null };

export type GetImageBrandedDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
}>;


export type GetImageBrandedDataQuery = { image: { id: string, type: ImageType | null, brandData: { id: string, active: boolean, title: string | null, description: string | null, copyrightName: string | null, from: string | null, to: string | null, copyrights: Array<{ id: string, name: string }> | null } | null } | null };

export type GetImageB2bDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetImageB2bDataQuery = { image: { type: ImageType | null, b2bCopyrightName: string | null, available: boolean, b2bCopyrights: Array<{ id: string, name: string }> | null } | null };

export type UpdateFestivalMutationVariables = Exact<{
  input: UpdateFestivalInput;
  locale: Scalars['ID']['input'];
}>;


export type UpdateFestivalMutation = { updateFestival: { id: string, active: boolean, ref: string, name: string, type: FestivalType | null, theme: FestivalTheme | null, keywords: Array<string> | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, localization: { id: string, name: string, type: LocalizationKind } | null, localizedData: { name: string | null, synopsis: string | object[] | null } | null, poster: { id: string, url: string, ref: string } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type GetImageDetailsQueryVariables = Exact<{
  imageId: Scalars['ID']['input'];
  localeId?: InputMaybe<Scalars['ID']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  withBrand?: InputMaybe<Scalars['Boolean']['input']>;
  withLocale?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetImageDetailsQuery = { image: { id: string, url: string, ref: string, height: number | null, width: number | null, mime: string | null, size: number | null, copyrightName: string | null, b2bCopyrightName: string | null, copyrights: Array<{ id: string, name: string }> | null, b2bCopyrights: Array<{ id: string, name: string }> | null, brandData?: { id: string, copyrightName: string | null, active: boolean, copyrights: Array<{ id: string, name: string }> | null } | null, localizedData?: { __typename: 'ImageLocaleData', id: string, ref: string, title: string | null, description: string | null, locale: string | null } | null, relatedEntities: Array<{ __typename: 'Movie', id: string, ref: string, title: string } | { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | { __typename: 'SeriesEpisode', id: string, ref: string, number: number, optionalTitle: string | null, series: { id: string, ref: string, title: string }, season: { id: string, ref: string, number: number } | null } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | { __typename: 'Series', id: string, ref: string, title: string } | { __typename: 'FestivalEdition', id: string, ref: string, name: string | null, editionNumber: number | null, year: number, festival: { id: string, ref: string, name: string } }> } | null };

export type ImageDetailsFragment = { id: string, url: string, ref: string, height: number | null, width: number | null, mime: string | null, size: number | null, copyrightName: string | null, b2bCopyrightName: string | null, copyrights: Array<{ id: string, name: string }> | null, b2bCopyrights: Array<{ id: string, name: string }> | null, brandData?: { id: string, copyrightName: string | null, active: boolean, copyrights: Array<{ id: string, name: string }> | null } | null, localizedData?: { __typename: 'ImageLocaleData', id: string, ref: string, title: string | null, description: string | null, locale: string | null } | null, relatedEntities: Array<{ __typename: 'Movie', id: string, ref: string, title: string } | { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | { __typename: 'SeriesEpisode', id: string, ref: string, number: number, optionalTitle: string | null, series: { id: string, ref: string, title: string }, season: { id: string, ref: string, number: number } | null } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | { __typename: 'Series', id: string, ref: string, title: string } | { __typename: 'FestivalEdition', id: string, ref: string, name: string | null, editionNumber: number | null, year: number, festival: { id: string, ref: string, name: string } }> };

export type GetImageIdentityQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetImageIdentityQuery = { image: { id: string, ref: string, url: string, path: string, type: ImageType | null, copyrightName: string | null, mime: string | null, size: number | null, width: number | null, height: number | null, copyrights: Array<{ id: string, name: string }> | null } | null };

export type GetImageListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  orderBy: ImageOrder;
  localeId?: InputMaybe<Scalars['ID']['input']>;
  createdByUserId?: InputMaybe<Scalars['ID']['input']>;
  updatedByUserId?: InputMaybe<Scalars['ID']['input']>;
  imageId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetImageListQuery = { images: { totalCount: number, nodes: Array<{ hasLocalizedData: boolean, id: string, url: string, type: ImageType | null, ref: string, b2bAvailable: boolean, activeOnBrands: Array<{ ref: string }> }> } };

export type GetImageMetadataQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetImageMetadataQuery = { entityByRef: { id: string, title: string | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, activeOnBrands: Array<{ ref: string }> } | {} | null };

export type GetImageRelatedEntitiesListQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetImageRelatedEntitiesListQuery = { image: { id: string, relatedEntities: Array<{ __typename: 'Movie', id: string, ref: string, title: string } | { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | { __typename: 'SeriesEpisode', id: string, ref: string, episodeNumber: number, season: { id: string, ref: string, number: number } | null, series: { id: string, ref: string, title: string } } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | { __typename: 'Series', id: string, ref: string, title: string } | { __typename: 'FestivalEdition', id: string, ref: string, name: string | null, editionNumber: number | null, year: number, festival: { __typename: 'Festival', id: string, ref: string, name: string } }> } | null };

export type GetImageSuggestedLinksQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetImageSuggestedLinksQuery = { entity: { __typename: 'User' } | { __typename: 'SocialUser' } | { __typename: 'Image' } | { __typename: 'Movie', credits: { nodes: Array<{ role: string | null, activity: PersonActivity, person: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | null }> } } | { __typename: 'Series', credits: { nodes: Array<{ role: string | null, activity: PersonActivity, person: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | null }> } } | { __typename: 'Company' } | { __typename: 'CompanyStaff' } | { __typename: 'News' } | { __typename: 'VideoLegacy' } | { __typename: 'SeriesSeason', credits: { nodes: Array<{ role: string | null, activity: PersonActivity, person: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | null }> } } | { __typename: 'SeriesEpisode', credits: { nodes: Array<{ role: string | null, activity: PersonActivity, person: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | null }> }, season: { credits: { nodes: Array<{ role: string | null, activity: PersonActivity, person: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | null }> } } | null } | { __typename: 'Person' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | { __typename: 'Slide' } | { __typename: 'Theater' } | { __typename: 'Screen' } | { __typename: 'FestivalAward' } | { __typename: 'FestivalSelection' } | { __typename: 'FestivalCompetition' } | { __typename: 'FestivalEditionCompetition' } | { __typename: 'FestivalJury' } | { __typename: 'TheaterEvent' } | { __typename: 'VideoB2B' } | null };

export type ImageSuggestedLinksCastingFragment = { role: string | null, activity: PersonActivity, person: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | null };

export type LinkEntityToImageMutationVariables = Exact<{
  input: LinkEntityToImageInput;
}>;


export type LinkEntityToImageMutation = { linkEntityToImage: { __typename: 'Movie' } | { __typename: 'Person' } | { __typename: 'SeriesEpisode' } | { __typename: 'SeriesSeason' } | { __typename: 'Series' } | { __typename: 'FestivalEdition' } | null };

export type MoveEntityImageMutationVariables = Exact<{
  input: MoveEntityImageInput;
}>;


export type MoveEntityImageMutation = { moveEntityImage: { __typename: 'Movie', id: string, ref: string, title: string } | { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | { __typename: 'SeriesEpisode', id: string, ref: string, episodeNumber: number, season: { id: string, ref: string, number: number } | null, series: { id: string, ref: string, title: string } } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | { __typename: 'Series', id: string, ref: string, title: string } | { __typename: 'FestivalEdition', id: string, ref: string, name: string | null, editionNumber: number | null, year: number, festival: { __typename: 'Festival', id: string, ref: string, name: string } } | null };

export type UnlinkEntityFromImageMutationVariables = Exact<{
  input: UnlinkEntityFromImageInput;
}>;


export type UnlinkEntityFromImageMutation = { unlinkEntityFromImage: { __typename: 'Movie' } | { __typename: 'Person' } | { __typename: 'SeriesEpisode' } | { __typename: 'SeriesSeason' } | { __typename: 'Series' } | { __typename: 'FestivalEdition' } | null };

export type UpdateImageB2bDataMutationVariables = Exact<{
  input: UpdateImageB2bDataInput;
}>;


export type UpdateImageB2bDataMutation = { updateImageB2bData: { id: string, b2bCopyrightName: string | null, available: boolean, b2bCopyrights: Array<{ id: string, name: string }> | null } | null };

export type UpdateImageLocaleDataMutationVariables = Exact<{
  input: UpdateImageLocaleDataInput;
}>;


export type UpdateImageLocaleDataMutation = { updateImageLocaleData: { __typename: 'ImageLocaleData', id: string, ref: string, title: string | null, description: string | null, locale: string | null } | null };

export type UpdateImageBrandedDataMutationVariables = Exact<{
  input: UpdateImageBrandDataInput;
}>;


export type UpdateImageBrandedDataMutation = { updateImageBrandData: { id: string, active: boolean, title: string | null, description: string | null, copyrightName: string | null, from: string | null, to: string | null, copyrights: Array<{ id: string, name: string }> | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } } | null };

export type UpdateImageMutationVariables = Exact<{
  input: UpdateImageInput;
}>;


export type UpdateImageMutation = { updateImage: { id: string, ref: string, url: string, path: string, type: ImageType | null, copyrightName: string | null, mime: string | null, size: number | null, width: number | null, height: number | null, copyrights: Array<{ id: string, name: string }> | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type ImportWizardDashboardTotalsFragment = { launched: number, completed: number, failed: number, answered: number, answeredAtLlmOrBrowser: number, llmRuns: number, localizedRuns: number, localizationErrors: number, llmCostUsd: number, llmInputTokens: number, llmOutputTokens: number, durationMedianMs: number | null, durationP95Ms: number | null, localizationCostUsd: number, localizationInputTokens: number, localizationOutputTokens: number, localizationDurationMedianMs: number | null };

export type GetImportWizardDashboardQueryVariables = Exact<{
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
  timeZone: Scalars['String']['input'];
  source?: InputMaybe<PersonCreditsImportSource>;
}>;


export type GetImportWizardDashboardQuery = { importWizardDashboard: { totals: { launched: number, completed: number, failed: number, answered: number, answeredAtLlmOrBrowser: number, llmRuns: number, localizedRuns: number, localizationErrors: number, llmCostUsd: number, llmInputTokens: number, llmOutputTokens: number, durationMedianMs: number | null, durationP95Ms: number | null, localizationCostUsd: number, localizationInputTokens: number, localizationOutputTokens: number, localizationDurationMedianMs: number | null }, previousTotals: { launched: number, completed: number, failed: number, answered: number, answeredAtLlmOrBrowser: number, llmRuns: number, localizedRuns: number, localizationErrors: number, llmCostUsd: number, llmInputTokens: number, llmOutputTokens: number, durationMedianMs: number | null, durationP95Ms: number | null, localizationCostUsd: number, localizationInputTokens: number, localizationOutputTokens: number, localizationDurationMedianMs: number | null }, running: { active: number, stale: number }, perDay: Array<{ day: string, completed: number, failed: number, llmCostUsd: number }>, byLevel: Array<{ level: string, runs: number, durationMedianMs: number }>, byModel: Array<{ provider: string, model: string, runs: number, llmCostUsd: number }>, nothingReturned: Array<{ kind: string, runs: number }>, bySource: Array<{ source: PersonCreditsImportSource, runs: number }>, byUser: Array<{ runs: number, user: { id: string, name: string } }> } };

type ImportWizardRunEntity_User_Fragment = { __typename: 'User', id: string };

type ImportWizardRunEntity_SocialUser_Fragment = { __typename: 'SocialUser', id: string };

type ImportWizardRunEntity_Image_Fragment = { __typename: 'Image', id: string };

type ImportWizardRunEntity_Movie_Fragment = { __typename: 'Movie', ref: string, title: string, id: string };

type ImportWizardRunEntity_Series_Fragment = { __typename: 'Series', ref: string, title: string, id: string };

type ImportWizardRunEntity_Company_Fragment = { __typename: 'Company', id: string };

type ImportWizardRunEntity_CompanyStaff_Fragment = { __typename: 'CompanyStaff', id: string };

type ImportWizardRunEntity_News_Fragment = { __typename: 'News', id: string };

type ImportWizardRunEntity_VideoLegacy_Fragment = { __typename: 'VideoLegacy', id: string };

type ImportWizardRunEntity_SeriesSeason_Fragment = { __typename: 'SeriesSeason', ref: string, number: number, id: string, series: { id: string, ref: string, title: string } };

type ImportWizardRunEntity_SeriesEpisode_Fragment = { __typename: 'SeriesEpisode', ref: string, number: number, id: string, episodeTitle: string | null, series: { id: string, ref: string, title: string }, season: { id: string, ref: string, number: number } | null };

type ImportWizardRunEntity_Person_Fragment = { __typename: 'Person', id: string };

type ImportWizardRunEntity_Festival_Fragment = { __typename: 'Festival', id: string };

type ImportWizardRunEntity_FestivalEdition_Fragment = { __typename: 'FestivalEdition', id: string };

type ImportWizardRunEntity_Slide_Fragment = { __typename: 'Slide', id: string };

type ImportWizardRunEntity_Theater_Fragment = { __typename: 'Theater', id: string };

type ImportWizardRunEntity_Screen_Fragment = { __typename: 'Screen', id: string };

type ImportWizardRunEntity_FestivalAward_Fragment = { __typename: 'FestivalAward', id: string };

type ImportWizardRunEntity_FestivalSelection_Fragment = { __typename: 'FestivalSelection', id: string };

type ImportWizardRunEntity_FestivalCompetition_Fragment = { __typename: 'FestivalCompetition', id: string };

type ImportWizardRunEntity_FestivalEditionCompetition_Fragment = { __typename: 'FestivalEditionCompetition', id: string };

type ImportWizardRunEntity_FestivalJury_Fragment = { __typename: 'FestivalJury', id: string };

type ImportWizardRunEntity_TheaterEvent_Fragment = { __typename: 'TheaterEvent', id: string };

type ImportWizardRunEntity_VideoB2B_Fragment = { __typename: 'VideoB2B', id: string };

export type ImportWizardRunEntityFragment = ImportWizardRunEntity_User_Fragment | ImportWizardRunEntity_SocialUser_Fragment | ImportWizardRunEntity_Image_Fragment | ImportWizardRunEntity_Movie_Fragment | ImportWizardRunEntity_Series_Fragment | ImportWizardRunEntity_Company_Fragment | ImportWizardRunEntity_CompanyStaff_Fragment | ImportWizardRunEntity_News_Fragment | ImportWizardRunEntity_VideoLegacy_Fragment | ImportWizardRunEntity_SeriesSeason_Fragment | ImportWizardRunEntity_SeriesEpisode_Fragment | ImportWizardRunEntity_Person_Fragment | ImportWizardRunEntity_Festival_Fragment | ImportWizardRunEntity_FestivalEdition_Fragment | ImportWizardRunEntity_Slide_Fragment | ImportWizardRunEntity_Theater_Fragment | ImportWizardRunEntity_Screen_Fragment | ImportWizardRunEntity_FestivalAward_Fragment | ImportWizardRunEntity_FestivalSelection_Fragment | ImportWizardRunEntity_FestivalCompetition_Fragment | ImportWizardRunEntity_FestivalEditionCompetition_Fragment | ImportWizardRunEntity_FestivalJury_Fragment | ImportWizardRunEntity_TheaterEvent_Fragment | ImportWizardRunEntity_VideoB2B_Fragment;

export type GetImportWizardReportsQueryVariables = Exact<{
  filter?: InputMaybe<ImportWizardReportFilter>;
  order?: InputMaybe<ImportWizardReportOrder>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetImportWizardReportsQuery = { importWizardReports: { totalCount: number, nodes: Array<{ id: string, status: ImportWizardReportStatus, failureReason: string | null, outcome: ImportWizardOutcome | null, answeredBy: ImportWizardLevel | null, launchedAt: string, finishedAt: string | null, source: PersonCreditsImportSource, isRemovedFromHistory: boolean, isStale: boolean, creditsCount: number, metadata: { createdBy: { id: string, name: string } | null }, stats: { durationMs: number, requests: number, llm: { provider: string, model: string, inputTokens: number, outputTokens: number, costUsd: number | null } | null }, localization: { outcome: string | null, durationMs: number | null, llm: { provider: string, model: string, inputTokens: number, outputTokens: number, costUsd: number | null } | null } | null, entity: { __typename: 'User', id: string } | { __typename: 'SocialUser', id: string } | { __typename: 'Image', id: string } | { __typename: 'Movie', ref: string, title: string, id: string } | { __typename: 'Series', ref: string, title: string, id: string } | { __typename: 'Company', id: string } | { __typename: 'CompanyStaff', id: string } | { __typename: 'News', id: string } | { __typename: 'VideoLegacy', id: string } | { __typename: 'SeriesSeason', ref: string, number: number, id: string, series: { id: string, ref: string, title: string } } | { __typename: 'SeriesEpisode', ref: string, number: number, id: string, episodeTitle: string | null, series: { id: string, ref: string, title: string }, season: { id: string, ref: string, number: number } | null } | { __typename: 'Person', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'Slide', id: string } | { __typename: 'Theater', id: string } | { __typename: 'Screen', id: string } | { __typename: 'FestivalAward', id: string } | { __typename: 'FestivalSelection', id: string } | { __typename: 'FestivalCompetition', id: string } | { __typename: 'FestivalEditionCompetition', id: string } | { __typename: 'FestivalJury', id: string } | { __typename: 'TheaterEvent', id: string } | { __typename: 'VideoB2B', id: string } | null }> } };

export type GetImportWizardReportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetImportWizardReportQuery = { importWizardReport: { __typename: 'PersonCreditsImportReport', entityType: ImportWizardEntityType, id: string, status: ImportWizardReportStatus, failureReason: string | null, launchedAt: string, finishedAt: string | null, source: PersonCreditsImportSource, outcome: ImportWizardOutcome | null, answeredBy: ImportWizardLevel | null, sections: Array<PersonCreditsImportDataType>, entity: { __typename: 'User', id: string } | { __typename: 'SocialUser', id: string } | { __typename: 'Image', id: string } | { __typename: 'Movie', ref: string, title: string, id: string } | { __typename: 'Series', ref: string, title: string, id: string } | { __typename: 'Company', id: string } | { __typename: 'CompanyStaff', id: string } | { __typename: 'News', id: string } | { __typename: 'VideoLegacy', id: string } | { __typename: 'SeriesSeason', ref: string, number: number, id: string, series: { id: string, ref: string, title: string } } | { __typename: 'SeriesEpisode', ref: string, number: number, id: string, episodeTitle: string | null, series: { id: string, ref: string, title: string }, season: { id: string, ref: string, number: number } | null } | { __typename: 'Person', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'Slide', id: string } | { __typename: 'Theater', id: string } | { __typename: 'Screen', id: string } | { __typename: 'FestivalAward', id: string } | { __typename: 'FestivalSelection', id: string } | { __typename: 'FestivalCompetition', id: string } | { __typename: 'FestivalEditionCompetition', id: string } | { __typename: 'FestivalJury', id: string } | { __typename: 'TheaterEvent', id: string } | { __typename: 'VideoB2B', id: string } | null, metadata: { createdBy: { id: string, name: string } | null }, counts: { linked: number, matched: number, ambiguous: number, unknown: number, extraneous: number }, stats: { durationMs: number, requests: number, bytesReceived: number, resolutionDurationMs: number, resolutionRequests: number, levels: Array<{ level: number, name: string, outcome: string, durationMs: number, requests: number, bytesReceived: number, creditsCount: number, detail: string, llmInputTokens: number | null, llm: { provider: string, model: string, inputTokens: number, outputTokens: number, durationMs: number, costUsd: number | null, error: string | null } | null }>, llm: { provider: string, model: string, inputTokens: number, outputTokens: number, durationMs: number, costUsd: number | null, error: string | null } | null }, localization: { locale: string, localeId: string, outcome: string | null, detail: string | null, durationMs: number | null, rolesAsked: number | null, rolesLocalized: number | null, llm: { provider: string, model: string, inputTokens: number, outputTokens: number, durationMs: number, costUsd: number | null, error: string | null } | null } | null, resolution: { __typename: 'PersonCreditsImportResolution', confidence: string, sourceId: string | null, source: string, detail: string, candidates: Array<{ id: string, title: string, year: number | null, kind: string | null }> } | null, entries: Array<{ __typename: 'PersonCreditsImportEntry', status: PersonCreditsImportStatus, name: string | null, category: string | null, role: string | null, localizedRole: string | null, externalPersonId: string | null, order: number | null, suggestedActivity: PersonActivity | null, gender: Gender | null, isVoice: boolean, linkKind: PersonCreditsImportLinkKind | null, linkLocale: string | null, linkedPerson: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, birthDate: string | null, deathDate: string | null, activities: Array<PersonActivity>, countries: Array<{ id: string, name: string, alpha2: string }>, poster: { id: string, path: string } | null } | null, candidates: Array<{ __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, birthDate: string | null, deathDate: string | null, activities: Array<PersonActivity>, countries: Array<{ id: string, name: string, alpha2: string }>, poster: { id: string, path: string } | null }>, credit: { __typename: 'PersonCredits', id: string, activity: PersonActivity, rank: number, role: string | null } | null }> } | null };

export type GetPersonCreditsImportUnmappedJobsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPersonCreditsImportUnmappedJobsQuery = { personCreditsImportUnmappedJobs: Array<{ source: PersonCreditsImportSource, category: string, job: string, occurrences: number, entities: number, fallbackActivity: PersonActivity | null, lastSeenAt: string }> };

export type CreateImportConfigurationMutationVariables = Exact<{
  input: CreateImportConfigurationInput;
}>;


export type CreateImportConfigurationMutation = { createImportConfiguration: { id: string } | null };

export type CreateImportConfigurationsFromCsvMutationVariables = Exact<{
  input: CreateImportConfigurationsFromCsvInput;
}>;


export type CreateImportConfigurationsFromCsvMutation = { createImportConfigurationsFromCSV: number | null };

export type BatchImportConfigurationOperationMutationVariables = Exact<{
  input: BatchImportConfigurationOperationInput;
}>;


export type BatchImportConfigurationOperationMutation = { batchImportConfigurationOperation: { id: string, enabled: boolean, nextRun: string } | null };

export type CreateImportCrawlerMutationVariables = Exact<{
  input: CreateImportCrawlerInput;
}>;


export type CreateImportCrawlerMutation = { createImportCrawler: { id: string, name: string } | null };

export type DeleteImportConfigurationMutationVariables = Exact<{
  input: DeleteImportConfigurationInput;
}>;


export type DeleteImportConfigurationMutation = { deleteImportConfiguration: { id: string } | null };

export type DeleteImportShowtimesStatsQueryVariables = Exact<{
  theaterId: Scalars['ID']['input'];
  entityId?: InputMaybe<Scalars['ID']['input']>;
  range?: InputMaybe<DateRangeInput>;
}>;


export type DeleteImportShowtimesStatsQuery = { deleteImportShowtimesStats: { totalCount: number } };

export type DeleteImportShowtimesMutationVariables = Exact<{
  input: DeleteImportShowtimesInput;
}>;


export type DeleteImportShowtimesMutation = { deleteImportShowtimes: { totalCount: number } | null };

export type DeleteImportCrawlerMutationVariables = Exact<{
  crawlerId: Scalars['ID']['input'];
}>;


export type DeleteImportCrawlerMutation = { deleteImportCrawler: { id: string, name: string } | null };

export type ImportConfigurationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ImportConfigurationQuery = { importConfiguration: { id: string, sourceId: string | null, uri: string, entityMatcher: string | null, theaterMatcher: string | null, enabled: boolean, interval: number, nextRun: string, fetchedDays: number, gathertimesTimeout: number | null, inheritsScreenAttributes: boolean, linksOnly: boolean, moviesOnly: boolean, parameters: string | null, averageDuration: string | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, lastRun: { id: string, status: ImportRunStatus, startTime: string | null, endTime: string | null, crawlExportFile: string | null, crawlMovieExportFile: string | null, configuration: { id: string, sourceId: string | null, crawler: { name: string } }, stats: { totalShowtimes: number, insertedShowtimes: number, matchedShowtimes: number, removedShowtimes: number, unmatchedShowtimes: number, ignoredShowtimes: number, importedMovies: number, importedTheaters: number } | null, steps: Array<{ name: string, status: ImportRunStatus, error: string | null, extra: any | null }> } | null, crawler: { name: string, notes: string | null }, entity: { __typename: 'Company', id: string, ref: string, name: string, companyCountry: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Theater', id: string, ref: string, name: string, showtimeSource: TheaterShowtimeSource | null, openingStatus: TheaterOpeningStatus, temporaryClosure: { startsAt: string | null, endsAt: string | null, message: string } | null, location: { city: string | null, zip: string | null } | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, parent: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null } | null } | null };

export type ImportConfigurationRunsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  lastStep?: InputMaybe<ImportRunStepType>;
}>;


export type ImportConfigurationRunsQuery = { importConfiguration: { id: string, runs: { totalCount: number, nodes: Array<{ id: string, status: ImportRunStatus, startTime: string | null, endTime: string | null, crawlExportFile: string | null, crawlMovieExportFile: string | null, configuration: { id: string, sourceId: string | null, crawler: { name: string } }, stats: { totalShowtimes: number, insertedShowtimes: number, matchedShowtimes: number, removedShowtimes: number, unmatchedShowtimes: number, ignoredShowtimes: number, importedMovies: number, importedTheaters: number } | null, steps: Array<{ name: string, status: ImportRunStatus, error: string | null, extra: any | null }> }> } } | null };

export type ImportConfigurationsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  crawler?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  linksOnly?: InputMaybe<Scalars['Boolean']['input']>;
  moviesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  inheritsScreenAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  entityIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  orderBy: ImportConfigurationOrder;
}>;


export type ImportConfigurationsQuery = { importConfigurations: { totalCount: number, nodes: Array<{ id: string, enabled: boolean, sourceId: string | null, theaterMatcher: string | null, entityMatcher: string | null, nextRun: string, inheritsScreenAttributes: boolean, linksOnly: boolean, moviesOnly: boolean, crawler: { id: string, name: string, countries: Array<{ __typename: 'Country', id: string, ref: string, name: string, alpha2: string }> | null }, lastRun: { id: string, status: ImportRunStatus, startTime: string | null } | null, entity: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | { __typename: 'Theater', name: string, ref: string } | null }> } };

export type ImportConfigurationRowFragment = { id: string, enabled: boolean, sourceId: string | null, theaterMatcher: string | null, entityMatcher: string | null, nextRun: string, inheritsScreenAttributes: boolean, linksOnly: boolean, moviesOnly: boolean, crawler: { id: string, name: string, countries: Array<{ __typename: 'Country', id: string, ref: string, name: string, alpha2: string }> | null }, lastRun: { id: string, status: ImportRunStatus, startTime: string | null } | null, entity: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | { __typename: 'Theater', name: string, ref: string } | null };

export type ImportCrawlersWithConfigurationsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ImportCrawlerOrder>;
  name?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  types?: InputMaybe<Array<CrawlerType> | CrawlerType>;
  tags?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ImportCrawlersWithConfigurationsQuery = { importCrawlers: { totalCount: number, nodes: Array<{ id: string, name: string, type: CrawlerType | null, tags: Array<string> | null, countries: Array<{ __typename: 'Country', id: string, ref: string, name: string, alpha2: string }> | null, configurations: { totalCount: number, nodes: Array<{ id: string, sourceId: string | null, uri: string, entityMatcher: string | null, theaterMatcher: string | null, enabled: boolean, interval: number, nextRun: string, fetchedDays: number, gathertimesTimeout: number | null, inheritsScreenAttributes: boolean, linksOnly: boolean, moviesOnly: boolean, parameters: string | null, crawler: { name: string, notes: string | null }, entity: { __typename: 'Company', id: string, ref: string, name: string, companyCountry: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Theater', id: string, ref: string, name: string, showtimeSource: TheaterShowtimeSource | null, openingStatus: TheaterOpeningStatus, temporaryClosure: { startsAt: string | null, endsAt: string | null, message: string } | null, location: { city: string | null, zip: string | null } | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, parent: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null } | null }> } | null }> } };

export type ImportCrawlerWithConfigurationRowFragment = { id: string, name: string, type: CrawlerType | null, tags: Array<string> | null, countries: Array<{ __typename: 'Country', id: string, ref: string, name: string, alpha2: string }> | null, configurations: { totalCount: number, nodes: Array<{ id: string, sourceId: string | null, uri: string, entityMatcher: string | null, theaterMatcher: string | null, enabled: boolean, interval: number, nextRun: string, fetchedDays: number, gathertimesTimeout: number | null, inheritsScreenAttributes: boolean, linksOnly: boolean, moviesOnly: boolean, parameters: string | null, crawler: { name: string, notes: string | null }, entity: { __typename: 'Company', id: string, ref: string, name: string, companyCountry: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Theater', id: string, ref: string, name: string, showtimeSource: TheaterShowtimeSource | null, openingStatus: TheaterOpeningStatus, temporaryClosure: { startsAt: string | null, endsAt: string | null, message: string } | null, location: { city: string | null, zip: string | null } | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, parent: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null } | null }> } | null };

export type ImportCrawlerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ImportCrawlerQuery = { importCrawler: { id: string, name: string, type: CrawlerType | null, tags: Array<string> | null, notes: string | null, parameters: string | null, configurations: { totalCount: number, nodes: Array<{ id: string, sourceId: string | null, uri: string, entityMatcher: string | null, theaterMatcher: string | null, enabled: boolean, interval: number, nextRun: string, fetchedDays: number, gathertimesTimeout: number | null, inheritsScreenAttributes: boolean, linksOnly: boolean, moviesOnly: boolean, parameters: string | null, crawler: { name: string, notes: string | null }, entity: { __typename: 'Company', id: string, ref: string, name: string, companyCountry: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Theater', id: string, ref: string, name: string, showtimeSource: TheaterShowtimeSource | null, openingStatus: TheaterOpeningStatus, temporaryClosure: { startsAt: string | null, endsAt: string | null, message: string } | null, location: { city: string | null, zip: string | null } | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, parent: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null } | null }> } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, countries: Array<{ __typename: 'Country', id: string, ref: string, name: string, alpha2: string }> | null, defaultConfiguration: { uri: string | null, theaterMatcher: string | null, entityMatcher: string | null, parameters: string | null } | null } | null };

export type ImportCrawlersQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ImportCrawlerOrder>;
}>;


export type ImportCrawlersQuery = { importCrawlers: { nodes: Array<{ id: string, name: string, type: CrawlerType | null, tags: Array<string> | null, notes: string | null, parameters: string | null, countries: Array<{ __typename: 'Country', id: string, ref: string, name: string, alpha2: string }> | null, defaultConfiguration: { uri: string | null, theaterMatcher: string | null, entityMatcher: string | null, parameters: string | null } | null }> } };

export type ImportCrawlerRowFragment = { id: string, name: string, type: CrawlerType | null, tags: Array<string> | null, notes: string | null, parameters: string | null, countries: Array<{ __typename: 'Country', id: string, ref: string, name: string, alpha2: string }> | null, defaultConfiguration: { uri: string | null, theaterMatcher: string | null, entityMatcher: string | null, parameters: string | null } | null };

export type ImportMatchersQueryVariables = Exact<{
  sourceType: ShowtimeSourceType;
}>;


export type ImportMatchersQuery = { importMatchers: Array<string> };

export type ImportRunsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  crawler?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ImportRunStatus>;
  lastStep?: InputMaybe<ImportRunStepType>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ImportRunsQuery = { importRuns: { totalCount: number, nodes: Array<{ id: string, status: ImportRunStatus, startTime: string | null, endTime: string | null, crawlExportFile: string | null, crawlMovieExportFile: string | null, configuration: { id: string, sourceId: string | null, crawler: { name: string } }, stats: { totalShowtimes: number, insertedShowtimes: number, matchedShowtimes: number, removedShowtimes: number, unmatchedShowtimes: number, ignoredShowtimes: number, importedMovies: number, importedTheaters: number } | null, steps: Array<{ name: string, status: ImportRunStatus, error: string | null, extra: any | null }> }> } };

export type UpdateImportCrawlerMutationVariables = Exact<{
  input: UpdateImportCrawlerInput;
}>;


export type UpdateImportCrawlerMutation = { updateImportCrawler: { id: string, name: string, type: CrawlerType | null, tags: Array<string> | null, notes: string | null, parameters: string | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, countries: Array<{ __typename: 'Country', id: string, ref: string, name: string, alpha2: string }> | null, defaultConfiguration: { uri: string | null, theaterMatcher: string | null, entityMatcher: string | null, parameters: string | null } | null } | null };

export type UpdateImportConfigurationMutationVariables = Exact<{
  input: UpdateImportConfigurationInput;
}>;


export type UpdateImportConfigurationMutation = { updateImportConfiguration: { id: string, sourceId: string | null, uri: string, entityMatcher: string | null, theaterMatcher: string | null, enabled: boolean, interval: number, nextRun: string, fetchedDays: number, gathertimesTimeout: number | null, inheritsScreenAttributes: boolean, linksOnly: boolean, moviesOnly: boolean, parameters: string | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, crawler: { name: string, notes: string | null }, entity: { __typename: 'Company', id: string, ref: string, name: string, companyCountry: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Theater', id: string, ref: string, name: string, showtimeSource: TheaterShowtimeSource | null, openingStatus: TheaterOpeningStatus, temporaryClosure: { startsAt: string | null, endsAt: string | null, message: string } | null, location: { city: string | null, zip: string | null } | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, parent: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null } | null } | null };

export type GetJumpLinksQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  orderBy: JumpLinkOrder;
  search?: InputMaybe<Scalars['String']['input']>;
  targetDomainUrls?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  sourceUrls?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  partners?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  companyIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  userIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetJumpLinksQuery = { jumpLinks: { totalCount: number, nodes: Array<{ __typename: 'JumpLink', id: string, ref: string, sourceUrl: string, targetDomainUrl: string, generatedUrl: string, partner: string | null, data: any | null, company: { __typename: 'Company', id: string, ref: string, name: string, activities: Array<CompanyActivity>, logo: { id: string, url: string, ref: string } | null } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> } | null };

export type GetJumpPlatformDomainsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetJumpPlatformDomainsQuery = { jumpPlatformDomains: Array<{ url: string, label: string }> };

export type GenerateJumpLinkQueryVariables = Exact<{
  targetDomainUrl: Scalars['String']['input'];
  sourceUrl: Scalars['URL']['input'];
  companyId?: InputMaybe<Scalars['ID']['input']>;
  partner?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GenerateJumpLinkQuery = { jumpPlatformEncodedUrl: { __typename: 'JumpLink', id: string, ref: string, sourceUrl: string, targetDomainUrl: string, generatedUrl: string, partner: string | null, data: any | null, company: { __typename: 'Company', id: string, ref: string, name: string, activities: Array<CompanyActivity>, logo: { id: string, url: string, ref: string } | null } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type CreateLocaleMutationVariables = Exact<{
  input: CreateLocaleInput;
}>;


export type CreateLocaleMutation = { createLocale: { __typename: 'Locale', id: string, ref: string, name: string, syncFromBrand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type GetLocalesListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  countryId?: InputMaybe<Scalars['ID']['input']>;
  limitedLocalizationId?: InputMaybe<Scalars['ID']['input']>;
  syncFromIdBrand?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetLocalesListQuery = { localesList: { __typename: 'LocalePager', totalCount: number, nodes: Array<{ __typename: 'Locale', id: string, ref: string, name: string, syncFromBrand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> } };

export type UpdateLocaleMutationVariables = Exact<{
  input: UpdateLocaleInput;
}>;


export type UpdateLocaleMutation = { updateLocale: { __typename: 'Locale', id: string, ref: string, name: string, syncFromBrand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type DeleteLocaleMutationVariables = Exact<{
  input: DeleteLocaleInput;
}>;


export type DeleteLocaleMutation = { deleteLocale: { id: string } | null };

export type GetLocaleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetLocaleQuery = { locale: { __typename: 'Locale', id: string, ref: string, name: string, syncFromBrand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type GetEventLogsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  eventTypes?: InputMaybe<Array<EventLogType> | EventLogType>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<EventLogOrder>;
}>;


export type GetEventLogsQuery = { eventLogs: { totalCount: number, nodes: Array<{ eventType: EventLogType, occuredAt: string, label: string, payload: any, id: string, user: { __typename: 'User', id: string, ref: string, name: string } | null }> } };

export type CopyMovieBrandedDataToLocalizedDataMutationVariables = Exact<{
  input: CopyMovieBrandedDataToLocalizedDataInput;
}>;


export type CopyMovieBrandedDataToLocalizedDataMutation = { copyMovieBrandedDataToLocalizedData: { title: string | null, synopsis: string | null, synopsisShort: string | null, url: string | null, notes: string | null, poster: { id: string, url: string, ref: string } | null, quad: { id: string, url: string, ref: string } | null } | null };

export type CreateMovieVersionMutationVariables = Exact<{
  input: CreateMovieVersionInput;
}>;


export type CreateMovieVersionMutation = { createMovieVersion: { id: string } | null };

export type CreateMovieShowtimesEmbargoMutationVariables = Exact<{
  input: CreateShowtimesEmbargoInput;
}>;


export type CreateMovieShowtimesEmbargoMutation = { createShowtimesEmbargo: { id: string } | null };

export type CreateMovieReleaseMutationVariables = Exact<{
  input: AddReleaseToEntityInput;
}>;


export type CreateMovieReleaseMutation = { addReleaseToEntity: { id: string, ref: string, entity: { id: string } | {} } | null };

export type DeleteMovieVersionMutationVariables = Exact<{
  input: DeleteMovieVersionInput;
}>;


export type DeleteMovieVersionMutation = { deleteMovieVersion: { id: string } | null };

export type CreateMovieMutationVariables = Exact<{
  input: CreateMovieInput;
}>;


export type CreateMovieMutation = { createMovie: { id: string, ref: string } | null };

export type DeleteMovieShowtimesEmbargoMutationVariables = Exact<{
  input: DeleteShowtimesEmbargoInput;
}>;


export type DeleteMovieShowtimesEmbargoMutation = { deleteShowtimesEmbargo: { id: string } | null };

export type DeleteMovieMutationVariables = Exact<{
  input: DeleteEntityInput;
}>;


export type DeleteMovieMutation = { deleteEntity: { id: string, ref: string } | {} | null };

export type GetBrandEntityClubsQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
  entityType: EntityType;
  brandIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  clubIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetBrandEntityClubsQuery = { entityByRef: { __typename: 'User' } | { __typename: 'Locale' } | { __typename: 'Author' } | { __typename: 'SocialUser' } | { __typename: 'Image' } | { __typename: 'Movie', id: string, clubs: Array<{ __typename: 'BrandEntityClub', id: string, seen: boolean | null, approved: boolean | null, club: { __typename: 'Club', id: string, name: string, code: string, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, rating: { excellent: number | null, good: number | null, average: number | null, bad: number | null } | null }> | null } | { __typename: 'ImageCategory' } | { __typename: 'Series', id: string, clubs: Array<{ __typename: 'BrandEntityClub', id: string, seen: boolean | null, approved: boolean | null, club: { __typename: 'Club', id: string, name: string, code: string, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, rating: { excellent: number | null, good: number | null, average: number | null, bad: number | null } | null }> | null } | { __typename: 'Company' } | { __typename: 'CompanyStaff' } | { __typename: 'News' } | { __typename: 'VideoLegacy' } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' } | { __typename: 'Certificate' } | { __typename: 'Person' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | { __typename: 'Slide' } | { __typename: 'Carousel' } | { __typename: 'Theater' } | { __typename: 'Screen' } | { __typename: 'FestivalAward' } | { __typename: 'FestivalSelection' } | { __typename: 'FestivalCompetition' } | { __typename: 'FestivalEditionCompetition' } | { __typename: 'FestivalJury' } | { __typename: 'TheaterEvent' } | { __typename: 'Widget' } | { __typename: 'VideoB2B' } | null };

export type IBrandEntityClubFragment = { __typename: 'BrandEntityClub', id: string, seen: boolean | null, approved: boolean | null, club: { __typename: 'Club', id: string, name: string, code: string, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, rating: { excellent: number | null, good: number | null, average: number | null, bad: number | null } | null };

export type MovieClubsFragment = { __typename: 'Movie', id: string, clubs: Array<{ __typename: 'BrandEntityClub', id: string, seen: boolean | null, approved: boolean | null, club: { __typename: 'Club', id: string, name: string, code: string, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, rating: { excellent: number | null, good: number | null, average: number | null, bad: number | null } | null }> | null };

export type SeriesClubsFragment = { __typename: 'Series', id: string, clubs: Array<{ __typename: 'BrandEntityClub', id: string, seen: boolean | null, approved: boolean | null, club: { __typename: 'Club', id: string, name: string, code: string, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, rating: { excellent: number | null, good: number | null, average: number | null, bad: number | null } | null }> | null };

export type GetMovieAdditionalInfoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMovieAdditionalInfoQuery = { movie: { id: string, genres: Array<Genre>, budget: string | null, budgetValue: number | null, budgetCurrency: Currency | null, budgetOld: string | null, languages: Array<Language>, projections: Array<MovieProjection>, color: string | null, projection: string | null, production: string | null, sound: string | null, runtime: { hours: number, minutes: number } | null, countries: Array<{ id: string, name: string }> } | null };

export type MovieAdditionalInfoFragment = { id: string, genres: Array<Genre>, budget: string | null, budgetValue: number | null, budgetCurrency: Currency | null, budgetOld: string | null, languages: Array<Language>, projections: Array<MovieProjection>, color: string | null, projection: string | null, production: string | null, sound: string | null, runtime: { hours: number, minutes: number } | null, countries: Array<{ id: string, name: string }> };

export type GetMovieBoxofficeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMovieBoxofficeQuery = { movie: { id: string, totalBoxofficeUs: number | null, totalBoxofficeInternational: number | null } | null };

export type GetMovieBrandedContentQueryVariables = Exact<{
  brandId: Scalars['ID']['input'];
  movieId: Scalars['ID']['input'];
}>;


export type GetMovieBrandedContentQuery = { movie: { brandData: { id: string, brandedContent: { tabs: Array<{ index: number, title: string, contentJson: string | object[] }> | null } | null } | null } | null };

export type MovieTabFragment = { tabs: Array<{ index: number, title: string, contentJson: string | object[] }> | null };

export type GetMovieBrandedDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
}>;


export type GetMovieBrandedDataQuery = { movie: { id: string, brandData: { id: string, title: string | null, keywords: Array<string>, synopsis: string | object[] | null, synopsisShort: string | object[] | null, poster: { id: string, url: string, ref: string } | null, ruling: { hasRating: boolean, atRisk: boolean, hasWarningMessage: boolean, hasMandatoryReview: boolean } } | null } | null };

export type GetMovieCastingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  locale?: InputMaybe<Scalars['ID']['input']>;
  showLocaleData: Scalars['Boolean']['input'];
  brandId: Scalars['ID']['input'];
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  withSeoAttributes?: Scalars['Boolean']['input'];
}>;


export type GetMovieCastingQuery = { movie: { id: string, credits: { totalCount: number, nodes: Array<{ __typename: 'PersonCredits', id: string, active: boolean, rank: number, role: string | null, person: { __typename: 'Person', id: string, ref: string, lastName: string | null, firstName: string | null, deathDate: string | null, activities: Array<PersonActivity>, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, poster: { path: string } | null, countries: Array<{ name: string }>, activeOnBrands: Array<{ ref: string }>, seoAttributes?: Array<{ browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, voice: { __typename: 'Person', id: string, ref: string, lastName: string | null, firstName: string | null, deathDate: string | null, activities: Array<PersonActivity>, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, poster: { path: string } | null, countries: Array<{ name: string }>, activeOnBrands: Array<{ ref: string }>, seoAttributes?: Array<{ browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> } | null, localeData?: { nodes: Array<{ id: string, role: string | null, voice: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null } }> } }> } } | null };

export type GetMovieCompanyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  activities?: InputMaybe<Array<CompanyActivity> | CompanyActivity>;
}>;


export type GetMovieCompanyQuery = { movie: { id: string, companies: { totalCount: number, nodes: Array<{ id: string, rank: number, activity: CompanyActivity, company: { id: string, ref: string, name: string } }> } } | null };

export type GetMovieCreditQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  activities?: InputMaybe<Array<PersonActivity> | PersonActivity>;
  brandId: Scalars['ID']['input'];
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMovieCreditQuery = { movie: { id: string, credits: { totalCount: number, nodes: Array<{ __typename: 'PersonCredits', id: string, activity: PersonActivity, rank: number, person: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, activeOnBrands: Array<{ id: string, ref: string }>, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null } | null }> } } | null };

export type GetMovieExternalIdsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMovieExternalIdsQuery = { movie: { __typename: 'Movie', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> } | null };

export type GetMovieIdQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetMovieIdQuery = { entityByRef: { __typename: 'User' } | { __typename: 'Locale' } | { __typename: 'Author' } | { __typename: 'SocialUser' } | { __typename: 'Image' } | { __typename: 'Movie', id: string } | { __typename: 'ImageCategory' } | { __typename: 'Series' } | { __typename: 'Company' } | { __typename: 'CompanyStaff' } | { __typename: 'News' } | { __typename: 'VideoLegacy' } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' } | { __typename: 'Certificate' } | { __typename: 'Person' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | { __typename: 'Slide' } | { __typename: 'Carousel' } | { __typename: 'Theater' } | { __typename: 'Screen' } | { __typename: 'FestivalAward' } | { __typename: 'FestivalSelection' } | { __typename: 'FestivalCompetition' } | { __typename: 'FestivalEditionCompetition' } | { __typename: 'FestivalJury' } | { __typename: 'TheaterEvent' } | { __typename: 'Widget' } | { __typename: 'VideoB2B' } | null };

export type GetMovieIdentityQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMovieIdentityQuery = { movie: { id: string, title: string, productionYear: number | null, type: MovieType, keywords: Array<string>, additionalTags: Array<MovieAdditional>, poster: { id: string, url: string, ref: string } | null } | null };

export type MovieIdentityFragment = { id: string, title: string, productionYear: number | null, type: MovieType, keywords: Array<string>, additionalTags: Array<MovieAdditional>, poster: { id: string, url: string, ref: string } | null };

export type GetMovieListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<MovieOrder>;
  directorId?: InputMaybe<Scalars['ID']['input']>;
  brandIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  brandId: Scalars['ID']['input'];
  localeIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  searchIn?: InputMaybe<EntitySearchTypes>;
  searchSensitivity?: InputMaybe<EntitySearchOptions>;
  type?: InputMaybe<MovieType>;
  includeBrandsData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocalesData?: InputMaybe<Scalars['Boolean']['input']>;
  includeSeoData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMovieListQuery = { movies: { totalCount: number, nodes: Array<{ __typename: 'Movie', id: string, ref: string, title: string, type: MovieType, popularity: number | null, productionYear: number | null, activeOnBrands: Array<{ id: string, ref: string, name: string }>, poster: { id: string, url: string, ref: string } | null, brandsData?: Array<{ title: string | null, brand: { ref: string } }> | null, localesData?: Array<{ title: string | null, locale: string }> | null, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, credits: { nodes: Array<{ person: { __typename: 'Person', ref: string, firstName: string | null, lastName: string | null } | null }> }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> } };

export type GetMovieMetadataQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
  brandIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  localeIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocalesData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMovieMetadataQuery = { entityByRef: { __typename: 'User' } | { __typename: 'Locale' } | { __typename: 'Author' } | { __typename: 'SocialUser' } | { __typename: 'Image' } | { __typename: 'Movie', id: string, type: MovieType, title: string, brandsData?: Array<{ title: string | null }> | null, localesData?: Array<{ title: string | null }> | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'ImageCategory' } | { __typename: 'Series' } | { __typename: 'Company' } | { __typename: 'CompanyStaff' } | { __typename: 'News' } | { __typename: 'VideoLegacy' } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' } | { __typename: 'Certificate' } | { __typename: 'Person' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | { __typename: 'Slide' } | { __typename: 'Carousel' } | { __typename: 'Theater' } | { __typename: 'Screen' } | { __typename: 'FestivalAward' } | { __typename: 'FestivalSelection' } | { __typename: 'FestivalCompetition' } | { __typename: 'FestivalEditionCompetition' } | { __typename: 'FestivalJury' } | { __typename: 'TheaterEvent' } | { __typename: 'Widget' } | { __typename: 'VideoB2B' } | null };

export type MovieMetadataEntityFragment = { __typename: 'Movie', id: string, type: MovieType, title: string, brandsData?: Array<{ title: string | null }> | null, localesData?: Array<{ title: string | null }> | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, activeOnBrands: Array<{ ref: string }> };

export type GetMovieLocalizedDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  locale: Scalars['ID']['input'];
}>;


export type GetMovieLocalizedDataQuery = { movie: { id: string, localeData: { title: string | null, synopsis: string | null, synopsisShort: string | null, url: string | null, notes: string | null, poster: { id: string, url: string, ref: string } | null, quad: { id: string, url: string, ref: string } | null } | null } | null };

export type GetMoviePersonCreditsImportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  reportId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetMoviePersonCreditsImportQuery = { movie: { id: string, personCreditsImport: { __typename: 'PersonCreditsImportReport', id: string, status: ImportWizardReportStatus, failureReason: string | null, launchedAt: string, finishedAt: string | null, source: PersonCreditsImportSource, outcome: ImportWizardOutcome | null, answeredBy: ImportWizardLevel | null, metadata: { createdBy: { id: string, name: string } | null }, counts: { linked: number, matched: number, ambiguous: number, unknown: number, extraneous: number }, stats: { durationMs: number, requests: number, bytesReceived: number, resolutionDurationMs: number, resolutionRequests: number, levels: Array<{ level: number, name: string, outcome: string, durationMs: number, requests: number, bytesReceived: number, creditsCount: number, detail: string, llmInputTokens: number | null, llm: { provider: string, model: string, inputTokens: number, outputTokens: number, durationMs: number, costUsd: number | null, error: string | null } | null }>, llm: { provider: string, model: string, inputTokens: number, outputTokens: number, durationMs: number, costUsd: number | null, error: string | null } | null }, localization: { locale: string, localeId: string, outcome: string | null, detail: string | null, durationMs: number | null, rolesAsked: number | null, rolesLocalized: number | null, llm: { provider: string, model: string, inputTokens: number, outputTokens: number, durationMs: number, costUsd: number | null, error: string | null } | null } | null, resolution: { __typename: 'PersonCreditsImportResolution', confidence: string, sourceId: string | null, source: string, detail: string, candidates: Array<{ id: string, title: string, year: number | null, kind: string | null }> } | null, entries: Array<{ __typename: 'PersonCreditsImportEntry', status: PersonCreditsImportStatus, name: string | null, category: string | null, role: string | null, localizedRole: string | null, externalPersonId: string | null, order: number | null, suggestedActivity: PersonActivity | null, gender: Gender | null, isVoice: boolean, linkKind: PersonCreditsImportLinkKind | null, linkLocale: string | null, linkedPerson: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, birthDate: string | null, deathDate: string | null, activities: Array<PersonActivity>, countries: Array<{ id: string, name: string, alpha2: string }>, poster: { id: string, path: string } | null } | null, candidates: Array<{ __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, birthDate: string | null, deathDate: string | null, activities: Array<PersonActivity>, countries: Array<{ id: string, name: string, alpha2: string }>, poster: { id: string, path: string } | null }>, credit: { __typename: 'PersonCredits', id: string, activity: PersonActivity, rank: number, role: string | null } | null }> } | null, personCreditsImports: Array<{ __typename: 'PersonCreditsImportReport', id: string, status: ImportWizardReportStatus, launchedAt: string, source: PersonCreditsImportSource, outcome: ImportWizardOutcome | null, sections: Array<PersonCreditsImportDataType>, resolution: { __typename: 'PersonCreditsImportResolution', confidence: string, source: string } | null, stats: { levels: Array<{ level: number, name: string, outcome: string, creditsCount: number }> }, metadata: { createdBy: { id: string, name: string } | null } }> } | null };

export type GetMovieReleaseQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetMovieReleaseQuery = { releaseByRef: { id: string, type: ReleaseType | null, flags: Array<ReleaseFlag>, releasedAt: string | null, releasedAtTime: string | null, unreleasedAt: string | null, notReleasedYet: boolean, visaNumber: string | null, techInfo: string | null, openingEstimate: number | null, advisory: string | null, entity: { __typename: 'Movie', id: string, ref: string, title: string } | { __typename: 'Series' } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' }, limitedCompany: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null, country: { __typename: 'Country', hasLocalCertificates: boolean | null, id: string, ref: string, name: string, alpha2: string }, distributors: Array<{ __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }>, certificate: { id: string, ref: string, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type MovieSimilaritiesQueryVariables = Exact<{
  movieId: Scalars['ID']['input'];
}>;


export type MovieSimilaritiesQuery = { movie: { id: string, entityLinks: Array<{ target: { __typename: 'User', id: string } | { __typename: 'SocialUser', id: string } | { __typename: 'Image', id: string } | { __typename: 'Movie', ref: string, title: string, id: string } | { __typename: 'Series', ref: string, title: string, id: string } | { __typename: 'Company', id: string } | { __typename: 'CompanyStaff', id: string } | { __typename: 'News', id: string } | { __typename: 'VideoLegacy', id: string } | { __typename: 'SeriesSeason', id: string } | { __typename: 'SeriesEpisode', id: string } | { __typename: 'Person', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'Slide', id: string } | { __typename: 'Theater', id: string } | { __typename: 'Screen', id: string } | { __typename: 'FestivalAward', id: string } | { __typename: 'FestivalSelection', id: string } | { __typename: 'FestivalCompetition', id: string } | { __typename: 'FestivalEditionCompetition', id: string } | { __typename: 'FestivalJury', id: string } | { __typename: 'TheaterEvent', id: string } | { __typename: 'VideoB2B', id: string } }> } | null };

type MovieSimilarEntity_User_Fragment = { __typename: 'User', id: string };

type MovieSimilarEntity_SocialUser_Fragment = { __typename: 'SocialUser', id: string };

type MovieSimilarEntity_Image_Fragment = { __typename: 'Image', id: string };

type MovieSimilarEntity_Movie_Fragment = { __typename: 'Movie', ref: string, title: string, id: string };

type MovieSimilarEntity_Series_Fragment = { __typename: 'Series', ref: string, title: string, id: string };

type MovieSimilarEntity_Company_Fragment = { __typename: 'Company', id: string };

type MovieSimilarEntity_CompanyStaff_Fragment = { __typename: 'CompanyStaff', id: string };

type MovieSimilarEntity_News_Fragment = { __typename: 'News', id: string };

type MovieSimilarEntity_VideoLegacy_Fragment = { __typename: 'VideoLegacy', id: string };

type MovieSimilarEntity_SeriesSeason_Fragment = { __typename: 'SeriesSeason', id: string };

type MovieSimilarEntity_SeriesEpisode_Fragment = { __typename: 'SeriesEpisode', id: string };

type MovieSimilarEntity_Person_Fragment = { __typename: 'Person', id: string };

type MovieSimilarEntity_Festival_Fragment = { __typename: 'Festival', id: string };

type MovieSimilarEntity_FestivalEdition_Fragment = { __typename: 'FestivalEdition', id: string };

type MovieSimilarEntity_Slide_Fragment = { __typename: 'Slide', id: string };

type MovieSimilarEntity_Theater_Fragment = { __typename: 'Theater', id: string };

type MovieSimilarEntity_Screen_Fragment = { __typename: 'Screen', id: string };

type MovieSimilarEntity_FestivalAward_Fragment = { __typename: 'FestivalAward', id: string };

type MovieSimilarEntity_FestivalSelection_Fragment = { __typename: 'FestivalSelection', id: string };

type MovieSimilarEntity_FestivalCompetition_Fragment = { __typename: 'FestivalCompetition', id: string };

type MovieSimilarEntity_FestivalEditionCompetition_Fragment = { __typename: 'FestivalEditionCompetition', id: string };

type MovieSimilarEntity_FestivalJury_Fragment = { __typename: 'FestivalJury', id: string };

type MovieSimilarEntity_TheaterEvent_Fragment = { __typename: 'TheaterEvent', id: string };

type MovieSimilarEntity_VideoB2B_Fragment = { __typename: 'VideoB2B', id: string };

export type MovieSimilarEntityFragment = MovieSimilarEntity_User_Fragment | MovieSimilarEntity_SocialUser_Fragment | MovieSimilarEntity_Image_Fragment | MovieSimilarEntity_Movie_Fragment | MovieSimilarEntity_Series_Fragment | MovieSimilarEntity_Company_Fragment | MovieSimilarEntity_CompanyStaff_Fragment | MovieSimilarEntity_News_Fragment | MovieSimilarEntity_VideoLegacy_Fragment | MovieSimilarEntity_SeriesSeason_Fragment | MovieSimilarEntity_SeriesEpisode_Fragment | MovieSimilarEntity_Person_Fragment | MovieSimilarEntity_Festival_Fragment | MovieSimilarEntity_FestivalEdition_Fragment | MovieSimilarEntity_Slide_Fragment | MovieSimilarEntity_Theater_Fragment | MovieSimilarEntity_Screen_Fragment | MovieSimilarEntity_FestivalAward_Fragment | MovieSimilarEntity_FestivalSelection_Fragment | MovieSimilarEntity_FestivalCompetition_Fragment | MovieSimilarEntity_FestivalEditionCompetition_Fragment | MovieSimilarEntity_FestivalJury_Fragment | MovieSimilarEntity_TheaterEvent_Fragment | MovieSimilarEntity_VideoB2B_Fragment;

export type GetMovieShowtimesEmbargosQueryVariables = Exact<{
  movieId: Scalars['ID']['input'];
}>;


export type GetMovieShowtimesEmbargosQuery = { movie: { id: string, showtimesEmbargos: Array<{ id: string, publicAt: string | null, bookableAt: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } }> } | null };

export type GetMovieSyncInfoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMovieSyncInfoQuery = { movie: { id: string, foxproSync: { create3D: boolean, createImax: boolean } } | null };

export type MovieSyncInfoFragment = { id: string, foxproSync: { create3D: boolean, createImax: boolean } };

export type GetMovieTechnicalInfoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMovieTechnicalInfoQuery = { movie: { id: string, color: string | null, projection: string | null, production: string | null, sound: string | null } | null };

export type MovieTechnicalInfoFragment = { id: string, color: string | null, projection: string | null, production: string | null, sound: string | null };

export type GetMovieTagsQueryVariables = Exact<{
  movieId: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
}>;


export type GetMovieTagsQuery = { movie: { id: string, tags: { nodes: Array<{ id: string, rank: number, tag: { id: string, ref: string, name: string, type: TagType, active: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }, entity: { __typename: 'Company', id: string, rawId: number, ref: string, name: string, title: string } | { __typename: 'Movie', id: string, rawId: number, ref: string, title: string } | { __typename: 'News', id: string, rawId: number, ref: string, title: string } | { __typename: 'Person', id: string, rawId: number, ref: string, firstName: string | null, lastName: string | null } | { __typename: 'SeriesEpisode', id: string, rawId: number, ref: string, episodeTitle: string | null } | { __typename: 'SeriesSeason', id: string, rawId: number, ref: string, number: number } | { __typename: 'Series', id: string, rawId: number, ref: string, title: string } | { __typename: 'Slide', id: string, rawId: number, ref: string, title: string } | { __typename: 'Theater', id: string, rawId: number, ref: string, name: string } }> } } | null };

export type GetMovieVersionsQueryVariables = Exact<{
  movieId: Scalars['ID']['input'];
}>;


export type GetMovieVersionsQuery = { movie: { id: string, versions: Array<{ id: string, version: MovieVersionType, label: string | null, runtime: { hours: number, minutes: number } | null }> } | null };

export type GetMovieTriviasQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  brandId: Scalars['ID']['input'];
}>;


export type GetMovieTriviasQuery = { movie: { id: string, trivias: { totalCount: number, nodes: Array<{ id: string, ref: string, rank: number, trivia: { __typename: 'Trivia', id: string, ref: string, active: boolean, title: string, body: string | object[] | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, relatedEntities: Array<{ __typename: 'Movie', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | { __typename: 'SeriesEpisode', ref: string, id: string, number: number, series: { ref: string, id: string, title: string }, season: { ref: string } | null } | { __typename: 'Person', ref: string, id: string, lastName: string | null, firstName: string | null }> } }> } } | null };

export type UpdateMovieBoxofficeMutationVariables = Exact<{
  input: UpdateMovieBoxofficeInput;
}>;


export type UpdateMovieBoxofficeMutation = { updateMovieBoxoffice: { id: string, totalBoxofficeUs: number | null, totalBoxofficeInternational: number | null } | null };

export type GetMoviesByRefsQueryVariables = Exact<{
  refs: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetMoviesByRefsQuery = { entitiesByRef: Array<{ __typename: 'Movie', id: string, ref: string, title: string } | {} | null> | null };

export type GetSlideshowSlideNewsQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetSlideshowSlideNewsQuery = { entityByRef: { id: string, ref: string, type: NewsType, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } } | {} | null };

export type UpdateMovieBrandedContentMutationVariables = Exact<{
  input: UpdateMovieBrandedContentInput;
}>;


export type UpdateMovieBrandedContentMutation = { updateMovieBrandedContent: { tabs: Array<{ index: number, title: string, contentJson: string | object[] }> | null } | null };

export type UpdateMovieBrandedDataMutationVariables = Exact<{
  input: UpdateMovieBrandDataInput;
}>;


export type UpdateMovieBrandedDataMutation = { updateMovieBrandData: { id: string, title: string | null, keywords: Array<string>, synopsis: string | object[] | null, synopsisShort: string | object[] | null, poster: { id: string, url: string } | null, ruling: { hasRating: boolean, atRisk: boolean, hasWarningMessage: boolean, hasMandatoryReview: boolean } } | null };

export type UpdateMovieLocalizedDataMutationVariables = Exact<{
  input: UpdateMovieLocaleDataInput;
}>;


export type UpdateMovieLocalizedDataMutation = { updateMovieLocaleData: { title: string | null, synopsis: string | null, synopsisShort: string | null, url: string | null, poster: { id: string, url: string } | null, quad: { id: string, url: string } | null } | null };

export type UpdateMoviesShowtimesEmbargoMutationVariables = Exact<{
  input: UpdateShowtimesEmbargoInput;
}>;


export type UpdateMoviesShowtimesEmbargoMutation = { updateShowtimesEmbargo: { id: string, bookableAt: string | null, publicAt: string | null } | null };

export type UpdateReleaseMutationVariables = Exact<{
  input: UpdateReleaseInput;
}>;


export type UpdateReleaseMutation = { updateRelease: { id: string, type: ReleaseType | null, flags: Array<ReleaseFlag>, releasedAt: string | null, releasedAtTime: string | null, unreleasedAt: string | null, notReleasedYet: boolean, visaNumber: string | null, techInfo: string | null, openingEstimate: number | null, advisory: string | null, limitedCompany: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null, country: { __typename: 'Country', hasLocalCertificates: boolean | null, id: string, ref: string, name: string, alpha2: string }, distributors: Array<{ __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }>, certificate: { id: string, ref: string, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null } | null } | null };

export type UpdateMovieMutationVariables = Exact<{
  input: UpdateMovieInput;
}>;


export type UpdateMovieMutation = { updateMovie: { id: string, ref: string, title: string, productionYear: number | null, type: MovieType, budget: string | null, languages: Array<Language>, genres: Array<Genre>, color: string | null, production: string | null, projection: string | null, sound: string | null, keywords: Array<string>, runtime: { hours: number, minutes: number } | null, countries: Array<{ id: string, name: string }>, poster: { id: string, url: string, ref: string } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpdateMovieVersionMutationVariables = Exact<{
  input: UpdateMovieVersionInput;
}>;


export type UpdateMovieVersionMutation = { updateMovieVersion: { id: string, version: MovieVersionType, label: string | null, runtime: { hours: number, minutes: number } | null } | null };

export type AllowedNewsScopesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllowedNewsScopesQuery = { viewer: { id: string, admin: boolean, allowedNewsScopes: Array<NewsScope> } };

export type CreateNewsPageMutationVariables = Exact<{
  input: CreateNewsPageInput;
}>;


export type CreateNewsPageMutation = { createNewsPage: { id: string, news: { id: string, pages: Array<{ id: string, number: number, title: string | null, video: { __typename: 'VideoLegacy', id: string, active: boolean, ref: string, title: string | null, generatedTitle: string | null } | null }> } } | null };

export type CreateNewsMutationVariables = Exact<{
  input: CreateNewsInput;
}>;


export type CreateNewsMutation = { createNews: { id: string, ref: string } | null };

export type CreateSlideshowSlideMutationVariables = Exact<{
  input: CreateSlideshowSlideInput;
}>;


export type CreateSlideshowSlideMutation = { createSlideshowSlide: { id: string, number: number, title: string, body: string | object[] | null, image: { id: string, url: string, ref: string, copyrightName: string | null, copyrights: Array<{ id: string, name: string }> | null }, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, news: { id: string, ref: string } } | null };

export type DeleteNewsPageMutationVariables = Exact<{
  input: DeleteNewsPageInput;
}>;


export type DeleteNewsPageMutation = { deleteNewsPage: { id: string, news: { id: string, pages: Array<{ id: string, number: number, title: string | null, video: { __typename: 'VideoLegacy', id: string, active: boolean, ref: string, title: string | null, generatedTitle: string | null } | null }> } } | null };

export type DeleteNewsMutationVariables = Exact<{
  input: DeleteNewsInput;
}>;


export type DeleteNewsMutation = { deleteNews: { id: string } | null };

export type GetAiArticleContentQueryVariables = Exact<{
  aiSkillId: Scalars['ID']['input'];
  articleId?: InputMaybe<Scalars['ID']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  universe?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetAiArticleContentQuery = { aiArticleContent: { title: string, description: string, keywords: Array<string>, aiMetadata: { promptTokenCount: number | null, totalTokenCount: number | null } | null } };

export type DeleteSlideshowSlideMutationVariables = Exact<{
  input: DeleteSlideshowSlideInput;
}>;


export type DeleteSlideshowSlideMutation = { deleteSlideshowSlide: { id: string, number: number, title: string, body: string | object[] | null, image: { id: string, url: string, ref: string, copyrightName: string | null, copyrights: Array<{ id: string, name: string }> | null }, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, news: { id: string, ref: string } } | null };

export type GetAiSkillsQueryVariables = Exact<{
  entityType: AiSkillEntityType;
  code: AiSkillCode;
}>;


export type GetAiSkillsQuery = { aiSkills: Array<{ id: string, entityType: AiSkillEntityType, code: AiSkillCode, version: number, isDefault: boolean, model: GeminiModel, displayLabel: string | null }> };

export type GetNewsAdditionalInfoQueryVariables = Exact<{
  newsId: Scalars['ID']['input'];
}>;


export type GetNewsAdditionalInfoQuery = { news: { ref: string, active: boolean, universe: NewsUniverse | null, id: string, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, authors: Array<{ id: string, rank: number, author: { id: string, ref: string, name: string, shortBio: string }, signature: { id: string, signature: string } | null }> } | null };

export type GetNewsChecklistQueryVariables = Exact<{
  newsId: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
  excludedTypes?: InputMaybe<Array<NewsLinkableEntityType> | NewsLinkableEntityType>;
  includedTypes?: InputMaybe<Array<NewsLinkableEntityType> | NewsLinkableEntityType>;
}>;


export type GetNewsChecklistQuery = { news: { id: string, active: boolean, isUpdatedWhenPublished: boolean, ref: string, title: string, socialTitle: string | null, type: NewsType, universe: NewsUniverse | null, keywords: Array<string>, category: NewsCategory | null, credits: string | null, headline: string | null, tracking: boolean, publicationStatus: EntityPublicationStatus, publicationDate: string | null, pages: Array<{ id: string, body: string | object[] | null }>, tags: { totalCount: number }, relatedNews: Array<{ id: string, ref: string, title: string } | {}>, relatedEntities: Array<{ __typename: 'Festival', id: string, ref: string } | { __typename: 'FestivalEdition', id: string, ref: string } | { __typename: 'Movie', id: string, ref: string, title: string } | { __typename: 'News', id: string, ref: string } | { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | { __typename: 'SeriesEpisode', id: string, ref: string, episodeNumber: number, season: { id: string, ref: string, number: number } | null, series: { id: string, ref: string, title: string } } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | { __typename: 'Series', id: string, ref: string, title: string }>, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { copyrightName: string | null, id: string, url: string, ref: string, copyrights: Array<{ id: string, name: string }> | null } | null, authors: Array<{ id: string, rank: number, author: { id: string, ref: string, name: string, shortBio: string }, signature: { id: string, signature: string } | null }>, publications: Array<{ startsAt: string, endsAt: string | null, status: EntityPublicationStatus }> } | null };

export type NewsTrackingFragment = { tracking: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } };

export type GetNewsListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  orderBy: NewsOrder;
  search?: InputMaybe<Scalars['String']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  authorIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  tagId?: InputMaybe<Scalars['ID']['input']>;
  relatedEntityId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<NewsType>;
  publicationStatus?: InputMaybe<EntityPublicationStatus>;
  universes?: InputMaybe<Array<InputMaybe<NewsUniverse>> | InputMaybe<NewsUniverse>>;
  range?: InputMaybe<DateRangeInput>;
}>;


export type GetNewsListQuery = { newsList: { totalCount: number, nodes: Array<{ id: string, active: boolean, ref: string, title: string, universe: NewsUniverse | null, type: NewsType, publicationStatus: EntityPublicationStatus, publicationDate: string | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, brand: { __typename: 'Brand', timezone: string | null, id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, authors: Array<{ id: string, author: { __typename: 'Author', id: string, ref: string, name: string } }> }> } };

export type NewsRowFragment = { id: string, active: boolean, ref: string, title: string, universe: NewsUniverse | null, type: NewsType, publicationStatus: EntityPublicationStatus, publicationDate: string | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, brand: { __typename: 'Brand', timezone: string | null, id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, authors: Array<{ id: string, author: { __typename: 'Author', id: string, ref: string, name: string } }> };

export type GetNewsIdentityQueryVariables = Exact<{
  newsId: Scalars['ID']['input'];
}>;


export type GetNewsIdentityQuery = { news: { id: string, ref: string, title: string, socialTitle: string | null, type: NewsType, universe: NewsUniverse | null, keywords: Array<string>, category: NewsCategory | null, credits: string | null, headline: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, pages: Array<{ id: string, number: number, title: string | null, video: { __typename: 'VideoLegacy', id: string, active: boolean, ref: string, title: string | null, generatedTitle: string | null } | null }> } | null };

export type GetNewsNavigationDataQueryVariables = Exact<{
  newsId: Scalars['ID']['input'];
}>;


export type GetNewsNavigationDataQuery = { news: { id: string, seoHidden: boolean, onlyOnSocialSite: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } } | null };

export type GetNewsPageContentQueryVariables = Exact<{
  newsPageId: Scalars['ID']['input'];
}>;


export type GetNewsPageContentQuery = { newsPage: { id: string, body: string | object[] | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { __typename: 'Country', currency: string, id: string, ref: string, name: string, alpha2: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } } | null };

export type GetNewsRelatedEntitiesListQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  excludedTypes?: InputMaybe<Array<NewsLinkableEntityType> | NewsLinkableEntityType>;
  includedTypes?: InputMaybe<Array<NewsLinkableEntityType> | NewsLinkableEntityType>;
}>;


export type GetNewsRelatedEntitiesListQuery = { news: { id: string, relatedEntities: Array<{ __typename: 'Festival', id: string, ref: string, festivalName: string } | { __typename: 'FestivalEdition', id: string, ref: string, year: number, editionName: string | null, festival: { ref: string, festivalName: string } } | { __typename: 'Movie', id: string, ref: string, title: string } | { __typename: 'News', id: string, ref: string } | { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | { __typename: 'SeriesEpisode', id: string, ref: string, episodeNumber: number, season: { id: string, ref: string, number: number } | null, series: { id: string, ref: string, title: string } } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | { __typename: 'Series', id: string, ref: string, title: string }> } | null };

export type GetNewsPublicationListQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetNewsPublicationListQuery = { news: { id: string, publicationStatus: EntityPublicationStatus, publicationDate: string | null, isUpdatedWhenPublished: boolean, brand: { __typename: 'Brand', timezone: string | null, id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { id: string } | null, pages: Array<{ id: string, body: string | object[] | null }>, publications: Array<{ startsAt: string, endsAt: string | null, status: EntityPublicationStatus }> } | null };

export type GetNewsPosterQueryVariables = Exact<{
  newsId: Scalars['ID']['input'];
}>;


export type GetNewsPosterQuery = { news: { id: string, poster: { copyrightName: string | null, id: string, url: string, ref: string, copyrights: Array<{ id: string, name: string }> | null } | null } | null };

export type GetNewsRelatedNewsListQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetNewsRelatedNewsListQuery = { news: { id: string, relatedEntities: Array<{ id: string, ref: string, title: string, active: boolean, publicationStatus: EntityPublicationStatus, publicationDate: string | null } | {}> } | null };

export type GetNewsSlidesQueryVariables = Exact<{
  newsId: Scalars['ID']['input'];
}>;


export type GetNewsSlidesQuery = { news: { id: string, ref: string, universe: NewsUniverse | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, slideshowSlides: Array<{ id: string, number: number, title: string }> } | null };

export type GetNewsSeoAttributesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetNewsSeoAttributesQuery = { news: { id: string, active: boolean, seoAttributes: { title: string | null, subtitle: string | null, description: string | null } } | null };

export type GetNewsTagsQueryVariables = Exact<{
  newsId: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
}>;


export type GetNewsTagsQuery = { news: { id: string, tags: { nodes: Array<{ id: string, rank: number, tag: { id: string, ref: string, name: string, type: TagType, active: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }, entity: { __typename: 'Company', id: string, rawId: number, ref: string, name: string, title: string } | { __typename: 'Movie', id: string, rawId: number, ref: string, title: string } | { __typename: 'News', id: string, rawId: number, ref: string, title: string } | { __typename: 'Person', id: string, rawId: number, ref: string, firstName: string | null, lastName: string | null } | { __typename: 'SeriesEpisode', id: string, rawId: number, ref: string, episodeTitle: string | null } | { __typename: 'SeriesSeason', id: string, rawId: number, ref: string, number: number } | { __typename: 'Series', id: string, rawId: number, ref: string, title: string } | { __typename: 'Slide', id: string, rawId: number, ref: string, title: string } | { __typename: 'Theater', id: string, rawId: number, ref: string, name: string } }> } } | null };

export type GetNewsQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetNewsQuery = { entityByRef: { id: string, title: string, universe: NewsUniverse | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | {} | null, viewer: { id: string, admin: boolean, allowedNewsScopes: Array<NewsScope> } };

export type GetSlideshowSlideQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSlideshowSlideQuery = { slideshowSlide: { id: string, number: number, title: string, body: string | object[] | null, image: { id: string, url: string, ref: string, copyrightName: string | null, copyrights: Array<{ id: string, name: string }> | null }, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, news: { id: string, ref: string } } | null };

export type GetSlideshowSlidesQueryVariables = Exact<{
  newsId: Scalars['ID']['input'];
}>;


export type GetSlideshowSlidesQuery = { news: { id: string, universe: NewsUniverse | null, slideshowSlides: Array<{ id: string, number: number, title: string, image: { id: string, url: string } }> } | null };

export type LinkAuthorToNewsMutationVariables = Exact<{
  input: LinkAuthorToNewsInput;
}>;


export type LinkAuthorToNewsMutation = { linkAuthorToNews: { id: string } | null };

export type LinkEntityToNewsMutationVariables = Exact<{
  input: LinkEntityToNewsInput;
}>;


export type LinkEntityToNewsMutation = { linkEntityToNews: { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | { __typename: 'Movie' } | { __typename: 'News' } | { __typename: 'Person' } | { __typename: 'SeriesEpisode' } | { __typename: 'SeriesSeason' } | { __typename: 'Series' } | null };

export type MoveAuthorInNewsMutationVariables = Exact<{
  input: MoveAuthorInNewsInput;
}>;


export type MoveAuthorInNewsMutation = { moveAuthorInNews: { id: string } | null };

export type SearchAuthorsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchAuthorsQuery = { authors: { nodes: Array<{ id: string, name: string, shortBio: string, signatures: Array<{ id: string, name: string, signature: string }> }> } };

export type ToggleNewsActivationMutationVariables = Exact<{
  input: ToggleNewsActivationInput;
}>;


export type ToggleNewsActivationMutation = { toggleNewsActivation: { seoAttributes: { title: string | null, subtitle: string | null, description: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UnlinkAuthorFromNewsMutationVariables = Exact<{
  input: UnlinkAuthorFromNewsInput;
}>;


export type UnlinkAuthorFromNewsMutation = { unlinkAuthorFromNews: { id: string } | null };

export type UpdateNewsMainImageMutationVariables = Exact<{
  input: UpdateNewsInput;
}>;


export type UpdateNewsMainImageMutation = { updateNews: { id: string, poster: { copyrightName: string | null, id: string, url: string, ref: string, copyrights: Array<{ id: string, name: string }> | null } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UnlinkEntityFromNewsMutationVariables = Exact<{
  input: UnlinkEntityFromNewsInput;
}>;


export type UnlinkEntityFromNewsMutation = { unlinkEntityFromNews: { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | { __typename: 'Movie' } | { __typename: 'News' } | { __typename: 'Person' } | { __typename: 'SeriesEpisode' } | { __typename: 'SeriesSeason' } | { __typename: 'Series' } | null };

export type UpdateNewsPageNumberMutationVariables = Exact<{
  input: UpdateNewsPageNumberInput;
}>;


export type UpdateNewsPageNumberMutation = { updateNewsPageNumber: { id: string, news: { id: string, pages: Array<{ id: string, number: number, title: string | null, video: { __typename: 'VideoLegacy', id: string, active: boolean, ref: string, title: string | null, generatedTitle: string | null } | null }>, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } } | null };

export type UpdateNewsPageMutationVariables = Exact<{
  input: UpdateNewsPageInput;
}>;


export type UpdateNewsPageMutation = { updateNewsPage: { id: string, title: string | null, video: { id: string, title: string | null, generatedTitle: string | null } | null, news: { id: string, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } } | null };

export type UpdateNewsPageContentMutationVariables = Exact<{
  input: UpdateNewsPageInput;
}>;


export type UpdateNewsPageContentMutation = { updateNewsPage: { id: string, body: string | object[] | null, news: { id: string, isUpdatedWhenPublished: boolean, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } } | null };

export type UpdateNewsSeoAttributesMutationVariables = Exact<{
  input: UpdateNewsSeoAttributesInput;
}>;


export type UpdateNewsSeoAttributesMutation = { updateNewsSeoAttributes: { id: string, active: boolean, seoAttributes: { title: string | null, subtitle: string | null, description: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpdateNewsNavigationDataMutationVariables = Exact<{
  input: UpdateNewsNavigationDataInput;
}>;


export type UpdateNewsNavigationDataMutation = { updateNewsNavigationData: { id: string, seoHidden: boolean, onlyOnSocialSite: boolean, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type MoveNewsSlideMutationVariables = Exact<{
  input: MoveNewsSlideInput;
}>;


export type MoveNewsSlideMutation = { moveNewsSlide: { id: string, news: { id: string, ref: string, universe: NewsUniverse | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, slideshowSlides: Array<{ id: string, number: number, title: string }>, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } } | null };

export type UpdateNewsMutationVariables = Exact<{
  input: UpdateNewsInput;
}>;


export type UpdateNewsMutation = { updateNews: { id: string, isUpdatedWhenPublished: boolean, tracking: boolean, ref: string, title: string, socialTitle: string | null, type: NewsType, universe: NewsUniverse | null, keywords: Array<string>, category: NewsCategory | null, credits: string | null, headline: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpdateSlideshowSlideMutationVariables = Exact<{
  input: UpdateSlideshowSlideInput;
}>;


export type UpdateSlideshowSlideMutation = { updateSlideshowSlide: { id: string, number: number, title: string, body: string | object[] | null, news: { id: string, ref: string, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } }, image: { id: string, url: string, ref: string, copyrightName: string | null, copyrights: Array<{ id: string, name: string }> | null }, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } } | null };

export type AddPersonNicknameMutationVariables = Exact<{
  input: AddPersonNicknameInput;
}>;


export type AddPersonNicknameMutation = { addPersonNickname: { id: string, nickname: string, gender: Gender } | null };

export type CreatePersonMutationVariables = Exact<{
  input: CreatePersonInput;
  brandId: Scalars['ID']['input'];
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  withSeoAttributes?: Scalars['Boolean']['input'];
}>;


export type CreatePersonMutation = { createPerson: { __typename: 'Person', id: string, ref: string, lastName: string | null, firstName: string | null, deathDate: string | null, activities: Array<PersonActivity>, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, poster: { path: string } | null, countries: Array<{ name: string }>, activeOnBrands: Array<{ ref: string }>, seoAttributes?: Array<{ browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> } | null };

export type DeletePersonImagesImportMutationVariables = Exact<{
  input: DeletePersonImagesImportInput;
}>;


export type DeletePersonImagesImportMutation = { deletePersonImagesImport: string };

export type DeletePersonNicknameMutationVariables = Exact<{
  input: DeletePersonNicknameInput;
}>;


export type DeletePersonNicknameMutation = { deletePersonNickname: { id: string } | null };

export type GetPersonActivitiesForEntityTypeQueryVariables = Exact<{
  entityType?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPersonActivitiesForEntityTypeQuery = { personActivities: Array<PersonActivity> };

export type DeletePersonMutationVariables = Exact<{
  input: DeleteEntityInput;
}>;


export type DeletePersonMutation = { deleteEntity: { id: string, ref: string } | {} | null };

export type GetPersonBrandedDataQueryVariables = Exact<{
  personId: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
}>;


export type GetPersonBrandedDataQuery = { person: { id: string, brandData: { biography: string | object[] | null, birthPlace: string | null, deathPlace: string | null, deathCause: string | null, poster: { id: string, url: string, ref: string, brandData: { id: string, copyrightName: string | null, copyrights: Array<{ id: string, name: string }> | null } | null } | null } | null } | null };

export type GetPersonFilmographyTotalCountQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPersonFilmographyTotalCountQuery = { person: { id: string, filmography: { totalCount: number } } | null };

export type GetPersonImageSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPersonImageSourcesQuery = { personImageSources: Array<PersonImageSource> };

export type GetPersonFilmographyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  entityTypes?: InputMaybe<Array<InputMaybe<FilmographyEntity>> | InputMaybe<FilmographyEntity>>;
  activities?: InputMaybe<Array<PersonActivity> | PersonActivity>;
  orderBy: FilmographyOrder;
}>;


export type GetPersonFilmographyQuery = { person: { id: string, filmography: { totalCount: number, nodes: Array<{ id: string, activity: string | null, role: string | null, productionDate: string | null, entity: { __typename: 'Movie', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | { __typename: 'SeriesEpisode', id: string, ref: string, number: number, episodeTitle: string | null, series: { id: string, ref: string, title: string }, season: { id: string, ref: string, number: number } | null } }> } } | null };

export type PersonFilmographyEntityFragment = { entity: { __typename: 'Movie', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | { __typename: 'SeriesEpisode', id: string, ref: string, number: number, episodeTitle: string | null, series: { id: string, ref: string, title: string }, season: { id: string, ref: string, number: number } | null } };

export type GetPersonImagesImportOutcomesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
}>;


export type GetPersonImagesImportOutcomesQuery = { person: { id: string, imageImport: { __typename: 'PersonImageImportReport', id: string, status: ImportWizardReportStatus, importedCount: number, outcomes: Array<{ url: string, status: PersonImageImportStatus, message: string | null }> } | null } | null };

export type GetPersonImagesImportsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPersonImagesImportsQuery = { person: { id: string, imageImports: Array<{ __typename: 'PersonImageImportReport', id: string, status: ImportWizardReportStatus, failureReason: string | null, launchedAt: string, source: PersonImageSource, sourceId: string | null, confidence: PersonImageConfidence, detail: string, limit: number, candidatesCount: number, importedCount: number, metadata: { createdBy: { id: string, name: string } | null } }> } | null };

export type GetPersonImagesImportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
}>;


export type GetPersonImagesImportQuery = { person: { id: string, imageImport: { __typename: 'PersonImageImportReport', id: string, status: ImportWizardReportStatus, failureReason: string | null, launchedAt: string, source: PersonImageSource, sourceId: string | null, confidence: PersonImageConfidence, detail: string, limit: number, candidatesCount: number, importedCount: number, candidates: Array<{ id: string, url: string, thumbnailUrl: string, qualities: Array<PersonImageQuality>, width: number | null, height: number | null, type: ImageType, category: string | null, title: string | null, pageUrl: string | null, credit: string | null, license: string | null }>, outcomes: Array<{ url: string, status: PersonImageImportStatus, message: string | null }>, metadata: { createdBy: { id: string, name: string } | null } } | null } | null };

export type GetPersonTagsQueryVariables = Exact<{
  personId: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
}>;


export type GetPersonTagsQuery = { person: { id: string, tags: { nodes: Array<{ id: string, rank: number, tag: { id: string, ref: string, name: string, type: TagType, active: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }, entity: { __typename: 'Company', id: string, rawId: number, ref: string, name: string, title: string } | { __typename: 'Movie', id: string, rawId: number, ref: string, title: string } | { __typename: 'News', id: string, rawId: number, ref: string, title: string } | { __typename: 'Person', id: string, rawId: number, ref: string, firstName: string | null, lastName: string | null } | { __typename: 'SeriesEpisode', id: string, rawId: number, ref: string, episodeTitle: string | null } | { __typename: 'SeriesSeason', id: string, rawId: number, ref: string, number: number } | { __typename: 'Series', id: string, rawId: number, ref: string, title: string } | { __typename: 'Slide', id: string, rawId: number, ref: string, title: string } | { __typename: 'Theater', id: string, rawId: number, ref: string, name: string } }> } } | null };

export type GetPersonListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<PersonOrder>;
  search?: InputMaybe<Scalars['String']['input']>;
  activities?: InputMaybe<Array<InputMaybe<PersonActivity>> | InputMaybe<PersonActivity>>;
  searchIn?: InputMaybe<EntitySearchTypes>;
  searchSensitivity?: InputMaybe<EntitySearchOptions>;
  brandId: Scalars['ID']['input'];
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetPersonListQuery = { persons: { totalCount: number, nodes: Array<{ __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, gender: Gender | null, birthDate: string | null, deathDate: string | null, activities: Array<PersonActivity>, countries: Array<{ __typename: 'Country', id: string, ref: string, name: string, alpha2: string }>, poster: { id: string, url: string, ref: string } | null, metadata: { createdAt: string, updatedAt: string, origin: string | null, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, activeOnBrands: Array<{ id: string }>, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null }> } };

export type GetPersonQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetPersonQuery = { entityByRef: { __typename: 'User' } | { __typename: 'Locale' } | { __typename: 'Author' } | { __typename: 'SocialUser' } | { __typename: 'Image' } | { __typename: 'Movie' } | { __typename: 'ImageCategory' } | { __typename: 'Series' } | { __typename: 'Company' } | { __typename: 'CompanyStaff' } | { __typename: 'News' } | { __typename: 'VideoLegacy' } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' } | { __typename: 'Certificate' } | { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, formalName: string | null, gender: Gender | null, birthDate: string | null, deathDate: string | null, keywords: Array<string>, activeOnBrands: Array<{ ref: string }>, poster: { copyrightName: string | null, id: string, url: string, ref: string, copyrights: Array<{ id: string, name: string }> | null } | null, countries: Array<{ __typename: 'Country', id: string, ref: string, name: string, alpha2: string }>, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, nicknames: Array<{ id: string, nickname: string, gender: Gender }> } | { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | { __typename: 'Slide' } | { __typename: 'Carousel' } | { __typename: 'Theater' } | { __typename: 'Screen' } | { __typename: 'FestivalAward' } | { __typename: 'FestivalSelection' } | { __typename: 'FestivalCompetition' } | { __typename: 'FestivalEditionCompetition' } | { __typename: 'FestivalJury' } | { __typename: 'TheaterEvent' } | { __typename: 'Widget' } | { __typename: 'VideoB2B' } | null };

export type ImportPersonImagesMutationVariables = Exact<{
  input: ImportPersonImagesInput;
}>;


export type ImportPersonImagesMutation = { importPersonImages: Array<{ url: string, status: PersonImageImportStatus, message: string | null }> };

export type UpdatePersonBrandedDataMutationVariables = Exact<{
  input: UpdatePersonBrandDataInput;
  brandId: Scalars['ID']['input'];
}>;


export type UpdatePersonBrandedDataMutation = { updatePersonBrandData: { biography: string | object[] | null, birthPlace: string | null, deathPlace: string | null, deathCause: string | null, poster: { id: string, url: string, ref: string, brandData: { id: string, copyrightName: string | null, copyrights: Array<{ id: string, name: string }> | null } | null } | null } | null };

export type LaunchPersonImagesImportMutationVariables = Exact<{
  input: LaunchPersonImagesImportInput;
}>;


export type LaunchPersonImagesImportMutation = { launchPersonImagesImport: { __typename: 'PersonImageImportReport', id: string, status: ImportWizardReportStatus, failureReason: string | null, launchedAt: string, source: PersonImageSource, sourceId: string | null, confidence: PersonImageConfidence, detail: string, limit: number, candidatesCount: number, importedCount: number, metadata: { createdBy: { id: string, name: string } | null } } };

export type AddReleaseToEntityMutationVariables = Exact<{
  input: AddReleaseToEntityInput;
}>;


export type AddReleaseToEntityMutation = { addReleaseToEntity: { id: string, ref: string } | null };

export type UpdatePersonMutationVariables = Exact<{
  input: UpdatePersonInput;
}>;


export type UpdatePersonMutation = { updatePerson: { id: string, ref: string, firstName: string | null, lastName: string | null, formalName: string | null, gender: Gender | null, birthDate: string | null, deathDate: string | null, keywords: Array<string>, poster: { copyrightName: string | null, id: string, url: string, ref: string, copyrights: Array<{ id: string, name: string }> | null } | null, countries: Array<{ __typename: 'Country', id: string, ref: string, name: string, alpha2: string }>, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type CreateProductMutationVariables = Exact<{
  input: CreateProductInput;
}>;


export type CreateProductMutation = { createProduct: { releaseCreated: boolean, product: { id: string } } };

export type GetProductListQueryVariables = Exact<{
  countryId: Scalars['ID']['input'];
  companyId?: InputMaybe<Scalars['ID']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<ProductEntityType>;
  entitySearch?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<ProductListOrigin>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProductListQuery = { productList: { totalCount: number, nodes: Array<{ productId: string, productType: string | null, productName: string | null, url: string | null, price: string | null, currency: string | null, relatedEntityId: string, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, provider: { id: string, name: string } | null }> } };

export type GetProductQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type GetProductQuery = { product: { productId: string, countryId: string, companyId: string, productType: string | null, name: string | null, url: string | null, price: string | null, currency: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, linkedEntities: Array<{ __typename: 'Movie', id: string, title: string } | { __typename: 'SeriesEpisode', id: string, ref: string, number: number, series: { id: string, title: string }, season: { id: string, number: number } | null } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, title: string } } | { __typename: 'Series', id: string, title: string }> } | null };

export type HasReleaseForEntityQueryVariables = Exact<{
  entityId: Scalars['ID']['input'];
  countryId: Scalars['ID']['input'];
  limitedCompanyId?: InputMaybe<Scalars['ID']['input']>;
  type: ReleaseType;
}>;


export type HasReleaseForEntityQuery = { hasReleaseForEntity: boolean };

export type UpdateProductDetailsMutationVariables = Exact<{
  input: UpdateProductDetailsInput;
}>;


export type UpdateProductDetailsMutation = { updateProductDetails: { id: string } | null };

export type UpdateProductProviderMutationVariables = Exact<{
  input: UpdateProductProviderInput;
}>;


export type UpdateProductProviderMutation = { updateProductProvider: { id: string } | null };

export type RedirectionRuleRowFragment = { __typename: 'RedirectionRule', id: string, ref: string, active: boolean, kind: RedirectionRuleKind, mode: RedirectionMode, cloudflareState: RedirectionRuleCloudflareState, sourcePattern: string | null, targetPattern: string | null, sourceEntity: string | null, targetEntity: string | null, startAt: string | null, endAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type CreateRedirectionRuleMutationVariables = Exact<{
  input: CreateRedirectionRuleInput;
}>;


export type CreateRedirectionRuleMutation = { createRedirectionRule: { __typename: 'RedirectionRule', id: string, ref: string, active: boolean, kind: RedirectionRuleKind, mode: RedirectionMode, cloudflareState: RedirectionRuleCloudflareState, sourcePattern: string | null, targetPattern: string | null, sourceEntity: string | null, targetEntity: string | null, startAt: string | null, endAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type RedirectionRuleChainRewriteFragment = { rowIndex: number | null, source: string, previousTarget: string, newTarget: string, path: Array<string>, warnings: Array<RedirectionChainWarning>, rule: { id: string, ref: string } | null };

export type RedirectionRuleChainRewritesQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId: Scalars['ID']['input'];
  kind: RedirectionRuleKind;
  mode: WritableRedirectionMode;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  sourcePattern?: InputMaybe<Scalars['String']['input']>;
  targetPattern?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  endAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
}>;


export type RedirectionRuleChainRewritesQuery = { redirectionRuleChainRewrites: { target: string, warnings: Array<RedirectionChainWarning>, reviewToken: string, rewrites: Array<{ rowIndex: number | null, source: string, previousTarget: string, newTarget: string, path: Array<string>, warnings: Array<RedirectionChainWarning>, rule: { id: string, ref: string } | null }> } | null };

export type RedirectionRulesExportQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  kinds?: InputMaybe<Array<RedirectionRuleKind> | RedirectionRuleKind>;
  modes?: InputMaybe<Array<RedirectionMode> | RedirectionMode>;
  status?: InputMaybe<RedirectionRuleStatus>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  destinationUrl?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  endAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
}>;


export type RedirectionRulesExportQuery = { redirectionRules: { totalCount: number, nodes: Array<{ active: boolean, mode: RedirectionMode, sourcePattern: string | null, targetPattern: string | null, startAt: string | null, endAt: string | null, brand: { ref: string } }> } | null };

export type RedirectionRuleExportRowFragment = { active: boolean, mode: RedirectionMode, sourcePattern: string | null, targetPattern: string | null, startAt: string | null, endAt: string | null, brand: { ref: string } };

export type DeleteRedirectionRulesMutationVariables = Exact<{
  input: DeleteRedirectionRulesInput;
}>;


export type DeleteRedirectionRulesMutation = { deleteRedirectionRules: number };

export type RedirectionRulesListQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  modes?: InputMaybe<Array<RedirectionMode> | RedirectionMode>;
  status?: InputMaybe<RedirectionRuleStatus>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  destinationUrl?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  endAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  orderBy?: InputMaybe<RedirectionRulesOrder>;
}>;


export type RedirectionRulesListQuery = { redirectionRules: { totalCount: number, nodes: Array<{ __typename: 'RedirectionRule', id: string, ref: string, active: boolean, kind: RedirectionRuleKind, mode: RedirectionMode, cloudflareState: RedirectionRuleCloudflareState, sourcePattern: string | null, targetPattern: string | null, sourceEntity: string | null, targetEntity: string | null, startAt: string | null, endAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> } | null };

export type UpsertRedirectionRulesMutationVariables = Exact<{
  input: UpsertRedirectionRulesInput;
}>;


export type UpsertRedirectionRulesMutation = { upsertRedirectionRules: { totalRows: number, createdCount: number, updatedCount: number, unchangedCount: number, rewrittenCount: number, chainReviewToken: string | null, chainRewrites: Array<{ rowIndex: number | null, source: string, previousTarget: string, newTarget: string, path: Array<string>, warnings: Array<RedirectionChainWarning>, rule: { id: string, ref: string } | null }>, errors: Array<{ index: number | null, field: string | null, message: string }> } };

export type UpdateRedirectionRuleMutationVariables = Exact<{
  input: UpdateRedirectionRuleInput;
}>;


export type UpdateRedirectionRuleMutation = { updateRedirectionRule: { __typename: 'RedirectionRule', id: string, ref: string, active: boolean, kind: RedirectionRuleKind, mode: RedirectionMode, cloudflareState: RedirectionRuleCloudflareState, sourcePattern: string | null, targetPattern: string | null, sourceEntity: string | null, targetEntity: string | null, startAt: string | null, endAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type CreateScreenMutationVariables = Exact<{
  theaterId: Scalars['ID']['input'];
  number: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  size?: InputMaybe<ScreenSizeInput>;
}>;


export type CreateScreenMutation = { createScreen: { id: string } | null };

export type AddImageToScreenMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
  imageId: Scalars['ID']['input'];
}>;


export type AddImageToScreenMutation = { addImageToScreen: { rank: number, image: { id: string, url: string, ref: string } } | null };

export type DeleteImageFromScreenMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
  imageId: Scalars['ID']['input'];
}>;


export type DeleteImageFromScreenMutation = { deleteImageFromScreen: { rank: number, image: { id: string, url: string } } };

export type GetScreenQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetScreenQuery = { screen: { __typename: 'Screen', id: string, name: string, number: number | null, seats: number | null, externalIDs: Array<{ type: string, alts: Array<string> }>, flags: { accessibility: Array<string>, comfort: Array<string>, experience: Array<string>, food: Array<string>, picture: Array<string>, projection: Array<string>, restriction: Array<string>, service: Array<string>, sound: Array<string> }, size: { width: number | null, unit: ScreenSizeUnit | null } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, theater: { __typename: 'Theater', id: string, ref: string, code: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } } } | null };

export type GetScreenImagesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
}>;


export type GetScreenImagesQuery = { screen: { id: string, images: { totalCount: number, nodes: Array<{ rank: number, image: { id: string, url: string, ref: string } }> } } | null };

export type GetTheaterIdQueryVariables = Exact<{
  code: Scalars['ID']['input'];
}>;


export type GetTheaterIdQuery = { theaterByCode: { id: string } | null };

export type UpdateScreenFlagsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  flags: ScreenFlagsInput;
}>;


export type UpdateScreenFlagsMutation = { updateScreen: { id: string, flags: { accessibility: Array<string>, comfort: Array<string>, experience: Array<string>, food: Array<string>, picture: Array<string>, projection: Array<string>, restriction: Array<string>, service: Array<string>, sound: Array<string> }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpdateScreenSeatsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  seats?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateScreenSeatsMutation = { updateScreen: { id: string, seats: number | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpdateScreenIdentityMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  number: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<ScreenSizeInput>;
}>;


export type UpdateScreenIdentityMutation = { updateScreen: { id: string, name: string, number: number | null, size: { width: number | null, unit: ScreenSizeUnit | null } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { createUser: { id: string, ref: string } | null };

export type DeletePresetMutationVariables = Exact<{
  presetId: Scalars['ID']['input'];
}>;


export type DeletePresetMutation = { deletePreset: { id: string } | null };

export type CreatePresetMutationVariables = Exact<{
  input: CreatePresetInput;
}>;


export type CreatePresetMutation = { createPreset: { id: string } | null };

export type CreateTeamMutationVariables = Exact<{
  name: Scalars['String']['input'];
  countryIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  brandIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  localeIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CreateTeamMutation = { createTeam: { id: string, ref: string } | null };

export type GetPresetListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  universes?: InputMaybe<Array<Universe> | Universe>;
}>;


export type GetPresetListQuery = { presets: { totalCount: number, nodes: Array<{ id: string, name: string, universes: Array<Universe> }> } };

export type PresetRowFragment = { id: string, name: string, universes: Array<Universe> };

export type DeleteTeamMutationVariables = Exact<{
  teamId: Scalars['ID']['input'];
}>;


export type DeleteTeamMutation = { deleteTeam: { id: string, name: string } | null };

export type GenerateUserTokenMutationVariables = Exact<{
  input: GenerateUserTokenInput;
}>;


export type GenerateUserTokenMutation = { generateUserToken: string | null };

export type GetBrandOrCountryLocaleQueryVariables = Exact<{
  brandId: Scalars['ID']['input'];
  countryId: Scalars['ID']['input'];
  withBrandData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBrandOrCountryLocaleQuery = { brand?: { id: string, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null } } | null, country: { id: string, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null } | null } | null };

export type GetPresetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPresetQuery = { preset: { id: string, name: string, universes: Array<Universe>, permissions: Array<Permission>, users: Array<{ id: string, ref: string, active: boolean, name: string, presets: Array<{ id: string }> }>, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type GetTeamListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  brandIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  localeIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  countryIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetTeamListQuery = { teams: { totalCount: number, nodes: Array<{ id: string, ref: string, name: string, locales: Array<{ id: string, name: string }>, brands: Array<{ id: string, name: string }>, countries: Array<{ id: string, name: string }> }> } };

export type TeamRowFragment = { id: string, ref: string, name: string, locales: Array<{ id: string, name: string }>, brands: Array<{ id: string, name: string }>, countries: Array<{ id: string, name: string }> };

export type GetTeamQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetTeamQuery = { teamByRef: { id: string, ref: string, name: string, locales: Array<{ id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }>, brands: Array<{ __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }>, countries: Array<{ __typename: 'Country', id: string, ref: string, name: string, alpha2: string }>, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type GetUserListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  teamIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserListQuery = { users: { totalCount: number, nodes: Array<{ id: string, ref: string, name: string, email: string, active: boolean, application: boolean, admin: boolean, metadata: { createdAt: string }, allowedBrands: Array<{ ref: string }> }> } };

export type GetUserQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetUserQuery = { entityByRef: { id: string, ref: string, name: string, email: string, active: boolean, application: boolean, admin: boolean, allowedNewsScopes: Array<NewsScope>, permissions: Array<Permission>, presets: Array<{ id: string, permissions: Array<Permission>, name: string }>, allowedBrands: Array<{ __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }>, defaultBrand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } | null, defaultCountry: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, defaultLocale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null } | null, rights: Array<{ team: { id: string, name: string }, preset: { id: string, name: string } }>, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | {} | null };

export type GetUserPreferencesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserPreferencesQuery = { user: { id: string, defaultBrand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } | null, defaultCountry: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, defaultLocale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null } | null } | null };

export type UpdatePresetPermissionsMutationVariables = Exact<{
  input: UpdatePresetInput;
}>;


export type UpdatePresetPermissionsMutation = { updatePreset: { id: string, permissions: Array<Permission>, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpdatePresetMutationVariables = Exact<{
  input: UpdatePresetInput;
}>;


export type UpdatePresetMutation = { updatePreset: { id: string, name: string, universes: Array<Universe>, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpdateTeamMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  countryIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  brandIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  localeIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type UpdateTeamMutation = { updateTeam: { id: string, ref: string, name: string, locales: Array<{ id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }>, brands: Array<{ __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }>, countries: Array<{ __typename: 'Country', id: string, ref: string, name: string, alpha2: string }>, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpdateUserPermissionsMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserPermissionsMutation = { updateUser: { id: string, permissions: Array<Permission>, presets: Array<{ id: string, permissions: Array<Permission> }>, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpdateUserPreferencesMutationVariables = Exact<{
  input: UpdateUserPreferencesInput;
}>;


export type UpdateUserPreferencesMutation = { updateUserPreferences: { id: string, defaultBrand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } | null, defaultCountry: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, defaultLocale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { updateUser: { id: string, ref: string, name: string, email: string, active: boolean, application: boolean, admin: boolean, allowedNewsScopes: Array<NewsScope>, presets: Array<{ id: string, name: string }>, allowedBrands: Array<{ __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }>, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpdateUserRolesMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserRolesMutation = { updateUser: { id: string, rights: Array<{ team: { id: string, name: string }, preset: { id: string, name: string } }>, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type BatchCreateSeriesSeasonsMutationVariables = Exact<{
  input: BatchCreateSeriesSeasonsInput;
}>;


export type BatchCreateSeriesSeasonsMutation = { batchCreateSeriesSeasons: Array<{ id: string }> | null };

export type ApplyCreditToEntityMutationVariables = Exact<{
  input: ApplyCreditToEntityInput;
}>;


export type ApplyCreditToEntityMutation = { applyCreditToEntity: Array<{ id: string }> | null };

export type ApplyCastingToEntityMutationVariables = Exact<{
  input: ApplyCastingToEntityInput;
}>;


export type ApplyCastingToEntityMutation = { applyCastingToEntity: Array<{ id: string }> | null };

export type BatchCreateSeriesEpisodesMutationVariables = Exact<{
  input: BatchCreateSeriesEpisodesInput;
}>;


export type BatchCreateSeriesEpisodesMutation = { batchCreateSeriesEpisodes: Array<{ id: string }> | null };

export type TeamOptionFragment = { id: string, name: string };

export type TeamOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type TeamOptionsQuery = { teams: { nodes: Array<{ id: string, name: string }> } };

export type PresetOptionFragment = { id: string, name: string };

export type PresetOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PresetOptionsQuery = { presets: { nodes: Array<{ id: string, name: string }> } };

export type CreateSeasonReleaseMutationVariables = Exact<{
  input: AddReleaseToEntityInput;
}>;


export type CreateSeasonReleaseMutation = { addReleaseToEntity: { id: string } | null };

export type CreateEpisodeReleaseMutationVariables = Exact<{
  input: AddReleaseToEntityInput;
}>;


export type CreateEpisodeReleaseMutation = { addReleaseToEntity: { id: string } | null };

export type CreateSeriesEpisodeMutationVariables = Exact<{
  input: CreateSeriesEpisodeInput;
}>;


export type CreateSeriesEpisodeMutation = { createSeriesEpisode: { id: string, ref: string, series: { id: string, ref: string }, season: { id: string, ref: string } | null } | null };

export type CreateSeriesReleaseMutationVariables = Exact<{
  input: AddReleaseToEntityInput;
}>;


export type CreateSeriesReleaseMutation = { addReleaseToEntity: { id: string, entity: { id: string } | {} } | null };

export type CreateSeriesSeasonMutationVariables = Exact<{
  input: CreateSeriesSeasonInput;
}>;


export type CreateSeriesSeasonMutation = { createSeriesSeason: { id: string, ref: string, series: { id: string, ref: string } } | null };

export type CreateSeriesMutationVariables = Exact<{
  input: CreateSeriesInput;
}>;


export type CreateSeriesMutation = { createSeries: { id: string, ref: string } | null };

export type DeleteEpisodeMutationVariables = Exact<{
  input: DeleteEntityInput;
}>;


export type DeleteEpisodeMutation = { deleteEntity: { id: string, ref: string } | {} | null };

export type GetEpisodeBrandedDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
}>;


export type GetEpisodeBrandedDataQuery = { seriesEpisode: { id: string, brandData: { synopsis: string | object[] | null, title: string | null, ruling: { hasRating: boolean, atRisk: boolean, hasWarningMessage: boolean, hasMandatoryReview: boolean } } | null } | null };

export type DeleteSeriesSeasonMutationVariables = Exact<{
  input: DeleteEntityInput;
}>;


export type DeleteSeriesSeasonMutation = { deleteEntity: { id: string, ref: string } | {} | null };

export type DeleteSeriesMutationVariables = Exact<{
  input: DeleteEntityInput;
}>;


export type DeleteSeriesMutation = { deleteEntity: { id: string, ref: string } | {} | null };

export type GetEpisodeCompanyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  activities?: InputMaybe<Array<CompanyActivity> | CompanyActivity>;
}>;


export type GetEpisodeCompanyQuery = { seriesEpisode: { id: string, companies: { totalCount: number, nodes: Array<{ id: string, rank: number, activity: CompanyActivity, company: { id: string, ref: string, name: string } }> } } | null };

export type GetEpisodeCastingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  locale?: InputMaybe<Scalars['ID']['input']>;
  showLocaleData: Scalars['Boolean']['input'];
  brandId: Scalars['ID']['input'];
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  withSeoAttributes?: Scalars['Boolean']['input'];
}>;


export type GetEpisodeCastingQuery = { seriesEpisode: { id: string, parent: { id: string } | null, credits: { totalCount: number, nodes: Array<{ __typename: 'PersonCredits', id: string, active: boolean, rank: number, role: string | null, person: { __typename: 'Person', id: string, ref: string, lastName: string | null, firstName: string | null, deathDate: string | null, activities: Array<PersonActivity>, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, poster: { path: string } | null, countries: Array<{ name: string }>, activeOnBrands: Array<{ ref: string }>, seoAttributes?: Array<{ browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, voice: { __typename: 'Person', id: string, ref: string, lastName: string | null, firstName: string | null, deathDate: string | null, activities: Array<PersonActivity>, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, poster: { path: string } | null, countries: Array<{ name: string }>, activeOnBrands: Array<{ ref: string }>, seoAttributes?: Array<{ browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> } | null, localeData?: { nodes: Array<{ id: string, role: string | null, voice: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null } }> } }> } } | null };

export type GetEpisodeCreditQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  activities?: InputMaybe<Array<PersonActivity> | PersonActivity>;
  brandId: Scalars['ID']['input'];
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetEpisodeCreditQuery = { seriesEpisode: { id: string, parent: { id: string } | null, credits: { totalCount: number, nodes: Array<{ __typename: 'PersonCredits', id: string, activity: PersonActivity, rank: number, person: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, activeOnBrands: Array<{ id: string, ref: string }>, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null } | null }> } } | null };

export type GetEpisodeExternalIdsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEpisodeExternalIdsQuery = { seriesEpisode: { __typename: 'SeriesEpisode', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> } | null };

export type GetEpisodeIdQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetEpisodeIdQuery = { entityByRef: { id: string } | {} | null };

export type GetEpisodeIdentityQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetEpisodeIdentityQuery = { seriesEpisode: { __typename: 'SeriesEpisode', id: string, ref: string, title: string | null, number: number, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, season: { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | null, series: { id: string, ref: string, title: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type SeriesEpisodeWithSeoFragment = { __typename: 'SeriesEpisode', id: string, ref: string, title: string | null, number: number, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, season: { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | null, series: { id: string, ref: string, title: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type GetEpisodePersonCreditsImportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  reportId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetEpisodePersonCreditsImportQuery = { seriesEpisode: { id: string, personCreditsImport: { __typename: 'PersonCreditsImportReport', id: string, status: ImportWizardReportStatus, failureReason: string | null, launchedAt: string, finishedAt: string | null, source: PersonCreditsImportSource, outcome: ImportWizardOutcome | null, answeredBy: ImportWizardLevel | null, metadata: { createdBy: { id: string, name: string } | null }, counts: { linked: number, matched: number, ambiguous: number, unknown: number, extraneous: number }, stats: { durationMs: number, requests: number, bytesReceived: number, resolutionDurationMs: number, resolutionRequests: number, levels: Array<{ level: number, name: string, outcome: string, durationMs: number, requests: number, bytesReceived: number, creditsCount: number, detail: string, llmInputTokens: number | null, llm: { provider: string, model: string, inputTokens: number, outputTokens: number, durationMs: number, costUsd: number | null, error: string | null } | null }>, llm: { provider: string, model: string, inputTokens: number, outputTokens: number, durationMs: number, costUsd: number | null, error: string | null } | null }, localization: { locale: string, localeId: string, outcome: string | null, detail: string | null, durationMs: number | null, rolesAsked: number | null, rolesLocalized: number | null, llm: { provider: string, model: string, inputTokens: number, outputTokens: number, durationMs: number, costUsd: number | null, error: string | null } | null } | null, resolution: { __typename: 'PersonCreditsImportResolution', confidence: string, sourceId: string | null, source: string, detail: string, candidates: Array<{ id: string, title: string, year: number | null, kind: string | null }> } | null, entries: Array<{ __typename: 'PersonCreditsImportEntry', status: PersonCreditsImportStatus, name: string | null, category: string | null, role: string | null, localizedRole: string | null, externalPersonId: string | null, order: number | null, suggestedActivity: PersonActivity | null, gender: Gender | null, isVoice: boolean, linkKind: PersonCreditsImportLinkKind | null, linkLocale: string | null, linkedPerson: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, birthDate: string | null, deathDate: string | null, activities: Array<PersonActivity>, countries: Array<{ id: string, name: string, alpha2: string }>, poster: { id: string, path: string } | null } | null, candidates: Array<{ __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, birthDate: string | null, deathDate: string | null, activities: Array<PersonActivity>, countries: Array<{ id: string, name: string, alpha2: string }>, poster: { id: string, path: string } | null }>, credit: { __typename: 'PersonCredits', id: string, activity: PersonActivity, rank: number, role: string | null } | null }> } | null, personCreditsImports: Array<{ __typename: 'PersonCreditsImportReport', id: string, status: ImportWizardReportStatus, launchedAt: string, source: PersonCreditsImportSource, outcome: ImportWizardOutcome | null, sections: Array<PersonCreditsImportDataType>, resolution: { __typename: 'PersonCreditsImportResolution', confidence: string, source: string } | null, stats: { levels: Array<{ level: number, name: string, outcome: string, creditsCount: number }> }, metadata: { createdBy: { id: string, name: string } | null } }> } | null };

export type GetEpisodeMetadataQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetEpisodeMetadataQuery = { entityByRef: { __typename: 'SeriesEpisode', id: string, ref: string, number: number, title: string | null, season: { __typename: 'SeriesSeason', ref: string, number: number, id: string, originalPremiere: string | null, status: SeriesStatus | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | null, series: { ref: string, title: string, id: string }, metadata: { createdAt: string, updatedAt: string, origin: string | null, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, activeOnBrands: Array<{ ref: string }> } | {} | null };

export type GetEpisodeReleaseQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetEpisodeReleaseQuery = { releaseByRef: { id: string, ref: string, type: ReleaseType | null, flags: Array<ReleaseFlag>, releasedAt: string | null, releasedAtTime: string | null, unreleasedAt: string | null, notReleasedYet: boolean, techInfo: string | null, limitedCompany: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, distributors: Array<{ __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }>, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, entity: { id: string, ref: string, title: string | null, series: { id: string, title: string }, season: { id: string, number: number } | null } | {} } | null };

export type GetSeasonBrandedDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
}>;


export type GetSeasonBrandedDataQuery = { seriesSeason: { id: string, brandData: { id: string, synopsis: string | object[] | null, poster: { id: string, url: string, ref: string } | null, ruling: { hasRating: boolean, atRisk: boolean, hasWarningMessage: boolean, hasMandatoryReview: boolean } } | null } | null };

export type GetSeasonCompanyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  activities?: InputMaybe<Array<CompanyActivity> | CompanyActivity>;
}>;


export type GetSeasonCompanyQuery = { seriesSeason: { id: string, companies: { totalCount: number, nodes: Array<{ id: string, rank: number, activity: CompanyActivity, company: { id: string, ref: string, name: string } }> }, series: { id: string } } | null };

export type GetSeasonCreditQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  activities?: InputMaybe<Array<PersonActivity> | PersonActivity>;
  brandId: Scalars['ID']['input'];
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetSeasonCreditQuery = { seriesSeason: { id: string, parent: { id: string }, credits: { totalCount: number, nodes: Array<{ __typename: 'PersonCredits', id: string, activity: PersonActivity, rank: number, person: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, activeOnBrands: Array<{ id: string, ref: string }>, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null } | null }> } } | null };

export type GetSeasonEpisodesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  brandId: Scalars['ID']['input'];
  episodeNumbers?: InputMaybe<Array<Scalars['NonNegativeInt']['input']> | Scalars['NonNegativeInt']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetSeasonEpisodesQuery = { seriesSeason: { id: string, series: { id: string }, episodes: { totalCount: number, nodes: Array<{ __typename: 'SeriesEpisode', id: string, ref: string, title: string | null, number: number, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, season: { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | null, series: { id: string, ref: string, title: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> } } | null };

export type GetSeasonCastingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  locale?: InputMaybe<Scalars['ID']['input']>;
  showLocaleData: Scalars['Boolean']['input'];
  brandId: Scalars['ID']['input'];
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  withSeoAttributes?: Scalars['Boolean']['input'];
}>;


export type GetSeasonCastingQuery = { seriesSeason: { id: string, parent: { id: string }, credits: { totalCount: number, nodes: Array<{ __typename: 'PersonCredits', id: string, active: boolean, rank: number, role: string | null, person: { __typename: 'Person', id: string, ref: string, lastName: string | null, firstName: string | null, deathDate: string | null, activities: Array<PersonActivity>, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, poster: { path: string } | null, countries: Array<{ name: string }>, activeOnBrands: Array<{ ref: string }>, seoAttributes?: Array<{ browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, voice: { __typename: 'Person', id: string, ref: string, lastName: string | null, firstName: string | null, deathDate: string | null, activities: Array<PersonActivity>, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, poster: { path: string } | null, countries: Array<{ name: string }>, activeOnBrands: Array<{ ref: string }>, seoAttributes?: Array<{ browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> } | null, localeData?: { nodes: Array<{ id: string, role: string | null, voice: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null } }> } }> } } | null };

export type GetSeasonExternalIdsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSeasonExternalIdsQuery = { seriesSeason: { __typename: 'SeriesSeason', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> } | null };

export type GetSeasonIdQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetSeasonIdQuery = { entityByRef: { id: string } | {} | null };

export type GetSeasonIdentityQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetSeasonIdentityQuery = { seriesSeason: { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, originalFinale: string | null, status: SeriesStatus | null, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, poster: { id: string, url: string, ref: string } | null, series: { id: string, ref: string, title: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type SeriesSeasonWithSeoFragment = { id: string, ref: string, number: number, originalPremiere: string | null, originalFinale: string | null, status: SeriesStatus | null, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, poster: { id: string, url: string, ref: string } | null, series: { id: string, ref: string, title: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type GetSeasonPersonCreditsImportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  reportId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetSeasonPersonCreditsImportQuery = { seriesSeason: { id: string, personCreditsImport: { __typename: 'PersonCreditsImportReport', id: string, status: ImportWizardReportStatus, failureReason: string | null, launchedAt: string, finishedAt: string | null, source: PersonCreditsImportSource, outcome: ImportWizardOutcome | null, answeredBy: ImportWizardLevel | null, metadata: { createdBy: { id: string, name: string } | null }, counts: { linked: number, matched: number, ambiguous: number, unknown: number, extraneous: number }, stats: { durationMs: number, requests: number, bytesReceived: number, resolutionDurationMs: number, resolutionRequests: number, levels: Array<{ level: number, name: string, outcome: string, durationMs: number, requests: number, bytesReceived: number, creditsCount: number, detail: string, llmInputTokens: number | null, llm: { provider: string, model: string, inputTokens: number, outputTokens: number, durationMs: number, costUsd: number | null, error: string | null } | null }>, llm: { provider: string, model: string, inputTokens: number, outputTokens: number, durationMs: number, costUsd: number | null, error: string | null } | null }, localization: { locale: string, localeId: string, outcome: string | null, detail: string | null, durationMs: number | null, rolesAsked: number | null, rolesLocalized: number | null, llm: { provider: string, model: string, inputTokens: number, outputTokens: number, durationMs: number, costUsd: number | null, error: string | null } | null } | null, resolution: { __typename: 'PersonCreditsImportResolution', confidence: string, sourceId: string | null, source: string, detail: string, candidates: Array<{ id: string, title: string, year: number | null, kind: string | null }> } | null, entries: Array<{ __typename: 'PersonCreditsImportEntry', status: PersonCreditsImportStatus, name: string | null, category: string | null, role: string | null, localizedRole: string | null, externalPersonId: string | null, order: number | null, suggestedActivity: PersonActivity | null, gender: Gender | null, isVoice: boolean, linkKind: PersonCreditsImportLinkKind | null, linkLocale: string | null, linkedPerson: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, birthDate: string | null, deathDate: string | null, activities: Array<PersonActivity>, countries: Array<{ id: string, name: string, alpha2: string }>, poster: { id: string, path: string } | null } | null, candidates: Array<{ __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, birthDate: string | null, deathDate: string | null, activities: Array<PersonActivity>, countries: Array<{ id: string, name: string, alpha2: string }>, poster: { id: string, path: string } | null }>, credit: { __typename: 'PersonCredits', id: string, activity: PersonActivity, rank: number, role: string | null } | null }> } | null, personCreditsImports: Array<{ __typename: 'PersonCreditsImportReport', id: string, status: ImportWizardReportStatus, launchedAt: string, source: PersonCreditsImportSource, outcome: ImportWizardOutcome | null, sections: Array<PersonCreditsImportDataType>, resolution: { __typename: 'PersonCreditsImportResolution', confidence: string, source: string } | null, stats: { levels: Array<{ level: number, name: string, outcome: string, creditsCount: number }> }, metadata: { createdBy: { id: string, name: string } | null } }> } | null };

export type GetSeriesBrandedDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
}>;


export type GetSeriesBrandedDataQuery = { series: { id: string, brandData: { id: string, title: string | null, keywords: Array<string>, synopsis: string | object[] | null, synopsisShort: string | null, poster: { id: string, url: string, ref: string } | null, ruling: { hasRating: boolean, atRisk: boolean, hasWarningMessage: boolean, hasMandatoryReview: boolean } } | null } | null };

export type GetSeasonMetadataQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetSeasonMetadataQuery = { entityByRef: { __typename: 'SeriesSeason', id: string, ref: string, number: number, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, series: { title: string }, activeOnBrands: Array<{ ref: string }> } | {} | null };

export type GetSeasonReleaseQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetSeasonReleaseQuery = { releaseByRef: { id: string, type: ReleaseType | null, flags: Array<ReleaseFlag>, releasedAt: string | null, releasedAtTime: string | null, unreleasedAt: string | null, notReleasedYet: boolean, techInfo: string | null, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null, limitedCompany: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, distributors: Array<{ __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }>, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, entity: { id: string, number: number, series: { id: string, title: string } } | {} } | null };

export type GetSeriesByRefsQueryVariables = Exact<{
  refs: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetSeriesByRefsQuery = { entitiesByRef: Array<{ __typename: 'Series', id: string, ref: string, title: string } | {} | null> | null };

export type GetSeriesCompanyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  activities?: InputMaybe<Array<CompanyActivity> | CompanyActivity>;
}>;


export type GetSeriesCompanyQuery = { series: { id: string, companies: { totalCount: number, nodes: Array<{ id: string, rank: number, activity: CompanyActivity, company: { id: string, ref: string, name: string } }> } } | null };

export type GetSeriesEntityLinksQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSeriesEntityLinksQuery = { series: { id: string, title: string, entityLinks: Array<{ linkType: EntityLinkType, target: { __typename: 'User', id: string } | { __typename: 'SocialUser', id: string } | { __typename: 'Image', id: string } | { __typename: 'Movie', id: string, title: string, ref: string } | { __typename: 'Series', id: string, title: string, ref: string } | { __typename: 'Company', id: string } | { __typename: 'CompanyStaff', id: string } | { __typename: 'News', id: string } | { __typename: 'VideoLegacy', id: string } | { __typename: 'SeriesSeason', id: string } | { __typename: 'SeriesEpisode', id: string } | { __typename: 'Person', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'Slide', id: string } | { __typename: 'Theater', id: string } | { __typename: 'Screen', id: string } | { __typename: 'FestivalAward', id: string } | { __typename: 'FestivalSelection', id: string } | { __typename: 'FestivalCompetition', id: string } | { __typename: 'FestivalEditionCompetition', id: string } | { __typename: 'FestivalJury', id: string } | { __typename: 'TheaterEvent', id: string } | { __typename: 'VideoB2B', id: string } }> } | null };

export type GetSeriesCreditQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  activities?: InputMaybe<Array<PersonActivity> | PersonActivity>;
  brandId: Scalars['ID']['input'];
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetSeriesCreditQuery = { series: { id: string, credits: { totalCount: number, nodes: Array<{ __typename: 'PersonCredits', id: string, activity: PersonActivity, rank: number, person: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, activeOnBrands: Array<{ id: string, ref: string }>, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null } | null }> } } | null };

export type GetSeriesEpisodesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<SeriesEpisodeFilter>;
  brandId: Scalars['ID']['input'];
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetSeriesEpisodesQuery = { series: { id: string, episodes: { totalCount: number, nodes: Array<{ __typename: 'SeriesEpisode', id: string, ref: string, title: string | null, number: number, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, season: { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | null, series: { id: string, ref: string, title: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> } } | null };

export type GetSeriesIdQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetSeriesIdQuery = { entityByRef: { id: string } | {} | null };

export type GetSeriesExternalIdsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSeriesExternalIdsQuery = { series: { __typename: 'Series', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> } | null };

export type GetSeriesIdentityQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSeriesIdentityQuery = { series: { id: string, ref: string, title: string, type: SeriesType | null, status: SeriesStatus | null, keywords: Array<string>, baseRuntime: number | null, genres: Array<Genre>, originalPremiere: string | null, originalFinale: string | null, credits: { nodes: Array<{ person: { ref: string, firstName: string | null, lastName: string | null } | null }> }, poster: { id: string, url: string, ref: string } | null, countries: Array<{ id: string, name: string }>, premiereChannel: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null } | null };

export type GetSeriesListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  genres?: InputMaybe<Array<Genre> | Genre>;
  orderBy?: InputMaybe<SeriesOrder>;
  personId?: InputMaybe<Scalars['ID']['input']>;
  brandIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  localeIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  includeBrandsData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocalesData?: InputMaybe<Scalars['Boolean']['input']>;
  brandId: Scalars['ID']['input'];
  includeSeoData?: InputMaybe<Scalars['Boolean']['input']>;
  searchIn?: InputMaybe<EntitySearchTypes>;
  searchSensitivity?: InputMaybe<EntitySearchOptions>;
}>;


export type GetSeriesListQuery = { seriesList: { totalCount: number, nodes: Array<{ __typename: 'Series', id: string, ref: string, title: string, originalPremiere: string | null, status: SeriesStatus | null, activeOnBrands: Array<{ id: string, ref: string, name: string }>, poster: { id: string, url: string, ref: string } | null, brandsData?: Array<{ title: string | null, brand: { ref: string } }> | null, localesData?: Array<{ title: string | null }> | null, credits: { nodes: Array<{ person: { ref: string, firstName: string | null, lastName: string | null } | null }> }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null }> } };

export type GetSeriesPersonCreditsImportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  reportId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetSeriesPersonCreditsImportQuery = { series: { id: string, personCreditsImport: { __typename: 'PersonCreditsImportReport', id: string, status: ImportWizardReportStatus, failureReason: string | null, launchedAt: string, finishedAt: string | null, source: PersonCreditsImportSource, outcome: ImportWizardOutcome | null, answeredBy: ImportWizardLevel | null, metadata: { createdBy: { id: string, name: string } | null }, counts: { linked: number, matched: number, ambiguous: number, unknown: number, extraneous: number }, stats: { durationMs: number, requests: number, bytesReceived: number, resolutionDurationMs: number, resolutionRequests: number, levels: Array<{ level: number, name: string, outcome: string, durationMs: number, requests: number, bytesReceived: number, creditsCount: number, detail: string, llmInputTokens: number | null, llm: { provider: string, model: string, inputTokens: number, outputTokens: number, durationMs: number, costUsd: number | null, error: string | null } | null }>, llm: { provider: string, model: string, inputTokens: number, outputTokens: number, durationMs: number, costUsd: number | null, error: string | null } | null }, localization: { locale: string, localeId: string, outcome: string | null, detail: string | null, durationMs: number | null, rolesAsked: number | null, rolesLocalized: number | null, llm: { provider: string, model: string, inputTokens: number, outputTokens: number, durationMs: number, costUsd: number | null, error: string | null } | null } | null, resolution: { __typename: 'PersonCreditsImportResolution', confidence: string, sourceId: string | null, source: string, detail: string, candidates: Array<{ id: string, title: string, year: number | null, kind: string | null }> } | null, entries: Array<{ __typename: 'PersonCreditsImportEntry', status: PersonCreditsImportStatus, name: string | null, category: string | null, role: string | null, localizedRole: string | null, externalPersonId: string | null, order: number | null, suggestedActivity: PersonActivity | null, gender: Gender | null, isVoice: boolean, linkKind: PersonCreditsImportLinkKind | null, linkLocale: string | null, linkedPerson: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, birthDate: string | null, deathDate: string | null, activities: Array<PersonActivity>, countries: Array<{ id: string, name: string, alpha2: string }>, poster: { id: string, path: string } | null } | null, candidates: Array<{ __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, birthDate: string | null, deathDate: string | null, activities: Array<PersonActivity>, countries: Array<{ id: string, name: string, alpha2: string }>, poster: { id: string, path: string } | null }>, credit: { __typename: 'PersonCredits', id: string, activity: PersonActivity, rank: number, role: string | null } | null }> } | null, personCreditsImports: Array<{ __typename: 'PersonCreditsImportReport', id: string, status: ImportWizardReportStatus, launchedAt: string, source: PersonCreditsImportSource, outcome: ImportWizardOutcome | null, sections: Array<PersonCreditsImportDataType>, resolution: { __typename: 'PersonCreditsImportResolution', confidence: string, source: string } | null, stats: { levels: Array<{ level: number, name: string, outcome: string, creditsCount: number }> }, metadata: { createdBy: { id: string, name: string } | null } }> } | null };

export type GetSeriesMetadataQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
  brandIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  localeIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocalesData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetSeriesMetadataQuery = { entityByRef: { __typename: 'User' } | { __typename: 'Locale' } | { __typename: 'Author' } | { __typename: 'SocialUser' } | { __typename: 'Image' } | { __typename: 'Movie' } | { __typename: 'ImageCategory' } | { __typename: 'Series', id: string, ref: string, title: string, brandsData?: Array<{ title: string | null }> | null, localesData?: Array<{ title: string | null }> | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'Company' } | { __typename: 'CompanyStaff' } | { __typename: 'News' } | { __typename: 'VideoLegacy' } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' } | { __typename: 'Certificate' } | { __typename: 'Person' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | { __typename: 'Slide' } | { __typename: 'Carousel' } | { __typename: 'Theater' } | { __typename: 'Screen' } | { __typename: 'FestivalAward' } | { __typename: 'FestivalSelection' } | { __typename: 'FestivalCompetition' } | { __typename: 'FestivalEditionCompetition' } | { __typename: 'FestivalJury' } | { __typename: 'TheaterEvent' } | { __typename: 'Widget' } | { __typename: 'VideoB2B' } | null };

export type SeriesMetadataEntityFragment = { __typename: 'Series', id: string, ref: string, title: string, brandsData?: Array<{ title: string | null }> | null, localesData?: Array<{ title: string | null }> | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, activeOnBrands: Array<{ ref: string }> };

export type GetSeriesSeasonsEpisodesQuickAccessQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  seasonsLimit?: InputMaybe<Scalars['Int']['input']>;
  subEpisodesLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSeriesSeasonsEpisodesQuickAccessQuery = { series: { __typename: 'Series', id: string, ref: string, seasons: { totalCount: number, nodes: Array<{ __typename: 'SeriesSeason', id: string, ref: string, number: number, episodes: { totalCount: number, nodes: Array<{ __typename: 'SeriesEpisode', id: string, ref: string, title: string | null, number: number }> } }> }, specialEpisodes: { totalCount: number, nodes: Array<{ __typename: 'SeriesEpisode', id: string, ref: string, title: string | null, number: number }> } } | null };

export type SeriesQuickAccessIdentityFragment = { __typename: 'Series', id: string, ref: string };

export type SeriesSeasonQuickAccessIdentityFragment = { __typename: 'SeriesSeason', id: string, ref: string, number: number };

export type EpisodeQuickAccessIdentityFragment = { __typename: 'SeriesEpisode', id: string, ref: string, title: string | null, number: number };

export type SeriesSeasonEpisodesQuickAccessRowFragment = { __typename: 'SeriesSeason', id: string, ref: string, number: number, episodes: { totalCount: number, nodes: Array<{ __typename: 'SeriesEpisode', id: string, ref: string, title: string | null, number: number }> } };

export type GetSeriesSeasonsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  brandId: Scalars['ID']['input'];
  seasonNumbers?: InputMaybe<Array<Scalars['NonNegativeInt']['input']> | Scalars['NonNegativeInt']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetSeriesSeasonsQuery = { series: { id: string, seasons: { totalCount: number, nodes: Array<{ __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, originalFinale: string | null, status: SeriesStatus | null, episodes: { totalCount: number }, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, poster: { id: string, url: string, ref: string } | null, series: { id: string, ref: string, title: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> }, episodes: { totalCount: number } } | null };

export type SeriesSeasonRowFragment = { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, originalFinale: string | null, status: SeriesStatus | null, episodes: { totalCount: number }, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, poster: { id: string, url: string, ref: string } | null, series: { id: string, ref: string, title: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type GetSeriesReleaseQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetSeriesReleaseQuery = { releaseByRef: { id: string, type: ReleaseType | null, flags: Array<ReleaseFlag>, releasedAt: string | null, releasedAtTime: string | null, unreleasedAt: string | null, notReleasedYet: boolean, advisory: string | null, techInfo: string | null, limitedCompany: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, distributors: Array<{ __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }>, certificate: { id: string, ref: string, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, entity: { id: string, title: string } | {} } | null };

export type GetSeriesSeasonsEpisodesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  brandId: Scalars['ID']['input'];
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetSeriesSeasonsEpisodesQuery = { series: { __typename: 'Series', id: string, seasons: { totalCount: number, nodes: Array<{ __typename: 'SeriesSeason', ref: string, id: string, number: number, originalPremiere: string | null, originalFinale: string | null, status: SeriesStatus | null, episodes: { totalCount: number, nodes: Array<{ __typename: 'SeriesEpisode', id: string, ref: string, title: string | null, number: number, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, season: { __typename: 'SeriesSeason', ref: string, number: number, id: string, originalPremiere: string | null, status: SeriesStatus | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | null, series: { ref: string, title: string, id: string }, metadata: { createdAt: string, updatedAt: string, origin: string | null, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> }, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, poster: { id: string, url: string, ref: string } | null, series: { id: string, ref: string, title: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> }, specialEpisodes: { totalCount: number, nodes: Array<{ __typename: 'SeriesEpisode', id: string, ref: string, title: string | null, number: number, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, season: { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | null, series: { id: string, ref: string, title: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> } } | null };

export type SeasonFromSeriesFragment = { __typename: 'Series', seasons: { totalCount: number, nodes: Array<{ __typename: 'SeriesSeason', ref: string, id: string, number: number, originalPremiere: string | null, originalFinale: string | null, status: SeriesStatus | null, episodes: { totalCount: number, nodes: Array<{ __typename: 'SeriesEpisode', id: string, ref: string, title: string | null, number: number, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, season: { __typename: 'SeriesSeason', ref: string, number: number, id: string, originalPremiere: string | null, status: SeriesStatus | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | null, series: { ref: string, title: string, id: string }, metadata: { createdAt: string, updatedAt: string, origin: string | null, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> }, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, poster: { id: string, url: string, ref: string } | null, series: { id: string, ref: string, title: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> } };

export type SeasonFromSeriesNodesFragment = { __typename: 'SeriesSeason', ref: string, id: string, number: number, originalPremiere: string | null, originalFinale: string | null, status: SeriesStatus | null, episodes: { totalCount: number, nodes: Array<{ __typename: 'SeriesEpisode', id: string, ref: string, title: string | null, number: number, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, season: { __typename: 'SeriesSeason', ref: string, number: number, id: string, originalPremiere: string | null, status: SeriesStatus | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | null, series: { ref: string, title: string, id: string }, metadata: { createdAt: string, updatedAt: string, origin: string | null, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> }, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, poster: { id: string, url: string, ref: string } | null, series: { id: string, ref: string, title: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type SeriesSeasonEpisodesRowFragment = { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, originalFinale: string | null, status: SeriesStatus | null, episodes: { totalCount: number, nodes: Array<{ __typename: 'SeriesEpisode', id: string, ref: string, title: string | null, number: number, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, season: { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | null, series: { id: string, ref: string, title: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> }, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, poster: { id: string, url: string, ref: string } | null, series: { id: string, ref: string, title: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type EpisodeFromSeriesSeasonFragment = { __typename: 'SeriesSeason', ref: string, episodes: { totalCount: number, nodes: Array<{ __typename: 'SeriesEpisode', id: string, ref: string, title: string | null, number: number, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, season: { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | null, series: { id: string, ref: string, title: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> } };

export type EpisodeFromSeriesFragment = { __typename: 'Series', specialEpisodes: { totalCount: number, nodes: Array<{ __typename: 'SeriesEpisode', id: string, ref: string, title: string | null, number: number, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, season: { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | null, series: { id: string, ref: string, title: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> } };

export type EpisodeFromSeriesNodesFragment = { __typename: 'SeriesEpisode', id: string, ref: string, title: string | null, number: number, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, season: { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | null, series: { id: string, ref: string, title: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type GetSeriesTagsQueryVariables = Exact<{
  seriesId: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
}>;


export type GetSeriesTagsQuery = { series: { id: string, tags: { nodes: Array<{ id: string, rank: number, tag: { id: string, ref: string, name: string, type: TagType, active: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }, entity: { __typename: 'Company', id: string, rawId: number, ref: string, name: string, title: string } | { __typename: 'Movie', id: string, rawId: number, ref: string, title: string } | { __typename: 'News', id: string, rawId: number, ref: string, title: string } | { __typename: 'Person', id: string, rawId: number, ref: string, firstName: string | null, lastName: string | null } | { __typename: 'SeriesEpisode', id: string, rawId: number, ref: string, episodeTitle: string | null } | { __typename: 'SeriesSeason', id: string, rawId: number, ref: string, number: number } | { __typename: 'Series', id: string, rawId: number, ref: string, title: string } | { __typename: 'Slide', id: string, rawId: number, ref: string, title: string } | { __typename: 'Theater', id: string, rawId: number, ref: string, name: string } }> } } | null };

export type GetSeriesTitleByRefQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetSeriesTitleByRefQuery = { entityByRef: { __typename: 'User' } | { __typename: 'Locale' } | { __typename: 'Author' } | { __typename: 'SocialUser' } | { __typename: 'Image' } | { __typename: 'Movie' } | { __typename: 'ImageCategory' } | { __typename: 'Series', id: string, title: string } | { __typename: 'Company' } | { __typename: 'CompanyStaff' } | { __typename: 'News' } | { __typename: 'VideoLegacy' } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' } | { __typename: 'Certificate' } | { __typename: 'Person' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | { __typename: 'Slide' } | { __typename: 'Carousel' } | { __typename: 'Theater' } | { __typename: 'Screen' } | { __typename: 'FestivalAward' } | { __typename: 'FestivalSelection' } | { __typename: 'FestivalCompetition' } | { __typename: 'FestivalEditionCompetition' } | { __typename: 'FestivalJury' } | { __typename: 'TheaterEvent' } | { __typename: 'Widget' } | { __typename: 'VideoB2B' } | null };

export type SearchSeriesSeasonQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  brandId: Scalars['ID']['input'];
  includeBrandData: Scalars['Boolean']['input'];
  entityType?: InputMaybe<Array<SearchableEntityType> | SearchableEntityType>;
  options?: InputMaybe<SearchOptionsInput>;
}>;


export type SearchSeriesSeasonQuery = { searchEntities: { totalCount: number, nodes: Array<{ __typename: 'Movie' } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'Slide' } | { __typename: 'Company' } | { __typename: 'CompanyStaff' } | { __typename: 'Festival' } | { __typename: 'News' } | { __typename: 'Person' } | { __typename: 'SeriesEpisode', id: string, ref: string, number: number, episodeTitle: string | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string }, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, season: { __typename: 'SeriesSeason', id: string, ref: string, number: number } | null, brandData?: { title: string | null } | null } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Theater' } | { __typename: 'VideoLegacy' }> } };

export type GetSeriesTriviasQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  brandId: Scalars['ID']['input'];
}>;


export type GetSeriesTriviasQuery = { series: { id: string, trivias: { totalCount: number, nodes: Array<{ id: string, ref: string, rank: number, trivia: { __typename: 'Trivia', id: string, ref: string, active: boolean, title: string, body: string | object[] | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, relatedEntities: Array<{ __typename: 'Movie', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | { __typename: 'SeriesEpisode', ref: string, id: string, number: number, series: { ref: string, id: string, title: string }, season: { ref: string } | null } | { __typename: 'Person', ref: string, id: string, lastName: string | null, firstName: string | null }> } }> } } | null };

export type UpdateEpisodeReleaseMutationVariables = Exact<{
  input: UpdateReleaseInput;
}>;


export type UpdateEpisodeReleaseMutation = { updateRelease: { id: string, ref: string, type: ReleaseType | null, flags: Array<ReleaseFlag>, releasedAt: string | null, releasedAtTime: string | null, unreleasedAt: string | null, notReleasedYet: boolean, techInfo: string | null, limitedCompany: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, distributors: Array<{ __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }> } | null };

export type UpdateSeriesSeasonBrandDataMutationVariables = Exact<{
  input: UpdateSeriesSeasonBrandDataInput;
}>;


export type UpdateSeriesSeasonBrandDataMutation = { updateSeriesSeasonBrandData: { id: string, synopsis: string | object[] | null, poster: { id: string, url: string } | null, ruling: { hasRating: boolean, atRisk: boolean, hasWarningMessage: boolean, hasMandatoryReview: boolean } } | null };

export type UpdateSeriesEpisodeBrandDataMutationVariables = Exact<{
  input: UpdateSeriesEpisodeBrandDataInput;
}>;


export type UpdateSeriesEpisodeBrandDataMutation = { updateSeriesEpisodeBrandData: { synopsis: string | object[] | null, title: string | null, ruling: { hasRating: boolean, atRisk: boolean, hasWarningMessage: boolean, hasMandatoryReview: boolean } } | null };

export type UpdateSeasonReleaseMutationVariables = Exact<{
  input: UpdateReleaseInput;
}>;


export type UpdateSeasonReleaseMutation = { updateRelease: { id: string, type: ReleaseType | null, flags: Array<ReleaseFlag>, releasedAt: string | null, releasedAtTime: string | null, unreleasedAt: string | null, notReleasedYet: boolean, techInfo: string | null, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null, limitedCompany: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, distributors: Array<{ __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }> } | null };

export type UpdateSeriesSeasonMutationVariables = Exact<{
  input: UpdateSeriesSeasonInput;
}>;


export type UpdateSeriesSeasonMutation = { updateSeriesSeason: { id: string, ref: string, number: number, originalPremiere: string | null, originalFinale: string | null, status: SeriesStatus | null, metadata: { createdAt: string, updatedAt: string, origin: string | null, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, poster: { id: string, url: string, ref: string } | null, series: { id: string, ref: string, title: string } } | null };

export type UpdateSeriesAdditionalInfoMutationVariables = Exact<{
  input: UpdateSeriesInput;
}>;


export type UpdateSeriesAdditionalInfoMutation = { updateSeries: { id: string, baseRuntime: number | null, genres: Array<Genre>, originalPremiere: string | null, originalFinale: string | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, countries: Array<{ id: string, name: string }>, premiereChannel: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null } | null };

export type UpdateSeriesReleaseMutationVariables = Exact<{
  input: UpdateReleaseInput;
}>;


export type UpdateSeriesReleaseMutation = { updateRelease: { id: string, type: ReleaseType | null, flags: Array<ReleaseFlag>, releasedAt: string | null, releasedAtTime: string | null, unreleasedAt: string | null, notReleasedYet: boolean, advisory: string | null, techInfo: string | null, limitedCompany: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, distributors: Array<{ __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }>, certificate: { id: string, ref: string, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null } | null } | null };

export type UpdateSeriesBrandedDataMutationVariables = Exact<{
  input: UpdateSeriesBrandDataInput;
}>;


export type UpdateSeriesBrandedDataMutation = { updateSeriesBrandData: { id: string, title: string | null, keywords: Array<string>, synopsis: string | object[] | null, synopsisShort: string | null, poster: { id: string, url: string } | null, ruling: { hasRating: boolean, atRisk: boolean, hasWarningMessage: boolean, hasMandatoryReview: boolean } } | null };

export type UpdateSeriesEpisodeMutationVariables = Exact<{
  input: UpdateSeriesEpisodeInput;
}>;


export type UpdateSeriesEpisodeMutation = { updateSeriesEpisode: { __typename: 'SeriesEpisode', id: string, ref: string, title: string | null, number: number, metadata: { createdAt: string, updatedAt: string, origin: string | null, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, season: { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | null, series: { id: string, ref: string, title: string } } | null };

export type UpdateSeriesMutationVariables = Exact<{
  input: UpdateSeriesInput;
}>;


export type UpdateSeriesMutation = { updateSeries: { id: string, ref: string, title: string, type: SeriesType | null, status: SeriesStatus | null, keywords: Array<string>, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, credits: { nodes: Array<{ person: { ref: string, firstName: string | null, lastName: string | null } | null }> }, poster: { id: string, url: string, ref: string } | null } | null };

export type BrandOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type BrandOptionsQuery = { brands: Array<{ __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }> };

export type AddCompanyToEntityMutationVariables = Exact<{
  input: AddCompanyToEntityInput;
}>;


export type AddCompanyToEntityMutation = { addCompanyToEntity: { id: string } | null };

export type AddActorToEntityMutationVariables = Exact<{
  input: AddActorToEntityInput;
}>;


export type AddActorToEntityMutation = { addActorToEntity: { id: string } | null };

export type AddCreditsToEntityMutationVariables = Exact<{
  input: AddCreditsToEntityInput;
}>;


export type AddCreditsToEntityMutation = { addCreditsToEntity: Array<{ id: string }> };

export type AddEntityToTagMutationVariables = Exact<{
  input: AddEntityToTagInput;
}>;


export type AddEntityToTagMutation = { addEntityToTag: { id: string, rank: number, tag: { id: string, ref: string, name: string, type: TagType, active: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }, entity: { __typename: 'Company', id: string, rawId: number, ref: string, name: string, title: string } | { __typename: 'Movie', id: string, rawId: number, ref: string, title: string } | { __typename: 'News', id: string, rawId: number, ref: string, title: string } | { __typename: 'Person', id: string, rawId: number, ref: string, firstName: string | null, lastName: string | null } | { __typename: 'SeriesEpisode', id: string, rawId: number, ref: string, episodeTitle: string | null } | { __typename: 'SeriesSeason', id: string, rawId: number, ref: string, number: number } | { __typename: 'Series', id: string, rawId: number, ref: string, title: string } | { __typename: 'Slide', id: string, rawId: number, ref: string, title: string } | { __typename: 'Theater', id: string, rawId: number, ref: string, name: string } } | null };

export type AddTriviaToEntityMutationVariables = Exact<{
  input: AddTriviaToEntityInput;
}>;


export type AddTriviaToEntityMutation = { addTriviaToEntity: { id: string, ref: string, rank: number, trivia: { __typename: 'Trivia', id: string, ref: string, active: boolean, title: string, body: string | object[] | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, relatedEntities: Array<{ __typename: 'Movie', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | { __typename: 'SeriesEpisode', ref: string, id: string, number: number, series: { ref: string, id: string, title: string }, season: { ref: string } | null } | { __typename: 'Person', ref: string, id: string, lastName: string | null, firstName: string | null }> } } | null };

export type AddCreditToEntityMutationVariables = Exact<{
  input: AddCreditToEntityInput;
}>;


export type AddCreditToEntityMutation = { addCreditToEntity: { id: string } | null };

export type AddLocalizedActorToEntityMutationVariables = Exact<{
  input: AddLocalizedActorToEntityInput;
}>;


export type AddLocalizedActorToEntityMutation = { addLocalizedActorToEntity: { id: string } | null };

export type AllowedBrandOptionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AllowedBrandOptionsQuery = { user: { id: string, allowedBrands: Array<{ __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }> } | null };

export type AllowedViewerBrandOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllowedViewerBrandOptionsQuery = { brands: Array<{ __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }>, viewer: { id: string, allowedBrands: Array<{ __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }> } };

export type AllowedCountryOptionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AllowedCountryOptionsQuery = { user: { allowedCountries: Array<{ __typename: 'Country', id: string, ref: string, name: string, alpha2: string }> } | null };

export type AllowedViewerCountryOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllowedViewerCountryOptionsQuery = { viewer: { id: string, allowedCountries: Array<{ __typename: 'Country', id: string, ref: string, name: string, alpha2: string }> } };

export type AllowedLocaleOptionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AllowedLocaleOptionsQuery = { user: { allowedLocales: Array<{ id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }> } | null };

export type AllowedViewerLocaleOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllowedViewerLocaleOptionsQuery = { viewer: { id: string, allowedLocales: Array<{ id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }> } };

export type CancelImportMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type CancelImportMutation = { cancelImport: string };

export type CountriesWithBrandsOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesWithBrandsOptionsQuery = { countries: { nodes: Array<{ __typename: 'Country', id: string, ref: string, name: string, alpha2: string }> } };

export type CountryOptionsQueryVariables = Exact<{
  linkedToBrand?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CountryOptionsQuery = { countries: { nodes: Array<{ __typename: 'Country', id: string, ref: string, name: string, alpha2: string }> } };

export type CreateCopyrightMutationVariables = Exact<{
  input: CreateCopyrightInput;
}>;


export type CreateCopyrightMutation = { createCopyright: { id: string, name: string } | null };

export type CreateEntityPublicationMutationVariables = Exact<{
  input: CreateEntityPublicationInput;
}>;


export type CreateEntityPublicationMutation = { createEntityPublication: { id: string, publicationStatus: EntityPublicationStatus, publicationDate: string | null, isUpdatedWhenPublished: boolean, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, publications: Array<{ startsAt: string, endsAt: string | null, status: EntityPublicationStatus }> } | { id: string, publicationStatus: EntityPublicationStatus, publicationDate: string | null, isUpdatedWhenPublished: boolean, publications: Array<{ startsAt: string, endsAt: string | null, status: EntityPublicationStatus }> } | null };

export type CreateImageMutationVariables = Exact<{
  input: CreateImageInput;
}>;


export type CreateImageMutation = { createImage: { __typename: 'Image', id: string, url: string, ref: string } | { __typename: 'DuplicatedImage', image: { id: string, url: string, ref: string } } | null };

export type CreatedImageFragment = { id: string, url: string, ref: string };

export type CreateLocalCertificateMutationVariables = Exact<{
  input: CreateLocalCertificateInput;
}>;


export type CreateLocalCertificateMutation = { createLocalCertificate: { advisory: string | null, localization: { id: string, name: string, type: LocalizationKind, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null }, certificate: { id: string, label: string | null } } | null };

export type DeleteEntityCompanyMutationVariables = Exact<{
  input: DeleteEntityCompanyInput;
}>;


export type DeleteEntityCompanyMutation = { deleteEntityCompany: { id: string } | null };

export type DeleteBrandEntityClubMutationVariables = Exact<{
  input: DeleteBrandEntityClubInput;
}>;


export type DeleteBrandEntityClubMutation = { deleteBrandEntityClub: { __typename: 'BrandEntityClub', id: string } | null };

export type DeleteEntityCreditMutationVariables = Exact<{
  input: DeleteCreditInput;
}>;


export type DeleteEntityCreditMutation = { deleteCredit: { id: string } | null };

export type DeleteEntityLocalCreditMutationVariables = Exact<{
  input: DeleteLocalCreditInput;
}>;


export type DeleteEntityLocalCreditMutation = { deleteLocalCredit: { id: string } };

export type DeleteEntityPublicationMutationVariables = Exact<{
  input: DeleteEntityPublicationInput;
}>;


export type DeleteEntityPublicationMutation = { deleteEntityPublication: { id: string, publicationStatus: EntityPublicationStatus, publicationDate: string | null, isUpdatedWhenPublished: boolean, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, publications: Array<{ startsAt: string, endsAt: string | null, status: EntityPublicationStatus }> } | { id: string, publicationStatus: EntityPublicationStatus, publicationDate: string | null, isUpdatedWhenPublished: boolean, publications: Array<{ startsAt: string, endsAt: string | null, status: EntityPublicationStatus }> } | null };

export type DeleteEntityFromTagMutationVariables = Exact<{
  input: DeleteEntityFromTagInput;
}>;


export type DeleteEntityFromTagMutation = { deleteEntityFromTag: { id: string, rank: number, tag: { id: string, ref: string, name: string, type: TagType, active: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }, entity: { __typename: 'Company', id: string, rawId: number, ref: string, name: string, title: string } | { __typename: 'Movie', id: string, rawId: number, ref: string, title: string } | { __typename: 'News', id: string, rawId: number, ref: string, title: string } | { __typename: 'Person', id: string, rawId: number, ref: string, firstName: string | null, lastName: string | null } | { __typename: 'SeriesEpisode', id: string, rawId: number, ref: string, episodeTitle: string | null } | { __typename: 'SeriesSeason', id: string, rawId: number, ref: string, number: number } | { __typename: 'Series', id: string, rawId: number, ref: string, title: string } | { __typename: 'Slide', id: string, rawId: number, ref: string, title: string } | { __typename: 'Theater', id: string, rawId: number, ref: string, name: string } } | null };

export type DeleteTriviaFromEntityMutationVariables = Exact<{
  input: DeleteTriviaFromEntityInput;
}>;


export type DeleteTriviaFromEntityMutation = { deleteTriviaFromEntity: { id: string, ref: string, rank: number, trivia: { __typename: 'Trivia', id: string, ref: string, active: boolean, title: string, body: string | object[] | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, relatedEntities: Array<{ __typename: 'Movie', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | { __typename: 'SeriesEpisode', ref: string, id: string, number: number, series: { ref: string, id: string, title: string }, season: { ref: string } | null } | { __typename: 'Person', ref: string, id: string, lastName: string | null, firstName: string | null }> } } | null };

export type DeleteEntityReleaseMutationVariables = Exact<{
  input: DeleteReleaseFromEntityInput;
}>;


export type DeleteEntityReleaseMutation = { deleteReleaseFromEntity: { id: string } | null };

export type DeleteLocalizedCertificateMutationVariables = Exact<{
  input: DeleteLocalCertificateInput;
}>;


export type DeleteLocalizedCertificateMutation = { deleteLocalCertificate: { advisory: string | null, localization: { id: string, name: string, type: LocalizationKind, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null }, certificate: { id: string, ref: string, label: string | null, code: string | null } } | null };

export type DeletePersonCreditsImportReportMutationVariables = Exact<{
  input: DeletePersonCreditsImportReportInput;
}>;


export type DeletePersonCreditsImportReportMutation = { deletePersonCreditsImportReport: string };

export type GetCertificatesQueryVariables = Exact<{
  scope?: InputMaybe<CertificateScope>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  limitedLocalizationId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCertificatesQuery = { certificates: { nodes: Array<{ id: string, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, limitedLocalization: { id: string, name: string, type: LocalizationKind } | null }> } };

export type CreateEntityConnectionMutationVariables = Exact<{
  input: LinkEntityToEntityInput;
}>;


export type CreateEntityConnectionMutation = { linkEntityToEntity: { linkType: EntityLinkType, rank: number, source: { __typename: 'User', id: string } | { __typename: 'SocialUser', id: string } | { __typename: 'Image', id: string } | { __typename: 'Movie', ref: string, title: string, id: string } | { __typename: 'Series', ref: string, title: string, id: string } | { __typename: 'Company', id: string } | { __typename: 'CompanyStaff', id: string } | { __typename: 'News', id: string } | { __typename: 'VideoLegacy', id: string } | { __typename: 'SeriesSeason', id: string } | { __typename: 'SeriesEpisode', id: string } | { __typename: 'Person', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'Slide', id: string } | { __typename: 'Theater', id: string } | { __typename: 'Screen', id: string } | { __typename: 'FestivalAward', id: string } | { __typename: 'FestivalSelection', id: string } | { __typename: 'FestivalCompetition', id: string } | { __typename: 'FestivalEditionCompetition', id: string } | { __typename: 'FestivalJury', id: string } | { __typename: 'TheaterEvent', id: string } | { __typename: 'VideoB2B', id: string }, target: { __typename: 'User', id: string } | { __typename: 'SocialUser', id: string } | { __typename: 'Image', id: string } | { __typename: 'Movie', ref: string, title: string, id: string } | { __typename: 'Series', ref: string, title: string, id: string } | { __typename: 'Company', id: string } | { __typename: 'CompanyStaff', id: string } | { __typename: 'News', id: string } | { __typename: 'VideoLegacy', id: string } | { __typename: 'SeriesSeason', id: string } | { __typename: 'SeriesEpisode', id: string } | { __typename: 'Person', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'Slide', id: string } | { __typename: 'Theater', id: string } | { __typename: 'Screen', id: string } | { __typename: 'FestivalAward', id: string } | { __typename: 'FestivalSelection', id: string } | { __typename: 'FestivalCompetition', id: string } | { __typename: 'FestivalEditionCompetition', id: string } | { __typename: 'FestivalJury', id: string } | { __typename: 'TheaterEvent', id: string } | { __typename: 'VideoB2B', id: string } } | null };

export type DeleteEntityConnectionMutationVariables = Exact<{
  input: DeleteEntityLinkInput;
}>;


export type DeleteEntityConnectionMutation = { deleteEntityLink: { linkType: EntityLinkType, rank: number, source: { __typename: 'User', id: string } | { __typename: 'SocialUser', id: string } | { __typename: 'Image', id: string } | { __typename: 'Movie', ref: string, title: string, id: string } | { __typename: 'Series', ref: string, title: string, id: string } | { __typename: 'Company', id: string } | { __typename: 'CompanyStaff', id: string } | { __typename: 'News', id: string } | { __typename: 'VideoLegacy', id: string } | { __typename: 'SeriesSeason', id: string } | { __typename: 'SeriesEpisode', id: string } | { __typename: 'Person', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'Slide', id: string } | { __typename: 'Theater', id: string } | { __typename: 'Screen', id: string } | { __typename: 'FestivalAward', id: string } | { __typename: 'FestivalSelection', id: string } | { __typename: 'FestivalCompetition', id: string } | { __typename: 'FestivalEditionCompetition', id: string } | { __typename: 'FestivalJury', id: string } | { __typename: 'TheaterEvent', id: string } | { __typename: 'VideoB2B', id: string }, target: { __typename: 'User', id: string } | { __typename: 'SocialUser', id: string } | { __typename: 'Image', id: string } | { __typename: 'Movie', ref: string, title: string, id: string } | { __typename: 'Series', ref: string, title: string, id: string } | { __typename: 'Company', id: string } | { __typename: 'CompanyStaff', id: string } | { __typename: 'News', id: string } | { __typename: 'VideoLegacy', id: string } | { __typename: 'SeriesSeason', id: string } | { __typename: 'SeriesEpisode', id: string } | { __typename: 'Person', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'Slide', id: string } | { __typename: 'Theater', id: string } | { __typename: 'Screen', id: string } | { __typename: 'FestivalAward', id: string } | { __typename: 'FestivalSelection', id: string } | { __typename: 'FestivalCompetition', id: string } | { __typename: 'FestivalEditionCompetition', id: string } | { __typename: 'FestivalJury', id: string } | { __typename: 'TheaterEvent', id: string } | { __typename: 'VideoB2B', id: string } } | null };

export type UpdateEntityConnectionMutationVariables = Exact<{
  input: UpdateEntityLinkInput;
}>;


export type UpdateEntityConnectionMutation = { updateEntityLink: { linkType: EntityLinkType, rank: number, source: { __typename: 'User', id: string } | { __typename: 'SocialUser', id: string } | { __typename: 'Image', id: string } | { __typename: 'Movie', ref: string, title: string, id: string } | { __typename: 'Series', ref: string, title: string, id: string } | { __typename: 'Company', id: string } | { __typename: 'CompanyStaff', id: string } | { __typename: 'News', id: string } | { __typename: 'VideoLegacy', id: string } | { __typename: 'SeriesSeason', id: string } | { __typename: 'SeriesEpisode', id: string } | { __typename: 'Person', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'Slide', id: string } | { __typename: 'Theater', id: string } | { __typename: 'Screen', id: string } | { __typename: 'FestivalAward', id: string } | { __typename: 'FestivalSelection', id: string } | { __typename: 'FestivalCompetition', id: string } | { __typename: 'FestivalEditionCompetition', id: string } | { __typename: 'FestivalJury', id: string } | { __typename: 'TheaterEvent', id: string } | { __typename: 'VideoB2B', id: string }, target: { __typename: 'User', id: string } | { __typename: 'SocialUser', id: string } | { __typename: 'Image', id: string } | { __typename: 'Movie', ref: string, title: string, id: string } | { __typename: 'Series', ref: string, title: string, id: string } | { __typename: 'Company', id: string } | { __typename: 'CompanyStaff', id: string } | { __typename: 'News', id: string } | { __typename: 'VideoLegacy', id: string } | { __typename: 'SeriesSeason', id: string } | { __typename: 'SeriesEpisode', id: string } | { __typename: 'Person', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'Slide', id: string } | { __typename: 'Theater', id: string } | { __typename: 'Screen', id: string } | { __typename: 'FestivalAward', id: string } | { __typename: 'FestivalSelection', id: string } | { __typename: 'FestivalCompetition', id: string } | { __typename: 'FestivalEditionCompetition', id: string } | { __typename: 'FestivalJury', id: string } | { __typename: 'TheaterEvent', id: string } | { __typename: 'VideoB2B', id: string } } | null };

export type MoveEntityConnectionMutationVariables = Exact<{
  input: MoveEntityLinkInput;
}>;


export type MoveEntityConnectionMutation = { moveEntityLink: { linkType: EntityLinkType, rank: number, source: { __typename: 'User', id: string } | { __typename: 'SocialUser', id: string } | { __typename: 'Image', id: string } | { __typename: 'Movie', ref: string, title: string, id: string } | { __typename: 'Series', ref: string, title: string, id: string } | { __typename: 'Company', id: string } | { __typename: 'CompanyStaff', id: string } | { __typename: 'News', id: string } | { __typename: 'VideoLegacy', id: string } | { __typename: 'SeriesSeason', id: string } | { __typename: 'SeriesEpisode', id: string } | { __typename: 'Person', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'Slide', id: string } | { __typename: 'Theater', id: string } | { __typename: 'Screen', id: string } | { __typename: 'FestivalAward', id: string } | { __typename: 'FestivalSelection', id: string } | { __typename: 'FestivalCompetition', id: string } | { __typename: 'FestivalEditionCompetition', id: string } | { __typename: 'FestivalJury', id: string } | { __typename: 'TheaterEvent', id: string } | { __typename: 'VideoB2B', id: string }, target: { __typename: 'User', id: string } | { __typename: 'SocialUser', id: string } | { __typename: 'Image', id: string } | { __typename: 'Movie', ref: string, title: string, id: string } | { __typename: 'Series', ref: string, title: string, id: string } | { __typename: 'Company', id: string } | { __typename: 'CompanyStaff', id: string } | { __typename: 'News', id: string } | { __typename: 'VideoLegacy', id: string } | { __typename: 'SeriesSeason', id: string } | { __typename: 'SeriesEpisode', id: string } | { __typename: 'Person', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'Slide', id: string } | { __typename: 'Theater', id: string } | { __typename: 'Screen', id: string } | { __typename: 'FestivalAward', id: string } | { __typename: 'FestivalSelection', id: string } | { __typename: 'FestivalCompetition', id: string } | { __typename: 'FestivalEditionCompetition', id: string } | { __typename: 'FestivalJury', id: string } | { __typename: 'TheaterEvent', id: string } | { __typename: 'VideoB2B', id: string } } | null };

export type GetEntityConnectionListQueryVariables = Exact<{
  entityId: Scalars['ID']['input'];
  linkType?: InputMaybe<EntityLinkType>;
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  orderBy?: InputMaybe<EntityLinkOrder>;
}>;


export type GetEntityConnectionListQuery = { linkedEntities: { totalCount: number, nodes: Array<{ linkType: EntityLinkType, rank: number, source: { __typename: 'User', id: string } | { __typename: 'SocialUser', id: string } | { __typename: 'Image', id: string } | { __typename: 'Movie', ref: string, title: string, id: string } | { __typename: 'Series', ref: string, title: string, id: string } | { __typename: 'Company', id: string } | { __typename: 'CompanyStaff', id: string } | { __typename: 'News', id: string } | { __typename: 'VideoLegacy', id: string } | { __typename: 'SeriesSeason', id: string } | { __typename: 'SeriesEpisode', id: string } | { __typename: 'Person', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'Slide', id: string } | { __typename: 'Theater', id: string } | { __typename: 'Screen', id: string } | { __typename: 'FestivalAward', id: string } | { __typename: 'FestivalSelection', id: string } | { __typename: 'FestivalCompetition', id: string } | { __typename: 'FestivalEditionCompetition', id: string } | { __typename: 'FestivalJury', id: string } | { __typename: 'TheaterEvent', id: string } | { __typename: 'VideoB2B', id: string }, target: { __typename: 'User', id: string } | { __typename: 'SocialUser', id: string } | { __typename: 'Image', id: string } | { __typename: 'Movie', ref: string, title: string, id: string } | { __typename: 'Series', ref: string, title: string, id: string } | { __typename: 'Company', id: string } | { __typename: 'CompanyStaff', id: string } | { __typename: 'News', id: string } | { __typename: 'VideoLegacy', id: string } | { __typename: 'SeriesSeason', id: string } | { __typename: 'SeriesEpisode', id: string } | { __typename: 'Person', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'Slide', id: string } | { __typename: 'Theater', id: string } | { __typename: 'Screen', id: string } | { __typename: 'FestivalAward', id: string } | { __typename: 'FestivalSelection', id: string } | { __typename: 'FestivalCompetition', id: string } | { __typename: 'FestivalEditionCompetition', id: string } | { __typename: 'FestivalJury', id: string } | { __typename: 'TheaterEvent', id: string } | { __typename: 'VideoB2B', id: string } }> } };

export type ConnectionIdentityFragment = { linkType: EntityLinkType, rank: number, source: { __typename: 'User', id: string } | { __typename: 'SocialUser', id: string } | { __typename: 'Image', id: string } | { __typename: 'Movie', ref: string, title: string, id: string } | { __typename: 'Series', ref: string, title: string, id: string } | { __typename: 'Company', id: string } | { __typename: 'CompanyStaff', id: string } | { __typename: 'News', id: string } | { __typename: 'VideoLegacy', id: string } | { __typename: 'SeriesSeason', id: string } | { __typename: 'SeriesEpisode', id: string } | { __typename: 'Person', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'Slide', id: string } | { __typename: 'Theater', id: string } | { __typename: 'Screen', id: string } | { __typename: 'FestivalAward', id: string } | { __typename: 'FestivalSelection', id: string } | { __typename: 'FestivalCompetition', id: string } | { __typename: 'FestivalEditionCompetition', id: string } | { __typename: 'FestivalJury', id: string } | { __typename: 'TheaterEvent', id: string } | { __typename: 'VideoB2B', id: string }, target: { __typename: 'User', id: string } | { __typename: 'SocialUser', id: string } | { __typename: 'Image', id: string } | { __typename: 'Movie', ref: string, title: string, id: string } | { __typename: 'Series', ref: string, title: string, id: string } | { __typename: 'Company', id: string } | { __typename: 'CompanyStaff', id: string } | { __typename: 'News', id: string } | { __typename: 'VideoLegacy', id: string } | { __typename: 'SeriesSeason', id: string } | { __typename: 'SeriesEpisode', id: string } | { __typename: 'Person', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'Slide', id: string } | { __typename: 'Theater', id: string } | { __typename: 'Screen', id: string } | { __typename: 'FestivalAward', id: string } | { __typename: 'FestivalSelection', id: string } | { __typename: 'FestivalCompetition', id: string } | { __typename: 'FestivalEditionCompetition', id: string } | { __typename: 'FestivalJury', id: string } | { __typename: 'TheaterEvent', id: string } | { __typename: 'VideoB2B', id: string } };

export type SearchCopyrightsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchCopyrightsQuery = { copyrights: Array<{ id: string, name: string }> };

export type GetEntityBrandDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEntityBrandDataQuery = { entity: { __typename: 'User' } | { __typename: 'SocialUser' } | { __typename: 'Image', activeOnBrands: Array<{ ref: string }> } | { __typename: 'Movie', activeOnBrands: Array<{ ref: string }> } | { __typename: 'Series', activeOnBrands: Array<{ ref: string }> } | { __typename: 'Company', activeOnBrands: Array<{ ref: string }> } | { __typename: 'CompanyStaff' } | { __typename: 'News' } | { __typename: 'VideoLegacy' } | { __typename: 'SeriesSeason', activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesEpisode', activeOnBrands: Array<{ ref: string }> } | { __typename: 'Person', activeOnBrands: Array<{ ref: string }> } | { __typename: 'Festival', activeOnBrands: Array<{ ref: string }> } | { __typename: 'FestivalEdition' } | { __typename: 'Slide' } | { __typename: 'Theater', activeOnBrands: Array<{ ref: string }> } | { __typename: 'Screen' } | { __typename: 'FestivalAward' } | { __typename: 'FestivalSelection' } | { __typename: 'FestivalCompetition' } | { __typename: 'FestivalEditionCompetition' } | { __typename: 'FestivalJury' } | { __typename: 'TheaterEvent' } | { __typename: 'VideoB2B' } | null };

export type GetCreditQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCreditQuery = { credit: { id: string, role: string | null, person: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | null, voice: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | null, localeData: { totalCount: number, nodes: Array<{ id: string, role: string | null, voice: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null } }> } } | null };

export type MainCreditFragment = { id: string, role: string | null, person: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | null, voice: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | null };

export type LocalCastingFragment = { id: string, localeData: { totalCount: number, nodes: Array<{ id: string, role: string | null, voice: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null } }> } };

export type LocalCastingDetailFragment = { id: string, role: string | null, voice: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null } };

export type GetEntityClosestReleaseQueryVariables = Exact<{
  entityId: Scalars['ID']['input'];
  countryId?: InputMaybe<Scalars['ID']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  referenceDateTime?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetEntityClosestReleaseQuery = { entity: { __typename: 'User' } | { __typename: 'SocialUser' } | { __typename: 'Image' } | { __typename: 'Movie', id: string, closestRelease: { releasedAt: string | null } | null } | { __typename: 'Series' } | { __typename: 'Company' } | { __typename: 'CompanyStaff' } | { __typename: 'News' } | { __typename: 'VideoLegacy' } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' } | { __typename: 'Person' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | { __typename: 'Slide' } | { __typename: 'Theater' } | { __typename: 'Screen' } | { __typename: 'FestivalAward' } | { __typename: 'FestivalSelection' } | { __typename: 'FestivalCompetition' } | { __typename: 'FestivalEditionCompetition' } | { __typename: 'FestivalJury' } | { __typename: 'TheaterEvent' } | { __typename: 'VideoB2B' } | null };

export type GetEntityImageListQueryVariables = Exact<{
  entityId: Scalars['ID']['input'];
  imageId?: InputMaybe<Scalars['String']['input']>;
  brandId: Scalars['ID']['input'];
  localeId: Scalars['ID']['input'];
  withMainPoster?: InputMaybe<Scalars['Boolean']['input']>;
  withMainBrandedPoster?: InputMaybe<Scalars['Boolean']['input']>;
  withMainLocalizedPoster?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  type?: InputMaybe<ImageType>;
  orderBy?: InputMaybe<Array<InputMaybe<EntityHasImageOrder>> | InputMaybe<EntityHasImageOrder>>;
  mainPoster?: InputMaybe<Scalars['Boolean']['input']>;
  mainBrandPosters?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  mainLocalizedPosters?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type GetEntityImageListQuery = { imagesByEntity: { totalCount: number, maxRank: number, nodes: Array<{ rank: number, image: { __typename: 'Image', title: string | null, isMainPosterOfEntity?: boolean, isMainBrandedPoster?: boolean, isMainLocalizedPoster?: boolean, hasLocalizedData: boolean, id: string, url: string, type: ImageType | null, ref: string, b2bAvailable: boolean, activeOnBrands: Array<{ ref: string }> } }> } };

export type EntityImageItemFragment = { rank: number, image: { __typename: 'Image', title: string | null, isMainPosterOfEntity?: boolean, isMainBrandedPoster?: boolean, isMainLocalizedPoster?: boolean, hasLocalizedData: boolean, id: string, url: string, type: ImageType | null, ref: string, b2bAvailable: boolean, activeOnBrands: Array<{ ref: string }> } };

export type GetEntityReleasesQueryVariables = Exact<{
  entityId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  type?: InputMaybe<ReleaseType>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetEntityReleasesQuery = { releases: { totalCount: number, nodes: Array<{ id: string, ref: string, releasedAt: string | null, type: ReleaseType | null, flags: Array<ReleaseFlag>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, limitedLocalization: { id: string, type: LocalizationKind, name: string, code: string | null } | null, certificate: { id: string, label: string | null, code: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, limitedLocalization: { id: string, type: LocalizationKind, name: string, code: string | null } | null } | null, limitedCompany: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null, distributors: Array<{ __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }> }> } };

export type EntityReleaseListItemFragment = { id: string, ref: string, releasedAt: string | null, type: ReleaseType | null, flags: Array<ReleaseFlag>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, limitedLocalization: { id: string, type: LocalizationKind, name: string, code: string | null } | null, certificate: { id: string, label: string | null, code: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, limitedLocalization: { id: string, type: LocalizationKind, name: string, code: string | null } | null } | null, limitedCompany: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null, distributors: Array<{ __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }> };

export type GetEntityReleaseVisaNumberQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
  countryId: Scalars['ID']['input'];
  releaseType: ReleaseType;
}>;


export type GetEntityReleaseVisaNumberQuery = { entityByRef: { __typename: 'User' } | { __typename: 'Locale' } | { __typename: 'Author' } | { __typename: 'SocialUser' } | { __typename: 'Image' } | { __typename: 'Movie', id: string, closestRelease: { id: string, visaNumber: string | null } | null } | { __typename: 'ImageCategory' } | { __typename: 'Series' } | { __typename: 'Company' } | { __typename: 'CompanyStaff' } | { __typename: 'News' } | { __typename: 'VideoLegacy' } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' } | { __typename: 'Certificate' } | { __typename: 'Person' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | { __typename: 'Slide' } | { __typename: 'Carousel' } | { __typename: 'Theater' } | { __typename: 'Screen' } | { __typename: 'FestivalAward' } | { __typename: 'FestivalSelection' } | { __typename: 'FestivalCompetition' } | { __typename: 'FestivalEditionCompetition' } | { __typename: 'FestivalJury' } | { __typename: 'TheaterEvent' } | { __typename: 'Widget' } | { __typename: 'VideoB2B' } | null };

export type GetEntitySeoDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
}>;


export type GetEntitySeoDataQuery = { entity: { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, seoData: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null } | { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, seoData: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null } | { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, seoData: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null } | { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, seoData: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null } | { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, seoData: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null } | { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, seoData: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null } | { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, seoData: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null } | {} | null };

export type GetVideosByEntityQueryVariables = Exact<{
  type?: InputMaybe<VideoType>;
  entityId: Scalars['ID']['input'];
  brandId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetVideosByEntityQuery = { videosLegacyByEntity: { totalCount: number, nodes: Array<{ rank: number, video: { __typename: 'VideoLegacy', id: string, ref: string, title: string | null, generatedTitle: string | null, active: boolean, language: Language | null, description: string | null, startsAt: string | null, endsAt: string | null, type: VideoType, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, relatedEntities: Array<{ __typename: 'Movie', id: string, ref: string, movieTitle: string } | { __typename: 'Series', id: string, ref: string, seriesTitle: string } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | { __typename: 'SeriesEpisode', id: string, ref: string, number: number, title: string | null, series: { id: string, ref: string, title: string }, season: { id: string, ref: string, number: number } | null } | { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, formalName: string | null } | { __typename: 'Festival', id: string, ref: string, festivalName: string } | { __typename: 'FestivalEdition', id: string, ref: string, editionNumber: number | null, year: number, editionName: string | null, festival: { id: string, ref: string, festivalName: string } }>, duration: { hours: number, minutes: number, seconds: number } | null, snapshot: { path: string, url: string } | null } | { __typename: 'VideoB2B', id: string, ref: string, title: string | null, generatedTitle: string | null, active: boolean, language: Language | null, description: string | null, startsAt: string | null, endsAt: string | null, type: VideoType, relatedEntities: Array<{ __typename: 'Movie', id: string, ref: string, movieTitle: string } | { __typename: 'Series', id: string, ref: string, seriesTitle: string } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | { __typename: 'SeriesEpisode', id: string, ref: string, number: number, title: string | null, series: { id: string, ref: string, title: string }, season: { id: string, ref: string, number: number } | null } | { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, formalName: string | null } | { __typename: 'Festival', id: string, ref: string, festivalName: string } | { __typename: 'FestivalEdition', id: string, ref: string, editionNumber: number | null, year: number, editionName: string | null, festival: { id: string, ref: string, festivalName: string } }>, duration: { hours: number, minutes: number, seconds: number } | null, snapshot: { path: string, url: string } | null } }> } };

export type GetVideosB2CByEntityQueryVariables = Exact<{
  entityId: Scalars['ID']['input'];
  type?: InputMaybe<VideoType>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<VideoOrder>;
}>;


export type GetVideosB2CByEntityQuery = { videosLegacyByEntity: { totalCount: number, nodes: Array<{ video: { __typename: 'VideoLegacy', rawId: number, universe: VideoUniverse | null, id: string, ref: string, title: string | null, generatedTitle: string | null, active: boolean, type: VideoType, description: string | null, copyrightName: string | null, startsAt: string | null, endsAt: string | null, embedCode: string | null, restrictions: Array<RestrictionType>, language: Language | null, subtitle: Language | null, previewVideoFile: { cdnUrl: string | null } | null, brand: { __typename: 'Brand', language: Language | null, id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, certificate: { __typename: 'Certificate', id: string, ref: string, rank: number, active: boolean, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null } | null, alt: { videoEncoder: Array<{ status: VideoEncoderStatusEnum, createdAt: string, updatedAt: string }> | null } | null, snapshot: { __typename: 'Image', id: string, title: string | null, path: string, url: string } | null, duration: { hours: number, minutes: number, seconds: number } | null, copyrights: Array<{ id: string, name: string }> | null, metadata: { updatedAt: string }, rankRelatedEntities: Array<{ rank: number, entity: { __typename: 'Movie', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | { __typename: 'SeriesEpisode', id: string, ref: string, number: number, series: { id: string, ref: string, title: string }, season: { id: string, ref: string, number: number } | null } | { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } }> } | { __typename: 'VideoB2B', rawId: number, id: string, ref: string, title: string | null, generatedTitle: string | null, active: boolean, type: VideoType, description: string | null, copyrightName: string | null, startsAt: string | null, endsAt: string | null, embedCode: string | null, restrictions: Array<RestrictionType>, language: Language | null, subtitle: Language | null, previewVideoFile: { cdnUrl: string | null } | null, certificate: { __typename: 'Certificate', id: string, ref: string, rank: number, active: boolean, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null } | null, snapshot: { __typename: 'Image', id: string, title: string | null, path: string, url: string } | null, duration: { hours: number, minutes: number, seconds: number } | null, copyrights: Array<{ id: string, name: string }> | null, metadata: { updatedAt: string }, rankRelatedEntities: Array<{ rank: number, entity: { __typename: 'Movie', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | { __typename: 'SeriesEpisode', id: string, ref: string, number: number, series: { id: string, ref: string, title: string }, season: { id: string, ref: string, number: number } | null } | { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } }> } }> } };

export type GetVideosB2BByEntityQueryVariables = Exact<{
  entityId: Scalars['ID']['input'];
  type?: InputMaybe<VideoType>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<VideoOrder>;
}>;


export type GetVideosB2BByEntityQuery = { videosB2BByEntity: { totalCount: number, nodes: Array<{ video: { __typename: 'VideoLegacy', rawId: number, universe: VideoUniverse | null, id: string, ref: string, title: string | null, generatedTitle: string | null, active: boolean, type: VideoType, description: string | null, copyrightName: string | null, startsAt: string | null, endsAt: string | null, embedCode: string | null, restrictions: Array<RestrictionType>, language: Language | null, subtitle: Language | null, previewVideoFile: { cdnUrl: string | null } | null, brand: { __typename: 'Brand', language: Language | null, id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, certificate: { __typename: 'Certificate', id: string, ref: string, rank: number, active: boolean, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null } | null, alt: { videoEncoder: Array<{ status: VideoEncoderStatusEnum, createdAt: string, updatedAt: string }> | null } | null, snapshot: { __typename: 'Image', id: string, title: string | null, path: string, url: string } | null, duration: { hours: number, minutes: number, seconds: number } | null, copyrights: Array<{ id: string, name: string }> | null, metadata: { updatedAt: string }, rankRelatedEntities: Array<{ rank: number, entity: { __typename: 'Movie', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | { __typename: 'SeriesEpisode', id: string, ref: string, number: number, series: { id: string, ref: string, title: string }, season: { id: string, ref: string, number: number } | null } | { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } }> } | { __typename: 'VideoB2B', rawId: number, id: string, ref: string, title: string | null, generatedTitle: string | null, active: boolean, type: VideoType, description: string | null, copyrightName: string | null, startsAt: string | null, endsAt: string | null, embedCode: string | null, restrictions: Array<RestrictionType>, language: Language | null, subtitle: Language | null, previewVideoFile: { cdnUrl: string | null } | null, certificate: { __typename: 'Certificate', id: string, ref: string, rank: number, active: boolean, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null } | null, snapshot: { __typename: 'Image', id: string, title: string | null, path: string, url: string } | null, duration: { hours: number, minutes: number, seconds: number } | null, copyrights: Array<{ id: string, name: string }> | null, metadata: { updatedAt: string }, rankRelatedEntities: Array<{ rank: number, entity: { __typename: 'Movie', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | { __typename: 'SeriesEpisode', id: string, ref: string, number: number, series: { id: string, ref: string, title: string }, season: { id: string, ref: string, number: number } | null } | { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } }> } }> } };

export type GetLocalCreditQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetLocalCreditQuery = { localCredit: { id: string, role: string | null, voice: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null } } | null };

export type GetLocalesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocalesQuery = { locales: Array<{ id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }> };

export type GetLocalizedCertificatesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetLocalizedCertificatesQuery = { release: { localCertificates: Array<{ advisory: string | null, localization: { id: string, name: string, type: LocalizationKind, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null }, certificate: { id: string, ref: string, label: string | null, code: string | null } }> } | null };

export type GetUserOptionsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserOptionsQuery = { users: { nodes: Array<{ id: string, name: string }> } };

export type GetRelatedProductsQueryVariables = Exact<{
  entityId: Scalars['ID']['input'];
  countryId: Scalars['ID']['input'];
}>;


export type GetRelatedProductsQuery = { companyProducts: Array<{ url: string, company: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }, product: { id: string, name: string, type: ProductType } }> };

export type GetPersonCreditsImportSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPersonCreditsImportSourcesQuery = { personCreditsImportSources: Array<PersonCreditsImportSource> };

export type GetClubsOptionsQueryVariables = Exact<{
  brandIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetClubsOptionsQuery = { clubs: Array<{ __typename: 'Club', id: string, name: string, code: string, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> };

export type LaunchPersonCreditsImportMutationVariables = Exact<{
  input: LaunchPersonCreditsImportInput;
}>;


export type LaunchPersonCreditsImportMutation = { launchPersonCreditsImport: { __typename: 'PersonCreditsImportReport', id: string, status: ImportWizardReportStatus, failureReason: string | null, launchedAt: string, finishedAt: string | null, source: PersonCreditsImportSource, outcome: ImportWizardOutcome | null, answeredBy: ImportWizardLevel | null, metadata: { createdBy: { id: string, name: string } | null }, counts: { linked: number, matched: number, ambiguous: number, unknown: number, extraneous: number }, stats: { durationMs: number, requests: number, bytesReceived: number, resolutionDurationMs: number, resolutionRequests: number, levels: Array<{ level: number, name: string, outcome: string, durationMs: number, requests: number, bytesReceived: number, creditsCount: number, detail: string, llmInputTokens: number | null, llm: { provider: string, model: string, inputTokens: number, outputTokens: number, durationMs: number, costUsd: number | null, error: string | null } | null }>, llm: { provider: string, model: string, inputTokens: number, outputTokens: number, durationMs: number, costUsd: number | null, error: string | null } | null }, localization: { locale: string, localeId: string, outcome: string | null, detail: string | null, durationMs: number | null, rolesAsked: number | null, rolesLocalized: number | null, llm: { provider: string, model: string, inputTokens: number, outputTokens: number, durationMs: number, costUsd: number | null, error: string | null } | null } | null, resolution: { __typename: 'PersonCreditsImportResolution', confidence: string, sourceId: string | null, source: string, detail: string, candidates: Array<{ id: string, title: string, year: number | null, kind: string | null }> } | null, entries: Array<{ __typename: 'PersonCreditsImportEntry', status: PersonCreditsImportStatus, name: string | null, category: string | null, role: string | null, localizedRole: string | null, externalPersonId: string | null, order: number | null, suggestedActivity: PersonActivity | null, gender: Gender | null, isVoice: boolean, linkKind: PersonCreditsImportLinkKind | null, linkLocale: string | null, linkedPerson: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, birthDate: string | null, deathDate: string | null, activities: Array<PersonActivity>, countries: Array<{ id: string, name: string, alpha2: string }>, poster: { id: string, path: string } | null } | null, candidates: Array<{ __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, birthDate: string | null, deathDate: string | null, activities: Array<PersonActivity>, countries: Array<{ id: string, name: string, alpha2: string }>, poster: { id: string, path: string } | null }>, credit: { __typename: 'PersonCredits', id: string, activity: PersonActivity, rank: number, role: string | null } | null }> } };

export type LocaleOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type LocaleOptionsQuery = { locales: Array<{ id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }> };

export type LinkEntitiesMutationVariables = Exact<{
  input: LinkEntitiesInput;
}>;


export type LinkEntitiesMutation = { linkEntities: { __typename: 'EntityLink' } | null };

export type LookupCountryQueryVariables = Exact<{
  alpha2: Scalars['String']['input'];
}>;


export type LookupCountryQuery = { countryByAlpha2: { id: string, name: string } | null };

export type MoveCompanyMutationVariables = Exact<{
  input: MoveCompanyInput;
}>;


export type MoveCompanyMutation = { moveCompany: { __typename: 'EntityCompany', id: string, rank: number } | null };

export type MetabaseWidgetQueryVariables = Exact<{
  dashboard: Scalars['Int']['input'];
  params?: InputMaybe<Scalars['JSONObject']['input']>;
}>;


export type MetabaseWidgetQuery = { metabase: string };

export type MoveCreditMutationVariables = Exact<{
  input: MoveCreditInput;
}>;


export type MoveCreditMutation = { moveCredit: { id: string } | null };

export type OnPersonCreditsImportReportSubscriptionVariables = Exact<{
  entityId: Scalars['ID']['input'];
}>;


export type OnPersonCreditsImportReportSubscription = { personCreditsImportReport: { __typename: 'PersonCreditsImportReport', id: string, status: ImportWizardReportStatus, failureReason: string | null, launchedAt: string, finishedAt: string | null, source: PersonCreditsImportSource, outcome: ImportWizardOutcome | null, answeredBy: ImportWizardLevel | null, metadata: { createdBy: { id: string, name: string } | null }, counts: { linked: number, matched: number, ambiguous: number, unknown: number, extraneous: number }, stats: { durationMs: number, requests: number, bytesReceived: number, resolutionDurationMs: number, resolutionRequests: number, levels: Array<{ level: number, name: string, outcome: string, durationMs: number, requests: number, bytesReceived: number, creditsCount: number, detail: string, llmInputTokens: number | null, llm: { provider: string, model: string, inputTokens: number, outputTokens: number, durationMs: number, costUsd: number | null, error: string | null } | null }>, llm: { provider: string, model: string, inputTokens: number, outputTokens: number, durationMs: number, costUsd: number | null, error: string | null } | null }, localization: { locale: string, localeId: string, outcome: string | null, detail: string | null, durationMs: number | null, rolesAsked: number | null, rolesLocalized: number | null, llm: { provider: string, model: string, inputTokens: number, outputTokens: number, durationMs: number, costUsd: number | null, error: string | null } | null } | null, resolution: { __typename: 'PersonCreditsImportResolution', confidence: string, sourceId: string | null, source: string, detail: string, candidates: Array<{ id: string, title: string, year: number | null, kind: string | null }> } | null, entries: Array<{ __typename: 'PersonCreditsImportEntry', status: PersonCreditsImportStatus, name: string | null, category: string | null, role: string | null, localizedRole: string | null, externalPersonId: string | null, order: number | null, suggestedActivity: PersonActivity | null, gender: Gender | null, isVoice: boolean, linkKind: PersonCreditsImportLinkKind | null, linkLocale: string | null, linkedPerson: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, birthDate: string | null, deathDate: string | null, activities: Array<PersonActivity>, countries: Array<{ id: string, name: string, alpha2: string }>, poster: { id: string, path: string } | null } | null, candidates: Array<{ __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, birthDate: string | null, deathDate: string | null, activities: Array<PersonActivity>, countries: Array<{ id: string, name: string, alpha2: string }>, poster: { id: string, path: string } | null }>, credit: { __typename: 'PersonCredits', id: string, activity: PersonActivity, rank: number, role: string | null } | null }> } };

export type ProductTypeOptionsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ProductTypeOptionsQuery = { productTypeOptions: Array<{ value: string, label: string }> };

export type SearchCompaniesQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  activities?: InputMaybe<Array<CompanyActivity> | CompanyActivity>;
  countryIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type SearchCompaniesQuery = { companies: { nodes: Array<{ __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }> } };

export type SearchEntitiesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  brandId: Scalars['ID']['input'];
  localeId?: InputMaybe<Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocaleData?: InputMaybe<Scalars['Boolean']['input']>;
  entityType?: InputMaybe<Array<SearchableEntityType> | SearchableEntityType>;
  options?: InputMaybe<SearchOptionsInput>;
  includeClosestRelease?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SearchEntitiesQuery = { searchEntities: { totalCount: number, nodes: Array<{ __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, closestRelease?: { releasedAt: string | null } | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, closestRelease?: { releasedAt: string | null } | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'Slide', id: string, ref: string, title: string } | { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'CompanyStaff', id: string } | { __typename: 'Festival', id: string, ref: string, name: string } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Person', id: string, ref: string, lastName: string | null, firstName: string | null, deathDate: string | null, countries: Array<{ name: string }>, poster: { path: string, ref: string } | null, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesEpisode', id: string, ref: string, number: number, episodeTitle: string | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string }, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, season: { __typename: 'SeriesSeason', id: string, ref: string, number: number } | null, brandData?: { title: string | null } | null } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Theater', id: string, ref: string, code: string, name: string, logo: { ref: string, path: string } | null, theaterCountry: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } } | { __typename: 'VideoLegacy', id: string, ref: string, generatedTitle: string | null, videoTitle: string | null }> } };

export type SearchExternalIdProvidersQueryVariables = Exact<{
  type: ExternalIdProviderType;
}>;


export type SearchExternalIdProvidersQuery = { externalIdProviders: Array<string> };

export type SearchFestivalEditionsQueryVariables = Exact<{
  festivalId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<FestivalEditionOrder>;
}>;


export type SearchFestivalEditionsQuery = { festivalEditions: { totalCount: number, nodes: Array<{ id: string, ref: string, name: string | null, year: number, editionNumber: number | null, poster: { url: string } | null, festival: { name: string } }> } };

export type SearchFestivalsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy: FestivalOrder;
}>;


export type SearchFestivalsQuery = { festivals: { nodes: Array<{ id: string, ref: string, name: string, poster: { url: string } | null, country: { locale: { id: string } | null }, latestFestivalEdition: { poster: { url: string } | null } | null }> } };

export type SearchLocalizationsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['ID']['input']>;
  localizationKind?: InputMaybe<Array<LocalizationKind> | LocalizationKind>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchLocalizationsQuery = { localizations: { nodes: Array<{ id: string, name: string, type: LocalizationKind, code: string | null, parent: { id: string, name: string, type: LocalizationKind } | null }> } };

export type SearchMoviesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy: MovieOrder;
  algorithm?: InputMaybe<MovieSearchAlgorithm>;
  withSeoAttributes?: Scalars['Boolean']['input'];
  brandId?: Scalars['ID']['input'];
}>;


export type SearchMoviesQuery = { movies: { nodes: Array<{ __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string } | null, credits: { nodes: Array<{ person: { firstName: string | null, lastName: string | null } | null }> }, brandsData: Array<{ title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, activeOnBrands: Array<{ ref: string }>, seoAttributes?: Array<{ browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> }> } };

export type SearchNewsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  universes?: InputMaybe<Array<InputMaybe<NewsUniverse>> | InputMaybe<NewsUniverse>>;
}>;


export type SearchNewsQuery = { newsList: { nodes: Array<{ id: string, ref: string, title: string, active: boolean, publicationDate: string | null, publicationStatus: EntityPublicationStatus }> } };

export type SearchPersonsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy: PersonOrder;
  relatedEntities?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  withSeoAttributes?: Scalars['Boolean']['input'];
  brandId?: Scalars['ID']['input'];
}>;


export type SearchPersonsQuery = { persons: { nodes: Array<{ __typename: 'Person', id: string, ref: string, lastName: string | null, firstName: string | null, deathDate: string | null, activities: Array<PersonActivity>, poster: { path: string } | null, countries: Array<{ name: string }>, activeOnBrands: Array<{ ref: string }>, seoAttributes?: Array<{ browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> }> } };

export type SearchSeriesEpisodesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SearchSeriesEpisodesQuery = { series: { id: string, episodes: { totalCount: number, nodes: Array<{ __typename: 'SeriesEpisode', id: string, ref: string, number: number, title: string | null, brandData?: { title: string | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string }, season: { __typename: 'SeriesSeason', id: string, ref: string, number: number } | null }> } } | null };

export type SearchSeriesSeasonEpisodesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  brandId?: Scalars['ID']['input'];
  includeBrandData?: Scalars['Boolean']['input'];
}>;


export type SearchSeriesSeasonEpisodesQuery = { seriesSeason: { id: string, episodes: { totalCount: number, nodes: Array<{ __typename: 'SeriesEpisode', id: string, ref: string, number: number, title: string | null, brandData?: { title: string | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string }, season: { __typename: 'SeriesSeason', id: string, ref: string, number: number } | null }> } } | null };

export type SearchSeriesSeasonsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchSeriesSeasonsQuery = { series: { id: string, seasons: { totalCount: number, nodes: Array<{ __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } }> } } | null };

export type SearchSeriesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  brandId: Scalars['ID']['input'];
  orderBy: SeriesOrder;
  includeBrandData: Scalars['Boolean']['input'];
  withSeoAttributes?: Scalars['Boolean']['input'];
}>;


export type SearchSeriesQuery = { seriesList: { nodes: Array<{ __typename: 'Series', id: string, ref: string, title: string, originalPremiere: string | null, genres: Array<Genre>, poster: { path: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } } | null, activeOnBrands: Array<{ ref: string }>, seoAttributes?: Array<{ browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> }> } };

export type SearchTagsQueryVariables = Exact<{
  search: Scalars['String']['input'];
  brandId?: InputMaybe<Scalars['ID']['input']>;
  scoped?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SearchTagsQuery = { tags: { nodes: Array<{ id: string, ref: string, name: string }> } };

export type SearchSlidesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchSlidesQuery = { slides: { nodes: Array<{ id: string, title: string }> } };

export type SearchTheatersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  countryIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type SearchTheatersQuery = { theaters: { nodes: Array<{ __typename: 'Theater', id: string, ref: string, code: string, name: string, openingStatus: TheaterOpeningStatus, location: { city: string | null, zip: string | null } | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, parent: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null }> } };

export type SearchTriviasQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SearchTriviasQuery = { trivias: { nodes: Array<{ id: string, ref: string, title: string }> } };

export type TimezonesQueryVariables = Exact<{ [key: string]: never; }>;


export type TimezonesQuery = { timezones: Array<string> };

export type SearchVideosQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  search: Scalars['String']['input'];
  brandId?: InputMaybe<Scalars['ID']['input']>;
  universes?: InputMaybe<Array<InputMaybe<VideoUniverse>> | InputMaybe<VideoUniverse>>;
}>;


export type SearchVideosQuery = { videos: { nodes: Array<{ __typename: 'VideoLegacy', id: string, ref: string, title: string | null, generatedTitle: string | null, active: boolean, optionalTitle: string | null }> } };

export type SecureUserOptionsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SecureUserOptionsQuery = { users: { nodes: Array<{ id: string, name: string, email: string }> } };

export type UnlinkEntitiesMutationVariables = Exact<{
  input: UnlinkEntitiesInput;
}>;


export type UnlinkEntitiesMutation = { unlinkEntities: { __typename: 'EntityLink' } | null };

export type ToggleEntityBrandActivationMutationVariables = Exact<{
  brandId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type ToggleEntityBrandActivationMutation = { toggleEntityBrandActivation: { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, seoData: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null } | { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, seoData: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null } | { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, seoData: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null } | {} | null };

export type UpdateBrandEntityClubMutationVariables = Exact<{
  input: UpdateBrandEntityClubInput;
}>;


export type UpdateBrandEntityClubMutation = { updateBrandEntityClub: { __typename: 'BrandEntityClub' } | null };

export type UpdateEntityAltsMutationVariables = Exact<{
  input: UpdateEntityAltsInput;
}>;


export type UpdateEntityAltsMutation = { updateEntityAlts: { __typename: 'User', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> } | { __typename: 'SocialUser', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> } | { __typename: 'Image', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> } | { __typename: 'Movie', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> } | { __typename: 'Series', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> } | { __typename: 'Company', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> } | { __typename: 'CompanyStaff', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> } | { __typename: 'News', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> } | { __typename: 'VideoLegacy', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> } | { __typename: 'SeriesSeason', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> } | { __typename: 'SeriesEpisode', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> } | { __typename: 'Person', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> } | { __typename: 'Festival', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> } | { __typename: 'FestivalEdition', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> } | { __typename: 'Slide', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> } | { __typename: 'Theater', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> } | { __typename: 'Screen', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> } | { __typename: 'FestivalAward', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> } | { __typename: 'FestivalSelection', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> } | { __typename: 'FestivalCompetition', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> } | { __typename: 'FestivalEditionCompetition', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> } | { __typename: 'FestivalJury', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> } | { __typename: 'TheaterEvent', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> } | { __typename: 'VideoB2B', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> } | null };

export type UpdateEntityGeneratedVideoTitlesMutationVariables = Exact<{
  input: UpdateEntityGeneratedVideoTitlesInput;
}>;


export type UpdateEntityGeneratedVideoTitlesMutation = { updateEntityGeneratedVideoTitles: { __typename: 'EntityGeneratedVideoTitles', count: number | null } | null };

export type UpdateCreditMutationVariables = Exact<{
  input: UpdateCreditInput;
}>;


export type UpdateCreditMutation = { updateCredit: { id: string, role: string | null, person: { id: string } | null, voice: { id: string } | null } | null };

export type UpdateEntityMainPosterMutationVariables = Exact<{
  input: UpdateEntityMainPosterInput;
}>;


export type UpdateEntityMainPosterMutation = { updateEntityMainPoster: { __typename: 'User', id: string } | { __typename: 'SocialUser', id: string } | { __typename: 'Image', id: string } | { __typename: 'Movie', id: string } | { __typename: 'Series', id: string } | { __typename: 'Company', id: string } | { __typename: 'CompanyStaff', id: string } | { __typename: 'News', id: string } | { __typename: 'VideoLegacy', id: string } | { __typename: 'SeriesSeason', id: string } | { __typename: 'SeriesEpisode', id: string } | { __typename: 'Person', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'Slide', id: string } | { __typename: 'Theater', id: string } | { __typename: 'Screen', id: string } | { __typename: 'FestivalAward', id: string } | { __typename: 'FestivalSelection', id: string } | { __typename: 'FestivalCompetition', id: string } | { __typename: 'FestivalEditionCompetition', id: string } | { __typename: 'FestivalJury', id: string } | { __typename: 'TheaterEvent', id: string } | { __typename: 'VideoB2B', id: string } | null };

export type UpdateEntityMainBrandedPosterMutationVariables = Exact<{
  input: UpdateEntityMainBrandPosterInput;
}>;


export type UpdateEntityMainBrandedPosterMutation = { updateEntityMainBrandPoster: { __typename: 'User', id: string } | { __typename: 'SocialUser', id: string } | { __typename: 'Image', id: string } | { __typename: 'Movie', id: string } | { __typename: 'Series', id: string } | { __typename: 'Company', id: string } | { __typename: 'CompanyStaff', id: string } | { __typename: 'News', id: string } | { __typename: 'VideoLegacy', id: string } | { __typename: 'SeriesSeason', id: string } | { __typename: 'SeriesEpisode', id: string } | { __typename: 'Person', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'Slide', id: string } | { __typename: 'Theater', id: string } | { __typename: 'Screen', id: string } | { __typename: 'FestivalAward', id: string } | { __typename: 'FestivalSelection', id: string } | { __typename: 'FestivalCompetition', id: string } | { __typename: 'FestivalEditionCompetition', id: string } | { __typename: 'FestivalJury', id: string } | { __typename: 'TheaterEvent', id: string } | { __typename: 'VideoB2B', id: string } | null };

export type UpdateEntityMainLocalizedPosterMutationVariables = Exact<{
  input: UpdateEntityMainLocalizedPosterInput;
}>;


export type UpdateEntityMainLocalizedPosterMutation = { updateEntityMainLocalizedPoster: { __typename: 'User', id: string } | { __typename: 'SocialUser', id: string } | { __typename: 'Image', id: string } | { __typename: 'Movie', id: string } | { __typename: 'Series', id: string } | { __typename: 'Company', id: string } | { __typename: 'CompanyStaff', id: string } | { __typename: 'News', id: string } | { __typename: 'VideoLegacy', id: string } | { __typename: 'SeriesSeason', id: string } | { __typename: 'SeriesEpisode', id: string } | { __typename: 'Person', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'Slide', id: string } | { __typename: 'Theater', id: string } | { __typename: 'Screen', id: string } | { __typename: 'FestivalAward', id: string } | { __typename: 'FestivalSelection', id: string } | { __typename: 'FestivalCompetition', id: string } | { __typename: 'FestivalEditionCompetition', id: string } | { __typename: 'FestivalJury', id: string } | { __typename: 'TheaterEvent', id: string } | { __typename: 'VideoB2B', id: string } | null };

export type UpdateEntitySeoDataMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
  active: Scalars['Boolean']['input'];
  browsable: Scalars['Boolean']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  alternateTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateEntitySeoDataMutation = { updateEntitySeoData: { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, seoData: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null } | { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, seoData: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null } | { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, seoData: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null } | { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, seoData: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null } | {} | null };

export type UpdateEntityPublicationMutationVariables = Exact<{
  input: UpdateEntityPublicationInput;
}>;


export type UpdateEntityPublicationMutation = { updateEntityPublication: { id: string, publicationStatus: EntityPublicationStatus, publicationDate: string | null, isUpdatedWhenPublished: boolean, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, publications: Array<{ startsAt: string, endsAt: string | null, status: EntityPublicationStatus }> } | { id: string, publicationStatus: EntityPublicationStatus, publicationDate: string | null, isUpdatedWhenPublished: boolean, publications: Array<{ startsAt: string, endsAt: string | null, status: EntityPublicationStatus }> } | null };

export type UpdateLocalCertificateMutationVariables = Exact<{
  input: UpdateLocalCertificateInput;
}>;


export type UpdateLocalCertificateMutation = { updateLocalCertificate: { advisory: string | null, localization: { id: string, name: string, type: LocalizationKind, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null }, certificate: { id: string, ref: string, label: string | null, code: string | null } } | null };

export type UpdateLocalCreditMutationVariables = Exact<{
  input: UpdateLocalCreditInput;
}>;


export type UpdateLocalCreditMutation = { updateLocalCredit: { id: string, role: string | null, voice: { id: string } | null, locale: { id: string } } };

export type UpdateTriviaRankMutationVariables = Exact<{
  input: UpdateTriviaRankInput;
}>;


export type UpdateTriviaRankMutation = { updateTriviaRank: { id: string } | null };

export type ViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerQuery = { viewer: { id: string, ref: string, email: string, name: string, allowedLocales: Array<{ id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }>, allowedBrands: Array<{ __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }>, defaultBrand: { __typename: 'Brand', language: Language | null, id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } | null, defaultCountry: { __typename: 'Country', language: Language | null, id: string, ref: string, name: string, alpha2: string } | null, defaultLocale: { language: Language | null, id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null } | null } };

export type ViewerDataFragment = { id: string, ref: string, email: string, name: string, allowedLocales: Array<{ id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }>, allowedBrands: Array<{ __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }>, defaultBrand: { __typename: 'Brand', language: Language | null, id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } | null, defaultCountry: { __typename: 'Country', language: Language | null, id: string, ref: string, name: string, alpha2: string } | null, defaultLocale: { language: Language | null, id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null } | null };

export type ViewerInfoFragment = { id: string, ref: string, email: string, name: string, allowedLocales: Array<{ id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }>, allowedBrands: Array<{ __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }> };

export type ViewerPreferencesFragment = { defaultBrand: { __typename: 'Brand', language: Language | null, id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } | null, defaultCountry: { __typename: 'Country', language: Language | null, id: string, ref: string, name: string, alpha2: string } | null, defaultLocale: { language: Language | null, id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null } | null };

export type DeleteSpecialOperationMutationVariables = Exact<{
  specialOperationId: Scalars['ID']['input'];
}>;


export type DeleteSpecialOperationMutation = { deleteSpecialOperation: { id: string } | null };

export type CreateSpecialOperationMutationVariables = Exact<{
  input: CreateSpecialOperationInput;
}>;


export type CreateSpecialOperationMutation = { createSpecialOperation: { id: string, ref: string } | null };

export type AddTargetToSpecialOperationMutationVariables = Exact<{
  input: AddTargetToSpecialOperationInput;
}>;


export type AddTargetToSpecialOperationMutation = { addTargetToSpecialOperation: { id: string } | null };

export type GetEmergenceTargetsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  target?: InputMaybe<Array<Scalars['Tag3D']['input']> | Scalars['Tag3D']['input']>;
}>;


export type GetEmergenceTargetsQuery = { specialOperation: { id: string, targets: Array<{ id: string, rank: number, target: string | null, startsAt: string | null, endsAt: string | null, data: any, entity: { __typename: 'User' } | { __typename: 'SocialUser' } | { __typename: 'Image' } | { __typename: 'Movie' } | { __typename: 'Series' } | { __typename: 'Company' } | { __typename: 'CompanyStaff' } | { __typename: 'News', id: string, ref: string, title: string, active: boolean, publicationStatus: EntityPublicationStatus } | { __typename: 'VideoLegacy', id: string, ref: string, active: boolean, generatedTitle: string | null, optionalTitle: string | null } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' } | { __typename: 'Person' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | { __typename: 'Slide', id: string, ref: string, title: string, active: boolean } | { __typename: 'Theater' } | { __typename: 'Screen' } | { __typename: 'FestivalAward' } | { __typename: 'FestivalSelection' } | { __typename: 'FestivalCompetition' } | { __typename: 'FestivalEditionCompetition' } | { __typename: 'FestivalJury' } | { __typename: 'TheaterEvent' } | { __typename: 'VideoB2B' } | null }> } | null };

export type EmergenceTargetFragment = { id: string, rank: number, target: string | null, startsAt: string | null, endsAt: string | null, data: any, entity: { __typename: 'User' } | { __typename: 'SocialUser' } | { __typename: 'Image' } | { __typename: 'Movie' } | { __typename: 'Series' } | { __typename: 'Company' } | { __typename: 'CompanyStaff' } | { __typename: 'News', id: string, ref: string, title: string, active: boolean, publicationStatus: EntityPublicationStatus } | { __typename: 'VideoLegacy', id: string, ref: string, active: boolean, generatedTitle: string | null, optionalTitle: string | null } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' } | { __typename: 'Person' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | { __typename: 'Slide', id: string, ref: string, title: string, active: boolean } | { __typename: 'Theater' } | { __typename: 'Screen' } | { __typename: 'FestivalAward' } | { __typename: 'FestivalSelection' } | { __typename: 'FestivalCompetition' } | { __typename: 'FestivalEditionCompetition' } | { __typename: 'FestivalJury' } | { __typename: 'TheaterEvent' } | { __typename: 'VideoB2B' } | null };

export type EmergenceSlideFragment = { id: string, ref: string, title: string, active: boolean };

export type EmergenceNewsFragment = { id: string, ref: string, title: string, active: boolean, publicationStatus: EntityPublicationStatus };

export type EmergenceVideoLegacyFragment = { id: string, ref: string, active: boolean, generatedTitle: string | null, optionalTitle: string | null };

export type GetSpecialOperationAdditionalInfosQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetSpecialOperationAdditionalInfosQuery = { specialOperationByRef: { id: string, ref: string, name: string | null, entity: { __typename: 'Company' } | { __typename: 'Movie', id: string, title: string } | { __typename: 'News' } | { __typename: 'Series' } | { __typename: 'SeriesSeason' } | { __typename: 'Slide' } | null, data: { __typename: 'BannerHPData', link_desktop: string | null, link_mobile: string | null, medias: { desktop: string | null, mobile: string | null } | null } | { __typename: 'CanalHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'ClassiqueHomeData', heading1: string | null, heading2: string | null, heading3: string | null, link1_label: string | null, link1_url: string | null, link2_label: string | null, link2_url: string | null } | { __typename: 'Club300Data', _placeholder: boolean | null } | { __typename: 'DisneyHomeData', medias: { native_grand_angle: { image_url: string | null, url: string | null } | null } | null } | { __typename: 'DolbyHomeData', _placeholder: boolean | null } | { __typename: 'EmergenceMovieData', distribution: EmergenceDistribution | null, provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceSeriesData', provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceSVODData', provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceTheaterData', release_date: string | null } | { __typename: 'FestivalSectionData', festivalEditionId: number | null, festivalId: number | null, playlist: Array<{ key: string, value: { movies: Array<number> | null, series: Array<number> | null } | null } | null> | null } | { __typename: 'FilmesOnlineData', heading1: string | null, heading2: string | null, heading3: string | null, heading4: string | null, heading5: string | null, heading6: string | null, heading7: string | null, heading8: string | null, heading9: string | null, heading10: string | null } | { __typename: 'IMAXHomeData', _placeholder: boolean | null } | { __typename: 'IndelebileHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'M6HomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'MaxHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'MobileDdayData', dday_campaign: string | null, dday_movie_id: number | null, dday_movie_list_id: Array<number> | null, dday_movie_list_title: string | null, dday_force_uppercase_headers: boolean | null, dday_nav_background_color_light: string | null, dday_nav_background_color_dark: string | null, dday_nav_font_color_light: string | null, dday_nav_font_color_dark: string | null, dday_main_color_light: string | null, dday_main_color_dark: string | null, dday_title_spacing_between_letters: number | null, dday_title_see_more_title_displayed: boolean | null, dday_background_color: string | null, dday_force_theme_light: boolean | null, dday_force_theme_dark: boolean | null, dday_status_bar_icons_light: boolean | null, dday_status_bar_icons_dark: boolean | null, dday_segmented_color_light: string | null, dday_segmented_color_dark: string | null, dday_segmented_selected_font_color_light: string | null, dday_segmented_selected_font_color_dark: string | null, dday_date: string | null, dday_last_date: string | null, dday_assets_version: number | null, dday_font_url: string | null, dday_font_size: number | null, dday_movie_background_url: string | null, dday_movie_background_id: string | null, dday_movie_logo_url: string | null, dday_movie_logo_id: string | null, dday_splash_background_url: string | null, dday_splash_background_id: string | null, dday_splash_logo_url: string | null, dday_splash_logo_id: string | null, dday_splashscreen_status_bar_color_style: string | null, dday_splashscreen_activity_color: string | null } | { __typename: 'NovelasHomeData', _placeholder: boolean | null } | { __typename: 'RollerHomeData', title: string | null } | { __typename: 'SponsoredAutocompleteData', release_date: string | null } | { __typename: 'TF1HomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'TicketAnchorData', cta_text_after_release: string | null, cta_text_before_release: string | null, display_showtimes: boolean | null, link: string | null, release_date: string | null, slots: Array<TicketAnchorSlot> | null, text_after_release: string | null, text_before_release: string | null, text_color: string | null, medias: { desktop: string | null, desktopHp: string | null, mobile: string | null } | null } | { __typename: 'VODHomeData', heading1: string | null, heading2: string | null } } | null };

export type GetSpecialOperationCustoQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetSpecialOperationCustoQuery = { specialOperationByRef: { id: string, ref: string, data: { __typename: 'BannerHPData', link_desktop: string | null, link_mobile: string | null, medias: { desktop: string | null, mobile: string | null } | null } | { __typename: 'CanalHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'ClassiqueHomeData', heading1: string | null, heading2: string | null, heading3: string | null, link1_label: string | null, link1_url: string | null, link2_label: string | null, link2_url: string | null } | { __typename: 'Club300Data', _placeholder: boolean | null } | { __typename: 'DisneyHomeData', medias: { native_grand_angle: { image_url: string | null, url: string | null } | null } | null } | { __typename: 'DolbyHomeData', _placeholder: boolean | null } | { __typename: 'EmergenceMovieData', distribution: EmergenceDistribution | null, provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceSeriesData', provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceSVODData', provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceTheaterData', release_date: string | null } | { __typename: 'FestivalSectionData', festivalEditionId: number | null, festivalId: number | null, playlist: Array<{ key: string, value: { movies: Array<number> | null, series: Array<number> | null } | null } | null> | null } | { __typename: 'FilmesOnlineData', heading1: string | null, heading2: string | null, heading3: string | null, heading4: string | null, heading5: string | null, heading6: string | null, heading7: string | null, heading8: string | null, heading9: string | null, heading10: string | null } | { __typename: 'IMAXHomeData', _placeholder: boolean | null } | { __typename: 'IndelebileHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'M6HomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'MaxHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'MobileDdayData', dday_campaign: string | null, dday_movie_id: number | null, dday_movie_list_id: Array<number> | null, dday_movie_list_title: string | null, dday_force_uppercase_headers: boolean | null, dday_nav_background_color_light: string | null, dday_nav_background_color_dark: string | null, dday_nav_font_color_light: string | null, dday_nav_font_color_dark: string | null, dday_main_color_light: string | null, dday_main_color_dark: string | null, dday_title_spacing_between_letters: number | null, dday_title_see_more_title_displayed: boolean | null, dday_background_color: string | null, dday_force_theme_light: boolean | null, dday_force_theme_dark: boolean | null, dday_status_bar_icons_light: boolean | null, dday_status_bar_icons_dark: boolean | null, dday_segmented_color_light: string | null, dday_segmented_color_dark: string | null, dday_segmented_selected_font_color_light: string | null, dday_segmented_selected_font_color_dark: string | null, dday_date: string | null, dday_last_date: string | null, dday_assets_version: number | null, dday_font_url: string | null, dday_font_size: number | null, dday_movie_background_url: string | null, dday_movie_background_id: string | null, dday_movie_logo_url: string | null, dday_movie_logo_id: string | null, dday_splash_background_url: string | null, dday_splash_background_id: string | null, dday_splash_logo_url: string | null, dday_splash_logo_id: string | null, dday_splashscreen_status_bar_color_style: string | null, dday_splashscreen_activity_color: string | null } | { __typename: 'NovelasHomeData', _placeholder: boolean | null } | { __typename: 'RollerHomeData', title: string | null } | { __typename: 'SponsoredAutocompleteData', release_date: string | null } | { __typename: 'TF1HomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'TicketAnchorData', cta_text_after_release: string | null, cta_text_before_release: string | null, display_showtimes: boolean | null, link: string | null, release_date: string | null, slots: Array<TicketAnchorSlot> | null, text_after_release: string | null, text_before_release: string | null, text_color: string | null, medias: { desktop: string | null, desktopHp: string | null, mobile: string | null } | null } | { __typename: 'VODHomeData', heading1: string | null, heading2: string | null } } | null };

export type GetSpecialOperationEntitiesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  target?: InputMaybe<Array<Scalars['Tag3D']['input']> | Scalars['Tag3D']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  localeId?: InputMaybe<Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocaleData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetSpecialOperationEntitiesQuery = { specialOperation: { id: string, targets: Array<{ id: string, rank: number, target: string | null, startsAt: string | null, endsAt: string | null, data: any, entity: { __typename: 'User' } | { __typename: 'SocialUser' } | { __typename: 'Image' } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'Company' } | { __typename: 'CompanyStaff' } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'VideoLegacy', id: string, ref: string, generatedTitle: string | null, videoTitle: string | null } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' } | { __typename: 'Person' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | { __typename: 'Slide', id: string, ref: string, title: string } | { __typename: 'Theater' } | { __typename: 'Screen' } | { __typename: 'FestivalAward' } | { __typename: 'FestivalSelection' } | { __typename: 'FestivalCompetition' } | { __typename: 'FestivalEditionCompetition' } | { __typename: 'FestivalJury' } | { __typename: 'TheaterEvent' } | { __typename: 'VideoB2B' } | null }> } | null };

export type SpecialOperationHasTargetFragment = { id: string, rank: number, target: string | null, startsAt: string | null, endsAt: string | null, data: any, entity: { __typename: 'User' } | { __typename: 'SocialUser' } | { __typename: 'Image' } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'Company' } | { __typename: 'CompanyStaff' } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'VideoLegacy', id: string, ref: string, generatedTitle: string | null, videoTitle: string | null } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' } | { __typename: 'Person' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | { __typename: 'Slide', id: string, ref: string, title: string } | { __typename: 'Theater' } | { __typename: 'Screen' } | { __typename: 'FestivalAward' } | { __typename: 'FestivalSelection' } | { __typename: 'FestivalCompetition' } | { __typename: 'FestivalEditionCompetition' } | { __typename: 'FestivalJury' } | { __typename: 'TheaterEvent' } | { __typename: 'VideoB2B' } | null };

export type GetSpecialOperationSlotsQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetSpecialOperationSlotsQuery = { specialOperationByRef: { id: string, ref: string, slots: Array<TicketAnchorSlot> } | null };

export type GetSpecialOperationsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  brands?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  codes?: InputMaybe<Array<SpecialOperationCode> | SpecialOperationCode>;
}>;


export type GetSpecialOperationsQuery = { specialOperations: { totalCount: number, nodes: Array<{ id: string, ref: string, active: boolean | null, code: SpecialOperationCode, name: string | null, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company' } | { __typename: 'Movie', id: string, ref: string } | { __typename: 'News' } | { __typename: 'Series' } | { __typename: 'SeriesSeason' } | { __typename: 'Slide' } | null, data: { __typename: 'BannerHPData', link_desktop: string | null, link_mobile: string | null, medias: { desktop: string | null, mobile: string | null } | null } | { __typename: 'CanalHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'ClassiqueHomeData', heading1: string | null, heading2: string | null, heading3: string | null, link1_label: string | null, link1_url: string | null, link2_label: string | null, link2_url: string | null } | { __typename: 'Club300Data', _placeholder: boolean | null } | { __typename: 'DisneyHomeData', medias: { native_grand_angle: { image_url: string | null, url: string | null } | null } | null } | { __typename: 'DolbyHomeData', _placeholder: boolean | null } | { __typename: 'EmergenceMovieData', distribution: EmergenceDistribution | null, provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceSeriesData', provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceSVODData', provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceTheaterData', release_date: string | null } | { __typename: 'FestivalSectionData', festivalEditionId: number | null, festivalId: number | null, playlist: Array<{ key: string, value: { movies: Array<number> | null, series: Array<number> | null } | null } | null> | null } | { __typename: 'FilmesOnlineData', heading1: string | null, heading2: string | null, heading3: string | null, heading4: string | null, heading5: string | null, heading6: string | null, heading7: string | null, heading8: string | null, heading9: string | null, heading10: string | null } | { __typename: 'IMAXHomeData', _placeholder: boolean | null } | { __typename: 'IndelebileHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'M6HomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'MaxHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'MobileDdayData', dday_campaign: string | null, dday_movie_id: number | null, dday_movie_list_id: Array<number> | null, dday_movie_list_title: string | null, dday_force_uppercase_headers: boolean | null, dday_nav_background_color_light: string | null, dday_nav_background_color_dark: string | null, dday_nav_font_color_light: string | null, dday_nav_font_color_dark: string | null, dday_main_color_light: string | null, dday_main_color_dark: string | null, dday_title_spacing_between_letters: number | null, dday_title_see_more_title_displayed: boolean | null, dday_background_color: string | null, dday_force_theme_light: boolean | null, dday_force_theme_dark: boolean | null, dday_status_bar_icons_light: boolean | null, dday_status_bar_icons_dark: boolean | null, dday_segmented_color_light: string | null, dday_segmented_color_dark: string | null, dday_segmented_selected_font_color_light: string | null, dday_segmented_selected_font_color_dark: string | null, dday_date: string | null, dday_last_date: string | null, dday_assets_version: number | null, dday_font_url: string | null, dday_font_size: number | null, dday_movie_background_url: string | null, dday_movie_background_id: string | null, dday_movie_logo_url: string | null, dday_movie_logo_id: string | null, dday_splash_background_url: string | null, dday_splash_background_id: string | null, dday_splash_logo_url: string | null, dday_splash_logo_id: string | null, dday_splashscreen_status_bar_color_style: string | null, dday_splashscreen_activity_color: string | null } | { __typename: 'NovelasHomeData', _placeholder: boolean | null } | { __typename: 'RollerHomeData', title: string | null } | { __typename: 'SponsoredAutocompleteData', release_date: string | null } | { __typename: 'TF1HomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'TicketAnchorData', cta_text_after_release: string | null, cta_text_before_release: string | null, display_showtimes: boolean | null, link: string | null, release_date: string | null, slots: Array<TicketAnchorSlot> | null, text_after_release: string | null, text_before_release: string | null, text_color: string | null, medias: { desktop: string | null, desktopHp: string | null, mobile: string | null } | null } | { __typename: 'VODHomeData', heading1: string | null, heading2: string | null } }> } };

export type SpecialOperationItemFragment = { id: string, ref: string, active: boolean | null, code: SpecialOperationCode, name: string | null, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company' } | { __typename: 'Movie', id: string, ref: string } | { __typename: 'News' } | { __typename: 'Series' } | { __typename: 'SeriesSeason' } | { __typename: 'Slide' } | null, data: { __typename: 'BannerHPData', link_desktop: string | null, link_mobile: string | null, medias: { desktop: string | null, mobile: string | null } | null } | { __typename: 'CanalHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'ClassiqueHomeData', heading1: string | null, heading2: string | null, heading3: string | null, link1_label: string | null, link1_url: string | null, link2_label: string | null, link2_url: string | null } | { __typename: 'Club300Data', _placeholder: boolean | null } | { __typename: 'DisneyHomeData', medias: { native_grand_angle: { image_url: string | null, url: string | null } | null } | null } | { __typename: 'DolbyHomeData', _placeholder: boolean | null } | { __typename: 'EmergenceMovieData', distribution: EmergenceDistribution | null, provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceSeriesData', provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceSVODData', provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceTheaterData', release_date: string | null } | { __typename: 'FestivalSectionData', festivalEditionId: number | null, festivalId: number | null, playlist: Array<{ key: string, value: { movies: Array<number> | null, series: Array<number> | null } | null } | null> | null } | { __typename: 'FilmesOnlineData', heading1: string | null, heading2: string | null, heading3: string | null, heading4: string | null, heading5: string | null, heading6: string | null, heading7: string | null, heading8: string | null, heading9: string | null, heading10: string | null } | { __typename: 'IMAXHomeData', _placeholder: boolean | null } | { __typename: 'IndelebileHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'M6HomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'MaxHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'MobileDdayData', dday_campaign: string | null, dday_movie_id: number | null, dday_movie_list_id: Array<number> | null, dday_movie_list_title: string | null, dday_force_uppercase_headers: boolean | null, dday_nav_background_color_light: string | null, dday_nav_background_color_dark: string | null, dday_nav_font_color_light: string | null, dday_nav_font_color_dark: string | null, dday_main_color_light: string | null, dday_main_color_dark: string | null, dday_title_spacing_between_letters: number | null, dday_title_see_more_title_displayed: boolean | null, dday_background_color: string | null, dday_force_theme_light: boolean | null, dday_force_theme_dark: boolean | null, dday_status_bar_icons_light: boolean | null, dday_status_bar_icons_dark: boolean | null, dday_segmented_color_light: string | null, dday_segmented_color_dark: string | null, dday_segmented_selected_font_color_light: string | null, dday_segmented_selected_font_color_dark: string | null, dday_date: string | null, dday_last_date: string | null, dday_assets_version: number | null, dday_font_url: string | null, dday_font_size: number | null, dday_movie_background_url: string | null, dday_movie_background_id: string | null, dday_movie_logo_url: string | null, dday_movie_logo_id: string | null, dday_splash_background_url: string | null, dday_splash_background_id: string | null, dday_splash_logo_url: string | null, dday_splash_logo_id: string | null, dday_splashscreen_status_bar_color_style: string | null, dday_splashscreen_activity_color: string | null } | { __typename: 'NovelasHomeData', _placeholder: boolean | null } | { __typename: 'RollerHomeData', title: string | null } | { __typename: 'SponsoredAutocompleteData', release_date: string | null } | { __typename: 'TF1HomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'TicketAnchorData', cta_text_after_release: string | null, cta_text_before_release: string | null, display_showtimes: boolean | null, link: string | null, release_date: string | null, slots: Array<TicketAnchorSlot> | null, text_after_release: string | null, text_before_release: string | null, text_color: string | null, medias: { desktop: string | null, desktopHp: string | null, mobile: string | null } | null } | { __typename: 'VODHomeData', heading1: string | null, heading2: string | null } };

export type GetSpecialOperationQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
  localeId?: InputMaybe<Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocaleData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetSpecialOperationQuery = { specialOperationByRef: { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, active: boolean | null, missingRequiredFields: Array<string>, startsAt: string, endsAt: string | null, slots: Array<TicketAnchorSlot>, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, data: { __typename: 'BannerHPData', link_desktop: string | null, link_mobile: string | null, medias: { desktop: string | null, mobile: string | null } | null } | { __typename: 'CanalHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'ClassiqueHomeData', heading1: string | null, heading2: string | null, heading3: string | null, link1_label: string | null, link1_url: string | null, link2_label: string | null, link2_url: string | null } | { __typename: 'Club300Data', _placeholder: boolean | null } | { __typename: 'DisneyHomeData', medias: { native_grand_angle: { image_url: string | null, url: string | null } | null } | null } | { __typename: 'DolbyHomeData', _placeholder: boolean | null } | { __typename: 'EmergenceMovieData', distribution: EmergenceDistribution | null, provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceSeriesData', provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceSVODData', provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceTheaterData', release_date: string | null } | { __typename: 'FestivalSectionData', festivalEditionId: number | null, festivalId: number | null, playlist: Array<{ key: string, value: { movies: Array<number> | null, series: Array<number> | null } | null } | null> | null } | { __typename: 'FilmesOnlineData', heading1: string | null, heading2: string | null, heading3: string | null, heading4: string | null, heading5: string | null, heading6: string | null, heading7: string | null, heading8: string | null, heading9: string | null, heading10: string | null } | { __typename: 'IMAXHomeData', _placeholder: boolean | null } | { __typename: 'IndelebileHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'M6HomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'MaxHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'MobileDdayData', dday_campaign: string | null, dday_movie_id: number | null, dday_movie_list_id: Array<number> | null, dday_movie_list_title: string | null, dday_force_uppercase_headers: boolean | null, dday_nav_background_color_light: string | null, dday_nav_background_color_dark: string | null, dday_nav_font_color_light: string | null, dday_nav_font_color_dark: string | null, dday_main_color_light: string | null, dday_main_color_dark: string | null, dday_title_spacing_between_letters: number | null, dday_title_see_more_title_displayed: boolean | null, dday_background_color: string | null, dday_force_theme_light: boolean | null, dday_force_theme_dark: boolean | null, dday_status_bar_icons_light: boolean | null, dday_status_bar_icons_dark: boolean | null, dday_segmented_color_light: string | null, dday_segmented_color_dark: string | null, dday_segmented_selected_font_color_light: string | null, dday_segmented_selected_font_color_dark: string | null, dday_date: string | null, dday_last_date: string | null, dday_assets_version: number | null, dday_font_url: string | null, dday_font_size: number | null, dday_movie_background_url: string | null, dday_movie_background_id: string | null, dday_movie_logo_url: string | null, dday_movie_logo_id: string | null, dday_splash_background_url: string | null, dday_splash_background_id: string | null, dday_splash_logo_url: string | null, dday_splash_logo_id: string | null, dday_splashscreen_status_bar_color_style: string | null, dday_splashscreen_activity_color: string | null } | { __typename: 'NovelasHomeData', _placeholder: boolean | null } | { __typename: 'RollerHomeData', title: string | null } | { __typename: 'SponsoredAutocompleteData', release_date: string | null } | { __typename: 'TF1HomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'TicketAnchorData', cta_text_after_release: string | null, cta_text_before_release: string | null, display_showtimes: boolean | null, link: string | null, release_date: string | null, slots: Array<TicketAnchorSlot> | null, text_after_release: string | null, text_before_release: string | null, text_color: string | null, medias: { desktop: string | null, desktopHp: string | null, mobile: string | null } | null } | { __typename: 'VODHomeData', heading1: string | null, heading2: string | null } } | null };

export type RemoveTargetFromSpecialOperationMutationVariables = Exact<{
  input: RemoveTargetFromSpecialOperationInput;
}>;


export type RemoveTargetFromSpecialOperationMutation = { removeTargetFromSpecialOperation: { id: string } | null };

export type UpdateSpecialOperationMutationVariables = Exact<{
  input: UpdateSpecialOperationInput;
  brandId?: Scalars['ID']['input'];
  localeId?: InputMaybe<Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocaleData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateSpecialOperationMutation = { updateSpecialOperation: { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, active: boolean | null, missingRequiredFields: Array<string>, startsAt: string, endsAt: string | null, slots: Array<TicketAnchorSlot>, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, data: { __typename: 'BannerHPData', link_desktop: string | null, link_mobile: string | null, medias: { desktop: string | null, mobile: string | null } | null } | { __typename: 'CanalHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'ClassiqueHomeData', heading1: string | null, heading2: string | null, heading3: string | null, link1_label: string | null, link1_url: string | null, link2_label: string | null, link2_url: string | null } | { __typename: 'Club300Data', _placeholder: boolean | null } | { __typename: 'DisneyHomeData', medias: { native_grand_angle: { image_url: string | null, url: string | null } | null } | null } | { __typename: 'DolbyHomeData', _placeholder: boolean | null } | { __typename: 'EmergenceMovieData', distribution: EmergenceDistribution | null, provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceSeriesData', provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceSVODData', provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceTheaterData', release_date: string | null } | { __typename: 'FestivalSectionData', festivalEditionId: number | null, festivalId: number | null, playlist: Array<{ key: string, value: { movies: Array<number> | null, series: Array<number> | null } | null } | null> | null } | { __typename: 'FilmesOnlineData', heading1: string | null, heading2: string | null, heading3: string | null, heading4: string | null, heading5: string | null, heading6: string | null, heading7: string | null, heading8: string | null, heading9: string | null, heading10: string | null } | { __typename: 'IMAXHomeData', _placeholder: boolean | null } | { __typename: 'IndelebileHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'M6HomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'MaxHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'MobileDdayData', dday_campaign: string | null, dday_movie_id: number | null, dday_movie_list_id: Array<number> | null, dday_movie_list_title: string | null, dday_force_uppercase_headers: boolean | null, dday_nav_background_color_light: string | null, dday_nav_background_color_dark: string | null, dday_nav_font_color_light: string | null, dday_nav_font_color_dark: string | null, dday_main_color_light: string | null, dday_main_color_dark: string | null, dday_title_spacing_between_letters: number | null, dday_title_see_more_title_displayed: boolean | null, dday_background_color: string | null, dday_force_theme_light: boolean | null, dday_force_theme_dark: boolean | null, dday_status_bar_icons_light: boolean | null, dday_status_bar_icons_dark: boolean | null, dday_segmented_color_light: string | null, dday_segmented_color_dark: string | null, dday_segmented_selected_font_color_light: string | null, dday_segmented_selected_font_color_dark: string | null, dday_date: string | null, dday_last_date: string | null, dday_assets_version: number | null, dday_font_url: string | null, dday_font_size: number | null, dday_movie_background_url: string | null, dday_movie_background_id: string | null, dday_movie_logo_url: string | null, dday_movie_logo_id: string | null, dday_splash_background_url: string | null, dday_splash_background_id: string | null, dday_splash_logo_url: string | null, dday_splash_logo_id: string | null, dday_splashscreen_status_bar_color_style: string | null, dday_splashscreen_activity_color: string | null } | { __typename: 'NovelasHomeData', _placeholder: boolean | null } | { __typename: 'RollerHomeData', title: string | null } | { __typename: 'SponsoredAutocompleteData', release_date: string | null } | { __typename: 'TF1HomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'TicketAnchorData', cta_text_after_release: string | null, cta_text_before_release: string | null, display_showtimes: boolean | null, link: string | null, release_date: string | null, slots: Array<TicketAnchorSlot> | null, text_after_release: string | null, text_before_release: string | null, text_color: string | null, medias: { desktop: string | null, desktopHp: string | null, mobile: string | null } | null } | { __typename: 'VODHomeData', heading1: string | null, heading2: string | null } } | null };

export type UpdateSpecialOperationTargetMutationVariables = Exact<{
  input: UpdateSpecialOperationTargetInput;
}>;


export type UpdateSpecialOperationTargetMutation = { updateSpecialOperationTarget: { id: string, rank: number, startsAt: string | null, endsAt: string | null, data: any } | null };

export type UpsertCanalHomeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId?: Scalars['ID']['input'];
  localeId?: InputMaybe<Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocaleData?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: CanalHomeDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertCanalHomeMutation = { upsertCanalHome: { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'CanalHomeData', heading1: string | null, heading2: string | null, heading3: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpsertBannerHpMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId?: Scalars['ID']['input'];
  localeId?: InputMaybe<Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocaleData?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: BannerHpDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertBannerHpMutation = { upsertBannerHP: { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'BannerHPData', link_desktop: string | null, link_mobile: string | null, medias: { desktop: string | null, mobile: string | null } | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpsertClub300MutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId?: Scalars['ID']['input'];
  localeId?: InputMaybe<Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocaleData?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: Club300DataInput;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertClub300Mutation = { upsertClub300: { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'Club300Data', _placeholder: boolean | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpsertClassiqueHomeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId?: Scalars['ID']['input'];
  localeId?: InputMaybe<Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocaleData?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: ClassiqueHomeDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertClassiqueHomeMutation = { upsertClassiqueHome: { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'ClassiqueHomeData', heading1: string | null, heading2: string | null, heading3: string | null, link1_label: string | null, link1_url: string | null, link2_label: string | null, link2_url: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpsertDolbyHomeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId?: Scalars['ID']['input'];
  localeId?: InputMaybe<Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocaleData?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: DolbyHomeDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertDolbyHomeMutation = { upsertDolbyHome: { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'DolbyHomeData', _placeholder: boolean | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpsertEmergenceMovieMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId?: Scalars['ID']['input'];
  localeId?: InputMaybe<Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocaleData?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: EmergenceMovieDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertEmergenceMovieMutation = { upsertEmergenceMovie: { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'EmergenceMovieData', distribution: EmergenceDistribution | null, provider: SvodProvider | null, release_date: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpsertDisneyHomeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId?: Scalars['ID']['input'];
  localeId?: InputMaybe<Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocaleData?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: DisneyHomeDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertDisneyHomeMutation = { upsertDisneyHome: { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'DisneyHomeData', medias: { native_grand_angle: { image_url: string | null, url: string | null } | null } | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpsertEmergenceSeriesMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId?: Scalars['ID']['input'];
  localeId?: InputMaybe<Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocaleData?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: EmergenceSeriesDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertEmergenceSeriesMutation = { upsertEmergenceSeries: { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'EmergenceSeriesData', provider: SvodProvider | null, release_date: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpsertFestivalSectionMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId?: Scalars['ID']['input'];
  localeId?: InputMaybe<Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocaleData?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: FestivalSectionDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertFestivalSectionMutation = { upsertFestivalSection: { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'FestivalSectionData', festivalEditionId: number | null, festivalId: number | null, playlist: Array<{ key: string, value: { movies: Array<number> | null, series: Array<number> | null } | null } | null> | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpsertEmergenceTheaterMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId?: Scalars['ID']['input'];
  localeId?: InputMaybe<Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocaleData?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: EmergenceTheaterDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertEmergenceTheaterMutation = { upsertEmergenceTheater: { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'EmergenceTheaterData', release_date: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpsertImaxHomeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId?: Scalars['ID']['input'];
  localeId?: InputMaybe<Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocaleData?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: ImaxHomeDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertImaxHomeMutation = { upsertIMAXHome: { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'IMAXHomeData', _placeholder: boolean | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpsertEmergenceSvodMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId?: Scalars['ID']['input'];
  localeId?: InputMaybe<Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocaleData?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: EmergenceSvodDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertEmergenceSvodMutation = { upsertEmergenceSVOD: { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'EmergenceSVODData', provider: SvodProvider | null, release_date: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpsertM6HomeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId?: Scalars['ID']['input'];
  localeId?: InputMaybe<Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocaleData?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: M6HomeDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertM6HomeMutation = { upsertM6Home: { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'M6HomeData', heading1: string | null, heading2: string | null, heading3: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpsertIndelebileHomeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId?: Scalars['ID']['input'];
  localeId?: InputMaybe<Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocaleData?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: IndelebileHomeDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertIndelebileHomeMutation = { upsertIndelebileHome: { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'IndelebileHomeData', heading1: string | null, heading2: string | null, heading3: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpsertFilmesOnlineMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId?: Scalars['ID']['input'];
  localeId?: InputMaybe<Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocaleData?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: FilmesOnlineDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertFilmesOnlineMutation = { upsertFilmesOnline: { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'FilmesOnlineData', heading1: string | null, heading2: string | null, heading3: string | null, heading4: string | null, heading5: string | null, heading6: string | null, heading7: string | null, heading8: string | null, heading9: string | null, heading10: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpsertRollerHomeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId?: Scalars['ID']['input'];
  localeId?: InputMaybe<Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocaleData?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: RollerHomeDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertRollerHomeMutation = { upsertRollerHome: { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'RollerHomeData', title: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpsertMaxHomeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId?: Scalars['ID']['input'];
  localeId?: InputMaybe<Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocaleData?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: MaxHomeDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertMaxHomeMutation = { upsertMaxHome: { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'MaxHomeData', heading1: string | null, heading2: string | null, heading3: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpsertMobileDdayMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId?: Scalars['ID']['input'];
  localeId?: InputMaybe<Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocaleData?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: MobileDdayDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertMobileDdayMutation = { upsertMobileDday: { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'MobileDdayData', dday_campaign: string | null, dday_movie_id: number | null, dday_movie_list_id: Array<number> | null, dday_movie_list_title: string | null, dday_force_uppercase_headers: boolean | null, dday_nav_background_color_light: string | null, dday_nav_background_color_dark: string | null, dday_nav_font_color_light: string | null, dday_nav_font_color_dark: string | null, dday_main_color_light: string | null, dday_main_color_dark: string | null, dday_title_spacing_between_letters: number | null, dday_title_see_more_title_displayed: boolean | null, dday_background_color: string | null, dday_force_theme_light: boolean | null, dday_force_theme_dark: boolean | null, dday_status_bar_icons_light: boolean | null, dday_status_bar_icons_dark: boolean | null, dday_segmented_color_light: string | null, dday_segmented_color_dark: string | null, dday_segmented_selected_font_color_light: string | null, dday_segmented_selected_font_color_dark: string | null, dday_date: string | null, dday_last_date: string | null, dday_assets_version: number | null, dday_font_url: string | null, dday_font_size: number | null, dday_movie_background_url: string | null, dday_movie_background_id: string | null, dday_movie_logo_url: string | null, dday_movie_logo_id: string | null, dday_splash_background_url: string | null, dday_splash_background_id: string | null, dday_splash_logo_url: string | null, dday_splash_logo_id: string | null, dday_splashscreen_status_bar_color_style: string | null, dday_splashscreen_activity_color: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpsertSponsoredAutocompleteMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId?: Scalars['ID']['input'];
  localeId?: InputMaybe<Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocaleData?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: SponsoredAutocompleteDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertSponsoredAutocompleteMutation = { upsertSponsoredAutocomplete: { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'SponsoredAutocompleteData', release_date: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpsertTf1HomeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId?: Scalars['ID']['input'];
  localeId?: InputMaybe<Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocaleData?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: Tf1HomeDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertTf1HomeMutation = { upsertTF1Home: { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'TF1HomeData', heading1: string | null, heading2: string | null, heading3: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpsertTicketAnchorMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId?: Scalars['ID']['input'];
  localeId?: InputMaybe<Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocaleData?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: TicketAnchorDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertTicketAnchorMutation = { upsertTicketAnchor: { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'TicketAnchorData', cta_text_after_release: string | null, cta_text_before_release: string | null, display_showtimes: boolean | null, link: string | null, release_date: string | null, slots: Array<TicketAnchorSlot> | null, text_after_release: string | null, text_before_release: string | null, text_color: string | null, medias: { desktop: string | null, desktopHp: string | null, mobile: string | null } | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpsertNovelasHomeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId?: Scalars['ID']['input'];
  localeId?: InputMaybe<Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocaleData?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: NovelasHomeDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertNovelasHomeMutation = { upsertNovelasHome: { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'NovelasHomeData', _placeholder: boolean | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type CreateTagMutationVariables = Exact<{
  input: CreateTagInput;
}>;


export type CreateTagMutation = { createTag: { __typename: 'Tag', id: string, ref: string, rawId: number, name: string, active: boolean, type: TagType, scope: TagScope | null, metadata: { updatedAt: string }, data: { seo: { friendly: boolean | null } | null }, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } } | null };

export type GetTagEntitiesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  entityType?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTagEntitiesQuery = { tag: { id: string, entities: { totalCount: number, nodes: Array<{ id: string, rank: number, tag: { id: string, ref: string, name: string, type: TagType, active: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }, entity: { __typename: 'Company', id: string, rawId: number, ref: string, name: string, title: string } | { __typename: 'Movie', id: string, rawId: number, ref: string, title: string } | { __typename: 'News', id: string, rawId: number, ref: string, title: string } | { __typename: 'Person', id: string, rawId: number, ref: string, firstName: string | null, lastName: string | null } | { __typename: 'SeriesEpisode', id: string, rawId: number, ref: string, episodeTitle: string | null } | { __typename: 'SeriesSeason', id: string, rawId: number, ref: string, number: number } | { __typename: 'Series', id: string, rawId: number, ref: string, title: string } | { __typename: 'Slide', id: string, rawId: number, ref: string, title: string } | { __typename: 'Theater', id: string, rawId: number, ref: string, name: string } }> } } | null };

export type UpsertVodHomeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  brandId?: Scalars['ID']['input'];
  localeId?: InputMaybe<Scalars['ID']['input']>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocaleData?: InputMaybe<Scalars['Boolean']['input']>;
  startsAt: Scalars['DateTimeWithoutTz']['input'];
  endsAt?: InputMaybe<Scalars['DateTimeWithoutTz']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  data: VodHomeDataInput;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertVodHomeMutation = { upsertVODHome: { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'VODHomeData', heading1: string | null, heading2: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type GetTagQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetTagQuery = { tagByRef: { __typename: 'Tag', id: string, ref: string, rawId: number, name: string, active: boolean, type: TagType, scope: TagScope | null, metadata: { createdAt: string, updatedAt: string, origin: string | null, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, data: { seo: { friendly: boolean | null, browsable: boolean | null, topRanking: boolean | null, scope: { userRating: { movie: { title: string | null, subTitle: string | null, description: string | null } | null, series: { title: string | null, subTitle: string | null, description: string | null } | null } | null, pressRating: { movie: { title: string | null, subTitle: string | null, description: string | null } | null, series: { title: string | null, subTitle: string | null, description: string | null } | null } | null, popularity: { movie: { title: string | null, subTitle: string | null, description: string | null } | null, series: { title: string | null, subTitle: string | null, description: string | null } | null } | null, ranking: { movie: { title: string | null, subTitle: string | null, description: string | null } | null, series: { title: string | null, subTitle: string | null, description: string | null } | null } | null } | null } | null }, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } } | null };

export type ToggleTagActivationMutationVariables = Exact<{
  input: ToggleTagActivationInput;
}>;


export type ToggleTagActivationMutation = { toggleTagActivation: { id: string } | null };

export type GetTagsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<TagOrder>;
}>;


export type GetTagsQuery = { tags: { totalCount: number, nodes: Array<{ id: string, name: string }> } };

export type GetTagListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  orderBy?: InputMaybe<TagOrder>;
}>;


export type GetTagListQuery = { tags: { totalCount: number, nodes: Array<{ __typename: 'Tag', id: string, ref: string, rawId: number, name: string, active: boolean, type: TagType, scope: TagScope | null, metadata: { updatedAt: string }, data: { seo: { friendly: boolean | null } | null }, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> } };

export type UpdateTagRankMutationVariables = Exact<{
  input: UpdateTagRankInput;
}>;


export type UpdateTagRankMutation = { updateTagRank: { id: string } | null };

export type AddFareMutationVariables = Exact<{
  input: AddFareInput;
}>;


export type AddFareMutation = { addFare: { id: string, theater: { __typename: 'Theater', id: string, ref: string, code: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, fares: { totalCount: number, nodes: Array<{ id: string, name: string, comment: string | null, price: number, currency: Currency, rank: number, screens: Array<{ id: string, name: string }> }> }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } } | null };

export type UpdateTagMutationVariables = Exact<{
  input: UpdateTagInput;
}>;


export type UpdateTagMutation = { updateTag: { __typename: 'Tag', id: string, ref: string, rawId: number, name: string, active: boolean, type: TagType, scope: TagScope | null, metadata: { updatedAt: string }, data: { seo: { friendly: boolean | null, browsable: boolean | null, topRanking: boolean | null, scope: { userRating: { movie: { title: string | null, subTitle: string | null, description: string | null } | null, series: { title: string | null, subTitle: string | null, description: string | null } | null } | null, pressRating: { movie: { title: string | null, subTitle: string | null, description: string | null } | null, series: { title: string | null, subTitle: string | null, description: string | null } | null } | null, popularity: { movie: { title: string | null, subTitle: string | null, description: string | null } | null, series: { title: string | null, subTitle: string | null, description: string | null } | null } | null, ranking: { movie: { title: string | null, subTitle: string | null, description: string | null } | null, series: { title: string | null, subTitle: string | null, description: string | null } | null } | null } | null } | null }, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } } | null };

export type AddImageToTheaterMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
  imageId: Scalars['ID']['input'];
}>;


export type AddImageToTheaterMutation = { addImageToTheater: { rank: number, image: { id: string, url: string, ref: string } } | null };

export type CreateScreensMutationVariables = Exact<{
  input: CreateScreensInput;
}>;


export type CreateScreensMutation = { createScreens: Array<{ id: string }> | null };

export type DataApiProxyQueryVariables = Exact<{
  query: Scalars['String']['input'];
  variables?: InputMaybe<Scalars['JSONObject']['input']>;
}>;


export type DataApiProxyQuery = { dataApi: any };

export type CreateTheaterMutationVariables = Exact<{
  input: CreateTheaterInput;
}>;


export type CreateTheaterMutation = { createTheater: { id: string, code: string } | null };

export type DeleteImageFromTheaterMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
  imageId: Scalars['ID']['input'];
}>;


export type DeleteImageFromTheaterMutation = { deleteImageFromTheater: { rank: number, image: { id: string, url: string } } | null };

export type DeleteScreenMutationVariables = Exact<{
  screenId: Scalars['ID']['input'];
}>;


export type DeleteScreenMutation = { deleteScreen: { id: string } | null };

export type DeleteFareMutationVariables = Exact<{
  input: DeleteFareInput;
}>;


export type DeleteFareMutation = { deleteFare: { id: string, theater: { __typename: 'Theater', id: string, ref: string, code: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, fares: { totalCount: number, nodes: Array<{ id: string, name: string, comment: string | null, price: number, currency: Currency, rank: number, screens: Array<{ id: string, name: string }> }> }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } } | null };

export type GetMarketsQueryVariables = Exact<{
  countryId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetMarketsQuery = { markets: Array<string> };

export type GetScreenListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  theater: Scalars['ID']['input'];
}>;


export type GetScreenListQuery = { theater: { id: string, code: string, screens: { totalCount: number, nodes: Array<{ id: string, ref: string, number: number | null, name: string, seats: number | null, flags: { accessibility: Array<string>, comfort: Array<string>, experience: Array<string>, food: Array<string>, picture: Array<string>, restriction: Array<string>, service: Array<string>, sound: Array<string> } }> } } | null };

export type ScreenRowFragment = { id: string, ref: string, number: number | null, name: string, seats: number | null, flags: { accessibility: Array<string>, comfort: Array<string>, experience: Array<string>, food: Array<string>, picture: Array<string>, restriction: Array<string>, service: Array<string>, sound: Array<string> } };

export type GetTheaterAdditionalInfoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTheaterAdditionalInfoQuery = { theater: { id: string, email: string | null, movieLine: string | null, timezone: string | null, openingStatus: TheaterOpeningStatus, phone: string | null, websiteUrl: string | null, androidUrl: string | null, iosUrl: string | null, showtimesUrl: string | null, showtimesAlternateUrl: string | null, note: string | null, displayName: string | null, showtimeSource: TheaterShowtimeSource | null, foundedAt: string | null, showtimesGatheringMethod: TheaterShowtimesGatheringMethod | null, showtimesGatheringMethodCode: string | null, showtimesGatheringMethodPriority: string | null, temporaryClosure: { startsAt: string | null, endsAt: string | null, message: string } | null, nextOpening: { startsAt: string | null, message: string } | null } | null };

export type TheaterAdditionalInfoFragment = { id: string, email: string | null, movieLine: string | null, timezone: string | null, openingStatus: TheaterOpeningStatus, phone: string | null, websiteUrl: string | null, androidUrl: string | null, iosUrl: string | null, showtimesUrl: string | null, showtimesAlternateUrl: string | null, note: string | null, displayName: string | null, showtimeSource: TheaterShowtimeSource | null, foundedAt: string | null, showtimesGatheringMethod: TheaterShowtimesGatheringMethod | null, showtimesGatheringMethodCode: string | null, showtimesGatheringMethodPriority: string | null, temporaryClosure: { startsAt: string | null, endsAt: string | null, message: string } | null, nextOpening: { startsAt: string | null, message: string } | null };

export type TheaterNextOpeningFragment = { startsAt: string | null, message: string };

export type GetTheaterAddressQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTheaterAddressQuery = { theater: { id: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, coordinates: { latitude: number, longitude: number } | null, location: { address: string | null, address2: string | null, zip: string | null, city: string | null, state: string | null, county: string | null, country: string | null } | null } | null };

export type GetTheaterAttributesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTheaterAttributesQuery = { theater: { __typename: 'Theater', id: string, market: string | null, scheduledTypology: Array<TheaterTypology>, affiliatedTo: Array<{ __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }>, tradeGroup: Array<{ __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }>, pointOfSale: Array<{ __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, flags: { payment: Array<TheaterPaymentMethod>, service: Array<TheaterExtraService> }, ticketing: { useAtom: boolean, useMovieTickets: boolean } } | null };

export type GetTheaterChainQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetTheaterChainQuery = { entityByRef: { __typename: 'Company', id: string, ref: string, name: string, activities: Array<CompanyActivity>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | {} | null };

export type TheaterChainFragment = { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> };

export type TheaterCountryFragment = { __typename: 'Country', id: string, ref: string, name: string, alpha2: string };

export type GetTheaterFareListQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTheaterFareListQuery = { theater: { id: string, fares: { totalCount: number, nodes: Array<{ id: string, name: string, comment: string | null, price: number, currency: Currency, rank: number, screens: Array<{ id: string, name: string }> }> } } | null };

export type GetTheaterDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTheaterDataQuery = { theater: { __typename: 'Theater', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> } | null };

export type GetTheaterIdentityQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTheaterIdentityQuery = { theater: { id: string, name: string, foundedAt: string | null, logo: { id: string, url: string, ref: string } | null, parent: { __typename: 'Company', ref: string, activities: Array<CompanyActivity>, id: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } } | null };

export type TheaterIdentityFragment = { id: string, name: string, foundedAt: string | null, logo: { id: string, url: string, ref: string } | null, parent: { __typename: 'Company', ref: string, activities: Array<CompanyActivity>, id: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } };

export type GetTheaterImagesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
}>;


export type GetTheaterImagesQuery = { theater: { id: string, images: { totalCount: number, nodes: Array<{ rank: number, image: { id: string, url: string, ref: string } }> } } | null };

export type GetTheaterLinksQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTheaterLinksQuery = { theater: { id: string, links: { facebook: string | null, bluesky: string | null, instagram: string | null, letterboxd: string | null, linkedin: string | null, pinterest: string | null, snapchat: string | null, tiktok: string | null, threads: string | null, tumblr: string | null, twitter: string | null, vk: string | null, wechat: string | null, whatsapp: string | null, youtube: string | null } } | null };

export type GetTheaterListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  search: Scalars['String']['input'];
  companyIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  countryIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  localizationIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  theaterOpeningStatuses: Array<TheaterOpeningStatus> | TheaterOpeningStatus;
  showtimeSources?: InputMaybe<Array<TheaterShowtimeSource> | TheaterShowtimeSource>;
  orderBy: TheaterOrder;
}>;


export type GetTheaterListQuery = { theaters: { totalCount: number, nodes: Array<{ __typename: 'Theater', id: string, ref: string, name: string, code: string, showtimeSource: TheaterShowtimeSource | null, openingStatus: TheaterOpeningStatus, showtimesGatheringMethod: TheaterShowtimesGatheringMethod | null, showtimesGatheringMethodCode: string | null, closed: boolean, parent: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null, location: { zip: string | null, city: string | null } | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, localization: { name: string } | null, metadata: { createdAt: string }, temporaryClosure: { startsAt: string | null, endsAt: string | null, message: string } | null }> } };

export type ClosureFragment = { closed: boolean, temporaryClosure: { startsAt: string | null, endsAt: string | null, message: string } | null };

export type GetTheaterLocalizedDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  locale: Scalars['ID']['input'];
}>;


export type GetTheaterLocalizedDataQuery = { theater: { id: string, localeData: { title: string | null, description: string | null, locale: string, address: string | null, city: string | null, state: string | null } | null } | null };

export type GetTheaterMetadataQueryVariables = Exact<{
  code: Scalars['ID']['input'];
}>;


export type GetTheaterMetadataQuery = { theaterByCode: { id: string, name: string, activeOnBrands: Array<{ ref: string }>, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type MoveFareMutationVariables = Exact<{
  input: MoveFareInput;
}>;


export type MoveFareMutation = { moveFare: { id: string, name: string, comment: string | null, price: number, currency: Currency, rank: number, screens: Array<{ id: string, name: string }> } | null };

export type UpdateTheaterAddressMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
  coordinates: CoordinatesInput;
  location: LocationInput;
}>;


export type UpdateTheaterAddressMutation = { updateEntityLocalization: { id: string, timezone: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, coordinates: { latitude: number, longitude: number } | null, location: { address: string | null, address2: string | null, zip: string | null, city: string | null, state: string | null, county: string | null, country: string | null } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | {} | null };

export type UpdateFareMutationVariables = Exact<{
  input: UpdateFareInput;
}>;


export type UpdateFareMutation = { updateFare: { id: string, name: string, comment: string | null, price: number, currency: Currency, rank: number, screens: Array<{ id: string, name: string }> } | null };

export type UpdateTheaterFlagsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  flags?: InputMaybe<TheaterFlagsInput>;
}>;


export type UpdateTheaterFlagsMutation = { updateTheater: { id: string, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, flags: { payment: Array<TheaterPaymentMethod>, service: Array<TheaterExtraService> } } | null };

export type UpdateTheaterInfoMutationVariables = Exact<{
  input: UpdateTheaterInput;
}>;


export type UpdateTheaterInfoMutation = { updateTheater: { id: string, code: string, name: string, foundedAt: string | null, movieLine: string | null, timezone: string | null, closed: boolean, displayName: string | null, email: string | null, phone: string | null, websiteUrl: string | null, androidUrl: string | null, iosUrl: string | null, showtimesUrl: string | null, showtimesAlternateUrl: string | null, showtimeSource: TheaterShowtimeSource | null, showtimesGatheringMethod: TheaterShowtimesGatheringMethod | null, showtimesGatheringMethodCode: string | null, showtimesGatheringMethodPriority: string | null, note: string | null, openingStatus: TheaterOpeningStatus, parent: { id: string, ref: string, name: string, activities: Array<CompanyActivity> } | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, logo: { id: string, url: string, ref: string } | null, temporaryClosure: { message: string, startsAt: string | null, endsAt: string | null } | null, nextOpening: { startsAt: string | null, message: string } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpdateTheaterIdentityMutationVariables = Exact<{
  input: UpdateTheaterInput;
}>;


export type UpdateTheaterIdentityMutation = { updateTheater: { id: string, code: string, name: string, foundedAt: string | null, movieLine: string | null, timezone: string | null, closed: boolean, displayName: string | null, email: string | null, phone: string | null, websiteUrl: string | null, androidUrl: string | null, iosUrl: string | null, showtimesUrl: string | null, showtimesAlternateUrl: string | null, showtimeSource: TheaterShowtimeSource | null, showtimesGatheringMethod: TheaterShowtimesGatheringMethod | null, showtimesGatheringMethodCode: string | null, showtimesGatheringMethodPriority: string | null, note: string | null, openingStatus: TheaterOpeningStatus, parent: { id: string, ref: string, name: string, activities: Array<CompanyActivity> } | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, logo: { id: string, url: string, ref: string } | null, temporaryClosure: { message: string, startsAt: string | null, endsAt: string | null } | null, nextOpening: { startsAt: string | null, message: string } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpdateTheaterAffiliationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  market?: InputMaybe<Scalars['String']['input']>;
  affiliatedTo?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  tradeGroup?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  pointOfSale?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  scheduledTypology?: InputMaybe<Array<TheaterTypology> | TheaterTypology>;
}>;


export type UpdateTheaterAffiliationMutation = { updateTheater: { __typename: 'Theater', id: string, market: string | null, scheduledTypology: Array<TheaterTypology>, affiliatedTo: Array<{ __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }>, tradeGroup: Array<{ __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }>, pointOfSale: Array<{ __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpdateTheaterLinksMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  links: SocialLinksInput;
}>;


export type UpdateTheaterLinksMutation = { updateTheater: { id: string, links: { facebook: string | null, bluesky: string | null, instagram: string | null, letterboxd: string | null, linkedin: string | null, pinterest: string | null, snapchat: string | null, tiktok: string | null, threads: string | null, tumblr: string | null, twitter: string | null, vk: string | null, wechat: string | null, whatsapp: string | null, youtube: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpdateTheaterLocalizedDataMutationVariables = Exact<{
  theaterId: Scalars['ID']['input'];
  locale: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateTheaterLocalizedDataMutation = { updateTheaterLocaleData: { id: string, localeData: { locale: string, title: string | null, description: string | null, address: string | null, city: string | null, state: string | null } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type DeleteTriviaMutationVariables = Exact<{
  input: DeleteTriviaInput;
}>;


export type DeleteTriviaMutation = { deleteTrivia: { id: string } | null };

export type UpdateTheaterTicketingMutationVariables = Exact<{
  input: UpdateTheaterTicketingInput;
}>;


export type UpdateTheaterTicketingMutation = { updateTheaterTicketing: { id: string, ticketing: { useAtom: boolean, useMovieTickets: boolean }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type GetTriviaListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  brandId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTriviaListQuery = { trivias: { totalCount: number, nodes: Array<{ __typename: 'Trivia', id: string, ref: string, active: boolean, title: string, type: TriviaType | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, relatedEntities: Array<{ __typename: 'Movie', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | { __typename: 'SeriesEpisode', ref: string, id: string, number: number, series: { ref: string, id: string, title: string }, season: { ref: string } | null } | { __typename: 'Person', ref: string, id: string, lastName: string | null, firstName: string | null }> }> } };

export type GetTriviaQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetTriviaQuery = { triviaByRef: { id: string, rawId: number, ref: string, active: boolean, title: string, type: TriviaType | null, body: string | object[] | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } } | null };

export type CreateTriviaMutationVariables = Exact<{
  input: CreateTriviaInput;
}>;


export type CreateTriviaMutation = { createTrivia: { id: string, ref: string } | null };

export type UpdateTriviaMutationVariables = Exact<{
  input: UpdateTriviaInput;
}>;


export type UpdateTriviaMutation = { updateTrivia: { id: string, rawId: number, ref: string, active: boolean, title: string, type: TriviaType | null, body: string | object[] | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } } | null };

export type GetTriviaRelatedEntitiesListQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  excludedTypes?: InputMaybe<Array<TriviaLinkableEntityType> | TriviaLinkableEntityType>;
  includedTypes?: InputMaybe<Array<TriviaLinkableEntityType> | TriviaLinkableEntityType>;
}>;


export type GetTriviaRelatedEntitiesListQuery = { trivia: { id: string, relatedEntities: Array<{ __typename: 'Movie', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | { __typename: 'SeriesEpisode', ref: string, id: string, number: number, series: { ref: string, id: string, title: string }, season: { ref: string } | null } | { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null }> } | null };

export type CreateFileUploadTokenMutationVariables = Exact<{
  fileStorageType: FileUploadStorageType;
  mimeType: FileUploadMimeType;
  originalFileName: Scalars['String']['input'];
  iso8601Duration?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateFileUploadTokenMutation = { createFileUploadToken: { uploadUrl: string, uploadToken: string, additionalStorageParams: any | null, relativePath: string } | null };

export type CreateVideoMutationVariables = Exact<{
  input: CreateVideoInput;
}>;


export type CreateVideoMutation = { createVideo: { id: string, ref: string, title: string | null } | { id: string, ref: string, title: string | null } | null };

export type DeleteVideoFileMutationVariables = Exact<{
  videoRef: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
}>;


export type DeleteVideoFileMutation = { deleteVideoFile: { __typename: 'VideoLegacy' } | { __typename: 'VideoB2B' } | null };

export type GetVideoCopyrightQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
  type: EntityType;
}>;


export type GetVideoCopyrightQuery = { entityByRef: { id: string, copyrightName: string | null, copyrights: Array<{ id: string, name: string }> | null } | { id: string, copyrightName: string | null, copyrights: Array<{ id: string, name: string }> | null } | {} | null };

type VideoCopyright_VideoLegacy_Fragment = { id: string, copyrightName: string | null, copyrights: Array<{ id: string, name: string }> | null };

type VideoCopyright_VideoB2B_Fragment = { id: string, copyrightName: string | null, copyrights: Array<{ id: string, name: string }> | null };

export type VideoCopyrightFragment = VideoCopyright_VideoLegacy_Fragment | VideoCopyright_VideoB2B_Fragment;

export type DeleteVideoMutationVariables = Exact<{
  input: DeleteVideoInput;
}>;


export type DeleteVideoMutation = { deleteVideo: { __typename: 'VideoLegacy', id: string, ref: string } | { __typename: 'VideoB2B', id: string, ref: string } | null };

export type GetVideoFilesQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
  type: EntityType;
}>;


export type GetVideoFilesQuery = { entityByRef: { __typename: 'User' } | { __typename: 'Locale' } | { __typename: 'Author' } | { __typename: 'SocialUser' } | { __typename: 'Image' } | { __typename: 'Movie' } | { __typename: 'ImageCategory' } | { __typename: 'Series' } | { __typename: 'Company' } | { __typename: 'CompanyStaff' } | { __typename: 'News' } | { __typename: 'VideoLegacy', dailymotionUrl: string | null, youtubeUrl: string | null, defaultYoutubeChannelId: string | null, dailymotionChannelId: string | null, id: string, ref: string, youtubeChannels: Array<{ id: string, label: string }>, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, videoFiles: Array<{ id: string, width: number | null, height: number | null, path: string | null, cdnUrl: string | null, formats: Array<VideoFormats>, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null> | null, snapshot: { id: string, url: string } | null, alt: { dailymotion: Array<string> | null, youtube: Array<{ id: string, channelId: string, channelLabel: string | null }> | null, videoEncoder: Array<{ id: string | null, platform: VideoPlatformEnum, channelId: string | null, fileCount: number | null, canRetry: boolean, status: VideoEncoderStatusEnum, statusText: string | null, cancelError: string | null, isCancelPending: boolean, isLinked: boolean, createdAt: string, updatedAt: string }> | null } | null } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' } | { __typename: 'Certificate' } | { __typename: 'Person' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | { __typename: 'Slide' } | { __typename: 'Carousel' } | { __typename: 'Theater' } | { __typename: 'Screen' } | { __typename: 'FestivalAward' } | { __typename: 'FestivalSelection' } | { __typename: 'FestivalCompetition' } | { __typename: 'FestivalEditionCompetition' } | { __typename: 'FestivalJury' } | { __typename: 'TheaterEvent' } | { __typename: 'Widget' } | { __typename: 'VideoB2B', id: string, ref: string, videoFiles: Array<{ id: string, width: number | null, height: number | null, path: string | null, cdnUrl: string | null, formats: Array<VideoFormats>, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null> | null, snapshot: { id: string, url: string } | null, alt: { dailymotion: Array<string> | null, youtube: Array<{ id: string, channelId: string, channelLabel: string | null }> | null, videoEncoder: Array<{ id: string | null, platform: VideoPlatformEnum, channelId: string | null, fileCount: number | null, canRetry: boolean, status: VideoEncoderStatusEnum, statusText: string | null, cancelError: string | null, isCancelPending: boolean, isLinked: boolean, createdAt: string, updatedAt: string }> | null } | null } | null };

type VideoFiles_VideoLegacy_Fragment = { __typename: 'VideoLegacy', dailymotionUrl: string | null, youtubeUrl: string | null, defaultYoutubeChannelId: string | null, dailymotionChannelId: string | null, id: string, ref: string, youtubeChannels: Array<{ id: string, label: string }>, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, videoFiles: Array<{ id: string, width: number | null, height: number | null, path: string | null, cdnUrl: string | null, formats: Array<VideoFormats>, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null> | null, snapshot: { id: string, url: string } | null };

type VideoFiles_VideoB2B_Fragment = { __typename: 'VideoB2B', id: string, ref: string, videoFiles: Array<{ id: string, width: number | null, height: number | null, path: string | null, cdnUrl: string | null, formats: Array<VideoFormats>, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null> | null, snapshot: { id: string, url: string } | null };

export type VideoFilesFragment = VideoFiles_VideoLegacy_Fragment | VideoFiles_VideoB2B_Fragment;

export type GetVideoEmbedCodeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetVideoEmbedCodeQuery = { entity: { __typename: 'VideoLegacy', id: string, embedCode: string | null } | { __typename: 'VideoB2B', id: string, embedCode: string | null } | {} | null };

type VideoEmbedCode_VideoLegacy_Fragment = { __typename: 'VideoLegacy', id: string, embedCode: string | null };

type VideoEmbedCode_VideoB2B_Fragment = { __typename: 'VideoB2B', id: string, embedCode: string | null };

export type VideoEmbedCodeFragment = VideoEmbedCode_VideoLegacy_Fragment | VideoEmbedCode_VideoB2B_Fragment;

export type GetVideoLanguageAndSubtitleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetVideoLanguageAndSubtitleQuery = { entity: { __typename: 'VideoLegacy', id: string, language: Language | null, subtitle: Language | null, brand: { __typename: 'Brand', id: string, ref: string, language: Language | null } } | { __typename: 'VideoB2B', id: string, language: Language | null, subtitle: Language | null } | {} | null };

export type VideoLanguageAndSubtitleB2BFragment = { __typename: 'VideoB2B', id: string, language: Language | null, subtitle: Language | null };

export type VideoLanguageAndSubtitleLegacyFragment = { __typename: 'VideoLegacy', id: string, language: Language | null, subtitle: Language | null, brand: { __typename: 'Brand', id: string, ref: string, language: Language | null } };

export type GetVideoListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  orderBy: VideoOrder;
  search?: InputMaybe<Scalars['String']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<VideoType>;
  universes?: InputMaybe<Array<InputMaybe<VideoUniverse>> | InputMaybe<VideoUniverse>>;
}>;


export type GetVideoListQuery = { videoLegacyList: { totalCount: number, nodes: Array<{ __typename: 'VideoLegacy', id: string, active: boolean, ref: string, title: string | null, generatedTitle: string | null, type: VideoType, universe: VideoUniverse | null, language: Language | null, subtitle: Language | null, duration: { hours: number, minutes: number, seconds: number } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, snapshot: { path: string, url: string } | null, previewVideoFile: { cdnUrl: string | null } | null }> } };

export type GetVideoRestrictionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetVideoRestrictionsQuery = { entity: { __typename: 'VideoLegacy', dailymotionUrl: string | null, id: string, brand: { country: { id: string } }, validity: { validity_from: string | null, validity_to: string | null } | null, certificate: { __typename: 'Certificate', id: string, ref: string, rank: number, active: boolean, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null } | null } | { __typename: 'VideoB2B', id: string, validity: { validity_from: string | null, validity_to: string | null } | null, certificate: { __typename: 'Certificate', id: string, ref: string, rank: number, active: boolean, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null } | null } | {} | null };

type VideoRestrictions_VideoLegacy_Fragment = { __typename: 'VideoLegacy', dailymotionUrl: string | null, id: string, brand: { country: { id: string } }, validity: { validity_from: string | null, validity_to: string | null } | null, certificate: { __typename: 'Certificate', id: string, ref: string, rank: number, active: boolean, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null } | null };

type VideoRestrictions_VideoB2B_Fragment = { __typename: 'VideoB2B', id: string, validity: { validity_from: string | null, validity_to: string | null } | null, certificate: { __typename: 'Certificate', id: string, ref: string, rank: number, active: boolean, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null } | null };

export type VideoRestrictionsFragment = VideoRestrictions_VideoLegacy_Fragment | VideoRestrictions_VideoB2B_Fragment;

export type GetVideoRelatedEntitiesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetVideoRelatedEntitiesQuery = { entity: { id: string, relatedEntities: Array<{ __typename: 'Movie', id: string, ref: string, movieTitle: string } | { __typename: 'Series', id: string, ref: string, seriesTitle: string } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | { __typename: 'SeriesEpisode', id: string, ref: string, number: number, title: string | null, series: { id: string, ref: string, title: string }, season: { id: string, ref: string, number: number } | null } | { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, formalName: string | null } | { __typename: 'Festival', id: string, ref: string, festivalName: string } | { __typename: 'FestivalEdition', id: string, ref: string, editionNumber: number | null, year: number, editionName: string | null, festival: { id: string, ref: string, festivalName: string } }> } | { id: string, relatedEntities: Array<{ __typename: 'Movie', id: string, ref: string, movieTitle: string } | { __typename: 'Series', id: string, ref: string, seriesTitle: string } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | { __typename: 'SeriesEpisode', id: string, ref: string, number: number, title: string | null, series: { id: string, ref: string, title: string }, season: { id: string, ref: string, number: number } | null } | { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, formalName: string | null } | { __typename: 'Festival', id: string, ref: string, festivalName: string } | { __typename: 'FestivalEdition', id: string, ref: string, editionNumber: number | null, year: number, editionName: string | null, festival: { id: string, ref: string, festivalName: string } }> } | {} | null };

type VideoRelatedEntities_VideoLegacy_Fragment = { id: string, relatedEntities: Array<{ __typename: 'Movie', id: string, ref: string, movieTitle: string } | { __typename: 'Series', id: string, ref: string, seriesTitle: string } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | { __typename: 'SeriesEpisode', id: string, ref: string, number: number, title: string | null, series: { id: string, ref: string, title: string }, season: { id: string, ref: string, number: number } | null } | { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, formalName: string | null } | { __typename: 'Festival', id: string, ref: string, festivalName: string } | { __typename: 'FestivalEdition', id: string, ref: string, editionNumber: number | null, year: number, editionName: string | null, festival: { id: string, ref: string, festivalName: string } }> };

type VideoRelatedEntities_VideoB2B_Fragment = { id: string, relatedEntities: Array<{ __typename: 'Movie', id: string, ref: string, movieTitle: string } | { __typename: 'Series', id: string, ref: string, seriesTitle: string } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | { __typename: 'SeriesEpisode', id: string, ref: string, number: number, title: string | null, series: { id: string, ref: string, title: string }, season: { id: string, ref: string, number: number } | null } | { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, formalName: string | null } | { __typename: 'Festival', id: string, ref: string, festivalName: string } | { __typename: 'FestivalEdition', id: string, ref: string, editionNumber: number | null, year: number, editionName: string | null, festival: { id: string, ref: string, festivalName: string } }> };

export type VideoRelatedEntitiesFragment = VideoRelatedEntities_VideoLegacy_Fragment | VideoRelatedEntities_VideoB2B_Fragment;

export type GetVideoSuggestedTitleQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
  type: EntityType;
}>;


export type GetVideoSuggestedTitleQuery = { entityByRef: { __typename: 'User' } | { __typename: 'Locale' } | { __typename: 'Author' } | { __typename: 'SocialUser' } | { __typename: 'Image' } | { __typename: 'Movie' } | { __typename: 'ImageCategory' } | { __typename: 'Series' } | { __typename: 'Company' } | { __typename: 'CompanyStaff' } | { __typename: 'News' } | { __typename: 'VideoLegacy', id: string, suggestedTitle: string | null } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' } | { __typename: 'Certificate' } | { __typename: 'Person' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | { __typename: 'Slide' } | { __typename: 'Carousel' } | { __typename: 'Theater' } | { __typename: 'Screen' } | { __typename: 'FestivalAward' } | { __typename: 'FestivalSelection' } | { __typename: 'FestivalCompetition' } | { __typename: 'FestivalEditionCompetition' } | { __typename: 'FestivalJury' } | { __typename: 'TheaterEvent' } | { __typename: 'Widget' } | { __typename: 'VideoB2B', id: string, suggestedTitle: string | null } | null };

type VideoSuggestedTitle_VideoLegacy_Fragment = { id: string, suggestedTitle: string | null };

type VideoSuggestedTitle_VideoB2B_Fragment = { id: string, suggestedTitle: string | null };

export type VideoSuggestedTitleFragment = VideoSuggestedTitle_VideoLegacy_Fragment | VideoSuggestedTitle_VideoB2B_Fragment;

export type LinkEntityToVideoMutationVariables = Exact<{
  input: LinkEntityToVideoInput;
}>;


export type LinkEntityToVideoMutation = { linkEntityToVideo: { __typename: 'Movie' } | { __typename: 'Series' } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' } | { __typename: 'Person' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | null };

export type GetVideoQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
  type: EntityType;
}>;


export type GetVideoQuery = { entityByRef: { __typename: 'User' } | { __typename: 'Locale' } | { __typename: 'Author' } | { __typename: 'SocialUser' } | { __typename: 'Image' } | { __typename: 'Movie' } | { __typename: 'ImageCategory' } | { __typename: 'Series' } | { __typename: 'Company' } | { __typename: 'CompanyStaff' } | { __typename: 'News' } | { __typename: 'VideoLegacy', rawId: number, universe: VideoUniverse | null, id: string, ref: string, title: string | null, generatedTitle: string | null, active: boolean, type: VideoType, description: string | null, copyrightName: string | null, startsAt: string | null, endsAt: string | null, embedCode: string | null, restrictions: Array<RestrictionType>, language: Language | null, subtitle: Language | null, metadata: { createdAt: string, updatedAt: string, origin: string | null, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, previewVideoFile: { cdnUrl: string | null } | null, brand: { __typename: 'Brand', language: Language | null, id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, certificate: { __typename: 'Certificate', id: string, ref: string, rank: number, active: boolean, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null } | null, alt: { videoEncoder: Array<{ status: VideoEncoderStatusEnum, createdAt: string, updatedAt: string }> | null } | null, snapshot: { __typename: 'Image', id: string, title: string | null, path: string, url: string } | null, duration: { hours: number, minutes: number, seconds: number } | null, copyrights: Array<{ id: string, name: string }> | null } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' } | { __typename: 'Certificate' } | { __typename: 'Person' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | { __typename: 'Slide' } | { __typename: 'Carousel' } | { __typename: 'Theater' } | { __typename: 'Screen' } | { __typename: 'FestivalAward' } | { __typename: 'FestivalSelection' } | { __typename: 'FestivalCompetition' } | { __typename: 'FestivalEditionCompetition' } | { __typename: 'FestivalJury' } | { __typename: 'TheaterEvent' } | { __typename: 'Widget' } | { __typename: 'VideoB2B', rawId: number, id: string, ref: string, title: string | null, generatedTitle: string | null, active: boolean, type: VideoType, description: string | null, copyrightName: string | null, startsAt: string | null, endsAt: string | null, embedCode: string | null, restrictions: Array<RestrictionType>, language: Language | null, subtitle: Language | null, metadata: { createdAt: string, updatedAt: string, origin: string | null, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, previewVideoFile: { cdnUrl: string | null } | null, certificate: { __typename: 'Certificate', id: string, ref: string, rank: number, active: boolean, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null } | null, snapshot: { __typename: 'Image', id: string, title: string | null, path: string, url: string } | null, duration: { hours: number, minutes: number, seconds: number } | null, copyrights: Array<{ id: string, name: string }> | null } | null };

type VideoEntity_VideoLegacy_Fragment = { __typename: 'VideoLegacy', rawId: number, universe: VideoUniverse | null, id: string, ref: string, title: string | null, generatedTitle: string | null, active: boolean, type: VideoType, description: string | null, copyrightName: string | null, startsAt: string | null, endsAt: string | null, embedCode: string | null, restrictions: Array<RestrictionType>, language: Language | null, subtitle: Language | null, metadata: { createdAt: string, updatedAt: string, origin: string | null, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, previewVideoFile: { cdnUrl: string | null } | null, brand: { __typename: 'Brand', language: Language | null, id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, certificate: { __typename: 'Certificate', id: string, ref: string, rank: number, active: boolean, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null } | null, alt: { videoEncoder: Array<{ status: VideoEncoderStatusEnum, createdAt: string, updatedAt: string }> | null } | null, snapshot: { __typename: 'Image', id: string, title: string | null, path: string, url: string } | null, duration: { hours: number, minutes: number, seconds: number } | null, copyrights: Array<{ id: string, name: string }> | null };

type VideoEntity_VideoB2B_Fragment = { __typename: 'VideoB2B', rawId: number, id: string, ref: string, title: string | null, generatedTitle: string | null, active: boolean, type: VideoType, description: string | null, copyrightName: string | null, startsAt: string | null, endsAt: string | null, embedCode: string | null, restrictions: Array<RestrictionType>, language: Language | null, subtitle: Language | null, metadata: { createdAt: string, updatedAt: string, origin: string | null, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, previewVideoFile: { cdnUrl: string | null } | null, certificate: { __typename: 'Certificate', id: string, ref: string, rank: number, active: boolean, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null } | null, snapshot: { __typename: 'Image', id: string, title: string | null, path: string, url: string } | null, duration: { hours: number, minutes: number, seconds: number } | null, copyrights: Array<{ id: string, name: string }> | null };

export type VideoEntityFragment = VideoEntity_VideoLegacy_Fragment | VideoEntity_VideoB2B_Fragment;

export type MoveEntityVideoMutationVariables = Exact<{
  input: MoveEntityVideoInput;
}>;


export type MoveEntityVideoMutation = { moveEntityVideo: { __typename: 'Movie', id: string } | { __typename: 'Series', id: string } | { __typename: 'SeriesSeason', id: string } | { __typename: 'SeriesEpisode', id: string } | { __typename: 'Person', id: string } | { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | null };

export type UnlinkEntityFromVideoMutationVariables = Exact<{
  input: UnlinkEntityFromVideoInput;
}>;


export type UnlinkEntityFromVideoMutation = { unlinkEntityFromVideo: { __typename: 'Movie' } | { __typename: 'Series' } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' } | { __typename: 'Person' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | null };

export type SetYoutubeVideoIdMutationVariables = Exact<{
  videoRef: Scalars['ID']['input'];
  youtubeVideo: Scalars['String']['input'];
}>;


export type SetYoutubeVideoIdMutation = { setYoutubeVideoId: { __typename: 'VideoLegacy', id: string, ref: string, youtubeUrl: string | null, alt: { dailymotion: Array<string> | null, youtube: Array<{ id: string, channelId: string, channelLabel: string | null }> | null, videoEncoder: Array<{ id: string | null, platform: VideoPlatformEnum, channelId: string | null, fileCount: number | null, canRetry: boolean, status: VideoEncoderStatusEnum, statusText: string | null, cancelError: string | null, isCancelPending: boolean, isLinked: boolean, createdAt: string, updatedAt: string }> | null } | null } | null };

export type RetryVideoPlatformEncodingMutationVariables = Exact<{
  videoRef: Scalars['ID']['input'];
  platform: VideoPlatformEnum;
  youtubeChannelId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RetryVideoPlatformEncodingMutation = { retryVideoPlatformEncoding: { __typename: 'VideoLegacy', id: string, alt: { dailymotion: Array<string> | null, youtube: Array<{ id: string, channelId: string, channelLabel: string | null }> | null, videoEncoder: Array<{ id: string | null, platform: VideoPlatformEnum, channelId: string | null, fileCount: number | null, canRetry: boolean, status: VideoEncoderStatusEnum, statusText: string | null, cancelError: string | null, isCancelPending: boolean, isLinked: boolean, createdAt: string, updatedAt: string }> | null } | null } | null };

export type VideoEncodingProgressSubscriptionVariables = Exact<{
  videoId: Scalars['ID']['input'];
}>;


export type VideoEncodingProgressSubscription = { videoEncodingProgress: { videoId: string, videoEncoders: Array<{ id: string | null, platform: VideoPlatformEnum, channelId: string | null, fileCount: number | null, canRetry: boolean, status: VideoEncoderStatusEnum, statusText: string | null, cancelError: string | null, isCancelPending: boolean, isLinked: boolean, createdAt: string, updatedAt: string }> } };

export type UpdateVideoMutationVariables = Exact<{
  input: UpdateVideoInput;
}>;


export type UpdateVideoMutation = { updateVideo: { __typename: 'VideoLegacy', rawId: number, universe: VideoUniverse | null, id: string, ref: string, title: string | null, generatedTitle: string | null, active: boolean, type: VideoType, description: string | null, copyrightName: string | null, startsAt: string | null, endsAt: string | null, embedCode: string | null, restrictions: Array<RestrictionType>, language: Language | null, subtitle: Language | null, dailymotionUrl: string | null, previewVideoFile: { cdnUrl: string | null } | null, brand: { __typename: 'Brand', language: Language | null, id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, certificate: { __typename: 'Certificate', id: string, ref: string, rank: number, active: boolean, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, metadata: { createdAt: string, updatedAt: string, origin: string | null, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null } | null, alt: { videoEncoder: Array<{ status: VideoEncoderStatusEnum, createdAt: string, updatedAt: string }> | null } | null, snapshot: { __typename: 'Image', id: string, title: string | null, path: string, url: string } | null, duration: { hours: number, minutes: number, seconds: number } | null, copyrights: Array<{ id: string, name: string }> | null, metadata: { createdAt: string, updatedAt: string, origin: string | null, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, validity: { validity_from: string | null, validity_to: string | null } | null } | { __typename: 'VideoB2B', rawId: number, id: string, ref: string, title: string | null, generatedTitle: string | null, active: boolean, type: VideoType, description: string | null, copyrightName: string | null, startsAt: string | null, endsAt: string | null, embedCode: string | null, restrictions: Array<RestrictionType>, language: Language | null, subtitle: Language | null, previewVideoFile: { cdnUrl: string | null } | null, certificate: { __typename: 'Certificate', id: string, ref: string, rank: number, active: boolean, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, metadata: { createdAt: string, updatedAt: string, origin: string | null, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null } | null, snapshot: { __typename: 'Image', id: string, title: string | null, path: string, url: string } | null, duration: { hours: number, minutes: number, seconds: number } | null, copyrights: Array<{ id: string, name: string }> | null, metadata: { createdAt: string, updatedAt: string, origin: string | null, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, validity: { validity_from: string | null, validity_to: string | null } | null } | null };

export type UploadVideoMutationVariables = Exact<{
  uploadToken: Scalars['String']['input'];
  videoRef: Scalars['ID']['input'];
  platforms?: InputMaybe<Array<VideoPlatformEnum> | VideoPlatformEnum>;
  youtubeChannelId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UploadVideoMutation = { uploadVideo: { __typename: 'VideoLegacy', id: string, ref: string } | { __typename: 'VideoB2B', id: string, ref: string } | null };

export type CreateWidgetMutationVariables = Exact<{
  input: CreateWidgetInput;
}>;


export type CreateWidgetMutation = { createWidget: { id: string, ref: string, name: string, type: WidgetType, url: string | null } | null };

export type DeleteWidgetMutationVariables = Exact<{
  input: DeleteWidgetInput;
}>;


export type DeleteWidgetMutation = { deleteWidget: { id: string } | null };

export type GetWidgetQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetWidgetQuery = { entityByRef: { __typename: 'User' } | { __typename: 'Locale' } | { __typename: 'Author' } | { __typename: 'SocialUser' } | { __typename: 'Image' } | { __typename: 'Movie' } | { __typename: 'ImageCategory' } | { __typename: 'Series' } | { __typename: 'Company' } | { __typename: 'CompanyStaff' } | { __typename: 'News' } | { __typename: 'VideoLegacy' } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' } | { __typename: 'Certificate' } | { __typename: 'Person' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | { __typename: 'Slide' } | { __typename: 'Carousel' } | { __typename: 'Theater' } | { __typename: 'Screen' } | { __typename: 'FestivalAward' } | { __typename: 'FestivalSelection' } | { __typename: 'FestivalCompetition' } | { __typename: 'FestivalEditionCompetition' } | { __typename: 'FestivalJury' } | { __typename: 'TheaterEvent' } | { __typename: 'Widget', id: string, ref: string, name: string, type: WidgetType, url: string | null } | { __typename: 'VideoB2B' } | null };

export type UpdateWidgetMutationVariables = Exact<{
  input: UpdateWidgetInput;
}>;


export type UpdateWidgetMutation = { updateWidget: { id: string, ref: string, name: string, type: WidgetType, url: string | null } | null };

export type SearchWidgetsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
}>;


export type SearchWidgetsQuery = { widgets: { totalCount: number, nodes: Array<{ __typename: 'Widget', id: string, ref: string, name: string, type: WidgetType, url: string | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> } };

export type AuthorSeoDataFragment = { id: string, seoData: { isAutonomouslyActivable: boolean, browsable: boolean, title: string | null, description: string | null } | null };

export type AuthorLinksFragment = { id: string, links: { facebook: string | null, bluesky: string | null, instagram: string | null, letterboxd: string | null, linkedin: string | null, pinterest: string | null, snapchat: string | null, tiktok: string | null, threads: string | null, tumblr: string | null, twitter: string | null, vk: string | null, wechat: string | null, whatsapp: string | null, youtube: string | null } };

export type AuthorMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type AuthorIdentityFragment = { id: string, ref: string, name: string, position: string | null, startDate: string | null, stopDate: string | null, shortBio: string, longBio: string | object[] | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, user: { id: string, name: string, email: string } | null, socialUser: { legacyID: string } | null, avatar: { id: string, url: string, ref: string } | null };

export type AuthorSignatureFragment = { id: string, name: string, signature: string };

export type BoxofficeIdentityFragment = { id: string, value: number | null, cumulative: number | null, copyCount: number | null, estimate: number | null, movie: { __typename: 'Movie', ref: string, id: string, title: string }, range: { startsAt: string, endsAt: string }, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } };

export type CarouselSlidesFragment = { id: string, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, slides: Array<{ id: string, rank: number, node: { id: string, ref: string, title: string } }> };

export type CarouselSlideFragment = { id: string, rank: number, node: { id: string, ref: string, title: string } };

export type CarouselMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type CarouselIdentityFragment = { id: string, ref: string, target: string, startsAt: string, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } };

export type SlideMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type CertificateIdentityFragment = { __typename: 'Certificate', id: string, ref: string, rank: number, active: boolean, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null };

export type SlideIdentityFragment = { id: string, active: boolean, title: string, description: string, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, link: { url: string, blank: boolean }, poster: { id: string, url: string, ref: string } | null };

export type SlidePlanningFragment = { id: string, parents: Array<{ id: string, rank: number, node: { id: string, ref: string, target: string, startsAt: string } }> };

export type SlideParentFragment = { id: string, rank: number, node: { id: string, ref: string, target: string, startsAt: string } };

export type ClockMetadataFragment = { id: string, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type ClockIdentityFragment = { id: string, ref: string, subtitlesLanguage: Language | null, language: Language | null, seatingStyle: ClockSeatingStyle | null, amenity: ClockAmenity | null, showtimes: Array<string>, technos: Array<ClockTechno>, sound: ClockSound | null, comment: string | null, range: { startsAt: string, endsAt: string }, theater: { __typename: 'Theater', id: string, ref: string, code: string, name: string, country: { __typename: 'Country', showtimeReleaseDay: ShowtimeReleaseDay | null, preferredClockFormat: PreferredClockFormat | null, id: string, ref: string, name: string, alpha2: string } }, screen: { id: string, name: string } | null, entity: { __typename: 'Movie', id: string, title: string, ref: string } };

export type ClockTheaterFragment = { __typename: 'Theater', id: string, ref: string, code: string, name: string, openingStatus: TheaterOpeningStatus, showtimeSource: TheaterShowtimeSource | null, parent: { __typename: 'Company', id: string, ref: string, name: string } | null, location: { city: string | null } | null, country: { __typename: 'Country', showtimeReleaseDay: ShowtimeReleaseDay | null, preferredClockFormat: PreferredClockFormat | null, id: string, ref: string, name: string, alpha2: string } };

export type CompanyLinksFragment = { __typename: 'Company', id: string, ref: string, name: string, links: { facebook: string | null, bluesky: string | null, instagram: string | null, letterboxd: string | null, linkedin: string | null, pinterest: string | null, snapchat: string | null, tiktok: string | null, threads: string | null, tumblr: string | null, twitter: string | null, vk: string | null, wechat: string | null, whatsapp: string | null, youtube: string | null }, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> };

export type CompanyFullIdentityFragment = { __typename: 'Company', foundedAt: string | null, activities: Array<CompanyActivity>, closed: boolean, providerAsFavorite: boolean, email: string | null, websiteUrl: string | null, androidUrl: string | null, iosUrl: string | null, phone: string | null, note: string | null, description: string | null, id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, parent: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null, logo: { id: string, url: string, ref: string } | null, data: { sourceName: string | null, allowMatchingTypeOverrides: boolean, approvals: { cnc: { number: string | null } | null } | null }, activeOnBrands: Array<{ ref: string }> };

export type CompanyAddressFragment = { __typename: 'Company', id: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, coordinates: { latitude: number, longitude: number } | null, location: { address: string | null, address2: string | null, zip: string | null, city: string | null, state: string | null, county: string | null, country: string | null } | null };

export type CompanyMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type CompanyRelationshipsFragment = { __typename: 'Company', id: string, ref: string, name: string, parent: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null, children: Array<{ __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> };

export type CompanyRelationFragment = { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> };

export type CompanyActivitySubactivityFragment = { activity: CompanyActivities, subactivities: Array<CompanySubactivities> };

export type CompanyStaffIdentityFragment = { ref: string, id: string, rank: number, active: boolean, companyId: string | null, firstName: string | null, lastName: string | null, name: string | null, department: CompanyStaffDepartment | null, title: string | null, email: string | null, workPhone: string | null, mobilePhone: string | null, company: { ref: string } | null, copyCompanies: Array<{ id: string, name: string }> | null, pubCompanies: Array<{ id: string, name: string }> | null };

export type CompanyStaffMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type CompanySeodataFragment = { seoData: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null };

export type CountryIdentityFragment = { __typename: 'Country', alpha3: string, preferredClockFormat: PreferredClockFormat | null, id: string, ref: string, name: string, alpha2: string };

type DuplicateEntity_DeletedEntity_Fragment = { __typename: 'DeletedEntity', ref: string, id: string, source: { typename: string, ref: string } };

type DuplicateEntity_Company_Fragment = { __typename: 'Company', id: string, ref: string, name: string, logo: { id: string } | null, activeOnBrands: Array<{ ref: string }>, brandsData: Array<{ description: string | null, name: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, seoAttributes: Array<{ isAutonomouslyActivable: boolean, browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null };

type DuplicateEntity_Movie_Fragment = { __typename: 'Movie', ref: string, id: string, title: string, releases: { totalCount: number }, activeOnBrands: Array<{ ref: string }>, movieBrandsData: Array<{ synopsis: string | object[] | null, synopsisShort: string | object[] | null, title: string | null, poster: { id: string } | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, seoAttributes: Array<{ isAutonomouslyActivable: boolean, browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }>, externalIDs: Array<{ type: string, alts: Array<string> }> };

type DuplicateEntity_Series_Fragment = { __typename: 'Series', ref: string, id: string, title: string, releases: { totalCount: number }, activeOnBrands: Array<{ ref: string }>, seriesBrandsData: Array<{ synopsis: string | object[] | null, synopsisShort: string | null, title: string | null, poster: { id: string } | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, seoAttributes: Array<{ isAutonomouslyActivable: boolean, browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> };

type DuplicateEntity_Person_Fragment = { __typename: 'Person', ref: string, id: string, lastName: string | null, firstName: string | null, activeOnBrands: Array<{ ref: string }>, brandsData: Array<{ biography: string | object[] | null, biographyShort: string | null, poster: { id: string } | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, seoAttributes: Array<{ isAutonomouslyActivable: boolean, browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> };

export type DuplicateEntityFragment = DuplicateEntity_DeletedEntity_Fragment | DuplicateEntity_Company_Fragment | DuplicateEntity_Movie_Fragment | DuplicateEntity_Series_Fragment | DuplicateEntity_Person_Fragment;

export type DuplicateCompanyBrandDataFragment = { description: string | null, name: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } };

export type DuplicatePersonBrandDataFragment = { biography: string | object[] | null, biographyShort: string | null, poster: { id: string } | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } };

export type DuplicateSeriesBrandDataFragment = { synopsis: string | object[] | null, synopsisShort: string | null, title: string | null, poster: { id: string } | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } };

export type DuplicateMovieBrandDataFragment = { synopsis: string | object[] | null, synopsisShort: string | object[] | null, title: string | null, poster: { id: string } | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } };

export type DuplicateEntitySeoDataFragment = { isAutonomouslyActivable: boolean, browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } };

export type CountryMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type DuplicateIdentityFragment = { id: string, status: DuplicateStatus, priority: DuplicatePriority, comment: string | null, firstEntity: { __typename: 'DeletedEntity', ref: string, id: string, source: { typename: string, ref: string } } | { __typename: 'Company', id: string, ref: string, name: string, logo: { id: string } | null, activeOnBrands: Array<{ ref: string }>, brandsData: Array<{ description: string | null, name: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, seoAttributes: Array<{ isAutonomouslyActivable: boolean, browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', ref: string, id: string, title: string, releases: { totalCount: number }, activeOnBrands: Array<{ ref: string }>, movieBrandsData: Array<{ synopsis: string | object[] | null, synopsisShort: string | object[] | null, title: string | null, poster: { id: string } | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, seoAttributes: Array<{ isAutonomouslyActivable: boolean, browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }>, externalIDs: Array<{ type: string, alts: Array<string> }> } | { __typename: 'Series', ref: string, id: string, title: string, releases: { totalCount: number }, activeOnBrands: Array<{ ref: string }>, seriesBrandsData: Array<{ synopsis: string | object[] | null, synopsisShort: string | null, title: string | null, poster: { id: string } | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, seoAttributes: Array<{ isAutonomouslyActivable: boolean, browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> } | { __typename: 'Person', ref: string, id: string, lastName: string | null, firstName: string | null, activeOnBrands: Array<{ ref: string }>, brandsData: Array<{ biography: string | object[] | null, biographyShort: string | null, poster: { id: string } | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, seoAttributes: Array<{ isAutonomouslyActivable: boolean, browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> }, secondEntity: { __typename: 'DeletedEntity', ref: string, id: string, source: { typename: string, ref: string } } | { __typename: 'Company', id: string, ref: string, name: string, logo: { id: string } | null, activeOnBrands: Array<{ ref: string }>, brandsData: Array<{ description: string | null, name: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, seoAttributes: Array<{ isAutonomouslyActivable: boolean, browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', ref: string, id: string, title: string, releases: { totalCount: number }, activeOnBrands: Array<{ ref: string }>, movieBrandsData: Array<{ synopsis: string | object[] | null, synopsisShort: string | object[] | null, title: string | null, poster: { id: string } | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, seoAttributes: Array<{ isAutonomouslyActivable: boolean, browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }>, externalIDs: Array<{ type: string, alts: Array<string> }> } | { __typename: 'Series', ref: string, id: string, title: string, releases: { totalCount: number }, activeOnBrands: Array<{ ref: string }>, seriesBrandsData: Array<{ synopsis: string | object[] | null, synopsisShort: string | null, title: string | null, poster: { id: string } | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, seoAttributes: Array<{ isAutonomouslyActivable: boolean, browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> } | { __typename: 'Person', ref: string, id: string, lastName: string | null, firstName: string | null, activeOnBrands: Array<{ ref: string }>, brandsData: Array<{ biography: string | object[] | null, biographyShort: string | null, poster: { id: string } | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, seoAttributes: Array<{ isAutonomouslyActivable: boolean, browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> }, winner: { id: string } | { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | { id: string } | { id: string } | { id: string } | null };

type DuplicateIdentityWinner_DeletedEntity_Fragment = { id: string };

type DuplicateIdentityWinner_Company_Fragment = { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> };

type DuplicateIdentityWinner_Movie_Fragment = { id: string };

type DuplicateIdentityWinner_Series_Fragment = { id: string };

type DuplicateIdentityWinner_Person_Fragment = { id: string };

export type DuplicateIdentityWinnerFragment = DuplicateIdentityWinner_DeletedEntity_Fragment | DuplicateIdentityWinner_Company_Fragment | DuplicateIdentityWinner_Movie_Fragment | DuplicateIdentityWinner_Series_Fragment | DuplicateIdentityWinner_Person_Fragment;

export type DuplicateMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type FestivalAwardFragment = { __typename: 'FestivalAward', id: string, ref: string, active: boolean, name: string, rank: number, festival: { id: string, ref: string, name: string, localizedData: { name: string | null, synopsis: string | object[] | null } | null }, nominees: { entity: { __typename: 'Movie', id: string, ref: string, title: string, localeData: { title: string | null } | null } | { __typename: 'Series', id: string, ref: string, title: string, localeData: { title: string | null } | null } | null, persons: Array<{ __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null }> | null } | null, localizedData: { name: string | null } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type FestivalCompetitionIdentityFragment = { id: string, ref: string, name: string | null, active: boolean, display: FestivalCompetitionDisplay | null, localizedData: { name: string | null } | null, festival: { ref: string, name: string } };

export type FestivalCompetitionMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type FestivalEditionCompetitionIdentityFragment = { id: string, active: boolean, rank: number, festivalCompetition: { id: string, ref: string, name: string | null, active: boolean, display: FestivalCompetitionDisplay | null, localizedData: { name: string | null } | null, festival: { ref: string, name: string } } | null, festival: { ref: string, name: string } };

export type FestivalEditionCompetitionSearchFragment = { name: string, festivalCompetition: { id: string }, edition: { editionNumber: number | null, year: number }, localizedData: { name: string | null } | null };

export type FestivalEditionIdentityFragment = { id: string, ref: string, active: boolean, year: number, editionNumber: number | null, name: string | null, startsAt: string | null, endsAt: string | null, localizedData: { name: string | null } | null, festival: { __typename: 'Festival', id: string, ref: string, name: string }, poster: { id: string, url: string, ref: string } | null };

export type FestivalEditionCompetitionMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type FestivalJuryFragment = { id: string, ref: string, role: FestivalJuryRole, rank: number, person: { __typename: 'Person', ref: string, firstName: string | null, lastName: string | null } };

export type FestivalEditionMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type FestivalIdentityFragment = { id: string, active: boolean, ref: string, name: string, type: FestivalType | null, theme: FestivalTheme | null, keywords: Array<string> | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, localization: { id: string, name: string, type: LocalizationKind } | null, localizedData: { name: string | null, synopsis: string | object[] | null } | null, poster: { id: string, url: string, ref: string } | null };

export type FestivalSelectionFragment = { id: string, ref: string, festivalCompetitionId: string | null, awards: Array<{ __typename: 'FestivalAward', id: string, ref: string, active: boolean, name: string, rank: number, festival: { id: string, ref: string, name: string, localizedData: { name: string | null, synopsis: string | object[] | null } | null }, nominees: { entity: { __typename: 'Movie', id: string, ref: string, title: string, localeData: { title: string | null } | null } | { __typename: 'Series', id: string, ref: string, title: string, localeData: { title: string | null } | null } | null, persons: Array<{ __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null }> | null } | null, localizedData: { name: string | null } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> | null, nominees: { entity: { __typename: 'Movie', id: string, ref: string, title: string, localeData: { title: string | null } | null } | { __typename: 'Series', id: string, ref: string, title: string, localeData: { title: string | null } | null } | null, persons: Array<{ __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null }> | null } | null };

export type UpdateApplicationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  active: Scalars['Boolean']['input'];
}>;


export type UpdateApplicationMutation = { updateApplication: { id: string, name: string, active: boolean, ref: string, origin: string, metadata: { createdAt: string } } | null };

export type GetApplicationListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  search: Scalars['String']['input'];
}>;


export type GetApplicationListQuery = { applications: { totalCount: number, nodes: Array<{ id: string, ref: string, name: string, active: boolean, origin: string, metadata: { createdAt: string } }> } };

export type ApplicationRowFragment = { ref: string, id: string, name: string, active: boolean, origin: string, metadata: { createdAt: string } };

export type FestivalMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type GetTokenApplicationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTokenApplicationsQuery = { applications: { totalCount: number, nodes: Array<{ id: string, name: string, active: boolean, ref: string, origin: string, metadata: { createdAt: string } }> } };

export type DeleteTokenMutationVariables = Exact<{
  tokenId: Scalars['ID']['input'];
}>;


export type DeleteTokenMutation = { deleteToken: { id: string } | null };

export type AddTokenMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  expiresAt: Scalars['DateTime']['input'];
  scopeId?: InputMaybe<Scalars['ID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddTokenMutation = { addToken: { ref: string, id: string } | null };

export type CreateApplicationMutationVariables = Exact<{
  name: Scalars['String']['input'];
  active: Scalars['Boolean']['input'];
}>;


export type CreateApplicationMutation = { createApplication: { id: string } | null };

export type GetTokenListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  search: Scalars['String']['input'];
  applicationIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  orderBy: TokenOrder;
}>;


export type GetTokenListQuery = { tokens: { totalCount: number, nodes: Array<{ id: string, ref: string, uuid: string, expiresAt: string, active: boolean, lastCheckedAt: string, metadata: { createdAt: string }, application: { id: string, name: string, ref: string } | null, user: { nickname: string | null } | null, scope: { customer: { name: string } } | null }> } };

export type GetTokenScopesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTokenScopesQuery = { scopes: { nodes: Array<{ id: string, name: string, customer: { id: string, name: string } }> } };

export type UpdateTokenMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  active: Scalars['Boolean']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateTokenMutation = { updateToken: { id: string, ref: string, uuid: string, expiresAt: string, active: boolean, lastCheckedAt: string, token: string, comment: string | null, metadata: { createdAt: string }, application: { id: string, name: string, active: boolean, ref: string, origin: string, metadata: { createdAt: string } } | null, user: { id: string, nickname: string | null } | null, scope: { id: string, ref: string, name: string, customer: { id: string, name: string, graphBackendEndpoint: string | null, active: boolean, comment: string | null, ref: string } } | null } | null };

export type GetTokenQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetTokenQuery = { tokenByRef: { id: string, ref: string, uuid: string, expiresAt: string, active: boolean, lastCheckedAt: string, token: string, comment: string | null, metadata: { createdAt: string }, application: { id: string, name: string, active: boolean, ref: string, origin: string, metadata: { createdAt: string } } | null, user: { id: string, nickname: string | null } | null, scope: { id: string, ref: string, name: string, customer: { id: string, name: string, graphBackendEndpoint: string | null, active: boolean, comment: string | null, ref: string } } | null } | null };

type ImageEntity_Movie_Fragment = { __typename: 'Movie', id: string, ref: string, title: string };

type ImageEntity_Person_Fragment = { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null };

type ImageEntity_SeriesEpisode_Fragment = { __typename: 'SeriesEpisode', id: string, ref: string, episodeNumber: number, season: { id: string, ref: string, number: number } | null, series: { id: string, ref: string, title: string } };

type ImageEntity_SeriesSeason_Fragment = { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } };

type ImageEntity_Series_Fragment = { __typename: 'Series', id: string, ref: string, title: string };

type ImageEntity_FestivalEdition_Fragment = { __typename: 'FestivalEdition', id: string, ref: string, name: string | null, editionNumber: number | null, year: number, festival: { __typename: 'Festival', id: string, ref: string, name: string } };

export type ImageEntityFragment = ImageEntity_Movie_Fragment | ImageEntity_Person_Fragment | ImageEntity_SeriesEpisode_Fragment | ImageEntity_SeriesSeason_Fragment | ImageEntity_Series_Fragment | ImageEntity_FestivalEdition_Fragment;

export type ImageFullIdentityFragment = { id: string, ref: string, url: string, path: string, type: ImageType | null, copyrightName: string | null, mime: string | null, size: number | null, width: number | null, height: number | null, copyrights: Array<{ id: string, name: string }> | null };

export type ImageListItemFragment = { id: string, url: string, type: ImageType | null, ref: string, b2bAvailable: boolean, activeOnBrands: Array<{ ref: string }> };

export type EntityImageListItemFragment = { __typename: 'Image', title: string | null, isMainPosterOfEntity?: boolean, isMainBrandedPoster?: boolean, isMainLocalizedPoster?: boolean, hasLocalizedData: boolean, id: string, url: string, type: ImageType | null, ref: string, b2bAvailable: boolean, activeOnBrands: Array<{ ref: string }> };

export type ImageLocalizedIdentityFragment = { __typename: 'ImageLocaleData', id: string, ref: string, title: string | null, description: string | null, locale: string | null };

export type ImageMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type ImageMetadataNavFragment = { title: string | null, activeOnBrands: Array<{ ref: string }> };

export type ImportConfigurationStatsFragment = { id: string, averageDuration: string | null };

export type ImportConfigurationIdentityFragment = { id: string, sourceId: string | null, uri: string, entityMatcher: string | null, theaterMatcher: string | null, enabled: boolean, interval: number, nextRun: string, fetchedDays: number, gathertimesTimeout: number | null, inheritsScreenAttributes: boolean, linksOnly: boolean, moviesOnly: boolean, parameters: string | null, crawler: { name: string, notes: string | null }, entity: { __typename: 'Company', id: string, ref: string, name: string, companyCountry: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Theater', id: string, ref: string, name: string, showtimeSource: TheaterShowtimeSource | null, openingStatus: TheaterOpeningStatus, temporaryClosure: { startsAt: string | null, endsAt: string | null, message: string } | null, location: { city: string | null, zip: string | null } | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, parent: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null } | null };

export type ImportRunRowFragment = { id: string, status: ImportRunStatus, startTime: string | null, endTime: string | null, crawlExportFile: string | null, crawlMovieExportFile: string | null, configuration: { id: string, sourceId: string | null, crawler: { name: string } }, stats: { totalShowtimes: number, insertedShowtimes: number, matchedShowtimes: number, removedShowtimes: number, unmatchedShowtimes: number, ignoredShowtimes: number, importedMovies: number, importedTheaters: number } | null, steps: Array<{ name: string, status: ImportRunStatus, error: string | null, extra: any | null }> };

export type ImportRunRowStepFragment = { name: string, status: ImportRunStatus, error: string | null, extra: any | null };

export type LocaleIdentityFragment = { __typename: 'Locale', id: string, ref: string, name: string, syncFromBrand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type JumpLinkFragment = { __typename: 'JumpLink', id: string, ref: string, sourceUrl: string, targetDomainUrl: string, generatedUrl: string, partner: string | null, data: any | null, company: { __typename: 'Company', id: string, ref: string, name: string, activities: Array<CompanyActivity>, logo: { id: string, url: string, ref: string } | null } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type LocalizationIdentityFragment = { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null };

export type DeleteIgnoredProductMutationVariables = Exact<{
  input: DeleteIgnoredProductInput;
}>;


export type DeleteIgnoredProductMutation = { deleteIgnoredProduct: { id: string } | null };

export type GetMatchedProductEntitiesQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type GetMatchedProductEntitiesQuery = { matchedProductEntities: { id: string, linkedEntities: Array<{ __typename: 'Movie', ref: string, id: string, title: string } | { __typename: 'SeriesEpisode', ref: string, id: string, number: number, series: { ref: string, id: string, title: string }, season: { ref: string } | null } | { __typename: 'SeriesSeason', ref: string, id: string, number: number, series: { ref: string, id: string, title: string } } | { __typename: 'Series', ref: string, id: string, title: string }> } | null };

export type GetIgnoredProductsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  source: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetIgnoredProductsQuery = { ignoredProducts: { totalCount: number, nodes: Array<{ id: string, sourceId: string, title: string | null, type: string, metadata: { createdAt: string, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> } | null };

export type GetMatchedProductsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  sourceName: Scalars['String']['input'];
  countryId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMatchedProductsQuery = { matchedProducts: { totalCount: number, nodes: Array<{ id: string, name: string, type: ProductType, url: string | null }> } };

export type GetProductSourcesQueryVariables = Exact<{
  countryId: Scalars['ID']['input'];
}>;


export type GetProductSourcesQuery = { productSources: Array<{ __typename: 'ProductSourceStats', id: string, sourceName: string, unmatchedTotal: number, company: { id: string, data: { sourceName: string | null, allowMatchingTypeOverrides: boolean } } | null }> };

export type ProductSourceStatsFragment = { __typename: 'ProductSourceStats', id: string, sourceName: string, unmatchedTotal: number, company: { id: string, data: { sourceName: string | null, allowMatchingTypeOverrides: boolean } } | null };

export type ProductSourceCompanyFragment = { id: string, data: { sourceName: string | null, allowMatchingTypeOverrides: boolean } };

export type GetProductSourceChannelsQueryVariables = Exact<{
  countryId: Scalars['ID']['input'];
  sourceId: Scalars['ID']['input'];
}>;


export type GetProductSourceChannelsQuery = { productSourceChannels: Array<{ __typename: 'ProductSourceChannel', id: string, channel: string, stats: { unmatchedTotal: number } | null }> };

export type ProductSourceChannelOptionFragment = { __typename: 'ProductSourceChannel', id: string, channel: string, stats: { unmatchedTotal: number } | null };

export type IgnoreProductMutationVariables = Exact<{
  input: IgnoreProductInput;
}>;


export type IgnoreProductMutation = { ignoreProduct: { id: string } | null };

export type GetUnknownProductsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  source: Scalars['String']['input'];
  countryId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  sourceChannelNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetUnknownProductsQuery = { unknownProducts: { totalCount: number, nodes: Array<{ id: string, entityType: ProductEntityType, title: string, type: string, sourceChannelName: string | null, url: string | null, imageUrl: string | null, matchingData: { title: string | null, episodeTitle: string | null, seasonNumber: number | null, episodeNumber: number | null, releasedAt: string | null, releasedAtTime: string | null, unreleasedAt: string | null, info: any | null, productionYear: number | null, actors: Array<string>, directors: Array<string>, runtime: number | null } }> } };

export type LinkProductsMutationVariables = Exact<{
  input: LinkProductsInput;
}>;


export type LinkProductsMutation = { linkProducts: { unknownProducts: Array<{ id: string }> } | null };

export type MatchingMovieListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type MatchingMovieListQuery = { movies: { totalCount: number, nodes: Array<{ __typename: 'Movie', id: string, title: string, ref: string, productionYear: number | null, credits: { nodes: Array<{ person: { id: string, firstName: string | null, lastName: string | null } | null }> } }> } };

export type MatchingMovieFragment = { __typename: 'Movie', id: string, title: string, ref: string, productionYear: number | null, credits: { nodes: Array<{ person: { id: string, firstName: string | null, lastName: string | null } | null }> } };

export type MatchingSeriesListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type MatchingSeriesListQuery = { seriesList: { totalCount: number, nodes: Array<{ __typename: 'Series', id: string, title: string, originalPremiere: string | null, ref: string, credits: { nodes: Array<{ person: { id: string, firstName: string | null, lastName: string | null } | null }> } }> } };

export type MatchingSeriesFragment = { __typename: 'Series', id: string, title: string, originalPremiere: string | null, ref: string, credits: { nodes: Array<{ person: { id: string, firstName: string | null, lastName: string | null } | null }> } };

export type SearchSeasonEpisodesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchSeasonEpisodesQuery = { seriesSeason: { episodes: { totalCount: number, nodes: Array<{ id: string, number: number }> } } | null };

export type MatchingToolSeriesSeasonsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type MatchingToolSeriesSeasonsQuery = { series: { seasons: { totalCount: number, nodes: Array<{ id: string, number: number }> } } | null };

export type UnlinkEntityFromProductMutationVariables = Exact<{
  input: UnlinkEntityFromProductInput;
}>;


export type UnlinkEntityFromProductMutation = { unlinkEntityFromProduct: { id: string } | null };

export type DeleteMatchedShowtimeEntityMutationVariables = Exact<{
  input: DeleteMatchedShowtimeEntityInput;
}>;


export type DeleteMatchedShowtimeEntityMutation = { deleteMatchedShowtimeEntity: number | null };

export type DeleteIgnoredShowtimeSourceMutationVariables = Exact<{
  input: DeleteIgnoredShowtimeSourceInput;
}>;


export type DeleteIgnoredShowtimeSourceMutation = { deleteIgnoredShowtimeSource: { __typename: 'IgnoredShowtimeSource' } | null };

export type DeleteMatchedShowtimeTheaterMutationVariables = Exact<{
  input: DeleteMatchedShowtimeTheaterInput;
}>;


export type DeleteMatchedShowtimeTheaterMutation = { deleteMatchedShowtimeTheater: number | null };

export type IgnoreIncompleteShowtimeSourceMutationVariables = Exact<{
  input: IgnoreIncompleteShowtimeSourceInput;
}>;


export type IgnoreIncompleteShowtimeSourceMutation = { ignoreIncompleteShowtimeSource: number };

export type IgnoredShowtimeSourcesQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  sourceType?: InputMaybe<ShowtimeSourceType>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
}>;


export type IgnoredShowtimeSourcesQuery = { ignoredShowtimeSources: { totalCount: number, nodes: Array<{ sourceType: ShowtimeSourceType, sourceName: string, sourceId: string, title: string | null }> } };

export type IgnoredShowtimeSourceRowFragment = { sourceType: ShowtimeSourceType, sourceName: string, sourceId: string, title: string | null };

export type IncompleteShowtimeSourcesQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  sourceType: ShowtimeSourceType;
  sourceName?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<IncompleteMavenStatus>;
  showId?: InputMaybe<Scalars['String']['input']>;
}>;


export type IncompleteShowtimeSourcesQuery = { incompleteShowtimeSources: { totalCount: number, nodes: Array<{ sourceName: string, sourceId: string, showId: string | null, titles: Array<string>, count: number, entityInfosRaw: any | null, entityInfos: { url: string | null, rating: string | null, summary: string | null, trailer: string | null, images: Array<{ url: string | null, name: string | null, type: string | null, display: string | null } | null> | null } | null }> } };

export type IncompleteShowtimeSourceRowFragment = { sourceName: string, sourceId: string, showId: string | null, titles: Array<string>, count: number, entityInfosRaw: any | null, entityInfos: { url: string | null, rating: string | null, summary: string | null, trailer: string | null, images: Array<{ url: string | null, name: string | null, type: string | null, display: string | null } | null> | null } | null };

export type MarkIncompleteEntityInProgressByMavensMutationVariables = Exact<{
  input: MarkIncompleteEntityInProgressByMavensInput;
}>;


export type MarkIncompleteEntityInProgressByMavensMutation = { markIncompleteEntityInProgressByMavens: number };

export type MatchShowtimeEntityMutationVariables = Exact<{
  input: MatchShowtimeEntityInput;
}>;


export type MatchShowtimeEntityMutation = { matchShowtimeEntity: number | null };

export type MatchedShowtimeSourcesQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  sourceName?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  theaterId?: InputMaybe<Scalars['ID']['input']>;
  fetchEntities: Scalars['Boolean']['input'];
  fetchTheaters: Scalars['Boolean']['input'];
}>;


export type MatchedShowtimeSourcesQuery = { matchedShowtimeEntities?: { totalCount: number, nodes: Array<{ sourceName: string, sourceId: string, entity: { __typename: 'User', id: string } | { __typename: 'SocialUser', id: string } | { __typename: 'Image', id: string } | { __typename: 'Movie', id: string, ref: string, title: string } | { __typename: 'Series', id: string } | { __typename: 'Company', id: string } | { __typename: 'CompanyStaff', id: string } | { __typename: 'News', id: string } | { __typename: 'VideoLegacy', id: string } | { __typename: 'SeriesSeason', id: string } | { __typename: 'SeriesEpisode', id: string } | { __typename: 'Person', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'Slide', id: string } | { __typename: 'Theater', id: string } | { __typename: 'Screen', id: string } | { __typename: 'FestivalAward', id: string } | { __typename: 'FestivalSelection', id: string } | { __typename: 'FestivalCompetition', id: string } | { __typename: 'FestivalEditionCompetition', id: string } | { __typename: 'FestivalJury', id: string } | { __typename: 'TheaterEvent', id: string } | { __typename: 'VideoB2B', id: string } }> }, matchedShowtimeTheaters?: { totalCount: number, nodes: Array<{ sourceName: string, sourceId: string, theater: { __typename: 'Theater', id: string, ref: string, code: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } } }> } };

export type MatchedShowtimeEntityRowFragment = { sourceName: string, sourceId: string, entity: { __typename: 'User', id: string } | { __typename: 'SocialUser', id: string } | { __typename: 'Image', id: string } | { __typename: 'Movie', id: string, ref: string, title: string } | { __typename: 'Series', id: string } | { __typename: 'Company', id: string } | { __typename: 'CompanyStaff', id: string } | { __typename: 'News', id: string } | { __typename: 'VideoLegacy', id: string } | { __typename: 'SeriesSeason', id: string } | { __typename: 'SeriesEpisode', id: string } | { __typename: 'Person', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'Slide', id: string } | { __typename: 'Theater', id: string } | { __typename: 'Screen', id: string } | { __typename: 'FestivalAward', id: string } | { __typename: 'FestivalSelection', id: string } | { __typename: 'FestivalCompetition', id: string } | { __typename: 'FestivalEditionCompetition', id: string } | { __typename: 'FestivalJury', id: string } | { __typename: 'TheaterEvent', id: string } | { __typename: 'VideoB2B', id: string } };

export type MatchedShowtimeTheaterRowFragment = { sourceName: string, sourceId: string, theater: { __typename: 'Theater', id: string, ref: string, code: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } } };

export type MatchShowtimeTheaterMutationVariables = Exact<{
  input: MatchShowtimeTheaterInput;
}>;


export type MatchShowtimeTheaterMutation = { matchShowtimeTheater: number | null };

export type ShowtimeEntitiesSearchQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
}>;


export type ShowtimeEntitiesSearchQuery = { entities: { totalCount: number, nodes: Array<{ __typename: 'Movie', title: string, genres: Array<Genre>, id: string, ref: string, productionYear: number | null, poster: { url: string } | null, credits: { nodes: Array<{ person: { id: string, ref: string, firstName: string | null, lastName: string | null } | null }> }, localesData: Array<{ locale: string, title: string | null, poster: { url: string } | null }> | null, countries: Array<{ id: string, ref: string, name: string }>, usLocale: { title: string | null } | null, localeData: { title: string | null, poster: { url: string } | null } | null }> } };

export type ShowtimeEntitySuggestionsQueryVariables = Exact<{
  entityMatcher: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
}>;


export type ShowtimeEntitySuggestionsQuery = { showtimeEntitySuggestions: Array<{ score: number, entity: { __typename: 'User' } | { __typename: 'SocialUser' } | { __typename: 'Image' } | { __typename: 'Movie', title: string, genres: Array<Genre>, id: string, ref: string, productionYear: number | null, poster: { url: string } | null, credits: { nodes: Array<{ person: { id: string, ref: string, firstName: string | null, lastName: string | null } | null }> }, localesData: Array<{ locale: string, title: string | null, poster: { url: string } | null }> | null, countries: Array<{ id: string, ref: string, name: string }>, usLocale: { title: string | null } | null, localeData: { title: string | null, poster: { url: string } | null } | null } | { __typename: 'Series' } | { __typename: 'Company' } | { __typename: 'CompanyStaff' } | { __typename: 'News' } | { __typename: 'VideoLegacy' } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' } | { __typename: 'Person' } | { __typename: 'Festival' } | { __typename: 'FestivalEdition' } | { __typename: 'Slide' } | { __typename: 'Theater' } | { __typename: 'Screen' } | { __typename: 'FestivalAward' } | { __typename: 'FestivalSelection' } | { __typename: 'FestivalCompetition' } | { __typename: 'FestivalEditionCompetition' } | { __typename: 'FestivalJury' } | { __typename: 'TheaterEvent' } | { __typename: 'VideoB2B' } }> };

export type ShowtimeTheatersSearchQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  countryIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  companyIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ShowtimeTheatersSearchQuery = { theaters: { totalCount: number, nodes: Array<{ id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, parent: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null }> } };

export type ShowtimeTheatersSearchRowFragment = { id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, parent: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null };

export type UnmatchedTheatersQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  sourceName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type UnmatchedTheatersQuery = { unmatchedTheaters: { totalCount: number, nodes: Array<{ sourceName: string, sourceId: string, name: string | null, data: any }> } };

export type UnmatchedTheaterRowFragment = { sourceName: string, sourceId: string, name: string | null, data: any };

export type UnmatchedMoviesQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  sourceName?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
}>;


export type UnmatchedMoviesQuery = { unmatchedMovies: { totalCount: number, nodes: Array<{ sourceName: string, sourceId: string, title: string | null, data: any }> } };

export type UnmatchedMovieRowFragment = { sourceName: string, sourceId: string, title: string | null, data: any };

export type MovieLocalizedDataFragment = { title: string | null, synopsis: string | null, synopsisShort: string | null, url: string | null, notes: string | null, poster: { id: string, url: string, ref: string } | null, quad: { id: string, url: string, ref: string } | null };

export type MovieFullIdentityFragment = { id: string, ref: string, title: string, productionYear: number | null, type: MovieType, budget: string | null, languages: Array<Language>, genres: Array<Genre>, color: string | null, production: string | null, projection: string | null, sound: string | null, keywords: Array<string>, runtime: { hours: number, minutes: number } | null, countries: Array<{ id: string, name: string }>, poster: { id: string, url: string, ref: string } | null };

export type MovieMetadataNavFragment = { title: string, activeOnBrands: Array<{ ref: string }> };

export type MovieMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type MovieReleaseMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type MovieReleaseNavFragment = { entity: { __typename: 'Movie', id: string, ref: string, title: string } | { __typename: 'Series' } | { __typename: 'SeriesSeason' } | { __typename: 'SeriesEpisode' } };

export type MovieReleaseFragment = { id: string, type: ReleaseType | null, flags: Array<ReleaseFlag>, releasedAt: string | null, releasedAtTime: string | null, unreleasedAt: string | null, notReleasedYet: boolean, visaNumber: string | null, techInfo: string | null, openingEstimate: number | null, advisory: string | null, limitedCompany: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null, country: { __typename: 'Country', hasLocalCertificates: boolean | null, id: string, ref: string, name: string, alpha2: string }, distributors: Array<{ __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }>, certificate: { id: string, ref: string, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null } | null };

export type MovieSeodataFragment = { seoData: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null };

export type MovieVersionFragment = { id: string, version: MovieVersionType, label: string | null, runtime: { hours: number, minutes: number } | null };

type NewsEntity_Festival_Fragment = { __typename: 'Festival', id: string, ref: string, festivalName: string };

type NewsEntity_FestivalEdition_Fragment = { __typename: 'FestivalEdition', id: string, ref: string, year: number, editionName: string | null, festival: { ref: string, festivalName: string } };

type NewsEntity_Movie_Fragment = { __typename: 'Movie', id: string, ref: string, title: string };

type NewsEntity_News_Fragment = { __typename: 'News', id: string, ref: string };

type NewsEntity_Person_Fragment = { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null };

type NewsEntity_SeriesEpisode_Fragment = { __typename: 'SeriesEpisode', id: string, ref: string, episodeNumber: number, season: { id: string, ref: string, number: number } | null, series: { id: string, ref: string, title: string } };

type NewsEntity_SeriesSeason_Fragment = { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } };

type NewsEntity_Series_Fragment = { __typename: 'Series', id: string, ref: string, title: string };

export type NewsEntityFragment = NewsEntity_Festival_Fragment | NewsEntity_FestivalEdition_Fragment | NewsEntity_Movie_Fragment | NewsEntity_News_Fragment | NewsEntity_Person_Fragment | NewsEntity_SeriesEpisode_Fragment | NewsEntity_SeriesSeason_Fragment | NewsEntity_Series_Fragment;

export type NewsAuthorsFragment = { id: string, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, authors: Array<{ id: string, rank: number, author: { id: string, ref: string, name: string, shortBio: string }, signature: { id: string, signature: string } | null }> };

export type NewsIdentityFragment = { id: string, ref: string, title: string, socialTitle: string | null, type: NewsType, universe: NewsUniverse | null, keywords: Array<string>, category: NewsCategory | null, credits: string | null, headline: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } };

export type NewsMainImageFragment = { id: string, poster: { copyrightName: string | null, id: string, url: string, ref: string, copyrights: Array<{ id: string, name: string }> | null } | null };

export type NewsMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type NewsNavigationDataFragment = { seoHidden: boolean, onlyOnSocialSite: boolean };

export type NewsPagesFragment = { id: string, pages: Array<{ id: string, number: number, title: string | null, video: { __typename: 'VideoLegacy', id: string, active: boolean, ref: string, title: string | null, generatedTitle: string | null } | null }> };

export type NewsPublicationsFragment = { publicationStatus: EntityPublicationStatus, publicationDate: string | null, isUpdatedWhenPublished: boolean, publications: Array<{ startsAt: string, endsAt: string | null, status: EntityPublicationStatus }> };

export type NewsSeoAttributesFragment = { seoAttributes: { title: string | null, subtitle: string | null, description: string | null } };

export type NewsSlidesFragment = { id: string, ref: string, universe: NewsUniverse | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, slideshowSlides: Array<{ id: string, number: number, title: string }> };

export type NewsTagListFragment = { id: string, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } };

export type SlideshowSlideIdentityFragment = { id: string, number: number, title: string, body: string | object[] | null, image: { id: string, url: string, ref: string, copyrightName: string | null, copyrights: Array<{ id: string, name: string }> | null }, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, news: { id: string, ref: string } };

export type SearchAuthorFragment = { id: string, name: string, shortBio: string, signatures: Array<{ id: string, name: string, signature: string }> };

export type PersonNicknameFragment = { id: string, nickname: string, gender: Gender };

export type PersonImagesImportReportSummaryFragment = { __typename: 'PersonImageImportReport', id: string, status: ImportWizardReportStatus, failureReason: string | null, launchedAt: string, source: PersonImageSource, sourceId: string | null, confidence: PersonImageConfidence, detail: string, limit: number, candidatesCount: number, importedCount: number, metadata: { createdBy: { id: string, name: string } | null } };

export type PersonImagesImportReportFragment = { __typename: 'PersonImageImportReport', id: string, status: ImportWizardReportStatus, failureReason: string | null, launchedAt: string, source: PersonImageSource, sourceId: string | null, confidence: PersonImageConfidence, detail: string, limit: number, candidatesCount: number, importedCount: number, candidates: Array<{ id: string, url: string, thumbnailUrl: string, qualities: Array<PersonImageQuality>, width: number | null, height: number | null, type: ImageType, category: string | null, title: string | null, pageUrl: string | null, credit: string | null, license: string | null }>, outcomes: Array<{ url: string, status: PersonImageImportStatus, message: string | null }>, metadata: { createdBy: { id: string, name: string } | null } };

export type PersonMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type PersonFullIdentityFragment = { id: string, ref: string, firstName: string | null, lastName: string | null, formalName: string | null, gender: Gender | null, birthDate: string | null, deathDate: string | null, keywords: Array<string>, poster: { copyrightName: string | null, id: string, url: string, ref: string, copyrights: Array<{ id: string, name: string }> | null } | null, countries: Array<{ __typename: 'Country', id: string, ref: string, name: string, alpha2: string }> };

export type PersonNicknamesFragment = { id: string, nicknames: Array<{ id: string, nickname: string, gender: Gender }> };

export type PersonSeodataFragment = { seoData: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null };

export type DeleteCustomerMutationVariables = Exact<{
  customerId: Scalars['ID']['input'];
}>;


export type DeleteCustomerMutation = { deleteCustomer: { id: string } | null };

export type GetCustomerListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  search: Scalars['String']['input'];
}>;


export type GetCustomerListQuery = { customers: { totalCount: number, nodes: Array<{ id: string, ref: string, name: string, metadata: { createdAt: string } }> } };

export type CreateCustomerMutationVariables = Exact<{
  active: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  graphBackendEndpoint?: InputMaybe<Scalars['URL']['input']>;
}>;


export type CreateCustomerMutation = { createCustomer: { id: string, ref: string } | null };

export type GetCustomerQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetCustomerQuery = { customerByRef: { id: string, name: string, graphBackendEndpoint: string | null, active: boolean, comment: string | null, ref: string, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpdateCustomerIdentityMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  graphBackendEndpoint?: InputMaybe<Scalars['URL']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCustomerIdentityMutation = { updateCustomer: { id: string, name: string, graphBackendEndpoint: string | null, active: boolean, comment: string | null, ref: string, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type DeleteQueryMutationVariables = Exact<{
  customerQueryId: Scalars['ID']['input'];
}>;


export type DeleteQueryMutation = { deleteCustomerQuery: { id: string } | null };

export type CreateQueryMutationVariables = Exact<{
  name: Scalars['String']['input'];
  template: Scalars['String']['input'];
}>;


export type CreateQueryMutation = { createCustomerQuery: { id: string, ref: string } | null };

export type GetQueryListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  search: Scalars['String']['input'];
}>;


export type GetQueryListQuery = { customerQueries: { totalCount: number, nodes: Array<{ id: string, name: string, ref: string, metadata: { createdAt: string } }> } };

export type GetQueryQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetQueryQuery = { customerQueryByRef: { id: string, name: string, ref: string, template: string, metadata: { createdAt: string, updatedAt: string, origin: string | null, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UpdateQueryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  template: Scalars['String']['input'];
}>;


export type UpdateQueryMutation = { updateCustomerQuery: { id: string, name: string, ref: string, template: string, metadata: { createdAt: string, updatedAt: string, origin: string | null, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type CreateScopeMutationVariables = Exact<{
  name: Scalars['String']['input'];
  customerId: Scalars['ID']['input'];
}>;


export type CreateScopeMutation = { createScope: { id: string, ref: string } | null };

export type GetScopeCustomerQueriesQueryVariables = Exact<{
  excludeScope: Scalars['ID']['input'];
}>;


export type GetScopeCustomerQueriesQuery = { customerQueries: { totalCount: number, nodes: Array<{ id: string, name: string, ref: string, template: string, metadata: { createdAt: string } }> } };

export type GetScopeCustomersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetScopeCustomersQuery = { customers: { totalCount: number, nodes: Array<{ id: string, name: string, active: boolean, metadata: { createdAt: string } }> } };

export type GetScopeListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  search: Scalars['String']['input'];
}>;


export type GetScopeListQuery = { scopes: { totalCount: number, nodes: Array<{ id: string, ref: string, name: string, customer: { ref: string, name: string } }> } };

export type GetScopeQueriesQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
}>;


export type GetScopeQueriesQuery = { scopeByRef: { id: string, ref: string, scopeCustomerQueries: { totalCount: number, nodes: Array<{ id: string, alias: string, config: { variables: any, userVariables: Array<string | null> }, scope: { id: string, ref: string }, customerQuery: { id: string, name: string } }> } } | null };

export type DeleteScopeMutationVariables = Exact<{
  scopeId: Scalars['ID']['input'];
}>;


export type DeleteScopeMutation = { deleteScope: { id: string } | null };

export type GetScopeQueryQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
  query: Scalars['ID']['input'];
}>;


export type GetScopeQueryQuery = { scopeByRef: { id: string, scopeCustomerQuery: { id: string, alias: string, config: { variables: any, userVariables: Array<string | null> }, customerQuery: { id: string } } } | null };

export type LinkCustomerQueryToScopeMutationVariables = Exact<{
  scopeId: Scalars['ID']['input'];
  customerQueryId: Scalars['ID']['input'];
  alias: Scalars['String']['input'];
  config: QueryConfigInput;
}>;


export type LinkCustomerQueryToScopeMutation = { linkCustomerQueryToScope: { id: string } | null };

export type GetScopeQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetScopeQuery = { scopeByRef: { id: string, ref: string, name: string, customer: { id: string, name: string, graphBackendEndpoint: string | null, active: boolean, comment: string | null, ref: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type UnlinkCustomerQueryFromScopeMutationVariables = Exact<{
  scopeId: Scalars['ID']['input'];
  customerQueryId: Scalars['ID']['input'];
}>;


export type UnlinkCustomerQueryFromScopeMutation = { unlinkCustomerQueryFromScope: { id: string } | null };

export type UpdateScopeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  customerId: Scalars['ID']['input'];
}>;


export type UpdateScopeMutation = { updateScope: { id: string, ref: string, name: string, customer: { id: string, name: string, graphBackendEndpoint: string | null, active: boolean, comment: string | null, ref: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type CreateEditorialReviewMutationVariables = Exact<{
  input: CreateEditorialReviewInput;
}>;


export type CreateEditorialReviewMutation = { createEditorialReview: { id: string } | null };

export type GetEditorialReviewEntityQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEditorialReviewEntityQuery = { entity: { __typename: 'Movie', id: string, title: string, ref: string } | { __typename: 'Series', id: string, title: string, ref: string } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | {} | null };

export type DeleteEditorialReviewMutationVariables = Exact<{
  editorialReviewId: Scalars['ID']['input'];
}>;


export type DeleteEditorialReviewMutation = { deleteEditorialReview: { id: string } | null };

export type GetEditorialReviewEntityCountQueryVariables = Exact<{
  brandId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
}>;


export type GetEditorialReviewEntityCountQuery = { editorialReviews: { totalCount: number } };

export type LinkAuthorToEditorialReviewMutationVariables = Exact<{
  input: LinkAuthorToEditorialReviewInput;
}>;


export type LinkAuthorToEditorialReviewMutation = { linkAuthorToEditorialReview: { id: string } | null };

export type GetEditorialReviewListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  entityIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetEditorialReviewListQuery = { editorialReviews: { totalCount: number, nodes: Array<{ __typename: 'EditorialReview', id: string, ref: string, title: string | null, active: boolean, rating: number, metadata: { updatedAt: string, createdAt: string, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null }, authors: Array<{ author: { __typename: 'Author', ref: string, name: string } }>, entity: { __typename: 'Movie', id: string, title: string, ref: string } | { __typename: 'Series', id: string, title: string, ref: string } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } }> } };

export type GetEditorialReviewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEditorialReviewQuery = { editorialReview: { id: string, title: string | null, body: string | object[] | null, active: boolean, bodyShort: string | null, rating: number, publicationStatus: EntityPublicationStatus, publicationDate: string | null, isUpdatedWhenPublished: boolean, brand: { __typename: 'Brand', timezone: string | null, id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, authors: Array<{ id: string, rank: number, author: { id: string, ref: string, name: string }, signature: { id: string, signature: string } | null }>, entity: { __typename: 'Movie', id: string, title: string, ref: string } | { __typename: 'Series', id: string, title: string, ref: string } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, picture: { id: string, url: string, copyrightName: string | null, ref: string, copyrights: Array<{ id: string, name: string }> | null } | null, publications: Array<{ startsAt: string, endsAt: string | null, status: EntityPublicationStatus }> } | null };

export type EditorialReviewFragment = { id: string, title: string | null };

export type MoveAuthorInEditorialReviewsMutationVariables = Exact<{
  input: MoveAuthorInEditorialReviewsInput;
}>;


export type MoveAuthorInEditorialReviewsMutation = { moveAuthorInEditorialReviews: { id: string } | null };

export type UpdateEditorialReviewMutationVariables = Exact<{
  input: UpdateEditorialReviewInput;
}>;


export type UpdateEditorialReviewMutation = { updateEditorialReview: { id: string, active: boolean, body: string | object[] | null, bodyShort: string | null, rating: number, title: string | null, picture: { id: string, url: string } | null } | null };

export type UnlinkAuthorFromEditorialReviewMutationVariables = Exact<{
  input: UnlinkAuthorFromEditorialReviewInput;
}>;


export type UnlinkAuthorFromEditorialReviewMutation = { unlinkAuthorFromEditorialReview: { id: string } | null };

export type CreatePressReviewMutationVariables = Exact<{
  input: CreatePressReviewInput;
}>;


export type CreatePressReviewMutation = { createPressReview: { id: string, entity: { __typename: 'Movie', title: string, id: string, ref: string } | { __typename: 'Series', title: string, id: string, ref: string } | { __typename: 'SeriesSeason', id: string, number: number, ref: string, originalPremiere: string | null, status: SeriesStatus | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } } | null };

export type DeletePressReviewMutationVariables = Exact<{
  pressReviewId: Scalars['ID']['input'];
}>;


export type DeletePressReviewMutation = { deletePressReview: { id: string } | null };

export type PressReviewEntityQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PressReviewEntityQuery = { entity: { __typename: 'Movie', title: string, id: string, ref: string } | { __typename: 'Series', title: string, id: string, ref: string } | { __typename: 'SeriesSeason', id: string, number: number, ref: string, originalPremiere: string | null, status: SeriesStatus | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | {} | null };

export type GetPressReviewEntityCountQueryVariables = Exact<{
  brandId: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
}>;


export type GetPressReviewEntityCountQuery = { pressReviews: { totalCount: number } };

export type GetPressReviewListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  brandId?: InputMaybe<Scalars['ID']['input']>;
  companyIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  entityIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPressReviewListQuery = { pressReviews: { totalCount: number, nodes: Array<{ __typename: 'PressReview', id: string, ref: string, active: boolean, rating: number, author: string | null, company: { __typename: 'Company', id: string, ref: string, name: string }, entity: { __typename: 'Movie', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string } | { __typename: 'SeriesSeason', id: string, number: number, ref: string, series: { id: string, ref: string, originalPremiere: string | null, title: string } }, metadata: { createdAt: string } }> } };

export type PressReviewRowFragment = { __typename: 'PressReview', id: string, ref: string, active: boolean, rating: number, author: string | null, company: { __typename: 'Company', id: string, ref: string, name: string }, entity: { __typename: 'Movie', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string } | { __typename: 'SeriesSeason', id: string, number: number, ref: string, series: { id: string, ref: string, originalPremiere: string | null, title: string } }, metadata: { createdAt: string } };

export type UpdatePressReviewMutationVariables = Exact<{
  input: UpdatePressReviewInput;
}>;


export type UpdatePressReviewMutation = { updatePressReview: { id: string, ref: string, active: boolean, author: string | null, rating: number, body: string | object[] | null, snippet: string | null, url: string | null, metadata: { updatedAt: string, createdAt: string }, company: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Movie', title: string, id: string, ref: string } | { __typename: 'Series', title: string, id: string, ref: string } | { __typename: 'SeriesSeason', id: string, number: number, ref: string, originalPremiere: string | null, status: SeriesStatus | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } } | null };

export type GetPressReviewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPressReviewQuery = { pressReview: { id: string, ref: string, active: boolean, author: string | null, rating: number, body: string | object[] | null, snippet: string | null, url: string | null, metadata: { createdAt: string, updatedAt: string, origin: string | null, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, company: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Movie', title: string, id: string, ref: string } | { __typename: 'Series', title: string, id: string, ref: string } | { __typename: 'SeriesSeason', id: string, number: number, ref: string, originalPremiere: string | null, status: SeriesStatus | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } } | null };

export type ScreenFlagsFragment = { id: string, flags: { accessibility: Array<string>, comfort: Array<string>, experience: Array<string>, food: Array<string>, picture: Array<string>, projection: Array<string>, restriction: Array<string>, service: Array<string>, sound: Array<string> } };

export type ScreenMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type ScreenIdentityFragment = { id: string, name: string, number: number | null, size: { width: number | null, unit: ScreenSizeUnit | null } | null };

export type ScreenNavFragment = { theater: { __typename: 'Theater', id: string, ref: string, code: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } } };

export type ScreenSeatsFragment = { id: string, seats: number | null };

export type PresetIdentityFragment = { id: string, name: string, universes: Array<Universe> };

export type PresetMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type PresetPermissionsFragment = { id: string, permissions: Array<Permission> };

export type PresetUsersFragment = { id: string, users: Array<{ id: string, ref: string, active: boolean, name: string, presets: Array<{ id: string }> }> };

export type TeamMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type UserIdentityFragment = { id: string, ref: string, name: string, email: string, active: boolean, application: boolean, admin: boolean, allowedNewsScopes: Array<NewsScope>, presets: Array<{ id: string, name: string }>, allowedBrands: Array<{ __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }> };

export type TeamIdentityFragment = { id: string, ref: string, name: string, locales: Array<{ id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }>, brands: Array<{ __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }>, countries: Array<{ __typename: 'Country', id: string, ref: string, name: string, alpha2: string }> };

export type UserMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type UserPermissionsFragment = { id: string, permissions: Array<Permission>, presets: Array<{ id: string, permissions: Array<Permission> }> };

export type UserRolesFragment = { id: string, rights: Array<{ team: { id: string, name: string }, preset: { id: string, name: string } }> };

export type UserPreferencesFragment = { id: string, defaultBrand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } | null, defaultCountry: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, defaultLocale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null } | null };

export type EpisodeBrandIdentityFragment = { __typename: 'SeriesEpisode', id: string, ref: string, title: string | null, number: number, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, season: { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | null, series: { id: string, ref: string, title: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type EpisodeIdentityFragment = { __typename: 'SeriesEpisode', id: string, ref: string, title: string | null, number: number, season: { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | null, series: { id: string, ref: string, title: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type EpisodeIdentitySeriesFragment = { id: string, ref: string, title: string };

export type EpisodeIdentitySeasonFragment = { id: string, ref: string, number: number };

export type EpisodeMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type EpisodeMetadataNavFragment = { number: number, series: { ref: string, title: string }, season: { ref: string, number: number } | null, activeOnBrands: Array<{ ref: string }> };

export type EpisodeReleaseMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type EpisodeReleaseNavFragment = { entity: { id: string, ref: string, title: string | null, series: { id: string, title: string }, season: { id: string, number: number } | null } | {} };

export type EpisodeReleaseFragment = { id: string, ref: string, type: ReleaseType | null, flags: Array<ReleaseFlag>, releasedAt: string | null, releasedAtTime: string | null, unreleasedAt: string | null, notReleasedYet: boolean, techInfo: string | null, limitedCompany: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, distributors: Array<{ __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }> };

export type EpisodeSeodataFragment = { seoData: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null };

export type SeasonMetadataNavFragment = { number: number, series: { title: string }, activeOnBrands: Array<{ ref: string }> };

export type SeasonIdentityFragment = { id: string, ref: string, number: number, originalPremiere: string | null, originalFinale: string | null, status: SeriesStatus | null, poster: { id: string, url: string, ref: string } | null, series: { id: string, ref: string, title: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type SeasonMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type SeasonReleaseNavFragment = { entity: { id: string, number: number, series: { id: string, title: string } } | {} };

export type SeasonReleaseMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type SeasonReleaseFragment = { id: string, type: ReleaseType | null, flags: Array<ReleaseFlag>, releasedAt: string | null, releasedAtTime: string | null, unreleasedAt: string | null, notReleasedYet: boolean, techInfo: string | null, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null, limitedCompany: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, distributors: Array<{ __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }> };

export type SeasonSeodataFragment = { seoData: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null };

export type SeriesAdditionalInfoFragment = { baseRuntime: number | null, genres: Array<Genre>, originalPremiere: string | null, originalFinale: string | null, countries: Array<{ id: string, name: string }>, premiereChannel: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null };

export type SeriesEntityLinkListFragment = { title: string, entityLinks: Array<{ linkType: EntityLinkType, target: { __typename: 'User', id: string } | { __typename: 'SocialUser', id: string } | { __typename: 'Image', id: string } | { __typename: 'Movie', id: string, title: string, ref: string } | { __typename: 'Series', id: string, title: string, ref: string } | { __typename: 'Company', id: string } | { __typename: 'CompanyStaff', id: string } | { __typename: 'News', id: string } | { __typename: 'VideoLegacy', id: string } | { __typename: 'SeriesSeason', id: string } | { __typename: 'SeriesEpisode', id: string } | { __typename: 'Person', id: string } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } | { __typename: 'Slide', id: string } | { __typename: 'Theater', id: string } | { __typename: 'Screen', id: string } | { __typename: 'FestivalAward', id: string } | { __typename: 'FestivalSelection', id: string } | { __typename: 'FestivalCompetition', id: string } | { __typename: 'FestivalEditionCompetition', id: string } | { __typename: 'FestivalJury', id: string } | { __typename: 'TheaterEvent', id: string } | { __typename: 'VideoB2B', id: string } }> };

export type SeriesIdentityFragment = { id: string, ref: string, title: string, type: SeriesType | null, status: SeriesStatus | null, keywords: Array<string>, credits: { nodes: Array<{ person: { ref: string, firstName: string | null, lastName: string | null } | null }> }, poster: { id: string, url: string, ref: string } | null };

export type SeriesMetadataNavFragment = { title: string, activeOnBrands: Array<{ ref: string }> };

export type SeriesMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type SeriesReleaseMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type SeriesReleaseNavFragment = { entity: { id: string, title: string } | {} };

export type SeriesReleaseFragment = { id: string, type: ReleaseType | null, flags: Array<ReleaseFlag>, releasedAt: string | null, releasedAtTime: string | null, unreleasedAt: string | null, notReleasedYet: boolean, advisory: string | null, techInfo: string | null, limitedCompany: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, distributors: Array<{ __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }>, certificate: { id: string, ref: string, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null } | null };

export type SeriesSeodataFragment = { seoData: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null };

export type CompanySearchEntityFragment = { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null };

export type CertificateFragment = { id: string, ref: string, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null };

export type CompanyOptionFragment = { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> };

export type BrandOptionFragment = { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null };

export type CopyrightIdentityFragment = { id: string, name: string };

export type CountryOptionFragment = { __typename: 'Country', id: string, ref: string, name: string, alpha2: string };

export type CreditFragment = { __typename: 'PersonCredits', id: string, active: boolean, rank: number, role: string | null, person: { __typename: 'Person', id: string, ref: string, lastName: string | null, firstName: string | null, deathDate: string | null, activities: Array<PersonActivity>, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, poster: { path: string } | null, countries: Array<{ name: string }>, activeOnBrands: Array<{ ref: string }>, seoAttributes?: Array<{ browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, voice: { __typename: 'Person', id: string, ref: string, lastName: string | null, firstName: string | null, deathDate: string | null, activities: Array<PersonActivity>, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, poster: { path: string } | null, countries: Array<{ name: string }>, activeOnBrands: Array<{ ref: string }>, seoAttributes?: Array<{ browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> } | null, localeData?: { nodes: Array<{ id: string, role: string | null, voice: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null } }> } };

export type PersonWithSeoMetadataFragment = { __typename: 'Person', id: string, ref: string, lastName: string | null, firstName: string | null, deathDate: string | null, activities: Array<PersonActivity>, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null, poster: { path: string } | null, countries: Array<{ name: string }>, activeOnBrands: Array<{ ref: string }>, seoAttributes?: Array<{ browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> };

export type CreditLimitedFragment = { __typename: 'PersonCredits', id: string, activity: PersonActivity, rank: number, person: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, activeOnBrands: Array<{ id: string, ref: string }>, seoData?: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null } | null };

type EntityAlts_User_Fragment = { __typename: 'User', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> };

type EntityAlts_SocialUser_Fragment = { __typename: 'SocialUser', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> };

type EntityAlts_Image_Fragment = { __typename: 'Image', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> };

type EntityAlts_Movie_Fragment = { __typename: 'Movie', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> };

type EntityAlts_Series_Fragment = { __typename: 'Series', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> };

type EntityAlts_Company_Fragment = { __typename: 'Company', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> };

type EntityAlts_CompanyStaff_Fragment = { __typename: 'CompanyStaff', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> };

type EntityAlts_News_Fragment = { __typename: 'News', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> };

type EntityAlts_VideoLegacy_Fragment = { __typename: 'VideoLegacy', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> };

type EntityAlts_SeriesSeason_Fragment = { __typename: 'SeriesSeason', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> };

type EntityAlts_SeriesEpisode_Fragment = { __typename: 'SeriesEpisode', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> };

type EntityAlts_Person_Fragment = { __typename: 'Person', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> };

type EntityAlts_Festival_Fragment = { __typename: 'Festival', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> };

type EntityAlts_FestivalEdition_Fragment = { __typename: 'FestivalEdition', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> };

type EntityAlts_Slide_Fragment = { __typename: 'Slide', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> };

type EntityAlts_Theater_Fragment = { __typename: 'Theater', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> };

type EntityAlts_Screen_Fragment = { __typename: 'Screen', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> };

type EntityAlts_FestivalAward_Fragment = { __typename: 'FestivalAward', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> };

type EntityAlts_FestivalSelection_Fragment = { __typename: 'FestivalSelection', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> };

type EntityAlts_FestivalCompetition_Fragment = { __typename: 'FestivalCompetition', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> };

type EntityAlts_FestivalEditionCompetition_Fragment = { __typename: 'FestivalEditionCompetition', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> };

type EntityAlts_FestivalJury_Fragment = { __typename: 'FestivalJury', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> };

type EntityAlts_TheaterEvent_Fragment = { __typename: 'TheaterEvent', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> };

type EntityAlts_VideoB2B_Fragment = { __typename: 'VideoB2B', id: string, externalIDs: Array<{ type: string, alts: Array<string> }> };

export type EntityAltsFragment = EntityAlts_User_Fragment | EntityAlts_SocialUser_Fragment | EntityAlts_Image_Fragment | EntityAlts_Movie_Fragment | EntityAlts_Series_Fragment | EntityAlts_Company_Fragment | EntityAlts_CompanyStaff_Fragment | EntityAlts_News_Fragment | EntityAlts_VideoLegacy_Fragment | EntityAlts_SeriesSeason_Fragment | EntityAlts_SeriesEpisode_Fragment | EntityAlts_Person_Fragment | EntityAlts_Festival_Fragment | EntityAlts_FestivalEdition_Fragment | EntityAlts_Slide_Fragment | EntityAlts_Theater_Fragment | EntityAlts_Screen_Fragment | EntityAlts_FestivalAward_Fragment | EntityAlts_FestivalSelection_Fragment | EntityAlts_FestivalCompetition_Fragment | EntityAlts_FestivalEditionCompetition_Fragment | EntityAlts_FestivalJury_Fragment | EntityAlts_TheaterEvent_Fragment | EntityAlts_VideoB2B_Fragment;

type EntityBrandData_Image_Fragment = { activeOnBrands: Array<{ ref: string }> };

type EntityBrandData_Movie_Fragment = { activeOnBrands: Array<{ ref: string }> };

type EntityBrandData_Series_Fragment = { activeOnBrands: Array<{ ref: string }> };

type EntityBrandData_Company_Fragment = { activeOnBrands: Array<{ ref: string }> };

type EntityBrandData_SeriesSeason_Fragment = { activeOnBrands: Array<{ ref: string }> };

type EntityBrandData_SeriesEpisode_Fragment = { activeOnBrands: Array<{ ref: string }> };

type EntityBrandData_Person_Fragment = { activeOnBrands: Array<{ ref: string }> };

type EntityBrandData_Festival_Fragment = { activeOnBrands: Array<{ ref: string }> };

type EntityBrandData_Theater_Fragment = { activeOnBrands: Array<{ ref: string }> };

export type EntityBrandDataFragment = EntityBrandData_Image_Fragment | EntityBrandData_Movie_Fragment | EntityBrandData_Series_Fragment | EntityBrandData_Company_Fragment | EntityBrandData_SeriesSeason_Fragment | EntityBrandData_SeriesEpisode_Fragment | EntityBrandData_Person_Fragment | EntityBrandData_Festival_Fragment | EntityBrandData_Theater_Fragment;

export type EntitiesCompanyFragment = { id: string, rank: number, activity: CompanyActivity, company: { id: string, ref: string, name: string } };

export type EntityTagFragment = { id: string, rank: number, tag: { id: string, ref: string, name: string, type: TagType, active: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }, entity: { __typename: 'Company', id: string, rawId: number, ref: string, name: string, title: string } | { __typename: 'Movie', id: string, rawId: number, ref: string, title: string } | { __typename: 'News', id: string, rawId: number, ref: string, title: string } | { __typename: 'Person', id: string, rawId: number, ref: string, firstName: string | null, lastName: string | null } | { __typename: 'SeriesEpisode', id: string, rawId: number, ref: string, episodeTitle: string | null } | { __typename: 'SeriesSeason', id: string, rawId: number, ref: string, number: number } | { __typename: 'Series', id: string, rawId: number, ref: string, title: string } | { __typename: 'Slide', id: string, rawId: number, ref: string, title: string } | { __typename: 'Theater', id: string, rawId: number, ref: string, name: string } };

export type EntityTriviaFragment = { id: string, ref: string, rank: number, trivia: { __typename: 'Trivia', id: string, ref: string, active: boolean, title: string, body: string | object[] | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, relatedEntities: Array<{ __typename: 'Movie', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | { __typename: 'SeriesEpisode', ref: string, id: string, number: number, series: { ref: string, id: string, title: string }, season: { ref: string } | null } | { __typename: 'Person', ref: string, id: string, lastName: string | null, firstName: string | null }> } };

export type FestivalSearchEntityFragment = { id: string, ref: string, name: string };

export type EntityVideoFragment = { rank: number, video: { __typename: 'VideoLegacy', id: string, ref: string, title: string | null, generatedTitle: string | null, active: boolean, language: Language | null, description: string | null, startsAt: string | null, endsAt: string | null, type: VideoType, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, relatedEntities: Array<{ __typename: 'Movie', id: string, ref: string, movieTitle: string } | { __typename: 'Series', id: string, ref: string, seriesTitle: string } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | { __typename: 'SeriesEpisode', id: string, ref: string, number: number, title: string | null, series: { id: string, ref: string, title: string }, season: { id: string, ref: string, number: number } | null } | { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, formalName: string | null } | { __typename: 'Festival', id: string, ref: string, festivalName: string } | { __typename: 'FestivalEdition', id: string, ref: string, editionNumber: number | null, year: number, editionName: string | null, festival: { id: string, ref: string, festivalName: string } }>, duration: { hours: number, minutes: number, seconds: number } | null, snapshot: { path: string, url: string } | null } | { __typename: 'VideoB2B', id: string, ref: string, title: string | null, generatedTitle: string | null, active: boolean, language: Language | null, description: string | null, startsAt: string | null, endsAt: string | null, type: VideoType, relatedEntities: Array<{ __typename: 'Movie', id: string, ref: string, movieTitle: string } | { __typename: 'Series', id: string, ref: string, seriesTitle: string } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | { __typename: 'SeriesEpisode', id: string, ref: string, number: number, title: string | null, series: { id: string, ref: string, title: string }, season: { id: string, ref: string, number: number } | null } | { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, formalName: string | null } | { __typename: 'Festival', id: string, ref: string, festivalName: string } | { __typename: 'FestivalEdition', id: string, ref: string, editionNumber: number | null, year: number, editionName: string | null, festival: { id: string, ref: string, festivalName: string } }>, duration: { hours: number, minutes: number, seconds: number } | null, snapshot: { path: string, url: string } | null } };

export type IClubFragment = { __typename: 'Club', id: string, name: string, code: string, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } };

export type ImageReferenceFragment = { rank: number, image: { id: string, url: string, ref: string } };

export type ImageReferenceMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type ImageFragment = { id: string, url: string, ref: string };

export type LocalCertificateIdentityFragment = { advisory: string | null, localization: { id: string, name: string, type: LocalizationKind, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null }, certificate: { id: string, ref: string, label: string | null, code: string | null } };

export type LocaleOptionFragment = { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null };

export type MetadataFragment = { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null };

export type MetadataUserFragment = { __typename: 'User', id: string, ref: string, name: string };

export type MovieSearchEntityFragment = { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> };

export type NewsSearchEntityFragment = { id: string, ref: string, title: string };

export type PersonCreditsImportPersonFragment = { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, birthDate: string | null, deathDate: string | null, activities: Array<PersonActivity>, countries: Array<{ id: string, name: string, alpha2: string }>, poster: { id: string, path: string } | null };

export type PersonCreditsImportLlmCallFragment = { provider: string, model: string, inputTokens: number, outputTokens: number, durationMs: number, costUsd: number | null, error: string | null };

export type PersonCreditsImportReportFragment = { __typename: 'PersonCreditsImportReport', id: string, status: ImportWizardReportStatus, failureReason: string | null, launchedAt: string, finishedAt: string | null, source: PersonCreditsImportSource, outcome: ImportWizardOutcome | null, answeredBy: ImportWizardLevel | null, metadata: { createdBy: { id: string, name: string } | null }, counts: { linked: number, matched: number, ambiguous: number, unknown: number, extraneous: number }, stats: { durationMs: number, requests: number, bytesReceived: number, resolutionDurationMs: number, resolutionRequests: number, levels: Array<{ level: number, name: string, outcome: string, durationMs: number, requests: number, bytesReceived: number, creditsCount: number, detail: string, llmInputTokens: number | null, llm: { provider: string, model: string, inputTokens: number, outputTokens: number, durationMs: number, costUsd: number | null, error: string | null } | null }>, llm: { provider: string, model: string, inputTokens: number, outputTokens: number, durationMs: number, costUsd: number | null, error: string | null } | null }, localization: { locale: string, localeId: string, outcome: string | null, detail: string | null, durationMs: number | null, rolesAsked: number | null, rolesLocalized: number | null, llm: { provider: string, model: string, inputTokens: number, outputTokens: number, durationMs: number, costUsd: number | null, error: string | null } | null } | null, resolution: { __typename: 'PersonCreditsImportResolution', confidence: string, sourceId: string | null, source: string, detail: string, candidates: Array<{ id: string, title: string, year: number | null, kind: string | null }> } | null, entries: Array<{ __typename: 'PersonCreditsImportEntry', status: PersonCreditsImportStatus, name: string | null, category: string | null, role: string | null, localizedRole: string | null, externalPersonId: string | null, order: number | null, suggestedActivity: PersonActivity | null, gender: Gender | null, isVoice: boolean, linkKind: PersonCreditsImportLinkKind | null, linkLocale: string | null, linkedPerson: { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, birthDate: string | null, deathDate: string | null, activities: Array<PersonActivity>, countries: Array<{ id: string, name: string, alpha2: string }>, poster: { id: string, path: string } | null } | null, candidates: Array<{ __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, birthDate: string | null, deathDate: string | null, activities: Array<PersonActivity>, countries: Array<{ id: string, name: string, alpha2: string }>, poster: { id: string, path: string } | null }>, credit: { __typename: 'PersonCredits', id: string, activity: PersonActivity, rank: number, role: string | null } | null }> };

export type PersonCreditsImportReportSummaryFragment = { __typename: 'PersonCreditsImportReport', id: string, status: ImportWizardReportStatus, launchedAt: string, source: PersonCreditsImportSource, outcome: ImportWizardOutcome | null, sections: Array<PersonCreditsImportDataType>, resolution: { __typename: 'PersonCreditsImportResolution', confidence: string, source: string } | null, stats: { levels: Array<{ level: number, name: string, outcome: string, creditsCount: number }> }, metadata: { createdBy: { id: string, name: string } | null } };

export type PersonSearchEntityFragment = { __typename: 'Person', id: string, ref: string, lastName: string | null, firstName: string | null, deathDate: string | null, countries: Array<{ name: string }>, poster: { path: string, ref: string } | null, activeOnBrands: Array<{ ref: string }> };

type PublishableEntityFragment_News_Fragment = { publicationStatus: EntityPublicationStatus, publicationDate: string | null, isUpdatedWhenPublished: boolean, publications: Array<{ startsAt: string, endsAt: string | null, status: EntityPublicationStatus }> };

type PublishableEntityFragment_EditorialReview_Fragment = { publicationStatus: EntityPublicationStatus, publicationDate: string | null, isUpdatedWhenPublished: boolean, publications: Array<{ startsAt: string, endsAt: string | null, status: EntityPublicationStatus }> };

export type PublishableEntityFragmentFragment = PublishableEntityFragment_News_Fragment | PublishableEntityFragment_EditorialReview_Fragment;

export type SearchCompanyFragment = { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> };

type SearchEntitiesEntity_User_Fragment = { __typename: 'User' };

type SearchEntitiesEntity_SocialUser_Fragment = { __typename: 'SocialUser' };

type SearchEntitiesEntity_Image_Fragment = { __typename: 'Image' };

type SearchEntitiesEntity_Movie_Fragment = { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, poster: { id: string, path: string } | null };

type SearchEntitiesEntity_Series_Fragment = { __typename: 'Series', id: string, ref: string, title: string, originalPremiere: string | null, poster: { id: string, path: string } | null };

type SearchEntitiesEntity_Company_Fragment = { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> };

type SearchEntitiesEntity_CompanyStaff_Fragment = { __typename: 'CompanyStaff' };

type SearchEntitiesEntity_News_Fragment = { __typename: 'News', id: string, ref: string, title: string, poster: { id: string, path: string } | null };

type SearchEntitiesEntity_VideoLegacy_Fragment = { __typename: 'VideoLegacy' };

type SearchEntitiesEntity_SeriesSeason_Fragment = { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { __typename: 'Series', id: string, title: string }, poster: { id: string, path: string } | null };

type SearchEntitiesEntity_SeriesEpisode_Fragment = { __typename: 'SeriesEpisode' };

type SearchEntitiesEntity_Person_Fragment = { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, poster: { id: string, path: string } | null };

type SearchEntitiesEntity_Festival_Fragment = { __typename: 'Festival' };

type SearchEntitiesEntity_FestivalEdition_Fragment = { __typename: 'FestivalEdition' };

type SearchEntitiesEntity_Slide_Fragment = { __typename: 'Slide' };

type SearchEntitiesEntity_Theater_Fragment = { __typename: 'Theater' };

type SearchEntitiesEntity_Screen_Fragment = { __typename: 'Screen' };

type SearchEntitiesEntity_FestivalAward_Fragment = { __typename: 'FestivalAward' };

type SearchEntitiesEntity_FestivalSelection_Fragment = { __typename: 'FestivalSelection' };

type SearchEntitiesEntity_FestivalCompetition_Fragment = { __typename: 'FestivalCompetition' };

type SearchEntitiesEntity_FestivalEditionCompetition_Fragment = { __typename: 'FestivalEditionCompetition' };

type SearchEntitiesEntity_FestivalJury_Fragment = { __typename: 'FestivalJury' };

type SearchEntitiesEntity_TheaterEvent_Fragment = { __typename: 'TheaterEvent' };

type SearchEntitiesEntity_VideoB2B_Fragment = { __typename: 'VideoB2B' };

export type SearchEntitiesEntityFragment = SearchEntitiesEntity_User_Fragment | SearchEntitiesEntity_SocialUser_Fragment | SearchEntitiesEntity_Image_Fragment | SearchEntitiesEntity_Movie_Fragment | SearchEntitiesEntity_Series_Fragment | SearchEntitiesEntity_Company_Fragment | SearchEntitiesEntity_CompanyStaff_Fragment | SearchEntitiesEntity_News_Fragment | SearchEntitiesEntity_VideoLegacy_Fragment | SearchEntitiesEntity_SeriesSeason_Fragment | SearchEntitiesEntity_SeriesEpisode_Fragment | SearchEntitiesEntity_Person_Fragment | SearchEntitiesEntity_Festival_Fragment | SearchEntitiesEntity_FestivalEdition_Fragment | SearchEntitiesEntity_Slide_Fragment | SearchEntitiesEntity_Theater_Fragment | SearchEntitiesEntity_Screen_Fragment | SearchEntitiesEntity_FestivalAward_Fragment | SearchEntitiesEntity_FestivalSelection_Fragment | SearchEntitiesEntity_FestivalCompetition_Fragment | SearchEntitiesEntity_FestivalEditionCompetition_Fragment | SearchEntitiesEntity_FestivalJury_Fragment | SearchEntitiesEntity_TheaterEvent_Fragment | SearchEntitiesEntity_VideoB2B_Fragment;

export type SearchEntitiesNewsFragment = { id: string, ref: string, title: string, poster: { id: string, path: string } | null };

export type SearchEntitiesMovieFragment = { id: string, ref: string, title: string, productionYear: number | null, poster: { id: string, path: string } | null };

export type SearchEntitiesPersonFragment = { id: string, ref: string, firstName: string | null, lastName: string | null, poster: { id: string, path: string } | null };

export type SearchEntitiesCompanyFragment = { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> };

export type SearchEntitiesSeriesFragment = { id: string, ref: string, title: string, originalPremiere: string | null, poster: { id: string, path: string } | null };

export type SearchEntitiesSeriesSeasonFragment = { id: string, ref: string, number: number, series: { __typename: 'Series', id: string, title: string }, poster: { id: string, path: string } | null };

export type SearchFestivalEditionFragment = { id: string, ref: string, name: string | null, year: number, editionNumber: number | null, poster: { url: string } | null, festival: { name: string } };

export type SearchFestivalFragment = { id: string, ref: string, name: string, poster: { url: string } | null, country: { locale: { id: string } | null }, latestFestivalEdition: { poster: { url: string } | null } | null };

export type SearchMovieFragment = { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string } | null, credits: { nodes: Array<{ person: { firstName: string | null, lastName: string | null } | null }> }, brandsData: Array<{ title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, activeOnBrands: Array<{ ref: string }>, seoAttributes?: Array<{ browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> };

export type SearchNewsFragment = { id: string, ref: string, title: string, active: boolean, publicationDate: string | null, publicationStatus: EntityPublicationStatus };

export type SearchPersonFragment = { __typename: 'Person', id: string, ref: string, lastName: string | null, firstName: string | null, deathDate: string | null, activities: Array<PersonActivity>, poster: { path: string } | null, countries: Array<{ name: string }>, activeOnBrands: Array<{ ref: string }>, seoAttributes?: Array<{ browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> };

export type SearchSeriesEpisodeFragment = { __typename: 'SeriesEpisode', id: string, ref: string, number: number, title: string | null, brandData?: { title: string | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string }, season: { __typename: 'SeriesSeason', id: string, ref: string, number: number } | null };

export type SearchSeriesSeasonFragment = { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } };

export type SearchSeriesFragment = { __typename: 'Series', id: string, ref: string, title: string, originalPremiere: string | null, genres: Array<Genre>, poster: { path: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } } | null, activeOnBrands: Array<{ ref: string }>, seoAttributes?: Array<{ browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> };

export type SearchTheaterFragment = { __typename: 'Theater', id: string, ref: string, code: string, name: string, openingStatus: TheaterOpeningStatus, location: { city: string | null, zip: string | null } | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, parent: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | null };

export type SecureUserOptionFragment = { id: string, name: string, email: string };

export type SearchVideoFragment = { __typename: 'VideoLegacy', id: string, ref: string, title: string | null, generatedTitle: string | null, active: boolean, optionalTitle: string | null };

export type SeoDataFragment = { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } };

export type SeoAttributesBrowsableFragment = { browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } };

export type SeriesEpisodeSearchEntityFragment = { __typename: 'SeriesEpisode', id: string, ref: string, number: number, episodeTitle: string | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string }, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, season: { __typename: 'SeriesSeason', id: string, ref: string, number: number } | null, brandData?: { title: string | null } | null };

export type SeriesSearchEntityFragment = { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> };

export type SeriesSeasonSearchEntityFragment = { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } };

export type SlideSearchEntityFragment = { id: string, ref: string, title: string };

export type SocialLinksFragment = { facebook: string | null, bluesky: string | null, instagram: string | null, letterboxd: string | null, linkedin: string | null, pinterest: string | null, snapchat: string | null, tiktok: string | null, threads: string | null, tumblr: string | null, twitter: string | null, vk: string | null, wechat: string | null, whatsapp: string | null, youtube: string | null };

export type TheaterSearchEntityFragment = { __typename: 'Theater', id: string, ref: string, code: string, name: string, logo: { ref: string, path: string } | null, theaterCountry: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } };

export type VideoLegacySearchEntityFragment = { __typename: 'VideoLegacy', id: string, ref: string, generatedTitle: string | null, videoTitle: string | null };

type VideoRelatedEntity_Movie_Fragment = { __typename: 'Movie', id: string, ref: string, movieTitle: string };

type VideoRelatedEntity_Series_Fragment = { __typename: 'Series', id: string, ref: string, seriesTitle: string };

type VideoRelatedEntity_SeriesSeason_Fragment = { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } };

type VideoRelatedEntity_SeriesEpisode_Fragment = { __typename: 'SeriesEpisode', id: string, ref: string, number: number, title: string | null, series: { id: string, ref: string, title: string }, season: { id: string, ref: string, number: number } | null };

type VideoRelatedEntity_Person_Fragment = { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null, formalName: string | null };

type VideoRelatedEntity_Festival_Fragment = { __typename: 'Festival', id: string, ref: string, festivalName: string };

type VideoRelatedEntity_FestivalEdition_Fragment = { __typename: 'FestivalEdition', id: string, ref: string, editionNumber: number | null, year: number, editionName: string | null, festival: { id: string, ref: string, festivalName: string } };

export type VideoRelatedEntityFragment = VideoRelatedEntity_Movie_Fragment | VideoRelatedEntity_Series_Fragment | VideoRelatedEntity_SeriesSeason_Fragment | VideoRelatedEntity_SeriesEpisode_Fragment | VideoRelatedEntity_Person_Fragment | VideoRelatedEntity_Festival_Fragment | VideoRelatedEntity_FestivalEdition_Fragment;

export type UpdateUserReviewMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  status: UserReviewStatus;
}>;


export type UpdateUserReviewMutation = { updateUserReview: { id: string, status: UserReviewStatus } | null };

export type GetRatingListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  brandId: Scalars['ID']['input'];
  localeId?: InputMaybe<Scalars['ID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  entityIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  entityTypes?: InputMaybe<Array<SocialRatingsEntityType> | SocialRatingsEntityType>;
  search?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  onlyReviews?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['DateTimeISO']['input']>;
  to?: InputMaybe<Scalars['DateTimeISO']['input']>;
  ratings?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<UserReviewStatus> | UserReviewStatus>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<SocialRatingsOrder>;
  includeBrandData?: InputMaybe<Scalars['Boolean']['input']>;
  includeLocaleData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetRatingListQuery = { userRatings: { totalCount: number, nodes: Array<{ id: string, ref: string, rawId: number, active: boolean, rating: number, metadata: { updatedAt: string, createdAt: string }, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'SeriesEpisode', id: string, ref: string, number: number, episodeTitle: string | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string }, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, season: { __typename: 'SeriesSeason', id: string, ref: string, number: number } | null, brandData?: { title: string | null } | null }, review: { id: string, ref: string, rawId: number, status: UserReviewStatus, body: string, stats: { wilsonScore: number | null, rating: number | null, helpfulCount: number | null, unhelpfulCount: number | null } } | null, user: { id: string, rawId: number, ref: string, nickname: string | null, email: string | null, metadata: { createdAt: string }, stats: { database: { ratingCount: number, reviewCount: number } } } }> } };

export type RatingIdentityFragment = { id: string, ref: string, rawId: number, active: boolean, rating: number, metadata: { updatedAt: string, createdAt: string }, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'SeriesEpisode', id: string, ref: string, number: number, episodeTitle: string | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string }, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, season: { __typename: 'SeriesSeason', id: string, ref: string, number: number } | null, brandData?: { title: string | null } | null }, review: { id: string, ref: string, rawId: number, status: UserReviewStatus, body: string, stats: { wilsonScore: number | null, rating: number | null, helpfulCount: number | null, unhelpfulCount: number | null } } | null, user: { id: string, rawId: number, ref: string, nickname: string | null, email: string | null, metadata: { createdAt: string }, stats: { database: { ratingCount: number, reviewCount: number } } } };

export type AddImageToCategoryMutationVariables = Exact<{
  input: AddImageToCategoryInput;
}>;


export type AddImageToCategoryMutation = { addImageToCategory: { id: string, imageId: string, categoryId: string, rank: number } | null };

export type GetSocialImagesListQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  onlyUncategorizedAvatarsAndBanners?: InputMaybe<Scalars['Boolean']['input']>;
  imageCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  type?: InputMaybe<ImageType>;
  hasTTL?: InputMaybe<Scalars['Boolean']['input']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  validityFrom?: InputMaybe<Scalars['Date']['input']>;
  validityTo?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSocialImagesListQuery = { socialImagesList: { totalCount: number, maxRank: number, nodes: Array<{ rank: number, image: { type: ImageType | null, active: boolean, endDate: string | null, startDate: string | null, tags: Array<string>, title: string | null, id: string, url: string, ref: string }, category: { id: string, name: string | null, brand: { id: string, ref: string, name: string } } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> } };

export type RemoveImageFromCategoryMutationVariables = Exact<{
  input: RemoveImageFromCategoryInput;
}>;


export type RemoveImageFromCategoryMutation = { removeImageFromCategory: { id: string, imageId: string, categoryId: string, rank: number } | null };

export type UpdateImageInCategoryMutationVariables = Exact<{
  input: UpdateImageInCategoryInput;
}>;


export type UpdateImageInCategoryMutation = { updateImageInCategory: { id: string, imageId: string, categoryId: string, rank: number } | null };

export type DeleteOrAnonymizeSocialUserMutationVariables = Exact<{
  input: DeleteOrAnonymizeSocialUserInput;
}>;


export type DeleteOrAnonymizeSocialUserMutation = { deleteOrAnonymizeSocialUser: { id: string } | null };

export type CreateActitoProfileMutationVariables = Exact<{
  input: CreateActitoProfileInput;
}>;


export type CreateActitoProfileMutation = { createActitoProfile: { id: string, ref: string, active: boolean, email: string | null, legacyID: string, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type GetSocialUsersQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type GetSocialUsersQuery = { socialUsers: { totalCount: number, nodes: Array<{ id: string, ref: string, active: boolean, legacyID: string, email: string | null, metadata: { createdAt: string, updatedAt: string } }> } };

export type GetSocialUserQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
}>;


export type GetSocialUserQuery = { entityByRef: { id: string, ref: string, actito: string | null, active: boolean, avatar: string | null, email: string | null, isClub300: boolean, isEULAAccepted: boolean, isEmailValid: boolean, legacyID: string, nickname: string | null, socialProviders: Array<string>, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, stats: { database: { ratingCount: number, reviewCount: number, actionCount: number, theaterCount: number, collectionCount: number, followedCollectionCount: number, followerCount: number, followeeCount: number }, graphAPI: { ratingCount: number, reviewCount: number, actionCount: number, theaterCount: number, collectionCount: number, followedCollectionCount: number, followerCount: number, followeeCount: number } }, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } } | {} | null };

export type UpdateSocialUserMutationVariables = Exact<{
  input: UpdateSocialUserInput;
}>;


export type UpdateSocialUserMutation = { updateSocialUser: { id: string, ref: string, actito: string | null, active: boolean, avatar: string | null, email: string | null, isClub300: boolean, isEULAAccepted: boolean, isEmailValid: boolean, legacyID: string, nickname: string | null, socialProviders: Array<string>, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type TagIdentityFragment = { __typename: 'Tag', id: string, ref: string, rawId: number, name: string, active: boolean, type: TagType, scope: TagScope | null, metadata: { updatedAt: string }, data: { seo: { friendly: boolean | null } | null }, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } };

export type TagMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type TagSeoFragment = { id: string, active: boolean, data: { seo: { friendly: boolean | null, browsable: boolean | null, topRanking: boolean | null, scope: { userRating: { movie: { title: string | null, subTitle: string | null, description: string | null } | null, series: { title: string | null, subTitle: string | null, description: string | null } | null } | null, pressRating: { movie: { title: string | null, subTitle: string | null, description: string | null } | null, series: { title: string | null, subTitle: string | null, description: string | null } | null } | null, popularity: { movie: { title: string | null, subTitle: string | null, description: string | null } | null, series: { title: string | null, subTitle: string | null, description: string | null } | null } | null, ranking: { movie: { title: string | null, subTitle: string | null, description: string | null } | null, series: { title: string | null, subTitle: string | null, description: string | null } | null } | null } | null } | null } };

export type TagFragment = { id: string, name: string };

export type BannerHpDataFragment = { link_desktop: string | null, link_mobile: string | null, medias: { desktop: string | null, mobile: string | null } | null };

export type CanalHomeSpecialOperationFragment = { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'CanalHomeData', heading1: string | null, heading2: string | null, heading3: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type BannerHpSpecialOperationFragment = { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'BannerHPData', link_desktop: string | null, link_mobile: string | null, medias: { desktop: string | null, mobile: string | null } | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type ClassiqueHomeSpecialOperationFragment = { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'ClassiqueHomeData', heading1: string | null, heading2: string | null, heading3: string | null, link1_label: string | null, link1_url: string | null, link2_label: string | null, link2_url: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type Club300DataFragment = { _placeholder: boolean | null };

export type DolbyHomeSpecialOperationFragment = { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'DolbyHomeData', _placeholder: boolean | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type DisneyHomeSpecialOperationFragment = { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'DisneyHomeData', medias: { native_grand_angle: { image_url: string | null, url: string | null } | null } | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type EmergenceMovieDataFragment = { distribution: EmergenceDistribution | null, provider: SvodProvider | null, release_date: string | null };

export type EmergenceMovieSpecialOperationFragment = { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'EmergenceMovieData', distribution: EmergenceDistribution | null, provider: SvodProvider | null, release_date: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type EmergenceSeriesDataFragment = { provider: SvodProvider | null, release_date: string | null };

export type EmergenceSeriesSpecialOperationFragment = { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'EmergenceSeriesData', provider: SvodProvider | null, release_date: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type EmergenceSvodDataFragment = { provider: SvodProvider | null, release_date: string | null };

export type EmergenceSvodSpecialOperationFragment = { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'EmergenceSVODData', provider: SvodProvider | null, release_date: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type EmergenceTheaterDataFragment = { release_date: string | null };

export type EmergenceTheaterSpecialOperationFragment = { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'EmergenceTheaterData', release_date: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type FestivalSectionSpecialOperationFragment = { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'FestivalSectionData', festivalEditionId: number | null, festivalId: number | null, playlist: Array<{ key: string, value: { movies: Array<number> | null, series: Array<number> | null } | null } | null> | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type FilmesOnlineSpecialOperationFragment = { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'FilmesOnlineData', heading1: string | null, heading2: string | null, heading3: string | null, heading4: string | null, heading5: string | null, heading6: string | null, heading7: string | null, heading8: string | null, heading9: string | null, heading10: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type IndelebileHomeSpecialOperationFragment = { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'IndelebileHomeData', heading1: string | null, heading2: string | null, heading3: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type ImaxHomeSpecialOperationFragment = { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'IMAXHomeData', _placeholder: boolean | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type MaxHomeSpecialOperationFragment = { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'MaxHomeData', heading1: string | null, heading2: string | null, heading3: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type M6HomeSpecialOperationFragment = { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'M6HomeData', heading1: string | null, heading2: string | null, heading3: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type MobileDdayDataFragment = { dday_campaign: string | null, dday_movie_id: number | null, dday_movie_list_id: Array<number> | null, dday_movie_list_title: string | null, dday_force_uppercase_headers: boolean | null, dday_nav_background_color_light: string | null, dday_nav_background_color_dark: string | null, dday_nav_font_color_light: string | null, dday_nav_font_color_dark: string | null, dday_main_color_light: string | null, dday_main_color_dark: string | null, dday_title_spacing_between_letters: number | null, dday_title_see_more_title_displayed: boolean | null, dday_background_color: string | null, dday_force_theme_light: boolean | null, dday_force_theme_dark: boolean | null, dday_status_bar_icons_light: boolean | null, dday_status_bar_icons_dark: boolean | null, dday_segmented_color_light: string | null, dday_segmented_color_dark: string | null, dday_segmented_selected_font_color_light: string | null, dday_segmented_selected_font_color_dark: string | null, dday_date: string | null, dday_last_date: string | null, dday_assets_version: number | null, dday_font_url: string | null, dday_font_size: number | null, dday_movie_background_url: string | null, dday_movie_background_id: string | null, dday_movie_logo_url: string | null, dday_movie_logo_id: string | null, dday_splash_background_url: string | null, dday_splash_background_id: string | null, dday_splash_logo_url: string | null, dday_splash_logo_id: string | null, dday_splashscreen_status_bar_color_style: string | null, dday_splashscreen_activity_color: string | null };

export type MobileDdaySpecialOperationFragment = { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'MobileDdayData', dday_campaign: string | null, dday_movie_id: number | null, dday_movie_list_id: Array<number> | null, dday_movie_list_title: string | null, dday_force_uppercase_headers: boolean | null, dday_nav_background_color_light: string | null, dday_nav_background_color_dark: string | null, dday_nav_font_color_light: string | null, dday_nav_font_color_dark: string | null, dday_main_color_light: string | null, dday_main_color_dark: string | null, dday_title_spacing_between_letters: number | null, dday_title_see_more_title_displayed: boolean | null, dday_background_color: string | null, dday_force_theme_light: boolean | null, dday_force_theme_dark: boolean | null, dday_status_bar_icons_light: boolean | null, dday_status_bar_icons_dark: boolean | null, dday_segmented_color_light: string | null, dday_segmented_color_dark: string | null, dday_segmented_selected_font_color_light: string | null, dday_segmented_selected_font_color_dark: string | null, dday_date: string | null, dday_last_date: string | null, dday_assets_version: number | null, dday_font_url: string | null, dday_font_size: number | null, dday_movie_background_url: string | null, dday_movie_background_id: string | null, dday_movie_logo_url: string | null, dday_movie_logo_id: string | null, dday_splash_background_url: string | null, dday_splash_background_id: string | null, dday_splash_logo_url: string | null, dday_splash_logo_id: string | null, dday_splashscreen_status_bar_color_style: string | null, dday_splashscreen_activity_color: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type NovelasHomeSpecialOperationFragment = { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'NovelasHomeData', _placeholder: boolean | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type RollerHomeDataFragment = { title: string | null };

export type RollerHomeSpecialOperationFragment = { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'RollerHomeData', title: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type SpecialOperationAdditionalInfosFragment = { id: string, ref: string, name: string | null, entity: { __typename: 'Company' } | { __typename: 'Movie', id: string, title: string } | { __typename: 'News' } | { __typename: 'Series' } | { __typename: 'SeriesSeason' } | { __typename: 'Slide' } | null, data: { __typename: 'BannerHPData', link_desktop: string | null, link_mobile: string | null, medias: { desktop: string | null, mobile: string | null } | null } | { __typename: 'CanalHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'ClassiqueHomeData', heading1: string | null, heading2: string | null, heading3: string | null, link1_label: string | null, link1_url: string | null, link2_label: string | null, link2_url: string | null } | { __typename: 'Club300Data', _placeholder: boolean | null } | { __typename: 'DisneyHomeData', medias: { native_grand_angle: { image_url: string | null, url: string | null } | null } | null } | { __typename: 'DolbyHomeData', _placeholder: boolean | null } | { __typename: 'EmergenceMovieData', distribution: EmergenceDistribution | null, provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceSeriesData', provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceSVODData', provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceTheaterData', release_date: string | null } | { __typename: 'FestivalSectionData', festivalEditionId: number | null, festivalId: number | null, playlist: Array<{ key: string, value: { movies: Array<number> | null, series: Array<number> | null } | null } | null> | null } | { __typename: 'FilmesOnlineData', heading1: string | null, heading2: string | null, heading3: string | null, heading4: string | null, heading5: string | null, heading6: string | null, heading7: string | null, heading8: string | null, heading9: string | null, heading10: string | null } | { __typename: 'IMAXHomeData', _placeholder: boolean | null } | { __typename: 'IndelebileHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'M6HomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'MaxHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'MobileDdayData', dday_campaign: string | null, dday_movie_id: number | null, dday_movie_list_id: Array<number> | null, dday_movie_list_title: string | null, dday_force_uppercase_headers: boolean | null, dday_nav_background_color_light: string | null, dday_nav_background_color_dark: string | null, dday_nav_font_color_light: string | null, dday_nav_font_color_dark: string | null, dday_main_color_light: string | null, dday_main_color_dark: string | null, dday_title_spacing_between_letters: number | null, dday_title_see_more_title_displayed: boolean | null, dday_background_color: string | null, dday_force_theme_light: boolean | null, dday_force_theme_dark: boolean | null, dday_status_bar_icons_light: boolean | null, dday_status_bar_icons_dark: boolean | null, dday_segmented_color_light: string | null, dday_segmented_color_dark: string | null, dday_segmented_selected_font_color_light: string | null, dday_segmented_selected_font_color_dark: string | null, dday_date: string | null, dday_last_date: string | null, dday_assets_version: number | null, dday_font_url: string | null, dday_font_size: number | null, dday_movie_background_url: string | null, dday_movie_background_id: string | null, dday_movie_logo_url: string | null, dday_movie_logo_id: string | null, dday_splash_background_url: string | null, dday_splash_background_id: string | null, dday_splash_logo_url: string | null, dday_splash_logo_id: string | null, dday_splashscreen_status_bar_color_style: string | null, dday_splashscreen_activity_color: string | null } | { __typename: 'NovelasHomeData', _placeholder: boolean | null } | { __typename: 'RollerHomeData', title: string | null } | { __typename: 'SponsoredAutocompleteData', release_date: string | null } | { __typename: 'TF1HomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'TicketAnchorData', cta_text_after_release: string | null, cta_text_before_release: string | null, display_showtimes: boolean | null, link: string | null, release_date: string | null, slots: Array<TicketAnchorSlot> | null, text_after_release: string | null, text_before_release: string | null, text_color: string | null, medias: { desktop: string | null, desktopHp: string | null, mobile: string | null } | null } | { __typename: 'VODHomeData', heading1: string | null, heading2: string | null } };

export type SpecialOperationBrandFragment = { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null };

type SpecialOperationEntity_Company_Fragment = { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null };

type SpecialOperationEntity_Movie_Fragment = { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> };

type SpecialOperationEntity_News_Fragment = { __typename: 'News', id: string, ref: string, title: string };

type SpecialOperationEntity_Series_Fragment = { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> };

type SpecialOperationEntity_SeriesSeason_Fragment = { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } };

type SpecialOperationEntity_Slide_Fragment = { __typename: 'Slide', id: string, ref: string, title: string };

export type SpecialOperationEntityFragment = SpecialOperationEntity_Company_Fragment | SpecialOperationEntity_Movie_Fragment | SpecialOperationEntity_News_Fragment | SpecialOperationEntity_Series_Fragment | SpecialOperationEntity_SeriesSeason_Fragment | SpecialOperationEntity_Slide_Fragment;

export type SpecialOperationMetadataFieldsFragment = { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null };

export type SpecialOperationCustoFragment = { id: string, ref: string, data: { __typename: 'BannerHPData', link_desktop: string | null, link_mobile: string | null, medias: { desktop: string | null, mobile: string | null } | null } | { __typename: 'CanalHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'ClassiqueHomeData', heading1: string | null, heading2: string | null, heading3: string | null, link1_label: string | null, link1_url: string | null, link2_label: string | null, link2_url: string | null } | { __typename: 'Club300Data', _placeholder: boolean | null } | { __typename: 'DisneyHomeData', medias: { native_grand_angle: { image_url: string | null, url: string | null } | null } | null } | { __typename: 'DolbyHomeData', _placeholder: boolean | null } | { __typename: 'EmergenceMovieData', distribution: EmergenceDistribution | null, provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceSeriesData', provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceSVODData', provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceTheaterData', release_date: string | null } | { __typename: 'FestivalSectionData', festivalEditionId: number | null, festivalId: number | null, playlist: Array<{ key: string, value: { movies: Array<number> | null, series: Array<number> | null } | null } | null> | null } | { __typename: 'FilmesOnlineData', heading1: string | null, heading2: string | null, heading3: string | null, heading4: string | null, heading5: string | null, heading6: string | null, heading7: string | null, heading8: string | null, heading9: string | null, heading10: string | null } | { __typename: 'IMAXHomeData', _placeholder: boolean | null } | { __typename: 'IndelebileHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'M6HomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'MaxHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'MobileDdayData', dday_campaign: string | null, dday_movie_id: number | null, dday_movie_list_id: Array<number> | null, dday_movie_list_title: string | null, dday_force_uppercase_headers: boolean | null, dday_nav_background_color_light: string | null, dday_nav_background_color_dark: string | null, dday_nav_font_color_light: string | null, dday_nav_font_color_dark: string | null, dday_main_color_light: string | null, dday_main_color_dark: string | null, dday_title_spacing_between_letters: number | null, dday_title_see_more_title_displayed: boolean | null, dday_background_color: string | null, dday_force_theme_light: boolean | null, dday_force_theme_dark: boolean | null, dday_status_bar_icons_light: boolean | null, dday_status_bar_icons_dark: boolean | null, dday_segmented_color_light: string | null, dday_segmented_color_dark: string | null, dday_segmented_selected_font_color_light: string | null, dday_segmented_selected_font_color_dark: string | null, dday_date: string | null, dday_last_date: string | null, dday_assets_version: number | null, dday_font_url: string | null, dday_font_size: number | null, dday_movie_background_url: string | null, dday_movie_background_id: string | null, dday_movie_logo_url: string | null, dday_movie_logo_id: string | null, dday_splash_background_url: string | null, dday_splash_background_id: string | null, dday_splash_logo_url: string | null, dday_splash_logo_id: string | null, dday_splashscreen_status_bar_color_style: string | null, dday_splashscreen_activity_color: string | null } | { __typename: 'NovelasHomeData', _placeholder: boolean | null } | { __typename: 'RollerHomeData', title: string | null } | { __typename: 'SponsoredAutocompleteData', release_date: string | null } | { __typename: 'TF1HomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'TicketAnchorData', cta_text_after_release: string | null, cta_text_before_release: string | null, display_showtimes: boolean | null, link: string | null, release_date: string | null, slots: Array<TicketAnchorSlot> | null, text_after_release: string | null, text_before_release: string | null, text_color: string | null, medias: { desktop: string | null, desktopHp: string | null, mobile: string | null } | null } | { __typename: 'VODHomeData', heading1: string | null, heading2: string | null } };

type SpecialOperationDataInner_BannerHpData_Fragment = { __typename: 'BannerHPData', link_desktop: string | null, link_mobile: string | null, medias: { desktop: string | null, mobile: string | null } | null };

type SpecialOperationDataInner_CanalHomeData_Fragment = { __typename: 'CanalHomeData', heading1: string | null, heading2: string | null, heading3: string | null };

type SpecialOperationDataInner_ClassiqueHomeData_Fragment = { __typename: 'ClassiqueHomeData', heading1: string | null, heading2: string | null, heading3: string | null, link1_label: string | null, link1_url: string | null, link2_label: string | null, link2_url: string | null };

type SpecialOperationDataInner_Club300Data_Fragment = { __typename: 'Club300Data', _placeholder: boolean | null };

type SpecialOperationDataInner_DisneyHomeData_Fragment = { __typename: 'DisneyHomeData', medias: { native_grand_angle: { image_url: string | null, url: string | null } | null } | null };

type SpecialOperationDataInner_DolbyHomeData_Fragment = { __typename: 'DolbyHomeData', _placeholder: boolean | null };

type SpecialOperationDataInner_EmergenceMovieData_Fragment = { __typename: 'EmergenceMovieData', distribution: EmergenceDistribution | null, provider: SvodProvider | null, release_date: string | null };

type SpecialOperationDataInner_EmergenceSeriesData_Fragment = { __typename: 'EmergenceSeriesData', provider: SvodProvider | null, release_date: string | null };

type SpecialOperationDataInner_EmergenceSvodData_Fragment = { __typename: 'EmergenceSVODData', provider: SvodProvider | null, release_date: string | null };

type SpecialOperationDataInner_EmergenceTheaterData_Fragment = { __typename: 'EmergenceTheaterData', release_date: string | null };

type SpecialOperationDataInner_FestivalSectionData_Fragment = { __typename: 'FestivalSectionData', festivalEditionId: number | null, festivalId: number | null, playlist: Array<{ key: string, value: { movies: Array<number> | null, series: Array<number> | null } | null } | null> | null };

type SpecialOperationDataInner_FilmesOnlineData_Fragment = { __typename: 'FilmesOnlineData', heading1: string | null, heading2: string | null, heading3: string | null, heading4: string | null, heading5: string | null, heading6: string | null, heading7: string | null, heading8: string | null, heading9: string | null, heading10: string | null };

type SpecialOperationDataInner_ImaxHomeData_Fragment = { __typename: 'IMAXHomeData', _placeholder: boolean | null };

type SpecialOperationDataInner_IndelebileHomeData_Fragment = { __typename: 'IndelebileHomeData', heading1: string | null, heading2: string | null, heading3: string | null };

type SpecialOperationDataInner_M6HomeData_Fragment = { __typename: 'M6HomeData', heading1: string | null, heading2: string | null, heading3: string | null };

type SpecialOperationDataInner_MaxHomeData_Fragment = { __typename: 'MaxHomeData', heading1: string | null, heading2: string | null, heading3: string | null };

type SpecialOperationDataInner_MobileDdayData_Fragment = { __typename: 'MobileDdayData', dday_campaign: string | null, dday_movie_id: number | null, dday_movie_list_id: Array<number> | null, dday_movie_list_title: string | null, dday_force_uppercase_headers: boolean | null, dday_nav_background_color_light: string | null, dday_nav_background_color_dark: string | null, dday_nav_font_color_light: string | null, dday_nav_font_color_dark: string | null, dday_main_color_light: string | null, dday_main_color_dark: string | null, dday_title_spacing_between_letters: number | null, dday_title_see_more_title_displayed: boolean | null, dday_background_color: string | null, dday_force_theme_light: boolean | null, dday_force_theme_dark: boolean | null, dday_status_bar_icons_light: boolean | null, dday_status_bar_icons_dark: boolean | null, dday_segmented_color_light: string | null, dday_segmented_color_dark: string | null, dday_segmented_selected_font_color_light: string | null, dday_segmented_selected_font_color_dark: string | null, dday_date: string | null, dday_last_date: string | null, dday_assets_version: number | null, dday_font_url: string | null, dday_font_size: number | null, dday_movie_background_url: string | null, dday_movie_background_id: string | null, dday_movie_logo_url: string | null, dday_movie_logo_id: string | null, dday_splash_background_url: string | null, dday_splash_background_id: string | null, dday_splash_logo_url: string | null, dday_splash_logo_id: string | null, dday_splashscreen_status_bar_color_style: string | null, dday_splashscreen_activity_color: string | null };

type SpecialOperationDataInner_NovelasHomeData_Fragment = { __typename: 'NovelasHomeData', _placeholder: boolean | null };

type SpecialOperationDataInner_RollerHomeData_Fragment = { __typename: 'RollerHomeData', title: string | null };

type SpecialOperationDataInner_SponsoredAutocompleteData_Fragment = { __typename: 'SponsoredAutocompleteData', release_date: string | null };

type SpecialOperationDataInner_Tf1HomeData_Fragment = { __typename: 'TF1HomeData', heading1: string | null, heading2: string | null, heading3: string | null };

type SpecialOperationDataInner_TicketAnchorData_Fragment = { __typename: 'TicketAnchorData', cta_text_after_release: string | null, cta_text_before_release: string | null, display_showtimes: boolean | null, link: string | null, release_date: string | null, slots: Array<TicketAnchorSlot> | null, text_after_release: string | null, text_before_release: string | null, text_color: string | null, medias: { desktop: string | null, desktopHp: string | null, mobile: string | null } | null };

type SpecialOperationDataInner_VodHomeData_Fragment = { __typename: 'VODHomeData', heading1: string | null, heading2: string | null };

export type SpecialOperationDataInnerFragment = SpecialOperationDataInner_BannerHpData_Fragment | SpecialOperationDataInner_CanalHomeData_Fragment | SpecialOperationDataInner_ClassiqueHomeData_Fragment | SpecialOperationDataInner_Club300Data_Fragment | SpecialOperationDataInner_DisneyHomeData_Fragment | SpecialOperationDataInner_DolbyHomeData_Fragment | SpecialOperationDataInner_EmergenceMovieData_Fragment | SpecialOperationDataInner_EmergenceSeriesData_Fragment | SpecialOperationDataInner_EmergenceSvodData_Fragment | SpecialOperationDataInner_EmergenceTheaterData_Fragment | SpecialOperationDataInner_FestivalSectionData_Fragment | SpecialOperationDataInner_FilmesOnlineData_Fragment | SpecialOperationDataInner_ImaxHomeData_Fragment | SpecialOperationDataInner_IndelebileHomeData_Fragment | SpecialOperationDataInner_M6HomeData_Fragment | SpecialOperationDataInner_MaxHomeData_Fragment | SpecialOperationDataInner_MobileDdayData_Fragment | SpecialOperationDataInner_NovelasHomeData_Fragment | SpecialOperationDataInner_RollerHomeData_Fragment | SpecialOperationDataInner_SponsoredAutocompleteData_Fragment | SpecialOperationDataInner_Tf1HomeData_Fragment | SpecialOperationDataInner_TicketAnchorData_Fragment | SpecialOperationDataInner_VodHomeData_Fragment;

export type SpecialOperationDataFragment = { data: { __typename: 'BannerHPData', link_desktop: string | null, link_mobile: string | null, medias: { desktop: string | null, mobile: string | null } | null } | { __typename: 'CanalHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'ClassiqueHomeData', heading1: string | null, heading2: string | null, heading3: string | null, link1_label: string | null, link1_url: string | null, link2_label: string | null, link2_url: string | null } | { __typename: 'Club300Data', _placeholder: boolean | null } | { __typename: 'DisneyHomeData', medias: { native_grand_angle: { image_url: string | null, url: string | null } | null } | null } | { __typename: 'DolbyHomeData', _placeholder: boolean | null } | { __typename: 'EmergenceMovieData', distribution: EmergenceDistribution | null, provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceSeriesData', provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceSVODData', provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceTheaterData', release_date: string | null } | { __typename: 'FestivalSectionData', festivalEditionId: number | null, festivalId: number | null, playlist: Array<{ key: string, value: { movies: Array<number> | null, series: Array<number> | null } | null } | null> | null } | { __typename: 'FilmesOnlineData', heading1: string | null, heading2: string | null, heading3: string | null, heading4: string | null, heading5: string | null, heading6: string | null, heading7: string | null, heading8: string | null, heading9: string | null, heading10: string | null } | { __typename: 'IMAXHomeData', _placeholder: boolean | null } | { __typename: 'IndelebileHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'M6HomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'MaxHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'MobileDdayData', dday_campaign: string | null, dday_movie_id: number | null, dday_movie_list_id: Array<number> | null, dday_movie_list_title: string | null, dday_force_uppercase_headers: boolean | null, dday_nav_background_color_light: string | null, dday_nav_background_color_dark: string | null, dday_nav_font_color_light: string | null, dday_nav_font_color_dark: string | null, dday_main_color_light: string | null, dday_main_color_dark: string | null, dday_title_spacing_between_letters: number | null, dday_title_see_more_title_displayed: boolean | null, dday_background_color: string | null, dday_force_theme_light: boolean | null, dday_force_theme_dark: boolean | null, dday_status_bar_icons_light: boolean | null, dday_status_bar_icons_dark: boolean | null, dday_segmented_color_light: string | null, dday_segmented_color_dark: string | null, dday_segmented_selected_font_color_light: string | null, dday_segmented_selected_font_color_dark: string | null, dday_date: string | null, dday_last_date: string | null, dday_assets_version: number | null, dday_font_url: string | null, dday_font_size: number | null, dday_movie_background_url: string | null, dday_movie_background_id: string | null, dday_movie_logo_url: string | null, dday_movie_logo_id: string | null, dday_splash_background_url: string | null, dday_splash_background_id: string | null, dday_splash_logo_url: string | null, dday_splash_logo_id: string | null, dday_splashscreen_status_bar_color_style: string | null, dday_splashscreen_activity_color: string | null } | { __typename: 'NovelasHomeData', _placeholder: boolean | null } | { __typename: 'RollerHomeData', title: string | null } | { __typename: 'SponsoredAutocompleteData', release_date: string | null } | { __typename: 'TF1HomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'TicketAnchorData', cta_text_after_release: string | null, cta_text_before_release: string | null, display_showtimes: boolean | null, link: string | null, release_date: string | null, slots: Array<TicketAnchorSlot> | null, text_after_release: string | null, text_before_release: string | null, text_color: string | null, medias: { desktop: string | null, desktopHp: string | null, mobile: string | null } | null } | { __typename: 'VODHomeData', heading1: string | null, heading2: string | null } };

export type SpecialOperationMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type SpecialOperationSlotsFragment = { id: string, ref: string, slots: Array<TicketAnchorSlot> };

export type SpecialOperationFragment = { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, active: boolean | null, missingRequiredFields: Array<string>, startsAt: string, endsAt: string | null, slots: Array<TicketAnchorSlot>, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'BannerHPData', link_desktop: string | null, link_mobile: string | null, medias: { desktop: string | null, mobile: string | null } | null } | { __typename: 'CanalHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'ClassiqueHomeData', heading1: string | null, heading2: string | null, heading3: string | null, link1_label: string | null, link1_url: string | null, link2_label: string | null, link2_url: string | null } | { __typename: 'Club300Data', _placeholder: boolean | null } | { __typename: 'DisneyHomeData', medias: { native_grand_angle: { image_url: string | null, url: string | null } | null } | null } | { __typename: 'DolbyHomeData', _placeholder: boolean | null } | { __typename: 'EmergenceMovieData', distribution: EmergenceDistribution | null, provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceSeriesData', provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceSVODData', provider: SvodProvider | null, release_date: string | null } | { __typename: 'EmergenceTheaterData', release_date: string | null } | { __typename: 'FestivalSectionData', festivalEditionId: number | null, festivalId: number | null, playlist: Array<{ key: string, value: { movies: Array<number> | null, series: Array<number> | null } | null } | null> | null } | { __typename: 'FilmesOnlineData', heading1: string | null, heading2: string | null, heading3: string | null, heading4: string | null, heading5: string | null, heading6: string | null, heading7: string | null, heading8: string | null, heading9: string | null, heading10: string | null } | { __typename: 'IMAXHomeData', _placeholder: boolean | null } | { __typename: 'IndelebileHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'M6HomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'MaxHomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'MobileDdayData', dday_campaign: string | null, dday_movie_id: number | null, dday_movie_list_id: Array<number> | null, dday_movie_list_title: string | null, dday_force_uppercase_headers: boolean | null, dday_nav_background_color_light: string | null, dday_nav_background_color_dark: string | null, dday_nav_font_color_light: string | null, dday_nav_font_color_dark: string | null, dday_main_color_light: string | null, dday_main_color_dark: string | null, dday_title_spacing_between_letters: number | null, dday_title_see_more_title_displayed: boolean | null, dday_background_color: string | null, dday_force_theme_light: boolean | null, dday_force_theme_dark: boolean | null, dday_status_bar_icons_light: boolean | null, dday_status_bar_icons_dark: boolean | null, dday_segmented_color_light: string | null, dday_segmented_color_dark: string | null, dday_segmented_selected_font_color_light: string | null, dday_segmented_selected_font_color_dark: string | null, dday_date: string | null, dday_last_date: string | null, dday_assets_version: number | null, dday_font_url: string | null, dday_font_size: number | null, dday_movie_background_url: string | null, dday_movie_background_id: string | null, dday_movie_logo_url: string | null, dday_movie_logo_id: string | null, dday_splash_background_url: string | null, dday_splash_background_id: string | null, dday_splash_logo_url: string | null, dday_splash_logo_id: string | null, dday_splashscreen_status_bar_color_style: string | null, dday_splashscreen_activity_color: string | null } | { __typename: 'NovelasHomeData', _placeholder: boolean | null } | { __typename: 'RollerHomeData', title: string | null } | { __typename: 'SponsoredAutocompleteData', release_date: string | null } | { __typename: 'TF1HomeData', heading1: string | null, heading2: string | null, heading3: string | null } | { __typename: 'TicketAnchorData', cta_text_after_release: string | null, cta_text_before_release: string | null, display_showtimes: boolean | null, link: string | null, release_date: string | null, slots: Array<TicketAnchorSlot> | null, text_after_release: string | null, text_before_release: string | null, text_color: string | null, medias: { desktop: string | null, desktopHp: string | null, mobile: string | null } | null } | { __typename: 'VODHomeData', heading1: string | null, heading2: string | null } };

export type SponsoredAutocompleteDataFragment = { release_date: string | null };

export type SponsoredAutocompleteSpecialOperationFragment = { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'SponsoredAutocompleteData', release_date: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type Tf1HomeSpecialOperationFragment = { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'TF1HomeData', heading1: string | null, heading2: string | null, heading3: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type TicketAnchorDataFragment = { cta_text_after_release: string | null, cta_text_before_release: string | null, display_showtimes: boolean | null, link: string | null, release_date: string | null, slots: Array<TicketAnchorSlot> | null, text_after_release: string | null, text_before_release: string | null, text_color: string | null, medias: { desktop: string | null, desktopHp: string | null, mobile: string | null } | null };

export type TicketAnchorSpecialOperationFragment = { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'TicketAnchorData', cta_text_after_release: string | null, cta_text_before_release: string | null, display_showtimes: boolean | null, link: string | null, release_date: string | null, slots: Array<TicketAnchorSlot> | null, text_after_release: string | null, text_before_release: string | null, text_color: string | null, medias: { desktop: string | null, desktopHp: string | null, mobile: string | null } | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type VodHomeSpecialOperationFragment = { id: string, name: string | null, ref: string, rawId: number, code: SpecialOperationCode, startsAt: string, endsAt: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, country: { id: string }, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Company', activities: Array<CompanyActivity>, id: string, ref: string, name: string, logo: { ref: string, path: string } | null, activeOnBrands: Array<{ ref: string }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, localeData?: { title: string | null, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'News', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string, genres: Array<Genre>, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, ref: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, poster: { path: string, ref: string } | null } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, activeOnBrands: Array<{ ref: string }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, poster: { path: string, url: string } | null, credits: { nodes: Array<{ person: { id: string, lastName: string | null, firstName: string | null } | null }> }, brandData?: { poster: { path: string, ref: string } | null } | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Slide', id: string, ref: string, title: string } | null, data: { __typename: 'VODHomeData', heading1: string | null, heading2: string | null }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type TheaterAddressFragment = { id: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, coordinates: { latitude: number, longitude: number } | null, location: { address: string | null, address2: string | null, zip: string | null, city: string | null, state: string | null, county: string | null, country: string | null } | null };

export type TheaterAffiliationFragment = { __typename: 'Theater', id: string, market: string | null, scheduledTypology: Array<TheaterTypology>, affiliatedTo: Array<{ __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }>, tradeGroup: Array<{ __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }>, pointOfSale: Array<{ __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }>, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } };

export type TheaterFareListFragment = { id: string, fares: { totalCount: number, nodes: Array<{ id: string, name: string, comment: string | null, price: number, currency: Currency, rank: number, screens: Array<{ id: string, name: string }> }> } };

export type TheaterFlagsFragment = { flags: { payment: Array<TheaterPaymentMethod>, service: Array<TheaterExtraService> } };

export type TheaterFareFragment = { id: string, name: string, comment: string | null, price: number, currency: Currency, rank: number, screens: Array<{ id: string, name: string }> };

export type TheaterLinksFragment = { id: string, links: { facebook: string | null, bluesky: string | null, instagram: string | null, letterboxd: string | null, linkedin: string | null, pinterest: string | null, snapchat: string | null, tiktok: string | null, threads: string | null, tumblr: string | null, twitter: string | null, vk: string | null, wechat: string | null, whatsapp: string | null, youtube: string | null } };

export type TheaterFullIdentityFragment = { id: string, code: string, name: string, foundedAt: string | null, movieLine: string | null, timezone: string | null, closed: boolean, displayName: string | null, email: string | null, phone: string | null, websiteUrl: string | null, androidUrl: string | null, iosUrl: string | null, showtimesUrl: string | null, showtimesAlternateUrl: string | null, showtimeSource: TheaterShowtimeSource | null, showtimesGatheringMethod: TheaterShowtimesGatheringMethod | null, showtimesGatheringMethodCode: string | null, showtimesGatheringMethodPriority: string | null, note: string | null, openingStatus: TheaterOpeningStatus, parent: { id: string, ref: string, name: string, activities: Array<CompanyActivity> } | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, logo: { id: string, url: string, ref: string } | null, temporaryClosure: { message: string, startsAt: string | null, endsAt: string | null } | null, nextOpening: { startsAt: string | null, message: string } | null };

export type TheaterMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type TheaterSeodataFragment = { seoData: { isAutonomouslyActivable: boolean, active: boolean, canActivate: boolean, browsable: boolean, title: string | null, alternateTitle: string | null, description: string | null, brand: { id: string, ref: string } } | null };

export type TheaterTicketingFragment = { id: string, ticketing: { useAtom: boolean, useMovieTickets: boolean } };

type TriviaEntity_Movie_Fragment = { __typename: 'Movie', id: string, ref: string, title: string };

type TriviaEntity_Series_Fragment = { __typename: 'Series', id: string, ref: string, title: string };

type TriviaEntity_SeriesSeason_Fragment = { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } };

type TriviaEntity_SeriesEpisode_Fragment = { __typename: 'SeriesEpisode', ref: string, id: string, number: number, series: { ref: string, id: string, title: string }, season: { ref: string } | null };

type TriviaEntity_Person_Fragment = { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null };

export type TriviaEntityFragment = TriviaEntity_Movie_Fragment | TriviaEntity_Series_Fragment | TriviaEntity_SeriesSeason_Fragment | TriviaEntity_SeriesEpisode_Fragment | TriviaEntity_Person_Fragment;

export type TriviaIdentityFragment = { id: string, rawId: number, ref: string, active: boolean, title: string, type: TriviaType | null, body: string | object[] | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } };

type VideoAlt_VideoLegacy_Fragment = { alt: { dailymotion: Array<string> | null, youtube: Array<{ id: string, channelId: string, channelLabel: string | null }> | null, videoEncoder: Array<{ id: string | null, platform: VideoPlatformEnum, channelId: string | null, fileCount: number | null, canRetry: boolean, status: VideoEncoderStatusEnum, statusText: string | null, cancelError: string | null, isCancelPending: boolean, isLinked: boolean, createdAt: string, updatedAt: string }> | null } | null };

type VideoAlt_VideoB2B_Fragment = { alt: { dailymotion: Array<string> | null, youtube: Array<{ id: string, channelId: string, channelLabel: string | null }> | null, videoEncoder: Array<{ id: string | null, platform: VideoPlatformEnum, channelId: string | null, fileCount: number | null, canRetry: boolean, status: VideoEncoderStatusEnum, statusText: string | null, cancelError: string | null, isCancelPending: boolean, isLinked: boolean, createdAt: string, updatedAt: string }> | null } | null };

export type VideoAltFragment = VideoAlt_VideoLegacy_Fragment | VideoAlt_VideoB2B_Fragment;

export type VideoAltIdentityFragment = { dailymotion: Array<string> | null, youtube: Array<{ id: string, channelId: string, channelLabel: string | null }> | null, videoEncoder: Array<{ id: string | null, platform: VideoPlatformEnum, channelId: string | null, fileCount: number | null, canRetry: boolean, status: VideoEncoderStatusEnum, statusText: string | null, cancelError: string | null, isCancelPending: boolean, isLinked: boolean, createdAt: string, updatedAt: string }> | null };

export type VideoEncoderIdentityFragment = { id: string | null, platform: VideoPlatformEnum, channelId: string | null, fileCount: number | null, canRetry: boolean, status: VideoEncoderStatusEnum, statusText: string | null, cancelError: string | null, isCancelPending: boolean, isLinked: boolean, createdAt: string, updatedAt: string };

type VideoIdentity_VideoLegacy_Fragment = { __typename: 'VideoLegacy', rawId: number, universe: VideoUniverse | null, id: string, ref: string, title: string | null, generatedTitle: string | null, active: boolean, type: VideoType, description: string | null, copyrightName: string | null, startsAt: string | null, endsAt: string | null, embedCode: string | null, restrictions: Array<RestrictionType>, language: Language | null, subtitle: Language | null, previewVideoFile: { cdnUrl: string | null } | null, brand: { __typename: 'Brand', language: Language | null, id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, certificate: { __typename: 'Certificate', id: string, ref: string, rank: number, active: boolean, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null } | null, alt: { videoEncoder: Array<{ status: VideoEncoderStatusEnum, createdAt: string, updatedAt: string }> | null } | null, snapshot: { __typename: 'Image', id: string, title: string | null, path: string, url: string } | null, duration: { hours: number, minutes: number, seconds: number } | null, copyrights: Array<{ id: string, name: string }> | null, metadata: { updatedAt: string } };

type VideoIdentity_VideoB2B_Fragment = { __typename: 'VideoB2B', rawId: number, id: string, ref: string, title: string | null, generatedTitle: string | null, active: boolean, type: VideoType, description: string | null, copyrightName: string | null, startsAt: string | null, endsAt: string | null, embedCode: string | null, restrictions: Array<RestrictionType>, language: Language | null, subtitle: Language | null, previewVideoFile: { cdnUrl: string | null } | null, certificate: { __typename: 'Certificate', id: string, ref: string, rank: number, active: boolean, code: string | null, label: string | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null }, limitedLocalization: { id: string, name: string, code: string | null, type: LocalizationKind, parent: { id: string, name: string, code: string | null, type: LocalizationKind } | null } | null } | null, snapshot: { __typename: 'Image', id: string, title: string | null, path: string, url: string } | null, duration: { hours: number, minutes: number, seconds: number } | null, copyrights: Array<{ id: string, name: string }> | null, metadata: { updatedAt: string } };

export type VideoIdentityFragment = VideoIdentity_VideoLegacy_Fragment | VideoIdentity_VideoB2B_Fragment;

type VideoRank_VideoLegacy_Fragment = { rankRelatedEntities: Array<{ rank: number, entity: { __typename: 'Movie', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | { __typename: 'SeriesEpisode', id: string, ref: string, number: number, series: { id: string, ref: string, title: string }, season: { id: string, ref: string, number: number } | null } | { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } }> };

type VideoRank_VideoB2B_Fragment = { rankRelatedEntities: Array<{ rank: number, entity: { __typename: 'Movie', id: string, ref: string, title: string } | { __typename: 'Series', id: string, ref: string, title: string } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } | { __typename: 'SeriesEpisode', id: string, ref: string, number: number, series: { id: string, ref: string, title: string }, season: { id: string, ref: string, number: number } | null } | { __typename: 'Person', id: string, ref: string, firstName: string | null, lastName: string | null } | { __typename: 'Festival', id: string } | { __typename: 'FestivalEdition', id: string } }> };

export type VideoRankFragment = VideoRank_VideoLegacy_Fragment | VideoRank_VideoB2B_Fragment;

type VideoMetadata_VideoLegacy_Fragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

type VideoMetadata_VideoB2B_Fragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type VideoMetadataFragment = VideoMetadata_VideoLegacy_Fragment | VideoMetadata_VideoB2B_Fragment;

export type WidgetIdentityFragment = { id: string, ref: string, name: string, type: WidgetType, url: string | null };

export type TokenIdentityFragment = { id: string, ref: string, uuid: string, expiresAt: string, active: boolean, lastCheckedAt: string, token: string, comment: string | null, metadata: { createdAt: string }, application: { id: string, name: string, active: boolean, ref: string, origin: string, metadata: { createdAt: string } } | null, user: { id: string, nickname: string | null } | null, scope: { id: string, ref: string, name: string, customer: { id: string, name: string, graphBackendEndpoint: string | null, active: boolean, comment: string | null, ref: string } } | null };

export type TokenUserFragment = { id: string, nickname: string | null };

export type TokenScopeFragment = { id: string, ref: string, name: string, customer: { id: string, name: string, graphBackendEndpoint: string | null, active: boolean, comment: string | null, ref: string } };

export type ApplicationIdentityFragment = { id: string, name: string, active: boolean, ref: string, origin: string, metadata: { createdAt: string } };

export type MatchedProductFragment = { id: string, name: string, type: ProductType, url: string | null };

export type IgnoredProductFragment = { id: string, sourceId: string, title: string | null, type: string, metadata: { createdAt: string, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type UnknownProductFragment = { id: string, entityType: ProductEntityType, title: string, type: string, sourceChannelName: string | null, url: string | null, imageUrl: string | null, matchingData: { title: string | null, episodeTitle: string | null, seasonNumber: number | null, episodeNumber: number | null, releasedAt: string | null, releasedAtTime: string | null, unreleasedAt: string | null, info: any | null, productionYear: number | null, actors: Array<string>, directors: Array<string>, runtime: number | null } };

export type MovieLocaleDataFragment = { localeData: { title: string | null, poster: { url: string } | null } | null };

export type MovieLocaleDataInfosFragment = { title: string | null, poster: { url: string } | null };

export type ShowtimeEntityInfosFragment = { title: string, genres: Array<Genre>, poster: { url: string } | null, credits: { nodes: Array<{ person: { id: string, ref: string, firstName: string | null, lastName: string | null } | null }> }, localesData: Array<{ locale: string, title: string | null, poster: { url: string } | null }> | null, countries: Array<{ id: string, ref: string, name: string }> };

export type ShowtimeEntityLocaleDataFragment = { localeData: { title: string | null, poster: { url: string } | null } | null };

export type ShowtimeEntityRowFragment = { id: string, ref: string, title: string, productionYear: number | null, credits: { nodes: Array<{ person: { id: string, firstName: string | null, lastName: string | null, ref: string } | null }> }, usLocale: { title: string | null } | null };

export type CustomerIdentityFragment = { id: string, name: string, graphBackendEndpoint: string | null, active: boolean, comment: string | null, ref: string };

export type CustomerMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type CustomerQueryFragment = { id: string, name: string, ref: string, template: string, metadata: { createdAt: string } };

export type CustomerQueryMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type ScopeIdentityFragment = { id: string, ref: string, name: string, customer: { id: string, name: string, graphBackendEndpoint: string | null, active: boolean, comment: string | null, ref: string } };

export type ScopeMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type ScopeCustomerQueryIdentityFragment = { id: string, alias: string, config: { variables: any, userVariables: Array<string | null> }, scope: { id: string, ref: string }, customerQuery: { id: string, name: string } };

export type EditorialReviewAuthorsFragment = { id: string, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, authors: Array<{ id: string, rank: number, author: { id: string, ref: string, name: string }, signature: { id: string, signature: string } | null }> };

export type EditorialReviewBodyFragment = { id: string, body: string | object[] | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } };

type EditorialReviewEntity_Movie_Fragment = { __typename: 'Movie', id: string, title: string, ref: string };

type EditorialReviewEntity_Series_Fragment = { __typename: 'Series', id: string, title: string, ref: string };

type EditorialReviewEntity_SeriesSeason_Fragment = { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } };

export type EditorialReviewEntityFragment = EditorialReviewEntity_Movie_Fragment | EditorialReviewEntity_Series_Fragment | EditorialReviewEntity_SeriesSeason_Fragment;

export type EditorialReviewIdentityFragment = { id: string, title: string | null, active: boolean, bodyShort: string | null, rating: number, brand: { __typename: 'Brand', timezone: string | null, id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Movie', id: string, title: string, ref: string } | { __typename: 'Series', id: string, title: string, ref: string } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, series: { id: string, ref: string, title: string } } };

export type EditorialReviewMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type EditorialReviewPictureFragment = { id: string, picture: { id: string, url: string, copyrightName: string | null, ref: string, copyrights: Array<{ id: string, name: string }> | null } | null };

export type EditorialReviewPublicationsFragment = { publicationStatus: EntityPublicationStatus, publicationDate: string | null, isUpdatedWhenPublished: boolean, publications: Array<{ startsAt: string, endsAt: string | null, status: EntityPublicationStatus }> };

type PressReviewEntity_Movie_Fragment = { __typename: 'Movie', title: string, id: string, ref: string };

type PressReviewEntity_Series_Fragment = { __typename: 'Series', title: string, id: string, ref: string };

type PressReviewEntity_SeriesSeason_Fragment = { __typename: 'SeriesSeason', id: string, number: number, ref: string, originalPremiere: string | null, status: SeriesStatus | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } };

export type PressReviewEntityFragment = PressReviewEntity_Movie_Fragment | PressReviewEntity_Series_Fragment | PressReviewEntity_SeriesSeason_Fragment;

export type PressReviewIdentityFragment = { id: string, ref: string, active: boolean, author: string | null, rating: number, body: string | object[] | null, snippet: string | null, url: string | null, metadata: { updatedAt: string, createdAt: string }, company: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> }, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null }, entity: { __typename: 'Movie', title: string, id: string, ref: string } | { __typename: 'Series', title: string, id: string, ref: string } | { __typename: 'SeriesSeason', id: string, number: number, ref: string, originalPremiere: string | null, status: SeriesStatus | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } };

export type PressReviewMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type GetEntityItemEntityQueryVariables = Exact<{
  ref: Scalars['ID']['input'];
  type: EntityType;
  brandId?: Scalars['ID']['input'];
  includeBrandData?: Scalars['Boolean']['input'];
  withSeoAttributes?: Scalars['Boolean']['input'];
}>;


export type GetEntityItemEntityQuery = { entityByRef: { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string } | null, credits: { nodes: Array<{ person: { firstName: string | null, lastName: string | null } | null }> }, brandsData: Array<{ title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, activeOnBrands: Array<{ ref: string }>, seoAttributes?: Array<{ browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> } | { __typename: 'Series', id: string, ref: string, title: string, originalPremiere: string | null, genres: Array<Genre>, poster: { path: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } } | null, activeOnBrands: Array<{ ref: string }>, seoAttributes?: Array<{ browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Person', id: string, ref: string, lastName: string | null, firstName: string | null, deathDate: string | null, activities: Array<PersonActivity>, poster: { path: string } | null, countries: Array<{ name: string }>, activeOnBrands: Array<{ ref: string }>, seoAttributes?: Array<{ browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> } | {} | null };

export type GetBrandCountryQueryVariables = Exact<{
  brandId: Scalars['ID']['input'];
}>;


export type GetBrandCountryQuery = { brand: { id: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } } | null };

export type GetBoxofficeDataListQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  countryId: Scalars['ID']['input'];
  movieId?: InputMaybe<Scalars['ID']['input']>;
  range?: InputMaybe<DateRangeInput>;
  rangeOperator?: InputMaybe<RangeOperator>;
  orderBy?: InputMaybe<TemporalBoxofficeOrder>;
}>;


export type GetBoxofficeDataListQuery = { temporalBoxoffices: { totalCount: number, nodes: Array<{ id: string, value: number | null, cumulative: number | null, copyCount: number | null, estimate: number | null, movie: { ref: string, id: string, title: string, releases: { nodes: Array<{ releasedAt: string | null, type: ReleaseType | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } }> } }, range: { startsAt: string, endsAt: string }, country: { id: string, name: string, alpha2: string } }> } };

export type GetEntityWellKnownRoutesQueryVariables = Exact<{
  brandId: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
}>;


export type GetEntityWellKnownRoutesQuery = { wysiwyg: { wellKnownRoutes: Array<{ name: string, title: string, params: Array<{ name: string, value: string }> }> } };

export type GetLinkableEntityQueryVariables = Exact<{
  type: EntityType;
  ref: Scalars['ID']['input'];
  brandId?: Scalars['ID']['input'];
  includeBrandData?: Scalars['Boolean']['input'];
  withSeoAttributes?: Scalars['Boolean']['input'];
}>;


export type GetLinkableEntityQuery = { entityByRef: { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string } | null, credits: { nodes: Array<{ person: { firstName: string | null, lastName: string | null } | null }> }, brandsData: Array<{ title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, activeOnBrands: Array<{ ref: string }>, seoAttributes?: Array<{ browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> } | { __typename: 'Series', id: string, ref: string, title: string, originalPremiere: string | null, genres: Array<Genre>, poster: { path: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } } | null, activeOnBrands: Array<{ ref: string }>, seoAttributes?: Array<{ browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> } | { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | { id: string, ref: string, title: string, active: boolean, publicationDate: string | null, publicationStatus: EntityPublicationStatus } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Person', id: string, ref: string, lastName: string | null, firstName: string | null, deathDate: string | null, activities: Array<PersonActivity>, poster: { path: string } | null, countries: Array<{ name: string }>, activeOnBrands: Array<{ ref: string }>, seoAttributes?: Array<{ browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> } | {} | null };

export type RetroengineerUrlMutationVariables = Exact<{
  input: RetroengineerUrlInput;
}>;


export type RetroengineerUrlMutation = { retroengineerUrl: { name: string, params: Array<{ name: string, value: string }> } | null };

export type GetWellKnownRouteQueryVariables = Exact<{
  route: Scalars['String']['input'];
  params: Array<WebsiteRouteParamInput> | WebsiteRouteParamInput;
  brandId?: Scalars['ID']['input'];
  includeBrandData?: Scalars['Boolean']['input'];
  withSeoAttributes?: Scalars['Boolean']['input'];
}>;


export type GetWellKnownRouteQuery = { wysiwyg: { wellKnownRoute: { type: WellKnownWebsiteRouteType, mainParam: string, name: string, title: string, entity: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string } | null, credits: { nodes: Array<{ person: { firstName: string | null, lastName: string | null } | null }> }, brandsData: Array<{ title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, activeOnBrands: Array<{ ref: string }>, seoAttributes?: Array<{ browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> } | { id: string, ref: string, title: string, active: boolean, publicationDate: string | null, publicationStatus: EntityPublicationStatus } | { __typename: 'Person', id: string, ref: string, lastName: string | null, firstName: string | null, deathDate: string | null, activities: Array<PersonActivity>, poster: { path: string } | null, countries: Array<{ name: string }>, activeOnBrands: Array<{ ref: string }>, seoAttributes?: Array<{ browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Series', id: string, ref: string, title: string, originalPremiere: string | null, genres: Array<Genre>, poster: { path: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } } | null, activeOnBrands: Array<{ ref: string }>, seoAttributes?: Array<{ browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> }, params: Array<{ name: string, value: string }> } | null } };

export type WellKnownRouteFragment = { type: WellKnownWebsiteRouteType, mainParam: string, name: string, title: string, entity: { __typename: 'Company', id: string, ref: string, name: string, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } | null, activeOnBrands: Array<{ ref: string }> } | { __typename: 'Movie', id: string, ref: string, title: string, productionYear: number | null, genres: Array<Genre>, poster: { path: string } | null, credits: { nodes: Array<{ person: { firstName: string | null, lastName: string | null } | null }> }, brandsData: Array<{ title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> | null, activeOnBrands: Array<{ ref: string }>, seoAttributes?: Array<{ browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> } | { id: string, ref: string, title: string, active: boolean, publicationDate: string | null, publicationStatus: EntityPublicationStatus } | { __typename: 'Person', id: string, ref: string, lastName: string | null, firstName: string | null, deathDate: string | null, activities: Array<PersonActivity>, poster: { path: string } | null, countries: Array<{ name: string }>, activeOnBrands: Array<{ ref: string }>, seoAttributes?: Array<{ browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> } | { __typename: 'SeriesSeason', id: string, ref: string, number: number, originalPremiere: string | null, status: SeriesStatus | null, series: { __typename: 'Series', id: string, ref: string, originalPremiere: string | null, title: string } } | { __typename: 'Series', id: string, ref: string, title: string, originalPremiere: string | null, genres: Array<Genre>, poster: { path: string } | null, brandData?: { title: string | null, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } } | null, activeOnBrands: Array<{ ref: string }>, seoAttributes?: Array<{ browsable: boolean, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } }> }, params: Array<{ name: string, value: string }> };

export type GetWysiwygVideoQueryVariables = Exact<{
  videoRef: Scalars['ID']['input'];
}>;


export type GetWysiwygVideoQuery = { entityByRef: { __typename: 'VideoLegacy', id: string, ref: string, title: string | null, generatedTitle: string | null, active: boolean, optionalTitle: string | null } | {} | null };

export type CreateImageCategoryMutationVariables = Exact<{
  input: CreateImageCategoryInput;
}>;


export type CreateImageCategoryMutation = { createImageCategory: { __typename: 'ImageCategory', id: string, ref: string, name: string | null, imageType: ImageType | null, sponsored: boolean, rank: number, active: boolean, brand: { id: string, ref: string, name: string }, imagesValidityRange: { min: string | null, max: string | null, totalHasTtl: number, totalWithoutTtl: number, hasComingSoon: boolean, hasPlanned: boolean }, images: { totalCount: number }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } } | null };

export type DeleteImageCategoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  brandId: Scalars['ID']['input'];
}>;


export type DeleteImageCategoryMutation = { deleteImageCategory: boolean | null };

export type GetImageCategoriesListQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']['input']>;
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  imageTypes?: InputMaybe<Array<InputMaybe<ImageType>> | InputMaybe<ImageType>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<ImageCategoryOrder>;
}>;


export type GetImageCategoriesListQuery = { imageCategories: { totalCount: number, nodes: Array<{ __typename: 'ImageCategory', id: string, ref: string, name: string | null, imageType: ImageType | null, sponsored: boolean, rank: number, active: boolean, brand: { id: string, ref: string, name: string }, imagesValidityRange: { min: string | null, max: string | null, totalHasTtl: number, totalWithoutTtl: number, hasComingSoon: boolean, hasPlanned: boolean }, images: { totalCount: number }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } }> } };

export type UpdateImageCategoryMutationVariables = Exact<{
  input: UpdateImageCategoryInput;
}>;


export type UpdateImageCategoryMutation = { updateImageCategory: { id: string, ref: string, name: string | null, imageType: ImageType | null, sponsored: boolean, rank: number, active: boolean, brand: { id: string, name: string } } | null };

export type ImageReferenceFromImageHasCategoryFragment = { rank: number, image: { type: ImageType | null, active: boolean, endDate: string | null, startDate: string | null, tags: Array<string>, title: string | null, id: string, url: string, ref: string }, category: { id: string, name: string | null, brand: { id: string, ref: string, name: string } } | null, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type ImageHasCategoryFragment = { id: string, imageId: string, categoryId: string, rank: number };

export type SocialMetadataFragment = { metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };

export type SocialStatsFragment = { id: string, stats: { database: { ratingCount: number, reviewCount: number, actionCount: number, theaterCount: number, collectionCount: number, followedCollectionCount: number, followerCount: number, followeeCount: number }, graphAPI: { ratingCount: number, reviewCount: number, actionCount: number, theaterCount: number, collectionCount: number, followedCollectionCount: number, followerCount: number, followeeCount: number } } };

export type SocialUserFullIdentityFragment = { id: string, ref: string, actito: string | null, active: boolean, avatar: string | null, email: string | null, isClub300: boolean, isEULAAccepted: boolean, isEmailValid: boolean, legacyID: string, nickname: string | null, socialProviders: Array<string>, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } };

export type SocialUserIdentityFragment = { id: string, ref: string, active: boolean, email: string | null, legacyID: string, brand: { __typename: 'Brand', id: string, ref: string, name: string, redirectionDomain: string | null, locale: { id: string, ref: string, name: string, syncFromBrand: { id: string, ref: string, name: string } | null }, imageConfiguration: { imageTypes: Array<ImageType> | null, defaultValue: boolean } | null } };

export type BoxofficeReleaseFragment = { id: string, value: number | null, cumulative: number | null, copyCount: number | null, estimate: number | null, movie: { ref: string, id: string, title: string, releases: { nodes: Array<{ releasedAt: string | null, type: ReleaseType | null, country: { __typename: 'Country', id: string, ref: string, name: string, alpha2: string } }> } }, range: { startsAt: string, endsAt: string }, country: { id: string, name: string, alpha2: string } };

export type SelectWellKnownRouteFragment = { name: string, title: string, params: Array<{ name: string, value: string }> };

export type ImageCategoryFragment = { __typename: 'ImageCategory', id: string, ref: string, name: string | null, imageType: ImageType | null, sponsored: boolean, rank: number, active: boolean, brand: { id: string, ref: string, name: string }, imagesValidityRange: { min: string | null, max: string | null, totalHasTtl: number, totalWithoutTtl: number, hasComingSoon: boolean, hasPlanned: boolean }, images: { totalCount: number }, metadata: { origin: string | null, createdAt: string, updatedAt: string, scheduledForDeletion: boolean, createdBy: { __typename: 'User', id: string, ref: string, name: string } | null, updatedBy: { __typename: 'User', id: string, ref: string, name: string } | null } };
